
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("boZNq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e4b14ad7ed75be8c$export$2e2bcd8739ae039);
parcelRequire("8BBfn");
var $eayOh = parcelRequire("eayOh");
var $fVLUl = parcelRequire("fVLUl");



var $bnwzR = parcelRequire("bnwzR");

var $emn4R = parcelRequire("emn4R");

var $ki3ue = parcelRequire("ki3ue");
var $e4b14ad7ed75be8c$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $fVLUl.defineComponent)({
    __name: "App",
    setup (__props, { expose: __expose }) {
        __expose();
        let splitterModel = (0, $eayOh.ref)(20);
        const q = (0, $bnwzR.useQuasar)();
        function onTripCostInput({ target: target }) {
            const res = Number(target.value.replace(/[^0-9^\\.\\.]/g, ""));
            tripCost.value = res;
            target.value = res != 0 ? res.toLocaleString("ru") : "";
        }
        function onCargoCostInput({ target: target }) {
            let res = Number(target.value.replace(/[^0-9^\\.\\.]/g, ""));
            cargoCost.value = res;
            target.value = res.toLocaleString("ru");
        }
        function getShowInternalInfo() {
            return window.location.hash.includes("showTripCost") || window.location.hash.includes("showInternalInfo");
        }
        const transportType = (0, $eayOh.ref)("truck");
        const deliveryType = (0, $eayOh.ref)("warehouse");
        const tripCost = (0, $eayOh.ref)(0);
        const showInternalInfo = (0, $eayOh.ref)(getShowInternalInfo());
        const cargoCost = (0, $eayOh.ref)(0);
        const cargoCostAbove4M = (0, $eayOh.ref)(false);
        const routeDistanceKm = (0, $eayOh.ref)(undefined);
        const waypoints = (0, $eayOh.ref)([]);
        const pointAddresses = (0, $eayOh.ref)([
            "\u0420\u044F\u0437\u0430\u043D\u044C",
            "",
            ""
        ]);
        const foundRoutes = (0, $eayOh.computed)(()=>$ki3ue.findRoutes(waypoints.value, $ki3ue.transportKindToNumber(transportType.value), deliveryType.value, tripCost.value));
        window.addEventListener("hashchange", function() {
            showInternalInfo.value = getShowInternalInfo();
        });
        function calcPrice(r) {
            return $ki3ue.calcPrice({
                routeDistanceKm: routeDistanceKm.value,
                waypoints: waypoints.value,
                cargoCost: cargoCost.value,
                cargoCostAbove4M: cargoCostAbove4M.value,
                transportType: transportType.value,
                deliveryType: deliveryType.value,
                route: r
            });
        }
        const deliveryPrices = (0, $eayOh.computed)(()=>foundRoutes.value.map((r)=>calcPrice(r)));
        const popupText = (0, $eayOh.computed)(()=>$ki3ue.getPopupText({
                transportType: transportType.value,
                deliveryType: deliveryType.value,
                foundRoutes: foundRoutes.value,
                routeDistanceKm: routeDistanceKm.value,
                waypoints: waypoints.value,
                showInternalInfo: showInternalInfo.value
            }));
        const __returned__ = {
            get splitterModel () {
                return splitterModel;
            },
            set splitterModel (v){
                splitterModel = v;
            },
            q: q,
            onTripCostInput: onTripCostInput,
            onCargoCostInput: onCargoCostInput,
            getShowInternalInfo: getShowInternalInfo,
            transportType: transportType,
            deliveryType: deliveryType,
            tripCost: tripCost,
            showInternalInfo: showInternalInfo,
            cargoCost: cargoCost,
            cargoCostAbove4M: cargoCostAbove4M,
            routeDistanceKm: routeDistanceKm,
            waypoints: waypoints,
            pointAddresses: pointAddresses,
            foundRoutes: foundRoutes,
            calcPrice: calcPrice,
            deliveryPrices: deliveryPrices,
            popupText: popupText,
            YMap: $emn4R.default,
            get logic () {
                return $ki3ue;
            }
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("8BBfn", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("fVLUl")).computed);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("fVLUl")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("fVLUl")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("fVLUl")).createElementVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("fVLUl")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("fVLUl")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("fVLUl")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("fVLUl")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("fVLUl")).getCurrentInstance);
$parcel$export(module.exports, "h", () => (parcelRequire("fVLUl")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("fVLUl")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("fVLUl")).inject);
$parcel$export(module.exports, "isRef", () => (parcelRequire("eayOh")).isRef);
$parcel$export(module.exports, "KeepAlive", () => (parcelRequire("fVLUl")).KeepAlive);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("eayOh")).markRaw);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("fVLUl")).nextTick);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("fVLUl")).onActivated);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("fVLUl")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("fVLUl")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("fVLUl")).onBeforeUpdate);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("fVLUl")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("fVLUl")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("fVLUl")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("fVLUl")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("fVLUl")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("fVLUl")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("eayOh")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("eayOh")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("fVLUl")).renderList);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("fVLUl")).resolveComponent);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("eayOh")).shallowReactive);
$parcel$export(module.exports, "Teleport", () => (parcelRequire("fVLUl")).Teleport);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("eayOh")).toRaw);
$parcel$export(module.exports, "watch", () => (parcelRequire("fVLUl")).watch);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("fVLUl")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("fVLUl")).withDirectives);
$parcel$export(module.exports, "createApp", () => (parcelRequire("24349")).createApp);
$parcel$export(module.exports, "Transition", () => (parcelRequire("24349")).Transition);
$parcel$export(module.exports, "TransitionGroup", () => (parcelRequire("24349")).TransitionGroup);
$parcel$export(module.exports, "vModelCheckbox", () => (parcelRequire("24349")).vModelCheckbox);
$parcel$export(module.exports, "vModelSelect", () => (parcelRequire("24349")).vModelSelect);
$parcel$export(module.exports, "vShow", () => (parcelRequire("24349")).vShow);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("iE8iy")).toDisplayString);
$parcel$export(module.exports, "unref", () => (parcelRequire("eayOh")).unref);
/**
* vue v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $fVLUl = parcelRequire("fVLUl");parcelRequire("24349");parcelRequire("iE8iy");parcelRequire("eayOh");
function $643eabec69092971$var$initDev() {
    (0, $fVLUl.initCustomFormatter)();
}
const $643eabec69092971$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("fVLUl", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $b991575ae291844b$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $b991575ae291844b$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $b991575ae291844b$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $b991575ae291844b$export$ffb0004e005737fa);
$parcel$export(module.exports, "Static", () => $b991575ae291844b$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $b991575ae291844b$export$694b237e827a3d23);
$parcel$export(module.exports, "withDirectives", () => $b991575ae291844b$export$49729353e7c1e6c5);
$parcel$export(module.exports, "Teleport", () => $b991575ae291844b$export$76d55a0304a371f4);
$parcel$export(module.exports, "useTransitionState", () => $b991575ae291844b$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $b991575ae291844b$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $b991575ae291844b$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $b991575ae291844b$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $b991575ae291844b$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $b991575ae291844b$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $b991575ae291844b$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $b991575ae291844b$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $b991575ae291844b$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "defineComponent", () => $b991575ae291844b$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "createVNode", () => $b991575ae291844b$export$bf5c4cf060303d58);
$parcel$export(module.exports, "createTextVNode", () => $b991575ae291844b$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "watch", () => $b991575ae291844b$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "onUpdated", () => $b991575ae291844b$export$5876c47052fb88b1);
$parcel$export(module.exports, "KeepAlive", () => $b991575ae291844b$export$70eb8a58709972df);
$parcel$export(module.exports, "onActivated", () => $b991575ae291844b$export$ba52d824b95a2154);
$parcel$export(module.exports, "onDeactivated", () => $b991575ae291844b$export$bf1440eeaf5fa709);
$parcel$export(module.exports, "onUnmounted", () => $b991575ae291844b$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeMount", () => $b991575ae291844b$export$23b7aeb0d671f804);
$parcel$export(module.exports, "onBeforeUpdate", () => $b991575ae291844b$export$ab91988a13872e4c);
$parcel$export(module.exports, "resolveComponent", () => $b991575ae291844b$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "renderList", () => $b991575ae291844b$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "openBlock", () => $b991575ae291844b$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "computed", () => $b991575ae291844b$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "provide", () => $b991575ae291844b$export$abe1e183e22e10ad);
$parcel$export(module.exports, "inject", () => $b991575ae291844b$export$a976684a0efeb93f);
$parcel$export(module.exports, "createRenderer", () => $b991575ae291844b$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $b991575ae291844b$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $b991575ae291844b$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $b991575ae291844b$export$42098e0eaa15c48e);
$parcel$export(module.exports, "createCommentVNode", () => $b991575ae291844b$export$49553837c7236d3c);
$parcel$export(module.exports, "isRuntimeOnly", () => $b991575ae291844b$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $b991575ae291844b$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $b991575ae291844b$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $b991575ae291844b$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "isRef", () => (parcelRequire("eayOh")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("eayOh")).markRaw);
$parcel$export(module.exports, "reactive", () => (parcelRequire("eayOh")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("eayOh")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("eayOh")).shallowReactive);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("eayOh")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("iE8iy")).camelize);
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $eayOh = parcelRequire("eayOh");

var $iE8iy = parcelRequire("iE8iy");
const $b991575ae291844b$var$stack = [];
function $b991575ae291844b$var$pushWarningContext(vnode) {
    $b991575ae291844b$var$stack.push(vnode);
}
function $b991575ae291844b$var$popWarningContext() {
    $b991575ae291844b$var$stack.pop();
}
let $b991575ae291844b$var$isWarning = false;
function $b991575ae291844b$var$warn$1(msg, ...args) {
    if ($b991575ae291844b$var$isWarning) return;
    $b991575ae291844b$var$isWarning = true;
    (0, $eayOh.pauseTracking)();
    const instance = $b991575ae291844b$var$stack.length ? $b991575ae291844b$var$stack[$b991575ae291844b$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $b991575ae291844b$var$getComponentTrace();
    if (appWarnHandler) $b991575ae291844b$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$b991575ae291844b$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$b991575ae291844b$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $eayOh.resetTracking)();
    $b991575ae291844b$var$isWarning = false;
}
function $b991575ae291844b$var$getComponentTrace() {
    let currentVNode = $b991575ae291844b$var$stack[$b991575ae291844b$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $b991575ae291844b$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$b991575ae291844b$var$formatTraceEntry(entry));
    });
    return logs;
}
function $b991575ae291844b$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$b991575ae291844b$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$b991575ae291844b$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $b991575ae291844b$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$b991575ae291844b$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $b991575ae291844b$var$formatProp(key, value, raw) {
    if ((0, $iE8iy.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $eayOh.isRef)(value)) {
        value = $b991575ae291844b$var$formatProp(key, (0, $eayOh.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $iE8iy.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $eayOh.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $b991575ae291844b$export$dfbcecb440255e4a(val, type) {
    return;
}
const $b991575ae291844b$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $b991575ae291844b$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $b991575ae291844b$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $b991575ae291844b$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $b991575ae291844b$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $iE8iy.isFunction)(fn)) {
        const res = $b991575ae291844b$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $iE8iy.isPromise)(res)) res.catch((err)=>{
            $b991575ae291844b$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $iE8iy.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($b991575ae291844b$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $b991575ae291844b$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $iE8iy.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $eayOh.pauseTracking)();
            $b991575ae291844b$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $eayOh.resetTracking)();
            return;
        }
    }
    $b991575ae291844b$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $b991575ae291844b$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $b991575ae291844b$var$queue = [];
let $b991575ae291844b$var$flushIndex = -1;
const $b991575ae291844b$var$pendingPostFlushCbs = [];
let $b991575ae291844b$var$activePostFlushCbs = null;
let $b991575ae291844b$var$postFlushIndex = 0;
const $b991575ae291844b$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $b991575ae291844b$var$currentFlushPromise = null;
const $b991575ae291844b$var$RECURSION_LIMIT = 100;
function $b991575ae291844b$export$bdd553fddd433dcb(fn) {
    const p = $b991575ae291844b$var$currentFlushPromise || $b991575ae291844b$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $b991575ae291844b$var$findInsertionIndex(id) {
    let start = $b991575ae291844b$var$flushIndex + 1;
    let end = $b991575ae291844b$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $b991575ae291844b$var$queue[middle];
        const middleJobId = $b991575ae291844b$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $b991575ae291844b$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $b991575ae291844b$var$getId(job);
        const lastJob = $b991575ae291844b$var$queue[$b991575ae291844b$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $b991575ae291844b$var$getId(lastJob)) $b991575ae291844b$var$queue.push(job);
        else $b991575ae291844b$var$queue.splice($b991575ae291844b$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $b991575ae291844b$var$queueFlush();
    }
}
function $b991575ae291844b$var$queueFlush() {
    if (!$b991575ae291844b$var$currentFlushPromise) $b991575ae291844b$var$currentFlushPromise = $b991575ae291844b$var$resolvedPromise.then($b991575ae291844b$var$flushJobs);
}
function $b991575ae291844b$export$59536a0199721cab(cb) {
    if (!(0, $iE8iy.isArray)(cb)) {
        if ($b991575ae291844b$var$activePostFlushCbs && cb.id === -1) $b991575ae291844b$var$activePostFlushCbs.splice($b991575ae291844b$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $b991575ae291844b$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else $b991575ae291844b$var$pendingPostFlushCbs.push(...cb);
    $b991575ae291844b$var$queueFlush();
}
function $b991575ae291844b$var$flushPreFlushCbs(instance, seen, i = $b991575ae291844b$var$flushIndex + 1) {
    for(; i < $b991575ae291844b$var$queue.length; i++){
        const cb = $b991575ae291844b$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $b991575ae291844b$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $b991575ae291844b$var$flushPostFlushCbs(seen) {
    if ($b991575ae291844b$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($b991575ae291844b$var$pendingPostFlushCbs)
        ].sort((a, b)=>$b991575ae291844b$var$getId(a) - $b991575ae291844b$var$getId(b));
        $b991575ae291844b$var$pendingPostFlushCbs.length = 0;
        if ($b991575ae291844b$var$activePostFlushCbs) {
            $b991575ae291844b$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $b991575ae291844b$var$activePostFlushCbs = deduped;
        for($b991575ae291844b$var$postFlushIndex = 0; $b991575ae291844b$var$postFlushIndex < $b991575ae291844b$var$activePostFlushCbs.length; $b991575ae291844b$var$postFlushIndex++){
            const cb = $b991575ae291844b$var$activePostFlushCbs[$b991575ae291844b$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $b991575ae291844b$var$activePostFlushCbs = null;
        $b991575ae291844b$var$postFlushIndex = 0;
    }
}
const $b991575ae291844b$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $b991575ae291844b$var$flushJobs(seen) {
    const check = (0, $iE8iy.NOOP);
    try {
        for($b991575ae291844b$var$flushIndex = 0; $b991575ae291844b$var$flushIndex < $b991575ae291844b$var$queue.length; $b991575ae291844b$var$flushIndex++){
            const job = $b991575ae291844b$var$queue[$b991575ae291844b$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $b991575ae291844b$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $b991575ae291844b$var$flushIndex < $b991575ae291844b$var$queue.length; $b991575ae291844b$var$flushIndex++){
            const job = $b991575ae291844b$var$queue[$b991575ae291844b$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $b991575ae291844b$var$flushIndex = -1;
        $b991575ae291844b$var$queue.length = 0;
        $b991575ae291844b$var$flushPostFlushCbs(seen);
        $b991575ae291844b$var$currentFlushPromise = null;
        if ($b991575ae291844b$var$queue.length || $b991575ae291844b$var$pendingPostFlushCbs.length) $b991575ae291844b$var$flushJobs(seen);
    }
}
function $b991575ae291844b$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $b991575ae291844b$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $b991575ae291844b$var$getComponentName(instance.type);
        $b991575ae291844b$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $b991575ae291844b$var$isHmrUpdating = false;
const $b991575ae291844b$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $b991575ae291844b$var$map = /* @__PURE__ */ new Map();
function $b991575ae291844b$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $b991575ae291844b$var$map.get(id);
    if (!record) {
        $b991575ae291844b$var$createRecord(id, instance.type);
        record = $b991575ae291844b$var$map.get(id);
    }
    record.instances.add(instance);
}
function $b991575ae291844b$var$unregisterHMR(instance) {
    $b991575ae291844b$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $b991575ae291844b$var$createRecord(id, initialDef) {
    if ($b991575ae291844b$var$map.has(id)) return false;
    $b991575ae291844b$var$map.set(id, {
        initialDef: $b991575ae291844b$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $b991575ae291844b$var$normalizeClassComponent(component) {
    return $b991575ae291844b$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $b991575ae291844b$var$rerender(id, newRender) {
    const record = $b991575ae291844b$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $b991575ae291844b$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $b991575ae291844b$var$isHmrUpdating = true;
        instance.update();
        $b991575ae291844b$var$isHmrUpdating = false;
    });
}
function $b991575ae291844b$var$reload(id, newComp) {
    const record = $b991575ae291844b$var$map.get(id);
    if (!record) return;
    newComp = $b991575ae291844b$var$normalizeClassComponent(newComp);
    $b991575ae291844b$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $b991575ae291844b$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $b991575ae291844b$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $b991575ae291844b$var$updateComponentDef(oldComp, newComp);
            $b991575ae291844b$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $b991575ae291844b$var$queueJob(()=>{
            $b991575ae291844b$var$isHmrUpdating = true;
            instance.parent.update();
            $b991575ae291844b$var$isHmrUpdating = false;
            dirtyInstances.delete(instance);
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $b991575ae291844b$export$59536a0199721cab(()=>{
        $b991575ae291844b$var$hmrDirtyComponents.clear();
    });
}
function $b991575ae291844b$var$updateComponentDef(oldComp, newComp) {
    (0, $iE8iy.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $b991575ae291844b$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $b991575ae291844b$var$devtools$1;
let $b991575ae291844b$var$buffer = [];
let $b991575ae291844b$var$devtoolsNotInstalled = false;
function $b991575ae291844b$var$emit$1(event, ...args) {
    if ($b991575ae291844b$var$devtools$1) $b991575ae291844b$var$devtools$1.emit(event, ...args);
    else if (!$b991575ae291844b$var$devtoolsNotInstalled) $b991575ae291844b$var$buffer.push({
        event: event,
        args: args
    });
}
function $b991575ae291844b$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $b991575ae291844b$var$devtools$1 = hook;
    if ($b991575ae291844b$var$devtools$1) {
        $b991575ae291844b$var$devtools$1.enabled = true;
        $b991575ae291844b$var$buffer.forEach(({ event: event, args: args })=>$b991575ae291844b$var$devtools$1.emit(event, ...args));
        $b991575ae291844b$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $b991575ae291844b$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$b991575ae291844b$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $b991575ae291844b$var$devtoolsNotInstalled = true;
                $b991575ae291844b$var$buffer = [];
            }
        }, 3e3);
    } else {
        $b991575ae291844b$var$devtoolsNotInstalled = true;
        $b991575ae291844b$var$buffer = [];
    }
}
function $b991575ae291844b$var$devtoolsInitApp(app, version) {
    $b991575ae291844b$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $b991575ae291844b$export$ffb0004e005737fa,
        Text: $b991575ae291844b$export$5f1af8db9871e1d6,
        Comment: $b991575ae291844b$export$4d299b491347818a,
        Static: $b991575ae291844b$export$c1b9a1d3af45b7b6
    });
}
function $b991575ae291844b$var$devtoolsUnmountApp(app) {
    $b991575ae291844b$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $b991575ae291844b$var$devtoolsComponentAdded = /* @__PURE__ */ $b991575ae291844b$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $b991575ae291844b$var$devtoolsComponentUpdated = /* @__PURE__ */ $b991575ae291844b$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $b991575ae291844b$var$_devtoolsComponentRemoved = /* @__PURE__ */ $b991575ae291844b$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $b991575ae291844b$var$devtoolsComponentRemoved = (component)=>{
    if ($b991575ae291844b$var$devtools$1 && typeof $b991575ae291844b$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$b991575ae291844b$var$devtools$1.cleanupBuffer(component)) $b991575ae291844b$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $b991575ae291844b$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $b991575ae291844b$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $b991575ae291844b$var$devtoolsPerfStart = /* @__PURE__ */ $b991575ae291844b$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $b991575ae291844b$var$devtoolsPerfEnd = /* @__PURE__ */ $b991575ae291844b$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $b991575ae291844b$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $b991575ae291844b$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $b991575ae291844b$var$devtoolsComponentEmit(component, event, params) {
    $b991575ae291844b$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $b991575ae291844b$var$currentRenderingInstance = null;
let $b991575ae291844b$var$currentScopeId = null;
function $b991575ae291844b$var$setCurrentRenderingInstance(instance) {
    const prev = $b991575ae291844b$var$currentRenderingInstance;
    $b991575ae291844b$var$currentRenderingInstance = instance;
    $b991575ae291844b$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $b991575ae291844b$export$ac020265ca2cc4cd(id) {
    $b991575ae291844b$var$currentScopeId = id;
}
function $b991575ae291844b$export$f2dc6805dc11834e() {
    $b991575ae291844b$var$currentScopeId = null;
}
const $b991575ae291844b$export$15ba313e13f3dd04 = (_id)=>$b991575ae291844b$export$694b237e827a3d23;
function $b991575ae291844b$export$694b237e827a3d23(fn, ctx = $b991575ae291844b$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $b991575ae291844b$export$c20bee82f26f1e27(-1);
        const prevInstance = $b991575ae291844b$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $b991575ae291844b$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $b991575ae291844b$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $b991575ae291844b$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $b991575ae291844b$var$validateDirectiveName(name) {
    if ((0, $iE8iy.isBuiltInDirective)(name)) $b991575ae291844b$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $b991575ae291844b$export$49729353e7c1e6c5(vnode, directives) {
    if ($b991575ae291844b$var$currentRenderingInstance === null) return vnode;
    const instance = $b991575ae291844b$var$getComponentPublicInstance($b991575ae291844b$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $iE8iy.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $iE8iy.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $eayOh.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $b991575ae291844b$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $eayOh.pauseTracking)();
            $b991575ae291844b$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $eayOh.resetTracking)();
        }
    }
}
const $b991575ae291844b$var$TeleportEndKey = Symbol("_vte");
const $b991575ae291844b$var$isTeleport = (type)=>type.__isTeleport;
const $b991575ae291844b$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $b991575ae291844b$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $b991575ae291844b$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $b991575ae291844b$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $b991575ae291844b$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $iE8iy.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $b991575ae291844b$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $b991575ae291844b$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) {
                    if (parentComponent && parentComponent.isCE) parentComponent.ce._teleportTarget = container2;
                    mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
            };
            const mountToTarget = ()=>{
                const target = n2.target = $b991575ae291844b$var$resolveTarget(n2.props, querySelector);
                const targetAnchor = $b991575ae291844b$var$prepareAnchor(target, n2, createText, insert);
                if (target) {
                    if (namespace !== "svg" && $b991575ae291844b$var$isTargetSVG(target)) namespace = "svg";
                    else if (namespace !== "mathml" && $b991575ae291844b$var$isTargetMathML(target)) namespace = "mathml";
                    if (!disabled) {
                        mount(target, targetAnchor);
                        $b991575ae291844b$var$updateCssVars(n2, false);
                    }
                }
            };
            if (disabled) {
                mount(container, mainAnchor);
                $b991575ae291844b$var$updateCssVars(n2, true);
            }
            if ($b991575ae291844b$var$isTeleportDeferred(n2.props)) $b991575ae291844b$var$queuePostRenderEffect(()=>{
                mountToTarget();
                n2.el.__isMounted = true;
            }, parentSuspense);
            else mountToTarget();
        } else {
            if ($b991575ae291844b$var$isTeleportDeferred(n2.props) && !n1.el.__isMounted) {
                $b991575ae291844b$var$queuePostRenderEffect(()=>{
                    $b991575ae291844b$var$TeleportImpl.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                    delete n1.el.__isMounted;
                }, parentSuspense);
                return;
            }
            n2.el = n1.el;
            n2.targetStart = n1.targetStart;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $b991575ae291844b$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $b991575ae291844b$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $b991575ae291844b$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $b991575ae291844b$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $b991575ae291844b$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $b991575ae291844b$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $b991575ae291844b$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $b991575ae291844b$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $b991575ae291844b$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$b991575ae291844b$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $b991575ae291844b$var$moveTeleport,
    hydrate: $b991575ae291844b$var$hydrateTeleport
};
function $b991575ae291844b$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $b991575ae291844b$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $b991575ae291844b$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    const target = vnode.target = $b991575ae291844b$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const disabled = $b991575ae291844b$var$isTeleportDisabled(vnode.props);
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetStart = targetNode;
                vnode.targetAnchor = targetNode && nextSibling(targetNode);
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    if (targetAnchor && targetAnchor.nodeType === 8) {
                        if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                        else if (targetAnchor.data === "teleport anchor") {
                            vnode.targetAnchor = targetAnchor;
                            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                            break;
                        }
                    }
                    targetAnchor = nextSibling(targetAnchor);
                }
                if (!vnode.targetAnchor) $b991575ae291844b$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $b991575ae291844b$var$updateCssVars(vnode, disabled);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $b991575ae291844b$export$76d55a0304a371f4 = $b991575ae291844b$var$TeleportImpl;
function $b991575ae291844b$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $b991575ae291844b$var$prepareAnchor(target, vnode, createText, insert) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$b991575ae291844b$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target);
        insert(targetAnchor, target);
    }
    return targetAnchor;
}
const $b991575ae291844b$var$leaveCbKey = Symbol("_leaveCb");
const $b991575ae291844b$var$enterCbKey = Symbol("_enterCb");
function $b991575ae291844b$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $b991575ae291844b$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $b991575ae291844b$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $b991575ae291844b$var$TransitionHookValidator = [
    Function,
    Array
];
const $b991575ae291844b$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $b991575ae291844b$var$TransitionHookValidator,
    onEnter: $b991575ae291844b$var$TransitionHookValidator,
    onAfterEnter: $b991575ae291844b$var$TransitionHookValidator,
    onEnterCancelled: $b991575ae291844b$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $b991575ae291844b$var$TransitionHookValidator,
    onLeave: $b991575ae291844b$var$TransitionHookValidator,
    onAfterLeave: $b991575ae291844b$var$TransitionHookValidator,
    onLeaveCancelled: $b991575ae291844b$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $b991575ae291844b$var$TransitionHookValidator,
    onAppear: $b991575ae291844b$var$TransitionHookValidator,
    onAfterAppear: $b991575ae291844b$var$TransitionHookValidator,
    onAppearCancelled: $b991575ae291844b$var$TransitionHookValidator
};
const $b991575ae291844b$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $b991575ae291844b$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $b991575ae291844b$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $b991575ae291844b$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $b991575ae291844b$export$f13e630aa3915748();
        const state = $b991575ae291844b$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $b991575ae291844b$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            const child = $b991575ae291844b$var$findNonCommentChild(children);
            const rawProps = (0, $eayOh.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $b991575ae291844b$var$emptyPlaceholder(child);
            const innerChild = $b991575ae291844b$var$getInnerChild$1(child);
            if (!innerChild) return $b991575ae291844b$var$emptyPlaceholder(child);
            let enterHooks = $b991575ae291844b$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $b991575ae291844b$export$4d299b491347818a) $b991575ae291844b$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $b991575ae291844b$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $b991575ae291844b$export$4d299b491347818a && !$b991575ae291844b$var$isSameVNodeType(innerChild, oldInnerChild) && $b991575ae291844b$var$recursiveGetSubtree(instance).type !== $b991575ae291844b$export$4d299b491347818a) {
                let leavingHooks = $b991575ae291844b$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $b991575ae291844b$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $b991575ae291844b$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $b991575ae291844b$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $b991575ae291844b$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $b991575ae291844b$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$b991575ae291844b$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$b991575ae291844b$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $b991575ae291844b$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $b991575ae291844b$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $b991575ae291844b$export$abd95b5f5e8a8837 = $b991575ae291844b$var$BaseTransitionImpl;
function $b991575ae291844b$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $b991575ae291844b$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $b991575ae291844b$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $b991575ae291844b$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $iE8iy.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$b991575ae291844b$var$leaveCbKey]) el[$b991575ae291844b$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $b991575ae291844b$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$b991575ae291844b$var$leaveCbKey]) leavingVNode.el[$b991575ae291844b$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$b991575ae291844b$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$b991575ae291844b$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$b991575ae291844b$var$enterCbKey]) el[$b991575ae291844b$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$b991575ae291844b$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$b991575ae291844b$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $b991575ae291844b$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $b991575ae291844b$var$emptyPlaceholder(vnode) {
    if ($b991575ae291844b$var$isKeepAlive(vnode)) {
        vnode = $b991575ae291844b$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $b991575ae291844b$var$getInnerChild$1(vnode) {
    if (!$b991575ae291844b$var$isKeepAlive(vnode)) {
        if ($b991575ae291844b$var$isTeleport(vnode.type) && vnode.children) return $b991575ae291844b$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $iE8iy.isFunction)(children.default)) return children.default();
    }
}
function $b991575ae291844b$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        $b991575ae291844b$export$7770a22486565649(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $b991575ae291844b$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $b991575ae291844b$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($b991575ae291844b$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $b991575ae291844b$export$4d299b491347818a) ret.push(key != null ? $b991575ae291844b$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $b991575ae291844b$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $iE8iy.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $iE8iy.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $b991575ae291844b$export$f680877a34711e37() {
    const i = $b991575ae291844b$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $b991575ae291844b$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $b991575ae291844b$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $b991575ae291844b$export$83a5dbc1f35517ca(key) {
    const i = $b991575ae291844b$export$f13e630aa3915748();
    const r = (0, $eayOh.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $iE8iy.EMPTY_OBJ) ? i.refs = {} : i.refs;
        let desc;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $b991575ae291844b$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $iE8iy.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$b991575ae291844b$var$setRef(r, oldRawRef && ((0, $iE8iy.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($b991575ae291844b$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $b991575ae291844b$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $b991575ae291844b$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $iE8iy.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $eayOh.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $iE8iy.EMPTY_OBJ) ? ()=>false : (key)=>{
        return (0, $iE8iy.hasOwn)(rawSetupState, key);
    };
    if (oldRef != null && oldRef !== ref) {
        if ((0, $iE8iy.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $eayOh.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $iE8iy.isFunction)(ref)) $b991575ae291844b$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $iE8iy.isString)(ref);
        const _isRef = (0, $eayOh.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $iE8iy.isArray)(existing) && (0, $iE8iy.remove)(existing, refValue);
                    else {
                        if (!(0, $iE8iy.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $b991575ae291844b$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $b991575ae291844b$var$hasLoggedMismatchError = false;
const $b991575ae291844b$var$logMismatchError = ()=>{
    if ($b991575ae291844b$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $b991575ae291844b$var$hasLoggedMismatchError = true;
};
const $b991575ae291844b$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $b991575ae291844b$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $b991575ae291844b$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($b991575ae291844b$var$isSVGContainer(container)) return "svg";
    if ($b991575ae291844b$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $b991575ae291844b$var$isComment = (node)=>node.nodeType === 8;
function $b991575ae291844b$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $b991575ae291844b$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $b991575ae291844b$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $b991575ae291844b$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $b991575ae291844b$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $iE8iy.def)(node, "__vnode", vnode, true);
            (0, $iE8iy.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $b991575ae291844b$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $b991575ae291844b$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $b991575ae291844b$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $b991575ae291844b$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $b991575ae291844b$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $b991575ae291844b$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($b991575ae291844b$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $b991575ae291844b$var$getContainerType(container), optimized);
                    if ($b991575ae291844b$var$isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $b991575ae291844b$export$bf5c4cf060303d58($b991575ae291844b$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $b991575ae291844b$export$22f9b5ffd89dac9("") : $b991575ae291844b$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $b991575ae291844b$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $b991575ae291844b$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $b991575ae291844b$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $b991575ae291844b$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $b991575ae291844b$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (!$b991575ae291844b$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                            $b991575ae291844b$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                            hasWarned = true;
                        }
                        $b991575ae291844b$var$logMismatchError();
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                if (el.textContent !== clientText) {
                    if (!$b991575ae291844b$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $b991575ae291844b$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                        $b991575ae291844b$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $b991575ae291844b$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $b991575ae291844b$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $iE8iy.isOn)(key) && !(0, $iE8iy.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $eayOh.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $b991575ae291844b$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $b991575ae291844b$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $b991575ae291844b$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $b991575ae291844b$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $b991575ae291844b$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $b991575ae291844b$var$normalizeVNode(children[i]);
            const isText = vnode.type === $b991575ae291844b$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $b991575ae291844b$var$normalizeVNode(children[i + 1]).type === $b991575ae291844b$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!$b991575ae291844b$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $b991575ae291844b$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    $b991575ae291844b$var$logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $b991575ae291844b$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $b991575ae291844b$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $b991575ae291844b$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$b991575ae291844b$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $b991575ae291844b$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $b991575ae291844b$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $b991575ae291844b$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $b991575ae291844b$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $b991575ae291844b$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $b991575ae291844b$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $b991575ae291844b$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, $iE8iy.normalizeClass)(clientValue);
        if (!$b991575ae291844b$var$isSetEqual($b991575ae291844b$var$toClassSet(actual || ""), $b991575ae291844b$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $iE8iy.isString)(clientValue) ? clientValue : (0, $iE8iy.stringifyStyle)((0, $iE8iy.normalizeStyle)(clientValue));
        const actualMap = $b991575ae291844b$var$toStyleMap(actual);
        const expectedMap = $b991575ae291844b$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $b991575ae291844b$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$b991575ae291844b$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $iE8iy.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $iE8iy.isBooleanAttr)(key) || (0, $iE8iy.isKnownHtmlAttr)(key))) {
        if ((0, $iE8iy.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $iE8iy.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $iE8iy.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$b991575ae291844b$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$b991575ae291844b$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $b991575ae291844b$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $b991575ae291844b$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $b991575ae291844b$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $b991575ae291844b$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $b991575ae291844b$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $b991575ae291844b$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $b991575ae291844b$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars)expectedMap.set(`--${(0, $iE8iy.getEscapedCssVarName)(key, false)}`, String(cssVars[key]));
    }
    if (vnode === root && instance.parent) $b991575ae291844b$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $b991575ae291844b$var$allowMismatchAttr = "data-allow-mismatch";
const $b991575ae291844b$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $b991575ae291844b$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($b991575ae291844b$var$allowMismatchAttr))el = el.parentElement;
    const allowedAttr = el && el.getAttribute($b991575ae291844b$var$allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return allowedAttr.split(",").includes($b991575ae291844b$var$MismatchTypeString[allowedType]);
    }
}
const $b991575ae291844b$var$requestIdleCallback = (0, $iE8iy.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $b991575ae291844b$var$cancelIdleCallback = (0, $iE8iy.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $b991575ae291844b$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $b991575ae291844b$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$b991575ae291844b$var$cancelIdleCallback(id);
    };
function $b991575ae291844b$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $b991575ae291844b$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($b991575ae291844b$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $b991575ae291844b$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $b991575ae291844b$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $iE8iy.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $b991575ae291844b$var$forEachElement(node, cb) {
    if ($b991575ae291844b$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($b991575ae291844b$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $b991575ae291844b$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $b991575ae291844b$export$d75d499b4c16cf21(source) {
    if ((0, $iE8iy.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $b991575ae291844b$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(hydrate, (cb)=>$b991575ae291844b$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : hydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $b991575ae291844b$var$currentInstance;
            $b991575ae291844b$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$b991575ae291844b$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $b991575ae291844b$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $b991575ae291844b$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$b991575ae291844b$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $b991575ae291844b$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $eayOh.ref)(false);
            const error = (0, $eayOh.ref)();
            const delayed = (0, $eayOh.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $b991575ae291844b$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $b991575ae291844b$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $b991575ae291844b$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $b991575ae291844b$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $b991575ae291844b$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $b991575ae291844b$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $b991575ae291844b$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $b991575ae291844b$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $b991575ae291844b$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $b991575ae291844b$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $iE8iy.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $b991575ae291844b$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $b991575ae291844b$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $b991575ae291844b$var$invalidateMount(instance2.m);
            $b991575ae291844b$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $b991575ae291844b$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $iE8iy.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $b991575ae291844b$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $b991575ae291844b$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $b991575ae291844b$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $b991575ae291844b$var$getComponentName(vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$b991575ae291844b$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $b991575ae291844b$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $b991575ae291844b$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$b991575ae291844b$var$matches(include, name));
            exclude && pruneCache((name)=>!$b991575ae291844b$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($b991575ae291844b$var$isSuspense(instance.subTree.type)) $b991575ae291844b$var$queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, $b991575ae291844b$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $b991575ae291844b$var$getInnerChild(instance.subTree));
            }
        };
        $b991575ae291844b$export$6d1641039221b5cb(cacheSubtree);
        $b991575ae291844b$export$5876c47052fb88b1(cacheSubtree);
        $b991575ae291844b$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $b991575ae291844b$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $b991575ae291844b$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $b991575ae291844b$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$b991575ae291844b$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $b991575ae291844b$var$getInnerChild(rawVNode);
            if (vnode.type === $b991575ae291844b$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $b991575ae291844b$var$getComponentName($b991575ae291844b$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$b991575ae291844b$var$matches(include, name)) || exclude && name && $b991575ae291844b$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $b991575ae291844b$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $b991575ae291844b$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $b991575ae291844b$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $b991575ae291844b$export$70eb8a58709972df = $b991575ae291844b$var$KeepAliveImpl;
function $b991575ae291844b$var$matches(pattern, name) {
    if ((0, $iE8iy.isArray)(pattern)) return pattern.some((p)=>$b991575ae291844b$var$matches(p, name));
    else if ((0, $iE8iy.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $iE8iy.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $b991575ae291844b$export$ba52d824b95a2154(hook, target) {
    $b991575ae291844b$var$registerKeepAliveHook(hook, "a", target);
}
function $b991575ae291844b$export$bf1440eeaf5fa709(hook, target) {
    $b991575ae291844b$var$registerKeepAliveHook(hook, "da", target);
}
function $b991575ae291844b$var$registerKeepAliveHook(hook, type, target = $b991575ae291844b$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $b991575ae291844b$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($b991575ae291844b$var$isKeepAlive(current.parent.vnode)) $b991575ae291844b$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $b991575ae291844b$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $b991575ae291844b$var$injectHook(type, hook, keepAliveRoot, true);
    $b991575ae291844b$export$13348a43ccacfe58(()=>{
        (0, $iE8iy.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $b991575ae291844b$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $b991575ae291844b$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $b991575ae291844b$var$injectHook(type, hook, target = $b991575ae291844b$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $eayOh.pauseTracking)();
            const reset = $b991575ae291844b$var$setCurrentInstance(target);
            const res = $b991575ae291844b$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $eayOh.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $b991575ae291844b$var$createHook = (lifecycle)=>(hook, target = $b991575ae291844b$var$currentInstance)=>{
        if (!$b991575ae291844b$var$isInSSRComponentSetup || lifecycle === "sp") $b991575ae291844b$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $b991575ae291844b$export$23b7aeb0d671f804 = $b991575ae291844b$var$createHook("bm");
const $b991575ae291844b$export$6d1641039221b5cb = $b991575ae291844b$var$createHook("m");
const $b991575ae291844b$export$ab91988a13872e4c = $b991575ae291844b$var$createHook("bu");
const $b991575ae291844b$export$5876c47052fb88b1 = $b991575ae291844b$var$createHook("u");
const $b991575ae291844b$export$40c420df62d2614 = $b991575ae291844b$var$createHook("bum");
const $b991575ae291844b$export$13348a43ccacfe58 = $b991575ae291844b$var$createHook("um");
const $b991575ae291844b$export$ebf0c601f267bceb = $b991575ae291844b$var$createHook("sp");
const $b991575ae291844b$export$898295a813d662eb = $b991575ae291844b$var$createHook("rtg");
const $b991575ae291844b$export$2b41f4235363e921 = $b991575ae291844b$var$createHook("rtc");
function $b991575ae291844b$export$6a3a15856e50ad19(hook, target = $b991575ae291844b$var$currentInstance) {
    $b991575ae291844b$var$injectHook("ec", hook, target);
}
const $b991575ae291844b$var$COMPONENTS = "components";
const $b991575ae291844b$var$DIRECTIVES = "directives";
function $b991575ae291844b$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $b991575ae291844b$var$resolveAsset($b991575ae291844b$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $b991575ae291844b$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $b991575ae291844b$export$b44c564a05ca975(component) {
    if ((0, $iE8iy.isString)(component)) return $b991575ae291844b$var$resolveAsset($b991575ae291844b$var$COMPONENTS, component, false) || component;
    else return component || $b991575ae291844b$var$NULL_DYNAMIC_COMPONENT;
}
function $b991575ae291844b$export$a1989e995cd481be(name) {
    return $b991575ae291844b$var$resolveAsset($b991575ae291844b$var$DIRECTIVES, name);
}
function $b991575ae291844b$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $b991575ae291844b$var$currentRenderingInstance || $b991575ae291844b$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $b991575ae291844b$var$COMPONENTS) {
            const selfName = $b991575ae291844b$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $iE8iy.camelize)(name) || selfName === (0, $iE8iy.capitalize)((0, $iE8iy.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $b991575ae291844b$var$resolve(instance[type] || Component[type], name) || // global registration
        $b991575ae291844b$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $b991575ae291844b$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $iE8iy.camelize)(name)] || registry[(0, $iE8iy.capitalize)((0, $iE8iy.camelize)(name))]);
}
function $b991575ae291844b$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $iE8iy.isArray)(source);
    if (sourceIsArray || (0, $iE8iy.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $eayOh.isReactive)(source);
        let needsWrap = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $eayOh.isShallow)(source);
            source = (0, $eayOh.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? (0, $eayOh.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $iE8iy.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $b991575ae291844b$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $iE8iy.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $b991575ae291844b$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($b991575ae291844b$var$currentRenderingInstance.ce || $b991575ae291844b$var$currentRenderingInstance.parent && $b991575ae291844b$var$isAsyncWrapper($b991575ae291844b$var$currentRenderingInstance.parent) && $b991575ae291844b$var$currentRenderingInstance.parent.ce) {
        if (name !== "default") props.name = name;
        return $b991575ae291844b$export$e7eaa45e502fe5cc(), $b991575ae291844b$export$9f2dfe8048dfb22b($b991575ae291844b$export$ffb0004e005737fa, null, [
            $b991575ae291844b$export$bf5c4cf060303d58("slot", props, fallback && fallback())
        ], 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $b991575ae291844b$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $b991575ae291844b$var$ensureValidVNode(slot(props));
    const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    const rendered = $b991575ae291844b$export$9f2dfe8048dfb22b($b991575ae291844b$export$ffb0004e005737fa, {
        key: (slotKey && !(0, $iE8iy.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $b991575ae291844b$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$b991575ae291844b$export$3868d13f8734ae81(child)) return true;
        if (child.type === $b991575ae291844b$export$4d299b491347818a) return false;
        if (child.type === $b991575ae291844b$export$ffb0004e005737fa && !$b991575ae291844b$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $b991575ae291844b$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $iE8iy.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $b991575ae291844b$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($b991575ae291844b$var$isStatefulComponent(i)) return $b991575ae291844b$var$getComponentPublicInstance(i);
    return $b991575ae291844b$var$getPublicInstance(i.parent);
};
const $b991575ae291844b$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $iE8iy.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$b991575ae291844b$var$getPublicInstance(i.parent),
    $root: (i)=>$b991575ae291844b$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $b991575ae291844b$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $b991575ae291844b$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $b991575ae291844b$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $b991575ae291844b$var$instanceWatch.bind(i) : (0, $iE8iy.NOOP)
});
const $b991575ae291844b$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $b991575ae291844b$var$hasSetupBinding = (state, key)=>state !== (0, $iE8iy.EMPTY_OBJ) && !state.__isScriptSetup && (0, $iE8iy.hasOwn)(state, key);
const $b991575ae291844b$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($b991575ae291844b$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $iE8iy.EMPTY_OBJ) && (0, $iE8iy.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $iE8iy.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $iE8iy.EMPTY_OBJ) && (0, $iE8iy.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $b991575ae291844b$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $b991575ae291844b$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $eayOh.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $iE8iy.EMPTY_OBJ) && (0, $iE8iy.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $iE8iy.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($b991575ae291844b$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $iE8iy.EMPTY_OBJ) && (0, $iE8iy.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $iE8iy.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $iE8iy.EMPTY_OBJ) && (0, $iE8iy.hasOwn)(data, key) || $b991575ae291844b$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $iE8iy.hasOwn)(normalizedProps, key) || (0, $iE8iy.hasOwn)(ctx, key) || (0, $iE8iy.hasOwn)($b991575ae291844b$var$publicPropertiesMap, key) || (0, $iE8iy.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $iE8iy.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $b991575ae291844b$var$target;
const $b991575ae291844b$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $iE8iy.extend)({}, $b991575ae291844b$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $b991575ae291844b$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $iE8iy.isGloballyAllowed)(key);
        return has;
    }
});
function $b991575ae291844b$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($b991575ae291844b$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$b991575ae291844b$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $iE8iy.NOOP)
        });
    });
    return target;
}
function $b991575ae291844b$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $iE8iy.NOOP)
        });
    });
}
function $b991575ae291844b$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $eayOh.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($b991575ae291844b$var$isReservedPrefix(key[0])) {
                $b991575ae291844b$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $iE8iy.NOOP)
            });
        }
    });
}
const $b991575ae291844b$var$warnRuntimeUsage = (method)=>$b991575ae291844b$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $b991575ae291844b$export$80b33eababae110e() {
    return null;
}
function $b991575ae291844b$export$51ecece22fc17ddc() {
    return null;
}
function $b991575ae291844b$export$da25b65ca24b518a(exposed) {}
function $b991575ae291844b$export$77e79129327f3d0d(options) {}
function $b991575ae291844b$export$1b3acd4bb805b712() {
    return null;
}
function $b991575ae291844b$export$acd55aa037e791bb() {}
function $b991575ae291844b$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $b991575ae291844b$export$9203a8e84125433c() {
    return $b991575ae291844b$var$getContext().slots;
}
function $b991575ae291844b$export$75e29435042cd2ea() {
    return $b991575ae291844b$var$getContext().attrs;
}
function $b991575ae291844b$var$getContext() {
    const i = $b991575ae291844b$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $b991575ae291844b$var$createSetupContext(i));
}
function $b991575ae291844b$var$normalizePropsOrEmits(props) {
    return (0, $iE8iy.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $b991575ae291844b$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $b991575ae291844b$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $iE8iy.isArray)(opt) || (0, $iE8iy.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $b991575ae291844b$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $iE8iy.isArray)(a) && (0, $iE8iy.isArray)(b)) return a.concat(b);
    return (0, $iE8iy.extend)({}, $b991575ae291844b$var$normalizePropsOrEmits(a), $b991575ae291844b$var$normalizePropsOrEmits(b));
}
function $b991575ae291844b$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $b991575ae291844b$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $b991575ae291844b$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $b991575ae291844b$var$unsetCurrentInstance();
    if ((0, $iE8iy.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $b991575ae291844b$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$b991575ae291844b$var$setCurrentInstance(ctx)
    ];
}
function $b991575ae291844b$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $b991575ae291844b$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $b991575ae291844b$var$shouldCacheAccess = true;
function $b991575ae291844b$var$applyOptions(instance) {
    const options = $b991575ae291844b$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $b991575ae291844b$var$shouldCacheAccess = false;
    if (options.beforeCreate) $b991575ae291844b$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $b991575ae291844b$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $iE8iy.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $iE8iy.isObject)(data)) ;
        else instance.data = (0, $eayOh.reactive)(data);
    }
    $b991575ae291844b$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $iE8iy.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $iE8iy.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $iE8iy.NOOP);
        const set = !(0, $iE8iy.isFunction)(opt) && (0, $iE8iy.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $iE8iy.NOOP);
        const c = $b991575ae291844b$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$b991575ae291844b$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $iE8iy.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $b991575ae291844b$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $b991575ae291844b$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $iE8iy.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($b991575ae291844b$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($b991575ae291844b$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($b991575ae291844b$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($b991575ae291844b$export$5876c47052fb88b1, updated);
    registerLifecycleHook($b991575ae291844b$export$ba52d824b95a2154, activated);
    registerLifecycleHook($b991575ae291844b$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($b991575ae291844b$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($b991575ae291844b$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($b991575ae291844b$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($b991575ae291844b$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($b991575ae291844b$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($b991575ae291844b$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $iE8iy.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $iE8iy.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $b991575ae291844b$var$markAsyncBoundary(instance);
}
function $b991575ae291844b$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $iE8iy.NOOP)) {
    if ((0, $iE8iy.isArray)(injectOptions)) injectOptions = $b991575ae291844b$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $iE8iy.isObject)(opt)) {
            if ("default" in opt) injected = $b991575ae291844b$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $b991575ae291844b$export$a976684a0efeb93f(opt.from || key);
        } else injected = $b991575ae291844b$export$a976684a0efeb93f(opt);
        if ((0, $eayOh.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $b991575ae291844b$var$callHook(hook, instance, type) {
    $b991575ae291844b$export$dae85862a8d94378((0, $iE8iy.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $b991575ae291844b$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $b991575ae291844b$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $iE8iy.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $iE8iy.isFunction)(handler)) $b991575ae291844b$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $iE8iy.isFunction)(raw)) $b991575ae291844b$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $iE8iy.isObject)(raw)) {
        if ((0, $iE8iy.isArray)(raw)) raw.forEach((r)=>$b991575ae291844b$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $iE8iy.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $iE8iy.isFunction)(handler)) $b991575ae291844b$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $b991575ae291844b$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$b991575ae291844b$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $b991575ae291844b$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $iE8iy.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $b991575ae291844b$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $b991575ae291844b$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$b991575ae291844b$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $b991575ae291844b$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $b991575ae291844b$var$internalOptionMergeStrats = {
    data: $b991575ae291844b$var$mergeDataFn,
    props: $b991575ae291844b$var$mergeEmitsOrPropsOptions,
    emits: $b991575ae291844b$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $b991575ae291844b$var$mergeObjectOptions,
    computed: $b991575ae291844b$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $b991575ae291844b$var$mergeAsArray,
    created: $b991575ae291844b$var$mergeAsArray,
    beforeMount: $b991575ae291844b$var$mergeAsArray,
    mounted: $b991575ae291844b$var$mergeAsArray,
    beforeUpdate: $b991575ae291844b$var$mergeAsArray,
    updated: $b991575ae291844b$var$mergeAsArray,
    beforeDestroy: $b991575ae291844b$var$mergeAsArray,
    beforeUnmount: $b991575ae291844b$var$mergeAsArray,
    destroyed: $b991575ae291844b$var$mergeAsArray,
    unmounted: $b991575ae291844b$var$mergeAsArray,
    activated: $b991575ae291844b$var$mergeAsArray,
    deactivated: $b991575ae291844b$var$mergeAsArray,
    errorCaptured: $b991575ae291844b$var$mergeAsArray,
    serverPrefetch: $b991575ae291844b$var$mergeAsArray,
    // assets
    components: $b991575ae291844b$var$mergeObjectOptions,
    directives: $b991575ae291844b$var$mergeObjectOptions,
    // watch
    watch: $b991575ae291844b$var$mergeWatchOptions,
    // provide / inject
    provide: $b991575ae291844b$var$mergeDataFn,
    inject: $b991575ae291844b$var$mergeInject
};
function $b991575ae291844b$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $iE8iy.extend)((0, $iE8iy.isFunction)(to) ? to.call(this, this) : to, (0, $iE8iy.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $b991575ae291844b$var$mergeInject(to, from) {
    return $b991575ae291844b$var$mergeObjectOptions($b991575ae291844b$var$normalizeInject(to), $b991575ae291844b$var$normalizeInject(from));
}
function $b991575ae291844b$var$normalizeInject(raw) {
    if ((0, $iE8iy.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $b991575ae291844b$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $b991575ae291844b$var$mergeObjectOptions(to, from) {
    return to ? (0, $iE8iy.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $b991575ae291844b$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $iE8iy.isArray)(to) && (0, $iE8iy.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $iE8iy.extend)(/* @__PURE__ */ Object.create(null), $b991575ae291844b$var$normalizePropsOrEmits(to), $b991575ae291844b$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $b991575ae291844b$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $iE8iy.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $b991575ae291844b$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $b991575ae291844b$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $iE8iy.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $b991575ae291844b$var$uid$1 = 0;
function $b991575ae291844b$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $iE8iy.isFunction)(rootComponent)) rootComponent = (0, $iE8iy.extend)({}, rootComponent);
        if (rootProps != null && !(0, $iE8iy.isObject)(rootProps)) rootProps = null;
        const context = $b991575ae291844b$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $b991575ae291844b$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $b991575ae291844b$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $iE8iy.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $iE8iy.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $b991575ae291844b$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $b991575ae291844b$var$devtoolsInitApp(app, $b991575ae291844b$export$83d89fbfd8236492);
                    }
                    return $b991575ae291844b$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $b991575ae291844b$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $b991575ae291844b$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $b991575ae291844b$var$currentApp;
                $b991575ae291844b$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $b991575ae291844b$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $b991575ae291844b$var$currentApp = null;
function $b991575ae291844b$export$abe1e183e22e10ad(key, value) {
    if (!$b991575ae291844b$var$currentInstance) ;
    else {
        let provides = $b991575ae291844b$var$currentInstance.provides;
        const parentProvides = $b991575ae291844b$var$currentInstance.parent && $b991575ae291844b$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $b991575ae291844b$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $b991575ae291844b$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $b991575ae291844b$var$currentInstance || $b991575ae291844b$var$currentRenderingInstance;
    if (instance || $b991575ae291844b$var$currentApp) {
        const provides = $b991575ae291844b$var$currentApp ? $b991575ae291844b$var$currentApp._context.provides : instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $iE8iy.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $b991575ae291844b$export$caf6761f24fc571a() {
    return !!($b991575ae291844b$var$currentInstance || $b991575ae291844b$var$currentRenderingInstance || $b991575ae291844b$var$currentApp);
}
const $b991575ae291844b$var$internalObjectProto = {};
const $b991575ae291844b$var$createInternalObject = ()=>Object.create($b991575ae291844b$var$internalObjectProto);
const $b991575ae291844b$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $b991575ae291844b$var$internalObjectProto;
function $b991575ae291844b$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $b991575ae291844b$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $b991575ae291844b$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $eayOh.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $b991575ae291844b$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $b991575ae291844b$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $eayOh.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($b991575ae291844b$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $iE8iy.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $iE8iy.camelize)(key);
                        props[camelizedKey] = $b991575ae291844b$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($b991575ae291844b$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $iE8iy.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $iE8iy.hyphenate)(key)) === key || !(0, $iE8iy.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $b991575ae291844b$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $iE8iy.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $eayOh.trigger)(instance.attrs, "set", "");
}
function $b991575ae291844b$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $iE8iy.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $iE8iy.hasOwn)(options, camelKey = (0, $iE8iy.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$b991575ae291844b$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $eayOh.toRaw)(props);
        const castValues = rawCastValues || (0, $iE8iy.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $b991575ae291844b$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $iE8iy.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $b991575ae291844b$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $iE8iy.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $iE8iy.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $b991575ae291844b$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $iE8iy.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $b991575ae291844b$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $b991575ae291844b$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $b991575ae291844b$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $iE8iy.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $b991575ae291844b$var$normalizePropsOptions(raw2, appContext, true);
            (0, $iE8iy.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $iE8iy.isObject)(comp)) cache.set(comp, (0, $iE8iy.EMPTY_ARR));
        return 0, $iE8iy.EMPTY_ARR;
    }
    if ((0, $iE8iy.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $iE8iy.camelize)(raw[i]);
        if ($b991575ae291844b$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $iE8iy.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $iE8iy.camelize)(key);
        if ($b991575ae291844b$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $iE8iy.isArray)(opt) || (0, $iE8iy.isFunction)(opt) ? {
                type: opt
            } : (0, $iE8iy.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $iE8iy.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $iE8iy.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $iE8iy.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $iE8iy.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $iE8iy.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $b991575ae291844b$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $iE8iy.isReservedProp)(key)) return true;
    return false;
}
function $b991575ae291844b$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $b991575ae291844b$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $eayOh.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $iE8iy.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $b991575ae291844b$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $b991575ae291844b$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $b991575ae291844b$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $iE8iy.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $b991575ae291844b$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $b991575ae291844b$var$warn$1($b991575ae291844b$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $b991575ae291844b$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $b991575ae291844b$var$isSimpleType = /* @__PURE__ */ (0, $iE8iy.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $b991575ae291844b$var$assertType(value, type) {
    let valid;
    const expectedType = $b991575ae291844b$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($b991575ae291844b$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $iE8iy.isObject)(value);
    else if (expectedType === "Array") valid = (0, $iE8iy.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $b991575ae291844b$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $iE8iy.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $iE8iy.toRawType)(value);
    const expectedValue = $b991575ae291844b$var$styleValue(value, expectedType);
    const receivedValue = $b991575ae291844b$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $b991575ae291844b$var$isExplicable(expectedType) && !$b991575ae291844b$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($b991575ae291844b$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $b991575ae291844b$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $b991575ae291844b$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $b991575ae291844b$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $b991575ae291844b$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $b991575ae291844b$var$normalizeSlotValue = (value)=>(0, $iE8iy.isArray)(value) ? value.map($b991575ae291844b$var$normalizeVNode) : [
        $b991575ae291844b$var$normalizeVNode(value)
    ];
const $b991575ae291844b$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $b991575ae291844b$export$694b237e827a3d23((...args)=>{
        return $b991575ae291844b$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $b991575ae291844b$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($b991575ae291844b$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $iE8iy.isFunction)(value)) slots[key] = $b991575ae291844b$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $b991575ae291844b$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $b991575ae291844b$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $b991575ae291844b$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $b991575ae291844b$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || key !== "_") slots[key] = children[key];
};
const $b991575ae291844b$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $b991575ae291844b$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $b991575ae291844b$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $iE8iy.def)(slots, "_", type, true);
        } else $b991575ae291844b$var$normalizeObjectSlots(children, slots);
    } else if (children) $b991575ae291844b$var$normalizeVNodeSlots(instance, children);
};
const $b991575ae291844b$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $iE8iy.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $b991575ae291844b$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $b991575ae291844b$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $b991575ae291844b$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$b991575ae291844b$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $b991575ae291844b$var$supported;
let $b991575ae291844b$var$perf;
function $b991575ae291844b$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $b991575ae291844b$var$isSupported()) $b991575ae291844b$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $b991575ae291844b$var$devtoolsPerfStart(instance, type, $b991575ae291844b$var$isSupported() ? $b991575ae291844b$var$perf.now() : Date.now());
}
function $b991575ae291844b$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $b991575ae291844b$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $b991575ae291844b$var$perf.mark(endTag);
        $b991575ae291844b$var$perf.measure(`<${$b991575ae291844b$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $b991575ae291844b$var$perf.clearMarks(startTag);
        $b991575ae291844b$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $b991575ae291844b$var$devtoolsPerfEnd(instance, type, $b991575ae291844b$var$isSupported() ? $b991575ae291844b$var$perf.now() : Date.now());
}
function $b991575ae291844b$var$isSupported() {
    if ($b991575ae291844b$var$supported !== void 0) return $b991575ae291844b$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $b991575ae291844b$var$supported = true;
        $b991575ae291844b$var$perf = window.performance;
    } else $b991575ae291844b$var$supported = false;
    return $b991575ae291844b$var$supported;
}
function $b991575ae291844b$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $iE8iy.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $iE8iy.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $iE8iy.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $b991575ae291844b$var$queuePostRenderEffect = $b991575ae291844b$var$queueEffectWithSuspense;
function $b991575ae291844b$export$53ae2f996c64e9a(options) {
    return $b991575ae291844b$var$baseCreateRenderer(options);
}
function $b991575ae291844b$export$200524cf0d997ff0(options) {
    return $b991575ae291844b$var$baseCreateRenderer(options, $b991575ae291844b$var$createHydrationFunctions);
}
function $b991575ae291844b$var$baseCreateRenderer(options, createHydrationFns) {
    $b991575ae291844b$var$initFeatureFlags();
    const target = (0, $iE8iy.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $b991575ae291844b$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $iE8iy.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$b991575ae291844b$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $b991575ae291844b$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $b991575ae291844b$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $b991575ae291844b$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $b991575ae291844b$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $b991575ae291844b$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $b991575ae291844b$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $b991575ae291844b$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $iE8iy.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $b991575ae291844b$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $iE8iy.def)(el, "__vnode", vnode, true);
            (0, $iE8iy.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $b991575ae291844b$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $b991575ae291844b$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $b991575ae291844b$var$queuePostRenderEffect(()=>{
            vnodeHook && $b991575ae291844b$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $b991575ae291844b$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $b991575ae291844b$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $b991575ae291844b$var$cloneIfMounted(children[i]) : $b991575ae291844b$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $iE8iy.EMPTY_OBJ);
        const newProps = n2.props || (0, $iE8iy.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $b991575ae291844b$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $b991575ae291844b$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $b991575ae291844b$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $b991575ae291844b$var$toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $b991575ae291844b$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $b991575ae291844b$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $b991575ae291844b$var$queuePostRenderEffect(()=>{
            vnodeHook && $b991575ae291844b$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $b991575ae291844b$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $b991575ae291844b$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$b991575ae291844b$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $iE8iy.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $iE8iy.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $iE8iy.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $b991575ae291844b$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $b991575ae291844b$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($b991575ae291844b$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $b991575ae291844b$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $b991575ae291844b$export$bf5c4cf060303d58($b991575ae291844b$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($b991575ae291844b$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $b991575ae291844b$var$isAsyncWrapper(initialVNode);
                $b991575ae291844b$var$toggleRecurse(instance, false);
                if (bm) (0, $iE8iy.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $b991575ae291844b$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $b991575ae291844b$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $b991575ae291844b$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce) root.ce._injectChildStyle(type);
                    const subTree = instance.subTree = $b991575ae291844b$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $b991575ae291844b$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $b991575ae291844b$var$queuePostRenderEffect(()=>$b991575ae291844b$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $b991575ae291844b$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $b991575ae291844b$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $b991575ae291844b$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $b991575ae291844b$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $b991575ae291844b$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $iE8iy.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $b991575ae291844b$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $b991575ae291844b$var$toggleRecurse(instance, true);
                const nextTree = $b991575ae291844b$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $b991575ae291844b$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $b991575ae291844b$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $b991575ae291844b$var$queuePostRenderEffect(()=>$b991575ae291844b$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $b991575ae291844b$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $eayOh.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$b991575ae291844b$var$queueJob(job);
        $b991575ae291844b$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $b991575ae291844b$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $b991575ae291844b$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $eayOh.pauseTracking)();
        $b991575ae291844b$var$flushPreFlushCbs(instance);
        (0, $eayOh.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $iE8iy.EMPTY_ARR);
        c2 = c2 || (0, $iE8iy.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $b991575ae291844b$var$cloneIfMounted(c2[i]) : $b991575ae291844b$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $b991575ae291844b$var$cloneIfMounted(c2[i]) : $b991575ae291844b$var$normalizeVNode(c2[i]);
            if ($b991575ae291844b$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $b991575ae291844b$var$cloneIfMounted(c2[e2]) : $b991575ae291844b$var$normalizeVNode(c2[e2]);
            if ($b991575ae291844b$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $b991575ae291844b$var$cloneIfMounted(c2[i]) : $b991575ae291844b$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $b991575ae291844b$var$cloneIfMounted(c2[i]) : $b991575ae291844b$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $b991575ae291844b$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $b991575ae291844b$var$getSequence(newIndexToOldIndexMap) : (0, $iE8iy.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $b991575ae291844b$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $b991575ae291844b$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $b991575ae291844b$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) $b991575ae291844b$var$setRef(ref, null, parentSuspense, vnode, true);
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$b991575ae291844b$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $b991575ae291844b$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $b991575ae291844b$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $b991575ae291844b$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $b991575ae291844b$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $b991575ae291844b$var$queuePostRenderEffect(()=>{
            vnodeHook && $b991575ae291844b$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $b991575ae291844b$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $b991575ae291844b$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $b991575ae291844b$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a } = instance;
        $b991575ae291844b$var$invalidateMount(m);
        $b991575ae291844b$var$invalidateMount(a);
        if (bum) (0, $iE8iy.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $b991575ae291844b$var$queuePostRenderEffect(um, parentSuspense);
        $b991575ae291844b$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $b991575ae291844b$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$b991575ae291844b$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $b991575ae291844b$var$flushPreFlushCbs();
            $b991575ae291844b$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $b991575ae291844b$var$createAppAPI(render, hydrate)
    };
}
function $b991575ae291844b$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $b991575ae291844b$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $b991575ae291844b$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $b991575ae291844b$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $iE8iy.isArray)(ch1) && (0, $iE8iy.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $b991575ae291844b$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $b991575ae291844b$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $b991575ae291844b$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $b991575ae291844b$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $b991575ae291844b$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $b991575ae291844b$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $b991575ae291844b$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
const $b991575ae291844b$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $b991575ae291844b$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $b991575ae291844b$export$a976684a0efeb93f($b991575ae291844b$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $b991575ae291844b$export$ede35fc0e5500309(effect, options) {
    return $b991575ae291844b$var$doWatch(effect, null, options);
}
function $b991575ae291844b$export$b7f27ea67102d543(effect, options) {
    return $b991575ae291844b$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $b991575ae291844b$export$2035654f31b0e555(effect, options) {
    return $b991575ae291844b$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $b991575ae291844b$export$3db5d71bdb2d5499(source, cb, options) {
    return $b991575ae291844b$var$doWatch(source, cb, options);
}
function $b991575ae291844b$var$doWatch(source, cb, options = (0, $iE8iy.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $iE8iy.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($b991575ae291844b$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $b991575ae291844b$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $iE8iy.NOOP);
            watchStopHandle.resume = (0, $iE8iy.NOOP);
            watchStopHandle.pause = (0, $iE8iy.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $b991575ae291844b$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$b991575ae291844b$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $b991575ae291844b$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $b991575ae291844b$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $eayOh.watch)(source, cb, baseWatchOptions);
    if ($b991575ae291844b$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $b991575ae291844b$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $iE8iy.isString)(source) ? source.includes(".") ? $b991575ae291844b$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $iE8iy.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $b991575ae291844b$var$setCurrentInstance(this);
    const res = $b991575ae291844b$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $b991575ae291844b$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $b991575ae291844b$export$fb78bd113157f1a1(props, name, options = (0, $iE8iy.EMPTY_OBJ)) {
    const i = $b991575ae291844b$export$f13e630aa3915748();
    const camelizedName = (0, $iE8iy.camelize)(name);
    const hyphenatedName = (0, $iE8iy.hyphenate)(name);
    const modifiers = $b991575ae291844b$var$getModelModifiers(props, camelizedName);
    const res = (0, $eayOh.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $iE8iy.EMPTY_OBJ);
        let prevEmittedValue;
        $b991575ae291844b$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $iE8iy.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $iE8iy.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $iE8iy.EMPTY_OBJ) && (0, $iE8iy.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $iE8iy.hasChanged)(value, emittedValue) && (0, $iE8iy.hasChanged)(value, prevSetValue) && !(0, $iE8iy.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $iE8iy.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $b991575ae291844b$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $iE8iy.camelize)(modelName)}Modifiers`] || props[`${(0, $iE8iy.hyphenate)(modelName)}Modifiers`];
};
function $b991575ae291844b$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $iE8iy.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $b991575ae291844b$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $iE8iy.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, $iE8iy.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $b991575ae291844b$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $iE8iy.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $iE8iy.toHandlerKey)((0, $iE8iy.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $iE8iy.toHandlerKey)((0, $iE8iy.hyphenate)(event))];
    if (handler) $b991575ae291844b$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $b991575ae291844b$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $b991575ae291844b$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $iE8iy.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $b991575ae291844b$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $iE8iy.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $iE8iy.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $iE8iy.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $iE8iy.extend)(normalized, raw);
    if ((0, $iE8iy.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $b991575ae291844b$var$isEmitListener(options, key) {
    if (!options || !(0, $iE8iy.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $iE8iy.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $iE8iy.hasOwn)(options, (0, $iE8iy.hyphenate)(key)) || (0, $iE8iy.hasOwn)(options, key);
}
let $b991575ae291844b$var$accessedAttrs = false;
function $b991575ae291844b$var$markAttrsAccessed() {
    $b991575ae291844b$var$accessedAttrs = true;
}
function $b991575ae291844b$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $b991575ae291844b$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $b991575ae291844b$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $b991575ae291844b$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $b991575ae291844b$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $b991575ae291844b$var$blockStack.length = 0;
        $b991575ae291844b$export$d3da1ecaf1206c58(err, instance, 1);
        result = $b991575ae291844b$export$bf5c4cf060303d58($b991575ae291844b$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $iE8iy.isModelListener))) fallthroughAttrs = $b991575ae291844b$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $b991575ae291844b$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $b991575ae291844b$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) $b991575ae291844b$export$7770a22486565649(root, vnode.transition);
    result = root;
    $b991575ae291844b$var$setCurrentRenderingInstance(prev);
    return result;
}
const $b991575ae291844b$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $b991575ae291844b$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $b991575ae291844b$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $b991575ae291844b$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($b991575ae291844b$export$3868d13f8734ae81(child)) {
            if (child.type !== $b991575ae291844b$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $b991575ae291844b$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $iE8iy.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $b991575ae291844b$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $iE8iy.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $b991575ae291844b$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $b991575ae291844b$export$4d299b491347818a;
};
function $b991575ae291844b$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $b991575ae291844b$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$b991575ae291844b$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $b991575ae291844b$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $b991575ae291844b$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$b991575ae291844b$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $b991575ae291844b$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $b991575ae291844b$var$isSuspense = (type)=>type.__isSuspense;
let $b991575ae291844b$var$suspenseId = 0;
const $b991575ae291844b$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $b991575ae291844b$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $b991575ae291844b$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $b991575ae291844b$var$hydrateSuspense,
    normalize: $b991575ae291844b$var$normalizeSuspenseChildren
};
const $b991575ae291844b$export$74bf444e3cd11ea5 = $b991575ae291844b$var$SuspenseImpl;
function $b991575ae291844b$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $iE8iy.isFunction)(eventListener)) eventListener();
}
function $b991575ae291844b$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $b991575ae291844b$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $b991575ae291844b$var$triggerEvent(vnode, "onPending");
        $b991575ae291844b$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $b991575ae291844b$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $b991575ae291844b$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($b991575ae291844b$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $b991575ae291844b$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $b991575ae291844b$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $b991575ae291844b$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $b991575ae291844b$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $b991575ae291844b$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $b991575ae291844b$var$setActiveBranch(suspense, newBranch);
    } else {
        $b991575ae291844b$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $b991575ae291844b$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $b991575ae291844b$var$hasWarned = false;
function $b991575ae291844b$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $b991575ae291844b$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $iE8iy.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $b991575ae291844b$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $b991575ae291844b$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) === container2) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $b991575ae291844b$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $b991575ae291844b$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $b991575ae291844b$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $b991575ae291844b$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $b991575ae291844b$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $b991575ae291844b$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $b991575ae291844b$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) remove(placeholder);
                $b991575ae291844b$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $b991575ae291844b$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $b991575ae291844b$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $b991575ae291844b$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $b991575ae291844b$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $b991575ae291844b$var$normalizeSuspenseSlot(children.fallback) : $b991575ae291844b$export$bf5c4cf060303d58($b991575ae291844b$export$4d299b491347818a);
}
function $b991575ae291844b$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $iE8iy.isFunction)(s)) {
        const trackBlock = $b991575ae291844b$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $b991575ae291844b$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $b991575ae291844b$var$currentBlock;
            $b991575ae291844b$var$closeBlock();
        }
    }
    if ((0, $iE8iy.isArray)(s)) {
        const singleChild = $b991575ae291844b$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $b991575ae291844b$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $b991575ae291844b$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $iE8iy.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $b991575ae291844b$export$59536a0199721cab(fn);
}
function $b991575ae291844b$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $b991575ae291844b$var$updateHOCHostEl(parentComponent, el);
    }
}
function $b991575ae291844b$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $b991575ae291844b$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $b991575ae291844b$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $b991575ae291844b$export$4d299b491347818a = Symbol.for("v-cmt");
const $b991575ae291844b$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $b991575ae291844b$var$blockStack = [];
let $b991575ae291844b$var$currentBlock = null;
function $b991575ae291844b$export$e7eaa45e502fe5cc(disableTracking = false) {
    $b991575ae291844b$var$blockStack.push($b991575ae291844b$var$currentBlock = disableTracking ? null : []);
}
function $b991575ae291844b$var$closeBlock() {
    $b991575ae291844b$var$blockStack.pop();
    $b991575ae291844b$var$currentBlock = $b991575ae291844b$var$blockStack[$b991575ae291844b$var$blockStack.length - 1] || null;
}
let $b991575ae291844b$var$isBlockTreeEnabled = 1;
function $b991575ae291844b$export$c20bee82f26f1e27(value, inVOnce = false) {
    $b991575ae291844b$var$isBlockTreeEnabled += value;
    if (value < 0 && $b991575ae291844b$var$currentBlock && inVOnce) $b991575ae291844b$var$currentBlock.hasOnce = true;
}
function $b991575ae291844b$var$setupBlock(vnode) {
    vnode.dynamicChildren = $b991575ae291844b$var$isBlockTreeEnabled > 0 ? $b991575ae291844b$var$currentBlock || (0, $iE8iy.EMPTY_ARR) : null;
    $b991575ae291844b$var$closeBlock();
    if ($b991575ae291844b$var$isBlockTreeEnabled > 0 && $b991575ae291844b$var$currentBlock) $b991575ae291844b$var$currentBlock.push(vnode);
    return vnode;
}
function $b991575ae291844b$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $b991575ae291844b$var$setupBlock($b991575ae291844b$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $b991575ae291844b$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $b991575ae291844b$var$setupBlock($b991575ae291844b$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $b991575ae291844b$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $b991575ae291844b$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $b991575ae291844b$var$vnodeArgsTransformer;
function $b991575ae291844b$export$83beccd3afeeb809(transformer) {
    $b991575ae291844b$var$vnodeArgsTransformer = transformer;
}
const $b991575ae291844b$var$createVNodeWithArgsTransform = (...args)=>{
    return $b991575ae291844b$var$_createVNode(...$b991575ae291844b$var$vnodeArgsTransformer ? $b991575ae291844b$var$vnodeArgsTransformer(args, $b991575ae291844b$var$currentRenderingInstance) : args);
};
const $b991575ae291844b$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $b991575ae291844b$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $iE8iy.isString)(ref) || (0, $eayOh.isRef)(ref) || (0, $iE8iy.isFunction)(ref) ? {
        i: $b991575ae291844b$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $b991575ae291844b$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $b991575ae291844b$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $b991575ae291844b$var$normalizeKey(props),
        ref: props && $b991575ae291844b$var$normalizeRef(props),
        scopeId: $b991575ae291844b$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $b991575ae291844b$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $b991575ae291844b$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $iE8iy.isString)(children) ? 8 : 16;
    if ($b991575ae291844b$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $b991575ae291844b$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $b991575ae291844b$var$currentBlock.push(vnode);
    return vnode;
}
const $b991575ae291844b$export$bf5c4cf060303d58 = $b991575ae291844b$var$_createVNode;
function $b991575ae291844b$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $b991575ae291844b$var$NULL_DYNAMIC_COMPONENT) type = $b991575ae291844b$export$4d299b491347818a;
    if ($b991575ae291844b$export$3868d13f8734ae81(type)) {
        const cloned = $b991575ae291844b$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $b991575ae291844b$var$normalizeChildren(cloned, children);
        if ($b991575ae291844b$var$isBlockTreeEnabled > 0 && !isBlockNode && $b991575ae291844b$var$currentBlock) {
            if (cloned.shapeFlag & 6) $b991575ae291844b$var$currentBlock[$b991575ae291844b$var$currentBlock.indexOf(type)] = cloned;
            else $b991575ae291844b$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($b991575ae291844b$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $b991575ae291844b$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $iE8iy.isString)(klass)) props.class = (0, $iE8iy.normalizeClass)(klass);
        if ((0, $iE8iy.isObject)(style)) {
            if ((0, $eayOh.isProxy)(style) && !(0, $iE8iy.isArray)(style)) style = (0, $iE8iy.extend)({}, style);
            props.style = (0, $iE8iy.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $iE8iy.isString)(type) ? 1 : $b991575ae291844b$var$isSuspense(type) ? 128 : $b991575ae291844b$var$isTeleport(type) ? 64 : (0, $iE8iy.isObject)(type) ? 4 : (0, $iE8iy.isFunction)(type) ? 2 : 0;
    return $b991575ae291844b$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $b991575ae291844b$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $eayOh.isProxy)(props) || $b991575ae291844b$var$isInternalObject(props) ? (0, $iE8iy.extend)({}, props) : props;
}
function $b991575ae291844b$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $b991575ae291844b$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $b991575ae291844b$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $iE8iy.isArray)(ref) ? ref.concat($b991575ae291844b$var$normalizeRef(extraProps)) : [
            ref,
            $b991575ae291844b$var$normalizeRef(extraProps)
        ] : $b991575ae291844b$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $b991575ae291844b$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $b991575ae291844b$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $b991575ae291844b$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $b991575ae291844b$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $b991575ae291844b$var$deepCloneVNode(vnode) {
    const cloned = $b991575ae291844b$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $iE8iy.isArray)(vnode.children)) cloned.children = vnode.children.map($b991575ae291844b$var$deepCloneVNode);
    return cloned;
}
function $b991575ae291844b$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $b991575ae291844b$export$bf5c4cf060303d58($b991575ae291844b$export$5f1af8db9871e1d6, null, text, flag);
}
function $b991575ae291844b$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $b991575ae291844b$export$bf5c4cf060303d58($b991575ae291844b$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $b991575ae291844b$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($b991575ae291844b$export$e7eaa45e502fe5cc(), $b991575ae291844b$export$9f2dfe8048dfb22b($b991575ae291844b$export$4d299b491347818a, null, text)) : $b991575ae291844b$export$bf5c4cf060303d58($b991575ae291844b$export$4d299b491347818a, null, text);
}
function $b991575ae291844b$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $b991575ae291844b$export$bf5c4cf060303d58($b991575ae291844b$export$4d299b491347818a);
    else if ((0, $iE8iy.isArray)(child)) return $b991575ae291844b$export$bf5c4cf060303d58($b991575ae291844b$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($b991575ae291844b$export$3868d13f8734ae81(child)) return $b991575ae291844b$var$cloneIfMounted(child);
    else return $b991575ae291844b$export$bf5c4cf060303d58($b991575ae291844b$export$5f1af8db9871e1d6, null, String(child));
}
function $b991575ae291844b$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $b991575ae291844b$export$ee4f9e12c0a92a1a(child);
}
function $b991575ae291844b$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $iE8iy.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $b991575ae291844b$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$b991575ae291844b$var$isInternalObject(children)) children._ctx = $b991575ae291844b$var$currentRenderingInstance;
            else if (slotFlag === 3 && $b991575ae291844b$var$currentRenderingInstance) {
                if ($b991575ae291844b$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $iE8iy.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $b991575ae291844b$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $b991575ae291844b$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $b991575ae291844b$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $iE8iy.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $iE8iy.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $iE8iy.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $iE8iy.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $b991575ae291844b$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $b991575ae291844b$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $b991575ae291844b$var$emptyAppContext = $b991575ae291844b$var$createAppContext();
let $b991575ae291844b$var$uid = 0;
function $b991575ae291844b$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $b991575ae291844b$var$emptyAppContext;
    const instance = {
        uid: $b991575ae291844b$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $eayOh.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $b991575ae291844b$var$normalizePropsOptions(type, appContext),
        emitsOptions: $b991575ae291844b$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $iE8iy.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $iE8iy.EMPTY_OBJ),
        data: (0, $iE8iy.EMPTY_OBJ),
        props: (0, $iE8iy.EMPTY_OBJ),
        attrs: (0, $iE8iy.EMPTY_OBJ),
        slots: (0, $iE8iy.EMPTY_OBJ),
        refs: (0, $iE8iy.EMPTY_OBJ),
        setupState: (0, $iE8iy.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $b991575ae291844b$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $b991575ae291844b$var$currentInstance = null;
const $b991575ae291844b$export$f13e630aa3915748 = ()=>$b991575ae291844b$var$currentInstance || $b991575ae291844b$var$currentRenderingInstance;
let $b991575ae291844b$var$internalSetCurrentInstance;
let $b991575ae291844b$var$setInSSRSetupState;
{
    const g = (0, $iE8iy.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $b991575ae291844b$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$b991575ae291844b$var$currentInstance = v1);
    $b991575ae291844b$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$b991575ae291844b$var$isInSSRComponentSetup = v1);
}const $b991575ae291844b$var$setCurrentInstance = (instance)=>{
    const prev = $b991575ae291844b$var$currentInstance;
    $b991575ae291844b$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $b991575ae291844b$var$internalSetCurrentInstance(prev);
    };
};
const $b991575ae291844b$var$unsetCurrentInstance = ()=>{
    $b991575ae291844b$var$currentInstance && $b991575ae291844b$var$currentInstance.scope.off();
    $b991575ae291844b$var$internalSetCurrentInstance(null);
};
const $b991575ae291844b$var$isBuiltInTag = /* @__PURE__ */ (0, $iE8iy.makeMap)("slot,component");
function $b991575ae291844b$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($b991575ae291844b$var$isBuiltInTag(name) || isNativeTag(name)) $b991575ae291844b$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $b991575ae291844b$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $b991575ae291844b$var$isInSSRComponentSetup = false;
function $b991575ae291844b$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $b991575ae291844b$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $b991575ae291844b$var$isStatefulComponent(instance);
    $b991575ae291844b$var$initProps(instance, props, isStateful, isSSR);
    $b991575ae291844b$var$initSlots(instance, children, optimized);
    const setupResult = isStateful ? $b991575ae291844b$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $b991575ae291844b$var$setInSSRSetupState(false);
    return setupResult;
}
function $b991575ae291844b$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $b991575ae291844b$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $eayOh.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $b991575ae291844b$var$createSetupContext(instance) : null;
        const reset = $b991575ae291844b$var$setCurrentInstance(instance);
        const setupResult = $b991575ae291844b$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $iE8iy.isPromise)(setupResult);
        (0, $eayOh.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$b991575ae291844b$var$isAsyncWrapper(instance)) $b991575ae291844b$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($b991575ae291844b$var$unsetCurrentInstance, $b991575ae291844b$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $b991575ae291844b$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $b991575ae291844b$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $b991575ae291844b$var$handleSetupResult(instance, setupResult, isSSR);
    } else $b991575ae291844b$var$finishComponentSetup(instance, isSSR);
}
function $b991575ae291844b$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $iE8iy.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $iE8iy.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $eayOh.proxyRefs)(setupResult);
    }
    $b991575ae291844b$var$finishComponentSetup(instance, isSSR);
}
let $b991575ae291844b$var$compile;
let $b991575ae291844b$var$installWithProxy;
function $b991575ae291844b$export$667bb5a67822b941(_compile) {
    $b991575ae291844b$var$compile = _compile;
    $b991575ae291844b$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $b991575ae291844b$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $b991575ae291844b$export$c93a9c496c5211fa = ()=>!$b991575ae291844b$var$compile;
function $b991575ae291844b$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $b991575ae291844b$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $b991575ae291844b$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $iE8iy.extend)((0, $iE8iy.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $b991575ae291844b$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $iE8iy.NOOP);
        if ($b991575ae291844b$var$installWithProxy) $b991575ae291844b$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $b991575ae291844b$var$setCurrentInstance(instance);
        (0, $eayOh.pauseTracking)();
        try {
            $b991575ae291844b$var$applyOptions(instance);
        } finally{
            (0, $eayOh.resetTracking)();
            reset();
        }
    }
}
const $b991575ae291844b$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $eayOh.track)(target, "get", "");
        return target[key];
    }
};
function $b991575ae291844b$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $eayOh.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $b991575ae291844b$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $b991575ae291844b$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $b991575ae291844b$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $eayOh.proxyRefs)((0, $eayOh.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $b991575ae291844b$var$publicPropertiesMap) return $b991575ae291844b$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $b991575ae291844b$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $b991575ae291844b$var$classifyRE = /(?:^|[-_])(\w)/g;
const $b991575ae291844b$var$classify = (str)=>str.replace($b991575ae291844b$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $b991575ae291844b$var$getComponentName(Component, includeInferred = true) {
    return (0, $iE8iy.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $b991575ae291844b$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $b991575ae291844b$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $b991575ae291844b$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $b991575ae291844b$var$isClassComponent(value) {
    return (0, $iE8iy.isFunction)(value) && "__vccOpts" in value;
}
const $b991575ae291844b$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $eayOh.computed)(getterOrOptions, debugOptions, $b991575ae291844b$var$isInSSRComponentSetup);
    return c;
};
function $b991575ae291844b$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $iE8iy.isObject)(propsOrChildren) && !(0, $iE8iy.isArray)(propsOrChildren)) {
            if ($b991575ae291844b$export$3868d13f8734ae81(propsOrChildren)) return $b991575ae291844b$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $b991575ae291844b$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $b991575ae291844b$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $b991575ae291844b$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $b991575ae291844b$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $b991575ae291844b$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $eayOh.toRaw)(instance.props)));
        if (instance.setupState !== (0, $iE8iy.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $iE8iy.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $eayOh.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $iE8iy.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $iE8iy.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $eayOh.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $iE8iy.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $iE8iy.isArray)(opts) && opts.includes(key) || (0, $iE8iy.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $eayOh.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $b991575ae291844b$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $b991575ae291844b$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $b991575ae291844b$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $iE8iy.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($b991575ae291844b$var$isBlockTreeEnabled > 0 && $b991575ae291844b$var$currentBlock) $b991575ae291844b$var$currentBlock.push(cached);
    return true;
}
const $b991575ae291844b$export$83d89fbfd8236492 = "3.5.13";
const $b991575ae291844b$export$c106dd0671a0fc2d = (0, $iE8iy.NOOP);
const $b991575ae291844b$export$795e0ad4a0e2ed30 = $b991575ae291844b$var$ErrorTypeStrings$1;
const $b991575ae291844b$export$6922d3b3a607469e = $b991575ae291844b$var$devtools$1;
const $b991575ae291844b$export$b0c258b32c26c785 = $b991575ae291844b$var$setDevtoolsHook$1;
const $b991575ae291844b$var$_ssrUtils = {
    createComponentInstance: $b991575ae291844b$var$createComponentInstance,
    setupComponent: $b991575ae291844b$var$setupComponent,
    renderComponentRoot: $b991575ae291844b$var$renderComponentRoot,
    setCurrentRenderingInstance: $b991575ae291844b$var$setCurrentRenderingInstance,
    isVNode: $b991575ae291844b$export$3868d13f8734ae81,
    normalizeVNode: $b991575ae291844b$var$normalizeVNode,
    getComponentPublicInstance: $b991575ae291844b$var$getComponentPublicInstance,
    ensureValidVNode: $b991575ae291844b$var$ensureValidVNode,
    pushWarningContext: $b991575ae291844b$var$pushWarningContext,
    popWarningContext: $b991575ae291844b$var$popWarningContext
};
const $b991575ae291844b$export$a9679033567b336d = $b991575ae291844b$var$_ssrUtils;
const $b991575ae291844b$export$83cf26e06ea620e1 = null;
const $b991575ae291844b$export$dc678eddf276286e = null;
const $b991575ae291844b$export$22072a82865312f6 = null;

});
parcelRegister("eayOh", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $a50d0068e8e25184$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "ReactiveEffect", () => $a50d0068e8e25184$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $a50d0068e8e25184$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $a50d0068e8e25184$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $a50d0068e8e25184$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $a50d0068e8e25184$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $a50d0068e8e25184$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $a50d0068e8e25184$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "toReactive", () => $a50d0068e8e25184$export$45c769cf449a508c);
$parcel$export(module.exports, "shallowReadArray", () => $a50d0068e8e25184$export$5eb48af14254449e);
$parcel$export(module.exports, "isProxy", () => $a50d0068e8e25184$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $a50d0068e8e25184$export$4f9f5282de18fc69);
$parcel$export(module.exports, "reactive", () => $a50d0068e8e25184$export$90a44edba14e47be);
$parcel$export(module.exports, "shallowReactive", () => $a50d0068e8e25184$export$8d81cefd22d22260);
$parcel$export(module.exports, "isReactive", () => $a50d0068e8e25184$export$352205f445242f02);
$parcel$export(module.exports, "markRaw", () => $a50d0068e8e25184$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $a50d0068e8e25184$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $a50d0068e8e25184$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $a50d0068e8e25184$export$a239a76781616204);
$parcel$export(module.exports, "proxyRefs", () => $a50d0068e8e25184$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $a50d0068e8e25184$export$a20c2dd6199824cb);
$parcel$export(module.exports, "computed", () => $a50d0068e8e25184$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "watch", () => $a50d0068e8e25184$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $a50d0068e8e25184$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $iE8iy = parcelRequire("iE8iy");
function $a50d0068e8e25184$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $a50d0068e8e25184$var$activeEffectScope;
class $a50d0068e8e25184$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this.parent = $a50d0068e8e25184$var$activeEffectScope;
        if (!detached && $a50d0068e8e25184$var$activeEffectScope) this.index = ($a50d0068e8e25184$var$activeEffectScope.scopes || ($a50d0068e8e25184$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $a50d0068e8e25184$var$activeEffectScope;
            try {
                $a50d0068e8e25184$var$activeEffectScope = this;
                return fn();
            } finally{
                $a50d0068e8e25184$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $a50d0068e8e25184$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $a50d0068e8e25184$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $a50d0068e8e25184$export$7056603ea81600be(detached) {
    return new $a50d0068e8e25184$export$1168ed9dbc71ddbd(detached);
}
function $a50d0068e8e25184$export$c7be4b0125a10cba() {
    return $a50d0068e8e25184$var$activeEffectScope;
}
function $a50d0068e8e25184$export$a780418acd4762da(fn, failSilently = false) {
    if ($a50d0068e8e25184$var$activeEffectScope) $a50d0068e8e25184$var$activeEffectScope.cleanups.push(fn);
}
let $a50d0068e8e25184$var$activeSub;
const $a50d0068e8e25184$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED"
};
const $a50d0068e8e25184$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $a50d0068e8e25184$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($a50d0068e8e25184$var$activeEffectScope && $a50d0068e8e25184$var$activeEffectScope.active) $a50d0068e8e25184$var$activeEffectScope.effects.push(this);
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($a50d0068e8e25184$var$pausedQueueEffects.has(this)) {
                $a50d0068e8e25184$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $a50d0068e8e25184$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $a50d0068e8e25184$var$cleanupEffect(this);
        $a50d0068e8e25184$var$prepareDeps(this);
        const prevEffect = $a50d0068e8e25184$var$activeSub;
        const prevShouldTrack = $a50d0068e8e25184$var$shouldTrack;
        $a50d0068e8e25184$var$activeSub = this;
        $a50d0068e8e25184$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $a50d0068e8e25184$var$cleanupDeps(this);
            $a50d0068e8e25184$var$activeSub = prevEffect;
            $a50d0068e8e25184$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$a50d0068e8e25184$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $a50d0068e8e25184$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $a50d0068e8e25184$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($a50d0068e8e25184$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $a50d0068e8e25184$var$isDirty(this);
    }
}
let $a50d0068e8e25184$var$batchDepth = 0;
let $a50d0068e8e25184$var$batchedSub;
let $a50d0068e8e25184$var$batchedComputed;
function $a50d0068e8e25184$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $a50d0068e8e25184$var$batchedComputed;
        $a50d0068e8e25184$var$batchedComputed = sub;
        return;
    }
    sub.next = $a50d0068e8e25184$var$batchedSub;
    $a50d0068e8e25184$var$batchedSub = sub;
}
function $a50d0068e8e25184$var$startBatch() {
    $a50d0068e8e25184$var$batchDepth++;
}
function $a50d0068e8e25184$var$endBatch() {
    if (--$a50d0068e8e25184$var$batchDepth > 0) return;
    if ($a50d0068e8e25184$var$batchedComputed) {
        let e = $a50d0068e8e25184$var$batchedComputed;
        $a50d0068e8e25184$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($a50d0068e8e25184$var$batchedSub){
        let e = $a50d0068e8e25184$var$batchedSub;
        $a50d0068e8e25184$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $a50d0068e8e25184$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $a50d0068e8e25184$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $a50d0068e8e25184$var$removeSub(link);
            $a50d0068e8e25184$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $a50d0068e8e25184$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($a50d0068e8e25184$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $a50d0068e8e25184$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $a50d0068e8e25184$var$globalVersion) return;
    computed.globalVersion = $a50d0068e8e25184$var$globalVersion;
    const dep = computed.dep;
    computed.flags |= 2;
    if (dep.version > 0 && !computed.isSSR && computed.deps && !$a50d0068e8e25184$var$isDirty(computed)) {
        computed.flags &= -3;
        return;
    }
    const prevSub = $a50d0068e8e25184$var$activeSub;
    const prevShouldTrack = $a50d0068e8e25184$var$shouldTrack;
    $a50d0068e8e25184$var$activeSub = computed;
    $a50d0068e8e25184$var$shouldTrack = true;
    try {
        $a50d0068e8e25184$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $iE8iy.hasChanged)(value, computed._value)) {
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $a50d0068e8e25184$var$activeSub = prevSub;
        $a50d0068e8e25184$var$shouldTrack = prevShouldTrack;
        $a50d0068e8e25184$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $a50d0068e8e25184$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$a50d0068e8e25184$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $a50d0068e8e25184$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $a50d0068e8e25184$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $a50d0068e8e25184$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $a50d0068e8e25184$export$28352bb4dd362521(fn);
    if (options) (0, $iE8iy.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $a50d0068e8e25184$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $a50d0068e8e25184$var$shouldTrack = true;
const $a50d0068e8e25184$var$trackStack = [];
function $a50d0068e8e25184$export$938a971395fef855() {
    $a50d0068e8e25184$var$trackStack.push($a50d0068e8e25184$var$shouldTrack);
    $a50d0068e8e25184$var$shouldTrack = false;
}
function $a50d0068e8e25184$export$1f8ffc6fd33b1d16() {
    $a50d0068e8e25184$var$trackStack.push($a50d0068e8e25184$var$shouldTrack);
    $a50d0068e8e25184$var$shouldTrack = true;
}
function $a50d0068e8e25184$export$c39176b1babaa8b8() {
    const last = $a50d0068e8e25184$var$trackStack.pop();
    $a50d0068e8e25184$var$shouldTrack = last === void 0 ? true : last;
}
function $a50d0068e8e25184$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($a50d0068e8e25184$var$activeSub instanceof $a50d0068e8e25184$export$28352bb4dd362521) $a50d0068e8e25184$var$activeSub.cleanup = fn;
}
function $a50d0068e8e25184$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $a50d0068e8e25184$var$activeSub;
        $a50d0068e8e25184$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $a50d0068e8e25184$var$activeSub = prevSub;
        }
    }
}
let $a50d0068e8e25184$var$globalVersion = 0;
class $a50d0068e8e25184$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $a50d0068e8e25184$var$Dep {
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
    }
    track(debugInfo) {
        if (!$a50d0068e8e25184$var$activeSub || !$a50d0068e8e25184$var$shouldTrack || $a50d0068e8e25184$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $a50d0068e8e25184$var$activeSub) {
            link = this.activeLink = new $a50d0068e8e25184$var$Link($a50d0068e8e25184$var$activeSub, this);
            if (!$a50d0068e8e25184$var$activeSub.deps) $a50d0068e8e25184$var$activeSub.deps = $a50d0068e8e25184$var$activeSub.depsTail = link;
            else {
                link.prevDep = $a50d0068e8e25184$var$activeSub.depsTail;
                $a50d0068e8e25184$var$activeSub.depsTail.nextDep = link;
                $a50d0068e8e25184$var$activeSub.depsTail = link;
            }
            $a50d0068e8e25184$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $a50d0068e8e25184$var$activeSub.depsTail;
                link.nextDep = void 0;
                $a50d0068e8e25184$var$activeSub.depsTail.nextDep = link;
                $a50d0068e8e25184$var$activeSub.depsTail = link;
                if ($a50d0068e8e25184$var$activeSub.deps === link) $a50d0068e8e25184$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $a50d0068e8e25184$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $a50d0068e8e25184$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $a50d0068e8e25184$var$endBatch();
        }
    }
}
function $a50d0068e8e25184$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$a50d0068e8e25184$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $a50d0068e8e25184$var$targetMap = /* @__PURE__ */ new WeakMap();
const $a50d0068e8e25184$export$3c41b1a4e06acc14 = Symbol("");
const $a50d0068e8e25184$export$49093fa1cddcb78d = Symbol("");
const $a50d0068e8e25184$export$4f926f0baab682cd = Symbol("");
function $a50d0068e8e25184$export$6b2a7d5132615086(target, type, key) {
    if ($a50d0068e8e25184$var$shouldTrack && $a50d0068e8e25184$var$activeSub) {
        let depsMap = $a50d0068e8e25184$var$targetMap.get(target);
        if (!depsMap) $a50d0068e8e25184$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $a50d0068e8e25184$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $a50d0068e8e25184$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $a50d0068e8e25184$var$targetMap.get(target);
    if (!depsMap) {
        $a50d0068e8e25184$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $a50d0068e8e25184$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $iE8iy.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $iE8iy.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $a50d0068e8e25184$export$4f926f0baab682cd || !(0, $iE8iy.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($a50d0068e8e25184$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($a50d0068e8e25184$export$3c41b1a4e06acc14));
                        if ((0, $iE8iy.isMap)(target)) run(depsMap.get($a50d0068e8e25184$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($a50d0068e8e25184$export$3c41b1a4e06acc14));
                        if ((0, $iE8iy.isMap)(target)) run(depsMap.get($a50d0068e8e25184$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $iE8iy.isMap)(target)) run(depsMap.get($a50d0068e8e25184$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $a50d0068e8e25184$var$endBatch();
}
function $a50d0068e8e25184$var$getDepFromReactive(object, key) {
    const depMap = $a50d0068e8e25184$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $a50d0068e8e25184$export$1544eab4943788e4(array) {
    const raw = $a50d0068e8e25184$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $a50d0068e8e25184$export$6b2a7d5132615086(raw, "iterate", $a50d0068e8e25184$export$4f926f0baab682cd);
    return $a50d0068e8e25184$export$7f3fe6025abfa26e(array) ? raw : raw.map($a50d0068e8e25184$export$45c769cf449a508c);
}
function $a50d0068e8e25184$export$5eb48af14254449e(arr) {
    $a50d0068e8e25184$export$6b2a7d5132615086(arr = $a50d0068e8e25184$export$ab18938b9fc5f28e(arr), "iterate", $a50d0068e8e25184$export$4f926f0baab682cd);
    return arr;
}
const $a50d0068e8e25184$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $a50d0068e8e25184$var$iterator(this, Symbol.iterator, $a50d0068e8e25184$export$45c769cf449a508c);
    },
    concat (...args) {
        return $a50d0068e8e25184$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $iE8iy.isArray)(x) ? $a50d0068e8e25184$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $a50d0068e8e25184$var$iterator(this, "entries", (value)=>{
            value[1] = $a50d0068e8e25184$export$45c769cf449a508c(value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $a50d0068e8e25184$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $a50d0068e8e25184$var$apply(this, "filter", fn, thisArg, (v)=>v.map($a50d0068e8e25184$export$45c769cf449a508c), arguments);
    },
    find (fn, thisArg) {
        return $a50d0068e8e25184$var$apply(this, "find", fn, thisArg, $a50d0068e8e25184$export$45c769cf449a508c, arguments);
    },
    findIndex (fn, thisArg) {
        return $a50d0068e8e25184$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $a50d0068e8e25184$var$apply(this, "findLast", fn, thisArg, $a50d0068e8e25184$export$45c769cf449a508c, arguments);
    },
    findLastIndex (fn, thisArg) {
        return $a50d0068e8e25184$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $a50d0068e8e25184$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $a50d0068e8e25184$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $a50d0068e8e25184$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $a50d0068e8e25184$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimisation required
    lastIndexOf (...args) {
        return $a50d0068e8e25184$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $a50d0068e8e25184$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $a50d0068e8e25184$var$noTracking(this, "pop");
    },
    push (...args) {
        return $a50d0068e8e25184$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $a50d0068e8e25184$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $a50d0068e8e25184$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $a50d0068e8e25184$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $a50d0068e8e25184$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $a50d0068e8e25184$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $a50d0068e8e25184$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $a50d0068e8e25184$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $a50d0068e8e25184$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $a50d0068e8e25184$var$noTracking(this, "unshift", args);
    },
    values () {
        return $a50d0068e8e25184$var$iterator(this, "values", $a50d0068e8e25184$export$45c769cf449a508c);
    }
};
function $a50d0068e8e25184$var$iterator(self, method, wrapValue) {
    const arr = $a50d0068e8e25184$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$a50d0068e8e25184$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (result.value) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $a50d0068e8e25184$var$arrayProto = Array.prototype;
function $a50d0068e8e25184$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $a50d0068e8e25184$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$a50d0068e8e25184$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $a50d0068e8e25184$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $a50d0068e8e25184$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $a50d0068e8e25184$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $a50d0068e8e25184$var$reduce(self, method, fn, args) {
    const arr = $a50d0068e8e25184$export$5eb48af14254449e(self);
    let wrappedFn = fn;
    if (arr !== self) {
        if (!$a50d0068e8e25184$export$7f3fe6025abfa26e(self)) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, $a50d0068e8e25184$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    return arr[method](wrappedFn, ...args);
}
function $a50d0068e8e25184$var$searchProxy(self, method, args) {
    const arr = $a50d0068e8e25184$export$ab18938b9fc5f28e(self);
    $a50d0068e8e25184$export$6b2a7d5132615086(arr, "iterate", $a50d0068e8e25184$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $a50d0068e8e25184$export$5f3ca29d057519b3(args[0])) {
        args[0] = $a50d0068e8e25184$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $a50d0068e8e25184$var$noTracking(self, method, args = []) {
    $a50d0068e8e25184$export$938a971395fef855();
    $a50d0068e8e25184$var$startBatch();
    const res = $a50d0068e8e25184$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $a50d0068e8e25184$var$endBatch();
    $a50d0068e8e25184$export$c39176b1babaa8b8();
    return res;
}
const $a50d0068e8e25184$var$isNonTrackableKeys = /* @__PURE__ */ (0, $iE8iy.makeMap)(`__proto__,__v_isRef,__isVue`);
const $a50d0068e8e25184$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $iE8iy.isSymbol)));
function $a50d0068e8e25184$var$hasOwnProperty(key) {
    if (!(0, $iE8iy.isSymbol)(key)) key = String(key);
    const obj = $a50d0068e8e25184$export$ab18938b9fc5f28e(this);
    $a50d0068e8e25184$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $a50d0068e8e25184$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $a50d0068e8e25184$var$shallowReadonlyMap : $a50d0068e8e25184$var$readonlyMap : isShallow2 ? $a50d0068e8e25184$var$shallowReactiveMap : $a50d0068e8e25184$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $iE8iy.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $a50d0068e8e25184$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $a50d0068e8e25184$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $a50d0068e8e25184$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $iE8iy.isSymbol)(key) ? $a50d0068e8e25184$var$builtInSymbols.has(key) : $a50d0068e8e25184$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $a50d0068e8e25184$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($a50d0068e8e25184$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $iE8iy.isIntegerKey)(key) ? res : res.value;
        if ((0, $iE8iy.isObject)(res)) return isReadonly2 ? $a50d0068e8e25184$export$6ec456bd5b7b3c51(res) : $a50d0068e8e25184$export$90a44edba14e47be(res);
        return res;
    }
}
class $a50d0068e8e25184$var$MutableReactiveHandler extends $a50d0068e8e25184$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $a50d0068e8e25184$export$92d09b48637741e7(oldValue);
            if (!$a50d0068e8e25184$export$7f3fe6025abfa26e(value) && !$a50d0068e8e25184$export$92d09b48637741e7(value)) {
                oldValue = $a50d0068e8e25184$export$ab18938b9fc5f28e(oldValue);
                value = $a50d0068e8e25184$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $iE8iy.isArray)(target) && $a50d0068e8e25184$export$4f9f5282de18fc69(oldValue) && !$a50d0068e8e25184$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $iE8iy.isArray)(target) && (0, $iE8iy.isIntegerKey)(key) ? Number(key) < target.length : (0, $iE8iy.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $a50d0068e8e25184$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $a50d0068e8e25184$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $a50d0068e8e25184$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $iE8iy.hasChanged)(value, oldValue)) $a50d0068e8e25184$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $iE8iy.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $a50d0068e8e25184$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $iE8iy.isSymbol)(key) || !$a50d0068e8e25184$var$builtInSymbols.has(key)) $a50d0068e8e25184$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $a50d0068e8e25184$export$6b2a7d5132615086(target, "iterate", (0, $iE8iy.isArray)(target) ? "length" : $a50d0068e8e25184$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $a50d0068e8e25184$var$ReadonlyReactiveHandler extends $a50d0068e8e25184$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $a50d0068e8e25184$var$mutableHandlers = /* @__PURE__ */ new $a50d0068e8e25184$var$MutableReactiveHandler();
const $a50d0068e8e25184$var$readonlyHandlers = /* @__PURE__ */ new $a50d0068e8e25184$var$ReadonlyReactiveHandler();
const $a50d0068e8e25184$var$shallowReactiveHandlers = /* @__PURE__ */ new $a50d0068e8e25184$var$MutableReactiveHandler(true);
const $a50d0068e8e25184$var$shallowReadonlyHandlers = /* @__PURE__ */ new $a50d0068e8e25184$var$ReadonlyReactiveHandler(true);
const $a50d0068e8e25184$var$toShallow = (value)=>value;
const $a50d0068e8e25184$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $a50d0068e8e25184$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $a50d0068e8e25184$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $iE8iy.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $a50d0068e8e25184$var$toShallow : isReadonly2 ? $a50d0068e8e25184$export$4a78e7a2a4fb689f : $a50d0068e8e25184$export$45c769cf449a508c;
        !isReadonly2 && $a50d0068e8e25184$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $a50d0068e8e25184$export$49093fa1cddcb78d : $a50d0068e8e25184$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $a50d0068e8e25184$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $a50d0068e8e25184$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $a50d0068e8e25184$export$ab18938b9fc5f28e(target);
            const rawKey = $a50d0068e8e25184$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $iE8iy.hasChanged)(key, rawKey)) $a50d0068e8e25184$export$6b2a7d5132615086(rawTarget, "get", key);
                $a50d0068e8e25184$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $a50d0068e8e25184$var$getProto(rawTarget);
            const wrap = shallow ? $a50d0068e8e25184$var$toShallow : readonly ? $a50d0068e8e25184$export$4a78e7a2a4fb689f : $a50d0068e8e25184$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $a50d0068e8e25184$export$6b2a7d5132615086($a50d0068e8e25184$export$ab18938b9fc5f28e(target), "iterate", $a50d0068e8e25184$export$3c41b1a4e06acc14);
            return Reflect.get(target, "size", target);
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $a50d0068e8e25184$export$ab18938b9fc5f28e(target);
            const rawKey = $a50d0068e8e25184$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $iE8iy.hasChanged)(key, rawKey)) $a50d0068e8e25184$export$6b2a7d5132615086(rawTarget, "has", key);
                $a50d0068e8e25184$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $a50d0068e8e25184$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $a50d0068e8e25184$var$toShallow : readonly ? $a50d0068e8e25184$export$4a78e7a2a4fb689f : $a50d0068e8e25184$export$45c769cf449a508c;
            !readonly && $a50d0068e8e25184$export$6b2a7d5132615086(rawTarget, "iterate", $a50d0068e8e25184$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $iE8iy.extend)(instrumentations, readonly ? {
        add: $a50d0068e8e25184$var$createReadonlyMethod("add"),
        set: $a50d0068e8e25184$var$createReadonlyMethod("set"),
        delete: $a50d0068e8e25184$var$createReadonlyMethod("delete"),
        clear: $a50d0068e8e25184$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            if (!shallow && !$a50d0068e8e25184$export$7f3fe6025abfa26e(value) && !$a50d0068e8e25184$export$92d09b48637741e7(value)) value = $a50d0068e8e25184$export$ab18938b9fc5f28e(value);
            const target = $a50d0068e8e25184$export$ab18938b9fc5f28e(this);
            const proto = $a50d0068e8e25184$var$getProto(target);
            const hadKey = proto.has.call(target, value);
            if (!hadKey) {
                target.add(value);
                $a50d0068e8e25184$export$e614dc9140f7ae71(target, "add", value, value);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$a50d0068e8e25184$export$7f3fe6025abfa26e(value) && !$a50d0068e8e25184$export$92d09b48637741e7(value)) value = $a50d0068e8e25184$export$ab18938b9fc5f28e(value);
            const target = $a50d0068e8e25184$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $a50d0068e8e25184$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $a50d0068e8e25184$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $a50d0068e8e25184$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $iE8iy.hasChanged)(value, oldValue)) $a50d0068e8e25184$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $a50d0068e8e25184$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $a50d0068e8e25184$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $a50d0068e8e25184$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $a50d0068e8e25184$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $a50d0068e8e25184$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $a50d0068e8e25184$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $a50d0068e8e25184$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $a50d0068e8e25184$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $a50d0068e8e25184$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $iE8iy.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $a50d0068e8e25184$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $a50d0068e8e25184$var$createInstrumentationGetter(false, false)
};
const $a50d0068e8e25184$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $a50d0068e8e25184$var$createInstrumentationGetter(false, true)
};
const $a50d0068e8e25184$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $a50d0068e8e25184$var$createInstrumentationGetter(true, false)
};
const $a50d0068e8e25184$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $a50d0068e8e25184$var$createInstrumentationGetter(true, true)
};
function $a50d0068e8e25184$var$checkIdentityKeys(target, has, key) {
    const rawKey = $a50d0068e8e25184$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $iE8iy.toRawType)(target);
        $a50d0068e8e25184$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $a50d0068e8e25184$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $a50d0068e8e25184$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $a50d0068e8e25184$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $a50d0068e8e25184$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $a50d0068e8e25184$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $a50d0068e8e25184$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $a50d0068e8e25184$var$targetTypeMap((0, $iE8iy.toRawType)(value));
}
function $a50d0068e8e25184$export$90a44edba14e47be(target) {
    if ($a50d0068e8e25184$export$92d09b48637741e7(target)) return target;
    return $a50d0068e8e25184$var$createReactiveObject(target, false, $a50d0068e8e25184$var$mutableHandlers, $a50d0068e8e25184$var$mutableCollectionHandlers, $a50d0068e8e25184$var$reactiveMap);
}
function $a50d0068e8e25184$export$8d81cefd22d22260(target) {
    return $a50d0068e8e25184$var$createReactiveObject(target, false, $a50d0068e8e25184$var$shallowReactiveHandlers, $a50d0068e8e25184$var$shallowCollectionHandlers, $a50d0068e8e25184$var$shallowReactiveMap);
}
function $a50d0068e8e25184$export$6ec456bd5b7b3c51(target) {
    return $a50d0068e8e25184$var$createReactiveObject(target, true, $a50d0068e8e25184$var$readonlyHandlers, $a50d0068e8e25184$var$readonlyCollectionHandlers, $a50d0068e8e25184$var$readonlyMap);
}
function $a50d0068e8e25184$export$7c4b5f2b50f09f6b(target) {
    return $a50d0068e8e25184$var$createReactiveObject(target, true, $a50d0068e8e25184$var$shallowReadonlyHandlers, $a50d0068e8e25184$var$shallowReadonlyCollectionHandlers, $a50d0068e8e25184$var$shallowReadonlyMap);
}
function $a50d0068e8e25184$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $iE8iy.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $a50d0068e8e25184$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $a50d0068e8e25184$export$352205f445242f02(value) {
    if ($a50d0068e8e25184$export$92d09b48637741e7(value)) return $a50d0068e8e25184$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $a50d0068e8e25184$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $a50d0068e8e25184$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $a50d0068e8e25184$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $a50d0068e8e25184$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $a50d0068e8e25184$export$ab18938b9fc5f28e(raw) : observed;
}
function $a50d0068e8e25184$export$995ab8b13ad7a9d0(value) {
    if (!(0, $iE8iy.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $iE8iy.def)(value, "__v_skip", true);
    return value;
}
const $a50d0068e8e25184$export$45c769cf449a508c = (value)=>(0, $iE8iy.isObject)(value) ? $a50d0068e8e25184$export$90a44edba14e47be(value) : value;
const $a50d0068e8e25184$export$4a78e7a2a4fb689f = (value)=>(0, $iE8iy.isObject)(value) ? $a50d0068e8e25184$export$6ec456bd5b7b3c51(value) : value;
function $a50d0068e8e25184$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
function $a50d0068e8e25184$export$eff4d24c3ff7876e(value) {
    return $a50d0068e8e25184$var$createRef(value, false);
}
function $a50d0068e8e25184$export$9b7bc5fe3b17c8b3(value) {
    return $a50d0068e8e25184$var$createRef(value, true);
}
function $a50d0068e8e25184$var$createRef(rawValue, shallow) {
    if ($a50d0068e8e25184$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $a50d0068e8e25184$var$RefImpl(rawValue, shallow);
}
class $a50d0068e8e25184$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $a50d0068e8e25184$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $a50d0068e8e25184$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $a50d0068e8e25184$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $a50d0068e8e25184$export$7f3fe6025abfa26e(newValue) || $a50d0068e8e25184$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $a50d0068e8e25184$export$ab18938b9fc5f28e(newValue);
        if ((0, $iE8iy.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $a50d0068e8e25184$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $a50d0068e8e25184$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $a50d0068e8e25184$export$a239a76781616204(ref2) {
    return $a50d0068e8e25184$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $a50d0068e8e25184$export$30bdcc2218aa9458(source) {
    return (0, $iE8iy.isFunction)(source) ? source() : $a50d0068e8e25184$export$a239a76781616204(source);
}
const $a50d0068e8e25184$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $a50d0068e8e25184$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($a50d0068e8e25184$export$4f9f5282de18fc69(oldValue) && !$a50d0068e8e25184$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $a50d0068e8e25184$export$f353fd1b97db3fa0(objectWithRefs) {
    return $a50d0068e8e25184$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $a50d0068e8e25184$var$shallowUnwrapHandlers);
}
class $a50d0068e8e25184$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $a50d0068e8e25184$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $a50d0068e8e25184$export$a20c2dd6199824cb(factory) {
    return new $a50d0068e8e25184$var$CustomRefImpl(factory);
}
function $a50d0068e8e25184$export$2e9533675e5e70e0(object) {
    const ret = (0, $iE8iy.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $a50d0068e8e25184$var$propertyToRef(object, key);
    return ret;
}
class $a50d0068e8e25184$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
    }
    get value() {
        const val = this._object[this._key];
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $a50d0068e8e25184$var$getDepFromReactive($a50d0068e8e25184$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $a50d0068e8e25184$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
function $a50d0068e8e25184$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($a50d0068e8e25184$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $iE8iy.isFunction)(source)) return new $a50d0068e8e25184$var$GetterRefImpl(source);
    else if ((0, $iE8iy.isObject)(source) && arguments.length > 1) return $a50d0068e8e25184$var$propertyToRef(source, key, defaultValue);
    else return $a50d0068e8e25184$export$eff4d24c3ff7876e(source);
}
function $a50d0068e8e25184$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $a50d0068e8e25184$export$4f9f5282de18fc69(val) ? val : new $a50d0068e8e25184$var$ObjectRefImpl(source, key, defaultValue);
}
class $a50d0068e8e25184$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $a50d0068e8e25184$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $a50d0068e8e25184$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $a50d0068e8e25184$var$activeSub !== this) {
            $a50d0068e8e25184$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $a50d0068e8e25184$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
function $a50d0068e8e25184$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $iE8iy.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $a50d0068e8e25184$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $a50d0068e8e25184$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $a50d0068e8e25184$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $a50d0068e8e25184$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $a50d0068e8e25184$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $a50d0068e8e25184$var$INITIAL_WATCHER_VALUE = {};
const $a50d0068e8e25184$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $a50d0068e8e25184$var$activeWatcher = void 0;
function $a50d0068e8e25184$export$2532f7acfca7c82d() {
    return $a50d0068e8e25184$var$activeWatcher;
}
function $a50d0068e8e25184$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $a50d0068e8e25184$var$activeWatcher) {
    if (owner) {
        let cleanups = $a50d0068e8e25184$var$cleanupMap.get(owner);
        if (!cleanups) $a50d0068e8e25184$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $a50d0068e8e25184$export$3db5d71bdb2d5499(source, cb, options = (0, $iE8iy.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $a50d0068e8e25184$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($a50d0068e8e25184$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $a50d0068e8e25184$export$df3f009e3d155b20(source2, 1);
        return $a50d0068e8e25184$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($a50d0068e8e25184$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $a50d0068e8e25184$export$7f3fe6025abfa26e(source);
    } else if ($a50d0068e8e25184$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $iE8iy.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$a50d0068e8e25184$export$352205f445242f02(s) || $a50d0068e8e25184$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($a50d0068e8e25184$export$4f9f5282de18fc69(s)) return s.value;
                else if ($a50d0068e8e25184$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $iE8iy.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $iE8iy.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $a50d0068e8e25184$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $a50d0068e8e25184$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $a50d0068e8e25184$var$activeWatcher;
            $a50d0068e8e25184$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $a50d0068e8e25184$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $iE8iy.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$a50d0068e8e25184$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $a50d0068e8e25184$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $iE8iy.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            watchHandle();
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($a50d0068e8e25184$var$INITIAL_WATCHER_VALUE) : $a50d0068e8e25184$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $iE8iy.hasChanged)(v, oldValue[i])) : (0, $iE8iy.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $a50d0068e8e25184$var$activeWatcher;
                $a50d0068e8e25184$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $a50d0068e8e25184$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $a50d0068e8e25184$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                    oldValue = newValue;
                } finally{
                    $a50d0068e8e25184$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $a50d0068e8e25184$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$a50d0068e8e25184$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $a50d0068e8e25184$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $a50d0068e8e25184$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $a50d0068e8e25184$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $iE8iy.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if ($a50d0068e8e25184$export$4f9f5282de18fc69(value)) $a50d0068e8e25184$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $iE8iy.isArray)(value)) for(let i = 0; i < value.length; i++)$a50d0068e8e25184$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $iE8iy.isSet)(value) || (0, $iE8iy.isMap)(value)) value.forEach((v)=>{
        $a50d0068e8e25184$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $iE8iy.isPlainObject)(value)) {
        for(const key in value)$a50d0068e8e25184$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $a50d0068e8e25184$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("iE8iy", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $d932664a5029f787$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $d932664a5029f787$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $d932664a5029f787$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $d932664a5029f787$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $d932664a5029f787$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $d932664a5029f787$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $d932664a5029f787$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $d932664a5029f787$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $d932664a5029f787$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $d932664a5029f787$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $d932664a5029f787$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $d932664a5029f787$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $d932664a5029f787$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $d932664a5029f787$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $d932664a5029f787$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $d932664a5029f787$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $d932664a5029f787$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $d932664a5029f787$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $d932664a5029f787$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $d932664a5029f787$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $d932664a5029f787$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $d932664a5029f787$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $d932664a5029f787$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $d932664a5029f787$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $d932664a5029f787$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $d932664a5029f787$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $d932664a5029f787$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $d932664a5029f787$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $d932664a5029f787$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $d932664a5029f787$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $d932664a5029f787$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $d932664a5029f787$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $d932664a5029f787$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $d932664a5029f787$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $d932664a5029f787$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $d932664a5029f787$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $d932664a5029f787$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $d932664a5029f787$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "isHTMLTag", () => $d932664a5029f787$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $d932664a5029f787$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $d932664a5029f787$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $d932664a5029f787$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $d932664a5029f787$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $d932664a5029f787$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $d932664a5029f787$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $d932664a5029f787$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $d932664a5029f787$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $d932664a5029f787$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "looseEqual", () => $d932664a5029f787$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $d932664a5029f787$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $d932664a5029f787$export$b5b1545233b45293);
/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $d932664a5029f787$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $d932664a5029f787$export$cf583d23ab39677c = {};
const $d932664a5029f787$export$6bd8558f433f1cc1 = [];
const $d932664a5029f787$export$5702a91a6f42969f = ()=>{};
const $d932664a5029f787$export$c01351c0af048e39 = ()=>false;
const $d932664a5029f787$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $d932664a5029f787$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $d932664a5029f787$export$8b58be045bf06082 = Object.assign;
const $d932664a5029f787$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $d932664a5029f787$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $d932664a5029f787$export$b5a638e9b3fff9f3 = (val, key)=>$d932664a5029f787$var$hasOwnProperty.call(val, key);
const $d932664a5029f787$export$43bee75e5e14138e = Array.isArray;
const $d932664a5029f787$export$5c90113a285f2241 = (val)=>$d932664a5029f787$export$1dccc787cc36538b(val) === "[object Map]";
const $d932664a5029f787$export$6750766a7c7ec627 = (val)=>$d932664a5029f787$export$1dccc787cc36538b(val) === "[object Set]";
const $d932664a5029f787$export$871608497c498473 = (val)=>$d932664a5029f787$export$1dccc787cc36538b(val) === "[object Date]";
const $d932664a5029f787$export$49841c62b9eff15 = (val)=>$d932664a5029f787$export$1dccc787cc36538b(val) === "[object RegExp]";
const $d932664a5029f787$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $d932664a5029f787$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $d932664a5029f787$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $d932664a5029f787$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $d932664a5029f787$export$4369c812aac99591 = (val)=>{
    return ($d932664a5029f787$export$a6cdc56e425d0d0a(val) || $d932664a5029f787$export$f6e2535fb5126e54(val)) && $d932664a5029f787$export$f6e2535fb5126e54(val.then) && $d932664a5029f787$export$f6e2535fb5126e54(val.catch);
};
const $d932664a5029f787$export$830c053460e5ddf6 = Object.prototype.toString;
const $d932664a5029f787$export$1dccc787cc36538b = (value)=>$d932664a5029f787$export$830c053460e5ddf6.call(value);
const $d932664a5029f787$export$5ad0a3c360b8fbb5 = (value)=>{
    return $d932664a5029f787$export$1dccc787cc36538b(value).slice(8, -1);
};
const $d932664a5029f787$export$53b83ca8eaab0383 = (val)=>$d932664a5029f787$export$1dccc787cc36538b(val) === "[object Object]";
const $d932664a5029f787$export$e2a2b93446ec9fe = (key)=>$d932664a5029f787$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $d932664a5029f787$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $d932664a5029f787$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $d932664a5029f787$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $d932664a5029f787$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $d932664a5029f787$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $d932664a5029f787$var$camelizeRE = /-(\w)/g;
const $d932664a5029f787$export$161d051f5dd25de7 = $d932664a5029f787$var$cacheStringFunction((str)=>{
    return str.replace($d932664a5029f787$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $d932664a5029f787$var$hyphenateRE = /\B([A-Z])/g;
const $d932664a5029f787$export$6e6a0a3676c4b8bb = $d932664a5029f787$var$cacheStringFunction((str)=>str.replace($d932664a5029f787$var$hyphenateRE, "-$1").toLowerCase());
const $d932664a5029f787$export$9a00dee1beb8f576 = $d932664a5029f787$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $d932664a5029f787$export$8c022799eeaaefcd = $d932664a5029f787$var$cacheStringFunction((str)=>{
    const s = str ? `on${$d932664a5029f787$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $d932664a5029f787$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $d932664a5029f787$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $d932664a5029f787$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $d932664a5029f787$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $d932664a5029f787$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $d932664a5029f787$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $d932664a5029f787$var$_globalThis;
const $d932664a5029f787$export$ff5f2eeb11fc7e14 = ()=>{
    return $d932664a5029f787$var$_globalThis || ($d932664a5029f787$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $d932664a5029f787$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $d932664a5029f787$export$53d5e12f9a1d3cde(name) {
    return $d932664a5029f787$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $d932664a5029f787$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $d932664a5029f787$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $d932664a5029f787$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $d932664a5029f787$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $d932664a5029f787$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $d932664a5029f787$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $d932664a5029f787$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $d932664a5029f787$export$f73b8c13b7f97ebf = /* @__PURE__ */ $d932664a5029f787$export$b41394a5437791c8($d932664a5029f787$var$GLOBALS_ALLOWED);
const $d932664a5029f787$export$d6571a1911e4f27e = $d932664a5029f787$export$f73b8c13b7f97ebf;
const $d932664a5029f787$var$range = 2;
function $d932664a5029f787$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $d932664a5029f787$var$range; j <= i + $d932664a5029f787$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $d932664a5029f787$export$8756898546458274(value) {
    if ($d932664a5029f787$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $d932664a5029f787$export$844ec244b1367d54(item) ? $d932664a5029f787$export$76a205ce979d066a(item) : $d932664a5029f787$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($d932664a5029f787$export$844ec244b1367d54(value) || $d932664a5029f787$export$a6cdc56e425d0d0a(value)) return value;
}
const $d932664a5029f787$var$listDelimiterRE = /;(?![^(]*\))/g;
const $d932664a5029f787$var$propertyDelimiterRE = /:([^]+)/;
const $d932664a5029f787$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $d932664a5029f787$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($d932664a5029f787$var$styleCommentRE, "").split($d932664a5029f787$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($d932664a5029f787$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $d932664a5029f787$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($d932664a5029f787$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($d932664a5029f787$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $d932664a5029f787$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $d932664a5029f787$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($d932664a5029f787$export$844ec244b1367d54(value)) res = value;
    else if ($d932664a5029f787$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $d932664a5029f787$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($d932664a5029f787$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $d932664a5029f787$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$d932664a5029f787$export$844ec244b1367d54(klass)) props.class = $d932664a5029f787$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $d932664a5029f787$export$8756898546458274(style);
    return props;
}
const $d932664a5029f787$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $d932664a5029f787$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $d932664a5029f787$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $d932664a5029f787$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $d932664a5029f787$export$1ccf854a0984f890 = /* @__PURE__ */ $d932664a5029f787$export$b41394a5437791c8($d932664a5029f787$var$HTML_TAGS);
const $d932664a5029f787$export$6328ce7565ea1049 = /* @__PURE__ */ $d932664a5029f787$export$b41394a5437791c8($d932664a5029f787$var$SVG_TAGS);
const $d932664a5029f787$export$4a46ca4c5be17b20 = /* @__PURE__ */ $d932664a5029f787$export$b41394a5437791c8($d932664a5029f787$var$MATH_TAGS);
const $d932664a5029f787$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $d932664a5029f787$export$b41394a5437791c8($d932664a5029f787$var$VOID_TAGS);
const $d932664a5029f787$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $d932664a5029f787$export$d186f5eb2e810715 = /* @__PURE__ */ $d932664a5029f787$export$b41394a5437791c8($d932664a5029f787$var$specialBooleanAttrs);
const $d932664a5029f787$export$f763ba3b84e9cd8c = /* @__PURE__ */ $d932664a5029f787$export$b41394a5437791c8($d932664a5029f787$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $d932664a5029f787$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $d932664a5029f787$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $d932664a5029f787$var$attrValidationCache = {};
function $d932664a5029f787$export$d55ef77660f30d12(name) {
    if ($d932664a5029f787$var$attrValidationCache.hasOwnProperty(name)) return $d932664a5029f787$var$attrValidationCache[name];
    const isUnsafe = $d932664a5029f787$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $d932664a5029f787$var$attrValidationCache[name] = !isUnsafe;
}
const $d932664a5029f787$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $d932664a5029f787$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $d932664a5029f787$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $d932664a5029f787$export$80da416f43933831 = /* @__PURE__ */ $d932664a5029f787$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $d932664a5029f787$export$fc0748a8e0014066 = /* @__PURE__ */ $d932664a5029f787$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $d932664a5029f787$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $d932664a5029f787$var$escapeRE = /["'&<>]/;
function $d932664a5029f787$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $d932664a5029f787$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $d932664a5029f787$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $d932664a5029f787$export$7b105034a53bde5f(src) {
    return src.replace($d932664a5029f787$var$commentStripRE, "");
}
const $d932664a5029f787$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $d932664a5029f787$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($d932664a5029f787$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $d932664a5029f787$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $d932664a5029f787$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $d932664a5029f787$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $d932664a5029f787$export$871608497c498473(a);
    let bValidType = $d932664a5029f787$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $d932664a5029f787$export$a244864fd9645c7f(a);
    bValidType = $d932664a5029f787$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $d932664a5029f787$export$43bee75e5e14138e(a);
    bValidType = $d932664a5029f787$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $d932664a5029f787$var$looseCompareArrays(a, b) : false;
    aValidType = $d932664a5029f787$export$a6cdc56e425d0d0a(a);
    bValidType = $d932664a5029f787$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$d932664a5029f787$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $d932664a5029f787$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$d932664a5029f787$export$ae8015769846262c(item, val));
}
const $d932664a5029f787$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $d932664a5029f787$export$b5b1545233b45293 = (val)=>{
    return $d932664a5029f787$export$844ec244b1367d54(val) ? val : val == null ? "" : $d932664a5029f787$export$43bee75e5e14138e(val) || $d932664a5029f787$export$a6cdc56e425d0d0a(val) && (val.toString === $d932664a5029f787$export$830c053460e5ddf6 || !$d932664a5029f787$export$f6e2535fb5126e54(val.toString)) ? $d932664a5029f787$var$isRef(val) ? $d932664a5029f787$export$b5b1545233b45293(val.value) : JSON.stringify(val, $d932664a5029f787$var$replacer, 2) : String(val);
};
const $d932664a5029f787$var$replacer = (_key, val)=>{
    if ($d932664a5029f787$var$isRef(val)) return $d932664a5029f787$var$replacer(_key, val.value);
    else if ($d932664a5029f787$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$d932664a5029f787$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($d932664a5029f787$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$d932664a5029f787$var$stringifySymbol(v))
    };
    else if ($d932664a5029f787$export$a244864fd9645c7f(val)) return $d932664a5029f787$var$stringifySymbol(val);
    else if ($d932664a5029f787$export$a6cdc56e425d0d0a(val) && !$d932664a5029f787$export$43bee75e5e14138e(val) && !$d932664a5029f787$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $d932664a5029f787$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $d932664a5029f787$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

});



parcelRegister("24349", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("fVLUl")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("fVLUl")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("fVLUl")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("iE8iy")).camelize);
$parcel$export(module.exports, "computed", () => (parcelRequire("fVLUl")).computed);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("fVLUl")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("fVLUl")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("fVLUl")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("fVLUl")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("fVLUl")).createRenderer);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("fVLUl")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("fVLUl")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("fVLUl")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("fVLUl")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("fVLUl")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("fVLUl")).getTransitionRawChildren);
$parcel$export(module.exports, "h", () => (parcelRequire("fVLUl")).h);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("fVLUl")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("fVLUl")).inject);
$parcel$export(module.exports, "isRef", () => (parcelRequire("eayOh")).isRef);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("fVLUl")).isRuntimeOnly);
$parcel$export(module.exports, "KeepAlive", () => (parcelRequire("fVLUl")).KeepAlive);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("eayOh")).markRaw);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("fVLUl")).nextTick);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("fVLUl")).onActivated);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("fVLUl")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("fVLUl")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("fVLUl")).onBeforeUpdate);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("fVLUl")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("fVLUl")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("fVLUl")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("fVLUl")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("fVLUl")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("fVLUl")).provide);
$parcel$export(module.exports, "queuePostFlushCb", () => (parcelRequire("fVLUl")).queuePostFlushCb);
$parcel$export(module.exports, "reactive", () => (parcelRequire("eayOh")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("eayOh")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("fVLUl")).renderList);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("fVLUl")).resolveComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("fVLUl")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("fVLUl")).setTransitionHooks);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("eayOh")).shallowReactive);
$parcel$export(module.exports, "Static", () => (parcelRequire("fVLUl")).Static);
$parcel$export(module.exports, "Teleport", () => (parcelRequire("fVLUl")).Teleport);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("eayOh")).toRaw);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("fVLUl")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("fVLUl")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("fVLUl")).watch);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("fVLUl")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("fVLUl")).withDirectives);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("iE8iy")).toDisplayString);

$parcel$export(module.exports, "Transition", () => $180e55545c205f6f$export$be58926105124dd4);
$parcel$export(module.exports, "vShow", () => $180e55545c205f6f$export$5cb4fcdc6937d7e1);
$parcel$export(module.exports, "createApp", () => $180e55545c205f6f$export$4e373c34abfa8c68);
$parcel$export(module.exports, "TransitionGroup", () => $180e55545c205f6f$export$19ffa8f511f7bc2e);
$parcel$export(module.exports, "vModelCheckbox", () => $180e55545c205f6f$export$8847c2e532b35714);
$parcel$export(module.exports, "vModelSelect", () => $180e55545c205f6f$export$87d227567b51ca39);
/**
* @vue/runtime-dom v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $fVLUl = parcelRequire("fVLUl");
var $iE8iy = parcelRequire("iE8iy");
var $eayOh = parcelRequire("eayOh");parcelRequire("iE8iy");
var $eayOh = parcelRequire("eayOh");

var $iE8iy = parcelRequire("iE8iy");
let $180e55545c205f6f$var$policy = void 0;
const $180e55545c205f6f$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($180e55545c205f6f$var$tt) try {
    $180e55545c205f6f$var$policy = /* @__PURE__ */ $180e55545c205f6f$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $180e55545c205f6f$var$unsafeToTrustedHTML = $180e55545c205f6f$var$policy ? (val)=>$180e55545c205f6f$var$policy.createHTML(val) : (val)=>val;
const $180e55545c205f6f$var$svgNS = "http://www.w3.org/2000/svg";
const $180e55545c205f6f$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $180e55545c205f6f$var$doc = typeof document !== "undefined" ? document : null;
const $180e55545c205f6f$var$templateContainer = $180e55545c205f6f$var$doc && /* @__PURE__ */ $180e55545c205f6f$var$doc.createElement("template");
const $180e55545c205f6f$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $180e55545c205f6f$var$doc.createElementNS($180e55545c205f6f$var$svgNS, tag) : namespace === "mathml" ? $180e55545c205f6f$var$doc.createElementNS($180e55545c205f6f$var$mathmlNS, tag) : is ? $180e55545c205f6f$var$doc.createElement(tag, {
            is: is
        }) : $180e55545c205f6f$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$180e55545c205f6f$var$doc.createTextNode(text),
    createComment: (text)=>$180e55545c205f6f$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$180e55545c205f6f$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $180e55545c205f6f$var$templateContainer.innerHTML = $180e55545c205f6f$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $180e55545c205f6f$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $180e55545c205f6f$var$TRANSITION = "transition";
const $180e55545c205f6f$var$ANIMATION = "animation";
const $180e55545c205f6f$var$vtcKey = Symbol("_vtc");
const $180e55545c205f6f$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $180e55545c205f6f$var$TransitionPropsValidators = /* @__PURE__ */ (0, $iE8iy.extend)({}, (0, $fVLUl.BaseTransitionPropsValidators), $180e55545c205f6f$var$DOMTransitionPropsValidators);
const $180e55545c205f6f$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $180e55545c205f6f$var$TransitionPropsValidators;
    return t;
};
const $180e55545c205f6f$export$be58926105124dd4 = /* @__PURE__ */ $180e55545c205f6f$var$decorate$1((props, { slots: slots })=>(0, $fVLUl.h)((0, $fVLUl.BaseTransition), $180e55545c205f6f$var$resolveTransitionProps(props), slots));
const $180e55545c205f6f$var$callHook = (hook, args = [])=>{
    if ((0, $iE8iy.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $180e55545c205f6f$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $iE8iy.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $180e55545c205f6f$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $180e55545c205f6f$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $180e55545c205f6f$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $180e55545c205f6f$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $180e55545c205f6f$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $180e55545c205f6f$var$removeTransitionClass(el, leaveFromClass);
        $180e55545c205f6f$var$removeTransitionClass(el, leaveToClass);
        $180e55545c205f6f$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $180e55545c205f6f$var$callHook(hook, [
                el,
                resolve
            ]);
            $180e55545c205f6f$var$nextFrame(()=>{
                $180e55545c205f6f$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $180e55545c205f6f$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$180e55545c205f6f$var$hasExplicitCallback(hook)) $180e55545c205f6f$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $iE8iy.extend)(baseProps, {
        onBeforeEnter (el) {
            $180e55545c205f6f$var$callHook(onBeforeEnter, [
                el
            ]);
            $180e55545c205f6f$var$addTransitionClass(el, enterFromClass);
            $180e55545c205f6f$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $180e55545c205f6f$var$callHook(onBeforeAppear, [
                el
            ]);
            $180e55545c205f6f$var$addTransitionClass(el, appearFromClass);
            $180e55545c205f6f$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $180e55545c205f6f$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $180e55545c205f6f$var$forceReflow();
                $180e55545c205f6f$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $180e55545c205f6f$var$addTransitionClass(el, leaveActiveClass);
                $180e55545c205f6f$var$forceReflow();
            }
            $180e55545c205f6f$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $180e55545c205f6f$var$removeTransitionClass(el, leaveFromClass);
                $180e55545c205f6f$var$addTransitionClass(el, leaveToClass);
                if (!$180e55545c205f6f$var$hasExplicitCallback(onLeave)) $180e55545c205f6f$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $180e55545c205f6f$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $180e55545c205f6f$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $180e55545c205f6f$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $180e55545c205f6f$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $180e55545c205f6f$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $iE8iy.isObject)(duration)) return [
        $180e55545c205f6f$var$NumberOf(duration.enter),
        $180e55545c205f6f$var$NumberOf(duration.leave)
    ];
    else {
        const n = $180e55545c205f6f$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $180e55545c205f6f$var$NumberOf(val) {
    const res = (0, $iE8iy.toNumber)(val);
    return res;
}
function $180e55545c205f6f$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$180e55545c205f6f$var$vtcKey] || (el[$180e55545c205f6f$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $180e55545c205f6f$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$180e55545c205f6f$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$180e55545c205f6f$var$vtcKey] = void 0;
    }
}
function $180e55545c205f6f$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $180e55545c205f6f$var$endId = 0;
function $180e55545c205f6f$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$180e55545c205f6f$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $180e55545c205f6f$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $180e55545c205f6f$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$180e55545c205f6f$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$180e55545c205f6f$var$TRANSITION}Duration`);
    const transitionTimeout = $180e55545c205f6f$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$180e55545c205f6f$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$180e55545c205f6f$var$ANIMATION}Duration`);
    const animationTimeout = $180e55545c205f6f$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $180e55545c205f6f$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $180e55545c205f6f$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $180e55545c205f6f$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $180e55545c205f6f$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $180e55545c205f6f$var$TRANSITION : $180e55545c205f6f$var$ANIMATION : null;
        propCount = type ? type === $180e55545c205f6f$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $180e55545c205f6f$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$180e55545c205f6f$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $180e55545c205f6f$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$180e55545c205f6f$var$toMs(d) + $180e55545c205f6f$var$toMs(delays[i])));
}
function $180e55545c205f6f$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $180e55545c205f6f$var$forceReflow() {
    return document.body.offsetHeight;
}
function $180e55545c205f6f$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$180e55545c205f6f$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $180e55545c205f6f$var$vShowOriginalDisplay = Symbol("_vod");
const $180e55545c205f6f$var$vShowHidden = Symbol("_vsh");
const $180e55545c205f6f$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$180e55545c205f6f$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $180e55545c205f6f$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $180e55545c205f6f$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $180e55545c205f6f$var$setDisplay(el, false);
            });
        } else $180e55545c205f6f$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $180e55545c205f6f$var$setDisplay(el, value);
    }
};
function $180e55545c205f6f$var$setDisplay(el, value) {
    el.style.display = value ? el[$180e55545c205f6f$var$vShowOriginalDisplay] : "none";
    el[$180e55545c205f6f$var$vShowHidden] = !value;
}
function $180e55545c205f6f$var$initVShowForSSR() {
    $180e55545c205f6f$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $180e55545c205f6f$var$CSS_VAR_TEXT = Symbol("");
function $180e55545c205f6f$export$ef28b76f07940108(getter) {
    const instance = (0, $fVLUl.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$180e55545c205f6f$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $180e55545c205f6f$var$setVarsOnNode(instance.ce, vars);
        else $180e55545c205f6f$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $fVLUl.onBeforeUpdate)(()=>{
        (0, $fVLUl.queuePostFlushCb)(setVars);
    });
    (0, $fVLUl.onMounted)(()=>{
        (0, $fVLUl.watch)(setVars, (0, $iE8iy.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $fVLUl.onUnmounted)(()=>ob.disconnect());
    });
}
function $180e55545c205f6f$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $180e55545c205f6f$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $180e55545c205f6f$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $fVLUl.Fragment)) vnode.children.forEach((c)=>$180e55545c205f6f$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $fVLUl.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $180e55545c205f6f$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $180e55545c205f6f$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[$180e55545c205f6f$var$CSS_VAR_TEXT] = cssText;
    }
}
const $180e55545c205f6f$var$displayRE = /(^|;)\s*display\s*:/;
function $180e55545c205f6f$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $iE8iy.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $iE8iy.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $180e55545c205f6f$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $180e55545c205f6f$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $180e55545c205f6f$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$180e55545c205f6f$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $180e55545c205f6f$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($180e55545c205f6f$var$vShowOriginalDisplay in el) {
        el[$180e55545c205f6f$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$180e55545c205f6f$var$vShowHidden]) style.display = "none";
    }
}
const $180e55545c205f6f$var$semicolonRE = /[^\\];\s*$/;
const $180e55545c205f6f$var$importantRE = /\s*!important$/;
function $180e55545c205f6f$var$setStyle(style, name, val) {
    if ((0, $iE8iy.isArray)(val)) val.forEach((v)=>$180e55545c205f6f$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $180e55545c205f6f$var$autoPrefix(style, name);
            if ($180e55545c205f6f$var$importantRE.test(val)) style.setProperty((0, $iE8iy.hyphenate)(prefixed), val.replace($180e55545c205f6f$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $180e55545c205f6f$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $180e55545c205f6f$var$prefixCache = {};
function $180e55545c205f6f$var$autoPrefix(style, rawName) {
    const cached = $180e55545c205f6f$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $iE8iy.camelize)(rawName);
    if (name !== "filter" && name in style) return $180e55545c205f6f$var$prefixCache[rawName] = name;
    name = (0, $iE8iy.capitalize)(name);
    for(let i = 0; i < $180e55545c205f6f$var$prefixes.length; i++){
        const prefixed = $180e55545c205f6f$var$prefixes[i] + name;
        if (prefixed in style) return $180e55545c205f6f$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $180e55545c205f6f$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $180e55545c205f6f$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $iE8iy.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($180e55545c205f6f$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($180e55545c205f6f$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $iE8iy.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $iE8iy.isSymbol)(value) ? String(value) : value);
}
function $180e55545c205f6f$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $180e55545c205f6f$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $iE8iy.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $180e55545c205f6f$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $180e55545c205f6f$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $180e55545c205f6f$var$veiKey = Symbol("_vei");
function $180e55545c205f6f$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$180e55545c205f6f$var$veiKey] || (el[$180e55545c205f6f$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $180e55545c205f6f$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $180e55545c205f6f$var$createInvoker(nextValue, instance);
            $180e55545c205f6f$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $180e55545c205f6f$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $180e55545c205f6f$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $180e55545c205f6f$var$parseName(name) {
    let options;
    if ($180e55545c205f6f$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($180e55545c205f6f$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $iE8iy.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $180e55545c205f6f$var$cachedNow = 0;
const $180e55545c205f6f$var$p = /* @__PURE__ */ Promise.resolve();
const $180e55545c205f6f$var$getNow = ()=>$180e55545c205f6f$var$cachedNow || ($180e55545c205f6f$var$p.then(()=>$180e55545c205f6f$var$cachedNow = 0), $180e55545c205f6f$var$cachedNow = Date.now());
function $180e55545c205f6f$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $fVLUl.callWithAsyncErrorHandling)($180e55545c205f6f$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $180e55545c205f6f$var$getNow();
    return invoker;
}
function $180e55545c205f6f$var$sanitizeEventValue(value, propName) {
    if ((0, $iE8iy.isFunction)(value) || (0, $iE8iy.isArray)(value)) return value;
    (0, $fVLUl.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $iE8iy.NOOP;
}
function $180e55545c205f6f$var$patchStopImmediatePropagation(e, value) {
    if ((0, $iE8iy.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $180e55545c205f6f$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $180e55545c205f6f$var$patchProp = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $180e55545c205f6f$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $180e55545c205f6f$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $iE8iy.isOn)(key)) {
        if (!(0, $iE8iy.isModelListener)(key)) $180e55545c205f6f$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $180e55545c205f6f$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $180e55545c205f6f$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $180e55545c205f6f$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && (/[A-Z]/.test(key) || !(0, $iE8iy.isString)(nextValue))) $180e55545c205f6f$var$patchDOMProp(el, (0, $iE8iy.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $180e55545c205f6f$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $180e55545c205f6f$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $180e55545c205f6f$var$isNativeOn(key) && (0, $iE8iy.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($180e55545c205f6f$var$isNativeOn(key) && (0, $iE8iy.isString)(value)) return false;
    return key in el;
}
const $180e55545c205f6f$var$REMOVAL = {};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $180e55545c205f6f$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    const Comp = (0, $fVLUl.defineComponent)(options, extraOptions);
    if ((0, $iE8iy.isPlainObject)(Comp)) (0, $iE8iy.extend)(Comp, extraOptions);
    class VueCustomElement extends $180e55545c205f6f$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $180e55545c205f6f$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $180e55545c205f6f$export$a00e2346eabbdbef(options, extraOptions, $180e55545c205f6f$export$35800275c0037383);
};
const $180e55545c205f6f$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $180e55545c205f6f$export$b337c1a55163dbe3 extends $180e55545c205f6f$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $180e55545c205f6f$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $180e55545c205f6f$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow({
                mode: "open"
            });
            this._root = this.shadowRoot;
        } else this._root = this;
        if (!this._def.__asyncLoader) this._resolveProps(this._def);
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $180e55545c205f6f$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) {
                this._setParent();
                this._update();
            } else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._instance.provides = parent._instance.provides;
        }
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $fVLUl.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $iE8iy.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $iE8iy.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $iE8iy.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>resolve(this._def = def, true));
        else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $iE8iy.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $eayOh.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $iE8iy.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $iE8iy.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, true);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $180e55545c205f6f$var$REMOVAL;
        const camelKey = (0, $iE8iy.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $iE8iy.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            if (val === $180e55545c205f6f$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                ob && ob.disconnect();
                if (val === true) this.setAttribute((0, $iE8iy.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $iE8iy.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $iE8iy.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        $180e55545c205f6f$export$b3890eb0ae9dca99(this._createVNode(), this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $fVLUl.createVNode)(this._def, (0, $iE8iy.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $iE8iy.isPlainObject)(args[0]) ? (0, $iE8iy.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $iE8iy.hyphenate)(event) !== event) dispatch((0, $iE8iy.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            this.shadowRoot.prepend(s);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = (this._teleportTarget || this).querySelectorAll("slot");
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _injectChildStyle(comp) {
        this._applyStyles(comp.styles, comp);
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $180e55545c205f6f$export$da5acfe93a94e37d(caller) {
    const instance = (0, $fVLUl.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $fVLUl.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $fVLUl.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $180e55545c205f6f$export$64d45095031fa749() {
    const el = $180e55545c205f6f$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $180e55545c205f6f$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $fVLUl.getCurrentInstance)();
        if (!instance) return 0, $iE8iy.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $iE8iy.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $iE8iy.EMPTY_OBJ;
        return mod;
    }
}
const $180e55545c205f6f$var$positionMap = /* @__PURE__ */ new WeakMap();
const $180e55545c205f6f$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $180e55545c205f6f$var$moveCbKey = Symbol("_moveCb");
const $180e55545c205f6f$var$enterCbKey = Symbol("_enterCb");
const $180e55545c205f6f$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $180e55545c205f6f$var$TransitionGroupImpl = /* @__PURE__ */ $180e55545c205f6f$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $iE8iy.extend)({}, $180e55545c205f6f$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $fVLUl.getCurrentInstance)();
        const state = (0, $fVLUl.useTransitionState)();
        let prevChildren;
        let children;
        (0, $fVLUl.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$180e55545c205f6f$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($180e55545c205f6f$var$callPendingCbs);
            prevChildren.forEach($180e55545c205f6f$var$recordPosition);
            const movedChildren = prevChildren.filter($180e55545c205f6f$var$applyTranslation);
            $180e55545c205f6f$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $180e55545c205f6f$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$180e55545c205f6f$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$180e55545c205f6f$var$moveCbKey] = null;
                        $180e55545c205f6f$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $eayOh.toRaw)(props);
            const cssTransitionProps = $180e55545c205f6f$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $fVLUl.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $fVLUl.setTransitionHooks)(child, (0, $fVLUl.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $180e55545c205f6f$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $fVLUl.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $fVLUl.setTransitionHooks)(child, (0, $fVLUl.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $fVLUl.createVNode)(tag, null, children);
        };
    }
});
const $180e55545c205f6f$export$19ffa8f511f7bc2e = $180e55545c205f6f$var$TransitionGroupImpl;
function $180e55545c205f6f$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$180e55545c205f6f$var$moveCbKey]) el[$180e55545c205f6f$var$moveCbKey]();
    if (el[$180e55545c205f6f$var$enterCbKey]) el[$180e55545c205f6f$var$enterCbKey]();
}
function $180e55545c205f6f$var$recordPosition(c) {
    $180e55545c205f6f$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $180e55545c205f6f$var$applyTranslation(c) {
    const oldPos = $180e55545c205f6f$var$positionMap.get(c);
    const newPos = $180e55545c205f6f$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $180e55545c205f6f$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$180e55545c205f6f$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $180e55545c205f6f$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $180e55545c205f6f$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $iE8iy.isArray)(fn) ? (value)=>(0, $iE8iy.invokeArrayFns)(fn, value) : fn;
};
function $180e55545c205f6f$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $180e55545c205f6f$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $180e55545c205f6f$var$assignKey = Symbol("_assign");
const $180e55545c205f6f$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$180e55545c205f6f$var$assignKey] = $180e55545c205f6f$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $180e55545c205f6f$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $iE8iy.looseToNumber)(domValue);
            el[$180e55545c205f6f$var$assignKey](domValue);
        });
        if (trim) $180e55545c205f6f$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $180e55545c205f6f$var$addEventListener(el, "compositionstart", $180e55545c205f6f$var$onCompositionStart);
            $180e55545c205f6f$var$addEventListener(el, "compositionend", $180e55545c205f6f$var$onCompositionEnd);
            $180e55545c205f6f$var$addEventListener(el, "change", $180e55545c205f6f$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$180e55545c205f6f$var$assignKey] = $180e55545c205f6f$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $iE8iy.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $180e55545c205f6f$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$180e55545c205f6f$var$assignKey] = $180e55545c205f6f$var$getModelAssigner(vnode);
        $180e55545c205f6f$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $180e55545c205f6f$var$getValue(el);
            const checked = el.checked;
            const assign = el[$180e55545c205f6f$var$assignKey];
            if ((0, $iE8iy.isArray)(modelValue)) {
                const index = (0, $iE8iy.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $iE8iy.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($180e55545c205f6f$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $180e55545c205f6f$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$180e55545c205f6f$var$assignKey] = $180e55545c205f6f$var$getModelAssigner(vnode);
        $180e55545c205f6f$var$setChecked(el, binding, vnode);
    }
};
function $180e55545c205f6f$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $iE8iy.isArray)(value)) checked = (0, $iE8iy.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $iE8iy.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $iE8iy.looseEqual)(value, $180e55545c205f6f$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $180e55545c205f6f$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $iE8iy.looseEqual)(value, vnode.props.value);
        el[$180e55545c205f6f$var$assignKey] = $180e55545c205f6f$var$getModelAssigner(vnode);
        $180e55545c205f6f$var$addEventListener(el, "change", ()=>{
            el[$180e55545c205f6f$var$assignKey]($180e55545c205f6f$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$180e55545c205f6f$var$assignKey] = $180e55545c205f6f$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $iE8iy.looseEqual)(value, vnode.props.value);
    }
};
const $180e55545c205f6f$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $iE8iy.isSet)(value);
        $180e55545c205f6f$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $iE8iy.looseToNumber)($180e55545c205f6f$var$getValue(o)) : $180e55545c205f6f$var$getValue(o));
            el[$180e55545c205f6f$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $fVLUl.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$180e55545c205f6f$var$assignKey] = $180e55545c205f6f$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $180e55545c205f6f$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$180e55545c205f6f$var$assignKey] = $180e55545c205f6f$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        if (!el._assigning) $180e55545c205f6f$var$setSelected(el, value);
    }
};
function $180e55545c205f6f$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $iE8iy.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $iE8iy.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $180e55545c205f6f$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $iE8iy.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $iE8iy.looseEqual)($180e55545c205f6f$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $180e55545c205f6f$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $180e55545c205f6f$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $180e55545c205f6f$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $180e55545c205f6f$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $180e55545c205f6f$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $180e55545c205f6f$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $180e55545c205f6f$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $180e55545c205f6f$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $180e55545c205f6f$export$87d227567b51ca39;
        case "TEXTAREA":
            return $180e55545c205f6f$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $180e55545c205f6f$export$8847c2e532b35714;
                case "radio":
                    return $180e55545c205f6f$export$b4356c59b38b7aa9;
                default:
                    return $180e55545c205f6f$export$f1f88689f5728478;
            }
    }
}
function $180e55545c205f6f$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $180e55545c205f6f$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $180e55545c205f6f$var$initVModelForSSR() {
    $180e55545c205f6f$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $180e55545c205f6f$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $iE8iy.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $180e55545c205f6f$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $iE8iy.isArray)(value)) {
            if (vnode.props && (0, $iE8iy.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $iE8iy.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $180e55545c205f6f$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $180e55545c205f6f$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $180e55545c205f6f$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $180e55545c205f6f$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$180e55545c205f6f$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $180e55545c205f6f$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $180e55545c205f6f$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $180e55545c205f6f$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $180e55545c205f6f$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $iE8iy.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $180e55545c205f6f$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $180e55545c205f6f$var$rendererOptions = /* @__PURE__ */ (0, $iE8iy.extend)({
    patchProp: $180e55545c205f6f$var$patchProp
}, $180e55545c205f6f$var$nodeOps);
let $180e55545c205f6f$var$renderer;
let $180e55545c205f6f$var$enabledHydration = false;
function $180e55545c205f6f$var$ensureRenderer() {
    return $180e55545c205f6f$var$renderer || ($180e55545c205f6f$var$renderer = (0, $fVLUl.createRenderer)($180e55545c205f6f$var$rendererOptions));
}
function $180e55545c205f6f$var$ensureHydrationRenderer() {
    $180e55545c205f6f$var$renderer = $180e55545c205f6f$var$enabledHydration ? $180e55545c205f6f$var$renderer : (0, $fVLUl.createHydrationRenderer)($180e55545c205f6f$var$rendererOptions);
    $180e55545c205f6f$var$enabledHydration = true;
    return $180e55545c205f6f$var$renderer;
}
const $180e55545c205f6f$export$b3890eb0ae9dca99 = (...args)=>{
    $180e55545c205f6f$var$ensureRenderer().render(...args);
};
const $180e55545c205f6f$export$fa8d919ba61d84db = (...args)=>{
    $180e55545c205f6f$var$ensureHydrationRenderer().hydrate(...args);
};
const $180e55545c205f6f$export$4e373c34abfa8c68 = (...args)=>{
    const app = $180e55545c205f6f$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $180e55545c205f6f$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $iE8iy.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $180e55545c205f6f$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $180e55545c205f6f$export$35800275c0037383 = (...args)=>{
    const app = $180e55545c205f6f$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $180e55545c205f6f$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $180e55545c205f6f$var$resolveRootNamespace(container));
    };
    return app;
};
function $180e55545c205f6f$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $180e55545c205f6f$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $iE8iy.isHTMLTag)(tag) || (0, $iE8iy.isSVGTag)(tag) || (0, $iE8iy.isMathMLTag)(tag),
        writable: false
    });
}
function $180e55545c205f6f$var$injectCompilerOptionsCheck(app) {
    if ((0, $fVLUl.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $fVLUl.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $fVLUl.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $fVLUl.warn)(msg);
            }
        });
    }
}
function $180e55545c205f6f$var$normalizeContainer(container) {
    if ((0, $iE8iy.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $180e55545c205f6f$var$ssrDirectiveInitialized = false;
const $180e55545c205f6f$export$800b28255aa678d9 = ()=>{
    if (!$180e55545c205f6f$var$ssrDirectiveInitialized) {
        $180e55545c205f6f$var$ssrDirectiveInitialized = true;
        $180e55545c205f6f$var$initVModelForSSR();
        $180e55545c205f6f$var$initVShowForSSR();
    }
};

});


parcelRegister("bnwzR", function(module, exports) {

$parcel$export(module.exports, "Notify", () => $848b1ce88e755b32$export$dd80a68918412a62);
$parcel$export(module.exports, "useQuasar", () => $848b1ce88e755b32$export$b1dfd21c8751085);
$parcel$export(module.exports, "Quasar", () => $848b1ce88e755b32$export$aa2891570c510a77);
/*!
 * Quasar Framework v2.15.4
 * (c) 2015-present Razvan Stoenescu
 * Released under the MIT License.
 */ parcelRequire("8BBfn");
var $eayOh = parcelRequire("eayOh");
var $24349 = parcelRequire("24349");
var $fVLUl = parcelRequire("fVLUl");
var $848b1ce88e755b32$var$p0 = Object.create;
var $848b1ce88e755b32$var$Qs = Object.defineProperty;
var $848b1ce88e755b32$var$b0 = Object.getOwnPropertyDescriptor;
var $848b1ce88e755b32$var$y0 = Object.getOwnPropertyNames;
var $848b1ce88e755b32$var$S0 = Object.getPrototypeOf, $848b1ce88e755b32$var$x0 = Object.prototype.hasOwnProperty;
var $848b1ce88e755b32$var$Dd = (e, t)=>()=>(t || e((t = {
            exports: {}
        }).exports, t), t.exports), $848b1ce88e755b32$var$Vd = (e, t)=>{
    for(var o in t)$848b1ce88e755b32$var$Qs(e, o, {
        get: t[o],
        enumerable: !0
    });
}, $848b1ce88e755b32$var$_0 = (e, t, o, r)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let n of $848b1ce88e755b32$var$y0(t))!$848b1ce88e755b32$var$x0.call(e, n) && n !== o && $848b1ce88e755b32$var$Qs(e, n, {
        get: ()=>t[n],
        enumerable: !(r = $848b1ce88e755b32$var$b0(t, n)) || r.enumerable
    });
    return e;
};
var $848b1ce88e755b32$var$zd = (e, t, o)=>(o = e != null ? $848b1ce88e755b32$var$p0($848b1ce88e755b32$var$S0(e)) : {}, $848b1ce88e755b32$var$_0(t || !e || !e.__esModule ? $848b1ce88e755b32$var$Qs(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e));
var $848b1ce88e755b32$var$Xd = $848b1ce88e755b32$var$Dd((t2, Yd)=>{
    Yd.exports = {
        isoName: "en-US",
        nativeName: "English (US)",
        label: {
            clear: "Clear",
            ok: "OK",
            cancel: "Cancel",
            close: "Close",
            set: "Set",
            select: "Select",
            reset: "Reset",
            remove: "Remove",
            update: "Update",
            create: "Create",
            search: "Search",
            filter: "Filter",
            refresh: "Refresh",
            expand: (e)=>e ? `Expand "${e}"` : "Expand",
            collapse: (e)=>e ? `Collapse "${e}"` : "Collapse"
        },
        date: {
            days: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
            daysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
            monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            firstDayOfWeek: 0,
            format24h: !1,
            pluralDay: "days"
        },
        table: {
            noData: "No data available",
            noResults: "No matching records found",
            loading: "Loading...",
            selectedRecords: (e)=>e === 1 ? "1 record selected." : (e === 0 ? "No" : e) + " records selected.",
            recordsPerPage: "Records per page:",
            allRows: "All",
            pagination: (e, t, o)=>e + "-" + t + " of " + o,
            columns: "Columns"
        },
        editor: {
            url: "URL",
            bold: "Bold",
            italic: "Italic",
            strikethrough: "Strikethrough",
            underline: "Underline",
            unorderedList: "Unordered List",
            orderedList: "Ordered List",
            subscript: "Subscript",
            superscript: "Superscript",
            hyperlink: "Hyperlink",
            toggleFullscreen: "Toggle Fullscreen",
            quote: "Quote",
            left: "Left align",
            center: "Center align",
            right: "Right align",
            justify: "Justify align",
            print: "Print",
            outdent: "Decrease indentation",
            indent: "Increase indentation",
            removeFormat: "Remove formatting",
            formatting: "Formatting",
            fontSize: "Font Size",
            align: "Align",
            hr: "Insert Horizontal Rule",
            undo: "Undo",
            redo: "Redo",
            heading1: "Heading 1",
            heading2: "Heading 2",
            heading3: "Heading 3",
            heading4: "Heading 4",
            heading5: "Heading 5",
            heading6: "Heading 6",
            paragraph: "Paragraph",
            code: "Code",
            size1: "Very small",
            size2: "A bit small",
            size3: "Normal",
            size4: "Medium-large",
            size5: "Big",
            size6: "Very big",
            size7: "Maximum",
            defaultFont: "Default Font",
            viewSource: "View Source"
        },
        tree: {
            noNodes: "No nodes available",
            noResults: "No matching nodes found"
        }
    };
});
var $848b1ce88e755b32$var$Jd = $848b1ce88e755b32$var$Dd((r2, Zd)=>{
    Zd.exports = {
        name: "material-icons",
        type: {
            positive: "check_circle",
            negative: "warning",
            info: "info",
            warning: "priority_high"
        },
        arrow: {
            up: "arrow_upward",
            right: "arrow_forward",
            down: "arrow_downward",
            left: "arrow_back",
            dropdown: "arrow_drop_down"
        },
        chevron: {
            left: "chevron_left",
            right: "chevron_right"
        },
        colorPicker: {
            spectrum: "gradient",
            tune: "tune",
            palette: "style"
        },
        pullToRefresh: {
            icon: "refresh"
        },
        carousel: {
            left: "chevron_left",
            right: "chevron_right",
            up: "keyboard_arrow_up",
            down: "keyboard_arrow_down",
            navigationIcon: "lens"
        },
        chip: {
            remove: "cancel",
            selected: "check"
        },
        datetime: {
            arrowLeft: "chevron_left",
            arrowRight: "chevron_right",
            now: "access_time",
            today: "today"
        },
        editor: {
            bold: "format_bold",
            italic: "format_italic",
            strikethrough: "strikethrough_s",
            underline: "format_underlined",
            unorderedList: "format_list_bulleted",
            orderedList: "format_list_numbered",
            subscript: "vertical_align_bottom",
            superscript: "vertical_align_top",
            hyperlink: "link",
            toggleFullscreen: "fullscreen",
            quote: "format_quote",
            left: "format_align_left",
            center: "format_align_center",
            right: "format_align_right",
            justify: "format_align_justify",
            print: "print",
            outdent: "format_indent_decrease",
            indent: "format_indent_increase",
            removeFormat: "format_clear",
            formatting: "text_format",
            fontSize: "format_size",
            align: "format_align_left",
            hr: "remove",
            undo: "undo",
            redo: "redo",
            heading: "format_size",
            code: "code",
            size: "format_size",
            font: "font_download",
            viewSource: "code"
        },
        expansionItem: {
            icon: "keyboard_arrow_down",
            denseIcon: "arrow_drop_down"
        },
        fab: {
            icon: "add",
            activeIcon: "close"
        },
        field: {
            clear: "cancel",
            error: "error"
        },
        pagination: {
            first: "first_page",
            prev: "keyboard_arrow_left",
            next: "keyboard_arrow_right",
            last: "last_page"
        },
        rating: {
            icon: "grade"
        },
        stepper: {
            done: "check",
            active: "edit",
            error: "warning"
        },
        tabs: {
            left: "chevron_left",
            right: "chevron_right",
            up: "keyboard_arrow_up",
            down: "keyboard_arrow_down"
        },
        table: {
            arrowUp: "arrow_upward",
            warning: "warning",
            firstPage: "first_page",
            prevPage: "chevron_left",
            nextPage: "chevron_right",
            lastPage: "last_page"
        },
        tree: {
            icon: "play_arrow"
        },
        uploader: {
            done: "done",
            clear: "clear",
            add: "add_box",
            upload: "cloud_upload",
            removeQueue: "clear_all",
            removeUploaded: "done_all"
        }
    };
});
function $848b1ce88e755b32$var$it(e, t, o, r) {
    return Object.defineProperty(e, t, {
        get: o,
        set: r,
        enumerable: !0
    }), e;
}
function $848b1ce88e755b32$var$Sl(e, t) {
    for(let o in t)$848b1ce88e755b32$var$it(e, o, t[o]);
    return e;
}
var $848b1ce88e755b32$var$bt = (0, $eayOh.ref)(!1), $848b1ce88e755b32$var$js;
function $848b1ce88e755b32$var$k0(e, t) {
    let o = /(edg|edge|edga|edgios)\/([\w.]+)/.exec(e) || /(opr)[\/]([\w.]+)/.exec(e) || /(vivaldi)[\/]([\w.]+)/.exec(e) || /(chrome|crios)[\/]([\w.]+)/.exec(e) || /(version)(applewebkit)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(e) || /(webkit)[\/]([\w.]+).*(version)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(e) || /(firefox|fxios)[\/]([\w.]+)/.exec(e) || /(webkit)[\/]([\w.]+)/.exec(e) || /(opera)(?:.*version|)[\/]([\w.]+)/.exec(e) || [];
    return {
        browser: o[5] || o[3] || o[1] || "",
        version: o[4] || o[2] || "0",
        platform: t[0] || ""
    };
}
function $848b1ce88e755b32$var$q0(e) {
    return /(ipad)/.exec(e) || /(ipod)/.exec(e) || /(windows phone)/.exec(e) || /(iphone)/.exec(e) || /(kindle)/.exec(e) || /(silk)/.exec(e) || /(android)/.exec(e) || /(win)/.exec(e) || /(mac)/.exec(e) || /(linux)/.exec(e) || /(cros)/.exec(e) || /(playbook)/.exec(e) || /(bb)/.exec(e) || /(blackberry)/.exec(e) || [];
}
var $848b1ce88e755b32$var$Id = "ontouchstart" in window || window.navigator.maxTouchPoints > 0;
function $848b1ce88e755b32$var$T0(e) {
    let t = e.toLowerCase(), o = $848b1ce88e755b32$var$q0(t), r = $848b1ce88e755b32$var$k0(t, o), n = {};
    r.browser && (n[r.browser] = !0, n.version = r.version, n.versionNumber = parseInt(r.version, 10)), r.platform && (n[r.platform] = !0);
    let i = n.android || n.ios || n.bb || n.blackberry || n.ipad || n.iphone || n.ipod || n.kindle || n.playbook || n.silk || n["windows phone"];
    if (i === !0 || t.indexOf("mobile") !== -1 ? n.mobile = !0 : n.desktop = !0, n["windows phone"] && (n.winphone = !0, delete n["windows phone"]), n.edga || n.edgios || n.edg ? (n.edge = !0, r.browser = "edge") : n.crios ? (n.chrome = !0, r.browser = "chrome") : n.fxios && (n.firefox = !0, r.browser = "firefox"), (n.ipod || n.ipad || n.iphone) && (n.ios = !0), n.vivaldi && (r.browser = "vivaldi", n.vivaldi = !0), (n.chrome || n.opr || n.safari || n.vivaldi || n.mobile === !0 && n.ios !== !0 && i !== !0) && (n.webkit = !0), n.opr && (r.browser = "opera", n.opera = !0), n.safari && (n.blackberry || n.bb ? (r.browser = "blackberry", n.blackberry = !0) : n.playbook ? (r.browser = "playbook", n.playbook = !0) : n.android ? (r.browser = "android", n.android = !0) : n.kindle ? (r.browser = "kindle", n.kindle = !0) : n.silk && (r.browser = "silk", n.silk = !0)), n.name = r.browser, n.platform = r.platform, t.indexOf("electron") !== -1) n.electron = !0;
    else if (document.location.href.indexOf("-extension://") !== -1) n.bex = !0;
    else {
        if (window.Capacitor !== void 0 ? (n.capacitor = !0, n.nativeMobile = !0, n.nativeMobileWrapper = "capacitor") : (window._cordovaNative !== void 0 || window.cordova !== void 0) && (n.cordova = !0, n.nativeMobile = !0, n.nativeMobileWrapper = "cordova"), $848b1ce88e755b32$var$bt.value === !0 && ($848b1ce88e755b32$var$js = {
            is: {
                ...n
            }
        }), $848b1ce88e755b32$var$Id === !0 && n.mac === !0 && (n.desktop === !0 && n.safari === !0 || n.nativeMobile === !0 && n.android !== !0 && n.ios !== !0 && n.ipad !== !0)) {
            delete n.mac, delete n.desktop;
            let a = Math.min(window.innerHeight, window.innerWidth) > 414 ? "ipad" : "iphone";
            Object.assign(n, {
                mobile: !0,
                ios: !0,
                platform: a,
                [a]: !0
            });
        }
        n.mobile !== !0 && window.navigator.userAgentData && window.navigator.userAgentData.mobile && (delete n.desktop, n.mobile = !0);
    }
    return n;
}
var $848b1ce88e755b32$var$Od = navigator.userAgent || navigator.vendor || window.opera, $848b1ce88e755b32$var$M0 = {
    has: {
        touch: !1,
        webStorage: !1
    },
    within: {
        iframe: !1
    }
}, $848b1ce88e755b32$var$Ce = {
    userAgent: $848b1ce88e755b32$var$Od,
    is: $848b1ce88e755b32$var$T0($848b1ce88e755b32$var$Od),
    has: {
        touch: $848b1ce88e755b32$var$Id
    },
    within: {
        iframe: window.self !== window.top
    }
}, $848b1ce88e755b32$var$Us = {
    install (e) {
        let { $q: t } = e;
        $848b1ce88e755b32$var$bt.value === !0 ? (e.onSSRHydrated.push(()=>{
            Object.assign(t.platform, $848b1ce88e755b32$var$Ce), $848b1ce88e755b32$var$bt.value = !1;
        }), t.platform = (0, $eayOh.reactive)(this)) : t.platform = this;
    }
};
{
    let e;
    $848b1ce88e755b32$var$it($848b1ce88e755b32$var$Ce.has, "webStorage", ()=>{
        if (e !== void 0) return e;
        try {
            if (window.localStorage) return e = !0, !0;
        } catch  {}
        return e = !1, !1;
    }), Object.assign($848b1ce88e755b32$var$Us, $848b1ce88e755b32$var$Ce), $848b1ce88e755b32$var$bt.value === !0 && (Object.assign($848b1ce88e755b32$var$Us, $848b1ce88e755b32$var$js, $848b1ce88e755b32$var$M0), $848b1ce88e755b32$var$js = null);
}var $848b1ce88e755b32$export$2dffd0b5373a4389 = $848b1ce88e755b32$var$Us;
function $848b1ce88e755b32$var$R(e) {
    return (0, $eayOh.markRaw)((0, $fVLUl.defineComponent)(e));
}
function $848b1ce88e755b32$var$Mt(e) {
    return (0, $eayOh.markRaw)(e);
}
var $848b1ce88e755b32$var$Xt = (e, t)=>{
    let o = (0, $eayOh.reactive)(e);
    for(let r in e)$848b1ce88e755b32$var$it(t, r, ()=>o[r], (n)=>{
        o[r] = n;
    });
    return t;
};
var $848b1ce88e755b32$var$Xe = {
    hasPassive: !1,
    passiveCapture: !0,
    notPassiveCapture: !0
};
try {
    let e = Object.defineProperty({}, "passive", {
        get () {
            Object.assign($848b1ce88e755b32$var$Xe, {
                hasPassive: !0,
                passive: {
                    passive: !0
                },
                notPassive: {
                    passive: !1
                },
                passiveCapture: {
                    passive: !0,
                    capture: !0
                },
                notPassiveCapture: {
                    passive: !1,
                    capture: !0
                }
            });
        }
    });
    window.addEventListener("qtest", null, e), window.removeEventListener("qtest", null, e);
} catch  {}
function $848b1ce88e755b32$export$8793edee2d425525() {}
function $848b1ce88e755b32$var$Tn(e) {
    return e.button === 0;
}
function $848b1ce88e755b32$var$A0(e) {
    return e.button === 1;
}
function $848b1ce88e755b32$var$$0(e) {
    return e.button === 2;
}
function $848b1ce88e755b32$var$yt(e) {
    return e.touches && e.touches[0] ? e = e.touches[0] : e.changedTouches && e.changedTouches[0] ? e = e.changedTouches[0] : e.targetTouches && e.targetTouches[0] && (e = e.targetTouches[0]), {
        top: e.clientY,
        left: e.clientX
    };
}
function $848b1ce88e755b32$var$Ks(e) {
    if (e.path) return e.path;
    if (e.composedPath) return e.composedPath();
    let t = [], o = e.target;
    for(; o;){
        if (t.push(o), o.tagName === "HTML") return t.push(document), t.push(window), t;
        o = o.parentElement;
    }
}
var $848b1ce88e755b32$var$E0 = 40, $848b1ce88e755b32$var$B0 = 800;
function $848b1ce88e755b32$var$L0(e) {
    let t = e.deltaX, o = e.deltaY;
    if ((t || o) && e.deltaMode) {
        let r = e.deltaMode === 1 ? $848b1ce88e755b32$var$E0 : $848b1ce88e755b32$var$B0;
        t *= r, o *= r;
    }
    return e.shiftKey && !t && ([o, t] = [
        t,
        o
    ]), {
        x: t,
        y: o
    };
}
function $848b1ce88e755b32$var$tt(e) {
    e.stopPropagation();
}
function $848b1ce88e755b32$var$ut(e) {
    e.cancelable !== !1 && e.preventDefault();
}
function $848b1ce88e755b32$var$Se(e) {
    e.cancelable !== !1 && e.preventDefault(), e.stopPropagation();
}
function $848b1ce88e755b32$var$Mn(e, t) {
    if (e === void 0 || t === !0 && e.__dragPrevented === !0) return;
    let o = t === !0 ? (r)=>{
        r.__dragPrevented = !0, r.addEventListener("dragstart", $848b1ce88e755b32$var$ut, $848b1ce88e755b32$var$Xe.notPassiveCapture);
    } : (r)=>{
        delete r.__dragPrevented, r.removeEventListener("dragstart", $848b1ce88e755b32$var$ut, $848b1ce88e755b32$var$Xe.notPassiveCapture);
    };
    e.querySelectorAll("a, img").forEach(o);
}
function $848b1ce88e755b32$var$lt(e, t, o) {
    let r = `__q_${t}_evt`;
    e[r] = e[r] !== void 0 ? e[r].concat(o) : o, o.forEach((n)=>{
        n[0].addEventListener(n[1], e[n[2]], $848b1ce88e755b32$var$Xe[n[3]]);
    });
}
function $848b1ce88e755b32$var$Ct(e, t) {
    let o = `__q_${t}_evt`;
    e[o] !== void 0 && (e[o].forEach((r)=>{
        r[0].removeEventListener(r[1], e[r[2]], $848b1ce88e755b32$var$Xe[r[3]]);
    }), e[o] = void 0);
}
var $848b1ce88e755b32$export$6cd530ed55e06764 = {
    listenOpts: $848b1ce88e755b32$var$Xe,
    leftClick: $848b1ce88e755b32$var$Tn,
    middleClick: $848b1ce88e755b32$var$A0,
    rightClick: $848b1ce88e755b32$var$$0,
    position: $848b1ce88e755b32$var$yt,
    getEventPath: $848b1ce88e755b32$var$Ks,
    getMouseWheelDistance: $848b1ce88e755b32$var$L0,
    stop: $848b1ce88e755b32$var$tt,
    prevent: $848b1ce88e755b32$var$ut,
    stopAndPrevent: $848b1ce88e755b32$var$Se,
    preventDraggable: $848b1ce88e755b32$var$Mn
};
function $848b1ce88e755b32$export$61fc7d43ac8f84b0(e, t = 250, o) {
    let r = null;
    function n() {
        let i = arguments, a = ()=>{
            r = null, o !== !0 && e.apply(this, i);
        };
        r !== null ? clearTimeout(r) : o === !0 && e.apply(this, i), r = setTimeout(a, t);
    }
    return n.cancel = ()=>{
        r !== null && clearTimeout(r);
    }, n;
}
var $848b1ce88e755b32$var$Ws = [
    "sm",
    "md",
    "lg",
    "xl"
], { passive: $848b1ce88e755b32$var$Nd } = $848b1ce88e755b32$var$Xe, $848b1ce88e755b32$export$a98515d67472a41f = $848b1ce88e755b32$var$Xt({
    width: 0,
    height: 0,
    name: "xs",
    sizes: {
        sm: 600,
        md: 1024,
        lg: 1440,
        xl: 1920
    },
    lt: {
        sm: !0,
        md: !0,
        lg: !0,
        xl: !0
    },
    gt: {
        xs: !1,
        sm: !1,
        md: !1,
        lg: !1
    },
    xs: !0,
    sm: !1,
    md: !1,
    lg: !1,
    xl: !1
}, {
    setSizes: $848b1ce88e755b32$export$8793edee2d425525,
    setDebounce: $848b1ce88e755b32$export$8793edee2d425525,
    install ({ $q: e, onSSRHydrated: t }) {
        if (e.screen = this, this.__installed === !0) {
            e.config.screen !== void 0 && (e.config.screen.bodyClasses === !1 ? document.body.classList.remove(`screen--${this.name}`) : this.__update(!0));
            return;
        }
        let { visualViewport: o } = window, r = o || window, n = document.scrollingElement || document.documentElement, i = o === void 0 || $848b1ce88e755b32$var$Ce.is.mobile === !0 ? ()=>[
                Math.max(window.innerWidth, n.clientWidth),
                Math.max(window.innerHeight, n.clientHeight)
            ] : ()=>[
                o.width * o.scale + window.innerWidth - n.clientWidth,
                o.height * o.scale + window.innerHeight - n.clientHeight
            ], a = e.config.screen !== void 0 && e.config.screen.bodyClasses === !0;
        this.__update = (v)=>{
            let [f, d] = i();
            if (d !== this.height && (this.height = d), f !== this.width) this.width = f;
            else if (v !== !0) return;
            let m = this.sizes;
            this.gt.xs = f >= m.sm, this.gt.sm = f >= m.md, this.gt.md = f >= m.lg, this.gt.lg = f >= m.xl, this.lt.sm = f < m.sm, this.lt.md = f < m.md, this.lt.lg = f < m.lg, this.lt.xl = f < m.xl, this.xs = this.lt.sm, this.sm = this.gt.xs === !0 && this.lt.md === !0, this.md = this.gt.sm === !0 && this.lt.lg === !0, this.lg = this.gt.md === !0 && this.lt.xl === !0, this.xl = this.gt.lg, m = this.xs === !0 && "xs" || this.sm === !0 && "sm" || this.md === !0 && "md" || this.lg === !0 && "lg" || "xl", m !== this.name && (a === !0 && (document.body.classList.remove(`screen--${this.name}`), document.body.classList.add(`screen--${m}`)), this.name = m);
        };
        let l, s = {}, c = 16;
        this.setSizes = (v)=>{
            $848b1ce88e755b32$var$Ws.forEach((f)=>{
                v[f] !== void 0 && (s[f] = v[f]);
            });
        }, this.setDebounce = (v)=>{
            c = v;
        };
        let u = ()=>{
            let v = getComputedStyle(document.body);
            v.getPropertyValue("--q-size-sm") && $848b1ce88e755b32$var$Ws.forEach((f)=>{
                this.sizes[f] = parseInt(v.getPropertyValue(`--q-size-${f}`), 10);
            }), this.setSizes = (f)=>{
                $848b1ce88e755b32$var$Ws.forEach((d)=>{
                    f[d] && (this.sizes[d] = f[d]);
                }), this.__update(!0);
            }, this.setDebounce = (f)=>{
                l !== void 0 && r.removeEventListener("resize", l, $848b1ce88e755b32$var$Nd), l = f > 0 ? $848b1ce88e755b32$export$61fc7d43ac8f84b0(this.__update, f) : this.__update, r.addEventListener("resize", l, $848b1ce88e755b32$var$Nd);
            }, this.setDebounce(c), Object.keys(s).length !== 0 ? (this.setSizes(s), s = void 0) : this.__update(), a === !0 && this.name === "xs" && document.body.classList.add("screen--xs");
        };
        $848b1ce88e755b32$var$bt.value === !0 ? t.push(u) : u();
    }
});
var $848b1ce88e755b32$var$Gt = $848b1ce88e755b32$var$Xt({
    isActive: !1,
    mode: !1
}, {
    __media: void 0,
    set (e) {
        $848b1ce88e755b32$var$Gt.mode = e, e === "auto" ? ($848b1ce88e755b32$var$Gt.__media === void 0 && ($848b1ce88e755b32$var$Gt.__media = window.matchMedia("(prefers-color-scheme: dark)"), $848b1ce88e755b32$var$Gt.__updateMedia = ()=>{
            $848b1ce88e755b32$var$Gt.set("auto");
        }, $848b1ce88e755b32$var$Gt.__media.addListener($848b1ce88e755b32$var$Gt.__updateMedia)), e = $848b1ce88e755b32$var$Gt.__media.matches) : $848b1ce88e755b32$var$Gt.__media !== void 0 && ($848b1ce88e755b32$var$Gt.__media.removeListener($848b1ce88e755b32$var$Gt.__updateMedia), $848b1ce88e755b32$var$Gt.__media = void 0), $848b1ce88e755b32$var$Gt.isActive = e === !0, document.body.classList.remove(`body--${e === !0 ? "light" : "dark"}`), document.body.classList.add(`body--${e === !0 ? "dark" : "light"}`);
    },
    toggle () {
        $848b1ce88e755b32$var$Gt.set($848b1ce88e755b32$var$Gt.isActive === !1);
    },
    install ({ $q: e, ssrContext: t }) {
        let { dark: o } = e.config;
        e.dark = this, this.__installed !== !0 && this.set(o !== void 0 ? o : !1);
    }
}), $848b1ce88e755b32$export$ef445a9602a9971f = $848b1ce88e755b32$var$Gt;
function $848b1ce88e755b32$export$e1eed9727d6445a7(e, t, o = document.body) {
    if (typeof e != "string") throw new TypeError("Expected a string as propName");
    if (typeof t != "string") throw new TypeError("Expected a string as value");
    if (!(o instanceof Element)) throw new TypeError("Expected a DOM element");
    o.style.setProperty(`--q-${e}`, t);
}
var $848b1ce88e755b32$var$Qd = !1;
function $848b1ce88e755b32$var$jd(e) {
    $848b1ce88e755b32$var$Qd = e.isComposing === !0;
}
function $848b1ce88e755b32$var$xo(e) {
    return $848b1ce88e755b32$var$Qd === !0 || e !== Object(e) || e.isComposing === !0 || e.qKeyEvent === !0;
}
function $848b1ce88e755b32$var$wt(e, t) {
    return $848b1ce88e755b32$var$xo(e) === !0 ? !1 : [].concat(t).includes(e.keyCode);
}
function $848b1ce88e755b32$var$Ud(e) {
    if (e.ios === !0) return "ios";
    if (e.android === !0) return "android";
}
function $848b1ce88e755b32$var$D0({ is: e, has: t, within: o }, r) {
    let n = [
        e.desktop === !0 ? "desktop" : "mobile",
        `${t.touch === !1 ? "no-" : ""}touch`
    ];
    if (e.mobile === !0) {
        let i = $848b1ce88e755b32$var$Ud(e);
        i !== void 0 && n.push("platform-" + i);
    }
    if (e.nativeMobile === !0) {
        let i = e.nativeMobileWrapper;
        n.push(i), n.push("native-mobile"), e.ios === !0 && (r[i] === void 0 || r[i].iosStatusBarPadding !== !1) && n.push("q-ios-padding");
    } else e.electron === !0 ? n.push("electron") : e.bex === !0 && n.push("bex");
    return o.iframe === !0 && n.push("within-iframe"), n;
}
function $848b1ce88e755b32$var$V0() {
    let { is: e } = $848b1ce88e755b32$var$Ce, t = document.body.className, o = new Set(t.replace(/ {2}/g, " ").split(" "));
    if (e.nativeMobile !== !0 && e.electron !== !0 && e.bex !== !0) {
        if (e.desktop === !0) o.delete("mobile"), o.delete("platform-ios"), o.delete("platform-android"), o.add("desktop");
        else if (e.mobile === !0) {
            o.delete("desktop"), o.add("mobile"), o.delete("platform-ios"), o.delete("platform-android");
            let n = $848b1ce88e755b32$var$Ud(e);
            n !== void 0 && o.add(`platform-${n}`);
        }
    }
    $848b1ce88e755b32$var$Ce.has.touch === !0 && (o.delete("no-touch"), o.add("touch")), $848b1ce88e755b32$var$Ce.within.iframe === !0 && o.add("within-iframe");
    let r = Array.from(o).join(" ");
    t !== r && (document.body.className = r);
}
function $848b1ce88e755b32$var$z0(e) {
    for(let t in e)$848b1ce88e755b32$export$e1eed9727d6445a7(t, e[t]);
}
var $848b1ce88e755b32$var$Kd = {
    install (e) {
        if (this.__installed !== !0) {
            if ($848b1ce88e755b32$var$bt.value === !0) $848b1ce88e755b32$var$V0();
            else {
                let { $q: t } = e;
                t.config.brand !== void 0 && $848b1ce88e755b32$var$z0(t.config.brand);
                let o = $848b1ce88e755b32$var$D0($848b1ce88e755b32$var$Ce, t.config);
                document.body.classList.add.apply(document.body.classList, o);
            }
            $848b1ce88e755b32$var$Ce.is.ios === !0 && document.body.addEventListener("touchstart", $848b1ce88e755b32$export$8793edee2d425525), window.addEventListener("keydown", $848b1ce88e755b32$var$jd, !0);
        }
    }
};
var $848b1ce88e755b32$var$Wd = ()=>!0;
function $848b1ce88e755b32$var$O0(e) {
    return typeof e == "string" && e !== "" && e !== "/" && e !== "#/";
}
function $848b1ce88e755b32$var$I0(e) {
    return e.startsWith("#") === !0 && (e = e.substring(1)), e.startsWith("/") === !1 && (e = "/" + e), e.endsWith("/") === !0 && (e = e.substring(0, e.length - 1)), "#" + e;
}
function $848b1ce88e755b32$var$H0(e) {
    if (e.backButtonExit === !1) return ()=>!1;
    if (e.backButtonExit === "*") return $848b1ce88e755b32$var$Wd;
    let t = [
        "#/"
    ];
    return Array.isArray(e.backButtonExit) === !0 && t.push(...e.backButtonExit.filter($848b1ce88e755b32$var$O0).map($848b1ce88e755b32$var$I0)), ()=>t.includes(window.location.hash);
}
var $848b1ce88e755b32$var$Un = {
    __history: [],
    add: $848b1ce88e755b32$export$8793edee2d425525,
    remove: $848b1ce88e755b32$export$8793edee2d425525,
    install ({ $q: e }) {
        if (this.__installed === !0) return;
        let { cordova: t, capacitor: o } = $848b1ce88e755b32$var$Ce.is;
        if (t !== !0 && o !== !0) return;
        let r = e.config[t === !0 ? "cordova" : "capacitor"];
        if (r !== void 0 && r.backButton === !1 || o === !0 && (window.Capacitor === void 0 || window.Capacitor.Plugins.App === void 0)) return;
        this.add = (a)=>{
            a.condition === void 0 && (a.condition = $848b1ce88e755b32$var$Wd), this.__history.push(a);
        }, this.remove = (a)=>{
            let l = this.__history.indexOf(a);
            l >= 0 && this.__history.splice(l, 1);
        };
        let n = $848b1ce88e755b32$var$H0(Object.assign({
            backButtonExit: !0
        }, r)), i = ()=>{
            if (this.__history.length) {
                let a = this.__history[this.__history.length - 1];
                a.condition() === !0 && (this.__history.pop(), a.handler());
            } else n() === !0 ? navigator.app.exitApp() : window.history.back();
        };
        t === !0 ? document.addEventListener("deviceready", ()=>{
            document.addEventListener("backbutton", i, !1);
        }) : window.Capacitor.Plugins.App.addListener("backButton", i);
    }
};
var $848b1ce88e755b32$var$qa = $848b1ce88e755b32$var$zd($848b1ce88e755b32$var$Xd());
function $848b1ce88e755b32$var$Gd() {
    let e = Array.isArray(navigator.languages) === !0 && navigator.languages.length !== 0 ? navigator.languages[0] : navigator.language;
    if (typeof e == "string") return e.split(/[-_]/).map((t, o)=>o === 0 ? t.toLowerCase() : o > 1 || t.length < 4 ? t.toUpperCase() : t[0].toUpperCase() + t.slice(1).toLowerCase()).join("-");
}
var $848b1ce88e755b32$var$kr = $848b1ce88e755b32$var$Xt({
    __qLang: {}
}, {
    getLocale: $848b1ce88e755b32$var$Gd,
    set (e = $848b1ce88e755b32$var$qa.default, t) {
        let o = {
            ...e,
            rtl: e.rtl === !0,
            getLocale: $848b1ce88e755b32$var$Gd
        };
        if (o.set = $848b1ce88e755b32$var$kr.set, $848b1ce88e755b32$var$kr.__langConfig === void 0 || $848b1ce88e755b32$var$kr.__langConfig.noHtmlAttrs !== !0) {
            let r = document.documentElement;
            r.setAttribute("dir", o.rtl === !0 ? "rtl" : "ltr"), r.setAttribute("lang", o.isoName);
        }
        Object.assign($848b1ce88e755b32$var$kr.__qLang, o);
    },
    install ({ $q: e, lang: t, ssrContext: o }) {
        e.lang = $848b1ce88e755b32$var$kr.__qLang, $848b1ce88e755b32$var$kr.__langConfig = e.config.lang, this.__installed === !0 ? t !== void 0 && this.set(t) : (this.props = new Proxy(this.__qLang, {
            get () {
                return Reflect.get(...arguments);
            },
            ownKeys (r) {
                return Reflect.ownKeys(r).filter((n)=>n !== "set" && n !== "getLocale");
            }
        }), this.set(t || $848b1ce88e755b32$var$qa.default));
    }
}), $848b1ce88e755b32$export$8a4528ea5590497a = $848b1ce88e755b32$var$kr;
var $848b1ce88e755b32$var$ef = $848b1ce88e755b32$var$zd($848b1ce88e755b32$var$Jd()), $848b1ce88e755b32$var$Gs = $848b1ce88e755b32$var$Xt({
    iconMapFn: null,
    __qIconSet: {}
}, {
    set (e, t) {
        let o = {
            ...e
        };
        o.set = $848b1ce88e755b32$var$Gs.set, Object.assign($848b1ce88e755b32$var$Gs.__qIconSet, o);
    },
    install ({ $q: e, iconSet: t, ssrContext: o }) {
        e.config.iconMapFn !== void 0 && (this.iconMapFn = e.config.iconMapFn), e.iconSet = this.__qIconSet, $848b1ce88e755b32$var$it(e, "iconMapFn", ()=>this.iconMapFn, (r)=>{
            this.iconMapFn = r;
        }), this.__installed === !0 ? t !== void 0 && this.set(t) : (this.props = new Proxy(this.__qIconSet, {
            get () {
                return Reflect.get(...arguments);
            },
            ownKeys (r) {
                return Reflect.ownKeys(r).filter((n)=>n !== "set");
            }
        }), this.set(t || $848b1ce88e755b32$var$ef.default));
    }
}), $848b1ce88e755b32$export$c0faf18b76ac5204 = $848b1ce88e755b32$var$Gs;
var $848b1ce88e755b32$var$_l = "_q_", $848b1ce88e755b32$var$Cl = "_q_t_", $848b1ce88e755b32$var$wl = "_q_s_", $848b1ce88e755b32$var$co = "_q_l_", $848b1ce88e755b32$var$kl = "_q_pc_", $848b1ce88e755b32$var$ql = "_q_f_", $848b1ce88e755b32$var$Rn = "_q_fo_", $848b1ce88e755b32$var$Tl = "_q_tabs_", $848b1ce88e755b32$var$Ml = "_q_u_";
function $848b1ce88e755b32$var$Ye() {}
var $848b1ce88e755b32$var$ni = {}, $848b1ce88e755b32$var$Zs = !1;
function $848b1ce88e755b32$var$tf() {
    $848b1ce88e755b32$var$Zs = !0;
}
function $848b1ce88e755b32$var$Zt(e, t) {
    if (e === t) return !0;
    if (e !== null && t !== null && typeof e == "object" && typeof t == "object") {
        if (e.constructor !== t.constructor) return !1;
        let o, r;
        if (e.constructor === Array) {
            if (o = e.length, o !== t.length) return !1;
            for(r = o; r-- !== 0;)if ($848b1ce88e755b32$var$Zt(e[r], t[r]) !== !0) return !1;
            return !0;
        }
        if (e.constructor === Map) {
            if (e.size !== t.size) return !1;
            let i = e.entries();
            for(r = i.next(); r.done !== !0;){
                if (t.has(r.value[0]) !== !0) return !1;
                r = i.next();
            }
            for(i = e.entries(), r = i.next(); r.done !== !0;){
                if ($848b1ce88e755b32$var$Zt(r.value[1], t.get(r.value[0])) !== !0) return !1;
                r = i.next();
            }
            return !0;
        }
        if (e.constructor === Set) {
            if (e.size !== t.size) return !1;
            let i = e.entries();
            for(r = i.next(); r.done !== !0;){
                if (t.has(r.value[0]) !== !0) return !1;
                r = i.next();
            }
            return !0;
        }
        if (e.buffer != null && e.buffer.constructor === ArrayBuffer) {
            if (o = e.length, o !== t.length) return !1;
            for(r = o; r-- !== 0;)if (e[r] !== t[r]) return !1;
            return !0;
        }
        if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
        if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
        if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
        let n = Object.keys(e).filter((i)=>e[i] !== void 0);
        if (o = n.length, o !== Object.keys(t).filter((i)=>t[i] !== void 0).length) return !1;
        for(r = o; r-- !== 0;){
            let i = n[r];
            if ($848b1ce88e755b32$var$Zt(e[i], t[i]) !== !0) return !1;
        }
        return !0;
    }
    return e !== e && t !== t;
}
function $848b1ce88e755b32$var$at(e) {
    return e !== null && typeof e == "object" && Array.isArray(e) !== !0;
}
function $848b1ce88e755b32$var$Pn(e) {
    return Object.prototype.toString.call(e) === "[object Date]";
}
function $848b1ce88e755b32$var$Js(e) {
    return Object.prototype.toString.call(e) === "[object RegExp]";
}
function $848b1ce88e755b32$var$Mo(e) {
    return typeof e == "number" && isFinite(e);
}
var $848b1ce88e755b32$export$226b3eccf92c9ed9 = {
    deepEqual: $848b1ce88e755b32$var$Zt,
    object: $848b1ce88e755b32$var$at,
    date: $848b1ce88e755b32$var$Pn,
    regexp: $848b1ce88e755b32$var$Js,
    number: $848b1ce88e755b32$var$Mo
};
var $848b1ce88e755b32$var$of = [
    $848b1ce88e755b32$export$2dffd0b5373a4389,
    $848b1ce88e755b32$var$Kd,
    $848b1ce88e755b32$export$ef445a9602a9971f,
    $848b1ce88e755b32$export$a98515d67472a41f,
    $848b1ce88e755b32$var$Un,
    $848b1ce88e755b32$export$8a4528ea5590497a,
    $848b1ce88e755b32$export$c0faf18b76ac5204
];
function $848b1ce88e755b32$var$Wn(e, t) {
    let o = (0, $24349.createApp)(e);
    o.config.globalProperties = t.config.globalProperties;
    let { reload: r, ...n } = t._context;
    return Object.assign(o._context, n), o;
}
function $848b1ce88e755b32$var$nf(e, t) {
    t.forEach((o)=>{
        o.install(e), o.__installed = !0;
    });
}
function $848b1ce88e755b32$var$j0(e, t, o) {
    e.config.globalProperties.$q = o.$q, e.provide($848b1ce88e755b32$var$_l, o.$q), $848b1ce88e755b32$var$nf(o, $848b1ce88e755b32$var$of), t.components !== void 0 && Object.values(t.components).forEach((r)=>{
        $848b1ce88e755b32$var$at(r) === !0 && r.name !== void 0 && e.component(r.name, r);
    }), t.directives !== void 0 && Object.values(t.directives).forEach((r)=>{
        $848b1ce88e755b32$var$at(r) === !0 && r.name !== void 0 && e.directive(r.name, r);
    }), t.plugins !== void 0 && $848b1ce88e755b32$var$nf(o, Object.values(t.plugins).filter((r)=>typeof r.install == "function" && $848b1ce88e755b32$var$of.includes(r) === !1)), $848b1ce88e755b32$var$bt.value === !0 && (o.$q.onSSRHydrated = ()=>{
        o.onSSRHydrated.forEach((r)=>{
            r();
        }), o.$q.onSSRHydrated = ()=>{};
    });
}
var $848b1ce88e755b32$var$rf = function(e, t = {}) {
    let o = {
        version: "2.15.4"
    };
    $848b1ce88e755b32$var$Zs === !1 ? (t.config !== void 0 && Object.assign($848b1ce88e755b32$var$ni, t.config), o.config = {
        ...$848b1ce88e755b32$var$ni
    }, $848b1ce88e755b32$var$tf()) : o.config = t.config || {}, $848b1ce88e755b32$var$j0(e, t, {
        parentApp: e,
        $q: o,
        lang: t.lang,
        iconSet: t.iconSet,
        onSSRHydrated: []
    });
};
var $848b1ce88e755b32$var$Td = {};
$848b1ce88e755b32$var$Vd($848b1ce88e755b32$var$Td, {
    QAjaxBar: ()=>$848b1ce88e755b32$export$b18d87171d171ca9,
    QAvatar: ()=>$848b1ce88e755b32$export$f3774053158ba051,
    QBadge: ()=>$848b1ce88e755b32$export$73f24ecabf561a88,
    QBanner: ()=>$848b1ce88e755b32$export$388879c71c3c10cf,
    QBar: ()=>$848b1ce88e755b32$export$31ac01ac4236208c,
    QBreadcrumbs: ()=>$848b1ce88e755b32$export$88a7ba48108b3d90,
    QBreadcrumbsEl: ()=>$848b1ce88e755b32$export$488745943e252354,
    QBtn: ()=>$848b1ce88e755b32$export$72abad9388e88b7,
    QBtnDropdown: ()=>$848b1ce88e755b32$export$ed13f95342ac4309,
    QBtnGroup: ()=>$848b1ce88e755b32$export$ec40a025a653c83b,
    QBtnToggle: ()=>$848b1ce88e755b32$export$1e5c1ca50ee4d96c,
    QCard: ()=>$848b1ce88e755b32$export$866037ffbc2a7c62,
    QCardActions: ()=>$848b1ce88e755b32$export$8c05ea70037eac6a,
    QCardSection: ()=>$848b1ce88e755b32$export$653482776a1a6c98,
    QCarousel: ()=>$848b1ce88e755b32$export$ceb1843391966906,
    QCarouselControl: ()=>$848b1ce88e755b32$export$99b8110ff6b4a7c0,
    QCarouselSlide: ()=>$848b1ce88e755b32$export$18e00ae665ca0ca8,
    QChatMessage: ()=>$848b1ce88e755b32$export$f38b603ba263988,
    QCheckbox: ()=>$848b1ce88e755b32$export$a3430661ad019cfb,
    QChip: ()=>$848b1ce88e755b32$export$fe8abce8a0a972d6,
    QCircularProgress: ()=>$848b1ce88e755b32$export$3bbfcedf93eff7f7,
    QColor: ()=>$848b1ce88e755b32$export$32ed8655ecd274c2,
    QDate: ()=>$848b1ce88e755b32$export$599a443f7d1feef,
    QDialog: ()=>$848b1ce88e755b32$export$e6ccdac5fb3e2417,
    QDrawer: ()=>$848b1ce88e755b32$export$8bd189b8cd6124c2,
    QEditor: ()=>$848b1ce88e755b32$export$2107e7367505ec8a,
    QExpansionItem: ()=>$848b1ce88e755b32$export$eb8cb4fb55e6cd84,
    QFab: ()=>$848b1ce88e755b32$export$feca39a40ec06c6e,
    QFabAction: ()=>$848b1ce88e755b32$export$a1eb3675933e8b79,
    QField: ()=>$848b1ce88e755b32$export$9e1d68206b908513,
    QFile: ()=>$848b1ce88e755b32$export$f9762928c84dca74,
    QFooter: ()=>$848b1ce88e755b32$export$bf2298245c72b04b,
    QForm: ()=>$848b1ce88e755b32$export$1f74a2a6ec5f7e27,
    QFormChildMixin: ()=>$848b1ce88e755b32$export$4c671bf544af0ee8,
    QHeader: ()=>$848b1ce88e755b32$export$2dcc2a0b89cfff9b,
    QIcon: ()=>$848b1ce88e755b32$export$d56d6691b226e237,
    QImg: ()=>$848b1ce88e755b32$export$b76c0105a5546ea6,
    QInfiniteScroll: ()=>$848b1ce88e755b32$export$cc6e9b131bede082,
    QInnerLoading: ()=>$848b1ce88e755b32$export$d3667a9435d68192,
    QInput: ()=>$848b1ce88e755b32$export$b1c6a0c22e16b328,
    QIntersection: ()=>$848b1ce88e755b32$export$bfb6b34b3c68a45a,
    QItem: ()=>$848b1ce88e755b32$export$adf75769807ad87e,
    QItemLabel: ()=>$848b1ce88e755b32$export$17cb5eb1f3204256,
    QItemSection: ()=>$848b1ce88e755b32$export$9579d29612d4e773,
    QKnob: ()=>$848b1ce88e755b32$export$6c883daf6170407d,
    QLayout: ()=>$848b1ce88e755b32$export$c40af6af424a1775,
    QLinearProgress: ()=>$848b1ce88e755b32$export$2d10adb726183d68,
    QList: ()=>$848b1ce88e755b32$export$546da2cac02ecac2,
    QMarkupTable: ()=>$848b1ce88e755b32$export$96e16f0b01ad0bca,
    QMenu: ()=>$848b1ce88e755b32$export$73537802004a2118,
    QNoSsr: ()=>$848b1ce88e755b32$export$20500169d4287824,
    QOptionGroup: ()=>$848b1ce88e755b32$export$3ceb287b9597da0e,
    QPage: ()=>$848b1ce88e755b32$export$2739fb63d58d99fc,
    QPageContainer: ()=>$848b1ce88e755b32$export$c532236a32af6b2e,
    QPageScroller: ()=>$848b1ce88e755b32$export$757ee84fd3b4950f,
    QPageSticky: ()=>$848b1ce88e755b32$export$fb6e3b1b2833174c,
    QPagination: ()=>$848b1ce88e755b32$export$e0e0e4dfbf7cf819,
    QParallax: ()=>$848b1ce88e755b32$export$7edd9a653cb140a3,
    QPopupEdit: ()=>$848b1ce88e755b32$export$7a21aee2db893a36,
    QPopupProxy: ()=>$848b1ce88e755b32$export$8d66f956927c5a7b,
    QPullToRefresh: ()=>$848b1ce88e755b32$export$38ad2c7cb47d3fec,
    QRadio: ()=>$848b1ce88e755b32$export$339924d2c57b87f,
    QRange: ()=>$848b1ce88e755b32$export$396f1d127e5ea44f,
    QRating: ()=>$848b1ce88e755b32$export$97d378c58b81b163,
    QResizeObserver: ()=>$848b1ce88e755b32$export$614f53fe102a3da7,
    QResponsive: ()=>$848b1ce88e755b32$export$9f7ab13694915fcc,
    QRouteTab: ()=>$848b1ce88e755b32$export$fc20573fc4d541d2,
    QScrollArea: ()=>$848b1ce88e755b32$export$6c88fb8d3b5e5b80,
    QScrollObserver: ()=>$848b1ce88e755b32$export$d6d34850bd31dad,
    QSelect: ()=>$848b1ce88e755b32$export$c6f171932ae1be1a,
    QSeparator: ()=>$848b1ce88e755b32$export$a3fe6e564278fbe9,
    QSkeleton: ()=>$848b1ce88e755b32$export$c03597c5c32a1b2c,
    QSlideItem: ()=>$848b1ce88e755b32$export$4b0d074f5c781fdc,
    QSlideTransition: ()=>$848b1ce88e755b32$export$1712cdc175d4649d,
    QSlider: ()=>$848b1ce88e755b32$export$eccd46d4261ec748,
    QSpace: ()=>$848b1ce88e755b32$export$e2e812bf9ee33e1a,
    QSpinner: ()=>$848b1ce88e755b32$export$7418ab329b11fed0,
    QSpinnerAudio: ()=>$848b1ce88e755b32$export$65a05f088d8e2ad5,
    QSpinnerBall: ()=>$848b1ce88e755b32$export$bccad2bfd65ba3b3,
    QSpinnerBars: ()=>$848b1ce88e755b32$export$4a50726b08ffdead,
    QSpinnerBox: ()=>$848b1ce88e755b32$export$dca5c45bff96781d,
    QSpinnerClock: ()=>$848b1ce88e755b32$export$ecf55558d357e9b2,
    QSpinnerComment: ()=>$848b1ce88e755b32$export$6e35813dfe5ed5df,
    QSpinnerCube: ()=>$848b1ce88e755b32$export$6a272c7550b80d16,
    QSpinnerDots: ()=>$848b1ce88e755b32$export$d62eca58f8bab60f,
    QSpinnerFacebook: ()=>$848b1ce88e755b32$export$bf634d821185ef2f,
    QSpinnerGears: ()=>$848b1ce88e755b32$export$d13dda2748f0ba28,
    QSpinnerGrid: ()=>$848b1ce88e755b32$export$ba3edcdf00657f3b,
    QSpinnerHearts: ()=>$848b1ce88e755b32$export$cb77d8a2fc9a1a83,
    QSpinnerHourglass: ()=>$848b1ce88e755b32$export$44b7dee4e71f51cd,
    QSpinnerInfinity: ()=>$848b1ce88e755b32$export$b71cd080434d9a8a,
    QSpinnerIos: ()=>$848b1ce88e755b32$export$77e9349f3d025ec0,
    QSpinnerOrbit: ()=>$848b1ce88e755b32$export$a97e088b3d2632d,
    QSpinnerOval: ()=>$848b1ce88e755b32$export$36a3d935578134a2,
    QSpinnerPie: ()=>$848b1ce88e755b32$export$e6f3833977eceb50,
    QSpinnerPuff: ()=>$848b1ce88e755b32$export$56d4f370365c4ec9,
    QSpinnerRadio: ()=>$848b1ce88e755b32$export$7734a351fc7fed9d,
    QSpinnerRings: ()=>$848b1ce88e755b32$export$6d6e0a9951cccd21,
    QSpinnerTail: ()=>$848b1ce88e755b32$export$87ed3277eacd506,
    QSplitter: ()=>$848b1ce88e755b32$export$e24eb95a687f22c5,
    QStep: ()=>$848b1ce88e755b32$export$973d42224d50092f,
    QStepper: ()=>$848b1ce88e755b32$export$9b249c4f2312b48e,
    QStepperNavigation: ()=>$848b1ce88e755b32$export$ccae125a3a1bd01f,
    QTab: ()=>$848b1ce88e755b32$export$39ade007f653a559,
    QTabPanel: ()=>$848b1ce88e755b32$export$a513456409dea750,
    QTabPanels: ()=>$848b1ce88e755b32$export$305a5380acbec321,
    QTable: ()=>$848b1ce88e755b32$export$27fbdc739212cd86,
    QTabs: ()=>$848b1ce88e755b32$export$f3e10d2f5515bdea,
    QTd: ()=>$848b1ce88e755b32$export$f8a8c02d3a86d0c6,
    QTh: ()=>$848b1ce88e755b32$export$f3b568562ea6363f,
    QTime: ()=>$848b1ce88e755b32$export$75b50612c5275613,
    QTimeline: ()=>$848b1ce88e755b32$export$aaf1acdf549e0e8f,
    QTimelineEntry: ()=>$848b1ce88e755b32$export$d0a3fbd020401544,
    QToggle: ()=>$848b1ce88e755b32$export$16e415cb3321864c,
    QToolbar: ()=>$848b1ce88e755b32$export$9cfe29ba9f08864a,
    QToolbarTitle: ()=>$848b1ce88e755b32$export$dbcf6fec4996856c,
    QTooltip: ()=>$848b1ce88e755b32$export$b4dba0bbe7f6a787,
    QTr: ()=>$848b1ce88e755b32$export$eb796db58a736f8f,
    QTree: ()=>$848b1ce88e755b32$export$6ac73dd07dbdca3b,
    QUploader: ()=>$848b1ce88e755b32$export$fb96d5a0acebf1f,
    QUploaderAddTrigger: ()=>$848b1ce88e755b32$export$6029b08fdeeb477,
    QVideo: ()=>$848b1ce88e755b32$export$a88d736580abbe,
    QVirtualScroll: ()=>$848b1ce88e755b32$export$e23e912583dc74c1
});
var $848b1ce88e755b32$var$af = [
    "B",
    "KB",
    "MB",
    "GB",
    "TB",
    "PB"
];
function $848b1ce88e755b32$var$ri(e, t = 1) {
    let o = 0;
    for(; parseInt(e, 10) >= 1024 && o < $848b1ce88e755b32$var$af.length - 1;)e /= 1024, ++o;
    return `${e.toFixed(t)}${$848b1ce88e755b32$var$af[o]}`;
}
function $848b1ce88e755b32$var$ec(e) {
    return e.charAt(0).toUpperCase() + e.slice(1);
}
function $848b1ce88e755b32$var$Ze(e, t, o) {
    return o <= t ? t : Math.min(o, Math.max(t, e));
}
function $848b1ce88e755b32$var$qr(e, t, o) {
    if (o <= t) return t;
    let r = o - t + 1, n = t + (e - t) % r;
    return n < t && (n = r + n), n === 0 ? 0 : n;
}
function $848b1ce88e755b32$var$Je(e, t = 2, o = "0") {
    if (e == null) return e;
    let r = "" + e;
    return r.length >= t ? r : new Array(t - r.length + 1).join(o) + r;
}
var $848b1ce88e755b32$export$d9468344d3651243 = {
    humanStorageSize: $848b1ce88e755b32$var$ri,
    capitalize: $848b1ce88e755b32$var$ec,
    between: $848b1ce88e755b32$var$Ze,
    normalizeToInterval: $848b1ce88e755b32$var$qr,
    pad: $848b1ce88e755b32$var$Je
};
var $848b1ce88e755b32$var$oc = XMLHttpRequest, $848b1ce88e755b32$var$lf = $848b1ce88e755b32$var$oc.prototype.open, $848b1ce88e755b32$var$G0 = [
    "top",
    "right",
    "bottom",
    "left"
], $848b1ce88e755b32$var$Rl = [], $848b1ce88e755b32$var$Ma = 0;
function $848b1ce88e755b32$var$Z0({ p: e, pos: t, active: o, horiz: r, reverse: n, dir: i }) {
    let a = 1, l = 1;
    return r === !0 ? (n === !0 && (a = -1), t === "bottom" && (l = -1), {
        transform: `translate3d(${a * (e - 100)}%,${o ? 0 : l * -200}%,0)`
    }) : (n === !0 && (l = -1), t === "right" && (a = -1), {
        transform: `translate3d(${o ? 0 : i * a * -200}%,${l * (e - 100)}%,0)`
    });
}
function $848b1ce88e755b32$var$J0(e, t) {
    return typeof t != "number" && (e < 25 ? t = Math.random() * 3 + 3 : e < 65 ? t = Math.random() * 3 : e < 85 ? t = Math.random() * 2 : e < 99 ? t = .6 : t = 0), $848b1ce88e755b32$var$Ze(e + t, 0, 100);
}
function $848b1ce88e755b32$var$eb(e) {
    $848b1ce88e755b32$var$Ma++, $848b1ce88e755b32$var$Rl.push(e), !($848b1ce88e755b32$var$Ma > 1) && ($848b1ce88e755b32$var$oc.prototype.open = function(t, o) {
        let r = [], n = ()=>{
            $848b1ce88e755b32$var$Rl.forEach((a)=>{
                (a.hijackFilter.value === null || a.hijackFilter.value(o) === !0) && (a.start(), r.push(a.stop));
            });
        }, i = ()=>{
            r.forEach((a)=>{
                a();
            });
        };
        this.addEventListener("loadstart", n, {
            once: !0
        }), this.addEventListener("loadend", i, {
            once: !0
        }), $848b1ce88e755b32$var$lf.apply(this, arguments);
    });
}
function $848b1ce88e755b32$var$tb(e) {
    $848b1ce88e755b32$var$Rl = $848b1ce88e755b32$var$Rl.filter((t)=>t.start !== e), $848b1ce88e755b32$var$Ma = Math.max(0, $848b1ce88e755b32$var$Ma - 1), $848b1ce88e755b32$var$Ma === 0 && ($848b1ce88e755b32$var$oc.prototype.open = $848b1ce88e755b32$var$lf);
}
var $848b1ce88e755b32$export$b18d87171d171ca9 = $848b1ce88e755b32$var$R({
    name: "QAjaxBar",
    props: {
        position: {
            type: String,
            default: "top",
            validator: (e)=>$848b1ce88e755b32$var$G0.includes(e)
        },
        size: {
            type: String,
            default: "2px"
        },
        color: String,
        skipHijack: Boolean,
        reverse: Boolean,
        hijackFilter: Function
    },
    emits: [
        "start",
        "stop"
    ],
    setup (e, { emit: t }) {
        let { proxy: o } = (0, $fVLUl.getCurrentInstance)(), r = (0, $eayOh.ref)(0), n = (0, $eayOh.ref)(!1), i = (0, $eayOh.ref)(!0), a = 0, l = null, s, c = (0, $eayOh.computed)(()=>`q-loading-bar q-loading-bar--${e.position}` + (e.color !== void 0 ? ` bg-${e.color}` : "") + (i.value === !0 ? "" : " no-transition")), u = (0, $eayOh.computed)(()=>e.position === "top" || e.position === "bottom"), v = (0, $eayOh.computed)(()=>u.value === !0 ? "height" : "width"), f = (0, $eayOh.computed)(()=>{
            let h = n.value, g = $848b1ce88e755b32$var$Z0({
                p: r.value,
                pos: e.position,
                active: h,
                horiz: u.value,
                reverse: o.$q.lang.rtl === !0 && [
                    "top",
                    "bottom"
                ].includes(e.position) ? e.reverse === !1 : e.reverse,
                dir: o.$q.lang.rtl === !0 ? -1 : 1
            });
            return g[v.value] = e.size, g.opacity = h ? 1 : 0, g;
        }), d = (0, $eayOh.computed)(()=>n.value === !0 ? {
                role: "progressbar",
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": r.value
            } : {
                "aria-hidden": "true"
            });
        function m(h = 300) {
            let g = s;
            return s = Math.max(0, h) || 0, a++, a > 1 ? (g === 0 && h > 0 ? C() : l !== null && g > 0 && h <= 0 && (clearTimeout(l), l = null), a) : (l !== null && clearTimeout(l), t("start"), r.value = 0, l = setTimeout(()=>{
                l = null, i.value = !0, h > 0 && C();
            }, n._value === !0 ? 500 : 1), n._value !== !0 && (n.value = !0, i.value = !1), a);
        }
        function y(h) {
            return a > 0 && (r.value = $848b1ce88e755b32$var$J0(r.value, h)), a;
        }
        function p() {
            if (a = Math.max(0, a - 1), a > 0) return a;
            l !== null && (clearTimeout(l), l = null), t("stop");
            let h = ()=>{
                i.value = !0, r.value = 100, l = setTimeout(()=>{
                    l = null, n.value = !1;
                }, 1e3);
            };
            return r.value === 0 ? l = setTimeout(h, 1) : h(), a;
        }
        function C() {
            r.value < 100 && (l = setTimeout(()=>{
                l = null, y(), C();
            }, s));
        }
        let b;
        return (0, $fVLUl.onMounted)(()=>{
            e.skipHijack !== !0 && (b = !0, $848b1ce88e755b32$var$eb({
                start: m,
                stop: p,
                hijackFilter: (0, $eayOh.computed)(()=>e.hijackFilter || null)
            }));
        }), (0, $fVLUl.onBeforeUnmount)(()=>{
            l !== null && clearTimeout(l), b === !0 && $848b1ce88e755b32$var$tb(m);
        }), Object.assign(o, {
            start: m,
            stop: p,
            increment: y
        }), ()=>(0, $fVLUl.h)("div", {
                class: c.value,
                style: f.value,
                ...d.value
            });
    }
});
var $848b1ce88e755b32$var$Al = {
    xs: 18,
    sm: 24,
    md: 32,
    lg: 38,
    xl: 46
}, $848b1ce88e755b32$var$Ot = {
    size: String
};
function $848b1ce88e755b32$var$It(e, t = $848b1ce88e755b32$var$Al) {
    return (0, $eayOh.computed)(()=>e.size !== void 0 ? {
            fontSize: e.size in t ? `${t[e.size]}px` : e.size
        } : null);
}
function $848b1ce88e755b32$var$J(e, t) {
    return e !== void 0 && e() || t;
}
function $848b1ce88e755b32$var$tn(e, t) {
    if (e !== void 0) {
        let o = e();
        if (o != null) return o.slice();
    }
    return t;
}
function $848b1ce88e755b32$var$Ke(e, t) {
    return e !== void 0 ? t.concat(e()) : t;
}
function $848b1ce88e755b32$var$ai(e, t) {
    return e === void 0 ? t : t !== void 0 ? t.concat(e()) : e();
}
function $848b1ce88e755b32$var$kt(e, t, o, r, n, i) {
    t.key = r + n;
    let a = (0, $fVLUl.h)(e, t, o);
    return n === !0 ? (0, $fVLUl.withDirectives)(a, i()) : a;
}
var $848b1ce88e755b32$var$sf = "0 0 24 24", $848b1ce88e755b32$var$cf = (e)=>e, $848b1ce88e755b32$var$nc = (e)=>`ionicons ${e}`, $848b1ce88e755b32$var$ff = {
    "mdi-": (e)=>`mdi ${e}`,
    "icon-": $848b1ce88e755b32$var$cf,
    "bt-": (e)=>`bt ${e}`,
    "eva-": (e)=>`eva ${e}`,
    "ion-md": $848b1ce88e755b32$var$nc,
    "ion-ios": $848b1ce88e755b32$var$nc,
    "ion-logo": $848b1ce88e755b32$var$nc,
    "iconfont ": $848b1ce88e755b32$var$cf,
    "ti-": (e)=>`themify-icon ${e}`,
    "bi-": (e)=>`bootstrap-icons ${e}`
}, $848b1ce88e755b32$var$mf = {
    o_: "-outlined",
    r_: "-round",
    s_: "-sharp"
}, $848b1ce88e755b32$var$vf = {
    sym_o_: "-outlined",
    sym_r_: "-rounded",
    sym_s_: "-sharp"
}, $848b1ce88e755b32$var$ab = new RegExp("^(" + Object.keys($848b1ce88e755b32$var$ff).join("|") + ")"), $848b1ce88e755b32$var$lb = new RegExp("^(" + Object.keys($848b1ce88e755b32$var$mf).join("|") + ")"), $848b1ce88e755b32$var$df = new RegExp("^(" + Object.keys($848b1ce88e755b32$var$vf).join("|") + ")"), $848b1ce88e755b32$var$ub = /^[Mm]\s?[-+]?\.?\d/, $848b1ce88e755b32$var$sb = /^img:/, $848b1ce88e755b32$var$cb = /^svguse:/, $848b1ce88e755b32$var$db = /^ion-/, $848b1ce88e755b32$var$fb = /^(fa-(sharp|solid|regular|light|brands|duotone|thin)|[lf]a[srlbdk]?) /, $848b1ce88e755b32$export$d56d6691b226e237 = $848b1ce88e755b32$var$R({
    name: "QIcon",
    props: {
        ...$848b1ce88e755b32$var$Ot,
        tag: {
            type: String,
            default: "i"
        },
        name: String,
        color: String,
        left: Boolean,
        right: Boolean
    },
    setup (e, { slots: t }) {
        let { proxy: { $q: o } } = (0, $fVLUl.getCurrentInstance)(), r = $848b1ce88e755b32$var$It(e), n = (0, $eayOh.computed)(()=>"q-icon" + (e.left === !0 ? " on-left" : "") + (e.right === !0 ? " on-right" : "") + (e.color !== void 0 ? ` text-${e.color}` : "")), i = (0, $eayOh.computed)(()=>{
            let a, l = e.name;
            if (l === "none" || !l) return {
                none: !0
            };
            if (o.iconMapFn !== null) {
                let u = o.iconMapFn(l);
                if (u !== void 0) {
                    if (u.icon !== void 0) {
                        if (l = u.icon, l === "none" || !l) return {
                            none: !0
                        };
                    } else return {
                        cls: u.cls,
                        content: u.content !== void 0 ? u.content : " "
                    };
                }
            }
            if ($848b1ce88e755b32$var$ub.test(l) === !0) {
                let [u, v = $848b1ce88e755b32$var$sf] = l.split("|");
                return {
                    svg: !0,
                    viewBox: v,
                    nodes: u.split("&&").map((f)=>{
                        let [d, m, y] = f.split("@@");
                        return (0, $fVLUl.h)("path", {
                            style: m,
                            d: d,
                            transform: y
                        });
                    })
                };
            }
            if ($848b1ce88e755b32$var$sb.test(l) === !0) return {
                img: !0,
                src: l.substring(4)
            };
            if ($848b1ce88e755b32$var$cb.test(l) === !0) {
                let [u, v = $848b1ce88e755b32$var$sf] = l.split("|");
                return {
                    svguse: !0,
                    src: u.substring(7),
                    viewBox: v
                };
            }
            let s = " ", c = l.match($848b1ce88e755b32$var$ab);
            if (c !== null) a = $848b1ce88e755b32$var$ff[c[1]](l);
            else if ($848b1ce88e755b32$var$fb.test(l) === !0) a = l;
            else if ($848b1ce88e755b32$var$db.test(l) === !0) a = `ionicons ion-${o.platform.is.ios === !0 ? "ios" : "md"}${l.substring(3)}`;
            else if ($848b1ce88e755b32$var$df.test(l) === !0) {
                a = "notranslate material-symbols";
                let u = l.match($848b1ce88e755b32$var$df);
                u !== null && (l = l.substring(6), a += $848b1ce88e755b32$var$vf[u[1]]), s = l;
            } else {
                a = "notranslate material-icons";
                let u = l.match($848b1ce88e755b32$var$lb);
                u !== null && (l = l.substring(2), a += $848b1ce88e755b32$var$mf[u[1]]), s = l;
            }
            return {
                cls: a,
                content: s
            };
        });
        return ()=>{
            let a = {
                class: n.value,
                style: r.value,
                "aria-hidden": "true",
                role: "presentation"
            };
            return i.value.none === !0 ? (0, $fVLUl.h)(e.tag, a, $848b1ce88e755b32$var$J(t.default)) : i.value.img === !0 ? (0, $fVLUl.h)(e.tag, a, $848b1ce88e755b32$var$Ke(t.default, [
                (0, $fVLUl.h)("img", {
                    src: i.value.src
                })
            ])) : i.value.svg === !0 ? (0, $fVLUl.h)(e.tag, a, $848b1ce88e755b32$var$Ke(t.default, [
                (0, $fVLUl.h)("svg", {
                    viewBox: i.value.viewBox || "0 0 24 24"
                }, i.value.nodes)
            ])) : i.value.svguse === !0 ? (0, $fVLUl.h)(e.tag, a, $848b1ce88e755b32$var$Ke(t.default, [
                (0, $fVLUl.h)("svg", {
                    viewBox: i.value.viewBox
                }, [
                    (0, $fVLUl.h)("use", {
                        "xlink:href": i.value.src
                    })
                ])
            ])) : (i.value.cls !== void 0 && (a.class += " " + i.value.cls), (0, $fVLUl.h)(e.tag, a, $848b1ce88e755b32$var$Ke(t.default, [
                i.value.content
            ])));
        };
    }
});
var $848b1ce88e755b32$export$f3774053158ba051 = $848b1ce88e755b32$var$R({
    name: "QAvatar",
    props: {
        ...$848b1ce88e755b32$var$Ot,
        fontSize: String,
        color: String,
        textColor: String,
        icon: String,
        square: Boolean,
        rounded: Boolean
    },
    setup (e, { slots: t }) {
        let o = $848b1ce88e755b32$var$It(e), r = (0, $eayOh.computed)(()=>"q-avatar" + (e.color ? ` bg-${e.color}` : "") + (e.textColor ? ` text-${e.textColor} q-chip--colored` : "") + (e.square === !0 ? " q-avatar--square" : e.rounded === !0 ? " rounded-borders" : "")), n = (0, $eayOh.computed)(()=>e.fontSize ? {
                fontSize: e.fontSize
            } : null);
        return ()=>{
            let i = e.icon !== void 0 ? [
                (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                    name: e.icon
                })
            ] : void 0;
            return (0, $fVLUl.h)("div", {
                class: r.value,
                style: o.value
            }, [
                (0, $fVLUl.h)("div", {
                    class: "q-avatar__content row flex-center overflow-hidden",
                    style: n.value
                }, $848b1ce88e755b32$var$ai(t.default, i))
            ]);
        };
    }
});
var $848b1ce88e755b32$var$vb = [
    "top",
    "middle",
    "bottom"
], $848b1ce88e755b32$export$73f24ecabf561a88 = $848b1ce88e755b32$var$R({
    name: "QBadge",
    props: {
        color: String,
        textColor: String,
        floating: Boolean,
        transparent: Boolean,
        multiLine: Boolean,
        outline: Boolean,
        rounded: Boolean,
        label: [
            Number,
            String
        ],
        align: {
            type: String,
            validator: (e)=>$848b1ce88e755b32$var$vb.includes(e)
        }
    },
    setup (e, { slots: t }) {
        let o = (0, $eayOh.computed)(()=>e.align !== void 0 ? {
                verticalAlign: e.align
            } : null), r = (0, $eayOh.computed)(()=>{
            let n = e.outline === !0 && e.color || e.textColor;
            return `q-badge flex inline items-center no-wrap q-badge--${e.multiLine === !0 ? "multi" : "single"}-line` + (e.outline === !0 ? " q-badge--outline" : e.color !== void 0 ? ` bg-${e.color}` : "") + (n !== void 0 ? ` text-${n}` : "") + (e.floating === !0 ? " q-badge--floating" : "") + (e.rounded === !0 ? " q-badge--rounded" : "") + (e.transparent === !0 ? " q-badge--transparent" : "");
        });
        return ()=>(0, $fVLUl.h)("div", {
                class: r.value,
                style: o.value,
                role: "status",
                "aria-label": e.label
            }, $848b1ce88e755b32$var$Ke(t.default, e.label !== void 0 ? [
                e.label
            ] : []));
    }
});
var $848b1ce88e755b32$var$he = {
    dark: {
        type: Boolean,
        default: null
    }
};
function $848b1ce88e755b32$var$pe(e, t) {
    return (0, $eayOh.computed)(()=>e.dark === null ? t.dark.isActive : e.dark);
}
var $848b1ce88e755b32$export$388879c71c3c10cf = $848b1ce88e755b32$var$R({
    name: "QBanner",
    props: {
        ...$848b1ce88e755b32$var$he,
        inlineActions: Boolean,
        dense: Boolean,
        rounded: Boolean
    },
    setup (e, { slots: t }) {
        let { proxy: { $q: o } } = (0, $fVLUl.getCurrentInstance)(), r = $848b1ce88e755b32$var$pe(e, o), n = (0, $eayOh.computed)(()=>"q-banner row items-center" + (e.dense === !0 ? " q-banner--dense" : "") + (r.value === !0 ? " q-banner--dark q-dark" : "") + (e.rounded === !0 ? " rounded-borders" : "")), i = (0, $eayOh.computed)(()=>`q-banner__actions row items-center justify-end col-${e.inlineActions === !0 ? "auto" : "all"}`);
        return ()=>{
            let a = [
                (0, $fVLUl.h)("div", {
                    class: "q-banner__avatar col-auto row items-center self-start"
                }, $848b1ce88e755b32$var$J(t.avatar)),
                (0, $fVLUl.h)("div", {
                    class: "q-banner__content col text-body2"
                }, $848b1ce88e755b32$var$J(t.default))
            ], l = $848b1ce88e755b32$var$J(t.action);
            return l !== void 0 && a.push((0, $fVLUl.h)("div", {
                class: i.value
            }, l)), (0, $fVLUl.h)("div", {
                class: n.value + (e.inlineActions === !1 && l !== void 0 ? " q-banner--top-padding" : ""),
                role: "alert"
            }, a);
        };
    }
});
var $848b1ce88e755b32$export$31ac01ac4236208c = $848b1ce88e755b32$var$R({
    name: "QBar",
    props: {
        ...$848b1ce88e755b32$var$he,
        dense: Boolean
    },
    setup (e, { slots: t }) {
        let { proxy: { $q: o } } = (0, $fVLUl.getCurrentInstance)(), r = $848b1ce88e755b32$var$pe(e, o), n = (0, $eayOh.computed)(()=>`q-bar row no-wrap items-center q-bar--${e.dense === !0 ? "dense" : "standard"}  q-bar--${r.value === !0 ? "dark" : "light"}`);
        return ()=>(0, $fVLUl.h)("div", {
                class: n.value,
                role: "toolbar"
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$var$xf = {
    left: "start",
    center: "center",
    right: "end",
    between: "between",
    around: "around",
    evenly: "evenly",
    stretch: "stretch"
}, $848b1ce88e755b32$var$xb = Object.keys($848b1ce88e755b32$var$xf), $848b1ce88e755b32$var$li = {
    align: {
        type: String,
        validator: (e)=>$848b1ce88e755b32$var$xb.includes(e)
    }
};
function $848b1ce88e755b32$var$ui(e) {
    return (0, $eayOh.computed)(()=>{
        let t = e.align === void 0 ? e.vertical === !0 ? "stretch" : "left" : e.align;
        return `${e.vertical === !0 ? "items" : "justify"}-${$848b1ce88e755b32$var$xf[t]}`;
    });
}
function $848b1ce88e755b32$var$Ra(e) {
    if (Object(e.$parent) === e.$parent) return e.$parent;
    let { parent: t } = e.$;
    for(; Object(t) === t;){
        if (Object(t.proxy) === t.proxy) return t.proxy;
        t = t.parent;
    }
}
function $848b1ce88e755b32$var$_f(e, t) {
    typeof t.type == "symbol" ? Array.isArray(t.children) === !0 && t.children.forEach((o)=>{
        $848b1ce88e755b32$var$_f(e, o);
    }) : e.add(t);
}
function $848b1ce88e755b32$var$si(e) {
    let t = new Set;
    return e.forEach((o)=>{
        $848b1ce88e755b32$var$_f(t, o);
    }), Array.from(t);
}
function $848b1ce88e755b32$var$ci(e) {
    return e.appContext.config.globalProperties.$router !== void 0;
}
function $848b1ce88e755b32$var$Jt(e) {
    return e.isUnmounted === !0 || e.isDeactivated === !0;
}
var $848b1ce88e755b32$var$_b = [
    "",
    !0
], $848b1ce88e755b32$export$88a7ba48108b3d90 = $848b1ce88e755b32$var$R({
    name: "QBreadcrumbs",
    props: {
        ...$848b1ce88e755b32$var$li,
        separator: {
            type: String,
            default: "/"
        },
        separatorColor: String,
        activeColor: {
            type: String,
            default: "primary"
        },
        gutter: {
            type: String,
            validator: (e)=>[
                    "none",
                    "xs",
                    "sm",
                    "md",
                    "lg",
                    "xl"
                ].includes(e),
            default: "sm"
        }
    },
    setup (e, { slots: t }) {
        let o = $848b1ce88e755b32$var$ui(e), r = (0, $eayOh.computed)(()=>`flex items-center ${o.value}${e.gutter === "none" ? "" : ` q-gutter-${e.gutter}`}`), n = (0, $eayOh.computed)(()=>e.separatorColor ? ` text-${e.separatorColor}` : ""), i = (0, $eayOh.computed)(()=>` text-${e.activeColor}`);
        return ()=>{
            if (t.default === void 0) return;
            let a = $848b1ce88e755b32$var$si($848b1ce88e755b32$var$J(t.default));
            if (a.length === 0) return;
            let l = 1, s = [], c = a.filter((v)=>v.type !== void 0 && v.type.name === "QBreadcrumbsEl").length, u = t.separator !== void 0 ? t.separator : ()=>e.separator;
            return a.forEach((v)=>{
                if (v.type !== void 0 && v.type.name === "QBreadcrumbsEl") {
                    let f = l < c, d = v.props !== null && $848b1ce88e755b32$var$_b.includes(v.props.disable), m = (f === !0 ? "" : " q-breadcrumbs--last") + (d !== !0 && f === !0 ? i.value : "");
                    l++, s.push((0, $fVLUl.h)("div", {
                        class: `flex items-center${m}`
                    }, [
                        v
                    ])), f === !0 && s.push((0, $fVLUl.h)("div", {
                        class: "q-breadcrumbs__separator" + n.value
                    }, u()));
                } else s.push(v);
            }), (0, $fVLUl.h)("div", {
                class: "q-breadcrumbs"
            }, [
                (0, $fVLUl.h)("div", {
                    class: r.value
                }, s)
            ]);
        };
    }
});
function $848b1ce88e755b32$var$wf(e) {
    return e ? e.aliasOf ? e.aliasOf.path : e.path : "";
}
function $848b1ce88e755b32$var$kf(e, t) {
    return (e.aliasOf || e) === (t.aliasOf || t);
}
function $848b1ce88e755b32$var$wb(e, t) {
    for(let o in t){
        let r = t[o], n = e[o];
        if (typeof r == "string") {
            if (r !== n) return !1;
        } else if (Array.isArray(n) === !1 || n.length !== r.length || r.some((i, a)=>i !== n[a])) return !1;
    }
    return !0;
}
function $848b1ce88e755b32$var$qf(e, t) {
    return Array.isArray(t) === !0 ? e.length === t.length && e.every((o, r)=>o === t[r]) : e.length === 1 && e[0] === t;
}
function $848b1ce88e755b32$var$kb(e, t) {
    return Array.isArray(e) === !0 ? $848b1ce88e755b32$var$qf(e, t) : Array.isArray(t) === !0 ? $848b1ce88e755b32$var$qf(t, e) : e === t;
}
function $848b1ce88e755b32$var$qb(e, t) {
    if (Object.keys(e).length !== Object.keys(t).length) return !1;
    for(let o in e)if ($848b1ce88e755b32$var$kb(e[o], t[o]) === !1) return !1;
    return !0;
}
var $848b1ce88e755b32$var$zo = {
    to: [
        String,
        Object
    ],
    replace: Boolean,
    exact: Boolean,
    activeClass: {
        type: String,
        default: "q-router-link--active"
    },
    exactActiveClass: {
        type: String,
        default: "q-router-link--exact-active"
    },
    href: String,
    target: String,
    disable: Boolean
};
function $848b1ce88e755b32$var$Yn({ fallbackTag: e, useDisableForRouterLinkProps: t = !0 } = {}) {
    let o = (0, $fVLUl.getCurrentInstance)(), { props: r, proxy: n, emit: i } = o, a = $848b1ce88e755b32$var$ci(o), l = (0, $eayOh.computed)(()=>r.disable !== !0 && r.href !== void 0), s = t === !0 ? (0, $eayOh.computed)(()=>a === !0 && r.disable !== !0 && l.value !== !0 && r.to !== void 0 && r.to !== null && r.to !== "") : (0, $eayOh.computed)(()=>a === !0 && l.value !== !0 && r.to !== void 0 && r.to !== null && r.to !== ""), c = (0, $eayOh.computed)(()=>s.value === !0 ? b(r.to) : null), u = (0, $eayOh.computed)(()=>c.value !== null), v = (0, $eayOh.computed)(()=>l.value === !0 || u.value === !0), f = (0, $eayOh.computed)(()=>r.type === "a" || v.value === !0 ? "a" : r.tag || e || "div"), d = (0, $eayOh.computed)(()=>l.value === !0 ? {
            href: r.href,
            target: r.target
        } : u.value === !0 ? {
            href: c.value.href,
            target: r.target
        } : {}), m = (0, $eayOh.computed)(()=>{
        if (u.value === !1) return -1;
        let { matched: S } = c.value, { length: P } = S, $ = S[P - 1];
        if ($ === void 0) return -1;
        let L = n.$route.matched;
        if (L.length === 0) return -1;
        let E = L.findIndex($848b1ce88e755b32$var$kf.bind(null, $));
        if (E !== -1) return E;
        let A = $848b1ce88e755b32$var$wf(S[P - 2]);
        return P > 1 && $848b1ce88e755b32$var$wf($) === A && L[L.length - 1].path !== A ? L.findIndex($848b1ce88e755b32$var$kf.bind(null, S[P - 2])) : E;
    }), y = (0, $eayOh.computed)(()=>u.value === !0 && m.value !== -1 && $848b1ce88e755b32$var$wb(n.$route.params, c.value.params)), p = (0, $eayOh.computed)(()=>y.value === !0 && m.value === n.$route.matched.length - 1 && $848b1ce88e755b32$var$qb(n.$route.params, c.value.params)), C = (0, $eayOh.computed)(()=>u.value === !0 ? p.value === !0 ? ` ${r.exactActiveClass} ${r.activeClass}` : r.exact === !0 ? "" : y.value === !0 ? ` ${r.activeClass}` : "" : "");
    function b(S) {
        try {
            return n.$router.resolve(S);
        } catch  {}
        return null;
    }
    function h(S, { returnRouterError: P, to: $ = r.to, replace: L = r.replace } = {}) {
        if (r.disable === !0) return S.preventDefault(), Promise.resolve(!1);
        if (S.metaKey || S.altKey || S.ctrlKey || S.shiftKey || S.button !== void 0 && S.button !== 0 || r.target === "_blank") return Promise.resolve(!1);
        S.preventDefault();
        let E = n.$router[L === !0 ? "replace" : "push"]($);
        return P === !0 ? E : E.then(()=>{}).catch(()=>{});
    }
    function g(S) {
        if (u.value === !0) {
            let P = ($)=>h(S, $);
            i("click", S, P), S.defaultPrevented !== !0 && P();
        } else i("click", S);
    }
    return {
        hasRouterLink: u,
        hasHrefLink: l,
        hasLink: v,
        linkTag: f,
        resolvedLink: c,
        linkIsActive: y,
        linkIsExactActive: p,
        linkClass: C,
        linkAttrs: d,
        getLink: b,
        navigateToRouterLink: h,
        navigateOnClick: g
    };
}
var $848b1ce88e755b32$export$488745943e252354 = $848b1ce88e755b32$var$R({
    name: "QBreadcrumbsEl",
    props: {
        ...$848b1ce88e755b32$var$zo,
        label: String,
        icon: String,
        tag: {
            type: String,
            default: "span"
        }
    },
    emits: [
        "click"
    ],
    setup (e, { slots: t }) {
        let { linkTag: o, linkAttrs: r, linkClass: n, navigateOnClick: i } = $848b1ce88e755b32$var$Yn(), a = (0, $eayOh.computed)(()=>({
                class: "q-breadcrumbs__el q-link flex inline items-center relative-position " + (e.disable !== !0 ? "q-link--focusable" + n.value : "q-breadcrumbs__el--disable"),
                ...r.value,
                onClick: i
            })), l = (0, $eayOh.computed)(()=>"q-breadcrumbs__el-icon" + (e.label !== void 0 ? " q-breadcrumbs__el-icon--with-label" : ""));
        return ()=>{
            let s = [];
            return e.icon !== void 0 && s.push((0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                class: l.value,
                name: e.icon
            })), e.label !== void 0 && s.push(e.label), (0, $fVLUl.h)(o.value, {
                ...a.value
            }, $848b1ce88e755b32$var$Ke(t.default, s));
        };
    }
});
var $848b1ce88e755b32$var$Oe = {
    size: {
        type: [
            Number,
            String
        ],
        default: "1em"
    },
    color: String
};
function $848b1ce88e755b32$var$Ve(e) {
    return {
        cSize: (0, $eayOh.computed)(()=>e.size in $848b1ce88e755b32$var$Al ? `${$848b1ce88e755b32$var$Al[e.size]}px` : e.size),
        classes: (0, $eayOh.computed)(()=>"q-spinner" + (e.color ? ` text-${e.color}` : ""))
    };
}
var $848b1ce88e755b32$export$7418ab329b11fed0 = $848b1ce88e755b32$var$R({
    name: "QSpinner",
    props: {
        ...$848b1ce88e755b32$var$Oe,
        thickness: {
            type: Number,
            default: 5
        }
    },
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value + " q-spinner-mat",
                width: t.value,
                height: t.value,
                viewBox: "25 25 50 50"
            }, [
                (0, $fVLUl.h)("circle", {
                    class: "path",
                    cx: "50",
                    cy: "50",
                    r: "20",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": e.thickness,
                    "stroke-miterlimit": "10"
                })
            ]);
    }
});
function $848b1ce88e755b32$var$Tr(e) {
    if (e === window) return {
        top: 0,
        left: 0
    };
    let { top: t, left: o } = e.getBoundingClientRect();
    return {
        top: t,
        left: o
    };
}
function $848b1ce88e755b32$var$Mb(e, t) {
    return window.getComputedStyle(e).getPropertyValue(t);
}
function $848b1ce88e755b32$var$nn(e) {
    return e === window ? window.innerHeight : e.getBoundingClientRect().height;
}
function $848b1ce88e755b32$var$Rb(e) {
    return e === window ? window.innerWidth : e.getBoundingClientRect().width;
}
function $848b1ce88e755b32$var$Mr(e, t) {
    let o = e.style;
    for(let r in t)o[r] = t[r];
}
function $848b1ce88e755b32$var$Pb(e, t) {
    e.forEach((o)=>$848b1ce88e755b32$var$Mr(o, t));
}
function $848b1ce88e755b32$var$Ab(e) {
    if (typeof e == "function") {
        if (document.readyState !== "loading") return e();
        document.addEventListener("DOMContentLoaded", e, !1);
    }
}
function $848b1ce88e755b32$var$$f(e) {
    if (e == null) return;
    if (typeof e == "string") try {
        return document.querySelector(e) || void 0;
    } catch  {
        return;
    }
    let t = (0, $eayOh.unref)(e);
    if (t) return t.$el || t;
}
function $848b1ce88e755b32$var$Ll(e, t) {
    if (e == null || e.contains(t) === !0) return !0;
    for(let o = e.nextElementSibling; o !== null; o = o.nextElementSibling)if (o.contains(t)) return !0;
    return !1;
}
var $848b1ce88e755b32$export$df3a06d6289f983e = {
    offset: $848b1ce88e755b32$var$Tr,
    style: $848b1ce88e755b32$var$Mb,
    height: $848b1ce88e755b32$var$nn,
    width: $848b1ce88e755b32$var$Rb,
    css: $848b1ce88e755b32$var$Mr,
    cssBatch: $848b1ce88e755b32$var$Pb,
    ready: $848b1ce88e755b32$var$Ab
};
function $848b1ce88e755b32$export$de363e709c412c8a(e, t = 250) {
    let o = !1, r;
    return function() {
        return o === !1 && (o = !0, setTimeout(()=>{
            o = !1;
        }, t), r = e.apply(this, arguments)), r;
    };
}
function $848b1ce88e755b32$var$Ef(e, t, o, r) {
    o.modifiers.stop === !0 && $848b1ce88e755b32$var$tt(e);
    let n = o.modifiers.color, i = o.modifiers.center;
    i = i === !0 || r === !0;
    let a = document.createElement("span"), l = document.createElement("span"), s = $848b1ce88e755b32$var$yt(e), { left: c, top: u, width: v, height: f } = t.getBoundingClientRect(), d = Math.sqrt(v * v + f * f), m = d / 2, y = `${(v - d) / 2}px`, p = i ? y : `${s.left - c - m}px`, C = `${(f - d) / 2}px`, b = i ? C : `${s.top - u - m}px`;
    l.className = "q-ripple__inner", $848b1ce88e755b32$var$Mr(l, {
        height: `${d}px`,
        width: `${d}px`,
        transform: `translate3d(${p},${b},0) scale3d(.2,.2,1)`,
        opacity: 0
    }), a.className = `q-ripple${n ? " text-" + n : ""}`, a.setAttribute("dir", "ltr"), a.appendChild(l), t.appendChild(a);
    let h = ()=>{
        a.remove(), clearTimeout(g);
    };
    o.abort.push(h);
    let g = setTimeout(()=>{
        l.classList.add("q-ripple__inner--enter"), l.style.transform = `translate3d(${y},${C},0) scale3d(1,1,1)`, l.style.opacity = .2, g = setTimeout(()=>{
            l.classList.remove("q-ripple__inner--enter"), l.classList.add("q-ripple__inner--leave"), l.style.opacity = 0, g = setTimeout(()=>{
                a.remove(), o.abort.splice(o.abort.indexOf(h), 1);
            }, 275);
        }, 250);
    }, 50);
}
function $848b1ce88e755b32$var$Bf(e, { modifiers: t, value: o, arg: r }) {
    let n = Object.assign({}, e.cfg.ripple, t, o);
    e.modifiers = {
        early: n.early === !0,
        stop: n.stop === !0,
        center: n.center === !0,
        color: n.color || r,
        keyCodes: [].concat(n.keyCodes || 13)
    };
}
var $848b1ce88e755b32$export$9e9146f7e027fdaa = $848b1ce88e755b32$var$Mt({
    name: "ripple",
    beforeMount (e, t) {
        let o = t.instance.$.appContext.config.globalProperties.$q.config || {};
        if (o.ripple === !1) return;
        let r = {
            cfg: o,
            enabled: t.value !== !1,
            modifiers: {},
            abort: [],
            start (n) {
                r.enabled === !0 && n.qSkipRipple !== !0 && n.type === (r.modifiers.early === !0 ? "pointerdown" : "click") && $848b1ce88e755b32$var$Ef(n, e, r, n.qKeyEvent === !0);
            },
            keystart: $848b1ce88e755b32$export$de363e709c412c8a((n)=>{
                r.enabled === !0 && n.qSkipRipple !== !0 && $848b1ce88e755b32$var$wt(n, r.modifiers.keyCodes) === !0 && n.type === `key${r.modifiers.early === !0 ? "down" : "up"}` && $848b1ce88e755b32$var$Ef(n, e, r, !0);
            }, 300)
        };
        $848b1ce88e755b32$var$Bf(r, t), e.__qripple = r, $848b1ce88e755b32$var$lt(r, "main", [
            [
                e,
                "pointerdown",
                "start",
                "passive"
            ],
            [
                e,
                "click",
                "start",
                "passive"
            ],
            [
                e,
                "keydown",
                "keystart",
                "passive"
            ],
            [
                e,
                "keyup",
                "keystart",
                "passive"
            ]
        ]);
    },
    updated (e, t) {
        if (t.oldValue !== t.value) {
            let o = e.__qripple;
            o !== void 0 && (o.enabled = t.value !== !1, o.enabled === !0 && Object(t.value) === t.value && $848b1ce88e755b32$var$Bf(o, t));
        }
    },
    beforeUnmount (e) {
        let t = e.__qripple;
        t !== void 0 && (t.abort.forEach((o)=>{
            o();
        }), $848b1ce88e755b32$var$Ct(t, "main"), delete e._qripple);
    }
});
var $848b1ce88e755b32$var$Aa = {
    none: 0,
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32
}, $848b1ce88e755b32$var$Eb = {
    xs: 8,
    sm: 10,
    md: 14,
    lg: 20,
    xl: 24
}, $848b1ce88e755b32$var$Bb = [
    "button",
    "submit",
    "reset"
], $848b1ce88e755b32$var$Lb = /[^\s]\/[^\s]/, $848b1ce88e755b32$var$ac = [
    "flat",
    "outline",
    "push",
    "unelevated"
];
function $848b1ce88e755b32$var$Fl(e, t) {
    return e.flat === !0 ? "flat" : e.outline === !0 ? "outline" : e.push === !0 ? "push" : e.unelevated === !0 ? "unelevated" : t;
}
function $848b1ce88e755b32$var$Dl(e) {
    let t = $848b1ce88e755b32$var$Fl(e);
    return t !== void 0 ? {
        [t]: !0
    } : {};
}
var $848b1ce88e755b32$var$$a = {
    ...$848b1ce88e755b32$var$Ot,
    ...$848b1ce88e755b32$var$zo,
    type: {
        type: String,
        default: "button"
    },
    label: [
        Number,
        String
    ],
    icon: String,
    iconRight: String,
    ...$848b1ce88e755b32$var$ac.reduce((e, t)=>(e[t] = Boolean) && e, {}),
    square: Boolean,
    round: Boolean,
    rounded: Boolean,
    glossy: Boolean,
    size: String,
    fab: Boolean,
    fabMini: Boolean,
    padding: String,
    color: String,
    textColor: String,
    noCaps: Boolean,
    noWrap: Boolean,
    dense: Boolean,
    tabindex: [
        Number,
        String
    ],
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: !0
    },
    align: {
        ...$848b1ce88e755b32$var$li.align,
        default: "center"
    },
    stack: Boolean,
    stretch: Boolean,
    loading: {
        type: Boolean,
        default: null
    },
    disable: Boolean
};
function $848b1ce88e755b32$var$Lf(e) {
    let t = $848b1ce88e755b32$var$It(e, $848b1ce88e755b32$var$Eb), o = $848b1ce88e755b32$var$ui(e), { hasRouterLink: r, hasLink: n, linkTag: i, linkAttrs: a, navigateOnClick: l } = $848b1ce88e755b32$var$Yn({
        fallbackTag: "button"
    }), s = (0, $eayOh.computed)(()=>{
        let p = e.fab === !1 && e.fabMini === !1 ? t.value : {};
        return e.padding !== void 0 ? Object.assign({}, p, {
            padding: e.padding.split(/\s+/).map((C)=>C in $848b1ce88e755b32$var$Aa ? $848b1ce88e755b32$var$Aa[C] + "px" : C).join(" "),
            minWidth: "0",
            minHeight: "0"
        }) : p;
    }), c = (0, $eayOh.computed)(()=>e.rounded === !0 || e.fab === !0 || e.fabMini === !0), u = (0, $eayOh.computed)(()=>e.disable !== !0 && e.loading !== !0), v = (0, $eayOh.computed)(()=>u.value === !0 ? e.tabindex || 0 : -1), f = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$Fl(e, "standard")), d = (0, $eayOh.computed)(()=>{
        let p = {
            tabindex: v.value
        };
        return n.value === !0 ? Object.assign(p, a.value) : $848b1ce88e755b32$var$Bb.includes(e.type) === !0 && (p.type = e.type), i.value === "a" ? (e.disable === !0 ? p["aria-disabled"] = "true" : p.href === void 0 && (p.role = "button"), r.value !== !0 && $848b1ce88e755b32$var$Lb.test(e.type) === !0 && (p.type = e.type)) : e.disable === !0 && (p.disabled = "", p["aria-disabled"] = "true"), e.loading === !0 && e.percentage !== void 0 && Object.assign(p, {
            role: "progressbar",
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-valuenow": e.percentage
        }), p;
    }), m = (0, $eayOh.computed)(()=>{
        let p;
        e.color !== void 0 ? e.flat === !0 || e.outline === !0 ? p = `text-${e.textColor || e.color}` : p = `bg-${e.color} text-${e.textColor || "white"}` : e.textColor && (p = `text-${e.textColor}`);
        let C = e.round === !0 ? "round" : `rectangle${c.value === !0 ? " q-btn--rounded" : e.square === !0 ? " q-btn--square" : ""}`;
        return `q-btn--${f.value} q-btn--${C}` + (p !== void 0 ? " " + p : "") + (u.value === !0 ? " q-btn--actionable q-focusable q-hoverable" : e.disable === !0 ? " disabled" : "") + (e.fab === !0 ? " q-btn--fab" : e.fabMini === !0 ? " q-btn--fab-mini" : "") + (e.noCaps === !0 ? " q-btn--no-uppercase" : "") + (e.dense === !0 ? " q-btn--dense" : "") + (e.stretch === !0 ? " no-border-radius self-stretch" : "") + (e.glossy === !0 ? " glossy" : "") + (e.square ? " q-btn--square" : "");
    }), y = (0, $eayOh.computed)(()=>o.value + (e.stack === !0 ? " column" : " row") + (e.noWrap === !0 ? " no-wrap text-no-wrap" : "") + (e.loading === !0 ? " q-btn__content--hidden" : ""));
    return {
        classes: m,
        style: s,
        innerClasses: y,
        attributes: d,
        hasLink: n,
        linkTag: i,
        navigateOnClick: l,
        isActionable: u
    };
}
var { passiveCapture: $848b1ce88e755b32$var$Po } = $848b1ce88e755b32$var$Xe, $848b1ce88e755b32$var$fi = null, $848b1ce88e755b32$var$mi = null, $848b1ce88e755b32$var$vi = null, $848b1ce88e755b32$export$72abad9388e88b7 = $848b1ce88e755b32$var$R({
    name: "QBtn",
    props: {
        ...$848b1ce88e755b32$var$$a,
        percentage: Number,
        darkPercentage: Boolean,
        onTouchstart: [
            Function,
            Array
        ]
    },
    emits: [
        "click",
        "keydown",
        "mousedown",
        "keyup"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: r } = (0, $fVLUl.getCurrentInstance)(), { classes: n, style: i, innerClasses: a, attributes: l, hasLink: s, linkTag: c, navigateOnClick: u, isActionable: v } = $848b1ce88e755b32$var$Lf(e), f = (0, $eayOh.ref)(null), d = (0, $eayOh.ref)(null), m = null, y, p = null, C = (0, $eayOh.computed)(()=>e.label !== void 0 && e.label !== null && e.label !== ""), b = (0, $eayOh.computed)(()=>e.disable === !0 || e.ripple === !1 ? !1 : {
                keyCodes: s.value === !0 ? [
                    13,
                    32
                ] : [
                    13
                ],
                ...e.ripple === !0 ? {} : e.ripple
            }), h = (0, $eayOh.computed)(()=>({
                center: e.round
            })), g = (0, $eayOh.computed)(()=>{
            let k = Math.max(0, Math.min(100, e.percentage));
            return k > 0 ? {
                transition: "transform 0.6s",
                transform: `translateX(${k - 100}%)`
            } : {};
        }), S = (0, $eayOh.computed)(()=>{
            if (e.loading === !0) return {
                onMousedown: x,
                onTouchstart: x,
                onClick: x,
                onKeydown: x,
                onKeyup: x
            };
            if (v.value === !0) {
                let k = {
                    onClick: $,
                    onKeydown: L,
                    onMousedown: A
                };
                if (r.$q.platform.has.touch === !0) {
                    let j = e.onTouchstart !== void 0 ? "" : "Passive";
                    k[`onTouchstart${j}`] = E;
                }
                return k;
            }
            return {
                onClick: $848b1ce88e755b32$var$Se
            };
        }), P = (0, $eayOh.computed)(()=>({
                ref: f,
                class: "q-btn q-btn-item non-selectable no-outline " + n.value,
                style: i.value,
                ...l.value,
                ...S.value
            }));
        function $(k) {
            if (f.value !== null) {
                if (k !== void 0) {
                    if (k.defaultPrevented === !0) return;
                    let j = document.activeElement;
                    if (e.type === "submit" && j !== document.body && f.value.contains(j) === !1 && j.contains(f.value) === !1) {
                        f.value.focus();
                        let Q = ()=>{
                            document.removeEventListener("keydown", $848b1ce88e755b32$var$Se, !0), document.removeEventListener("keyup", Q, $848b1ce88e755b32$var$Po), f.value !== null && f.value.removeEventListener("blur", Q, $848b1ce88e755b32$var$Po);
                        };
                        document.addEventListener("keydown", $848b1ce88e755b32$var$Se, !0), document.addEventListener("keyup", Q, $848b1ce88e755b32$var$Po), f.value.addEventListener("blur", Q, $848b1ce88e755b32$var$Po);
                    }
                }
                u(k);
            }
        }
        function L(k) {
            f.value !== null && (o("keydown", k), $848b1ce88e755b32$var$wt(k, [
                13,
                32
            ]) === !0 && $848b1ce88e755b32$var$mi !== f.value && ($848b1ce88e755b32$var$mi !== null && q(), k.defaultPrevented !== !0 && (f.value.focus(), $848b1ce88e755b32$var$mi = f.value, f.value.classList.add("q-btn--active"), document.addEventListener("keyup", B, !0), f.value.addEventListener("blur", B, $848b1ce88e755b32$var$Po)), $848b1ce88e755b32$var$Se(k)));
        }
        function E(k) {
            f.value !== null && (o("touchstart", k), k.defaultPrevented !== !0 && ($848b1ce88e755b32$var$fi !== f.value && ($848b1ce88e755b32$var$fi !== null && q(), $848b1ce88e755b32$var$fi = f.value, m = k.target, m.addEventListener("touchcancel", B, $848b1ce88e755b32$var$Po), m.addEventListener("touchend", B, $848b1ce88e755b32$var$Po)), y = !0, p !== null && clearTimeout(p), p = setTimeout(()=>{
                p = null, y = !1;
            }, 200)));
        }
        function A(k) {
            f.value !== null && (k.qSkipRipple = y === !0, o("mousedown", k), k.defaultPrevented !== !0 && $848b1ce88e755b32$var$vi !== f.value && ($848b1ce88e755b32$var$vi !== null && q(), $848b1ce88e755b32$var$vi = f.value, f.value.classList.add("q-btn--active"), document.addEventListener("mouseup", B, $848b1ce88e755b32$var$Po)));
        }
        function B(k) {
            if (f.value !== null && !(k !== void 0 && k.type === "blur" && document.activeElement === f.value)) {
                if (k !== void 0 && k.type === "keyup") {
                    if ($848b1ce88e755b32$var$mi === f.value && $848b1ce88e755b32$var$wt(k, [
                        13,
                        32
                    ]) === !0) {
                        let j = new MouseEvent("click", k);
                        j.qKeyEvent = !0, k.defaultPrevented === !0 && $848b1ce88e755b32$var$ut(j), k.cancelBubble === !0 && $848b1ce88e755b32$var$tt(j), f.value.dispatchEvent(j), $848b1ce88e755b32$var$Se(k), k.qKeyEvent = !0;
                    }
                    o("keyup", k);
                }
                q();
            }
        }
        function q(k) {
            let j = d.value;
            k !== !0 && ($848b1ce88e755b32$var$fi === f.value || $848b1ce88e755b32$var$vi === f.value) && j !== null && j !== document.activeElement && (j.setAttribute("tabindex", -1), j.focus()), $848b1ce88e755b32$var$fi === f.value && (m !== null && (m.removeEventListener("touchcancel", B, $848b1ce88e755b32$var$Po), m.removeEventListener("touchend", B, $848b1ce88e755b32$var$Po)), $848b1ce88e755b32$var$fi = m = null), $848b1ce88e755b32$var$vi === f.value && (document.removeEventListener("mouseup", B, $848b1ce88e755b32$var$Po), $848b1ce88e755b32$var$vi = null), $848b1ce88e755b32$var$mi === f.value && (document.removeEventListener("keyup", B, !0), f.value !== null && f.value.removeEventListener("blur", B, $848b1ce88e755b32$var$Po), $848b1ce88e755b32$var$mi = null), f.value !== null && f.value.classList.remove("q-btn--active");
        }
        function x(k) {
            $848b1ce88e755b32$var$Se(k), k.qSkipRipple = !0;
        }
        return (0, $fVLUl.onBeforeUnmount)(()=>{
            q(!0);
        }), Object.assign(r, {
            click: (k)=>{
                v.value === !0 && $(k);
            }
        }), ()=>{
            let k = [];
            e.icon !== void 0 && k.push((0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                name: e.icon,
                left: e.stack !== !0 && C.value === !0,
                role: "img",
                "aria-hidden": "true"
            })), C.value === !0 && k.push((0, $fVLUl.h)("span", {
                class: "block"
            }, [
                e.label
            ])), k = $848b1ce88e755b32$var$Ke(t.default, k), e.iconRight !== void 0 && e.round === !1 && k.push((0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                name: e.iconRight,
                right: e.stack !== !0 && C.value === !0,
                role: "img",
                "aria-hidden": "true"
            }));
            let j = [
                (0, $fVLUl.h)("span", {
                    class: "q-focus-helper",
                    ref: d
                })
            ];
            return e.loading === !0 && e.percentage !== void 0 && j.push((0, $fVLUl.h)("span", {
                class: "q-btn__progress absolute-full overflow-hidden" + (e.darkPercentage === !0 ? " q-btn__progress--dark" : "")
            }, [
                (0, $fVLUl.h)("span", {
                    class: "q-btn__progress-indicator fit block",
                    style: g.value
                })
            ])), j.push((0, $fVLUl.h)("span", {
                class: "q-btn__content text-center col items-center q-anchor--skip " + a.value
            }, k)), e.loading !== null && j.push((0, $fVLUl.h)((0, $24349.Transition), {
                name: "q-transition--fade"
            }, ()=>e.loading === !0 ? [
                    (0, $fVLUl.h)("span", {
                        key: "loading",
                        class: "absolute-full flex flex-center"
                    }, t.loading !== void 0 ? t.loading() : [
                        (0, $fVLUl.h)($848b1ce88e755b32$export$7418ab329b11fed0)
                    ])
                ] : null)), (0, $fVLUl.withDirectives)((0, $fVLUl.h)(c.value, P.value, j), [
                [
                    $848b1ce88e755b32$export$9e9146f7e027fdaa,
                    b.value,
                    void 0,
                    h.value
                ]
            ]);
        };
    }
});
var $848b1ce88e755b32$export$ec40a025a653c83b = $848b1ce88e755b32$var$R({
    name: "QBtnGroup",
    props: {
        unelevated: Boolean,
        outline: Boolean,
        flat: Boolean,
        rounded: Boolean,
        square: Boolean,
        push: Boolean,
        stretch: Boolean,
        glossy: Boolean,
        spread: Boolean
    },
    setup (e, { slots: t }) {
        let o = (0, $eayOh.computed)(()=>{
            let r = [
                "unelevated",
                "outline",
                "flat",
                "rounded",
                "square",
                "push",
                "stretch",
                "glossy"
            ].filter((n)=>e[n] === !0).map((n)=>`q-btn-group--${n}`).join(" ");
            return `q-btn-group row no-wrap${r.length !== 0 ? " " + r : ""}` + (e.spread === !0 ? " q-btn-group--spread" : " inline");
        });
        return ()=>(0, $fVLUl.h)("div", {
                class: o.value
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
function $848b1ce88e755b32$var$Ut() {
    if (window.getSelection !== void 0) {
        let e = window.getSelection();
        e.empty !== void 0 ? e.empty() : e.removeAllRanges !== void 0 && (e.removeAllRanges(), $848b1ce88e755b32$export$2dffd0b5373a4389.is.mobile !== !0 && e.addRange(document.createRange()));
    } else document.selection !== void 0 && document.selection.empty();
}
var $848b1ce88e755b32$var$hi = {
    target: {
        default: !0
    },
    noParentEvent: Boolean,
    contextMenu: Boolean
};
function $848b1ce88e755b32$var$pi({ showing: e, avoidEmit: t, configureAnchorEl: o }) {
    let { props: r, proxy: n, emit: i } = (0, $fVLUl.getCurrentInstance)(), a = (0, $eayOh.ref)(null), l = null;
    function s(d) {
        return a.value === null ? !1 : d === void 0 || d.touches === void 0 || d.touches.length <= 1;
    }
    let c = {};
    o === void 0 && (Object.assign(c, {
        hide (d) {
            n.hide(d);
        },
        toggle (d) {
            n.toggle(d), d.qAnchorHandled = !0;
        },
        toggleKey (d) {
            $848b1ce88e755b32$var$wt(d, 13) === !0 && c.toggle(d);
        },
        contextClick (d) {
            n.hide(d), $848b1ce88e755b32$var$ut(d), (0, $fVLUl.nextTick)(()=>{
                n.show(d), d.qAnchorHandled = !0;
            });
        },
        prevent: $848b1ce88e755b32$var$ut,
        mobileTouch (d) {
            if (c.mobileCleanup(d), s(d) !== !0) return;
            n.hide(d), a.value.classList.add("non-selectable");
            let m = d.target;
            $848b1ce88e755b32$var$lt(c, "anchor", [
                [
                    m,
                    "touchmove",
                    "mobileCleanup",
                    "passive"
                ],
                [
                    m,
                    "touchend",
                    "mobileCleanup",
                    "passive"
                ],
                [
                    m,
                    "touchcancel",
                    "mobileCleanup",
                    "passive"
                ],
                [
                    a.value,
                    "contextmenu",
                    "prevent",
                    "notPassive"
                ]
            ]), l = setTimeout(()=>{
                l = null, n.show(d), d.qAnchorHandled = !0;
            }, 300);
        },
        mobileCleanup (d) {
            a.value.classList.remove("non-selectable"), l !== null && (clearTimeout(l), l = null), e.value === !0 && d !== void 0 && $848b1ce88e755b32$var$Ut();
        }
    }), o = function(d = r.contextMenu) {
        if (r.noParentEvent === !0 || a.value === null) return;
        let m;
        d === !0 ? n.$q.platform.is.mobile === !0 ? m = [
            [
                a.value,
                "touchstart",
                "mobileTouch",
                "passive"
            ]
        ] : m = [
            [
                a.value,
                "mousedown",
                "hide",
                "passive"
            ],
            [
                a.value,
                "contextmenu",
                "contextClick",
                "notPassive"
            ]
        ] : m = [
            [
                a.value,
                "click",
                "toggle",
                "passive"
            ],
            [
                a.value,
                "keyup",
                "toggleKey",
                "passive"
            ]
        ], $848b1ce88e755b32$var$lt(c, "anchor", m);
    });
    function u() {
        $848b1ce88e755b32$var$Ct(c, "anchor");
    }
    function v(d) {
        for(a.value = d; a.value.classList.contains("q-anchor--skip");)a.value = a.value.parentNode;
        o();
    }
    function f() {
        if (r.target === !1 || r.target === "" || n.$el.parentNode === null) a.value = null;
        else if (r.target === !0) v(n.$el.parentNode);
        else {
            let d = r.target;
            if (typeof r.target == "string") try {
                d = document.querySelector(r.target);
            } catch  {
                d = void 0;
            }
            d != null ? (a.value = d.$el || d, o()) : (a.value = null, console.error(`Anchor: target "${r.target}" not found`));
        }
    }
    return (0, $eayOh.watch)(()=>r.contextMenu, (d)=>{
        a.value !== null && (u(), o(d));
    }), (0, $eayOh.watch)(()=>r.target, ()=>{
        a.value !== null && u(), f();
    }), (0, $eayOh.watch)(()=>r.noParentEvent, (d)=>{
        a.value !== null && (d === !0 ? u() : o());
    }), (0, $fVLUl.onMounted)(()=>{
        f(), t !== !0 && r.modelValue === !0 && a.value === null && i("update:modelValue", !1);
    }), (0, $fVLUl.onBeforeUnmount)(()=>{
        l !== null && clearTimeout(l), u();
    }), {
        anchorEl: a,
        canShow: s,
        anchorEvents: c
    };
}
function $848b1ce88e755b32$var$Vl(e, t) {
    let o = (0, $eayOh.ref)(null), r;
    function n(l, s) {
        let c = `${s !== void 0 ? "add" : "remove"}EventListener`, u = s !== void 0 ? s : r;
        l !== window && l[c]("scroll", u, $848b1ce88e755b32$var$Xe.passive), window[c]("scroll", u, $848b1ce88e755b32$var$Xe.passive), r = s;
    }
    function i() {
        o.value !== null && (n(o.value), o.value = null);
    }
    let a = (0, $eayOh.watch)(()=>e.noParentEvent, ()=>{
        o.value !== null && (i(), t());
    });
    return (0, $fVLUl.onBeforeUnmount)(a), {
        localScrollTarget: o,
        unconfigureScrollTarget: i,
        changeScrollEvent: n
    };
}
var $848b1ce88e755b32$var$Ao = {
    modelValue: {
        type: Boolean,
        default: null
    },
    "onUpdate:modelValue": [
        Function,
        Array
    ]
}, $848b1ce88e755b32$var$$o = [
    "beforeShow",
    "show",
    "beforeHide",
    "hide"
];
function $848b1ce88e755b32$var$Eo({ showing: e, canShow: t, hideOnRouteChange: o, handleShow: r, handleHide: n, processOnMount: i }) {
    let a = (0, $fVLUl.getCurrentInstance)(), { props: l, emit: s, proxy: c } = a, u;
    function v(b) {
        e.value === !0 ? m(b) : f(b);
    }
    function f(b) {
        if (l.disable === !0 || b !== void 0 && b.qAnchorHandled === !0 || t !== void 0 && t(b) !== !0) return;
        let h = l["onUpdate:modelValue"] !== void 0;
        h === !0 && (s("update:modelValue", !0), u = b, (0, $fVLUl.nextTick)(()=>{
            u === b && (u = void 0);
        })), (l.modelValue === null || h === !1) && d(b);
    }
    function d(b) {
        e.value !== !0 && (e.value = !0, s("beforeShow", b), r !== void 0 ? r(b) : s("show", b));
    }
    function m(b) {
        if (l.disable === !0) return;
        let h = l["onUpdate:modelValue"] !== void 0;
        h === !0 && (s("update:modelValue", !1), u = b, (0, $fVLUl.nextTick)(()=>{
            u === b && (u = void 0);
        })), (l.modelValue === null || h === !1) && y(b);
    }
    function y(b) {
        e.value !== !1 && (e.value = !1, s("beforeHide", b), n !== void 0 ? n(b) : s("hide", b));
    }
    function p(b) {
        l.disable === !0 && b === !0 ? l["onUpdate:modelValue"] !== void 0 && s("update:modelValue", !1) : b === !0 !== e.value && (b === !0 ? d : y)(u);
    }
    (0, $eayOh.watch)(()=>l.modelValue, p), o !== void 0 && $848b1ce88e755b32$var$ci(a) === !0 && (0, $eayOh.watch)(()=>c.$route.fullPath, ()=>{
        o.value === !0 && e.value === !0 && m();
    }), i === !0 && (0, $fVLUl.onMounted)(()=>{
        p(l.modelValue);
    });
    let C = {
        show: f,
        hide: m,
        toggle: v
    };
    return Object.assign(c, C), C;
}
var $848b1ce88e755b32$var$Rr = [], $848b1ce88e755b32$var$Ea = [];
function $848b1ce88e755b32$var$zf(e) {
    $848b1ce88e755b32$var$Ea = $848b1ce88e755b32$var$Ea.filter((t)=>t !== e);
}
function $848b1ce88e755b32$var$Of(e) {
    $848b1ce88e755b32$var$zf(e), $848b1ce88e755b32$var$Ea.push(e);
}
function $848b1ce88e755b32$var$uc(e) {
    $848b1ce88e755b32$var$zf(e), $848b1ce88e755b32$var$Ea.length === 0 && $848b1ce88e755b32$var$Rr.length !== 0 && ($848b1ce88e755b32$var$Rr[$848b1ce88e755b32$var$Rr.length - 1](), $848b1ce88e755b32$var$Rr = []);
}
function $848b1ce88e755b32$var$Bo(e) {
    $848b1ce88e755b32$var$Ea.length === 0 ? e() : $848b1ce88e755b32$var$Rr.push(e);
}
function $848b1ce88e755b32$var$If(e) {
    $848b1ce88e755b32$var$Rr = $848b1ce88e755b32$var$Rr.filter((t)=>t !== e);
}
var $848b1ce88e755b32$var$bi = [], $848b1ce88e755b32$var$Ba = [], $848b1ce88e755b32$var$Zb = 1, $848b1ce88e755b32$var$Gn = document.body;
function $848b1ce88e755b32$var$an(e, t) {
    let o = document.createElement("div");
    if (o.id = t !== void 0 ? `q-portal--${t}--${$848b1ce88e755b32$var$Zb++}` : e, $848b1ce88e755b32$var$ni.globalNodes !== void 0) {
        let r = $848b1ce88e755b32$var$ni.globalNodes.class;
        r !== void 0 && (o.className = r);
    }
    return $848b1ce88e755b32$var$Gn.appendChild(o), $848b1ce88e755b32$var$bi.push(o), $848b1ce88e755b32$var$Ba.push(t), o;
}
function $848b1ce88e755b32$var$yi(e) {
    let t = $848b1ce88e755b32$var$bi.indexOf(e);
    $848b1ce88e755b32$var$bi.splice(t, 1), $848b1ce88e755b32$var$Ba.splice(t, 1), e.remove();
}
function $848b1ce88e755b32$var$Hf(e) {
    if (e === $848b1ce88e755b32$var$Gn) return;
    if ($848b1ce88e755b32$var$Gn = e, $848b1ce88e755b32$var$Gn === document.body || $848b1ce88e755b32$var$Ba.reduce((o, r)=>r === "dialog" ? o + 1 : o, 0) < 2) {
        $848b1ce88e755b32$var$bi.forEach((o)=>{
            o.contains($848b1ce88e755b32$var$Gn) === !1 && $848b1ce88e755b32$var$Gn.appendChild(o);
        });
        return;
    }
    let t = $848b1ce88e755b32$var$Ba.lastIndexOf("dialog");
    for(let o = 0; o < $848b1ce88e755b32$var$bi.length; o++){
        let r = $848b1ce88e755b32$var$bi[o];
        (o === t || $848b1ce88e755b32$var$Ba[o] !== "dialog") && r.contains($848b1ce88e755b32$var$Gn) === !1 && $848b1ce88e755b32$var$Gn.appendChild(r);
    }
}
var $848b1ce88e755b32$var$Zn = [];
function $848b1ce88e755b32$var$Nf(e) {
    return $848b1ce88e755b32$var$Zn.find((t)=>t.contentEl !== null && t.contentEl.contains(e));
}
function $848b1ce88e755b32$var$sc(e, t) {
    do {
        if (e.$options.name === "QMenu") {
            if (e.hide(t), e.$props.separateClosePopup === !0) return $848b1ce88e755b32$var$Ra(e);
        } else if (e.__qPortal === !0) {
            let o = $848b1ce88e755b32$var$Ra(e);
            return o !== void 0 && o.$options.name === "QPopupProxy" ? (e.hide(t), o) : e;
        }
        e = $848b1ce88e755b32$var$Ra(e);
    }while (e != null);
}
function $848b1ce88e755b32$var$Qf(e, t, o) {
    for(; o !== 0 && e !== void 0 && e !== null;){
        if (e.__qPortal === !0) {
            if (o--, e.$options.name === "QMenu") {
                e = $848b1ce88e755b32$var$sc(e, t);
                continue;
            }
            e.hide(t);
        }
        e = $848b1ce88e755b32$var$Ra(e);
    }
}
var $848b1ce88e755b32$var$ty = $848b1ce88e755b32$var$R({
    name: "QPortal",
    setup (e, { slots: t }) {
        return ()=>t.default();
    }
});
function $848b1ce88e755b32$var$oy(e) {
    for(e = e.parent; e != null;){
        if (e.type.name === "QGlobalDialog") return !0;
        if (e.type.name === "QDialog" || e.type.name === "QMenu") return !1;
        e = e.parent;
    }
    return !1;
}
function $848b1ce88e755b32$var$Si(e, t, o, r) {
    let n = (0, $eayOh.ref)(!1), i = (0, $eayOh.ref)(!1), a = null, l = {}, s = r === "dialog" && $848b1ce88e755b32$var$oy(e);
    function c(v) {
        if (v === !0) {
            $848b1ce88e755b32$var$uc(l), i.value = !0;
            return;
        }
        i.value = !1, n.value === !1 && (s === !1 && a === null && (a = $848b1ce88e755b32$var$an(!1, r)), n.value = !0, $848b1ce88e755b32$var$Zn.push(e.proxy), $848b1ce88e755b32$var$Of(l));
    }
    function u(v) {
        if (i.value = !1, v !== !0) return;
        $848b1ce88e755b32$var$uc(l), n.value = !1;
        let f = $848b1ce88e755b32$var$Zn.indexOf(e.proxy);
        f !== -1 && $848b1ce88e755b32$var$Zn.splice(f, 1), a !== null && ($848b1ce88e755b32$var$yi(a), a = null);
    }
    return (0, $fVLUl.onUnmounted)(()=>{
        u(!0);
    }), e.proxy.__qPortal = !0, $848b1ce88e755b32$var$it(e.proxy, "contentEl", ()=>t.value), {
        showPortal: c,
        hidePortal: u,
        portalIsActive: n,
        portalIsAccessible: i,
        renderPortal: ()=>s === !0 ? o() : n.value === !0 ? [
                (0, $fVLUl.h)((0, $fVLUl.Teleport), {
                    to: a
                }, (0, $fVLUl.h)($848b1ce88e755b32$var$ty, o))
            ] : void 0
    };
}
var $848b1ce88e755b32$var$ln = {
    transitionShow: {
        type: String,
        default: "fade"
    },
    transitionHide: {
        type: String,
        default: "fade"
    },
    transitionDuration: {
        type: [
            String,
            Number
        ],
        default: 300
    }
};
function $848b1ce88e755b32$var$Jn(e, t = ()=>{}, o = ()=>{}) {
    return {
        transitionProps: (0, $eayOh.computed)(()=>{
            let r = `q-transition--${e.transitionShow || t()}`, n = `q-transition--${e.transitionHide || o()}`;
            return {
                appear: !0,
                enterFromClass: `${r}-enter-from`,
                enterActiveClass: `${r}-enter-active`,
                enterToClass: `${r}-enter-to`,
                leaveFromClass: `${n}-leave-from`,
                leaveActiveClass: `${n}-leave-active`,
                leaveToClass: `${n}-leave-to`
            };
        }),
        transitionStyle: (0, $eayOh.computed)(()=>`--q-transition-duration: ${e.transitionDuration}ms`)
    };
}
function $848b1ce88e755b32$export$98bfbd4c9d834fed() {
    let e, t = (0, $fVLUl.getCurrentInstance)();
    function o() {
        e = void 0;
    }
    return (0, $fVLUl.onDeactivated)(o), (0, $fVLUl.onBeforeUnmount)(o), {
        removeTick: o,
        registerTick (r) {
            e = r, (0, $fVLUl.nextTick)(()=>{
                e === r && ($848b1ce88e755b32$var$Jt(t) === !1 && e(), e = void 0);
            });
        }
    };
}
function $848b1ce88e755b32$export$d8e6abf214c9ec0f() {
    let e = null, t = (0, $fVLUl.getCurrentInstance)();
    function o() {
        e !== null && (clearTimeout(e), e = null);
    }
    return (0, $fVLUl.onDeactivated)(o), (0, $fVLUl.onBeforeUnmount)(o), {
        removeTimeout: o,
        registerTimeout (r, n) {
            o(e), $848b1ce88e755b32$var$Jt(t) === !1 && (e = setTimeout(()=>{
                e = null, r();
            }, n));
        }
    };
}
var $848b1ce88e755b32$var$cy = [
    null,
    document,
    document.body,
    document.scrollingElement,
    document.documentElement
];
function $848b1ce88e755b32$var$At(e, t) {
    let o = $848b1ce88e755b32$var$$f(t);
    if (o === void 0) {
        if (e == null) return window;
        o = e.closest(".scroll,.scroll-y,.overflow-auto");
    }
    return $848b1ce88e755b32$var$cy.includes(o) ? window : o;
}
function $848b1ce88e755b32$var$xi(e) {
    return (e === window ? document.body : e).scrollHeight;
}
function $848b1ce88e755b32$var$dy(e) {
    return (e === window ? document.body : e).scrollWidth;
}
function $848b1ce88e755b32$var$fo(e) {
    return e === window ? window.pageYOffset || window.scrollY || document.body.scrollTop || 0 : e.scrollTop;
}
function $848b1ce88e755b32$var$er(e) {
    return e === window ? window.pageXOffset || window.scrollX || document.body.scrollLeft || 0 : e.scrollLeft;
}
function $848b1ce88e755b32$var$fc(e, t, o = 0) {
    let r = arguments[3] === void 0 ? performance.now() : arguments[3], n = $848b1ce88e755b32$var$fo(e);
    if (o <= 0) {
        n !== t && $848b1ce88e755b32$var$cc(e, t);
        return;
    }
    requestAnimationFrame((i)=>{
        let a = i - r, l = n + (t - n) / Math.max(a, o) * a;
        $848b1ce88e755b32$var$cc(e, l), l !== t && $848b1ce88e755b32$var$fc(e, t, o - a, i);
    });
}
function $848b1ce88e755b32$var$mc(e, t, o = 0) {
    let r = arguments[3] === void 0 ? performance.now() : arguments[3], n = $848b1ce88e755b32$var$er(e);
    if (o <= 0) {
        n !== t && $848b1ce88e755b32$var$dc(e, t);
        return;
    }
    requestAnimationFrame((i)=>{
        let a = i - r, l = n + (t - n) / Math.max(a, o) * a;
        $848b1ce88e755b32$var$dc(e, l), l !== t && $848b1ce88e755b32$var$mc(e, t, o - a, i);
    });
}
function $848b1ce88e755b32$var$cc(e, t) {
    if (e === window) {
        window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, t);
        return;
    }
    e.scrollTop = t;
}
function $848b1ce88e755b32$var$dc(e, t) {
    if (e === window) {
        window.scrollTo(t, window.pageYOffset || window.scrollY || document.body.scrollTop || 0);
        return;
    }
    e.scrollLeft = t;
}
function $848b1ce88e755b32$var$un(e, t, o) {
    if (o) {
        $848b1ce88e755b32$var$fc(e, t, o);
        return;
    }
    $848b1ce88e755b32$var$cc(e, t);
}
function $848b1ce88e755b32$var$La(e, t, o) {
    if (o) {
        $848b1ce88e755b32$var$mc(e, t, o);
        return;
    }
    $848b1ce88e755b32$var$dc(e, t);
}
var $848b1ce88e755b32$var$zl;
function $848b1ce88e755b32$var$Pr() {
    if ($848b1ce88e755b32$var$zl !== void 0) return $848b1ce88e755b32$var$zl;
    let e = document.createElement("p"), t = document.createElement("div");
    $848b1ce88e755b32$var$Mr(e, {
        width: "100%",
        height: "200px"
    }), $848b1ce88e755b32$var$Mr(t, {
        position: "absolute",
        top: "0px",
        left: "0px",
        visibility: "hidden",
        width: "200px",
        height: "150px",
        overflow: "hidden"
    }), t.appendChild(e), document.body.appendChild(t);
    let o = e.offsetWidth;
    t.style.overflow = "scroll";
    let r = e.offsetWidth;
    return o === r && (r = t.clientWidth), t.remove(), $848b1ce88e755b32$var$zl = o - r, $848b1ce88e755b32$var$zl;
}
function $848b1ce88e755b32$var$vc(e, t = !0) {
    return !e || e.nodeType !== Node.ELEMENT_NODE ? !1 : t ? e.scrollHeight > e.clientHeight && (e.classList.contains("scroll") || e.classList.contains("overflow-auto") || [
        "auto",
        "scroll"
    ].includes(window.getComputedStyle(e)["overflow-y"])) : e.scrollWidth > e.clientWidth && (e.classList.contains("scroll") || e.classList.contains("overflow-auto") || [
        "auto",
        "scroll"
    ].includes(window.getComputedStyle(e)["overflow-x"]));
}
var $848b1ce88e755b32$export$209876d7b1ac8f3 = {
    getScrollTarget: $848b1ce88e755b32$var$At,
    getScrollHeight: $848b1ce88e755b32$var$xi,
    getScrollWidth: $848b1ce88e755b32$var$dy,
    getVerticalScrollPosition: $848b1ce88e755b32$var$fo,
    getHorizontalScrollPosition: $848b1ce88e755b32$var$er,
    animVerticalScrollTo: $848b1ce88e755b32$var$fc,
    animHorizontalScrollTo: $848b1ce88e755b32$var$mc,
    setVerticalScrollPosition: $848b1ce88e755b32$var$un,
    setHorizontalScrollPosition: $848b1ce88e755b32$var$La,
    getScrollbarWidth: $848b1ce88e755b32$var$Pr,
    hasScrollbar: $848b1ce88e755b32$var$vc
};
var $848b1ce88e755b32$var$Ar = [], $848b1ce88e755b32$var$_i;
function $848b1ce88e755b32$var$my(e) {
    $848b1ce88e755b32$var$_i = e.keyCode === 27;
}
function $848b1ce88e755b32$var$vy() {
    $848b1ce88e755b32$var$_i === !0 && ($848b1ce88e755b32$var$_i = !1);
}
function $848b1ce88e755b32$var$gy(e) {
    $848b1ce88e755b32$var$_i === !0 && ($848b1ce88e755b32$var$_i = !1, $848b1ce88e755b32$var$wt(e, 27) === !0 && $848b1ce88e755b32$var$Ar[$848b1ce88e755b32$var$Ar.length - 1](e));
}
function $848b1ce88e755b32$var$Wf(e) {
    window[e]("keydown", $848b1ce88e755b32$var$my), window[e]("blur", $848b1ce88e755b32$var$vy), window[e]("keyup", $848b1ce88e755b32$var$gy), $848b1ce88e755b32$var$_i = !1;
}
function $848b1ce88e755b32$var$Ol(e) {
    $848b1ce88e755b32$var$Ce.is.desktop === !0 && ($848b1ce88e755b32$var$Ar.push(e), $848b1ce88e755b32$var$Ar.length === 1 && $848b1ce88e755b32$var$Wf("addEventListener"));
}
function $848b1ce88e755b32$var$Ci(e) {
    let t = $848b1ce88e755b32$var$Ar.indexOf(e);
    t !== -1 && ($848b1ce88e755b32$var$Ar.splice(t, 1), $848b1ce88e755b32$var$Ar.length === 0 && $848b1ce88e755b32$var$Wf("removeEventListener"));
}
var $848b1ce88e755b32$var$$r = [];
function $848b1ce88e755b32$var$Yf(e) {
    $848b1ce88e755b32$var$$r[$848b1ce88e755b32$var$$r.length - 1](e);
}
function $848b1ce88e755b32$var$wi(e) {
    $848b1ce88e755b32$var$Ce.is.desktop === !0 && ($848b1ce88e755b32$var$$r.push(e), $848b1ce88e755b32$var$$r.length === 1 && document.body.addEventListener("focusin", $848b1ce88e755b32$var$Yf));
}
function $848b1ce88e755b32$var$Er(e) {
    let t = $848b1ce88e755b32$var$$r.indexOf(e);
    t !== -1 && ($848b1ce88e755b32$var$$r.splice(t, 1), $848b1ce88e755b32$var$$r.length === 0 && document.body.removeEventListener("focusin", $848b1ce88e755b32$var$Yf));
}
var $848b1ce88e755b32$var$ki = null, { notPassiveCapture: $848b1ce88e755b32$var$Il } = $848b1ce88e755b32$var$Xe, $848b1ce88e755b32$var$Br = [];
function $848b1ce88e755b32$var$Hl(e) {
    $848b1ce88e755b32$var$ki !== null && (clearTimeout($848b1ce88e755b32$var$ki), $848b1ce88e755b32$var$ki = null);
    let t = e.target;
    if (t === void 0 || t.nodeType === 8 || t.classList.contains("no-pointer-events") === !0) return;
    let o = $848b1ce88e755b32$var$Zn.length - 1;
    for(; o >= 0;){
        let r = $848b1ce88e755b32$var$Zn[o].$;
        if (r.type.name === "QTooltip") {
            o--;
            continue;
        }
        if (r.type.name !== "QDialog") break;
        if (r.props.seamless !== !0) return;
        o--;
    }
    for(let r = $848b1ce88e755b32$var$Br.length - 1; r >= 0; r--){
        let n = $848b1ce88e755b32$var$Br[r];
        if ((n.anchorEl.value === null || n.anchorEl.value.contains(t) === !1) && (t === document.body || n.innerRef.value !== null && n.innerRef.value.contains(t) === !1)) e.qClickOutside = !0, n.onClickOutside(e);
        else return;
    }
}
function $848b1ce88e755b32$var$Nl(e) {
    $848b1ce88e755b32$var$Br.push(e), $848b1ce88e755b32$var$Br.length === 1 && (document.addEventListener("mousedown", $848b1ce88e755b32$var$Hl, $848b1ce88e755b32$var$Il), document.addEventListener("touchstart", $848b1ce88e755b32$var$Hl, $848b1ce88e755b32$var$Il));
}
function $848b1ce88e755b32$var$qi(e) {
    let t = $848b1ce88e755b32$var$Br.findIndex((o)=>o === e);
    t !== -1 && ($848b1ce88e755b32$var$Br.splice(t, 1), $848b1ce88e755b32$var$Br.length === 0 && ($848b1ce88e755b32$var$ki !== null && (clearTimeout($848b1ce88e755b32$var$ki), $848b1ce88e755b32$var$ki = null), document.removeEventListener("mousedown", $848b1ce88e755b32$var$Hl, $848b1ce88e755b32$var$Il), document.removeEventListener("touchstart", $848b1ce88e755b32$var$Hl, $848b1ce88e755b32$var$Il)));
}
var $848b1ce88e755b32$var$Xf, $848b1ce88e755b32$var$Gf;
function $848b1ce88e755b32$var$Ti(e) {
    let t = e.split(" ");
    return t.length !== 2 ? !1 : [
        "top",
        "center",
        "bottom"
    ].includes(t[0]) !== !0 ? (console.error("Anchor/Self position must start with one of top/center/bottom"), !1) : [
        "left",
        "middle",
        "right",
        "start",
        "end"
    ].includes(t[1]) !== !0 ? (console.error("Anchor/Self position must end with one of left/middle/right/start/end"), !1) : !0;
}
function $848b1ce88e755b32$var$Ql(e) {
    return e ? !(e.length !== 2 || typeof e[0] != "number" || typeof e[1] != "number") : !0;
}
var $848b1ce88e755b32$var$hc = {
    "start#ltr": "left",
    "start#rtl": "right",
    "end#ltr": "right",
    "end#rtl": "left"
};
[
    "left",
    "middle",
    "right"
].forEach((e)=>{
    $848b1ce88e755b32$var$hc[`${e}#ltr`] = e, $848b1ce88e755b32$var$hc[`${e}#rtl`] = e;
});
function $848b1ce88e755b32$var$Mi(e, t) {
    let o = e.split(" ");
    return {
        vertical: o[0],
        horizontal: $848b1ce88e755b32$var$hc[`${o[1]}#${t === !0 ? "rtl" : "ltr"}`]
    };
}
function $848b1ce88e755b32$var$hy(e, t) {
    let { top: o, left: r, right: n, bottom: i, width: a, height: l } = e.getBoundingClientRect();
    return t !== void 0 && (o -= t[1], r -= t[0], i += t[1], n += t[0], a += t[0], l += t[1]), {
        top: o,
        bottom: i,
        height: l,
        left: r,
        right: n,
        width: a,
        middle: r + (n - r) / 2,
        center: o + (i - o) / 2
    };
}
function $848b1ce88e755b32$var$py(e, t, o) {
    let { top: r, left: n } = e.getBoundingClientRect();
    return r += t.top, n += t.left, o !== void 0 && (r += o[1], n += o[0]), {
        top: r,
        bottom: r + 1,
        height: 1,
        left: n,
        right: n + 1,
        width: 1,
        middle: n,
        center: r
    };
}
function $848b1ce88e755b32$var$by(e, t) {
    return {
        top: 0,
        center: t / 2,
        bottom: t,
        left: 0,
        middle: e / 2,
        right: e
    };
}
function $848b1ce88e755b32$var$Zf(e, t, o, r) {
    return {
        top: e[o.vertical] - t[r.vertical],
        left: e[o.horizontal] - t[r.horizontal]
    };
}
function $848b1ce88e755b32$var$Fa(e, t = 0) {
    if (e.targetEl === null || e.anchorEl === null || t > 5) return;
    if (e.targetEl.offsetHeight === 0 || e.targetEl.offsetWidth === 0) {
        setTimeout(()=>{
            $848b1ce88e755b32$var$Fa(e, t + 1);
        }, 10);
        return;
    }
    let { targetEl: o, offset: r, anchorEl: n, anchorOrigin: i, selfOrigin: a, absoluteOffset: l, fit: s, cover: c, maxHeight: u, maxWidth: v } = e;
    if ($848b1ce88e755b32$var$Ce.is.ios === !0 && window.visualViewport !== void 0) {
        let P = document.body.style, { offsetLeft: $, offsetTop: L } = window.visualViewport;
        $ !== $848b1ce88e755b32$var$Xf && (P.setProperty("--q-pe-left", $ + "px"), $848b1ce88e755b32$var$Xf = $), L !== $848b1ce88e755b32$var$Gf && (P.setProperty("--q-pe-top", L + "px"), $848b1ce88e755b32$var$Gf = L);
    }
    let { scrollLeft: f, scrollTop: d } = o, m = l === void 0 ? $848b1ce88e755b32$var$hy(n, c === !0 ? [
        0,
        0
    ] : r) : $848b1ce88e755b32$var$py(n, l, r);
    Object.assign(o.style, {
        top: 0,
        left: 0,
        minWidth: null,
        minHeight: null,
        maxWidth: v || "100vw",
        maxHeight: u || "100vh",
        visibility: "visible"
    });
    let { offsetWidth: y, offsetHeight: p } = o, { elWidth: C, elHeight: b } = s === !0 || c === !0 ? {
        elWidth: Math.max(m.width, y),
        elHeight: c === !0 ? Math.max(m.height, p) : p
    } : {
        elWidth: y,
        elHeight: p
    }, h = {
        maxWidth: v,
        maxHeight: u
    };
    (s === !0 || c === !0) && (h.minWidth = m.width + "px", c === !0 && (h.minHeight = m.height + "px")), Object.assign(o.style, h);
    let g = $848b1ce88e755b32$var$by(C, b), S = $848b1ce88e755b32$var$Zf(m, g, i, a);
    if (l === void 0 || r === void 0) $848b1ce88e755b32$var$gc(S, m, g, i, a);
    else {
        let { top: P, left: $ } = S;
        $848b1ce88e755b32$var$gc(S, m, g, i, a);
        let L = !1;
        if (S.top !== P) {
            L = !0;
            let E = 2 * r[1];
            m.center = m.top -= E, m.bottom -= E + 2;
        }
        if (S.left !== $) {
            L = !0;
            let E = 2 * r[0];
            m.middle = m.left -= E, m.right -= E + 2;
        }
        L === !0 && (S = $848b1ce88e755b32$var$Zf(m, g, i, a), $848b1ce88e755b32$var$gc(S, m, g, i, a));
    }
    h = {
        top: S.top + "px",
        left: S.left + "px"
    }, S.maxHeight !== void 0 && (h.maxHeight = S.maxHeight + "px", m.height > S.maxHeight && (h.minHeight = h.maxHeight)), S.maxWidth !== void 0 && (h.maxWidth = S.maxWidth + "px", m.width > S.maxWidth && (h.minWidth = h.maxWidth)), Object.assign(o.style, h), o.scrollTop !== d && (o.scrollTop = d), o.scrollLeft !== f && (o.scrollLeft = f);
}
function $848b1ce88e755b32$var$gc(e, t, o, r, n) {
    let i = o.bottom, a = o.right, l = $848b1ce88e755b32$var$Pr(), s = window.innerHeight - l, c = document.body.clientWidth;
    if (e.top < 0 || e.top + i > s) {
        if (n.vertical === "center") e.top = t[r.vertical] > s / 2 ? Math.max(0, s - i) : 0, e.maxHeight = Math.min(i, s);
        else if (t[r.vertical] > s / 2) {
            let u = Math.min(s, r.vertical === "center" ? t.center : r.vertical === n.vertical ? t.bottom : t.top);
            e.maxHeight = Math.min(i, u), e.top = Math.max(0, u - i);
        } else e.top = Math.max(0, r.vertical === "center" ? t.center : r.vertical === n.vertical ? t.top : t.bottom), e.maxHeight = Math.min(i, s - e.top);
    }
    if (e.left < 0 || e.left + a > c) {
        if (e.maxWidth = Math.min(a, c), n.horizontal === "middle") e.left = t[r.horizontal] > c / 2 ? Math.max(0, c - a) : 0;
        else if (t[r.horizontal] > c / 2) {
            let u = Math.min(c, r.horizontal === "middle" ? t.middle : r.horizontal === n.horizontal ? t.right : t.left);
            e.maxWidth = Math.min(a, u), e.left = Math.max(0, u - e.maxWidth);
        } else e.left = Math.max(0, r.horizontal === "middle" ? t.middle : r.horizontal === n.horizontal ? t.left : t.right), e.maxWidth = Math.min(a, c - e.left);
    }
}
var $848b1ce88e755b32$export$73537802004a2118 = $848b1ce88e755b32$var$R({
    name: "QMenu",
    inheritAttrs: !1,
    props: {
        ...$848b1ce88e755b32$var$hi,
        ...$848b1ce88e755b32$var$Ao,
        ...$848b1ce88e755b32$var$he,
        ...$848b1ce88e755b32$var$ln,
        persistent: Boolean,
        autoClose: Boolean,
        separateClosePopup: Boolean,
        noRouteDismiss: Boolean,
        noRefocus: Boolean,
        noFocus: Boolean,
        fit: Boolean,
        cover: Boolean,
        square: Boolean,
        anchor: {
            type: String,
            validator: $848b1ce88e755b32$var$Ti
        },
        self: {
            type: String,
            validator: $848b1ce88e755b32$var$Ti
        },
        offset: {
            type: Array,
            validator: $848b1ce88e755b32$var$Ql
        },
        scrollTarget: {
            default: void 0
        },
        touchPosition: Boolean,
        maxHeight: {
            type: String,
            default: null
        },
        maxWidth: {
            type: String,
            default: null
        }
    },
    emits: [
        ...$848b1ce88e755b32$var$$o,
        "click",
        "escapeKey"
    ],
    setup (e, { slots: t, emit: o, attrs: r }) {
        let n = null, i, a, l, s = (0, $fVLUl.getCurrentInstance)(), { proxy: c } = s, { $q: u } = c, v = (0, $eayOh.ref)(null), f = (0, $eayOh.ref)(!1), d = (0, $eayOh.computed)(()=>e.persistent !== !0 && e.noRouteDismiss !== !0), m = $848b1ce88e755b32$var$pe(e, u), { registerTick: y, removeTick: p } = $848b1ce88e755b32$export$98bfbd4c9d834fed(), { registerTimeout: C } = $848b1ce88e755b32$export$d8e6abf214c9ec0f(), { transitionProps: b, transitionStyle: h } = $848b1ce88e755b32$var$Jn(e), { localScrollTarget: g, changeScrollEvent: S, unconfigureScrollTarget: P } = $848b1ce88e755b32$var$Vl(e, N), { anchorEl: $, canShow: L } = $848b1ce88e755b32$var$pi({
            showing: f
        }), { hide: E } = $848b1ce88e755b32$var$Eo({
            showing: f,
            canShow: L,
            handleShow: ie,
            handleHide: V,
            hideOnRouteChange: d,
            processOnMount: !0
        }), { showPortal: A, hidePortal: B, renderPortal: q } = $848b1ce88e755b32$var$Si(s, v, te, "menu"), x = {
            anchorEl: $,
            innerRef: v,
            onClickOutside (z) {
                if (e.persistent !== !0 && f.value === !0) return E(z), (z.type === "touchstart" || z.target.classList.contains("q-dialog__backdrop")) && $848b1ce88e755b32$var$Se(z), !0;
            }
        }, k = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$Mi(e.anchor || (e.cover === !0 ? "center middle" : "bottom start"), u.lang.rtl)), j = (0, $eayOh.computed)(()=>e.cover === !0 ? k.value : $848b1ce88e755b32$var$Mi(e.self || "top start", u.lang.rtl)), Q = (0, $eayOh.computed)(()=>(e.square === !0 ? " q-menu--square" : "") + (m.value === !0 ? " q-menu--dark q-dark" : "")), w = (0, $eayOh.computed)(()=>e.autoClose === !0 ? {
                onClick: I
            } : {}), H = (0, $eayOh.computed)(()=>f.value === !0 && e.persistent !== !0);
        (0, $eayOh.watch)(H, (z)=>{
            z === !0 ? ($848b1ce88e755b32$var$Ol(T), $848b1ce88e755b32$var$Nl(x)) : ($848b1ce88e755b32$var$Ci(T), $848b1ce88e755b32$var$qi(x));
        });
        function W() {
            $848b1ce88e755b32$var$Bo(()=>{
                let z = v.value;
                z && z.contains(document.activeElement) !== !0 && (z = z.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || z.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || z.querySelector("[autofocus], [data-autofocus]") || z, z.focus({
                    preventScroll: !0
                }));
            });
        }
        function ie(z) {
            if (n = e.noRefocus === !1 ? document.activeElement : null, $848b1ce88e755b32$var$wi(oe), A(), N(), i = void 0, z !== void 0 && (e.touchPosition || e.contextMenu)) {
                let ue = $848b1ce88e755b32$var$yt(z);
                if (ue.left !== void 0) {
                    let { top: _e, left: U } = $.value.getBoundingClientRect();
                    i = {
                        left: ue.left - U,
                        top: ue.top - _e
                    };
                }
            }
            a === void 0 && (a = (0, $eayOh.watch)(()=>u.screen.width + "|" + u.screen.height + "|" + e.self + "|" + e.anchor + "|" + u.lang.rtl, D)), e.noFocus !== !0 && document.activeElement.blur(), y(()=>{
                D(), e.noFocus !== !0 && W();
            }), C(()=>{
                u.platform.is.ios === !0 && (l = e.autoClose, v.value.click()), D(), A(!0), o("show", z);
            }, e.transitionDuration);
        }
        function V(z) {
            p(), B(), _(!0), n !== null && (z === void 0 || z.qClickOutside !== !0) && (((z && z.type.indexOf("key") === 0 ? n.closest('[tabindex]:not([tabindex^="-"])') : void 0) || n).focus(), n = null), C(()=>{
                B(!0), o("hide", z);
            }, e.transitionDuration);
        }
        function _(z) {
            i = void 0, a !== void 0 && (a(), a = void 0), (z === !0 || f.value === !0) && ($848b1ce88e755b32$var$Er(oe), P(), $848b1ce88e755b32$var$qi(x), $848b1ce88e755b32$var$Ci(T)), z !== !0 && (n = null);
        }
        function N() {
            ($.value !== null || e.scrollTarget !== void 0) && (g.value = $848b1ce88e755b32$var$At($.value, e.scrollTarget), S(g.value, D));
        }
        function I(z) {
            l !== !0 ? ($848b1ce88e755b32$var$sc(c, z), o("click", z)) : l = !1;
        }
        function oe(z) {
            H.value === !0 && e.noFocus !== !0 && $848b1ce88e755b32$var$Ll(v.value, z.target) !== !0 && W();
        }
        function T(z) {
            o("escapeKey"), E(z);
        }
        function D() {
            $848b1ce88e755b32$var$Fa({
                targetEl: v.value,
                offset: e.offset,
                anchorEl: $.value,
                anchorOrigin: k.value,
                selfOrigin: j.value,
                absoluteOffset: i,
                fit: e.fit,
                cover: e.cover,
                maxHeight: e.maxHeight,
                maxWidth: e.maxWidth
            });
        }
        function te() {
            return (0, $fVLUl.h)((0, $24349.Transition), b.value, ()=>f.value === !0 ? (0, $fVLUl.h)("div", {
                    role: "menu",
                    ...r,
                    ref: v,
                    tabindex: -1,
                    class: [
                        "q-menu q-position-engine scroll" + Q.value,
                        r.class
                    ],
                    style: [
                        r.style,
                        h.value
                    ],
                    ...w.value
                }, $848b1ce88e755b32$var$J(t.default)) : null);
        }
        return (0, $fVLUl.onBeforeUnmount)(_), Object.assign(c, {
            focus: W,
            updatePosition: D
        }), q;
    }
});
var $848b1ce88e755b32$var$pc, $848b1ce88e755b32$var$jl = 0, $848b1ce88e755b32$var$Kt = new Array(256);
for(let e = 0; e < 256; e++)$848b1ce88e755b32$var$Kt[e] = (e + 256).toString(16).substring(1);
var $848b1ce88e755b32$var$_y = (()=>{
    let e = typeof crypto < "u" ? crypto : typeof window < "u" ? window.crypto || window.msCrypto : void 0;
    if (e !== void 0) {
        if (e.randomBytes !== void 0) return e.randomBytes;
        if (e.getRandomValues !== void 0) return (t)=>{
            let o = new Uint8Array(t);
            return e.getRandomValues(o), o;
        };
    }
    return (t)=>{
        let o = [];
        for(let r = t; r > 0; r--)o.push(Math.floor(Math.random() * 256));
        return o;
    };
})(), $848b1ce88e755b32$var$om = 4096;
function $848b1ce88e755b32$export$e2a22331486dcca0() {
    ($848b1ce88e755b32$var$pc === void 0 || $848b1ce88e755b32$var$jl + 16 > $848b1ce88e755b32$var$om) && ($848b1ce88e755b32$var$jl = 0, $848b1ce88e755b32$var$pc = $848b1ce88e755b32$var$_y($848b1ce88e755b32$var$om));
    let e = Array.prototype.slice.call($848b1ce88e755b32$var$pc, $848b1ce88e755b32$var$jl, $848b1ce88e755b32$var$jl += 16);
    return e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128, $848b1ce88e755b32$var$Kt[e[0]] + $848b1ce88e755b32$var$Kt[e[1]] + $848b1ce88e755b32$var$Kt[e[2]] + $848b1ce88e755b32$var$Kt[e[3]] + "-" + $848b1ce88e755b32$var$Kt[e[4]] + $848b1ce88e755b32$var$Kt[e[5]] + "-" + $848b1ce88e755b32$var$Kt[e[6]] + $848b1ce88e755b32$var$Kt[e[7]] + "-" + $848b1ce88e755b32$var$Kt[e[8]] + $848b1ce88e755b32$var$Kt[e[9]] + "-" + $848b1ce88e755b32$var$Kt[e[10]] + $848b1ce88e755b32$var$Kt[e[11]] + $848b1ce88e755b32$var$Kt[e[12]] + $848b1ce88e755b32$var$Kt[e[13]] + $848b1ce88e755b32$var$Kt[e[14]] + $848b1ce88e755b32$var$Kt[e[15]];
}
function $848b1ce88e755b32$var$qy(e) {
    return e ?? null;
}
function $848b1ce88e755b32$var$nm(e, t) {
    return e ?? (t === !0 ? `f_${$848b1ce88e755b32$export$e2a22331486dcca0()}` : null);
}
function $848b1ce88e755b32$export$f680877a34711e37({ getValue: e, required: t = !0 } = {}) {
    if ($848b1ce88e755b32$var$bt.value === !0) {
        let o = e !== void 0 ? (0, $eayOh.ref)($848b1ce88e755b32$var$qy(e())) : (0, $eayOh.ref)(null);
        return t === !0 && o.value === null && (0, $fVLUl.onMounted)(()=>{
            o.value = `f_${$848b1ce88e755b32$export$e2a22331486dcca0()}`;
        }), e !== void 0 && (0, $eayOh.watch)(e, (r)=>{
            o.value = $848b1ce88e755b32$var$nm(r, t);
        }), o;
    }
    return e !== void 0 ? (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$nm(e(), t)) : (0, $eayOh.ref)(`f_${$848b1ce88e755b32$export$e2a22331486dcca0()}`);
}
var $848b1ce88e755b32$var$Ry = Object.keys($848b1ce88e755b32$var$$a);
function $848b1ce88e755b32$var$Py(e) {
    return $848b1ce88e755b32$var$Ry.reduce((t, o)=>{
        let r = e[o];
        return r !== void 0 && (t[o] = r), t;
    }, {});
}
var $848b1ce88e755b32$export$ed13f95342ac4309 = $848b1ce88e755b32$var$R({
    name: "QBtnDropdown",
    props: {
        ...$848b1ce88e755b32$var$$a,
        ...$848b1ce88e755b32$var$ln,
        modelValue: Boolean,
        split: Boolean,
        dropdownIcon: String,
        contentClass: [
            Array,
            String,
            Object
        ],
        contentStyle: [
            Array,
            String,
            Object
        ],
        cover: Boolean,
        persistent: Boolean,
        noRouteDismiss: Boolean,
        autoClose: Boolean,
        menuAnchor: {
            type: String,
            default: "bottom end"
        },
        menuSelf: {
            type: String,
            default: "top end"
        },
        menuOffset: Array,
        disableMainBtn: Boolean,
        disableDropdown: Boolean,
        noIconAnimation: Boolean,
        toggleAriaLabel: String
    },
    emits: [
        "update:modelValue",
        "click",
        "beforeShow",
        "show",
        "beforeHide",
        "hide"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: r } = (0, $fVLUl.getCurrentInstance)(), n = (0, $eayOh.ref)(e.modelValue), i = (0, $eayOh.ref)(null), a = $848b1ce88e755b32$export$f680877a34711e37(), l = (0, $eayOh.computed)(()=>{
            let g = {
                "aria-expanded": n.value === !0 ? "true" : "false",
                "aria-haspopup": "true",
                "aria-controls": a.value,
                "aria-label": e.toggleAriaLabel || r.$q.lang.label[n.value === !0 ? "collapse" : "expand"](e.label)
            };
            return (e.disable === !0 || e.split === !1 && e.disableMainBtn === !0 || e.disableDropdown === !0) && (g["aria-disabled"] = "true"), g;
        }), s = (0, $eayOh.computed)(()=>"q-btn-dropdown__arrow" + (n.value === !0 && e.noIconAnimation === !1 ? " rotate-180" : "") + (e.split === !1 ? " q-btn-dropdown__arrow-container" : "")), c = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$Dl(e)), u = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$Py(e));
        (0, $eayOh.watch)(()=>e.modelValue, (g)=>{
            i.value !== null && i.value[g ? "show" : "hide"]();
        }), (0, $eayOh.watch)(()=>e.split, h);
        function v(g) {
            n.value = !0, o("beforeShow", g);
        }
        function f(g) {
            o("show", g), o("update:modelValue", !0);
        }
        function d(g) {
            n.value = !1, o("beforeHide", g);
        }
        function m(g) {
            o("hide", g), o("update:modelValue", !1);
        }
        function y(g) {
            o("click", g);
        }
        function p(g) {
            $848b1ce88e755b32$var$tt(g), h(), o("click", g);
        }
        function C(g) {
            i.value !== null && i.value.toggle(g);
        }
        function b(g) {
            i.value !== null && i.value.show(g);
        }
        function h(g) {
            i.value !== null && i.value.hide(g);
        }
        return Object.assign(r, {
            show: b,
            hide: h,
            toggle: C
        }), (0, $fVLUl.onMounted)(()=>{
            e.modelValue === !0 && b();
        }), ()=>{
            let g = [
                (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                    class: s.value,
                    name: e.dropdownIcon || r.$q.iconSet.arrow.dropdown
                })
            ];
            return e.disableDropdown !== !0 && g.push((0, $fVLUl.h)($848b1ce88e755b32$export$73537802004a2118, {
                ref: i,
                id: a.value,
                class: e.contentClass,
                style: e.contentStyle,
                cover: e.cover,
                fit: !0,
                persistent: e.persistent,
                noRouteDismiss: e.noRouteDismiss,
                autoClose: e.autoClose,
                anchor: e.menuAnchor,
                self: e.menuSelf,
                offset: e.menuOffset,
                separateClosePopup: !0,
                transitionShow: e.transitionShow,
                transitionHide: e.transitionHide,
                transitionDuration: e.transitionDuration,
                onBeforeShow: v,
                onShow: f,
                onBeforeHide: d,
                onHide: m
            }, t.default)), e.split === !1 ? (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                class: "q-btn-dropdown q-btn-dropdown--simple",
                ...u.value,
                ...l.value,
                disable: e.disable === !0 || e.disableMainBtn === !0,
                noWrap: !0,
                round: !1,
                onClick: y
            }, {
                default: ()=>$848b1ce88e755b32$var$J(t.label, []).concat(g),
                loading: t.loading
            }) : (0, $fVLUl.h)($848b1ce88e755b32$export$ec40a025a653c83b, {
                class: "q-btn-dropdown q-btn-dropdown--split no-wrap q-btn-item",
                rounded: e.rounded,
                square: e.square,
                ...c.value,
                glossy: e.glossy,
                stretch: e.stretch
            }, ()=>[
                    (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                        class: "q-btn-dropdown--current",
                        ...u.value,
                        disable: e.disable === !0 || e.disableMainBtn === !0,
                        noWrap: !0,
                        round: !1,
                        onClick: p
                    }, {
                        default: t.label,
                        loading: t.loading
                    }),
                    (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                        class: "q-btn-dropdown__arrow-container q-anchor--skip",
                        ...l.value,
                        ...c.value,
                        disable: e.disable === !0 || e.disableDropdown === !0,
                        rounded: e.rounded,
                        color: e.color,
                        textColor: e.textColor,
                        dense: e.dense,
                        size: e.size,
                        padding: e.padding,
                        ripple: e.ripple
                    }, ()=>g)
                ]);
        };
    }
});
var $848b1ce88e755b32$var$_t = {
    name: String
};
function $848b1ce88e755b32$var$cn(e) {
    return (0, $eayOh.computed)(()=>({
            type: "hidden",
            name: e.name,
            value: e.modelValue
        }));
}
function $848b1ce88e755b32$var$eo(e = {}) {
    return (t, o, r)=>{
        t[o]((0, $fVLUl.h)("input", {
            class: "hidden" + (r || ""),
            ...e.value
        }));
    };
}
function $848b1ce88e755b32$var$Ai(e) {
    return (0, $eayOh.computed)(()=>e.name || e.for);
}
var $848b1ce88e755b32$export$1e5c1ca50ee4d96c = $848b1ce88e755b32$var$R({
    name: "QBtnToggle",
    props: {
        ...$848b1ce88e755b32$var$_t,
        modelValue: {
            required: !0
        },
        options: {
            type: Array,
            required: !0,
            validator: (e)=>e.every((t)=>("label" in t || "icon" in t || "slot" in t) && "value" in t)
        },
        color: String,
        textColor: String,
        toggleColor: {
            type: String,
            default: "primary"
        },
        toggleTextColor: String,
        outline: Boolean,
        flat: Boolean,
        unelevated: Boolean,
        rounded: Boolean,
        push: Boolean,
        glossy: Boolean,
        size: String,
        padding: String,
        noCaps: Boolean,
        noWrap: Boolean,
        dense: Boolean,
        readonly: Boolean,
        disable: Boolean,
        stack: Boolean,
        stretch: Boolean,
        spread: Boolean,
        clearable: Boolean,
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: !0
        }
    },
    emits: [
        "update:modelValue",
        "clear",
        "click"
    ],
    setup (e, { slots: t, emit: o }) {
        let r = (0, $eayOh.computed)(()=>e.options.find((f)=>f.value === e.modelValue) !== void 0), n = (0, $eayOh.computed)(()=>({
                type: "hidden",
                name: e.name,
                value: e.modelValue
            })), i = $848b1ce88e755b32$var$eo(n), a = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$Dl(e)), l = (0, $eayOh.computed)(()=>({
                rounded: e.rounded,
                dense: e.dense,
                ...a.value
            })), s = (0, $eayOh.computed)(()=>e.options.map((f, d)=>{
                let { attrs: m, value: y, slot: p, ...C } = f;
                return {
                    slot: p,
                    props: {
                        key: d,
                        "aria-pressed": y === e.modelValue ? "true" : "false",
                        ...m,
                        ...C,
                        ...l.value,
                        disable: e.disable === !0 || C.disable === !0,
                        color: y === e.modelValue ? u(C, "toggleColor") : u(C, "color"),
                        textColor: y === e.modelValue ? u(C, "toggleTextColor") : u(C, "textColor"),
                        noCaps: u(C, "noCaps") === !0,
                        noWrap: u(C, "noWrap") === !0,
                        size: u(C, "size"),
                        padding: u(C, "padding"),
                        ripple: u(C, "ripple"),
                        stack: u(C, "stack") === !0,
                        stretch: u(C, "stretch") === !0,
                        onClick (b) {
                            c(y, f, b);
                        }
                    }
                };
            }));
        function c(f, d, m) {
            e.readonly !== !0 && (e.modelValue === f ? e.clearable === !0 && (o("update:modelValue", null, null), o("clear")) : o("update:modelValue", f, d), o("click", m));
        }
        function u(f, d) {
            return f[d] === void 0 ? e[d] : f[d];
        }
        function v() {
            let f = s.value.map((d)=>(0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, d.props, d.slot !== void 0 ? t[d.slot] : void 0));
            return e.name !== void 0 && e.disable !== !0 && r.value === !0 && i(f, "push"), $848b1ce88e755b32$var$Ke(t.default, f);
        }
        return ()=>(0, $fVLUl.h)($848b1ce88e755b32$export$ec40a025a653c83b, {
                class: "q-btn-toggle",
                ...a.value,
                rounded: e.rounded,
                stretch: e.stretch,
                glossy: e.glossy,
                spread: e.spread
            }, v);
    }
});
var $848b1ce88e755b32$export$866037ffbc2a7c62 = $848b1ce88e755b32$var$R({
    name: "QCard",
    props: {
        ...$848b1ce88e755b32$var$he,
        tag: {
            type: String,
            default: "div"
        },
        square: Boolean,
        flat: Boolean,
        bordered: Boolean
    },
    setup (e, { slots: t }) {
        let { proxy: { $q: o } } = (0, $fVLUl.getCurrentInstance)(), r = $848b1ce88e755b32$var$pe(e, o), n = (0, $eayOh.computed)(()=>"q-card" + (r.value === !0 ? " q-card--dark q-dark" : "") + (e.bordered === !0 ? " q-card--bordered" : "") + (e.square === !0 ? " q-card--square no-border-radius" : "") + (e.flat === !0 ? " q-card--flat no-shadow" : ""));
        return ()=>(0, $fVLUl.h)(e.tag, {
                class: n.value
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$export$653482776a1a6c98 = $848b1ce88e755b32$var$R({
    name: "QCardSection",
    props: {
        tag: {
            type: String,
            default: "div"
        },
        horizontal: Boolean
    },
    setup (e, { slots: t }) {
        let o = (0, $eayOh.computed)(()=>`q-card__section q-card__section--${e.horizontal === !0 ? "horiz row no-wrap" : "vert"}`);
        return ()=>(0, $fVLUl.h)(e.tag, {
                class: o.value
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$export$8c05ea70037eac6a = $848b1ce88e755b32$var$R({
    name: "QCardActions",
    props: {
        ...$848b1ce88e755b32$var$li,
        vertical: Boolean
    },
    setup (e, { slots: t }) {
        let o = $848b1ce88e755b32$var$ui(e), r = (0, $eayOh.computed)(()=>`q-card__actions ${o.value} q-card__actions--${e.vertical === !0 ? "vert column" : "horiz row"}`);
        return ()=>(0, $fVLUl.h)("div", {
                class: r.value
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$var$yc = {
    left: !0,
    right: !0,
    up: !0,
    down: !0,
    horizontal: !0,
    vertical: !0
}, $848b1ce88e755b32$var$zy = Object.keys($848b1ce88e755b32$var$yc);
$848b1ce88e755b32$var$yc.all = !0;
function $848b1ce88e755b32$var$Ei(e) {
    let t = {};
    for (let o of $848b1ce88e755b32$var$zy)e[o] === !0 && (t[o] = !0);
    return Object.keys(t).length === 0 ? $848b1ce88e755b32$var$yc : (t.horizontal === !0 ? t.left = t.right = !0 : t.left === !0 && t.right === !0 && (t.horizontal = !0), t.vertical === !0 ? t.up = t.down = !0 : t.up === !0 && t.down === !0 && (t.vertical = !0), t.horizontal === !0 && t.vertical === !0 && (t.all = !0), t);
}
var $848b1ce88e755b32$var$Oy = [
    "INPUT",
    "TEXTAREA"
];
function $848b1ce88e755b32$var$Bi(e, t) {
    return t.event === void 0 && e.target !== void 0 && e.target.draggable !== !0 && typeof t.handler == "function" && $848b1ce88e755b32$var$Oy.includes(e.target.nodeName.toUpperCase()) === !1 && (e.qClonedBy === void 0 || e.qClonedBy.indexOf(t.uid) === -1);
}
function $848b1ce88e755b32$var$Iy(e) {
    let t = [
        .06,
        6,
        50
    ];
    return typeof e == "string" && e.length && e.split(":").forEach((o, r)=>{
        let n = parseFloat(o);
        n && (t[r] = n);
    }), t;
}
var $848b1ce88e755b32$export$945da4db66eba3a1 = $848b1ce88e755b32$var$Mt({
    name: "touch-swipe",
    beforeMount (e, { value: t, arg: o, modifiers: r }) {
        if (r.mouse !== !0 && $848b1ce88e755b32$var$Ce.has.touch !== !0) return;
        let n = r.mouseCapture === !0 ? "Capture" : "", i = {
            handler: t,
            sensitivity: $848b1ce88e755b32$var$Iy(o),
            direction: $848b1ce88e755b32$var$Ei(r),
            noop: $848b1ce88e755b32$export$8793edee2d425525,
            mouseStart (a) {
                $848b1ce88e755b32$var$Bi(a, i) && $848b1ce88e755b32$var$Tn(a) && ($848b1ce88e755b32$var$lt(i, "temp", [
                    [
                        document,
                        "mousemove",
                        "move",
                        `notPassive${n}`
                    ],
                    [
                        document,
                        "mouseup",
                        "end",
                        "notPassiveCapture"
                    ]
                ]), i.start(a, !0));
            },
            touchStart (a) {
                if ($848b1ce88e755b32$var$Bi(a, i)) {
                    let l = a.target;
                    $848b1ce88e755b32$var$lt(i, "temp", [
                        [
                            l,
                            "touchmove",
                            "move",
                            "notPassiveCapture"
                        ],
                        [
                            l,
                            "touchcancel",
                            "end",
                            "notPassiveCapture"
                        ],
                        [
                            l,
                            "touchend",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]), i.start(a);
                }
            },
            start (a, l) {
                $848b1ce88e755b32$var$Ce.is.firefox === !0 && $848b1ce88e755b32$var$Mn(e, !0);
                let s = $848b1ce88e755b32$var$yt(a);
                i.event = {
                    x: s.left,
                    y: s.top,
                    time: Date.now(),
                    mouse: l === !0,
                    dir: !1
                };
            },
            move (a) {
                if (i.event === void 0) return;
                if (i.event.dir !== !1) {
                    $848b1ce88e755b32$var$Se(a);
                    return;
                }
                let l = Date.now() - i.event.time;
                if (l === 0) return;
                let s = $848b1ce88e755b32$var$yt(a), c = s.left - i.event.x, u = Math.abs(c), v = s.top - i.event.y, f = Math.abs(v);
                if (i.event.mouse !== !0) {
                    if (u < i.sensitivity[1] && f < i.sensitivity[1]) {
                        i.end(a);
                        return;
                    }
                } else if (window.getSelection().toString() !== "") {
                    i.end(a);
                    return;
                } else if (u < i.sensitivity[2] && f < i.sensitivity[2]) return;
                let d = u / l, m = f / l;
                i.direction.vertical === !0 && u < f && u < 100 && m > i.sensitivity[0] && (i.event.dir = v < 0 ? "up" : "down"), i.direction.horizontal === !0 && u > f && f < 100 && d > i.sensitivity[0] && (i.event.dir = c < 0 ? "left" : "right"), i.direction.up === !0 && u < f && v < 0 && u < 100 && m > i.sensitivity[0] && (i.event.dir = "up"), i.direction.down === !0 && u < f && v > 0 && u < 100 && m > i.sensitivity[0] && (i.event.dir = "down"), i.direction.left === !0 && u > f && c < 0 && f < 100 && d > i.sensitivity[0] && (i.event.dir = "left"), i.direction.right === !0 && u > f && c > 0 && f < 100 && d > i.sensitivity[0] && (i.event.dir = "right"), i.event.dir !== !1 ? ($848b1ce88e755b32$var$Se(a), i.event.mouse === !0 && (document.body.classList.add("no-pointer-events--children"), document.body.classList.add("non-selectable"), $848b1ce88e755b32$var$Ut(), i.styleCleanup = (y)=>{
                    i.styleCleanup = void 0, document.body.classList.remove("non-selectable");
                    let p = ()=>{
                        document.body.classList.remove("no-pointer-events--children");
                    };
                    y === !0 ? setTimeout(p, 50) : p();
                }), i.handler({
                    evt: a,
                    touch: i.event.mouse !== !0,
                    mouse: i.event.mouse,
                    direction: i.event.dir,
                    duration: l,
                    distance: {
                        x: u,
                        y: f
                    }
                })) : i.end(a);
            },
            end (a) {
                i.event !== void 0 && ($848b1ce88e755b32$var$Ct(i, "temp"), $848b1ce88e755b32$var$Ce.is.firefox === !0 && $848b1ce88e755b32$var$Mn(e, !1), i.styleCleanup !== void 0 && i.styleCleanup(!0), a !== void 0 && i.event.dir !== !1 && $848b1ce88e755b32$var$Se(a), i.event = void 0);
            }
        };
        if (e.__qtouchswipe = i, r.mouse === !0) {
            let a = r.mouseCapture === !0 || r.mousecapture === !0 ? "Capture" : "";
            $848b1ce88e755b32$var$lt(i, "main", [
                [
                    e,
                    "mousedown",
                    "mouseStart",
                    `passive${a}`
                ]
            ]);
        }
        $848b1ce88e755b32$var$Ce.has.touch === !0 && $848b1ce88e755b32$var$lt(i, "main", [
            [
                e,
                "touchstart",
                "touchStart",
                `passive${r.capture === !0 ? "Capture" : ""}`
            ],
            [
                e,
                "touchmove",
                "noop",
                "notPassiveCapture"
            ]
        ]);
    },
    updated (e, t) {
        let o = e.__qtouchswipe;
        o !== void 0 && (t.oldValue !== t.value && (typeof t.value != "function" && o.end(), o.handler = t.value), o.direction = $848b1ce88e755b32$var$Ei(t.modifiers));
    },
    beforeUnmount (e) {
        let t = e.__qtouchswipe;
        t !== void 0 && ($848b1ce88e755b32$var$Ct(t, "main"), $848b1ce88e755b32$var$Ct(t, "temp"), $848b1ce88e755b32$var$Ce.is.firefox === !0 && $848b1ce88e755b32$var$Mn(e, !1), t.styleCleanup !== void 0 && t.styleCleanup(), delete e.__qtouchswipe);
    }
});
function $848b1ce88e755b32$export$1c2929d84167dd53() {
    let e = Object.create(null);
    return {
        getCache: (t, o)=>e[t] === void 0 ? e[t] = typeof o == "function" ? o() : o : e[t],
        setCache (t, o) {
            e[t] = o;
        },
        hasCache (t) {
            return Object.hasOwnProperty.call(e, t);
        },
        clearCache (t) {
            t !== void 0 ? delete e[t] : e = Object.create(null);
        }
    };
}
var $848b1ce88e755b32$var$Li = {
    name: {
        required: !0
    },
    disable: Boolean
}, $848b1ce88e755b32$var$cm = {
    setup (e, { slots: t }) {
        return ()=>(0, $fVLUl.h)("div", {
                class: "q-panel scroll",
                role: "tabpanel"
            }, $848b1ce88e755b32$var$J(t.default));
    }
}, $848b1ce88e755b32$var$Fi = {
    modelValue: {
        required: !0
    },
    animated: Boolean,
    infinite: Boolean,
    swipeable: Boolean,
    vertical: Boolean,
    transitionPrev: String,
    transitionNext: String,
    transitionDuration: {
        type: [
            String,
            Number
        ],
        default: 300
    },
    keepAlive: Boolean,
    keepAliveInclude: [
        String,
        Array,
        RegExp
    ],
    keepAliveExclude: [
        String,
        Array,
        RegExp
    ],
    keepAliveMax: Number
}, $848b1ce88e755b32$var$Di = [
    "update:modelValue",
    "beforeTransition",
    "transition"
];
function $848b1ce88e755b32$var$Vi() {
    let { props: e, emit: t, proxy: o } = (0, $fVLUl.getCurrentInstance)(), { getCache: r } = $848b1ce88e755b32$export$1c2929d84167dd53(), n, i, a = (0, $eayOh.ref)(null), l = (0, $eayOh.ref)(null);
    function s(x) {
        let k = e.vertical === !0 ? "up" : "left";
        $((o.$q.lang.rtl === !0 ? -1 : 1) * (x.direction === k ? 1 : -1));
    }
    let c = (0, $eayOh.computed)(()=>[
            [
                $848b1ce88e755b32$export$945da4db66eba3a1,
                s,
                void 0,
                {
                    horizontal: e.vertical !== !0,
                    vertical: e.vertical,
                    mouse: !0
                }
            ]
        ]), u = (0, $eayOh.computed)(()=>e.transitionPrev || `slide-${e.vertical === !0 ? "down" : "right"}`), v = (0, $eayOh.computed)(()=>e.transitionNext || `slide-${e.vertical === !0 ? "up" : "left"}`), f = (0, $eayOh.computed)(()=>`--q-transition-duration: ${e.transitionDuration}ms`), d = (0, $eayOh.computed)(()=>typeof e.modelValue == "string" || typeof e.modelValue == "number" ? e.modelValue : String(e.modelValue)), m = (0, $eayOh.computed)(()=>({
            include: e.keepAliveInclude,
            exclude: e.keepAliveExclude,
            max: e.keepAliveMax
        })), y = (0, $eayOh.computed)(()=>e.keepAliveInclude !== void 0 || e.keepAliveExclude !== void 0);
    (0, $eayOh.watch)(()=>e.modelValue, (x, k)=>{
        let j = h(x) === !0 ? g(x) : -1;
        i !== !0 && P(j === -1 ? 0 : j < g(k) ? -1 : 1), a.value !== j && (a.value = j, t("beforeTransition", x, k), (0, $fVLUl.nextTick)(()=>{
            t("transition", x, k);
        }));
    });
    function p() {
        $(1);
    }
    function C() {
        $(-1);
    }
    function b(x) {
        t("update:modelValue", x);
    }
    function h(x) {
        return x != null && x !== "";
    }
    function g(x) {
        return n.findIndex((k)=>k.props.name === x && k.props.disable !== "" && k.props.disable !== !0);
    }
    function S() {
        return n.filter((x)=>x.props.disable !== "" && x.props.disable !== !0);
    }
    function P(x) {
        let k = x !== 0 && e.animated === !0 && a.value !== -1 ? "q-transition--" + (x === -1 ? u.value : v.value) : null;
        l.value !== k && (l.value = k);
    }
    function $(x, k = a.value) {
        let j = k + x;
        for(; j !== -1 && j < n.length;){
            let Q = n[j];
            if (Q !== void 0 && Q.props.disable !== "" && Q.props.disable !== !0) {
                P(x), i = !0, t("update:modelValue", Q.props.name), setTimeout(()=>{
                    i = !1;
                });
                return;
            }
            j += x;
        }
        e.infinite === !0 && n.length !== 0 && k !== -1 && k !== n.length && $(x, x === -1 ? n.length : -1);
    }
    function L() {
        let x = g(e.modelValue);
        return a.value !== x && (a.value = x), !0;
    }
    function E() {
        let x = h(e.modelValue) === !0 && L() && n[a.value];
        return e.keepAlive === !0 ? [
            (0, $fVLUl.h)((0, $fVLUl.KeepAlive), m.value, [
                (0, $fVLUl.h)(y.value === !0 ? r(d.value, ()=>({
                        ...$848b1ce88e755b32$var$cm,
                        name: d.value
                    })) : $848b1ce88e755b32$var$cm, {
                    key: d.value,
                    style: f.value
                }, ()=>x)
            ])
        ] : [
            (0, $fVLUl.h)("div", {
                class: "q-panel scroll",
                style: f.value,
                key: d.value,
                role: "tabpanel"
            }, [
                x
            ])
        ];
    }
    function A() {
        if (n.length !== 0) return e.animated === !0 ? [
            (0, $fVLUl.h)((0, $24349.Transition), {
                name: l.value
            }, E)
        ] : E();
    }
    function B(x) {
        return n = $848b1ce88e755b32$var$si($848b1ce88e755b32$var$J(x.default, [])).filter((k)=>k.props !== null && k.props.slot === void 0 && h(k.props.name) === !0), n.length;
    }
    function q() {
        return n;
    }
    return Object.assign(o, {
        next: p,
        previous: C,
        goTo: b
    }), {
        panelIndex: a,
        panelDirectives: c,
        updatePanelsList: B,
        updatePanelIndex: L,
        getPanelContent: A,
        getEnabledPanels: S,
        getPanels: q,
        isValidPanelName: h,
        keepAliveProps: m,
        needsUniqueKeepAliveWrapper: y,
        goToPanelByOffset: $,
        goToPanel: b,
        nextPanel: p,
        previousPanel: C
    };
}
var $848b1ce88e755b32$var$za = 0, $848b1ce88e755b32$var$zi = {
    fullscreen: Boolean,
    noRouteFullscreenExit: Boolean
}, $848b1ce88e755b32$var$Oi = [
    "update:fullscreen",
    "fullscreen"
];
function $848b1ce88e755b32$var$Ii() {
    let e = (0, $fVLUl.getCurrentInstance)(), { props: t, emit: o, proxy: r } = e, n, i, a, l = (0, $eayOh.ref)(!1);
    $848b1ce88e755b32$var$ci(e) === !0 && (0, $eayOh.watch)(()=>r.$route.fullPath, ()=>{
        t.noRouteFullscreenExit !== !0 && u();
    }), (0, $eayOh.watch)(()=>t.fullscreen, (v)=>{
        l.value !== v && s();
    }), (0, $eayOh.watch)(l, (v)=>{
        o("update:fullscreen", v), o("fullscreen", v);
    });
    function s() {
        l.value === !0 ? u() : c();
    }
    function c() {
        l.value !== !0 && (l.value = !0, a = r.$el.parentNode, a.replaceChild(i, r.$el), document.body.appendChild(r.$el), $848b1ce88e755b32$var$za++, $848b1ce88e755b32$var$za === 1 && document.body.classList.add("q-body--fullscreen-mixin"), n = {
            handler: u
        }, $848b1ce88e755b32$var$Un.add(n));
    }
    function u() {
        l.value === !0 && (n !== void 0 && ($848b1ce88e755b32$var$Un.remove(n), n = void 0), a.replaceChild(r.$el, i), l.value = !1, $848b1ce88e755b32$var$za = Math.max(0, $848b1ce88e755b32$var$za - 1), $848b1ce88e755b32$var$za === 0 && (document.body.classList.remove("q-body--fullscreen-mixin"), r.$el.scrollIntoView !== void 0 && setTimeout(()=>{
            r.$el.scrollIntoView();
        })));
    }
    return (0, $fVLUl.onBeforeMount)(()=>{
        i = document.createElement("span");
    }), (0, $fVLUl.onMounted)(()=>{
        t.fullscreen === !0 && c();
    }), (0, $fVLUl.onBeforeUnmount)(u), Object.assign(r, {
        toggleFullscreen: s,
        setFullscreen: c,
        exitFullscreen: u
    }), {
        inFullscreen: l,
        toggleFullscreen: s
    };
}
var $848b1ce88e755b32$var$tS = [
    "top",
    "right",
    "bottom",
    "left"
], $848b1ce88e755b32$var$oS = [
    "regular",
    "flat",
    "outline",
    "push",
    "unelevated"
], $848b1ce88e755b32$export$ceb1843391966906 = $848b1ce88e755b32$var$R({
    name: "QCarousel",
    props: {
        ...$848b1ce88e755b32$var$he,
        ...$848b1ce88e755b32$var$Fi,
        ...$848b1ce88e755b32$var$zi,
        transitionPrev: {
            type: String,
            default: "fade"
        },
        transitionNext: {
            type: String,
            default: "fade"
        },
        height: String,
        padding: Boolean,
        controlColor: String,
        controlTextColor: String,
        controlType: {
            type: String,
            validator: (e)=>$848b1ce88e755b32$var$oS.includes(e),
            default: "flat"
        },
        autoplay: [
            Number,
            Boolean
        ],
        arrows: Boolean,
        prevIcon: String,
        nextIcon: String,
        navigation: Boolean,
        navigationPosition: {
            type: String,
            validator: (e)=>$848b1ce88e755b32$var$tS.includes(e)
        },
        navigationIcon: String,
        navigationActiveIcon: String,
        thumbnails: Boolean
    },
    emits: [
        ...$848b1ce88e755b32$var$Oi,
        ...$848b1ce88e755b32$var$Di
    ],
    setup (e, { slots: t }) {
        let { proxy: { $q: o } } = (0, $fVLUl.getCurrentInstance)(), r = $848b1ce88e755b32$var$pe(e, o), n = null, i, { updatePanelsList: a, getPanelContent: l, panelDirectives: s, goToPanel: c, previousPanel: u, nextPanel: v, getEnabledPanels: f, panelIndex: d } = $848b1ce88e755b32$var$Vi(), { inFullscreen: m } = $848b1ce88e755b32$var$Ii(), y = (0, $eayOh.computed)(()=>m.value !== !0 && e.height !== void 0 ? {
                height: e.height
            } : {}), p = (0, $eayOh.computed)(()=>e.vertical === !0 ? "vertical" : "horizontal"), C = (0, $eayOh.computed)(()=>`q-carousel q-panel-parent q-carousel--with${e.padding === !0 ? "" : "out"}-padding` + (m.value === !0 ? " fullscreen" : "") + (r.value === !0 ? " q-carousel--dark q-dark" : "") + (e.arrows === !0 ? ` q-carousel--arrows-${p.value}` : "") + (e.navigation === !0 ? ` q-carousel--navigation-${S.value}` : "")), b = (0, $eayOh.computed)(()=>{
            let A = [
                e.prevIcon || o.iconSet.carousel[e.vertical === !0 ? "up" : "left"],
                e.nextIcon || o.iconSet.carousel[e.vertical === !0 ? "down" : "right"]
            ];
            return e.vertical === !1 && o.lang.rtl === !0 ? A.reverse() : A;
        }), h = (0, $eayOh.computed)(()=>e.navigationIcon || o.iconSet.carousel.navigationIcon), g = (0, $eayOh.computed)(()=>e.navigationActiveIcon || h.value), S = (0, $eayOh.computed)(()=>e.navigationPosition || (e.vertical === !0 ? "right" : "bottom")), P = (0, $eayOh.computed)(()=>({
                color: e.controlColor,
                textColor: e.controlTextColor,
                round: !0,
                [e.controlType]: !0,
                dense: !0
            }));
        (0, $eayOh.watch)(()=>e.modelValue, ()=>{
            e.autoplay && $();
        }), (0, $eayOh.watch)(()=>e.autoplay, (A)=>{
            A ? $() : n !== null && (clearTimeout(n), n = null);
        });
        function $() {
            let A = $848b1ce88e755b32$var$Mo(e.autoplay) === !0 ? Math.abs(e.autoplay) : 5e3;
            n !== null && clearTimeout(n), n = setTimeout(()=>{
                n = null, A >= 0 ? v() : u();
            }, A);
        }
        (0, $fVLUl.onMounted)(()=>{
            e.autoplay && $();
        }), (0, $fVLUl.onBeforeUnmount)(()=>{
            n !== null && clearTimeout(n);
        });
        function L(A, B) {
            return (0, $fVLUl.h)("div", {
                class: `q-carousel__control q-carousel__navigation no-wrap absolute flex q-carousel__navigation--${A} q-carousel__navigation--${S.value}` + (e.controlColor !== void 0 ? ` text-${e.controlColor}` : "")
            }, [
                (0, $fVLUl.h)("div", {
                    class: "q-carousel__navigation-inner flex flex-center no-wrap"
                }, f().map(B))
            ]);
        }
        function E() {
            let A = [];
            if (e.navigation === !0) {
                let B = t["navigation-icon"] !== void 0 ? t["navigation-icon"] : (x)=>(0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                        key: "nav" + x.name,
                        class: `q-carousel__navigation-icon q-carousel__navigation-icon--${x.active === !0 ? "" : "in"}active`,
                        ...x.btnProps,
                        onClick: x.onClick
                    }), q = i - 1;
                A.push(L("buttons", (x, k)=>{
                    let j = x.props.name, Q = d.value === k;
                    return B({
                        index: k,
                        maxIndex: q,
                        name: j,
                        active: Q,
                        btnProps: {
                            icon: Q === !0 ? g.value : h.value,
                            size: "sm",
                            ...P.value
                        },
                        onClick: ()=>{
                            c(j);
                        }
                    });
                }));
            } else if (e.thumbnails === !0) {
                let B = e.controlColor !== void 0 ? ` text-${e.controlColor}` : "";
                A.push(L("thumbnails", (q)=>{
                    let x = q.props;
                    return (0, $fVLUl.h)("img", {
                        key: "tmb#" + x.name,
                        class: `q-carousel__thumbnail q-carousel__thumbnail--${x.name === e.modelValue ? "" : "in"}active` + B,
                        src: x.imgSrc || x["img-src"],
                        onClick: ()=>{
                            c(x.name);
                        }
                    });
                }));
            }
            return e.arrows === !0 && d.value >= 0 && ((e.infinite === !0 || d.value > 0) && A.push((0, $fVLUl.h)("div", {
                key: "prev",
                class: `q-carousel__control q-carousel__arrow q-carousel__prev-arrow q-carousel__prev-arrow--${p.value} absolute flex flex-center`
            }, [
                (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                    icon: b.value[0],
                    ...P.value,
                    onClick: u
                })
            ])), (e.infinite === !0 || d.value < i - 1) && A.push((0, $fVLUl.h)("div", {
                key: "next",
                class: `q-carousel__control q-carousel__arrow q-carousel__next-arrow q-carousel__next-arrow--${p.value} absolute flex flex-center`
            }, [
                (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                    icon: b.value[1],
                    ...P.value,
                    onClick: v
                })
            ]))), $848b1ce88e755b32$var$Ke(t.control, A);
        }
        return ()=>(i = a(t), (0, $fVLUl.h)("div", {
                class: C.value,
                style: y.value
            }, [
                $848b1ce88e755b32$var$kt("div", {
                    class: "q-carousel__slides-container"
                }, l(), "sl-cont", e.swipeable, ()=>s.value)
            ].concat(E())));
    }
});
var $848b1ce88e755b32$export$18e00ae665ca0ca8 = $848b1ce88e755b32$var$R({
    name: "QCarouselSlide",
    props: {
        ...$848b1ce88e755b32$var$Li,
        imgSrc: String
    },
    setup (e, { slots: t }) {
        let o = (0, $eayOh.computed)(()=>e.imgSrc ? {
                backgroundImage: `url("${e.imgSrc}")`
            } : {});
        return ()=>(0, $fVLUl.h)("div", {
                class: "q-carousel__slide",
                style: o.value
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$export$99b8110ff6b4a7c0 = $848b1ce88e755b32$var$R({
    name: "QCarouselControl",
    props: {
        position: {
            type: String,
            default: "bottom-right",
            validator: (e)=>[
                    "top-right",
                    "top-left",
                    "bottom-right",
                    "bottom-left",
                    "top",
                    "right",
                    "bottom",
                    "left"
                ].includes(e)
        },
        offset: {
            type: Array,
            default: ()=>[
                    18,
                    18
                ],
            validator: (e)=>e.length === 2
        }
    },
    setup (e, { slots: t }) {
        let o = (0, $eayOh.computed)(()=>`q-carousel__control absolute absolute-${e.position}`), r = (0, $eayOh.computed)(()=>({
                margin: `${e.offset[1]}px ${e.offset[0]}px`
            }));
        return ()=>(0, $fVLUl.h)("div", {
                class: o.value,
                style: r.value
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$export$f38b603ba263988 = $848b1ce88e755b32$var$R({
    name: "QChatMessage",
    props: {
        sent: Boolean,
        label: String,
        bgColor: String,
        textColor: String,
        name: String,
        avatar: String,
        text: Array,
        stamp: String,
        size: String,
        labelHtml: Boolean,
        nameHtml: Boolean,
        textHtml: Boolean,
        stampHtml: Boolean
    },
    setup (e, { slots: t }) {
        let o = (0, $eayOh.computed)(()=>e.sent === !0 ? "sent" : "received"), r = (0, $eayOh.computed)(()=>`q-message-text-content q-message-text-content--${o.value}` + (e.textColor !== void 0 ? ` text-${e.textColor}` : "")), n = (0, $eayOh.computed)(()=>`q-message-text q-message-text--${o.value}` + (e.bgColor !== void 0 ? ` text-${e.bgColor}` : "")), i = (0, $eayOh.computed)(()=>"q-message-container row items-end no-wrap" + (e.sent === !0 ? " reverse" : "")), a = (0, $eayOh.computed)(()=>e.size !== void 0 ? `col-${e.size}` : ""), l = (0, $eayOh.computed)(()=>({
                msg: e.textHtml === !0 ? "innerHTML" : "textContent",
                stamp: e.stampHtml === !0 ? "innerHTML" : "textContent",
                name: e.nameHtml === !0 ? "innerHTML" : "textContent",
                label: e.labelHtml === !0 ? "innerHTML" : "textContent"
            }));
        function s(u) {
            return t.stamp !== void 0 ? [
                u,
                (0, $fVLUl.h)("div", {
                    class: "q-message-stamp"
                }, t.stamp())
            ] : e.stamp ? [
                u,
                (0, $fVLUl.h)("div", {
                    class: "q-message-stamp",
                    [l.value.stamp]: e.stamp
                })
            ] : [
                u
            ];
        }
        function c(u, v) {
            let f = v === !0 ? u.length > 1 ? (d)=>d : (d)=>(0, $fVLUl.h)("div", [
                    d
                ]) : (d)=>(0, $fVLUl.h)("div", {
                    [l.value.msg]: d
                });
            return u.map((d, m)=>(0, $fVLUl.h)("div", {
                    key: m,
                    class: n.value
                }, [
                    (0, $fVLUl.h)("div", {
                        class: r.value
                    }, s(f(d)))
                ]));
        }
        return ()=>{
            let u = [];
            t.avatar !== void 0 ? u.push(t.avatar()) : e.avatar !== void 0 && u.push((0, $fVLUl.h)("img", {
                class: `q-message-avatar q-message-avatar--${o.value}`,
                src: e.avatar,
                "aria-hidden": "true"
            }));
            let v = [];
            t.name !== void 0 ? v.push((0, $fVLUl.h)("div", {
                class: `q-message-name q-message-name--${o.value}`
            }, t.name())) : e.name !== void 0 && v.push((0, $fVLUl.h)("div", {
                class: `q-message-name q-message-name--${o.value}`,
                [l.value.name]: e.name
            })), t.default !== void 0 ? v.push(c($848b1ce88e755b32$var$si(t.default()), !0)) : e.text !== void 0 && v.push(c(e.text)), u.push((0, $fVLUl.h)("div", {
                class: a.value
            }, v));
            let f = [];
            return t.label !== void 0 ? f.push((0, $fVLUl.h)("div", {
                class: "q-message-label"
            }, t.label())) : e.label !== void 0 && f.push((0, $fVLUl.h)("div", {
                class: "q-message-label",
                [l.value.label]: e.label
            })), f.push((0, $fVLUl.h)("div", {
                class: i.value
            }, u)), (0, $fVLUl.h)("div", {
                class: `q-message q-message-${o.value}`
            }, f);
        };
    }
});
function $848b1ce88e755b32$var$Xl(e, t) {
    let o = (0, $eayOh.ref)(null), r = (0, $eayOh.computed)(()=>e.disable === !0 ? null : (0, $fVLUl.h)("span", {
            ref: o,
            class: "no-outline",
            tabindex: -1
        }));
    function n(i) {
        let a = t.value;
        i !== void 0 && i.type.indexOf("key") === 0 ? a !== null && document.activeElement !== a && a.contains(document.activeElement) === !0 && a.focus() : o.value !== null && (i === void 0 || a !== null && a.contains(i.target) === !0) && o.value.focus();
    }
    return {
        refocusTargetEl: r,
        refocusTarget: n
    };
}
var $848b1ce88e755b32$var$Gl = {
    xs: 30,
    sm: 35,
    md: 40,
    lg: 50,
    xl: 60
};
var $848b1ce88e755b32$var$Zl = {
    ...$848b1ce88e755b32$var$he,
    ...$848b1ce88e755b32$var$Ot,
    ...$848b1ce88e755b32$var$_t,
    modelValue: {
        required: !0,
        default: null
    },
    val: {},
    trueValue: {
        default: !0
    },
    falseValue: {
        default: !1
    },
    indeterminateValue: {
        default: null
    },
    checkedIcon: String,
    uncheckedIcon: String,
    indeterminateIcon: String,
    toggleOrder: {
        type: String,
        validator: (e)=>e === "tf" || e === "ft"
    },
    toggleIndeterminate: Boolean,
    label: String,
    leftLabel: Boolean,
    color: String,
    keepColor: Boolean,
    dense: Boolean,
    disable: Boolean,
    tabindex: [
        String,
        Number
    ]
}, $848b1ce88e755b32$var$Jl = [
    "update:modelValue"
];
function $848b1ce88e755b32$var$eu(e, t) {
    let { props: o, slots: r, emit: n, proxy: i } = (0, $fVLUl.getCurrentInstance)(), { $q: a } = i, l = $848b1ce88e755b32$var$pe(o, a), s = (0, $eayOh.ref)(null), { refocusTargetEl: c, refocusTarget: u } = $848b1ce88e755b32$var$Xl(o, s), v = $848b1ce88e755b32$var$It(o, $848b1ce88e755b32$var$Gl), f = (0, $eayOh.computed)(()=>o.val !== void 0 && Array.isArray(o.modelValue)), d = (0, $eayOh.computed)(()=>{
        let q = (0, $eayOh.toRaw)(o.val);
        return f.value === !0 ? o.modelValue.findIndex((x)=>(0, $eayOh.toRaw)(x) === q) : -1;
    }), m = (0, $eayOh.computed)(()=>f.value === !0 ? d.value !== -1 : (0, $eayOh.toRaw)(o.modelValue) === (0, $eayOh.toRaw)(o.trueValue)), y = (0, $eayOh.computed)(()=>f.value === !0 ? d.value === -1 : (0, $eayOh.toRaw)(o.modelValue) === (0, $eayOh.toRaw)(o.falseValue)), p = (0, $eayOh.computed)(()=>m.value === !1 && y.value === !1), C = (0, $eayOh.computed)(()=>o.disable === !0 ? -1 : o.tabindex || 0), b = (0, $eayOh.computed)(()=>`q-${e} cursor-pointer no-outline row inline no-wrap items-center` + (o.disable === !0 ? " disabled" : "") + (l.value === !0 ? ` q-${e}--dark` : "") + (o.dense === !0 ? ` q-${e}--dense` : "") + (o.leftLabel === !0 ? " reverse" : "")), h = (0, $eayOh.computed)(()=>{
        let q = m.value === !0 ? "truthy" : y.value === !0 ? "falsy" : "indet", x = o.color !== void 0 && (o.keepColor === !0 || (e === "toggle" ? m.value === !0 : y.value !== !0)) ? ` text-${o.color}` : "";
        return `q-${e}__inner relative-position non-selectable q-${e}__inner--${q}${x}`;
    }), g = (0, $eayOh.computed)(()=>{
        let q = {
            type: "checkbox"
        };
        return o.name !== void 0 && Object.assign(q, {
            ".checked": m.value,
            "^checked": m.value === !0 ? "checked" : void 0,
            name: o.name,
            value: f.value === !0 ? o.val : o.trueValue
        }), q;
    }), S = $848b1ce88e755b32$var$eo(g), P = (0, $eayOh.computed)(()=>{
        let q = {
            tabindex: C.value,
            role: e === "toggle" ? "switch" : "checkbox",
            "aria-label": o.label,
            "aria-checked": p.value === !0 ? "mixed" : m.value === !0 ? "true" : "false"
        };
        return o.disable === !0 && (q["aria-disabled"] = "true"), q;
    });
    function $(q) {
        q !== void 0 && ($848b1ce88e755b32$var$Se(q), u(q)), o.disable !== !0 && n("update:modelValue", L(), q);
    }
    function L() {
        if (f.value === !0) {
            if (m.value === !0) {
                let q = o.modelValue.slice();
                return q.splice(d.value, 1), q;
            }
            return o.modelValue.concat([
                o.val
            ]);
        }
        if (m.value === !0) {
            if (o.toggleOrder !== "ft" || o.toggleIndeterminate === !1) return o.falseValue;
        } else if (y.value === !0) {
            if (o.toggleOrder === "ft" || o.toggleIndeterminate === !1) return o.trueValue;
        } else return o.toggleOrder !== "ft" ? o.trueValue : o.falseValue;
        return o.indeterminateValue;
    }
    function E(q) {
        (q.keyCode === 13 || q.keyCode === 32) && $848b1ce88e755b32$var$Se(q);
    }
    function A(q) {
        (q.keyCode === 13 || q.keyCode === 32) && $(q);
    }
    let B = t(m, p);
    return Object.assign(i, {
        toggle: $
    }), ()=>{
        let q = B();
        o.disable !== !0 && S(q, "unshift", ` q-${e}__native absolute q-ma-none q-pa-none`);
        let x = [
            (0, $fVLUl.h)("div", {
                class: h.value,
                style: v.value,
                "aria-hidden": "true"
            }, q)
        ];
        c.value !== null && x.push(c.value);
        let k = o.label !== void 0 ? $848b1ce88e755b32$var$Ke(r.default, [
            o.label
        ]) : $848b1ce88e755b32$var$J(r.default);
        return k !== void 0 && x.push((0, $fVLUl.h)("div", {
            class: `q-${e}__label q-anchor--skip`
        }, k)), (0, $fVLUl.h)("div", {
            ref: s,
            class: b.value,
            ...P.value,
            onClick: $,
            onKeydown: E,
            onKeyup: A
        }, x);
    };
}
var $848b1ce88e755b32$var$fS = (0, $fVLUl.h)("div", {
    key: "svg",
    class: "q-checkbox__bg absolute"
}, [
    (0, $fVLUl.h)("svg", {
        class: "q-checkbox__svg fit absolute-full",
        viewBox: "0 0 24 24"
    }, [
        (0, $fVLUl.h)("path", {
            class: "q-checkbox__truthy",
            fill: "none",
            d: "M1.73,12.91 8.1,19.28 22.79,4.59"
        }),
        (0, $fVLUl.h)("path", {
            class: "q-checkbox__indet",
            d: "M4,14H20V10H4"
        })
    ])
]), $848b1ce88e755b32$export$a3430661ad019cfb = $848b1ce88e755b32$var$R({
    name: "QCheckbox",
    props: $848b1ce88e755b32$var$Zl,
    emits: $848b1ce88e755b32$var$Jl,
    setup (e) {
        function t(o, r) {
            let n = (0, $eayOh.computed)(()=>(o.value === !0 ? e.checkedIcon : r.value === !0 ? e.indeterminateIcon : e.uncheckedIcon) || null);
            return ()=>n.value !== null ? [
                    (0, $fVLUl.h)("div", {
                        key: "icon",
                        class: "q-checkbox__icon-container absolute-full flex flex-center no-wrap"
                    }, [
                        (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                            class: "q-checkbox__icon",
                            name: n.value
                        })
                    ])
                ] : [
                    $848b1ce88e755b32$var$fS
                ];
        }
        return $848b1ce88e755b32$var$eu("checkbox", t);
    }
});
var $848b1ce88e755b32$var$vS = {
    xs: 8,
    sm: 10,
    md: 14,
    lg: 20,
    xl: 24
}, $848b1ce88e755b32$export$fe8abce8a0a972d6 = $848b1ce88e755b32$var$R({
    name: "QChip",
    props: {
        ...$848b1ce88e755b32$var$he,
        ...$848b1ce88e755b32$var$Ot,
        dense: Boolean,
        icon: String,
        iconRight: String,
        iconRemove: String,
        iconSelected: String,
        label: [
            String,
            Number
        ],
        color: String,
        textColor: String,
        modelValue: {
            type: Boolean,
            default: !0
        },
        selected: {
            type: Boolean,
            default: null
        },
        square: Boolean,
        outline: Boolean,
        clickable: Boolean,
        removable: Boolean,
        removeAriaLabel: String,
        tabindex: [
            String,
            Number
        ],
        disable: Boolean,
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: !0
        }
    },
    emits: [
        "update:modelValue",
        "update:selected",
        "remove",
        "click"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: { $q: r } } = (0, $fVLUl.getCurrentInstance)(), n = $848b1ce88e755b32$var$pe(e, r), i = $848b1ce88e755b32$var$It(e, $848b1ce88e755b32$var$vS), a = (0, $eayOh.computed)(()=>e.selected === !0 || e.icon !== void 0), l = (0, $eayOh.computed)(()=>e.selected === !0 ? e.iconSelected || r.iconSet.chip.selected : e.icon), s = (0, $eayOh.computed)(()=>e.iconRemove || r.iconSet.chip.remove), c = (0, $eayOh.computed)(()=>e.disable === !1 && (e.clickable === !0 || e.selected !== null)), u = (0, $eayOh.computed)(()=>{
            let p = e.outline === !0 && e.color || e.textColor;
            return "q-chip row inline no-wrap items-center" + (e.outline === !1 && e.color !== void 0 ? ` bg-${e.color}` : "") + (p ? ` text-${p} q-chip--colored` : "") + (e.disable === !0 ? " disabled" : "") + (e.dense === !0 ? " q-chip--dense" : "") + (e.outline === !0 ? " q-chip--outline" : "") + (e.selected === !0 ? " q-chip--selected" : "") + (c.value === !0 ? " q-chip--clickable cursor-pointer non-selectable q-hoverable" : "") + (e.square === !0 ? " q-chip--square" : "") + (n.value === !0 ? " q-chip--dark q-dark" : "");
        }), v = (0, $eayOh.computed)(()=>{
            let p = e.disable === !0 ? {
                tabindex: -1,
                "aria-disabled": "true"
            } : {
                tabindex: e.tabindex || 0
            }, C = {
                ...p,
                role: "button",
                "aria-hidden": "false",
                "aria-label": e.removeAriaLabel || r.lang.label.remove
            };
            return {
                chip: p,
                remove: C
            };
        });
        function f(p) {
            p.keyCode === 13 && d(p);
        }
        function d(p) {
            e.disable || (o("update:selected", !e.selected), o("click", p));
        }
        function m(p) {
            (p.keyCode === void 0 || p.keyCode === 13) && ($848b1ce88e755b32$var$Se(p), e.disable === !1 && (o("update:modelValue", !1), o("remove")));
        }
        function y() {
            let p = [];
            c.value === !0 && p.push((0, $fVLUl.h)("div", {
                class: "q-focus-helper"
            })), a.value === !0 && p.push((0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                class: "q-chip__icon q-chip__icon--left",
                name: l.value
            }));
            let C = e.label !== void 0 ? [
                (0, $fVLUl.h)("div", {
                    class: "ellipsis"
                }, [
                    e.label
                ])
            ] : void 0;
            return p.push((0, $fVLUl.h)("div", {
                class: "q-chip__content col row no-wrap items-center q-anchor--skip"
            }, $848b1ce88e755b32$var$ai(t.default, C))), e.iconRight && p.push((0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                class: "q-chip__icon q-chip__icon--right",
                name: e.iconRight
            })), e.removable === !0 && p.push((0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                class: "q-chip__icon q-chip__icon--remove cursor-pointer",
                name: s.value,
                ...v.value.remove,
                onClick: m,
                onKeyup: m
            })), p;
        }
        return ()=>{
            if (e.modelValue === !1) return;
            let p = {
                class: u.value,
                style: i.value
            };
            return c.value === !0 && Object.assign(p, v.value.chip, {
                onClick: d,
                onKeyup: f
            }), $848b1ce88e755b32$var$kt("div", p, y(), "ripple", e.ripple !== !1 && e.disable !== !0, ()=>[
                    [
                        $848b1ce88e755b32$export$9e9146f7e027fdaa,
                        e.ripple
                    ]
                ]);
        };
    }
});
var $848b1ce88e755b32$var$Oa = {
    ...$848b1ce88e755b32$var$Ot,
    min: {
        type: Number,
        default: 0
    },
    max: {
        type: Number,
        default: 100
    },
    color: String,
    centerColor: String,
    trackColor: String,
    fontSize: String,
    rounded: Boolean,
    thickness: {
        type: Number,
        default: .2,
        validator: (e)=>e >= 0 && e <= 1
    },
    angle: {
        type: Number,
        default: 0
    },
    showValue: Boolean,
    reverse: Boolean,
    instantFeedback: Boolean
};
var $848b1ce88e755b32$var$_c = 50, $848b1ce88e755b32$var$pm = 2 * $848b1ce88e755b32$var$_c, $848b1ce88e755b32$var$bm = $848b1ce88e755b32$var$pm * Math.PI, $848b1ce88e755b32$var$hS = Math.round($848b1ce88e755b32$var$bm * 1e3) / 1e3, $848b1ce88e755b32$export$3bbfcedf93eff7f7 = $848b1ce88e755b32$var$R({
    name: "QCircularProgress",
    props: {
        ...$848b1ce88e755b32$var$Oa,
        value: {
            type: Number,
            default: 0
        },
        animationSpeed: {
            type: [
                String,
                Number
            ],
            default: 600
        },
        indeterminate: Boolean
    },
    setup (e, { slots: t }) {
        let { proxy: { $q: o } } = (0, $fVLUl.getCurrentInstance)(), r = $848b1ce88e755b32$var$It(e), n = (0, $eayOh.computed)(()=>{
            let d = (o.lang.rtl === !0 ? -1 : 1) * e.angle;
            return {
                transform: e.reverse !== (o.lang.rtl === !0) ? `scale3d(-1, 1, 1) rotate3d(0, 0, 1, ${-90 - d}deg)` : `rotate3d(0, 0, 1, ${d - 90}deg)`
            };
        }), i = (0, $eayOh.computed)(()=>e.instantFeedback !== !0 && e.indeterminate !== !0 ? {
                transition: `stroke-dashoffset ${e.animationSpeed}ms ease 0s, stroke ${e.animationSpeed}ms ease`
            } : ""), a = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$pm / (1 - e.thickness / 2)), l = (0, $eayOh.computed)(()=>`${a.value / 2} ${a.value / 2} ${a.value} ${a.value}`), s = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$Ze(e.value, e.min, e.max)), c = (0, $eayOh.computed)(()=>e.max - e.min), u = (0, $eayOh.computed)(()=>e.thickness / 2 * a.value), v = (0, $eayOh.computed)(()=>{
            let d = (e.max - s.value) / c.value, m = e.rounded === !0 && s.value < e.max && d < .25 ? u.value / 2 * (1 - d / .25) : 0;
            return $848b1ce88e755b32$var$bm * d + m;
        });
        function f({ thickness: d, offset: m, color: y, cls: p, rounded: C }) {
            return (0, $fVLUl.h)("circle", {
                class: "q-circular-progress__" + p + (y !== void 0 ? ` text-${y}` : ""),
                style: i.value,
                fill: "transparent",
                stroke: "currentColor",
                "stroke-width": d,
                "stroke-dasharray": $848b1ce88e755b32$var$hS,
                "stroke-dashoffset": m,
                "stroke-linecap": C,
                cx: a.value,
                cy: a.value,
                r: $848b1ce88e755b32$var$_c
            });
        }
        return ()=>{
            let d = [];
            e.centerColor !== void 0 && e.centerColor !== "transparent" && d.push((0, $fVLUl.h)("circle", {
                class: `q-circular-progress__center text-${e.centerColor}`,
                fill: "currentColor",
                r: $848b1ce88e755b32$var$_c - u.value / 2,
                cx: a.value,
                cy: a.value
            })), e.trackColor !== void 0 && e.trackColor !== "transparent" && d.push(f({
                cls: "track",
                thickness: u.value,
                offset: 0,
                color: e.trackColor
            })), d.push(f({
                cls: "circle",
                thickness: u.value,
                offset: v.value,
                color: e.color,
                rounded: e.rounded === !0 ? "round" : void 0
            }));
            let m = [
                (0, $fVLUl.h)("svg", {
                    class: "q-circular-progress__svg",
                    style: n.value,
                    viewBox: l.value,
                    "aria-hidden": "true"
                }, d)
            ];
            return e.showValue === !0 && m.push((0, $fVLUl.h)("div", {
                class: "q-circular-progress__text absolute-full row flex-center content-center",
                style: {
                    fontSize: e.fontSize
                }
            }, t.default !== void 0 ? t.default() : [
                (0, $fVLUl.h)("div", s.value)
            ])), (0, $fVLUl.h)("div", {
                class: `q-circular-progress q-circular-progress--${e.indeterminate === !0 ? "in" : ""}determinate`,
                style: r.value,
                role: "progressbar",
                "aria-valuemin": e.min,
                "aria-valuemax": e.max,
                "aria-valuenow": e.indeterminate === !0 ? void 0 : s.value
            }, $848b1ce88e755b32$var$ai(t.internal, m));
        };
    }
});
function $848b1ce88e755b32$var$Cc(e, t, o) {
    let r = $848b1ce88e755b32$var$yt(e), n, i = r.left - t.event.x, a = r.top - t.event.y, l = Math.abs(i), s = Math.abs(a), c = t.direction;
    c.horizontal === !0 && c.vertical !== !0 ? n = i < 0 ? "left" : "right" : c.horizontal !== !0 && c.vertical === !0 ? n = a < 0 ? "up" : "down" : c.up === !0 && a < 0 ? (n = "up", l > s && (c.left === !0 && i < 0 ? n = "left" : c.right === !0 && i > 0 && (n = "right"))) : c.down === !0 && a > 0 ? (n = "down", l > s && (c.left === !0 && i < 0 ? n = "left" : c.right === !0 && i > 0 && (n = "right"))) : c.left === !0 && i < 0 ? (n = "left", l < s && (c.up === !0 && a < 0 ? n = "up" : c.down === !0 && a > 0 && (n = "down"))) : c.right === !0 && i > 0 && (n = "right", l < s && (c.up === !0 && a < 0 ? n = "up" : c.down === !0 && a > 0 && (n = "down")));
    let u = !1;
    if (n === void 0 && o === !1) {
        if (t.event.isFirst === !0 || t.event.lastDir === void 0) return {};
        n = t.event.lastDir, u = !0, n === "left" || n === "right" ? (r.left -= i, l = 0, i = 0) : (r.top -= a, s = 0, a = 0);
    }
    return {
        synthetic: u,
        payload: {
            evt: e,
            touch: t.event.mouse !== !0,
            mouse: t.event.mouse === !0,
            position: r,
            direction: n,
            isFirst: t.event.isFirst,
            isFinal: o === !0,
            duration: Date.now() - t.event.time,
            distance: {
                x: l,
                y: s
            },
            offset: {
                x: i,
                y: a
            },
            delta: {
                x: r.left - t.event.lastX,
                y: r.top - t.event.lastY
            }
        }
    };
}
var $848b1ce88e755b32$var$pS = 0, $848b1ce88e755b32$export$718797250d1e376 = $848b1ce88e755b32$var$Mt({
    name: "touch-pan",
    beforeMount (e, { value: t, modifiers: o }) {
        if (o.mouse !== !0 && $848b1ce88e755b32$var$Ce.has.touch !== !0) return;
        function r(i, a) {
            o.mouse === !0 && a === !0 ? $848b1ce88e755b32$var$Se(i) : (o.stop === !0 && $848b1ce88e755b32$var$tt(i), o.prevent === !0 && $848b1ce88e755b32$var$ut(i));
        }
        let n = {
            uid: "qvtp_" + $848b1ce88e755b32$var$pS++,
            handler: t,
            modifiers: o,
            direction: $848b1ce88e755b32$var$Ei(o),
            noop: $848b1ce88e755b32$export$8793edee2d425525,
            mouseStart (i) {
                $848b1ce88e755b32$var$Bi(i, n) && $848b1ce88e755b32$var$Tn(i) && ($848b1ce88e755b32$var$lt(n, "temp", [
                    [
                        document,
                        "mousemove",
                        "move",
                        "notPassiveCapture"
                    ],
                    [
                        document,
                        "mouseup",
                        "end",
                        "passiveCapture"
                    ]
                ]), n.start(i, !0));
            },
            touchStart (i) {
                if ($848b1ce88e755b32$var$Bi(i, n)) {
                    let a = i.target;
                    $848b1ce88e755b32$var$lt(n, "temp", [
                        [
                            a,
                            "touchmove",
                            "move",
                            "notPassiveCapture"
                        ],
                        [
                            a,
                            "touchcancel",
                            "end",
                            "passiveCapture"
                        ],
                        [
                            a,
                            "touchend",
                            "end",
                            "passiveCapture"
                        ]
                    ]), n.start(i);
                }
            },
            start (i, a) {
                if ($848b1ce88e755b32$var$Ce.is.firefox === !0 && $848b1ce88e755b32$var$Mn(e, !0), n.lastEvt = i, a === !0 || o.stop === !0) {
                    if (n.direction.all !== !0 && (a !== !0 || n.modifiers.mouseAllDir !== !0 && n.modifiers.mousealldir !== !0)) {
                        let c = i.type.indexOf("mouse") !== -1 ? new MouseEvent(i.type, i) : new TouchEvent(i.type, i);
                        i.defaultPrevented === !0 && $848b1ce88e755b32$var$ut(c), i.cancelBubble === !0 && $848b1ce88e755b32$var$tt(c), Object.assign(c, {
                            qKeyEvent: i.qKeyEvent,
                            qClickOutside: i.qClickOutside,
                            qAnchorHandled: i.qAnchorHandled,
                            qClonedBy: i.qClonedBy === void 0 ? [
                                n.uid
                            ] : i.qClonedBy.concat(n.uid)
                        }), n.initialEvent = {
                            target: i.target,
                            event: c
                        };
                    }
                    $848b1ce88e755b32$var$tt(i);
                }
                let { left: l, top: s } = $848b1ce88e755b32$var$yt(i);
                n.event = {
                    x: l,
                    y: s,
                    time: Date.now(),
                    mouse: a === !0,
                    detected: !1,
                    isFirst: !0,
                    isFinal: !1,
                    lastX: l,
                    lastY: s
                };
            },
            move (i) {
                if (n.event === void 0) return;
                let a = $848b1ce88e755b32$var$yt(i), l = a.left - n.event.x, s = a.top - n.event.y;
                if (l === 0 && s === 0) return;
                n.lastEvt = i;
                let c = n.event.mouse === !0, u = ()=>{
                    r(i, c);
                    let d;
                    o.preserveCursor !== !0 && o.preservecursor !== !0 && (d = document.documentElement.style.cursor || "", document.documentElement.style.cursor = "grabbing"), c === !0 && document.body.classList.add("no-pointer-events--children"), document.body.classList.add("non-selectable"), $848b1ce88e755b32$var$Ut(), n.styleCleanup = (m)=>{
                        if (n.styleCleanup = void 0, d !== void 0 && (document.documentElement.style.cursor = d), document.body.classList.remove("non-selectable"), c === !0) {
                            let y = ()=>{
                                document.body.classList.remove("no-pointer-events--children");
                            };
                            m !== void 0 ? setTimeout(()=>{
                                y(), m();
                            }, 50) : y();
                        } else m !== void 0 && m();
                    };
                };
                if (n.event.detected === !0) {
                    n.event.isFirst !== !0 && r(i, n.event.mouse);
                    let { payload: d, synthetic: m } = $848b1ce88e755b32$var$Cc(i, n, !1);
                    d !== void 0 && (n.handler(d) === !1 ? n.end(i) : (n.styleCleanup === void 0 && n.event.isFirst === !0 && u(), n.event.lastX = d.position.left, n.event.lastY = d.position.top, n.event.lastDir = m === !0 ? void 0 : d.direction, n.event.isFirst = !1));
                    return;
                }
                if (n.direction.all === !0 || c === !0 && (n.modifiers.mouseAllDir === !0 || n.modifiers.mousealldir === !0)) {
                    u(), n.event.detected = !0, n.move(i);
                    return;
                }
                let v = Math.abs(l), f = Math.abs(s);
                v !== f && (n.direction.horizontal === !0 && v > f || n.direction.vertical === !0 && v < f || n.direction.up === !0 && v < f && s < 0 || n.direction.down === !0 && v < f && s > 0 || n.direction.left === !0 && v > f && l < 0 || n.direction.right === !0 && v > f && l > 0 ? (n.event.detected = !0, n.move(i)) : n.end(i, !0));
            },
            end (i, a) {
                if (n.event !== void 0) {
                    if ($848b1ce88e755b32$var$Ct(n, "temp"), $848b1ce88e755b32$var$Ce.is.firefox === !0 && $848b1ce88e755b32$var$Mn(e, !1), a === !0) n.styleCleanup !== void 0 && n.styleCleanup(), n.event.detected !== !0 && n.initialEvent !== void 0 && n.initialEvent.target.dispatchEvent(n.initialEvent.event);
                    else if (n.event.detected === !0) {
                        n.event.isFirst === !0 && n.handler($848b1ce88e755b32$var$Cc(i === void 0 ? n.lastEvt : i, n).payload);
                        let { payload: l } = $848b1ce88e755b32$var$Cc(i === void 0 ? n.lastEvt : i, n, !0), s = ()=>{
                            n.handler(l);
                        };
                        n.styleCleanup !== void 0 ? n.styleCleanup(s) : s();
                    }
                    n.event = void 0, n.initialEvent = void 0, n.lastEvt = void 0;
                }
            }
        };
        if (e.__qtouchpan = n, o.mouse === !0) {
            let i = o.mouseCapture === !0 || o.mousecapture === !0 ? "Capture" : "";
            $848b1ce88e755b32$var$lt(n, "main", [
                [
                    e,
                    "mousedown",
                    "mouseStart",
                    `passive${i}`
                ]
            ]);
        }
        $848b1ce88e755b32$var$Ce.has.touch === !0 && $848b1ce88e755b32$var$lt(n, "main", [
            [
                e,
                "touchstart",
                "touchStart",
                `passive${o.capture === !0 ? "Capture" : ""}`
            ],
            [
                e,
                "touchmove",
                "noop",
                "notPassiveCapture"
            ]
        ]);
    },
    updated (e, t) {
        let o = e.__qtouchpan;
        o !== void 0 && (t.oldValue !== t.value && (typeof value != "function" && o.end(), o.handler = t.value), o.direction = $848b1ce88e755b32$var$Ei(t.modifiers));
    },
    beforeUnmount (e) {
        let t = e.__qtouchpan;
        t !== void 0 && (t.event !== void 0 && t.end(), $848b1ce88e755b32$var$Ct(t, "main"), $848b1ce88e755b32$var$Ct(t, "temp"), $848b1ce88e755b32$var$Ce.is.firefox === !0 && $848b1ce88e755b32$var$Mn(e, !1), t.styleCleanup !== void 0 && t.styleCleanup(), delete e.__qtouchpan);
    }
});
var $848b1ce88e755b32$var$ym = "q-slider__marker-labels", $848b1ce88e755b32$var$SS = (e)=>({
        value: e
    }), $848b1ce88e755b32$var$xS = ({ marker: e })=>(0, $fVLUl.h)("div", {
        key: e.value,
        style: e.style,
        class: e.classes
    }, e.label), $848b1ce88e755b32$var$Ia = [
    34,
    37,
    40,
    33,
    39,
    38
], $848b1ce88e755b32$var$ou = {
    ...$848b1ce88e755b32$var$he,
    ...$848b1ce88e755b32$var$_t,
    min: {
        type: Number,
        default: 0
    },
    max: {
        type: Number,
        default: 100
    },
    innerMin: Number,
    innerMax: Number,
    step: {
        type: Number,
        default: 1,
        validator: (e)=>e >= 0
    },
    snap: Boolean,
    vertical: Boolean,
    reverse: Boolean,
    hideSelection: Boolean,
    color: String,
    markerLabelsClass: String,
    label: Boolean,
    labelColor: String,
    labelTextColor: String,
    labelAlways: Boolean,
    switchLabelSide: Boolean,
    markers: [
        Boolean,
        Number
    ],
    markerLabels: [
        Boolean,
        Array,
        Object,
        Function
    ],
    switchMarkerLabelsSide: Boolean,
    trackImg: String,
    trackColor: String,
    innerTrackImg: String,
    innerTrackColor: String,
    selectionColor: String,
    selectionImg: String,
    thumbSize: {
        type: String,
        default: "20px"
    },
    trackSize: {
        type: String,
        default: "4px"
    },
    disable: Boolean,
    readonly: Boolean,
    dense: Boolean,
    tabindex: [
        String,
        Number
    ],
    thumbColor: String,
    thumbPath: {
        type: String,
        default: "M 4, 10 a 6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"
    }
}, $848b1ce88e755b32$var$nu = [
    "pan",
    "update:modelValue",
    "change"
];
function $848b1ce88e755b32$var$ru({ updateValue: e, updatePosition: t, getDragging: o, formAttrs: r }) {
    let { props: n, emit: i, slots: a, proxy: { $q: l } } = (0, $fVLUl.getCurrentInstance)(), s = $848b1ce88e755b32$var$pe(n, l), c = $848b1ce88e755b32$var$eo(r), u = (0, $eayOh.ref)(!1), v = (0, $eayOh.ref)(!1), f = (0, $eayOh.ref)(!1), d = (0, $eayOh.ref)(!1), m = (0, $eayOh.computed)(()=>n.vertical === !0 ? "--v" : "--h"), y = (0, $eayOh.computed)(()=>"-" + (n.switchLabelSide === !0 ? "switched" : "standard")), p = (0, $eayOh.computed)(()=>n.vertical === !0 ? n.reverse === !0 : n.reverse !== (l.lang.rtl === !0)), C = (0, $eayOh.computed)(()=>isNaN(n.innerMin) === !0 || n.innerMin < n.min ? n.min : n.innerMin), b = (0, $eayOh.computed)(()=>isNaN(n.innerMax) === !0 || n.innerMax > n.max ? n.max : n.innerMax), h = (0, $eayOh.computed)(()=>n.disable !== !0 && n.readonly !== !0 && C.value < b.value), g = (0, $eayOh.computed)(()=>{
        if (n.step === 0) return (ee)=>ee;
        let K = (String(n.step).trim().split(".")[1] || "").length;
        return (ee)=>parseFloat(ee.toFixed(K));
    }), S = (0, $eayOh.computed)(()=>n.step === 0 ? 1 : n.step), P = (0, $eayOh.computed)(()=>h.value === !0 ? n.tabindex || 0 : -1), $ = (0, $eayOh.computed)(()=>n.max - n.min), L = (0, $eayOh.computed)(()=>b.value - C.value), E = (0, $eayOh.computed)(()=>_e(C.value)), A = (0, $eayOh.computed)(()=>_e(b.value)), B = (0, $eayOh.computed)(()=>n.vertical === !0 ? p.value === !0 ? "bottom" : "top" : p.value === !0 ? "right" : "left"), q = (0, $eayOh.computed)(()=>n.vertical === !0 ? "height" : "width"), x = (0, $eayOh.computed)(()=>n.vertical === !0 ? "width" : "height"), k = (0, $eayOh.computed)(()=>n.vertical === !0 ? "vertical" : "horizontal"), j = (0, $eayOh.computed)(()=>{
        let K = {
            role: "slider",
            "aria-valuemin": C.value,
            "aria-valuemax": b.value,
            "aria-orientation": k.value,
            "data-step": n.step
        };
        return n.disable === !0 ? K["aria-disabled"] = "true" : n.readonly === !0 && (K["aria-readonly"] = "true"), K;
    }), Q = (0, $eayOh.computed)(()=>`q-slider q-slider${m.value} q-slider--${u.value === !0 ? "" : "in"}active inline no-wrap ` + (n.vertical === !0 ? "row" : "column") + (n.disable === !0 ? " disabled" : " q-slider--enabled" + (h.value === !0 ? " q-slider--editable" : "")) + (f.value === "both" ? " q-slider--focus" : "") + (n.label || n.labelAlways === !0 ? " q-slider--label" : "") + (n.labelAlways === !0 ? " q-slider--label-always" : "") + (s.value === !0 ? " q-slider--dark" : "") + (n.dense === !0 ? " q-slider--dense q-slider--dense" + m.value : ""));
    function w(K) {
        let ee = "q-slider__" + K;
        return `${ee} ${ee}${m.value} ${ee}${m.value}${y.value}`;
    }
    function H(K) {
        let ee = "q-slider__" + K;
        return `${ee} ${ee}${m.value}`;
    }
    let W = (0, $eayOh.computed)(()=>{
        let K = n.selectionColor || n.color;
        return "q-slider__selection absolute" + (K !== void 0 ? ` text-${K}` : "");
    }), ie = (0, $eayOh.computed)(()=>H("markers") + " absolute overflow-hidden"), V = (0, $eayOh.computed)(()=>H("track-container")), _ = (0, $eayOh.computed)(()=>w("pin")), N = (0, $eayOh.computed)(()=>w("label")), I = (0, $eayOh.computed)(()=>w("text-container")), oe = (0, $eayOh.computed)(()=>w("marker-labels-container") + (n.markerLabelsClass !== void 0 ? ` ${n.markerLabelsClass}` : "")), T = (0, $eayOh.computed)(()=>"q-slider__track relative-position no-outline" + (n.trackColor !== void 0 ? ` bg-${n.trackColor}` : "")), D = (0, $eayOh.computed)(()=>{
        let K = {
            [x.value]: n.trackSize
        };
        return n.trackImg !== void 0 && (K.backgroundImage = `url(${n.trackImg}) !important`), K;
    }), te = (0, $eayOh.computed)(()=>"q-slider__inner absolute" + (n.innerTrackColor !== void 0 ? ` bg-${n.innerTrackColor}` : "")), z = (0, $eayOh.computed)(()=>{
        let K = A.value - E.value, ee = {
            [B.value]: `${100 * E.value}%`,
            [q.value]: K === 0 ? "2px" : `${100 * K}%`
        };
        return n.innerTrackImg !== void 0 && (ee.backgroundImage = `url(${n.innerTrackImg}) !important`), ee;
    });
    function ue(K) {
        let { min: ee, max: ke, step: ze } = n, ye = ee + K * (ke - ee);
        if (ze > 0) {
            let Ge = (ye - C.value) % ze;
            ye += (Math.abs(Ge) >= ze / 2 ? (Ge < 0 ? -1 : 1) * ze : 0) - Ge;
        }
        return ye = g.value(ye), $848b1ce88e755b32$var$Ze(ye, C.value, b.value);
    }
    function _e(K) {
        return $.value === 0 ? 0 : (K - n.min) / $.value;
    }
    function U(K, ee) {
        let ke = $848b1ce88e755b32$var$yt(K), ze = n.vertical === !0 ? $848b1ce88e755b32$var$Ze((ke.top - ee.top) / ee.height, 0, 1) : $848b1ce88e755b32$var$Ze((ke.left - ee.left) / ee.width, 0, 1);
        return $848b1ce88e755b32$var$Ze(p.value === !0 ? 1 - ze : ze, E.value, A.value);
    }
    let ae = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$Mo(n.markers) === !0 ? n.markers : S.value), ce = (0, $eayOh.computed)(()=>{
        let K = [], ee = ae.value, ke = n.max, ze = n.min;
        do K.push(ze), ze += ee;
        while (ze < ke);
        return K.push(ke), K;
    }), be = (0, $eayOh.computed)(()=>{
        let K = ` ${$848b1ce88e755b32$var$ym}${m.value}-`;
        return $848b1ce88e755b32$var$ym + `${K}${n.switchMarkerLabelsSide === !0 ? "switched" : "standard"}${K}${p.value === !0 ? "rtl" : "ltr"}`;
    }), Me = (0, $eayOh.computed)(()=>n.markerLabels === !1 ? null : Fe(n.markerLabels).map((K, ee)=>({
                index: ee,
                value: K.value,
                label: K.label || K.value,
                classes: be.value + (K.classes !== void 0 ? " " + K.classes : ""),
                style: {
                    ...De(K.value),
                    ...K.style || {}
                }
            }))), le = (0, $eayOh.computed)(()=>({
            markerList: Me.value,
            markerMap: ne.value,
            classes: be.value,
            getStyle: De
        })), Re = (0, $eayOh.computed)(()=>{
        let K = L.value === 0 ? "2px" : 100 * ae.value / L.value;
        return {
            ...z.value,
            backgroundSize: n.vertical === !0 ? `2px ${K}%` : `${K}% 2px`
        };
    });
    function Fe(K) {
        if (K === !1) return null;
        if (K === !0) return ce.value.map($848b1ce88e755b32$var$SS);
        if (typeof K == "function") return ce.value.map((ke)=>{
            let ze = K(ke);
            return $848b1ce88e755b32$var$at(ze) === !0 ? {
                ...ze,
                value: ke
            } : {
                value: ke,
                label: ze
            };
        });
        let ee = ({ value: ke })=>ke >= n.min && ke <= n.max;
        return Array.isArray(K) === !0 ? K.map((ke)=>$848b1ce88e755b32$var$at(ke) === !0 ? ke : {
                value: ke
            }).filter(ee) : Object.keys(K).map((ke)=>{
            let ze = K[ke], ye = Number(ke);
            return $848b1ce88e755b32$var$at(ze) === !0 ? {
                ...ze,
                value: ye
            } : {
                value: ye,
                label: ze
            };
        }).filter(ee);
    }
    function De(K) {
        return {
            [B.value]: `${100 * (K - n.min) / $.value}%`
        };
    }
    let ne = (0, $eayOh.computed)(()=>{
        if (n.markerLabels === !1) return null;
        let K = {};
        return Me.value.forEach((ee)=>{
            K[ee.value] = ee;
        }), K;
    });
    function se() {
        if (a["marker-label-group"] !== void 0) return a["marker-label-group"](le.value);
        let K = a["marker-label"] || $848b1ce88e755b32$var$xS;
        return Me.value.map((ee)=>K({
                marker: ee,
                ...le.value
            }));
    }
    let Y = (0, $eayOh.computed)(()=>[
            [
                $848b1ce88e755b32$export$718797250d1e376,
                me,
                void 0,
                {
                    [k.value]: !0,
                    prevent: !0,
                    stop: !0,
                    mouse: !0,
                    mouseAllDir: !0
                }
            ]
        ]);
    function me(K) {
        K.isFinal === !0 ? (d.value !== void 0 && (t(K.evt), K.touch === !0 && e(!0), d.value = void 0, i("pan", "end")), u.value = !1, f.value = !1) : K.isFirst === !0 ? (d.value = o(K.evt), t(K.evt), e(), u.value = !0, i("pan", "start")) : (t(K.evt), e());
    }
    function Pe() {
        f.value = !1;
    }
    function Ee(K) {
        t(K, o(K)), e(), v.value = !0, u.value = !0, document.addEventListener("mouseup", Ae, !0);
    }
    function Ae() {
        v.value = !1, u.value = !1, e(!0), Pe(), document.removeEventListener("mouseup", Ae, !0);
    }
    function nt(K) {
        t(K, o(K)), e(!0);
    }
    function ct(K) {
        $848b1ce88e755b32$var$Ia.includes(K.keyCode) && e(!0);
    }
    function dt(K) {
        if (n.vertical === !0) return null;
        let ee = l.lang.rtl !== n.reverse ? 1 - K : K;
        return {
            transform: `translateX(calc(${2 * ee - 1} * ${n.thumbSize} / 2 + ${50 - 100 * ee}%))`
        };
    }
    function G(K) {
        let ee = (0, $eayOh.computed)(()=>v.value === !1 && (f.value === K.focusValue || f.value === "both") ? " q-slider--focus" : ""), ke = (0, $eayOh.computed)(()=>`q-slider__thumb q-slider__thumb${m.value} q-slider__thumb${m.value}-${p.value === !0 ? "rtl" : "ltr"} absolute non-selectable` + ee.value + (K.thumbColor.value !== void 0 ? ` text-${K.thumbColor.value}` : "")), ze = (0, $eayOh.computed)(()=>({
                width: n.thumbSize,
                height: n.thumbSize,
                [B.value]: `${100 * K.ratio.value}%`,
                zIndex: f.value === K.focusValue ? 2 : void 0
            })), ye = (0, $eayOh.computed)(()=>K.labelColor.value !== void 0 ? ` text-${K.labelColor.value}` : ""), Ge = (0, $eayOh.computed)(()=>dt(K.ratio.value)), mt = (0, $eayOh.computed)(()=>"q-slider__text" + (K.labelTextColor.value !== void 0 ? ` text-${K.labelTextColor.value}` : ""));
        return ()=>{
            let ht = [
                (0, $fVLUl.h)("svg", {
                    class: "q-slider__thumb-shape absolute-full",
                    viewBox: "0 0 20 20",
                    "aria-hidden": "true"
                }, [
                    (0, $fVLUl.h)("path", {
                        d: n.thumbPath
                    })
                ]),
                (0, $fVLUl.h)("div", {
                    class: "q-slider__focus-ring fit"
                })
            ];
            return (n.label === !0 || n.labelAlways === !0) && (ht.push((0, $fVLUl.h)("div", {
                class: _.value + " absolute fit no-pointer-events" + ye.value
            }, [
                (0, $fVLUl.h)("div", {
                    class: N.value,
                    style: {
                        minWidth: n.thumbSize
                    }
                }, [
                    (0, $fVLUl.h)("div", {
                        class: I.value,
                        style: Ge.value
                    }, [
                        (0, $fVLUl.h)("span", {
                            class: mt.value
                        }, K.label.value)
                    ])
                ])
            ])), n.name !== void 0 && n.disable !== !0 && c(ht, "push")), (0, $fVLUl.h)("div", {
                class: ke.value,
                style: ze.value,
                ...K.getNodeData()
            }, ht);
        };
    }
    function re(K, ee, ke, ze) {
        let ye = [];
        n.innerTrackColor !== "transparent" && ye.push((0, $fVLUl.h)("div", {
            key: "inner",
            class: te.value,
            style: z.value
        })), n.selectionColor !== "transparent" && ye.push((0, $fVLUl.h)("div", {
            key: "selection",
            class: W.value,
            style: K.value
        })), n.markers !== !1 && ye.push((0, $fVLUl.h)("div", {
            key: "marker",
            class: ie.value,
            style: Re.value
        })), ze(ye);
        let Ge = [
            $848b1ce88e755b32$var$kt("div", {
                key: "trackC",
                class: V.value,
                tabindex: ee.value,
                ...ke.value
            }, [
                (0, $fVLUl.h)("div", {
                    class: T.value,
                    style: D.value
                }, ye)
            ], "slide", h.value, ()=>Y.value)
        ];
        if (n.markerLabels !== !1) {
            let mt = n.switchMarkerLabelsSide === !0 ? "unshift" : "push";
            Ge[mt]((0, $fVLUl.h)("div", {
                key: "markerL",
                class: oe.value
            }, se()));
        }
        return Ge;
    }
    return (0, $fVLUl.onBeforeUnmount)(()=>{
        document.removeEventListener("mouseup", Ae, !0);
    }), {
        state: {
            active: u,
            focus: f,
            preventFocus: v,
            dragging: d,
            editable: h,
            classes: Q,
            tabindex: P,
            attributes: j,
            roundValueFn: g,
            keyStep: S,
            trackLen: $,
            innerMin: C,
            innerMinRatio: E,
            innerMax: b,
            innerMaxRatio: A,
            positionProp: B,
            sizeProp: q,
            isReversed: p
        },
        methods: {
            onActivate: Ee,
            onMobileClick: nt,
            onBlur: Pe,
            onKeyup: ct,
            getContent: re,
            getThumbRenderFn: G,
            convertRatioToModel: ue,
            convertModelToRatio: _e,
            getDraggingRatio: U
        }
    };
}
var $848b1ce88e755b32$var$kS = ()=>({}), $848b1ce88e755b32$export$eccd46d4261ec748 = $848b1ce88e755b32$var$R({
    name: "QSlider",
    props: {
        ...$848b1ce88e755b32$var$ou,
        modelValue: {
            required: !0,
            default: null,
            validator: (e)=>typeof e == "number" || e === null
        },
        labelValue: [
            String,
            Number
        ]
    },
    emits: $848b1ce88e755b32$var$nu,
    setup (e, { emit: t }) {
        let { proxy: { $q: o } } = (0, $fVLUl.getCurrentInstance)(), { state: r, methods: n } = $848b1ce88e755b32$var$ru({
            updateValue: m,
            updatePosition: p,
            getDragging: y,
            formAttrs: $848b1ce88e755b32$var$cn(e)
        }), i = (0, $eayOh.ref)(null), a = (0, $eayOh.ref)(0), l = (0, $eayOh.ref)(0);
        function s() {
            l.value = e.modelValue === null ? r.innerMin.value : $848b1ce88e755b32$var$Ze(e.modelValue, r.innerMin.value, r.innerMax.value);
        }
        (0, $eayOh.watch)(()=>`${e.modelValue}|${r.innerMin.value}|${r.innerMax.value}`, s), s();
        let c = (0, $eayOh.computed)(()=>n.convertModelToRatio(l.value)), u = (0, $eayOh.computed)(()=>r.active.value === !0 ? a.value : c.value), v = (0, $eayOh.computed)(()=>{
            let h = {
                [r.positionProp.value]: `${100 * r.innerMinRatio.value}%`,
                [r.sizeProp.value]: `${100 * (u.value - r.innerMinRatio.value)}%`
            };
            return e.selectionImg !== void 0 && (h.backgroundImage = `url(${e.selectionImg}) !important`), h;
        }), f = n.getThumbRenderFn({
            focusValue: !0,
            getNodeData: $848b1ce88e755b32$var$kS,
            ratio: u,
            label: (0, $eayOh.computed)(()=>e.labelValue !== void 0 ? e.labelValue : l.value),
            thumbColor: (0, $eayOh.computed)(()=>e.thumbColor || e.color),
            labelColor: (0, $eayOh.computed)(()=>e.labelColor),
            labelTextColor: (0, $eayOh.computed)(()=>e.labelTextColor)
        }), d = (0, $eayOh.computed)(()=>r.editable.value !== !0 ? {} : o.platform.is.mobile === !0 ? {
                onClick: n.onMobileClick
            } : {
                onMousedown: n.onActivate,
                onFocus: C,
                onBlur: n.onBlur,
                onKeydown: b,
                onKeyup: n.onKeyup
            });
        function m(h) {
            l.value !== e.modelValue && t("update:modelValue", l.value), h === !0 && t("change", l.value);
        }
        function y() {
            return i.value.getBoundingClientRect();
        }
        function p(h, g = r.dragging.value) {
            let S = n.getDraggingRatio(h, g);
            l.value = n.convertRatioToModel(S), a.value = e.snap !== !0 || e.step === 0 ? S : n.convertModelToRatio(l.value);
        }
        function C() {
            r.focus.value = !0;
        }
        function b(h) {
            if (!$848b1ce88e755b32$var$Ia.includes(h.keyCode)) return;
            $848b1ce88e755b32$var$Se(h);
            let g = ([
                34,
                33
            ].includes(h.keyCode) ? 10 : 1) * r.keyStep.value, S = ([
                34,
                37,
                40
            ].includes(h.keyCode) ? -1 : 1) * (r.isReversed.value === !0 ? -1 : 1) * (e.vertical === !0 ? -1 : 1) * g;
            l.value = $848b1ce88e755b32$var$Ze(r.roundValueFn.value(l.value + S), r.innerMin.value, r.innerMax.value), m();
        }
        return ()=>{
            let h = n.getContent(v, r.tabindex, d, (g)=>{
                g.push(f());
            });
            return (0, $fVLUl.h)("div", {
                ref: i,
                class: r.classes.value + (e.modelValue === null ? " q-slider--no-value" : ""),
                ...r.attributes.value,
                "aria-valuenow": e.modelValue
            }, h);
        };
    }
});
function $848b1ce88e755b32$export$5b8689c380bcb3d5() {
    let e = (0, $eayOh.ref)(!$848b1ce88e755b32$var$bt.value);
    return e.value === !1 && (0, $fVLUl.onMounted)(()=>{
        e.value = !0;
    }), {
        isHydrated: e
    };
}
var $848b1ce88e755b32$var$wm = typeof ResizeObserver < "u", $848b1ce88e755b32$var$Cm = $848b1ce88e755b32$var$wm === !0 ? {} : {
    style: "display:block;position:absolute;top:0;left:0;right:0;bottom:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1;",
    url: "about:blank"
}, $848b1ce88e755b32$export$614f53fe102a3da7 = $848b1ce88e755b32$var$R({
    name: "QResizeObserver",
    props: {
        debounce: {
            type: [
                String,
                Number
            ],
            default: 100
        }
    },
    emits: [
        "resize"
    ],
    setup (e, { emit: t }) {
        let o = null, r, n = {
            width: -1,
            height: -1
        };
        function i(s) {
            s === !0 || e.debounce === 0 || e.debounce === "0" ? a() : o === null && (o = setTimeout(a, e.debounce));
        }
        function a() {
            if (o !== null && (clearTimeout(o), o = null), r) {
                let { offsetWidth: s, offsetHeight: c } = r;
                (s !== n.width || c !== n.height) && (n = {
                    width: s,
                    height: c
                }, t("resize", n));
            }
        }
        let { proxy: l } = (0, $fVLUl.getCurrentInstance)();
        if (l.trigger = i, $848b1ce88e755b32$var$wm === !0) {
            let s, c = (u)=>{
                r = l.$el.parentNode, r ? (s = new ResizeObserver(i), s.observe(r), a()) : u !== !0 && (0, $fVLUl.nextTick)(()=>{
                    c(!0);
                });
            };
            return (0, $fVLUl.onMounted)(()=>{
                c();
            }), (0, $fVLUl.onBeforeUnmount)(()=>{
                o !== null && clearTimeout(o), s !== void 0 && (s.disconnect !== void 0 ? s.disconnect() : r && s.unobserve(r));
            }), $848b1ce88e755b32$export$8793edee2d425525;
        } else {
            let u = function() {
                o !== null && (clearTimeout(o), o = null), c !== void 0 && (c.removeEventListener !== void 0 && c.removeEventListener("resize", i, $848b1ce88e755b32$var$Xe.passive), c = void 0);
            }, v = function() {
                u(), r && r.contentDocument && (c = r.contentDocument.defaultView, c.addEventListener("resize", i, $848b1ce88e755b32$var$Xe.passive), a());
            }, { isHydrated: s } = $848b1ce88e755b32$export$5b8689c380bcb3d5(), c;
            return (0, $fVLUl.onMounted)(()=>{
                (0, $fVLUl.nextTick)(()=>{
                    r = l.$el, r && v();
                });
            }), (0, $fVLUl.onBeforeUnmount)(u), ()=>{
                if (s.value === !0) return (0, $fVLUl.h)("object", {
                    class: "q--avoid-card-border",
                    style: $848b1ce88e755b32$var$Cm.style,
                    tabindex: -1,
                    type: "text/html",
                    data: $848b1ce88e755b32$var$Cm.url,
                    "aria-hidden": "true",
                    onLoad: v
                });
            };
        }
    }
});
var $848b1ce88e755b32$var$Fr = !1;
{
    let e = document.createElement("div");
    e.setAttribute("dir", "rtl"), Object.assign(e.style, {
        width: "1px",
        height: "1px",
        overflow: "auto"
    });
    let t = document.createElement("div");
    Object.assign(t.style, {
        width: "1000px",
        height: "1px"
    }), document.body.appendChild(e), e.appendChild(t), e.scrollLeft = -1000, $848b1ce88e755b32$var$Fr = e.scrollLeft >= 0, e.remove();
}function $848b1ce88e755b32$var$LS(e, t, o) {
    let r = o === !0 ? [
        "left",
        "right"
    ] : [
        "top",
        "bottom"
    ];
    return `absolute-${t === !0 ? r[0] : r[1]}${e ? ` text-${e}` : ""}`;
}
var $848b1ce88e755b32$var$FS = [
    "left",
    "center",
    "right",
    "justify"
], $848b1ce88e755b32$export$f3e10d2f5515bdea = $848b1ce88e755b32$var$R({
    name: "QTabs",
    props: {
        modelValue: [
            Number,
            String
        ],
        align: {
            type: String,
            default: "center",
            validator: (e)=>$848b1ce88e755b32$var$FS.includes(e)
        },
        breakpoint: {
            type: [
                String,
                Number
            ],
            default: 600
        },
        vertical: Boolean,
        shrink: Boolean,
        stretch: Boolean,
        activeClass: String,
        activeColor: String,
        activeBgColor: String,
        indicatorColor: String,
        leftIcon: String,
        rightIcon: String,
        outsideArrows: Boolean,
        mobileArrows: Boolean,
        switchIndicator: Boolean,
        narrowIndicator: Boolean,
        inlineLabel: Boolean,
        noCaps: Boolean,
        dense: Boolean,
        contentClass: String,
        "onUpdate:modelValue": [
            Function,
            Array
        ]
    },
    setup (e, { slots: t, emit: o }) {
        let { proxy: r } = (0, $fVLUl.getCurrentInstance)(), { $q: n } = r, { registerTick: i } = $848b1ce88e755b32$export$98bfbd4c9d834fed(), { registerTick: a } = $848b1ce88e755b32$export$98bfbd4c9d834fed(), { registerTick: l } = $848b1ce88e755b32$export$98bfbd4c9d834fed(), { registerTimeout: s, removeTimeout: c } = $848b1ce88e755b32$export$d8e6abf214c9ec0f(), { registerTimeout: u, removeTimeout: v } = $848b1ce88e755b32$export$d8e6abf214c9ec0f(), f = (0, $eayOh.ref)(null), d = (0, $eayOh.ref)(null), m = (0, $eayOh.ref)(e.modelValue), y = (0, $eayOh.ref)(!1), p = (0, $eayOh.ref)(!0), C = (0, $eayOh.ref)(!1), b = (0, $eayOh.ref)(!1), h = [], g = (0, $eayOh.ref)(0), S = (0, $eayOh.ref)(!1), P = null, $ = null, L, E = (0, $eayOh.computed)(()=>({
                activeClass: e.activeClass,
                activeColor: e.activeColor,
                activeBgColor: e.activeBgColor,
                indicatorClass: $848b1ce88e755b32$var$LS(e.indicatorColor, e.switchIndicator, e.vertical),
                narrowIndicator: e.narrowIndicator,
                inlineLabel: e.inlineLabel,
                noCaps: e.noCaps
            })), A = (0, $eayOh.computed)(()=>{
            let ne = g.value, se = m.value;
            for(let Y = 0; Y < ne; Y++)if (h[Y].name.value === se) return !0;
            return !1;
        }), B = (0, $eayOh.computed)(()=>`q-tabs__content--align-${y.value === !0 ? "left" : b.value === !0 ? "justify" : e.align}`), q = (0, $eayOh.computed)(()=>`q-tabs row no-wrap items-center q-tabs--${y.value === !0 ? "" : "not-"}scrollable q-tabs--${e.vertical === !0 ? "vertical" : "horizontal"} q-tabs__arrows--${e.outsideArrows === !0 ? "outside" : "inside"} q-tabs--mobile-with${e.mobileArrows === !0 ? "" : "out"}-arrows` + (e.dense === !0 ? " q-tabs--dense" : "") + (e.shrink === !0 ? " col-shrink" : "") + (e.stretch === !0 ? " self-stretch" : "")), x = (0, $eayOh.computed)(()=>"q-tabs__content scroll--mobile row no-wrap items-center self-stretch hide-scrollbar relative-position " + B.value + (e.contentClass !== void 0 ? ` ${e.contentClass}` : "")), k = (0, $eayOh.computed)(()=>e.vertical === !0 ? {
                container: "height",
                content: "offsetHeight",
                scroll: "scrollHeight"
            } : {
                container: "width",
                content: "offsetWidth",
                scroll: "scrollWidth"
            }), j = (0, $eayOh.computed)(()=>e.vertical !== !0 && n.lang.rtl === !0), Q = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$Fr === !1 && j.value === !0);
        (0, $eayOh.watch)(j, _), (0, $eayOh.watch)(()=>e.modelValue, (ne)=>{
            w({
                name: ne,
                setCurrent: !0,
                skipEmit: !0
            });
        }), (0, $eayOh.watch)(()=>e.outsideArrows, H);
        function w({ name: ne, setCurrent: se, skipEmit: Y }) {
            m.value !== ne && (Y !== !0 && e["onUpdate:modelValue"] !== void 0 && o("update:modelValue", ne), (se === !0 || e["onUpdate:modelValue"] === void 0) && (ie(m.value, ne), m.value = ne));
        }
        function H() {
            i(()=>{
                W({
                    width: f.value.offsetWidth,
                    height: f.value.offsetHeight
                });
            });
        }
        function W(ne) {
            if (k.value === void 0 || d.value === null) return;
            let se = ne[k.value.container], Y = Math.min(d.value[k.value.scroll], Array.prototype.reduce.call(d.value.children, (Pe, Ee)=>Pe + (Ee[k.value.content] || 0), 0)), me = se > 0 && Y > se;
            y.value = me, me === !0 && a(_), b.value = se < parseInt(e.breakpoint, 10);
        }
        function ie(ne, se) {
            let Y = ne != null && ne !== "" ? h.find((Pe)=>Pe.name.value === ne) : null, me = se != null && se !== "" ? h.find((Pe)=>Pe.name.value === se) : null;
            if (Y && me) {
                let Pe = Y.tabIndicatorRef.value, Ee = me.tabIndicatorRef.value;
                P !== null && (clearTimeout(P), P = null), Pe.style.transition = "none", Pe.style.transform = "none", Ee.style.transition = "none", Ee.style.transform = "none";
                let Ae = Pe.getBoundingClientRect(), nt = Ee.getBoundingClientRect();
                Ee.style.transform = e.vertical === !0 ? `translate3d(0,${Ae.top - nt.top}px,0) scale3d(1,${nt.height ? Ae.height / nt.height : 1},1)` : `translate3d(${Ae.left - nt.left}px,0,0) scale3d(${nt.width ? Ae.width / nt.width : 1},1,1)`, l(()=>{
                    P = setTimeout(()=>{
                        P = null, Ee.style.transition = "transform .25s cubic-bezier(.4, 0, .2, 1)", Ee.style.transform = "none";
                    }, 70);
                });
            }
            me && y.value === !0 && V(me.rootRef.value);
        }
        function V(ne) {
            let { left: se, width: Y, top: me, height: Pe } = d.value.getBoundingClientRect(), Ee = ne.getBoundingClientRect(), Ae = e.vertical === !0 ? Ee.top - me : Ee.left - se;
            if (Ae < 0) {
                d.value[e.vertical === !0 ? "scrollTop" : "scrollLeft"] += Math.floor(Ae), _();
                return;
            }
            Ae += e.vertical === !0 ? Ee.height - Pe : Ee.width - Y, Ae > 0 && (d.value[e.vertical === !0 ? "scrollTop" : "scrollLeft"] += Math.ceil(Ae), _());
        }
        function _() {
            let ne = d.value;
            if (ne === null) return;
            let se = ne.getBoundingClientRect(), Y = e.vertical === !0 ? ne.scrollTop : Math.abs(ne.scrollLeft);
            j.value === !0 ? (p.value = Math.ceil(Y + se.width) < ne.scrollWidth - 1, C.value = Y > 0) : (p.value = Y > 0, C.value = e.vertical === !0 ? Math.ceil(Y + se.height) < ne.scrollHeight : Math.ceil(Y + se.width) < ne.scrollWidth);
        }
        function N(ne) {
            $ !== null && clearInterval($), $ = setInterval(()=>{
                z(ne) === !0 && T();
            }, 5);
        }
        function I() {
            N(Q.value === !0 ? Number.MAX_SAFE_INTEGER : 0);
        }
        function oe() {
            N(Q.value === !0 ? 0 : Number.MAX_SAFE_INTEGER);
        }
        function T() {
            $ !== null && (clearInterval($), $ = null);
        }
        function D(ne, se) {
            let Y = Array.prototype.filter.call(d.value.children, (nt)=>nt === se || nt.matches && nt.matches(".q-tab.q-focusable") === !0), me = Y.length;
            if (me === 0) return;
            if (ne === 36) return V(Y[0]), Y[0].focus(), !0;
            if (ne === 35) return V(Y[me - 1]), Y[me - 1].focus(), !0;
            let Pe = ne === (e.vertical === !0 ? 38 : 37), Ee = ne === (e.vertical === !0 ? 40 : 39), Ae = Pe === !0 ? -1 : Ee === !0 ? 1 : void 0;
            if (Ae !== void 0) {
                let nt = j.value === !0 ? -1 : 1, ct = Y.indexOf(se) + Ae * nt;
                return ct >= 0 && ct < me && (V(Y[ct]), Y[ct].focus({
                    preventScroll: !0
                })), !0;
            }
        }
        let te = (0, $eayOh.computed)(()=>Q.value === !0 ? {
                get: (ne)=>Math.abs(ne.scrollLeft),
                set: (ne, se)=>{
                    ne.scrollLeft = -se;
                }
            } : e.vertical === !0 ? {
                get: (ne)=>ne.scrollTop,
                set: (ne, se)=>{
                    ne.scrollTop = se;
                }
            } : {
                get: (ne)=>ne.scrollLeft,
                set: (ne, se)=>{
                    ne.scrollLeft = se;
                }
            });
        function z(ne) {
            let se = d.value, { get: Y, set: me } = te.value, Pe = !1, Ee = Y(se), Ae = ne < Ee ? -1 : 1;
            return Ee += Ae * 5, Ee < 0 ? (Pe = !0, Ee = 0) : (Ae === -1 && Ee <= ne || Ae === 1 && Ee >= ne) && (Pe = !0, Ee = ne), me(se, Ee), _(), Pe;
        }
        function ue(ne, se) {
            for(let Y in ne)if (ne[Y] !== se[Y]) return !1;
            return !0;
        }
        function _e() {
            let ne = null, se = {
                matchedLen: 0,
                queryDiff: 9999,
                hrefLen: 0
            }, Y = h.filter((Ae)=>Ae.routeData !== void 0 && Ae.routeData.hasRouterLink.value === !0), { hash: me, query: Pe } = r.$route, Ee = Object.keys(Pe).length;
            for (let Ae of Y){
                let nt = Ae.routeData.exact.value === !0;
                if (Ae.routeData[nt === !0 ? "linkIsExactActive" : "linkIsActive"].value !== !0) continue;
                let { hash: ct, query: dt, matched: G, href: re } = Ae.routeData.resolvedLink.value, K = Object.keys(dt).length;
                if (nt === !0) {
                    if (ct !== me || K !== Ee || ue(Pe, dt) === !1) continue;
                    ne = Ae.name.value;
                    break;
                }
                if (ct !== "" && ct !== me || K !== 0 && ue(dt, Pe) === !1) continue;
                let ee = {
                    matchedLen: G.length,
                    queryDiff: Ee - K,
                    hrefLen: re.length - ct.length
                };
                if (ee.matchedLen > se.matchedLen) {
                    ne = Ae.name.value, se = ee;
                    continue;
                } else if (ee.matchedLen !== se.matchedLen) continue;
                if (ee.queryDiff < se.queryDiff) ne = Ae.name.value, se = ee;
                else if (ee.queryDiff !== se.queryDiff) continue;
                ee.hrefLen > se.hrefLen && (ne = Ae.name.value, se = ee);
            }
            ne === null && h.some((Ae)=>Ae.routeData === void 0 && Ae.name.value === m.value) === !0 || w({
                name: ne,
                setCurrent: !0
            });
        }
        function U(ne) {
            if (c(), S.value !== !0 && f.value !== null && ne.target && typeof ne.target.closest == "function") {
                let se = ne.target.closest(".q-tab");
                se && f.value.contains(se) === !0 && (S.value = !0, y.value === !0 && V(se));
            }
        }
        function ae() {
            s(()=>{
                S.value = !1;
            }, 30);
        }
        function ce() {
            Re.avoidRouteWatcher === !1 ? u(_e) : v();
        }
        function be() {
            if (L === void 0) {
                let ne = (0, $eayOh.watch)(()=>r.$route.fullPath, ce);
                L = ()=>{
                    ne(), L = void 0;
                };
            }
        }
        function Me(ne) {
            h.push(ne), g.value++, H(), ne.routeData === void 0 || r.$route === void 0 ? u(()=>{
                if (y.value === !0) {
                    let se = m.value, Y = se != null && se !== "" ? h.find((me)=>me.name.value === se) : null;
                    Y && V(Y.rootRef.value);
                }
            }) : (be(), ne.routeData.hasRouterLink.value === !0 && ce());
        }
        function le(ne) {
            h.splice(h.indexOf(ne), 1), g.value--, H(), L !== void 0 && ne.routeData !== void 0 && (h.every((se)=>se.routeData === void 0) === !0 && L(), ce());
        }
        let Re = {
            currentModel: m,
            tabProps: E,
            hasFocus: S,
            hasActiveTab: A,
            registerTab: Me,
            unregisterTab: le,
            verifyRouteModel: ce,
            updateModel: w,
            onKbdNavigate: D,
            avoidRouteWatcher: !1
        };
        (0, $fVLUl.provide)($848b1ce88e755b32$var$Tl, Re);
        function Fe() {
            P !== null && clearTimeout(P), T(), L !== void 0 && L();
        }
        let De;
        return (0, $fVLUl.onBeforeUnmount)(Fe), (0, $fVLUl.onDeactivated)(()=>{
            De = L !== void 0, Fe();
        }), (0, $fVLUl.onActivated)(()=>{
            De === !0 && be(), H();
        }), ()=>(0, $fVLUl.h)("div", {
                ref: f,
                class: q.value,
                role: "tablist",
                onFocusin: U,
                onFocusout: ae
            }, [
                (0, $fVLUl.h)($848b1ce88e755b32$export$614f53fe102a3da7, {
                    onResize: W
                }),
                (0, $fVLUl.h)("div", {
                    ref: d,
                    class: x.value,
                    onScroll: _
                }, $848b1ce88e755b32$var$J(t.default)),
                (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                    class: "q-tabs__arrow q-tabs__arrow--left absolute q-tab__icon" + (p.value === !0 ? "" : " q-tabs__arrow--faded"),
                    name: e.leftIcon || n.iconSet.tabs[e.vertical === !0 ? "up" : "left"],
                    onMousedownPassive: I,
                    onTouchstartPassive: I,
                    onMouseupPassive: T,
                    onMouseleavePassive: T,
                    onTouchendPassive: T
                }),
                (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                    class: "q-tabs__arrow q-tabs__arrow--right absolute q-tab__icon" + (C.value === !0 ? "" : " q-tabs__arrow--faded"),
                    name: e.rightIcon || n.iconSet.tabs[e.vertical === !0 ? "down" : "right"],
                    onMousedownPassive: oe,
                    onTouchstartPassive: oe,
                    onMouseupPassive: T,
                    onMouseleavePassive: T,
                    onTouchendPassive: T
                })
            ]);
    }
});
var $848b1ce88e755b32$var$HS = 0, $848b1ce88e755b32$var$au = [
    "click",
    "keydown"
], $848b1ce88e755b32$var$lu = {
    icon: String,
    label: [
        Number,
        String
    ],
    alert: [
        Boolean,
        String
    ],
    alertIcon: String,
    name: {
        type: [
            Number,
            String
        ],
        default: ()=>`t_${$848b1ce88e755b32$var$HS++}`
    },
    noCaps: Boolean,
    tabindex: [
        String,
        Number
    ],
    disable: Boolean,
    contentClass: String,
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: !0
    }
};
function $848b1ce88e755b32$var$uu(e, t, o, r) {
    let n = (0, $fVLUl.inject)($848b1ce88e755b32$var$Tl, $848b1ce88e755b32$var$Ye);
    if (n === $848b1ce88e755b32$var$Ye) return console.error("QTab/QRouteTab component needs to be child of QTabs"), $848b1ce88e755b32$var$Ye;
    let { proxy: i } = (0, $fVLUl.getCurrentInstance)(), a = (0, $eayOh.ref)(null), l = (0, $eayOh.ref)(null), s = (0, $eayOh.ref)(null), c = (0, $eayOh.computed)(()=>e.disable === !0 || e.ripple === !1 ? !1 : Object.assign({
            keyCodes: [
                13,
                32
            ],
            early: !0
        }, e.ripple === !0 ? {} : e.ripple)), u = (0, $eayOh.computed)(()=>n.currentModel.value === e.name), v = (0, $eayOh.computed)(()=>"q-tab relative-position self-stretch flex flex-center text-center" + (u.value === !0 ? " q-tab--active" + (n.tabProps.value.activeClass ? " " + n.tabProps.value.activeClass : "") + (n.tabProps.value.activeColor ? ` text-${n.tabProps.value.activeColor}` : "") + (n.tabProps.value.activeBgColor ? ` bg-${n.tabProps.value.activeBgColor}` : "") : " q-tab--inactive") + (e.icon && e.label && n.tabProps.value.inlineLabel === !1 ? " q-tab--full" : "") + (e.noCaps === !0 || n.tabProps.value.noCaps === !0 ? " q-tab--no-caps" : "") + (e.disable === !0 ? " disabled" : " q-focusable q-hoverable cursor-pointer") + (r !== void 0 ? r.linkClass.value : "")), f = (0, $eayOh.computed)(()=>"q-tab__content self-stretch flex-center relative-position q-anchor--skip non-selectable " + (n.tabProps.value.inlineLabel === !0 ? "row no-wrap q-tab__content--inline" : "column") + (e.contentClass !== void 0 ? ` ${e.contentClass}` : "")), d = (0, $eayOh.computed)(()=>e.disable === !0 || n.hasFocus.value === !0 || u.value === !1 && n.hasActiveTab.value === !0 ? -1 : e.tabindex || 0);
    function m(h, g) {
        if (g !== !0 && a.value !== null && a.value.focus(), e.disable === !0) {
            r !== void 0 && r.hasRouterLink.value === !0 && $848b1ce88e755b32$var$Se(h);
            return;
        }
        if (r === void 0) {
            n.updateModel({
                name: e.name
            }), o("click", h);
            return;
        }
        if (r.hasRouterLink.value === !0) {
            let S = (P = {})=>{
                let $, L = P.to === void 0 || $848b1ce88e755b32$var$Zt(P.to, e.to) === !0 ? n.avoidRouteWatcher = $848b1ce88e755b32$export$e2a22331486dcca0() : null;
                return r.navigateToRouterLink(h, {
                    ...P,
                    returnRouterError: !0
                }).catch((E)=>{
                    $ = E;
                }).then((E)=>{
                    if (L === n.avoidRouteWatcher && (n.avoidRouteWatcher = !1, $ === void 0 && (E === void 0 || E.message !== void 0 && E.message.startsWith("Avoided redundant navigation") === !0) && n.updateModel({
                        name: e.name
                    })), P.returnRouterError === !0) return $ !== void 0 ? Promise.reject($) : E;
                });
            };
            o("click", h, S), h.defaultPrevented !== !0 && S();
            return;
        }
        o("click", h);
    }
    function y(h) {
        $848b1ce88e755b32$var$wt(h, [
            13,
            32
        ]) ? m(h, !0) : $848b1ce88e755b32$var$xo(h) !== !0 && h.keyCode >= 35 && h.keyCode <= 40 && h.altKey !== !0 && h.metaKey !== !0 && n.onKbdNavigate(h.keyCode, i.$el) === !0 && $848b1ce88e755b32$var$Se(h), o("keydown", h);
    }
    function p() {
        let h = n.tabProps.value.narrowIndicator, g = [], S = (0, $fVLUl.h)("div", {
            ref: s,
            class: [
                "q-tab__indicator",
                n.tabProps.value.indicatorClass
            ]
        });
        e.icon !== void 0 && g.push((0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
            class: "q-tab__icon",
            name: e.icon
        })), e.label !== void 0 && g.push((0, $fVLUl.h)("div", {
            class: "q-tab__label"
        }, e.label)), e.alert !== !1 && g.push(e.alertIcon !== void 0 ? (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
            class: "q-tab__alert-icon",
            color: e.alert !== !0 ? e.alert : void 0,
            name: e.alertIcon
        }) : (0, $fVLUl.h)("div", {
            class: "q-tab__alert" + (e.alert !== !0 ? ` text-${e.alert}` : "")
        })), h === !0 && g.push(S);
        let P = [
            (0, $fVLUl.h)("div", {
                class: "q-focus-helper",
                tabindex: -1,
                ref: a
            }),
            (0, $fVLUl.h)("div", {
                class: f.value
            }, $848b1ce88e755b32$var$Ke(t.default, g))
        ];
        return h === !1 && P.push(S), P;
    }
    let C = {
        name: (0, $eayOh.computed)(()=>e.name),
        rootRef: l,
        tabIndicatorRef: s,
        routeData: r
    };
    (0, $fVLUl.onBeforeUnmount)(()=>{
        n.unregisterTab(C);
    }), (0, $fVLUl.onMounted)(()=>{
        n.registerTab(C);
    });
    function b(h, g) {
        let S = {
            ref: l,
            class: v.value,
            tabindex: d.value,
            role: "tab",
            "aria-selected": u.value === !0 ? "true" : "false",
            "aria-disabled": e.disable === !0 ? "true" : void 0,
            onClick: m,
            onKeydown: y,
            ...g
        };
        return (0, $fVLUl.withDirectives)((0, $fVLUl.h)(h, S, p()), [
            [
                $848b1ce88e755b32$export$9e9146f7e027fdaa,
                c.value
            ]
        ]);
    }
    return {
        renderTab: b,
        $tabs: n
    };
}
var $848b1ce88e755b32$export$39ade007f653a559 = $848b1ce88e755b32$var$R({
    name: "QTab",
    props: $848b1ce88e755b32$var$lu,
    emits: $848b1ce88e755b32$var$au,
    setup (e, { slots: t, emit: o }) {
        let { renderTab: r } = $848b1ce88e755b32$var$uu(e, t, o);
        return ()=>r("div");
    }
});
var $848b1ce88e755b32$export$305a5380acbec321 = $848b1ce88e755b32$var$R({
    name: "QTabPanels",
    props: {
        ...$848b1ce88e755b32$var$Fi,
        ...$848b1ce88e755b32$var$he
    },
    emits: $848b1ce88e755b32$var$Di,
    setup (e, { slots: t }) {
        let o = (0, $fVLUl.getCurrentInstance)(), r = $848b1ce88e755b32$var$pe(e, o.proxy.$q), { updatePanelsList: n, getPanelContent: i, panelDirectives: a } = $848b1ce88e755b32$var$Vi(), l = (0, $eayOh.computed)(()=>"q-tab-panels q-panel-parent" + (r.value === !0 ? " q-tab-panels--dark q-dark" : ""));
        return ()=>(n(t), $848b1ce88e755b32$var$kt("div", {
                class: l.value
            }, i(), "pan", e.swipeable, ()=>a.value));
    }
});
var $848b1ce88e755b32$export$a513456409dea750 = $848b1ce88e755b32$var$R({
    name: "QTabPanel",
    props: $848b1ce88e755b32$var$Li,
    setup (e, { slots: t }) {
        return ()=>(0, $fVLUl.h)("div", {
                class: "q-tab-panel",
                role: "tabpanel"
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$var$km = /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/, $848b1ce88e755b32$var$qm = /^#[0-9a-fA-F]{4}([0-9a-fA-F]{4})?$/, $848b1ce88e755b32$var$Tm = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/, $848b1ce88e755b32$var$cu = /^rgb\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5])\)$/, $848b1ce88e755b32$var$du = /^rgba\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/, $848b1ce88e755b32$var$Dr = {
    date: (e)=>/^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(e),
    time: (e)=>/^([0-1]?\d|2[0-3]):[0-5]\d$/.test(e),
    fulltime: (e)=>/^([0-1]?\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(e),
    timeOrFulltime: (e)=>/^([0-1]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(e),
    email: (e)=>/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e),
    hexColor: (e)=>$848b1ce88e755b32$var$km.test(e),
    hexaColor: (e)=>$848b1ce88e755b32$var$qm.test(e),
    hexOrHexaColor: (e)=>$848b1ce88e755b32$var$Tm.test(e),
    rgbColor: (e)=>$848b1ce88e755b32$var$cu.test(e),
    rgbaColor: (e)=>$848b1ce88e755b32$var$du.test(e),
    rgbOrRgbaColor: (e)=>$848b1ce88e755b32$var$cu.test(e) || $848b1ce88e755b32$var$du.test(e),
    hexOrRgbColor: (e)=>$848b1ce88e755b32$var$km.test(e) || $848b1ce88e755b32$var$cu.test(e),
    hexaOrRgbaColor: (e)=>$848b1ce88e755b32$var$qm.test(e) || $848b1ce88e755b32$var$du.test(e),
    anyColor: (e)=>$848b1ce88e755b32$var$Tm.test(e) || $848b1ce88e755b32$var$cu.test(e) || $848b1ce88e755b32$var$du.test(e)
}, $848b1ce88e755b32$export$ac7ce348c2237f4e = {
    testPattern: $848b1ce88e755b32$var$Dr
};
var $848b1ce88e755b32$var$KS = /^rgb(a)?\((\d{1,3}),(\d{1,3}),(\d{1,3}),?([01]?\.?\d*?)?\)$/;
function $848b1ce88e755b32$var$Vr({ r: e, g: t, b: o, a: r }) {
    let n = r !== void 0;
    if (e = Math.round(e), t = Math.round(t), o = Math.round(o), e > 255 || t > 255 || o > 255 || n && r > 100) throw new TypeError("Expected 3 numbers below 256 (and optionally one below 100)");
    return r = n ? (Math.round(255 * r / 100) | 256).toString(16).slice(1) : "", "#" + (o | t << 8 | e << 16 | 16777216).toString(16).slice(1) + r;
}
function $848b1ce88e755b32$var$qc({ r: e, g: t, b: o, a: r }) {
    return `rgb${r !== void 0 ? "a" : ""}(${e},${t},${o}${r !== void 0 ? "," + r / 100 : ""})`;
}
function $848b1ce88e755b32$var$fu(e) {
    if (typeof e != "string") throw new TypeError("Expected a string");
    e = e.replace(/^#/, ""), e.length === 3 ? e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2] : e.length === 4 && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2] + e[3] + e[3]);
    let t = parseInt(e, 16);
    return e.length > 6 ? {
        r: t >> 24 & 255,
        g: t >> 16 & 255,
        b: t >> 8 & 255,
        a: Math.round((t & 255) / 2.55)
    } : {
        r: t >> 16,
        g: t >> 8 & 255,
        b: t & 255
    };
}
function $848b1ce88e755b32$var$mu({ h: e, s: t, v: o, a: r }) {
    let n, i, a;
    t = t / 100, o = o / 100, e = e / 360;
    let l = Math.floor(e * 6), s = e * 6 - l, c = o * (1 - t), u = o * (1 - s * t), v = o * (1 - (1 - s) * t);
    switch(l % 6){
        case 0:
            n = o, i = v, a = c;
            break;
        case 1:
            n = u, i = o, a = c;
            break;
        case 2:
            n = c, i = o, a = v;
            break;
        case 3:
            n = c, i = u, a = o;
            break;
        case 4:
            n = v, i = c, a = o;
            break;
        case 5:
            n = o, i = c, a = u;
            break;
    }
    return {
        r: Math.round(n * 255),
        g: Math.round(i * 255),
        b: Math.round(a * 255),
        a: r
    };
}
function $848b1ce88e755b32$var$ja({ r: e, g: t, b: o, a: r }) {
    let n = Math.max(e, t, o), i = Math.min(e, t, o), a = n - i, l = n === 0 ? 0 : a / n, s = n / 255, c;
    switch(n){
        case i:
            c = 0;
            break;
        case e:
            c = t - o + a * (t < o ? 6 : 0), c /= 6 * a;
            break;
        case t:
            c = o - e + a * 2, c /= 6 * a;
            break;
        case o:
            c = e - t + a * 4, c /= 6 * a;
            break;
    }
    return {
        h: Math.round(c * 360),
        s: Math.round(l * 100),
        v: Math.round(s * 100),
        a: r
    };
}
function $848b1ce88e755b32$var$mn(e) {
    if (typeof e != "string") throw new TypeError("Expected a string");
    let t = e.replace(/ /g, ""), o = $848b1ce88e755b32$var$KS.exec(t);
    if (o === null) return $848b1ce88e755b32$var$fu(t);
    let r = {
        r: Math.min(255, parseInt(o[2], 10)),
        g: Math.min(255, parseInt(o[3], 10)),
        b: Math.min(255, parseInt(o[4], 10))
    };
    if (o[1]) {
        let n = parseFloat(o[5]);
        r.a = Math.min(1, isNaN(n) === !0 ? 1 : n) * 100;
    }
    return r;
}
function $848b1ce88e755b32$var$WS(e, t) {
    if (typeof e != "string") throw new TypeError("Expected a string as color");
    if (typeof t != "number") throw new TypeError("Expected a numeric percent");
    let o = $848b1ce88e755b32$var$mn(e), r = t < 0 ? 0 : 255, n = Math.abs(t) / 100, i = o.r, a = o.g, l = o.b;
    return "#" + (16777216 + (Math.round((r - i) * n) + i) * 65536 + (Math.round((r - a) * n) + a) * 256 + (Math.round((r - l) * n) + l)).toString(16).slice(1);
}
function $848b1ce88e755b32$var$Tc(e) {
    if (typeof e != "string" && (!e || e.r === void 0)) throw new TypeError("Expected a string or a {r, g, b} object as color");
    let t = typeof e == "string" ? $848b1ce88e755b32$var$mn(e) : e, o = t.r / 255, r = t.g / 255, n = t.b / 255, i = o <= .03928 ? o / 12.92 : Math.pow((o + .055) / 1.055, 2.4), a = r <= .03928 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4), l = n <= .03928 ? n / 12.92 : Math.pow((n + .055) / 1.055, 2.4);
    return .2126 * i + .7152 * a + .0722 * l;
}
function $848b1ce88e755b32$var$YS(e) {
    if (typeof e != "string" && (!e || e.r === void 0)) throw new TypeError("Expected a string or a {r, g, b} object as color");
    let t = typeof e == "string" ? $848b1ce88e755b32$var$mn(e) : e;
    return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
}
function $848b1ce88e755b32$var$XS(e, t) {
    if (typeof e != "string" && (!e || e.r === void 0)) throw new TypeError("Expected a string or a {r, g, b[, a]} object as fgColor");
    if (typeof t != "string" && (!t || t.r === void 0)) throw new TypeError("Expected a string or a {r, g, b[, a]} object as bgColor");
    let o = typeof e == "string" ? $848b1ce88e755b32$var$mn(e) : e, r = o.r / 255, n = o.g / 255, i = o.b / 255, a = o.a !== void 0 ? o.a / 100 : 1, l = typeof t == "string" ? $848b1ce88e755b32$var$mn(t) : t, s = l.r / 255, c = l.g / 255, u = l.b / 255, v = l.a !== void 0 ? l.a / 100 : 1, f = a + v * (1 - a), d = Math.round((r * a + s * v * (1 - a)) / f * 255), m = Math.round((n * a + c * v * (1 - a)) / f * 255), y = Math.round((i * a + u * v * (1 - a)) / f * 255), p = {
        r: d,
        g: m,
        b: y,
        a: Math.round(f * 100)
    };
    return typeof e == "string" ? $848b1ce88e755b32$var$Vr(p) : p;
}
function $848b1ce88e755b32$var$GS(e, t) {
    if (typeof e != "string") throw new TypeError("Expected a string as color");
    if (t === void 0 || t < -1 || t > 1) throw new TypeError("Expected offset to be between -1 and 1");
    let { r: o, g: r, b: n, a: i } = $848b1ce88e755b32$var$mn(e), a = i !== void 0 ? i / 100 : 0;
    return $848b1ce88e755b32$var$Vr({
        r: o,
        g: r,
        b: n,
        a: Math.round(Math.min(1, Math.max(0, a + t)) * 100)
    });
}
function $848b1ce88e755b32$var$ZS(e) {
    if (typeof e != "string") throw new TypeError("Expected a string as color");
    let t = document.createElement("div");
    t.className = `text-${e} invisible fixed no-pointer-events`, document.body.appendChild(t);
    let o = getComputedStyle(t).getPropertyValue("color");
    return t.remove(), $848b1ce88e755b32$var$Vr($848b1ce88e755b32$var$mn(o));
}
var $848b1ce88e755b32$export$8f45430ccf837300 = {
    rgbToHex: $848b1ce88e755b32$var$Vr,
    hexToRgb: $848b1ce88e755b32$var$fu,
    hsvToRgb: $848b1ce88e755b32$var$mu,
    rgbToHsv: $848b1ce88e755b32$var$ja,
    textToRgb: $848b1ce88e755b32$var$mn,
    lighten: $848b1ce88e755b32$var$WS,
    luminosity: $848b1ce88e755b32$var$Tc,
    brightness: $848b1ce88e755b32$var$YS,
    blend: $848b1ce88e755b32$var$XS,
    changeAlpha: $848b1ce88e755b32$var$GS,
    getPaletteColor: $848b1ce88e755b32$var$ZS
};
var $848b1ce88e755b32$var$tx = [
    "rgb(255,204,204)",
    "rgb(255,230,204)",
    "rgb(255,255,204)",
    "rgb(204,255,204)",
    "rgb(204,255,230)",
    "rgb(204,255,255)",
    "rgb(204,230,255)",
    "rgb(204,204,255)",
    "rgb(230,204,255)",
    "rgb(255,204,255)",
    "rgb(255,153,153)",
    "rgb(255,204,153)",
    "rgb(255,255,153)",
    "rgb(153,255,153)",
    "rgb(153,255,204)",
    "rgb(153,255,255)",
    "rgb(153,204,255)",
    "rgb(153,153,255)",
    "rgb(204,153,255)",
    "rgb(255,153,255)",
    "rgb(255,102,102)",
    "rgb(255,179,102)",
    "rgb(255,255,102)",
    "rgb(102,255,102)",
    "rgb(102,255,179)",
    "rgb(102,255,255)",
    "rgb(102,179,255)",
    "rgb(102,102,255)",
    "rgb(179,102,255)",
    "rgb(255,102,255)",
    "rgb(255,51,51)",
    "rgb(255,153,51)",
    "rgb(255,255,51)",
    "rgb(51,255,51)",
    "rgb(51,255,153)",
    "rgb(51,255,255)",
    "rgb(51,153,255)",
    "rgb(51,51,255)",
    "rgb(153,51,255)",
    "rgb(255,51,255)",
    "rgb(255,0,0)",
    "rgb(255,128,0)",
    "rgb(255,255,0)",
    "rgb(0,255,0)",
    "rgb(0,255,128)",
    "rgb(0,255,255)",
    "rgb(0,128,255)",
    "rgb(0,0,255)",
    "rgb(128,0,255)",
    "rgb(255,0,255)",
    "rgb(245,0,0)",
    "rgb(245,123,0)",
    "rgb(245,245,0)",
    "rgb(0,245,0)",
    "rgb(0,245,123)",
    "rgb(0,245,245)",
    "rgb(0,123,245)",
    "rgb(0,0,245)",
    "rgb(123,0,245)",
    "rgb(245,0,245)",
    "rgb(214,0,0)",
    "rgb(214,108,0)",
    "rgb(214,214,0)",
    "rgb(0,214,0)",
    "rgb(0,214,108)",
    "rgb(0,214,214)",
    "rgb(0,108,214)",
    "rgb(0,0,214)",
    "rgb(108,0,214)",
    "rgb(214,0,214)",
    "rgb(163,0,0)",
    "rgb(163,82,0)",
    "rgb(163,163,0)",
    "rgb(0,163,0)",
    "rgb(0,163,82)",
    "rgb(0,163,163)",
    "rgb(0,82,163)",
    "rgb(0,0,163)",
    "rgb(82,0,163)",
    "rgb(163,0,163)",
    "rgb(92,0,0)",
    "rgb(92,46,0)",
    "rgb(92,92,0)",
    "rgb(0,92,0)",
    "rgb(0,92,46)",
    "rgb(0,92,92)",
    "rgb(0,46,92)",
    "rgb(0,0,92)",
    "rgb(46,0,92)",
    "rgb(92,0,92)",
    "rgb(255,255,255)",
    "rgb(205,205,205)",
    "rgb(178,178,178)",
    "rgb(153,153,153)",
    "rgb(127,127,127)",
    "rgb(102,102,102)",
    "rgb(76,76,76)",
    "rgb(51,51,51)",
    "rgb(25,25,25)",
    "rgb(0,0,0)"
], $848b1ce88e755b32$var$Pm = "M5 5 h10 v10 h-10 v-10 z", $848b1ce88e755b32$var$ox = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAH0lEQVQoU2NkYGAwZkAFZ5G5jPRRgOYEVDeB3EBjBQBOZwTVugIGyAAAAABJRU5ErkJggg==", $848b1ce88e755b32$export$32ed8655ecd274c2 = $848b1ce88e755b32$var$R({
    name: "QColor",
    props: {
        ...$848b1ce88e755b32$var$he,
        ...$848b1ce88e755b32$var$_t,
        modelValue: String,
        defaultValue: String,
        defaultView: {
            type: String,
            default: "spectrum",
            validator: (e)=>[
                    "spectrum",
                    "tune",
                    "palette"
                ].includes(e)
        },
        formatModel: {
            type: String,
            default: "auto",
            validator: (e)=>[
                    "auto",
                    "hex",
                    "rgb",
                    "hexa",
                    "rgba"
                ].includes(e)
        },
        palette: Array,
        noHeader: Boolean,
        noHeaderTabs: Boolean,
        noFooter: Boolean,
        square: Boolean,
        flat: Boolean,
        bordered: Boolean,
        disable: Boolean,
        readonly: Boolean
    },
    emits: [
        "update:modelValue",
        "change"
    ],
    setup (e, { emit: t }) {
        let { proxy: o } = (0, $fVLUl.getCurrentInstance)(), { $q: r } = o, n = $848b1ce88e755b32$var$pe(e, r), { getCache: i } = $848b1ce88e755b32$export$1c2929d84167dd53(), a = (0, $eayOh.ref)(null), l = (0, $eayOh.ref)(null), s = (0, $eayOh.computed)(()=>e.formatModel === "auto" ? null : e.formatModel.indexOf("hex") !== -1), c = (0, $eayOh.computed)(()=>e.formatModel === "auto" ? null : e.formatModel.indexOf("a") !== -1), u = (0, $eayOh.ref)(e.formatModel === "auto" ? e.modelValue === void 0 || e.modelValue === null || e.modelValue === "" || e.modelValue.startsWith("#") ? "hex" : "rgb" : e.formatModel.startsWith("hex") ? "hex" : "rgb"), v = (0, $eayOh.ref)(e.defaultView), f = (0, $eayOh.ref)(q(e.modelValue || e.defaultValue)), d = (0, $eayOh.computed)(()=>e.disable !== !0 && e.readonly !== !0), m = (0, $eayOh.computed)(()=>e.modelValue === void 0 || e.modelValue === null || e.modelValue === "" || e.modelValue.startsWith("#")), y = (0, $eayOh.computed)(()=>s.value !== null ? s.value : m.value), p = (0, $eayOh.computed)(()=>({
                type: "hidden",
                name: e.name,
                value: f.value[y.value === !0 ? "hex" : "rgb"]
            })), C = $848b1ce88e755b32$var$eo(p), b = (0, $eayOh.computed)(()=>c.value !== null ? c.value : f.value.a !== void 0), h = (0, $eayOh.computed)(()=>({
                backgroundColor: f.value.rgb || "#000"
            })), g = (0, $eayOh.computed)(()=>`q-color-picker__header-content q-color-picker__header-content--${(f.value.a !== void 0 && f.value.a < 65 ? !0 : $848b1ce88e755b32$var$Tc(f.value) > .4) ? "light" : "dark"}`), S = (0, $eayOh.computed)(()=>({
                background: `hsl(${f.value.h},100%,50%)`
            })), P = (0, $eayOh.computed)(()=>({
                top: `${100 - f.value.v}%`,
                [r.lang.rtl === !0 ? "right" : "left"]: `${f.value.s}%`
            })), $ = (0, $eayOh.computed)(()=>e.palette !== void 0 && e.palette.length !== 0 ? e.palette : $848b1ce88e755b32$var$tx), L = (0, $eayOh.computed)(()=>"q-color-picker" + (e.bordered === !0 ? " q-color-picker--bordered" : "") + (e.square === !0 ? " q-color-picker--square no-border-radius" : "") + (e.flat === !0 ? " q-color-picker--flat no-shadow" : "") + (e.disable === !0 ? " disabled" : "") + (n.value === !0 ? " q-color-picker--dark q-dark" : "")), E = (0, $eayOh.computed)(()=>e.disable === !0 ? {
                "aria-disabled": "true"
            } : {}), A = (0, $eayOh.computed)(()=>[
                [
                    $848b1ce88e755b32$export$718797250d1e376,
                    W,
                    void 0,
                    {
                        prevent: !0,
                        stop: !0,
                        mouse: !0
                    }
                ]
            ]);
        (0, $eayOh.watch)(()=>e.modelValue, (U)=>{
            let ae = q(U || e.defaultValue);
            ae.hex !== f.value.hex && (f.value = ae);
        }), (0, $eayOh.watch)(()=>e.defaultValue, (U)=>{
            if (!e.modelValue && U) {
                let ae = q(U);
                ae.hex !== f.value.hex && (f.value = ae);
            }
        });
        function B(U, ae) {
            f.value.hex = $848b1ce88e755b32$var$Vr(U), f.value.rgb = $848b1ce88e755b32$var$qc(U), f.value.r = U.r, f.value.g = U.g, f.value.b = U.b, f.value.a = U.a;
            let ce = f.value[y.value === !0 ? "hex" : "rgb"];
            t("update:modelValue", ce), ae === !0 && t("change", ce);
        }
        function q(U) {
            let ae = c.value !== void 0 ? c.value : e.formatModel === "auto" ? null : e.formatModel.indexOf("a") !== -1;
            if (typeof U != "string" || U.length === 0 || $848b1ce88e755b32$var$Dr.anyColor(U.replace(/ /g, "")) !== !0) return {
                h: 0,
                s: 0,
                v: 0,
                r: 0,
                g: 0,
                b: 0,
                a: ae === !0 ? 100 : void 0,
                hex: void 0,
                rgb: void 0
            };
            let ce = $848b1ce88e755b32$var$mn(U);
            return ae === !0 && ce.a === void 0 && (ce.a = 100), ce.hex = $848b1ce88e755b32$var$Vr(ce), ce.rgb = $848b1ce88e755b32$var$qc(ce), Object.assign(ce, $848b1ce88e755b32$var$ja(ce));
        }
        function x(U, ae, ce) {
            let be = a.value;
            if (be === null) return;
            let Me = be.clientWidth, le = be.clientHeight, Re = be.getBoundingClientRect(), Fe = Math.min(Me, Math.max(0, U - Re.left));
            r.lang.rtl === !0 && (Fe = Me - Fe);
            let De = Math.min(le, Math.max(0, ae - Re.top)), ne = Math.round(100 * Fe / Me), se = Math.round(100 * Math.max(0, Math.min(1, -(De / le) + 1))), Y = $848b1ce88e755b32$var$mu({
                h: f.value.h,
                s: ne,
                v: se,
                a: b.value === !0 ? f.value.a : void 0
            });
            f.value.s = ne, f.value.v = se, B(Y, ce);
        }
        function k(U, ae) {
            let ce = Math.round(U), be = $848b1ce88e755b32$var$mu({
                h: ce,
                s: f.value.s,
                v: f.value.v,
                a: b.value === !0 ? f.value.a : void 0
            });
            f.value.h = ce, B(be, ae);
        }
        function j(U) {
            k(U, !0);
        }
        function Q(U, ae, ce, be, Me) {
            if (be !== void 0 && $848b1ce88e755b32$var$tt(be), !/^[0-9]+$/.test(U)) {
                Me === !0 && o.$forceUpdate();
                return;
            }
            let le = Math.floor(Number(U));
            if (le < 0 || le > ce) {
                Me === !0 && o.$forceUpdate();
                return;
            }
            let Re = {
                r: ae === "r" ? le : f.value.r,
                g: ae === "g" ? le : f.value.g,
                b: ae === "b" ? le : f.value.b,
                a: b.value === !0 ? ae === "a" ? le : f.value.a : void 0
            };
            if (ae !== "a") {
                let Fe = $848b1ce88e755b32$var$ja(Re);
                f.value.h = Fe.h, f.value.s = Fe.s, f.value.v = Fe.v;
            }
            if (B(Re, Me), be !== void 0 && Me !== !0 && be.target.selectionEnd !== void 0) {
                let Fe = be.target.selectionEnd;
                (0, $fVLUl.nextTick)(()=>{
                    be.target.setSelectionRange(Fe, Fe);
                });
            }
        }
        function w(U, ae) {
            let ce, be = U.target.value;
            if ($848b1ce88e755b32$var$tt(U), u.value === "hex") {
                if (be.length !== (b.value === !0 ? 9 : 7) || !/^#[0-9A-Fa-f]+$/.test(be)) return !0;
                ce = $848b1ce88e755b32$var$fu(be);
            } else {
                let le;
                if (be.endsWith(")")) {
                    if (b.value !== !0 && be.startsWith("rgb(")) {
                        if (le = be.substring(4, be.length - 1).split(",").map((Re)=>parseInt(Re, 10)), le.length !== 3 || !/^rgb\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3}\)$/.test(be)) return !0;
                    } else if (b.value === !0 && be.startsWith("rgba(")) {
                        if (le = be.substring(5, be.length - 1).split(","), le.length !== 4 || !/^rgba\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3},(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/.test(be)) return !0;
                        for(let Fe = 0; Fe < 3; Fe++){
                            let De = parseInt(le[Fe], 10);
                            if (De < 0 || De > 255) return !0;
                            le[Fe] = De;
                        }
                        let Re = parseFloat(le[3]);
                        if (Re < 0 || Re > 1) return !0;
                        le[3] = Re;
                    } else return !0;
                } else return !0;
                if (le[0] < 0 || le[0] > 255 || le[1] < 0 || le[1] > 255 || le[2] < 0 || le[2] > 255 || b.value === !0 && (le[3] < 0 || le[3] > 1)) return !0;
                ce = {
                    r: le[0],
                    g: le[1],
                    b: le[2],
                    a: b.value === !0 ? le[3] * 100 : void 0
                };
            }
            let Me = $848b1ce88e755b32$var$ja(ce);
            if (f.value.h = Me.h, f.value.s = Me.s, f.value.v = Me.v, B(ce, ae), ae !== !0) {
                let le = U.target.selectionEnd;
                (0, $fVLUl.nextTick)(()=>{
                    U.target.setSelectionRange(le, le);
                });
            }
        }
        function H(U) {
            let ae = q(U), ce = {
                r: ae.r,
                g: ae.g,
                b: ae.b,
                a: ae.a
            };
            ce.a === void 0 && (ce.a = f.value.a), f.value.h = ae.h, f.value.s = ae.s, f.value.v = ae.v, B(ce, !0);
        }
        function W(U) {
            U.isFinal ? x(U.position.left, U.position.top, !0) : ie(U);
        }
        let ie = $848b1ce88e755b32$export$de363e709c412c8a((U)=>{
            x(U.position.left, U.position.top);
        }, 20);
        function V(U) {
            x(U.pageX - window.pageXOffset, U.pageY - window.pageYOffset, !0);
        }
        function _(U) {
            x(U.pageX - window.pageXOffset, U.pageY - window.pageYOffset);
        }
        function N(U) {
            l.value !== null && (l.value.$el.style.opacity = U ? 1 : 0);
        }
        function I(U) {
            u.value = U;
        }
        function oe() {
            let U = [];
            return e.noHeaderTabs !== !0 && U.push((0, $fVLUl.h)($848b1ce88e755b32$export$f3e10d2f5515bdea, {
                class: "q-color-picker__header-tabs",
                modelValue: u.value,
                dense: !0,
                align: "justify",
                "onUpdate:modelValue": I
            }, ()=>[
                    (0, $fVLUl.h)($848b1ce88e755b32$export$39ade007f653a559, {
                        label: "HEX" + (b.value === !0 ? "A" : ""),
                        name: "hex",
                        ripple: !1
                    }),
                    (0, $fVLUl.h)($848b1ce88e755b32$export$39ade007f653a559, {
                        label: "RGB" + (b.value === !0 ? "A" : ""),
                        name: "rgb",
                        ripple: !1
                    })
                ])), U.push((0, $fVLUl.h)("div", {
                class: "q-color-picker__header-banner row flex-center no-wrap"
            }, [
                (0, $fVLUl.h)("input", {
                    class: "fit",
                    value: f.value[u.value],
                    ...d.value !== !0 ? {
                        readonly: !0
                    } : {},
                    ...i("topIn", {
                        onInput: (ae)=>{
                            N(w(ae) === !0);
                        },
                        onChange: $848b1ce88e755b32$var$tt,
                        onBlur: (ae)=>{
                            w(ae, !0) === !0 && o.$forceUpdate(), N(!1);
                        }
                    })
                }),
                (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                    ref: l,
                    class: "q-color-picker__error-icon absolute no-pointer-events",
                    name: r.iconSet.type.negative
                })
            ])), (0, $fVLUl.h)("div", {
                class: "q-color-picker__header relative-position overflow-hidden"
            }, [
                (0, $fVLUl.h)("div", {
                    class: "q-color-picker__header-bg absolute-full"
                }),
                (0, $fVLUl.h)("div", {
                    class: g.value,
                    style: h.value
                }, U)
            ]);
        }
        function T() {
            return (0, $fVLUl.h)($848b1ce88e755b32$export$305a5380acbec321, {
                modelValue: v.value,
                animated: !0
            }, ()=>[
                    (0, $fVLUl.h)($848b1ce88e755b32$export$a513456409dea750, {
                        class: "q-color-picker__spectrum-tab overflow-hidden",
                        name: "spectrum"
                    }, z),
                    (0, $fVLUl.h)($848b1ce88e755b32$export$a513456409dea750, {
                        class: "q-pa-md q-color-picker__tune-tab",
                        name: "tune"
                    }, ue),
                    (0, $fVLUl.h)($848b1ce88e755b32$export$a513456409dea750, {
                        class: "q-color-picker__palette-tab",
                        name: "palette"
                    }, _e)
                ]);
        }
        function D(U) {
            v.value = U;
        }
        function te() {
            return (0, $fVLUl.h)("div", {
                class: "q-color-picker__footer relative-position overflow-hidden"
            }, [
                (0, $fVLUl.h)($848b1ce88e755b32$export$f3e10d2f5515bdea, {
                    class: "absolute-full",
                    modelValue: v.value,
                    dense: !0,
                    align: "justify",
                    "onUpdate:modelValue": D
                }, ()=>[
                        (0, $fVLUl.h)($848b1ce88e755b32$export$39ade007f653a559, {
                            icon: r.iconSet.colorPicker.spectrum,
                            name: "spectrum",
                            ripple: !1
                        }),
                        (0, $fVLUl.h)($848b1ce88e755b32$export$39ade007f653a559, {
                            icon: r.iconSet.colorPicker.tune,
                            name: "tune",
                            ripple: !1
                        }),
                        (0, $fVLUl.h)($848b1ce88e755b32$export$39ade007f653a559, {
                            icon: r.iconSet.colorPicker.palette,
                            name: "palette",
                            ripple: !1
                        })
                    ])
            ]);
        }
        function z() {
            let U = {
                ref: a,
                class: "q-color-picker__spectrum non-selectable relative-position cursor-pointer" + (d.value !== !0 ? " readonly" : ""),
                style: S.value,
                ...d.value === !0 ? {
                    onClick: V,
                    onMousedown: _
                } : {}
            }, ae = [
                (0, $fVLUl.h)("div", {
                    style: {
                        paddingBottom: "100%"
                    }
                }),
                (0, $fVLUl.h)("div", {
                    class: "q-color-picker__spectrum-white absolute-full"
                }),
                (0, $fVLUl.h)("div", {
                    class: "q-color-picker__spectrum-black absolute-full"
                }),
                (0, $fVLUl.h)("div", {
                    class: "absolute",
                    style: P.value
                }, [
                    f.value.hex !== void 0 ? (0, $fVLUl.h)("div", {
                        class: "q-color-picker__spectrum-circle"
                    }) : null
                ])
            ], ce = [
                (0, $fVLUl.h)($848b1ce88e755b32$export$eccd46d4261ec748, {
                    class: "q-color-picker__hue non-selectable",
                    modelValue: f.value.h,
                    min: 0,
                    max: 360,
                    trackSize: "8px",
                    innerTrackColor: "transparent",
                    selectionColor: "transparent",
                    readonly: d.value !== !0,
                    thumbPath: $848b1ce88e755b32$var$Pm,
                    "onUpdate:modelValue": k,
                    onChange: j
                })
            ];
            return b.value === !0 && ce.push((0, $fVLUl.h)($848b1ce88e755b32$export$eccd46d4261ec748, {
                class: "q-color-picker__alpha non-selectable",
                modelValue: f.value.a,
                min: 0,
                max: 100,
                trackSize: "8px",
                trackColor: "white",
                innerTrackColor: "transparent",
                selectionColor: "transparent",
                trackImg: $848b1ce88e755b32$var$ox,
                readonly: d.value !== !0,
                hideSelection: !0,
                thumbPath: $848b1ce88e755b32$var$Pm,
                ...i("alphaSlide", {
                    "onUpdate:modelValue": (be)=>Q(be, "a", 100),
                    onChange: (be)=>Q(be, "a", 100, void 0, !0)
                })
            })), [
                $848b1ce88e755b32$var$kt("div", U, ae, "spec", d.value, ()=>A.value),
                (0, $fVLUl.h)("div", {
                    class: "q-color-picker__sliders"
                }, ce)
            ];
        }
        function ue() {
            return [
                (0, $fVLUl.h)("div", {
                    class: "row items-center no-wrap"
                }, [
                    (0, $fVLUl.h)("div", "R"),
                    (0, $fVLUl.h)($848b1ce88e755b32$export$eccd46d4261ec748, {
                        modelValue: f.value.r,
                        min: 0,
                        max: 255,
                        color: "red",
                        dark: n.value,
                        readonly: d.value !== !0,
                        ...i("rSlide", {
                            "onUpdate:modelValue": (U)=>Q(U, "r", 255),
                            onChange: (U)=>Q(U, "r", 255, void 0, !0)
                        })
                    }),
                    (0, $fVLUl.h)("input", {
                        value: f.value.r,
                        maxlength: 3,
                        readonly: d.value !== !0,
                        onChange: $848b1ce88e755b32$var$tt,
                        ...i("rIn", {
                            onInput: (U)=>Q(U.target.value, "r", 255, U),
                            onBlur: (U)=>Q(U.target.value, "r", 255, U, !0)
                        })
                    })
                ]),
                (0, $fVLUl.h)("div", {
                    class: "row items-center no-wrap"
                }, [
                    (0, $fVLUl.h)("div", "G"),
                    (0, $fVLUl.h)($848b1ce88e755b32$export$eccd46d4261ec748, {
                        modelValue: f.value.g,
                        min: 0,
                        max: 255,
                        color: "green",
                        dark: n.value,
                        readonly: d.value !== !0,
                        ...i("gSlide", {
                            "onUpdate:modelValue": (U)=>Q(U, "g", 255),
                            onChange: (U)=>Q(U, "g", 255, void 0, !0)
                        })
                    }),
                    (0, $fVLUl.h)("input", {
                        value: f.value.g,
                        maxlength: 3,
                        readonly: d.value !== !0,
                        onChange: $848b1ce88e755b32$var$tt,
                        ...i("gIn", {
                            onInput: (U)=>Q(U.target.value, "g", 255, U),
                            onBlur: (U)=>Q(U.target.value, "g", 255, U, !0)
                        })
                    })
                ]),
                (0, $fVLUl.h)("div", {
                    class: "row items-center no-wrap"
                }, [
                    (0, $fVLUl.h)("div", "B"),
                    (0, $fVLUl.h)($848b1ce88e755b32$export$eccd46d4261ec748, {
                        modelValue: f.value.b,
                        min: 0,
                        max: 255,
                        color: "blue",
                        readonly: d.value !== !0,
                        dark: n.value,
                        ...i("bSlide", {
                            "onUpdate:modelValue": (U)=>Q(U, "b", 255),
                            onChange: (U)=>Q(U, "b", 255, void 0, !0)
                        })
                    }),
                    (0, $fVLUl.h)("input", {
                        value: f.value.b,
                        maxlength: 3,
                        readonly: d.value !== !0,
                        onChange: $848b1ce88e755b32$var$tt,
                        ...i("bIn", {
                            onInput: (U)=>Q(U.target.value, "b", 255, U),
                            onBlur: (U)=>Q(U.target.value, "b", 255, U, !0)
                        })
                    })
                ]),
                b.value === !0 ? (0, $fVLUl.h)("div", {
                    class: "row items-center no-wrap"
                }, [
                    (0, $fVLUl.h)("div", "A"),
                    (0, $fVLUl.h)($848b1ce88e755b32$export$eccd46d4261ec748, {
                        modelValue: f.value.a,
                        color: "grey",
                        readonly: d.value !== !0,
                        dark: n.value,
                        ...i("aSlide", {
                            "onUpdate:modelValue": (U)=>Q(U, "a", 100),
                            onChange: (U)=>Q(U, "a", 100, void 0, !0)
                        })
                    }),
                    (0, $fVLUl.h)("input", {
                        value: f.value.a,
                        maxlength: 3,
                        readonly: d.value !== !0,
                        onChange: $848b1ce88e755b32$var$tt,
                        ...i("aIn", {
                            onInput: (U)=>Q(U.target.value, "a", 100, U),
                            onBlur: (U)=>Q(U.target.value, "a", 100, U, !0)
                        })
                    })
                ]) : null
            ];
        }
        function _e() {
            let U = (ae)=>(0, $fVLUl.h)("div", {
                    class: "q-color-picker__cube col-auto",
                    style: {
                        backgroundColor: ae
                    },
                    ...d.value === !0 ? i("palette#" + ae, {
                        onClick: ()=>{
                            H(ae);
                        }
                    }) : {}
                });
            return [
                (0, $fVLUl.h)("div", {
                    class: "row items-center q-color-picker__palette-rows" + (d.value === !0 ? " q-color-picker__palette-rows--editable" : "")
                }, $.value.map(U))
            ];
        }
        return ()=>{
            let U = [
                T()
            ];
            return e.name !== void 0 && e.disable !== !0 && C(U, "push"), e.noHeader !== !0 && U.unshift(oe()), e.noFooter !== !0 && U.push(te()), (0, $fVLUl.h)("div", {
                class: L.value,
                ...E.value
            }, U);
        };
    }
});
var $848b1ce88e755b32$var$ar = [
    -61,
    9,
    38,
    199,
    426,
    686,
    756,
    818,
    1111,
    1181,
    1210,
    1635,
    2060,
    2097,
    2192,
    2262,
    2324,
    2394,
    2456,
    3178
];
function $848b1ce88e755b32$var$$m(e, t, o) {
    return Object.prototype.toString.call(e) === "[object Date]" && (o = e.getDate(), t = e.getMonth() + 1, e = e.getFullYear()), $848b1ce88e755b32$var$ax($848b1ce88e755b32$var$Rc(e, t, o));
}
function $848b1ce88e755b32$var$Mc(e, t, o) {
    return $848b1ce88e755b32$var$Bm($848b1ce88e755b32$var$ix(e, t, o));
}
function $848b1ce88e755b32$var$nx(e) {
    return $848b1ce88e755b32$var$rx(e) === 0;
}
function $848b1ce88e755b32$var$Zi(e, t) {
    return t <= 6 ? 31 : t <= 11 || $848b1ce88e755b32$var$nx(e) ? 30 : 29;
}
function $848b1ce88e755b32$var$rx(e) {
    let t = $848b1ce88e755b32$var$ar.length, o = $848b1ce88e755b32$var$ar[0], r, n, i, a, l;
    if (e < o || e >= $848b1ce88e755b32$var$ar[t - 1]) throw new Error("Invalid Jalaali year " + e);
    for(l = 1; l < t && (r = $848b1ce88e755b32$var$ar[l], n = r - o, !(e < r)); l += 1)o = r;
    return a = e - o, n - a < 6 && (a = a - n + $848b1ce88e755b32$var$St(n + 4, 33) * 33), i = $848b1ce88e755b32$var$_o($848b1ce88e755b32$var$_o(a + 1, 33) - 1, 4), i === -1 && (i = 4), i;
}
function $848b1ce88e755b32$var$Em(e, t) {
    let o = $848b1ce88e755b32$var$ar.length, r = e + 621, n = -14, i = $848b1ce88e755b32$var$ar[0], a, l, s, c, u;
    if (e < i || e >= $848b1ce88e755b32$var$ar[o - 1]) throw new Error("Invalid Jalaali year " + e);
    for(u = 1; u < o && (a = $848b1ce88e755b32$var$ar[u], l = a - i, !(e < a)); u += 1)n = n + $848b1ce88e755b32$var$St(l, 33) * 8 + $848b1ce88e755b32$var$St($848b1ce88e755b32$var$_o(l, 33), 4), i = a;
    c = e - i, n = n + $848b1ce88e755b32$var$St(c, 33) * 8 + $848b1ce88e755b32$var$St($848b1ce88e755b32$var$_o(c, 33) + 3, 4), $848b1ce88e755b32$var$_o(l, 33) === 4 && l - c === 4 && (n += 1);
    let v = $848b1ce88e755b32$var$St(r, 4) - $848b1ce88e755b32$var$St(($848b1ce88e755b32$var$St(r, 100) + 1) * 3, 4) - 150, f = 20 + n - v;
    return t || (l - c < 6 && (c = c - l + $848b1ce88e755b32$var$St(l + 4, 33) * 33), s = $848b1ce88e755b32$var$_o($848b1ce88e755b32$var$_o(c + 1, 33) - 1, 4), s === -1 && (s = 4)), {
        leap: s,
        gy: r,
        march: f
    };
}
function $848b1ce88e755b32$var$ix(e, t, o) {
    let r = $848b1ce88e755b32$var$Em(e, !0);
    return $848b1ce88e755b32$var$Rc(r.gy, 3, r.march) + (t - 1) * 31 - $848b1ce88e755b32$var$St(t, 7) * (t - 7) + o - 1;
}
function $848b1ce88e755b32$var$ax(e) {
    let t = $848b1ce88e755b32$var$Bm(e).gy, o = t - 621, r, n, i, a = $848b1ce88e755b32$var$Em(o, !1), l = $848b1ce88e755b32$var$Rc(t, 3, a.march);
    if (i = e - l, i >= 0) {
        if (i <= 185) return n = 1 + $848b1ce88e755b32$var$St(i, 31), r = $848b1ce88e755b32$var$_o(i, 31) + 1, {
            jy: o,
            jm: n,
            jd: r
        };
        i -= 186;
    } else o -= 1, i += 179, a.leap === 1 && (i += 1);
    return n = 7 + $848b1ce88e755b32$var$St(i, 30), r = $848b1ce88e755b32$var$_o(i, 30) + 1, {
        jy: o,
        jm: n,
        jd: r
    };
}
function $848b1ce88e755b32$var$Rc(e, t, o) {
    let r = $848b1ce88e755b32$var$St((e + $848b1ce88e755b32$var$St(t - 8, 6) + 100100) * 1461, 4) + $848b1ce88e755b32$var$St(153 * $848b1ce88e755b32$var$_o(t + 9, 12) + 2, 5) + o - 34840408;
    return r = r - $848b1ce88e755b32$var$St($848b1ce88e755b32$var$St(e + 100100 + $848b1ce88e755b32$var$St(t - 8, 6), 100) * 3, 4) + 752, r;
}
function $848b1ce88e755b32$var$Bm(e) {
    let t = 4 * e + 139361631;
    t = t + $848b1ce88e755b32$var$St($848b1ce88e755b32$var$St(4 * e + 183187720, 146097) * 3, 4) * 4 - 3908;
    let o = $848b1ce88e755b32$var$St($848b1ce88e755b32$var$_o(t, 1461), 4) * 5 + 308, r = $848b1ce88e755b32$var$St($848b1ce88e755b32$var$_o(o, 153), 5) + 1, n = $848b1ce88e755b32$var$_o($848b1ce88e755b32$var$St(o, 153), 12) + 1;
    return {
        gy: $848b1ce88e755b32$var$St(t, 1461) - 100100 + $848b1ce88e755b32$var$St(8 - n, 6),
        gm: n,
        gd: r
    };
}
function $848b1ce88e755b32$var$St(e, t) {
    return ~~(e / t);
}
function $848b1ce88e755b32$var$_o(e, t) {
    return e - ~~(e / t) * t;
}
var $848b1ce88e755b32$var$lx = [
    "gregorian",
    "persian"
], $848b1ce88e755b32$var$vu = {
    modelValue: {
        required: !0
    },
    mask: {
        type: String
    },
    locale: Object,
    calendar: {
        type: String,
        validator: (e)=>$848b1ce88e755b32$var$lx.includes(e),
        default: "gregorian"
    },
    landscape: Boolean,
    color: String,
    textColor: String,
    square: Boolean,
    flat: Boolean,
    bordered: Boolean,
    readonly: Boolean,
    disable: Boolean
}, $848b1ce88e755b32$var$gu = [
    "update:modelValue"
];
function $848b1ce88e755b32$var$Qo(e) {
    return e.year + "/" + $848b1ce88e755b32$var$Je(e.month) + "/" + $848b1ce88e755b32$var$Je(e.day);
}
function $848b1ce88e755b32$var$hu(e, t) {
    let o = (0, $eayOh.computed)(()=>e.disable !== !0 && e.readonly !== !0), r = (0, $eayOh.computed)(()=>o.value === !0 ? 0 : -1), n = (0, $eayOh.computed)(()=>{
        let l = [];
        return e.color !== void 0 && l.push(`bg-${e.color}`), e.textColor !== void 0 && l.push(`text-${e.textColor}`), l.join(" ");
    });
    function i() {
        return e.locale !== void 0 ? {
            ...t.lang.date,
            ...e.locale
        } : t.lang.date;
    }
    function a(l) {
        let s = new Date, c = l === !0 ? null : 0;
        if (e.calendar === "persian") {
            let u = $848b1ce88e755b32$var$$m(s);
            return {
                year: u.jy,
                month: u.jm,
                day: u.jd
            };
        }
        return {
            year: s.getFullYear(),
            month: s.getMonth() + 1,
            day: s.getDate(),
            hour: c,
            minute: c,
            second: c,
            millisecond: c
        };
    }
    return {
        editable: o,
        tabindex: r,
        headerClass: n,
        getLocale: i,
        getCurrentDate: a
    };
}
var $848b1ce88e755b32$var$Vm = 864e5, $848b1ce88e755b32$var$ux = 36e5, $848b1ce88e755b32$var$Ec = 6e4, $848b1ce88e755b32$var$zm = "YYYY-MM-DDTHH:mm:ss.SSSZ", $848b1ce88e755b32$var$sx = /\[((?:[^\]\\]|\\]|\\)*)\]|d{1,4}|M{1,4}|m{1,2}|w{1,2}|Qo|Do|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]/g, $848b1ce88e755b32$var$cx = /(\[[^\]]*\])|d{1,4}|M{1,4}|m{1,2}|w{1,2}|Qo|Do|D{1,4}|YY(?:YY)?|H{1,2}|h{1,2}|s{1,2}|S{1,3}|Z{1,2}|a{1,2}|[AQExX]|([.*+:?^,\s${}()|\\]+)/g, $848b1ce88e755b32$var$Ac = {};
function $848b1ce88e755b32$var$dx(e, t) {
    let o = "(" + t.days.join("|") + ")", r = e + o;
    if ($848b1ce88e755b32$var$Ac[r] !== void 0) return $848b1ce88e755b32$var$Ac[r];
    let n = "(" + t.daysShort.join("|") + ")", i = "(" + t.months.join("|") + ")", a = "(" + t.monthsShort.join("|") + ")", l = {}, s = 0, c = e.replace($848b1ce88e755b32$var$cx, (v)=>{
        switch(s++, v){
            case "YY":
                return l.YY = s, "(-?\\d{1,2})";
            case "YYYY":
                return l.YYYY = s, "(-?\\d{1,4})";
            case "M":
                return l.M = s, "(\\d{1,2})";
            case "MM":
                return l.M = s, "(\\d{2})";
            case "MMM":
                return l.MMM = s, a;
            case "MMMM":
                return l.MMMM = s, i;
            case "D":
                return l.D = s, "(\\d{1,2})";
            case "Do":
                return l.D = s++, "(\\d{1,2}(st|nd|rd|th))";
            case "DD":
                return l.D = s, "(\\d{2})";
            case "H":
                return l.H = s, "(\\d{1,2})";
            case "HH":
                return l.H = s, "(\\d{2})";
            case "h":
                return l.h = s, "(\\d{1,2})";
            case "hh":
                return l.h = s, "(\\d{2})";
            case "m":
                return l.m = s, "(\\d{1,2})";
            case "mm":
                return l.m = s, "(\\d{2})";
            case "s":
                return l.s = s, "(\\d{1,2})";
            case "ss":
                return l.s = s, "(\\d{2})";
            case "S":
                return l.S = s, "(\\d{1})";
            case "SS":
                return l.S = s, "(\\d{2})";
            case "SSS":
                return l.S = s, "(\\d{3})";
            case "A":
                return l.A = s, "(AM|PM)";
            case "a":
                return l.a = s, "(am|pm)";
            case "aa":
                return l.aa = s, "(a\\.m\\.|p\\.m\\.)";
            case "ddd":
                return n;
            case "dddd":
                return o;
            case "Q":
            case "d":
            case "E":
                return "(\\d{1})";
            case "Qo":
                return "(1st|2nd|3rd|4th)";
            case "DDD":
            case "DDDD":
                return "(\\d{1,3})";
            case "w":
                return "(\\d{1,2})";
            case "ww":
                return "(\\d{2})";
            case "Z":
                return l.Z = s, "(Z|[+-]\\d{2}:\\d{2})";
            case "ZZ":
                return l.ZZ = s, "(Z|[+-]\\d{2}\\d{2})";
            case "X":
                return l.X = s, "(-?\\d+)";
            case "x":
                return l.x = s, "(-?\\d{4,})";
            default:
                return s--, v[0] === "[" && (v = v.substring(1, v.length - 1)), v.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }
    }), u = {
        map: l,
        regex: new RegExp("^" + c)
    };
    return $848b1ce88e755b32$var$Ac[r] = u, u;
}
function $848b1ce88e755b32$var$Om(e, t) {
    return e !== void 0 ? e : t !== void 0 ? t.date : $848b1ce88e755b32$var$qa.default.date;
}
function $848b1ce88e755b32$var$Lm(e, t = "") {
    let o = e > 0 ? "-" : "+", r = Math.abs(e), n = Math.floor(r / 60), i = r % 60;
    return o + $848b1ce88e755b32$var$Je(n) + t + $848b1ce88e755b32$var$Je(i);
}
function $848b1ce88e755b32$var$fx(e, t, o) {
    let r = e.getFullYear(), n = e.getMonth(), i = e.getDate();
    return t.year !== void 0 && (r += o * t.year, delete t.year), t.month !== void 0 && (n += o * t.month, delete t.month), e.setDate(1), e.setMonth(2), e.setFullYear(r), e.setMonth(n), e.setDate(Math.min(i, $848b1ce88e755b32$var$Dc(e))), t.date !== void 0 && (e.setDate(e.getDate() + o * t.date), delete t.date), e;
}
function $848b1ce88e755b32$var$mx(e, t, o) {
    let r = t.year !== void 0 ? t.year : e[`get${o}FullYear`](), n = t.month !== void 0 ? t.month - 1 : e[`get${o}Month`](), i = new Date(r, n + 1, 0).getDate(), a = Math.min(i, t.date !== void 0 ? t.date : e[`get${o}Date`]());
    return e[`set${o}Date`](1), e[`set${o}Month`](2), e[`set${o}FullYear`](r), e[`set${o}Month`](n), e[`set${o}Date`](a), delete t.year, delete t.month, delete t.date, e;
}
function $848b1ce88e755b32$var$Fc(e, t, o) {
    let r = $848b1ce88e755b32$var$Im(t), n = new Date(e), i = r.year !== void 0 || r.month !== void 0 || r.date !== void 0 ? $848b1ce88e755b32$var$fx(n, r, o) : n;
    for(let a in r){
        let l = $848b1ce88e755b32$var$ec(a);
        i[`set${l}`](i[`get${l}`]() + o * r[a]);
    }
    return i;
}
function $848b1ce88e755b32$var$Im(e) {
    let t = {
        ...e
    };
    return e.years !== void 0 && (t.year = e.years, delete t.years), e.months !== void 0 && (t.month = e.months, delete t.months), e.days !== void 0 && (t.date = e.days, delete t.days), e.day !== void 0 && (t.date = e.day, delete t.day), e.hour !== void 0 && (t.hours = e.hour, delete t.hour), e.minute !== void 0 && (t.minutes = e.minute, delete t.minute), e.second !== void 0 && (t.seconds = e.second, delete t.second), e.millisecond !== void 0 && (t.milliseconds = e.millisecond, delete t.millisecond), t;
}
function $848b1ce88e755b32$var$Hm(e, t, o) {
    let r = $848b1ce88e755b32$var$Im(t), n = o === !0 ? "UTC" : "", i = new Date(e), a = r.year !== void 0 || r.month !== void 0 || r.date !== void 0 ? $848b1ce88e755b32$var$mx(i, r, n) : i;
    for(let l in r){
        let s = l.charAt(0).toUpperCase() + l.slice(1);
        a[`set${n}${s}`](r[l]);
    }
    return a;
}
function $848b1ce88e755b32$var$vx(e, t, o) {
    let r = $848b1ce88e755b32$var$lr(e, t, o), n = new Date(r.year, r.month === null ? null : r.month - 1, r.day === null ? 1 : r.day, r.hour, r.minute, r.second, r.millisecond), i = n.getTimezoneOffset();
    return r.timezoneOffset === null || r.timezoneOffset === i ? n : $848b1ce88e755b32$var$Fc(n, {
        minutes: r.timezoneOffset - i
    }, 1);
}
function $848b1ce88e755b32$var$lr(e, t, o, r, n) {
    let i = {
        year: null,
        month: null,
        day: null,
        hour: null,
        minute: null,
        second: null,
        millisecond: null,
        timezoneOffset: null,
        dateHash: null,
        timeHash: null
    };
    if (n !== void 0 && Object.assign(i, n), e == null || e === "" || typeof e != "string") return i;
    t === void 0 && (t = $848b1ce88e755b32$var$zm);
    let a = $848b1ce88e755b32$var$Om(o, $848b1ce88e755b32$export$8a4528ea5590497a.props), l = a.months, s = a.monthsShort, { regex: c, map: u } = $848b1ce88e755b32$var$dx(t, a), v = e.match(c);
    if (v === null) return i;
    let f = "";
    if (u.X !== void 0 || u.x !== void 0) {
        let d = parseInt(v[u.X !== void 0 ? u.X : u.x], 10);
        if (isNaN(d) === !0 || d < 0) return i;
        let m = new Date(d * (u.X !== void 0 ? 1e3 : 1));
        i.year = m.getFullYear(), i.month = m.getMonth() + 1, i.day = m.getDate(), i.hour = m.getHours(), i.minute = m.getMinutes(), i.second = m.getSeconds(), i.millisecond = m.getMilliseconds();
    } else {
        if (u.YYYY !== void 0) i.year = parseInt(v[u.YYYY], 10);
        else if (u.YY !== void 0) {
            let d = parseInt(v[u.YY], 10);
            i.year = d < 0 ? d : 2e3 + d;
        }
        if (u.M !== void 0) {
            if (i.month = parseInt(v[u.M], 10), i.month < 1 || i.month > 12) return i;
        } else u.MMM !== void 0 ? i.month = s.indexOf(v[u.MMM]) + 1 : u.MMMM !== void 0 && (i.month = l.indexOf(v[u.MMMM]) + 1);
        if (u.D !== void 0) {
            if (i.day = parseInt(v[u.D], 10), i.year === null || i.month === null || i.day < 1) return i;
            let d = r !== "persian" ? new Date(i.year, i.month, 0).getDate() : $848b1ce88e755b32$var$Zi(i.year, i.month);
            if (i.day > d) return i;
        }
        u.H !== void 0 ? i.hour = parseInt(v[u.H], 10) % 24 : u.h !== void 0 && (i.hour = parseInt(v[u.h], 10) % 12, (u.A && v[u.A] === "PM" || u.a && v[u.a] === "pm" || u.aa && v[u.aa] === "p.m.") && (i.hour += 12), i.hour = i.hour % 24), u.m !== void 0 && (i.minute = parseInt(v[u.m], 10) % 60), u.s !== void 0 && (i.second = parseInt(v[u.s], 10) % 60), u.S !== void 0 && (i.millisecond = parseInt(v[u.S], 10) * 10 ** (3 - v[u.S].length)), (u.Z !== void 0 || u.ZZ !== void 0) && (f = u.Z !== void 0 ? v[u.Z].replace(":", "") : v[u.ZZ], i.timezoneOffset = (f[0] === "+" ? -1 : 1) * (60 * f.slice(1, 3) + 1 * f.slice(3, 5)));
    }
    return i.dateHash = $848b1ce88e755b32$var$Je(i.year, 6) + "/" + $848b1ce88e755b32$var$Je(i.month) + "/" + $848b1ce88e755b32$var$Je(i.day), i.timeHash = $848b1ce88e755b32$var$Je(i.hour) + ":" + $848b1ce88e755b32$var$Je(i.minute) + ":" + $848b1ce88e755b32$var$Je(i.second) + f, i;
}
function $848b1ce88e755b32$var$gx(e) {
    return typeof e == "number" ? !0 : isNaN(Date.parse(e)) === !1;
}
function $848b1ce88e755b32$var$hx(e, t) {
    return $848b1ce88e755b32$var$Hm(new Date, e, t);
}
function $848b1ce88e755b32$var$px(e) {
    let t = new Date(e).getDay();
    return t === 0 ? 7 : t;
}
function $848b1ce88e755b32$var$Bc(e) {
    let t = new Date(e.getFullYear(), e.getMonth(), e.getDate());
    t.setDate(t.getDate() - (t.getDay() + 6) % 7 + 3);
    let o = new Date(t.getFullYear(), 0, 4);
    o.setDate(o.getDate() - (o.getDay() + 6) % 7 + 3);
    let r = t.getTimezoneOffset() - o.getTimezoneOffset();
    t.setHours(t.getHours() - r);
    let n = (t - o) / ($848b1ce88e755b32$var$Vm * 7);
    return 1 + Math.floor(n);
}
function $848b1ce88e755b32$var$bx(e) {
    return e.getFullYear() * 1e4 + e.getMonth() * 100 + e.getDate();
}
function $848b1ce88e755b32$var$$c(e, t) {
    let o = new Date(e);
    return t === !0 ? $848b1ce88e755b32$var$bx(o) : o.getTime();
}
function $848b1ce88e755b32$var$yx(e, t, o, r = {}) {
    let n = $848b1ce88e755b32$var$$c(t, r.onlyDate), i = $848b1ce88e755b32$var$$c(o, r.onlyDate), a = $848b1ce88e755b32$var$$c(e, r.onlyDate);
    return (a > n || r.inclusiveFrom === !0 && a === n) && (a < i || r.inclusiveTo === !0 && a === i);
}
function $848b1ce88e755b32$var$Sx(e, t) {
    return $848b1ce88e755b32$var$Fc(e, t, 1);
}
function $848b1ce88e755b32$var$xx(e, t) {
    return $848b1ce88e755b32$var$Fc(e, t, -1);
}
function $848b1ce88e755b32$var$vn(e, t, o) {
    let r = new Date(e), n = `set${o === !0 ? "UTC" : ""}`;
    switch(t){
        case "year":
        case "years":
            r[`${n}Month`](0);
        case "month":
        case "months":
            r[`${n}Date`](1);
        case "day":
        case "days":
        case "date":
            r[`${n}Hours`](0);
        case "hour":
        case "hours":
            r[`${n}Minutes`](0);
        case "minute":
        case "minutes":
            r[`${n}Seconds`](0);
        case "second":
        case "seconds":
            r[`${n}Milliseconds`](0);
    }
    return r;
}
function $848b1ce88e755b32$var$_x(e, t, o) {
    let r = new Date(e), n = `set${o === !0 ? "UTC" : ""}`;
    switch(t){
        case "year":
        case "years":
            r[`${n}Month`](11);
        case "month":
        case "months":
            r[`${n}Date`]($848b1ce88e755b32$var$Dc(r));
        case "day":
        case "days":
        case "date":
            r[`${n}Hours`](23);
        case "hour":
        case "hours":
            r[`${n}Minutes`](59);
        case "minute":
        case "minutes":
            r[`${n}Seconds`](59);
        case "second":
        case "seconds":
            r[`${n}Milliseconds`](999);
    }
    return r;
}
function $848b1ce88e755b32$var$Cx(e) {
    let t = new Date(e);
    return Array.prototype.slice.call(arguments, 1).forEach((o)=>{
        t = Math.max(t, new Date(o));
    }), t;
}
function $848b1ce88e755b32$var$wx(e) {
    let t = new Date(e);
    return Array.prototype.slice.call(arguments, 1).forEach((o)=>{
        t = Math.min(t, new Date(o));
    }), t;
}
function $848b1ce88e755b32$var$pu(e, t, o) {
    return (e.getTime() - e.getTimezoneOffset() * $848b1ce88e755b32$var$Ec - (t.getTime() - t.getTimezoneOffset() * $848b1ce88e755b32$var$Ec)) / o;
}
function $848b1ce88e755b32$var$bu(e, t, o = "days") {
    let r = new Date(e), n = new Date(t);
    switch(o){
        case "years":
        case "year":
            return r.getFullYear() - n.getFullYear();
        case "months":
        case "month":
            return (r.getFullYear() - n.getFullYear()) * 12 + r.getMonth() - n.getMonth();
        case "days":
        case "day":
        case "date":
            return $848b1ce88e755b32$var$pu($848b1ce88e755b32$var$vn(r, "day"), $848b1ce88e755b32$var$vn(n, "day"), $848b1ce88e755b32$var$Vm);
        case "hours":
        case "hour":
            return $848b1ce88e755b32$var$pu($848b1ce88e755b32$var$vn(r, "hour"), $848b1ce88e755b32$var$vn(n, "hour"), $848b1ce88e755b32$var$ux);
        case "minutes":
        case "minute":
            return $848b1ce88e755b32$var$pu($848b1ce88e755b32$var$vn(r, "minute"), $848b1ce88e755b32$var$vn(n, "minute"), $848b1ce88e755b32$var$Ec);
        case "seconds":
        case "second":
            return $848b1ce88e755b32$var$pu($848b1ce88e755b32$var$vn(r, "second"), $848b1ce88e755b32$var$vn(n, "second"), 1e3);
    }
}
function $848b1ce88e755b32$var$Lc(e) {
    return $848b1ce88e755b32$var$bu(e, $848b1ce88e755b32$var$vn(e, "year"), "days") + 1;
}
function $848b1ce88e755b32$var$kx(e) {
    return $848b1ce88e755b32$var$Pn(e) === !0 ? "date" : typeof e == "number" ? "number" : "string";
}
function $848b1ce88e755b32$var$qx(e, t, o) {
    let r = new Date(e);
    if (t) {
        let n = new Date(t);
        if (r < n) return n;
    }
    if (o) {
        let n = new Date(o);
        if (r > n) return n;
    }
    return r;
}
function $848b1ce88e755b32$var$Tx(e, t, o) {
    let r = new Date(e), n = new Date(t);
    if (o === void 0) return r.getTime() === n.getTime();
    switch(o){
        case "second":
        case "seconds":
            if (r.getSeconds() !== n.getSeconds()) return !1;
        case "minute":
        case "minutes":
            if (r.getMinutes() !== n.getMinutes()) return !1;
        case "hour":
        case "hours":
            if (r.getHours() !== n.getHours()) return !1;
        case "day":
        case "days":
        case "date":
            if (r.getDate() !== n.getDate()) return !1;
        case "month":
        case "months":
            if (r.getMonth() !== n.getMonth()) return !1;
        case "year":
        case "years":
            if (r.getFullYear() !== n.getFullYear()) return !1;
            break;
        default:
            throw new Error(`date isSameDate unknown unit ${o}`);
    }
    return !0;
}
function $848b1ce88e755b32$var$Dc(e) {
    return new Date(e.getFullYear(), e.getMonth() + 1, 0).getDate();
}
function $848b1ce88e755b32$var$Fm(e) {
    if (e >= 11 && e <= 13) return `${e}th`;
    switch(e % 10){
        case 1:
            return `${e}st`;
        case 2:
            return `${e}nd`;
        case 3:
            return `${e}rd`;
    }
    return `${e}th`;
}
var $848b1ce88e755b32$var$Dm = {
    YY (e, t, o) {
        let r = this.YYYY(e, t, o) % 100;
        return r >= 0 ? $848b1ce88e755b32$var$Je(r) : "-" + $848b1ce88e755b32$var$Je(Math.abs(r));
    },
    YYYY (e, t, o) {
        return o ?? e.getFullYear();
    },
    M (e) {
        return e.getMonth() + 1;
    },
    MM (e) {
        return $848b1ce88e755b32$var$Je(e.getMonth() + 1);
    },
    MMM (e, t) {
        return t.monthsShort[e.getMonth()];
    },
    MMMM (e, t) {
        return t.months[e.getMonth()];
    },
    Q (e) {
        return Math.ceil((e.getMonth() + 1) / 3);
    },
    Qo (e) {
        return $848b1ce88e755b32$var$Fm(this.Q(e));
    },
    D (e) {
        return e.getDate();
    },
    Do (e) {
        return $848b1ce88e755b32$var$Fm(e.getDate());
    },
    DD (e) {
        return $848b1ce88e755b32$var$Je(e.getDate());
    },
    DDD (e) {
        return $848b1ce88e755b32$var$Lc(e);
    },
    DDDD (e) {
        return $848b1ce88e755b32$var$Je($848b1ce88e755b32$var$Lc(e), 3);
    },
    d (e) {
        return e.getDay();
    },
    dd (e, t) {
        return this.dddd(e, t).slice(0, 2);
    },
    ddd (e, t) {
        return t.daysShort[e.getDay()];
    },
    dddd (e, t) {
        return t.days[e.getDay()];
    },
    E (e) {
        return e.getDay() || 7;
    },
    w (e) {
        return $848b1ce88e755b32$var$Bc(e);
    },
    ww (e) {
        return $848b1ce88e755b32$var$Je($848b1ce88e755b32$var$Bc(e));
    },
    H (e) {
        return e.getHours();
    },
    HH (e) {
        return $848b1ce88e755b32$var$Je(e.getHours());
    },
    h (e) {
        let t = e.getHours();
        return t === 0 ? 12 : t > 12 ? t % 12 : t;
    },
    hh (e) {
        return $848b1ce88e755b32$var$Je(this.h(e));
    },
    m (e) {
        return e.getMinutes();
    },
    mm (e) {
        return $848b1ce88e755b32$var$Je(e.getMinutes());
    },
    s (e) {
        return e.getSeconds();
    },
    ss (e) {
        return $848b1ce88e755b32$var$Je(e.getSeconds());
    },
    S (e) {
        return Math.floor(e.getMilliseconds() / 100);
    },
    SS (e) {
        return $848b1ce88e755b32$var$Je(Math.floor(e.getMilliseconds() / 10));
    },
    SSS (e) {
        return $848b1ce88e755b32$var$Je(e.getMilliseconds(), 3);
    },
    A (e) {
        return this.H(e) < 12 ? "AM" : "PM";
    },
    a (e) {
        return this.H(e) < 12 ? "am" : "pm";
    },
    aa (e) {
        return this.H(e) < 12 ? "a.m." : "p.m.";
    },
    Z (e, t, o, r) {
        let n = r ?? e.getTimezoneOffset();
        return $848b1ce88e755b32$var$Lm(n, ":");
    },
    ZZ (e, t, o, r) {
        let n = r ?? e.getTimezoneOffset();
        return $848b1ce88e755b32$var$Lm(n);
    },
    X (e) {
        return Math.floor(e.getTime() / 1e3);
    },
    x (e) {
        return e.getTime();
    }
};
function $848b1ce88e755b32$var$Ka(e, t, o, r, n) {
    if (e !== 0 && !e || e === 1 / 0 || e === -1 / 0) return;
    let i = new Date(e);
    if (isNaN(i)) return;
    t === void 0 && (t = $848b1ce88e755b32$var$zm);
    let a = $848b1ce88e755b32$var$Om(o, $848b1ce88e755b32$export$8a4528ea5590497a.props);
    return t.replace($848b1ce88e755b32$var$sx, (l, s)=>l in $848b1ce88e755b32$var$Dm ? $848b1ce88e755b32$var$Dm[l](i, a, r, n) : s === void 0 ? l : s.split("\\]").join("]"));
}
function $848b1ce88e755b32$var$Mx(e) {
    return $848b1ce88e755b32$var$Pn(e) === !0 ? new Date(e.getTime()) : e;
}
var $848b1ce88e755b32$export$324d90190a8b822a = {
    isValid: $848b1ce88e755b32$var$gx,
    extractDate: $848b1ce88e755b32$var$vx,
    buildDate: $848b1ce88e755b32$var$hx,
    getDayOfWeek: $848b1ce88e755b32$var$px,
    getWeekOfYear: $848b1ce88e755b32$var$Bc,
    isBetweenDates: $848b1ce88e755b32$var$yx,
    addToDate: $848b1ce88e755b32$var$Sx,
    subtractFromDate: $848b1ce88e755b32$var$xx,
    adjustDate: $848b1ce88e755b32$var$Hm,
    startOfDate: $848b1ce88e755b32$var$vn,
    endOfDate: $848b1ce88e755b32$var$_x,
    getMaxDate: $848b1ce88e755b32$var$Cx,
    getMinDate: $848b1ce88e755b32$var$wx,
    getDateDiff: $848b1ce88e755b32$var$bu,
    getDayOfYear: $848b1ce88e755b32$var$Lc,
    inferDateFormat: $848b1ce88e755b32$var$kx,
    getDateBetween: $848b1ce88e755b32$var$qx,
    isSameDate: $848b1ce88e755b32$var$Tx,
    daysInMonth: $848b1ce88e755b32$var$Dc,
    formatDate: $848b1ce88e755b32$var$Ka,
    clone: $848b1ce88e755b32$var$Mx
};
var $848b1ce88e755b32$var$zr = 20, $848b1ce88e755b32$var$Ax = [
    "Calendar",
    "Years",
    "Months"
], $848b1ce88e755b32$var$Qm = (e)=>$848b1ce88e755b32$var$Ax.includes(e), $848b1ce88e755b32$var$Vc = (e)=>/^-?[\d]+\/[0-1]\d$/.test(e), $848b1ce88e755b32$var$Ji = " \u2014 ";
function $848b1ce88e755b32$var$ur(e) {
    return e.year + "/" + $848b1ce88e755b32$var$Je(e.month);
}
var $848b1ce88e755b32$export$599a443f7d1feef = $848b1ce88e755b32$var$R({
    name: "QDate",
    props: {
        ...$848b1ce88e755b32$var$vu,
        ...$848b1ce88e755b32$var$_t,
        ...$848b1ce88e755b32$var$he,
        multiple: Boolean,
        range: Boolean,
        title: String,
        subtitle: String,
        mask: {
            default: "YYYY/MM/DD"
        },
        defaultYearMonth: {
            type: String,
            validator: $848b1ce88e755b32$var$Vc
        },
        yearsInMonthView: Boolean,
        events: [
            Array,
            Function
        ],
        eventColor: [
            String,
            Function
        ],
        emitImmediately: Boolean,
        options: [
            Array,
            Function
        ],
        navigationMinYearMonth: {
            type: String,
            validator: $848b1ce88e755b32$var$Vc
        },
        navigationMaxYearMonth: {
            type: String,
            validator: $848b1ce88e755b32$var$Vc
        },
        noUnset: Boolean,
        firstDayOfWeek: [
            String,
            Number
        ],
        todayBtn: Boolean,
        minimal: Boolean,
        defaultView: {
            type: String,
            default: "Calendar",
            validator: $848b1ce88e755b32$var$Qm
        }
    },
    emits: [
        ...$848b1ce88e755b32$var$gu,
        "rangeStart",
        "rangeEnd",
        "navigation"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: r } = (0, $fVLUl.getCurrentInstance)(), { $q: n } = r, i = $848b1ce88e755b32$var$pe(e, n), { getCache: a } = $848b1ce88e755b32$export$1c2929d84167dd53(), { tabindex: l, headerClass: s, getLocale: c, getCurrentDate: u } = $848b1ce88e755b32$var$hu(e, n), v, f = $848b1ce88e755b32$var$cn(e), d = $848b1ce88e755b32$var$eo(f), m = (0, $eayOh.ref)(null), y = (0, $eayOh.ref)(nt()), p = (0, $eayOh.ref)(c()), C = (0, $eayOh.computed)(()=>nt()), b = (0, $eayOh.computed)(()=>c()), h = (0, $eayOh.computed)(()=>u()), g = (0, $eayOh.ref)(dt(y.value, p.value)), S = (0, $eayOh.ref)(e.defaultView), P = n.lang.rtl === !0 ? "right" : "left", $ = (0, $eayOh.ref)(P.value), L = (0, $eayOh.ref)(P.value), E = g.value.year, A = (0, $eayOh.ref)(E - E % $848b1ce88e755b32$var$zr - (E < 0 ? $848b1ce88e755b32$var$zr : 0)), B = (0, $eayOh.ref)(null), q = (0, $eayOh.computed)(()=>{
            let M = e.landscape === !0 ? "landscape" : "portrait";
            return `q-date q-date--${M} q-date--${M}-${e.minimal === !0 ? "minimal" : "standard"}` + (i.value === !0 ? " q-date--dark q-dark" : "") + (e.bordered === !0 ? " q-date--bordered" : "") + (e.square === !0 ? " q-date--square no-border-radius" : "") + (e.flat === !0 ? " q-date--flat no-shadow" : "") + (e.disable === !0 ? " disabled" : e.readonly === !0 ? " q-date--readonly" : "");
        }), x = (0, $eayOh.computed)(()=>e.color || "primary"), k = (0, $eayOh.computed)(()=>e.textColor || "white"), j = (0, $eayOh.computed)(()=>e.emitImmediately === !0 && e.multiple !== !0 && e.range !== !0), Q = (0, $eayOh.computed)(()=>Array.isArray(e.modelValue) === !0 ? e.modelValue : e.modelValue !== null && e.modelValue !== void 0 ? [
                e.modelValue
            ] : []), w = (0, $eayOh.computed)(()=>Q.value.filter((M)=>typeof M == "string").map((M)=>ct(M, y.value, p.value)).filter((M)=>M.dateHash !== null && M.day !== null && M.month !== null && M.year !== null)), H = (0, $eayOh.computed)(()=>{
            let M = (O)=>ct(O, y.value, p.value);
            return Q.value.filter((O)=>$848b1ce88e755b32$var$at(O) === !0 && O.from !== void 0 && O.to !== void 0).map((O)=>({
                    from: M(O.from),
                    to: M(O.to)
                })).filter((O)=>O.from.dateHash !== null && O.to.dateHash !== null && O.from.dateHash < O.to.dateHash);
        }), W = (0, $eayOh.computed)(()=>e.calendar !== "persian" ? (M)=>new Date(M.year, M.month - 1, M.day) : (M)=>{
                let O = $848b1ce88e755b32$var$Mc(M.year, M.month, M.day);
                return new Date(O.gy, O.gm - 1, O.gd);
            }), ie = (0, $eayOh.computed)(()=>e.calendar === "persian" ? $848b1ce88e755b32$var$Qo : (M, O, X)=>$848b1ce88e755b32$var$Ka(new Date(M.year, M.month - 1, M.day, M.hour, M.minute, M.second, M.millisecond), O === void 0 ? y.value : O, X === void 0 ? p.value : X, M.year, M.timezoneOffset)), V = (0, $eayOh.computed)(()=>w.value.length + H.value.reduce((M, O)=>M + 1 + $848b1ce88e755b32$var$bu(W.value(O.to), W.value(O.from)), 0)), _ = (0, $eayOh.computed)(()=>{
            if (e.title !== void 0 && e.title !== null && e.title.length !== 0) return e.title;
            if (B.value !== null) {
                let X = B.value.init, de = W.value(X);
                return p.value.daysShort[de.getDay()] + ", " + p.value.monthsShort[X.month - 1] + " " + X.day + $848b1ce88e755b32$var$Ji + "?";
            }
            if (V.value === 0) return $848b1ce88e755b32$var$Ji;
            if (V.value > 1) return `${V.value} ${p.value.pluralDay}`;
            let M = w.value[0], O = W.value(M);
            return isNaN(O.valueOf()) === !0 ? $848b1ce88e755b32$var$Ji : p.value.headerTitle !== void 0 ? p.value.headerTitle(O, M) : p.value.daysShort[O.getDay()] + ", " + p.value.monthsShort[M.month - 1] + " " + M.day;
        }), N = (0, $eayOh.computed)(()=>w.value.concat(H.value.map((O)=>O.from)).sort((O, X)=>O.year - X.year || O.month - X.month)[0]), I = (0, $eayOh.computed)(()=>w.value.concat(H.value.map((O)=>O.to)).sort((O, X)=>X.year - O.year || X.month - O.month)[0]), oe = (0, $eayOh.computed)(()=>{
            if (e.subtitle !== void 0 && e.subtitle !== null && e.subtitle.length !== 0) return e.subtitle;
            if (V.value === 0) return $848b1ce88e755b32$var$Ji;
            if (V.value > 1) {
                let M = N.value, O = I.value, X = p.value.monthsShort;
                return X[M.month - 1] + (M.year !== O.year ? " " + M.year + $848b1ce88e755b32$var$Ji + X[O.month - 1] + " " : M.month !== O.month ? $848b1ce88e755b32$var$Ji + X[O.month - 1] : "") + " " + O.year;
            }
            return w.value[0].year;
        }), T = (0, $eayOh.computed)(()=>{
            let M = [
                n.iconSet.datetime.arrowLeft,
                n.iconSet.datetime.arrowRight
            ];
            return n.lang.rtl === !0 ? M.reverse() : M;
        }), D = (0, $eayOh.computed)(()=>e.firstDayOfWeek !== void 0 ? Number(e.firstDayOfWeek) : p.value.firstDayOfWeek), te = (0, $eayOh.computed)(()=>{
            let M = p.value.daysShort, O = D.value;
            return O > 0 ? M.slice(O, 7).concat(M.slice(0, O)) : M;
        }), z = (0, $eayOh.computed)(()=>{
            let M = g.value;
            return e.calendar !== "persian" ? new Date(M.year, M.month, 0).getDate() : $848b1ce88e755b32$var$Zi(M.year, M.month);
        }), ue = (0, $eayOh.computed)(()=>typeof e.eventColor == "function" ? e.eventColor : ()=>e.eventColor), _e = (0, $eayOh.computed)(()=>{
            if (e.navigationMinYearMonth === void 0) return null;
            let M = e.navigationMinYearMonth.split("/");
            return {
                year: parseInt(M[0], 10),
                month: parseInt(M[1], 10)
            };
        }), U = (0, $eayOh.computed)(()=>{
            if (e.navigationMaxYearMonth === void 0) return null;
            let M = e.navigationMaxYearMonth.split("/");
            return {
                year: parseInt(M[0], 10),
                month: parseInt(M[1], 10)
            };
        }), ae = (0, $eayOh.computed)(()=>{
            let M = {
                month: {
                    prev: !0,
                    next: !0
                },
                year: {
                    prev: !0,
                    next: !0
                }
            };
            return _e.value !== null && _e.value.year >= g.value.year && (M.year.prev = !1, _e.value.year === g.value.year && _e.value.month >= g.value.month && (M.month.prev = !1)), U.value !== null && U.value.year <= g.value.year && (M.year.next = !1, U.value.year === g.value.year && U.value.month <= g.value.month && (M.month.next = !1)), M;
        }), ce = (0, $eayOh.computed)(()=>{
            let M = {};
            return w.value.forEach((O)=>{
                let X = $848b1ce88e755b32$var$ur(O);
                M[X] === void 0 && (M[X] = []), M[X].push(O.day);
            }), M;
        }), be = (0, $eayOh.computed)(()=>{
            let M = {};
            return H.value.forEach((O)=>{
                let X = $848b1ce88e755b32$var$ur(O.from), de = $848b1ce88e755b32$var$ur(O.to);
                if (M[X] === void 0 && (M[X] = []), M[X].push({
                    from: O.from.day,
                    to: X === de ? O.to.day : void 0,
                    range: O
                }), X < de) {
                    let fe, { year: et, month: Te } = O.from, We = Te < 12 ? {
                        year: et,
                        month: Te + 1
                    } : {
                        year: et + 1,
                        month: 1
                    };
                    for(; (fe = $848b1ce88e755b32$var$ur(We)) <= de;)M[fe] === void 0 && (M[fe] = []), M[fe].push({
                        from: void 0,
                        to: fe === de ? O.to.day : void 0,
                        range: O
                    }), We.month++, We.month > 12 && (We.year++, We.month = 1);
                }
            }), M;
        }), Me = (0, $eayOh.computed)(()=>{
            if (B.value === null) return;
            let { init: M, initHash: O, final: X, finalHash: de } = B.value, [fe, et] = O <= de ? [
                M,
                X
            ] : [
                X,
                M
            ], Te = $848b1ce88e755b32$var$ur(fe), We = $848b1ce88e755b32$var$ur(et);
            if (Te !== le.value && We !== le.value) return;
            let rt = {};
            return Te === le.value ? (rt.from = fe.day, rt.includeFrom = !0) : rt.from = 1, We === le.value ? (rt.to = et.day, rt.includeTo = !0) : rt.to = z.value, rt;
        }), le = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$ur(g.value)), Re = (0, $eayOh.computed)(()=>{
            let M = {};
            if (e.options === void 0) {
                for(let X = 1; X <= z.value; X++)M[X] = !0;
                return M;
            }
            let O = typeof e.options == "function" ? e.options : (X)=>e.options.includes(X);
            for(let X = 1; X <= z.value; X++){
                let de = le.value + "/" + $848b1ce88e755b32$var$Je(X);
                M[X] = O(de);
            }
            return M;
        }), Fe = (0, $eayOh.computed)(()=>{
            let M = {};
            if (e.events === void 0) for(let O = 1; O <= z.value; O++)M[O] = !1;
            else {
                let O = typeof e.events == "function" ? e.events : (X)=>e.events.includes(X);
                for(let X = 1; X <= z.value; X++){
                    let de = le.value + "/" + $848b1ce88e755b32$var$Je(X);
                    M[X] = O(de) === !0 && ue.value(de);
                }
            }
            return M;
        }), De = (0, $eayOh.computed)(()=>{
            let M, O, { year: X, month: de } = g.value;
            if (e.calendar !== "persian") M = new Date(X, de - 1, 1), O = new Date(X, de - 1, 0).getDate();
            else {
                let fe = $848b1ce88e755b32$var$Mc(X, de, 1);
                M = new Date(fe.gy, fe.gm - 1, fe.gd);
                let et = de - 1, Te = X;
                et === 0 && (et = 12, Te--), O = $848b1ce88e755b32$var$Zi(Te, et);
            }
            return {
                days: M.getDay() - D.value - 1,
                endDay: O
            };
        }), ne = (0, $eayOh.computed)(()=>{
            let M = [], { days: O, endDay: X } = De.value, de = O < 0 ? O + 7 : O;
            if (de < 6) for(let Te = X - de; Te <= X; Te++)M.push({
                i: Te,
                fill: !0
            });
            let fe = M.length;
            for(let Te = 1; Te <= z.value; Te++){
                let We = {
                    i: Te,
                    event: Fe.value[Te],
                    classes: []
                };
                Re.value[Te] === !0 && (We.in = !0, We.flat = !0), M.push(We);
            }
            if (ce.value[le.value] !== void 0 && ce.value[le.value].forEach((Te)=>{
                let We = fe + Te - 1;
                Object.assign(M[We], {
                    selected: !0,
                    unelevated: !0,
                    flat: !1,
                    color: x.value,
                    textColor: k.value
                });
            }), be.value[le.value] !== void 0 && be.value[le.value].forEach((Te)=>{
                if (Te.from !== void 0) {
                    let We = fe + Te.from - 1, rt = fe + (Te.to || z.value) - 1;
                    for(let To = We; To <= rt; To++)Object.assign(M[To], {
                        range: Te.range,
                        unelevated: !0,
                        color: x.value,
                        textColor: k.value
                    });
                    Object.assign(M[We], {
                        rangeFrom: !0,
                        flat: !1
                    }), Te.to !== void 0 && Object.assign(M[rt], {
                        rangeTo: !0,
                        flat: !1
                    });
                } else if (Te.to !== void 0) {
                    let We = fe + Te.to - 1;
                    for(let rt = fe; rt <= We; rt++)Object.assign(M[rt], {
                        range: Te.range,
                        unelevated: !0,
                        color: x.value,
                        textColor: k.value
                    });
                    Object.assign(M[We], {
                        flat: !1,
                        rangeTo: !0
                    });
                } else {
                    let We = fe + z.value - 1;
                    for(let rt = fe; rt <= We; rt++)Object.assign(M[rt], {
                        range: Te.range,
                        unelevated: !0,
                        color: x.value,
                        textColor: k.value
                    });
                }
            }), Me.value !== void 0) {
                let Te = fe + Me.value.from - 1, We = fe + Me.value.to - 1;
                for(let rt = Te; rt <= We; rt++)M[rt].color = x.value, M[rt].editRange = !0;
                Me.value.includeFrom === !0 && (M[Te].editRangeFrom = !0), Me.value.includeTo === !0 && (M[We].editRangeTo = !0);
            }
            g.value.year === h.value.year && g.value.month === h.value.month && (M[fe + h.value.day - 1].today = !0);
            let et = M.length % 7;
            if (et > 0) {
                let Te = 7 - et;
                for(let We = 1; We <= Te; We++)M.push({
                    i: We,
                    fill: !0
                });
            }
            return M.forEach((Te)=>{
                let We = "q-date__calendar-item ";
                Te.fill === !0 ? We += "q-date__calendar-item--fill" : (We += `q-date__calendar-item--${Te.in === !0 ? "in" : "out"}`, Te.range !== void 0 && (We += ` q-date__range${Te.rangeTo === !0 ? "-to" : Te.rangeFrom === !0 ? "-from" : ""}`), Te.editRange === !0 && (We += ` q-date__edit-range${Te.editRangeFrom === !0 ? "-from" : ""}${Te.editRangeTo === !0 ? "-to" : ""}`), (Te.range !== void 0 || Te.editRange === !0) && (We += ` text-${Te.color}`)), Te.classes = We;
            }), M;
        }), se = (0, $eayOh.computed)(()=>e.disable === !0 ? {
                "aria-disabled": "true"
            } : {});
        (0, $eayOh.watch)(()=>e.modelValue, (M)=>{
            if (v === M) v = 0;
            else {
                let O = dt(y.value, p.value);
                Ge(O.year, O.month, O);
            }
        }), (0, $eayOh.watch)(S, ()=>{
            m.value !== null && r.$el.contains(document.activeElement) === !0 && m.value.focus();
        }), (0, $eayOh.watch)(()=>g.value.year + "|" + g.value.month, ()=>{
            o("navigation", {
                year: g.value.year,
                month: g.value.month
            });
        }), (0, $eayOh.watch)(C, (M)=>{
            Z(M, p.value, "mask"), y.value = M;
        }), (0, $eayOh.watch)(b, (M)=>{
            Z(y.value, M, "locale"), p.value = M;
        });
        function Y() {
            let { year: M, month: O, day: X } = h.value, de = {
                ...g.value,
                year: M,
                month: O,
                day: X
            }, fe = ce.value[$848b1ce88e755b32$var$ur(de)];
            (fe === void 0 || fe.includes(de.day) === !1) && kn(de), Ee(de.year, de.month);
        }
        function me(M) {
            $848b1ce88e755b32$var$Qm(M) === !0 && (S.value = M);
        }
        function Pe(M, O) {
            [
                "month",
                "year"
            ].includes(M) && (M === "month" ? re : K)(O === !0 ? -1 : 1);
        }
        function Ee(M, O) {
            S.value = "Calendar", Ge(M, O);
        }
        function Ae(M, O) {
            if (e.range === !1 || !M) {
                B.value = null;
                return;
            }
            let X = Object.assign({
                ...g.value
            }, M), de = O !== void 0 ? Object.assign({
                ...g.value
            }, O) : X;
            B.value = {
                init: X,
                initHash: $848b1ce88e755b32$var$Qo(X),
                final: de,
                finalHash: $848b1ce88e755b32$var$Qo(de)
            }, Ee(X.year, X.month);
        }
        function nt() {
            return e.calendar === "persian" ? "YYYY/MM/DD" : e.mask;
        }
        function ct(M, O, X) {
            return $848b1ce88e755b32$var$lr(M, O, X, e.calendar, {
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0
            });
        }
        function dt(M, O) {
            let X = Array.isArray(e.modelValue) === !0 ? e.modelValue : e.modelValue ? [
                e.modelValue
            ] : [];
            if (X.length === 0) return G();
            let de = X[X.length - 1], fe = ct(de.from !== void 0 ? de.from : de, M, O);
            return fe.dateHash === null ? G() : fe;
        }
        function G() {
            let M, O;
            if (e.defaultYearMonth !== void 0) {
                let X = e.defaultYearMonth.split("/");
                M = parseInt(X[0], 10), O = parseInt(X[1], 10);
            } else {
                let X = h.value !== void 0 ? h.value : u();
                M = X.year, O = X.month;
            }
            return {
                year: M,
                month: O,
                day: 1,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                dateHash: M + "/" + $848b1ce88e755b32$var$Je(O) + "/01"
            };
        }
        function re(M) {
            let O = g.value.year, X = Number(g.value.month) + M;
            X === 13 ? (X = 1, O++) : X === 0 && (X = 12, O--), Ge(O, X), j.value === !0 && ht("month");
        }
        function K(M) {
            let O = Number(g.value.year) + M;
            Ge(O, g.value.month), j.value === !0 && ht("year");
        }
        function ee(M) {
            Ge(M, g.value.month), S.value = e.defaultView === "Years" ? "Months" : "Calendar", j.value === !0 && ht("year");
        }
        function ke(M) {
            Ge(g.value.year, M), S.value = "Calendar", j.value === !0 && ht("month");
        }
        function ze(M, O) {
            let X = ce.value[O];
            (X !== void 0 && X.includes(M.day) === !0 ? en : kn)(M);
        }
        function ye(M) {
            return {
                year: M.year,
                month: M.month,
                day: M.day
            };
        }
        function Ge(M, O, X) {
            if (_e.value !== null && M <= _e.value.year && ((O < _e.value.month || M < _e.value.year) && (O = _e.value.month), M = _e.value.year), U.value !== null && M >= U.value.year && ((O > U.value.month || M > U.value.year) && (O = U.value.month), M = U.value.year), X !== void 0) {
                let { hour: fe, minute: et, second: Te, millisecond: We, timezoneOffset: rt, timeHash: To } = X;
                Object.assign(g.value, {
                    hour: fe,
                    minute: et,
                    second: Te,
                    millisecond: We,
                    timezoneOffset: rt,
                    timeHash: To
                });
            }
            let de = M + "/" + $848b1ce88e755b32$var$Je(O) + "/01";
            de !== g.value.dateHash && ($.value = g.value.dateHash < de == (n.lang.rtl !== !0) ? "left" : "right", M !== g.value.year && (L.value = $.value), (0, $fVLUl.nextTick)(()=>{
                A.value = M - M % $848b1ce88e755b32$var$zr - (M < 0 ? $848b1ce88e755b32$var$zr : 0), Object.assign(g.value, {
                    year: M,
                    month: O,
                    day: 1,
                    dateHash: de
                });
            }));
        }
        function mt(M, O, X) {
            let de = M !== null && M.length === 1 && e.multiple === !1 ? M[0] : M;
            v = de;
            let { reason: fe, details: et } = ro(O, X);
            o("update:modelValue", de, fe, et);
        }
        function ht(M) {
            let O = w.value[0] !== void 0 && w.value[0].dateHash !== null ? {
                ...w.value[0]
            } : {
                ...g.value
            };
            (0, $fVLUl.nextTick)(()=>{
                O.year = g.value.year, O.month = g.value.month;
                let X = e.calendar !== "persian" ? new Date(O.year, O.month, 0).getDate() : $848b1ce88e755b32$var$Zi(O.year, O.month);
                O.day = Math.min(Math.max(1, O.day), X);
                let de = qo(O);
                v = de;
                let { details: fe } = ro("", O);
                o("update:modelValue", de, M, fe);
            });
        }
        function ro(M, O) {
            return O.from !== void 0 ? {
                reason: `${M}-range`,
                details: {
                    ...ye(O.target),
                    from: ye(O.from),
                    to: ye(O.to)
                }
            } : {
                reason: `${M}-day`,
                details: ye(O)
            };
        }
        function qo(M, O, X) {
            return M.from !== void 0 ? {
                from: ie.value(M.from, O, X),
                to: ie.value(M.to, O, X)
            } : ie.value(M, O, X);
        }
        function kn(M) {
            let O;
            if (e.multiple === !0) {
                if (M.from !== void 0) {
                    let X = $848b1ce88e755b32$var$Qo(M.from), de = $848b1ce88e755b32$var$Qo(M.to), fe = w.value.filter((Te)=>Te.dateHash < X || Te.dateHash > de), et = H.value.filter(({ from: Te, to: We })=>We.dateHash < X || Te.dateHash > de);
                    O = fe.concat(et).concat(M).map((Te)=>qo(Te));
                } else {
                    let X = Q.value.slice();
                    X.push(qo(M)), O = X;
                }
            } else O = qo(M);
            mt(O, "add", M);
        }
        function en(M) {
            if (e.noUnset === !0) return;
            let O = null;
            if (e.multiple === !0 && Array.isArray(e.modelValue) === !0) {
                let X = qo(M);
                M.from !== void 0 ? O = e.modelValue.filter((de)=>de.from !== void 0 ? de.from !== X.from && de.to !== X.to : !0) : O = e.modelValue.filter((de)=>de !== X), O.length === 0 && (O = null);
            }
            mt(O, "remove", M);
        }
        function Z(M, O, X) {
            let de = w.value.concat(H.value).map((fe)=>qo(fe, M, O)).filter((fe)=>fe.from !== void 0 ? fe.from.dateHash !== null && fe.to.dateHash !== null : fe.dateHash !== null);
            o("update:modelValue", (e.multiple === !0 ? de : de[0]) || null, X);
        }
        function ve() {
            if (e.minimal !== !0) return (0, $fVLUl.h)("div", {
                class: "q-date__header " + s.value
            }, [
                (0, $fVLUl.h)("div", {
                    class: "relative-position"
                }, [
                    (0, $fVLUl.h)((0, $24349.Transition), {
                        name: "q-transition--fade"
                    }, ()=>(0, $fVLUl.h)("div", {
                            key: "h-yr-" + oe.value,
                            class: "q-date__header-subtitle q-date__header-link " + (S.value === "Years" ? "q-date__header-link--active" : "cursor-pointer"),
                            tabindex: l.value,
                            ...a("vY", {
                                onClick () {
                                    S.value = "Years";
                                },
                                onKeyup (M) {
                                    M.keyCode === 13 && (S.value = "Years");
                                }
                            })
                        }, [
                            oe.value
                        ]))
                ]),
                (0, $fVLUl.h)("div", {
                    class: "q-date__header-title relative-position flex no-wrap"
                }, [
                    (0, $fVLUl.h)("div", {
                        class: "relative-position col"
                    }, [
                        (0, $fVLUl.h)((0, $24349.Transition), {
                            name: "q-transition--fade"
                        }, ()=>(0, $fVLUl.h)("div", {
                                key: "h-sub" + _.value,
                                class: "q-date__header-title-label q-date__header-link " + (S.value === "Calendar" ? "q-date__header-link--active" : "cursor-pointer"),
                                tabindex: l.value,
                                ...a("vC", {
                                    onClick () {
                                        S.value = "Calendar";
                                    },
                                    onKeyup (M) {
                                        M.keyCode === 13 && (S.value = "Calendar");
                                    }
                                })
                            }, [
                                _.value
                            ]))
                    ]),
                    e.todayBtn === !0 ? (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                        class: "q-date__header-today self-start",
                        icon: n.iconSet.datetime.today,
                        flat: !0,
                        size: "sm",
                        round: !0,
                        tabindex: l.value,
                        onClick: Y
                    }) : null
                ])
            ]);
        }
        function qe({ label: M, type: O, key: X, dir: de, goTo: fe, boundaries: et, cls: Te }) {
            return [
                (0, $fVLUl.h)("div", {
                    class: "row items-center q-date__arrow"
                }, [
                    (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                        round: !0,
                        dense: !0,
                        size: "sm",
                        flat: !0,
                        icon: T.value[0],
                        tabindex: l.value,
                        disable: et.prev === !1,
                        ...a("go-#" + O, {
                            onClick () {
                                fe(-1);
                            }
                        })
                    })
                ]),
                (0, $fVLUl.h)("div", {
                    class: "relative-position overflow-hidden flex flex-center" + Te
                }, [
                    (0, $fVLUl.h)((0, $24349.Transition), {
                        name: "q-transition--jump-" + de
                    }, ()=>(0, $fVLUl.h)("div", {
                            key: X
                        }, [
                            (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                                flat: !0,
                                dense: !0,
                                noCaps: !0,
                                label: M,
                                tabindex: l.value,
                                ...a("view#" + O, {
                                    onClick: ()=>{
                                        S.value = O;
                                    }
                                })
                            })
                        ]))
                ]),
                (0, $fVLUl.h)("div", {
                    class: "row items-center q-date__arrow"
                }, [
                    (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                        round: !0,
                        dense: !0,
                        size: "sm",
                        flat: !0,
                        icon: T.value[1],
                        tabindex: l.value,
                        disable: et.next === !1,
                        ...a("go+#" + O, {
                            onClick () {
                                fe(1);
                            }
                        })
                    })
                ])
            ];
        }
        let Be = {
            Calendar: ()=>[
                    (0, $fVLUl.h)("div", {
                        key: "calendar-view",
                        class: "q-date__view q-date__calendar"
                    }, [
                        (0, $fVLUl.h)("div", {
                            class: "q-date__navigation row items-center no-wrap"
                        }, qe({
                            label: p.value.months[g.value.month - 1],
                            type: "Months",
                            key: g.value.month,
                            dir: $.value,
                            goTo: re,
                            boundaries: ae.value.month,
                            cls: " col"
                        }).concat(qe({
                            label: g.value.year,
                            type: "Years",
                            key: g.value.year,
                            dir: L.value,
                            goTo: K,
                            boundaries: ae.value.year,
                            cls: ""
                        }))),
                        (0, $fVLUl.h)("div", {
                            class: "q-date__calendar-weekdays row items-center no-wrap"
                        }, te.value.map((M)=>(0, $fVLUl.h)("div", {
                                class: "q-date__calendar-item"
                            }, [
                                (0, $fVLUl.h)("div", M)
                            ]))),
                        (0, $fVLUl.h)("div", {
                            class: "q-date__calendar-days-container relative-position overflow-hidden"
                        }, [
                            (0, $fVLUl.h)((0, $24349.Transition), {
                                name: "q-transition--slide-" + $.value
                            }, ()=>(0, $fVLUl.h)("div", {
                                    key: le.value,
                                    class: "q-date__calendar-days fit"
                                }, ne.value.map((M)=>(0, $fVLUl.h)("div", {
                                        class: M.classes
                                    }, [
                                        M.in === !0 ? (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                                            class: M.today === !0 ? "q-date__today" : "",
                                            dense: !0,
                                            flat: M.flat,
                                            unelevated: M.unelevated,
                                            color: M.color,
                                            textColor: M.textColor,
                                            label: M.i,
                                            tabindex: l.value,
                                            ...a("day#" + M.i, {
                                                onClick: ()=>{
                                                    Ne(M.i);
                                                },
                                                onMouseover: ()=>{
                                                    pt(M.i);
                                                }
                                            })
                                        }, M.event !== !1 ? ()=>(0, $fVLUl.h)("div", {
                                                class: "q-date__event bg-" + M.event
                                            }) : null) : (0, $fVLUl.h)("div", "" + M.i)
                                    ]))))
                        ])
                    ])
                ],
            Months () {
                let M = g.value.year === h.value.year, O = (de)=>_e.value !== null && g.value.year === _e.value.year && _e.value.month > de || U.value !== null && g.value.year === U.value.year && U.value.month < de, X = p.value.monthsShort.map((de, fe)=>{
                    let et = g.value.month === fe + 1;
                    return (0, $fVLUl.h)("div", {
                        class: "q-date__months-item flex flex-center"
                    }, [
                        (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                            class: M === !0 && h.value.month === fe + 1 ? "q-date__today" : null,
                            flat: et !== !0,
                            label: de,
                            unelevated: et,
                            color: et === !0 ? x.value : null,
                            textColor: et === !0 ? k.value : null,
                            tabindex: l.value,
                            disable: O(fe + 1),
                            ...a("month#" + fe, {
                                onClick: ()=>{
                                    ke(fe + 1);
                                }
                            })
                        })
                    ]);
                });
                return e.yearsInMonthView === !0 && X.unshift((0, $fVLUl.h)("div", {
                    class: "row no-wrap full-width"
                }, [
                    qe({
                        label: g.value.year,
                        type: "Years",
                        key: g.value.year,
                        dir: L.value,
                        goTo: K,
                        boundaries: ae.value.year,
                        cls: " col"
                    })
                ])), (0, $fVLUl.h)("div", {
                    key: "months-view",
                    class: "q-date__view q-date__months flex flex-center"
                }, X);
            },
            Years () {
                let M = A.value, O = M + $848b1ce88e755b32$var$zr, X = [], de = (fe)=>_e.value !== null && _e.value.year > fe || U.value !== null && U.value.year < fe;
                for(let fe = M; fe <= O; fe++){
                    let et = g.value.year === fe;
                    X.push((0, $fVLUl.h)("div", {
                        class: "q-date__years-item flex flex-center"
                    }, [
                        (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                            key: "yr" + fe,
                            class: h.value.year === fe ? "q-date__today" : null,
                            flat: !et,
                            label: fe,
                            dense: !0,
                            unelevated: et,
                            color: et === !0 ? x.value : null,
                            textColor: et === !0 ? k.value : null,
                            tabindex: l.value,
                            disable: de(fe),
                            ...a("yr#" + fe, {
                                onClick: ()=>{
                                    ee(fe);
                                }
                            })
                        })
                    ]));
                }
                return (0, $fVLUl.h)("div", {
                    class: "q-date__view q-date__years flex flex-center"
                }, [
                    (0, $fVLUl.h)("div", {
                        class: "col-auto"
                    }, [
                        (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                            round: !0,
                            dense: !0,
                            flat: !0,
                            icon: T.value[0],
                            tabindex: l.value,
                            disable: de(M),
                            ...a("y-", {
                                onClick: ()=>{
                                    A.value -= $848b1ce88e755b32$var$zr;
                                }
                            })
                        })
                    ]),
                    (0, $fVLUl.h)("div", {
                        class: "q-date__years-content col self-stretch row items-center"
                    }, X),
                    (0, $fVLUl.h)("div", {
                        class: "col-auto"
                    }, [
                        (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                            round: !0,
                            dense: !0,
                            flat: !0,
                            icon: T.value[1],
                            tabindex: l.value,
                            disable: de(O),
                            ...a("y+", {
                                onClick: ()=>{
                                    A.value += $848b1ce88e755b32$var$zr;
                                }
                            })
                        })
                    ])
                ]);
            }
        };
        function Ne(M) {
            let O = {
                ...g.value,
                day: M
            };
            if (e.range === !1) {
                ze(O, le.value);
                return;
            }
            if (B.value === null) {
                let X = ne.value.find((fe)=>fe.fill !== !0 && fe.i === M);
                if (e.noUnset !== !0 && X.range !== void 0) {
                    en({
                        target: O,
                        from: X.range.from,
                        to: X.range.to
                    });
                    return;
                }
                if (X.selected === !0) {
                    en(O);
                    return;
                }
                let de = $848b1ce88e755b32$var$Qo(O);
                B.value = {
                    init: O,
                    initHash: de,
                    final: O,
                    finalHash: de
                }, o("rangeStart", ye(O));
            } else {
                let X = B.value.initHash, de = $848b1ce88e755b32$var$Qo(O), fe = X <= de ? {
                    from: B.value.init,
                    to: O
                } : {
                    from: O,
                    to: B.value.init
                };
                B.value = null, kn(X === de ? O : {
                    target: O,
                    ...fe
                }), o("rangeEnd", {
                    from: ye(fe.from),
                    to: ye(fe.to)
                });
            }
        }
        function pt(M) {
            if (B.value !== null) {
                let O = {
                    ...g.value,
                    day: M
                };
                Object.assign(B.value, {
                    final: O,
                    finalHash: $848b1ce88e755b32$var$Qo(O)
                });
            }
        }
        return Object.assign(r, {
            setToday: Y,
            setView: me,
            offsetCalendar: Pe,
            setCalendarTo: Ee,
            setEditingRange: Ae
        }), ()=>{
            let M = [
                (0, $fVLUl.h)("div", {
                    class: "q-date__content col relative-position"
                }, [
                    (0, $fVLUl.h)((0, $24349.Transition), {
                        name: "q-transition--fade"
                    }, Be[S.value])
                ])
            ], O = $848b1ce88e755b32$var$J(t.default);
            return O !== void 0 && M.push((0, $fVLUl.h)("div", {
                class: "q-date__actions"
            }, O)), e.name !== void 0 && e.disable !== !0 && d(M, "push"), (0, $fVLUl.h)("div", {
                class: q.value,
                ...se.value
            }, [
                ve(),
                (0, $fVLUl.h)("div", {
                    ref: m,
                    class: "q-date__main col column",
                    tabindex: -1
                }, M)
            ]);
        };
    }
});
function $848b1ce88e755b32$var$yu(e, t, o) {
    let r;
    function n() {
        r !== void 0 && ($848b1ce88e755b32$var$Un.remove(r), r = void 0);
    }
    return (0, $fVLUl.onBeforeUnmount)(()=>{
        e.value === !0 && n();
    }), {
        removeFromHistory: n,
        addToHistory () {
            r = {
                condition: ()=>o.value === !0,
                handler: t
            }, $848b1ce88e755b32$var$Un.add(r);
        }
    };
}
var $848b1ce88e755b32$var$Xa = 0, $848b1ce88e755b32$var$zc, $848b1ce88e755b32$var$Oc, $848b1ce88e755b32$var$Ga, $848b1ce88e755b32$var$Ic = !1, $848b1ce88e755b32$var$Um, $848b1ce88e755b32$var$Km, $848b1ce88e755b32$var$Wm, $848b1ce88e755b32$var$Or = null;
function $848b1ce88e755b32$var$Ex(e) {
    $848b1ce88e755b32$var$Bx(e) && $848b1ce88e755b32$var$Se(e);
}
function $848b1ce88e755b32$var$Bx(e) {
    if (e.target === document.body || e.target.classList.contains("q-layout__backdrop")) return !0;
    let t = $848b1ce88e755b32$var$Ks(e), o = e.shiftKey && !e.deltaX, r = !o && Math.abs(e.deltaX) <= Math.abs(e.deltaY), n = o || r ? e.deltaY : e.deltaX;
    for(let i = 0; i < t.length; i++){
        let a = t[i];
        if ($848b1ce88e755b32$var$vc(a, r)) return r ? n < 0 && a.scrollTop === 0 ? !0 : n > 0 && a.scrollTop + a.clientHeight === a.scrollHeight : n < 0 && a.scrollLeft === 0 ? !0 : n > 0 && a.scrollLeft + a.clientWidth === a.scrollWidth;
    }
    return !0;
}
function $848b1ce88e755b32$var$Ym(e) {
    e.target === document && (document.scrollingElement.scrollTop = document.scrollingElement.scrollTop);
}
function $848b1ce88e755b32$var$Su(e) {
    $848b1ce88e755b32$var$Ic !== !0 && ($848b1ce88e755b32$var$Ic = !0, requestAnimationFrame(()=>{
        $848b1ce88e755b32$var$Ic = !1;
        let { height: t } = e.target, { clientHeight: o, scrollTop: r } = document.scrollingElement;
        ($848b1ce88e755b32$var$Ga === void 0 || t !== window.innerHeight) && ($848b1ce88e755b32$var$Ga = o - t, document.scrollingElement.scrollTop = r), r > $848b1ce88e755b32$var$Ga && (document.scrollingElement.scrollTop -= Math.ceil((r - $848b1ce88e755b32$var$Ga) / 8));
    }));
}
function $848b1ce88e755b32$var$Xm(e) {
    let t = document.body, o = window.visualViewport !== void 0;
    if (e === "add") {
        let { overflowY: r, overflowX: n } = window.getComputedStyle(t);
        $848b1ce88e755b32$var$zc = $848b1ce88e755b32$var$er(window), $848b1ce88e755b32$var$Oc = $848b1ce88e755b32$var$fo(window), $848b1ce88e755b32$var$Um = t.style.left, $848b1ce88e755b32$var$Km = t.style.top, $848b1ce88e755b32$var$Wm = window.location.href, t.style.left = `-${$848b1ce88e755b32$var$zc}px`, t.style.top = `-${$848b1ce88e755b32$var$Oc}px`, n !== "hidden" && (n === "scroll" || t.scrollWidth > window.innerWidth) && t.classList.add("q-body--force-scrollbar-x"), r !== "hidden" && (r === "scroll" || t.scrollHeight > window.innerHeight) && t.classList.add("q-body--force-scrollbar-y"), t.classList.add("q-body--prevent-scroll"), document.qScrollPrevented = !0, $848b1ce88e755b32$var$Ce.is.ios === !0 && (o === !0 ? (window.scrollTo(0, 0), window.visualViewport.addEventListener("resize", $848b1ce88e755b32$var$Su, $848b1ce88e755b32$var$Xe.passiveCapture), window.visualViewport.addEventListener("scroll", $848b1ce88e755b32$var$Su, $848b1ce88e755b32$var$Xe.passiveCapture), window.scrollTo(0, 0)) : window.addEventListener("scroll", $848b1ce88e755b32$var$Ym, $848b1ce88e755b32$var$Xe.passiveCapture));
    }
    $848b1ce88e755b32$var$Ce.is.desktop === !0 && $848b1ce88e755b32$var$Ce.is.mac === !0 && window[`${e}EventListener`]("wheel", $848b1ce88e755b32$var$Ex, $848b1ce88e755b32$var$Xe.notPassive), e === "remove" && ($848b1ce88e755b32$var$Ce.is.ios === !0 && (o === !0 ? (window.visualViewport.removeEventListener("resize", $848b1ce88e755b32$var$Su, $848b1ce88e755b32$var$Xe.passiveCapture), window.visualViewport.removeEventListener("scroll", $848b1ce88e755b32$var$Su, $848b1ce88e755b32$var$Xe.passiveCapture)) : window.removeEventListener("scroll", $848b1ce88e755b32$var$Ym, $848b1ce88e755b32$var$Xe.passiveCapture)), t.classList.remove("q-body--prevent-scroll"), t.classList.remove("q-body--force-scrollbar-x"), t.classList.remove("q-body--force-scrollbar-y"), document.qScrollPrevented = !1, t.style.left = $848b1ce88e755b32$var$Um, t.style.top = $848b1ce88e755b32$var$Km, window.location.href === $848b1ce88e755b32$var$Wm && window.scrollTo($848b1ce88e755b32$var$zc, $848b1ce88e755b32$var$Oc), $848b1ce88e755b32$var$Ga = void 0);
}
function $848b1ce88e755b32$var$Za(e) {
    let t = "add";
    if (e === !0) {
        if ($848b1ce88e755b32$var$Xa++, $848b1ce88e755b32$var$Or !== null) {
            clearTimeout($848b1ce88e755b32$var$Or), $848b1ce88e755b32$var$Or = null;
            return;
        }
        if ($848b1ce88e755b32$var$Xa > 1) return;
    } else {
        if ($848b1ce88e755b32$var$Xa === 0 || ($848b1ce88e755b32$var$Xa--, $848b1ce88e755b32$var$Xa > 0)) return;
        if (t = "remove", $848b1ce88e755b32$var$Ce.is.ios === !0 && $848b1ce88e755b32$var$Ce.is.nativeMobile === !0) {
            $848b1ce88e755b32$var$Or !== null && clearTimeout($848b1ce88e755b32$var$Or), $848b1ce88e755b32$var$Or = setTimeout(()=>{
                $848b1ce88e755b32$var$Xm(t), $848b1ce88e755b32$var$Or = null;
            }, 100);
            return;
        }
    }
    $848b1ce88e755b32$var$Xm(t);
}
function $848b1ce88e755b32$var$xu() {
    let e;
    return {
        preventBodyScroll (t) {
            t !== e && (e !== void 0 || t === !0) && (e = t, $848b1ce88e755b32$var$Za(t));
        }
    };
}
var $848b1ce88e755b32$var$_u = 0, $848b1ce88e755b32$var$Dx = {
    standard: "fixed-full flex-center",
    top: "fixed-top justify-center",
    bottom: "fixed-bottom justify-center",
    right: "fixed-right items-center",
    left: "fixed-left items-center"
}, $848b1ce88e755b32$var$Jm = {
    standard: [
        "scale",
        "scale"
    ],
    top: [
        "slide-down",
        "slide-up"
    ],
    bottom: [
        "slide-up",
        "slide-down"
    ],
    right: [
        "slide-left",
        "slide-right"
    ],
    left: [
        "slide-right",
        "slide-left"
    ]
}, $848b1ce88e755b32$export$e6ccdac5fb3e2417 = $848b1ce88e755b32$var$R({
    name: "QDialog",
    inheritAttrs: !1,
    props: {
        ...$848b1ce88e755b32$var$Ao,
        ...$848b1ce88e755b32$var$ln,
        transitionShow: String,
        transitionHide: String,
        persistent: Boolean,
        autoClose: Boolean,
        allowFocusOutside: Boolean,
        noEscDismiss: Boolean,
        noBackdropDismiss: Boolean,
        noRouteDismiss: Boolean,
        noRefocus: Boolean,
        noFocus: Boolean,
        noShake: Boolean,
        seamless: Boolean,
        maximized: Boolean,
        fullWidth: Boolean,
        fullHeight: Boolean,
        square: Boolean,
        backdropFilter: String,
        position: {
            type: String,
            default: "standard",
            validator: (e)=>e === "standard" || [
                    "top",
                    "bottom",
                    "left",
                    "right"
                ].includes(e)
        }
    },
    emits: [
        ...$848b1ce88e755b32$var$$o,
        "shake",
        "click",
        "escapeKey"
    ],
    setup (e, { slots: t, emit: o, attrs: r }) {
        let n = (0, $fVLUl.getCurrentInstance)(), i = (0, $eayOh.ref)(null), a = (0, $eayOh.ref)(!1), l = (0, $eayOh.ref)(!1), s = null, c = null, u, v, f = (0, $eayOh.computed)(()=>e.persistent !== !0 && e.noRouteDismiss !== !0 && e.seamless !== !0), { preventBodyScroll: d } = $848b1ce88e755b32$var$xu(), { registerTimeout: m } = $848b1ce88e755b32$export$d8e6abf214c9ec0f(), { registerTick: y, removeTick: p } = $848b1ce88e755b32$export$98bfbd4c9d834fed(), { transitionProps: C, transitionStyle: b } = $848b1ce88e755b32$var$Jn(e, ()=>$848b1ce88e755b32$var$Jm[e.position][0], ()=>$848b1ce88e755b32$var$Jm[e.position][1]), h = (0, $eayOh.computed)(()=>b.value + (e.backdropFilter !== void 0 ? `;backdrop-filter:${e.backdropFilter};-webkit-backdrop-filter:${e.backdropFilter}` : "")), { showPortal: g, hidePortal: S, portalIsAccessible: P, renderPortal: $ } = $848b1ce88e755b32$var$Si(n, i, oe, "dialog"), { hide: L } = $848b1ce88e755b32$var$Eo({
            showing: a,
            hideOnRouteChange: f,
            handleShow: j,
            handleHide: Q,
            processOnMount: !0
        }), { addToHistory: E, removeFromHistory: A } = $848b1ce88e755b32$var$yu(a, L, f), B = (0, $eayOh.computed)(()=>`q-dialog__inner flex no-pointer-events q-dialog__inner--${e.maximized === !0 ? "maximized" : "minimized"} q-dialog__inner--${e.position} ${$848b1ce88e755b32$var$Dx[e.position]}` + (l.value === !0 ? " q-dialog__inner--animating" : "") + (e.fullWidth === !0 ? " q-dialog__inner--fullwidth" : "") + (e.fullHeight === !0 ? " q-dialog__inner--fullheight" : "") + (e.square === !0 ? " q-dialog__inner--square" : "")), q = (0, $eayOh.computed)(()=>a.value === !0 && e.seamless !== !0), x = (0, $eayOh.computed)(()=>e.autoClose === !0 ? {
                onClick: _
            } : {}), k = (0, $eayOh.computed)(()=>[
                `q-dialog fullscreen no-pointer-events q-dialog--${q.value === !0 ? "modal" : "seamless"}`,
                r.class
            ]);
        (0, $eayOh.watch)(()=>e.maximized, (T)=>{
            a.value === !0 && V(T);
        }), (0, $eayOh.watch)(q, (T)=>{
            d(T), T === !0 ? ($848b1ce88e755b32$var$wi(I), $848b1ce88e755b32$var$Ol(W)) : ($848b1ce88e755b32$var$Er(I), $848b1ce88e755b32$var$Ci(W));
        });
        function j(T) {
            E(), c = e.noRefocus === !1 && document.activeElement !== null ? document.activeElement : null, V(e.maximized), g(), l.value = !0, e.noFocus !== !0 ? (document.activeElement !== null && document.activeElement.blur(), y(w)) : p(), m(()=>{
                if (n.proxy.$q.platform.is.ios === !0) {
                    if (e.seamless !== !0 && document.activeElement) {
                        let { top: D, bottom: te } = document.activeElement.getBoundingClientRect(), { innerHeight: z } = window, ue = window.visualViewport !== void 0 ? window.visualViewport.height : z;
                        D > 0 && te > ue / 2 && (document.scrollingElement.scrollTop = Math.min(document.scrollingElement.scrollHeight - ue, te >= z ? 1 / 0 : Math.ceil(document.scrollingElement.scrollTop + te - ue / 2))), document.activeElement.scrollIntoView();
                    }
                    v = !0, i.value.click(), v = !1;
                }
                g(!0), l.value = !1, o("show", T);
            }, e.transitionDuration);
        }
        function Q(T) {
            p(), A(), ie(!0), l.value = !0, S(), c !== null && (((T && T.type.indexOf("key") === 0 ? c.closest('[tabindex]:not([tabindex^="-"])') : void 0) || c).focus(), c = null), m(()=>{
                S(!0), l.value = !1, o("hide", T);
            }, e.transitionDuration);
        }
        function w(T) {
            $848b1ce88e755b32$var$Bo(()=>{
                let D = i.value;
                if (D !== null) {
                    if (T !== void 0) {
                        let te = D.querySelector(T);
                        if (te !== null) {
                            te.focus({
                                preventScroll: !0
                            });
                            return;
                        }
                    }
                    D.contains(document.activeElement) !== !0 && (D = D.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || D.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || D.querySelector("[autofocus], [data-autofocus]") || D, D.focus({
                        preventScroll: !0
                    }));
                }
            });
        }
        function H(T) {
            T && typeof T.focus == "function" ? T.focus({
                preventScroll: !0
            }) : w(), o("shake");
            let D = i.value;
            D !== null && (D.classList.remove("q-animate--scale"), D.classList.add("q-animate--scale"), s !== null && clearTimeout(s), s = setTimeout(()=>{
                s = null, i.value !== null && (D.classList.remove("q-animate--scale"), w());
            }, 170));
        }
        function W() {
            e.seamless !== !0 && (e.persistent === !0 || e.noEscDismiss === !0 ? e.maximized !== !0 && e.noShake !== !0 && H() : (o("escapeKey"), L()));
        }
        function ie(T) {
            s !== null && (clearTimeout(s), s = null), (T === !0 || a.value === !0) && (V(!1), e.seamless !== !0 && (d(!1), $848b1ce88e755b32$var$Er(I), $848b1ce88e755b32$var$Ci(W))), T !== !0 && (c = null);
        }
        function V(T) {
            T === !0 ? u !== !0 && ($848b1ce88e755b32$var$_u < 1 && document.body.classList.add("q-body--dialog"), $848b1ce88e755b32$var$_u++, u = !0) : u === !0 && ($848b1ce88e755b32$var$_u < 2 && document.body.classList.remove("q-body--dialog"), $848b1ce88e755b32$var$_u--, u = !1);
        }
        function _(T) {
            v !== !0 && (L(T), o("click", T));
        }
        function N(T) {
            e.persistent !== !0 && e.noBackdropDismiss !== !0 ? L(T) : e.noShake !== !0 && H();
        }
        function I(T) {
            e.allowFocusOutside !== !0 && P.value === !0 && $848b1ce88e755b32$var$Ll(i.value, T.target) !== !0 && w('[tabindex]:not([tabindex="-1"])');
        }
        Object.assign(n.proxy, {
            focus: w,
            shake: H,
            __updateRefocusTarget (T) {
                c = T || null;
            }
        }), (0, $fVLUl.onBeforeUnmount)(ie);
        function oe() {
            return (0, $fVLUl.h)("div", {
                role: "dialog",
                "aria-modal": q.value === !0 ? "true" : "false",
                ...r,
                class: k.value
            }, [
                (0, $fVLUl.h)((0, $24349.Transition), {
                    name: "q-transition--fade",
                    appear: !0
                }, ()=>q.value === !0 ? (0, $fVLUl.h)("div", {
                        class: "q-dialog__backdrop fixed-full",
                        style: h.value,
                        "aria-hidden": "true",
                        tabindex: -1,
                        onClick: N
                    }) : null),
                (0, $fVLUl.h)((0, $24349.Transition), C.value, ()=>a.value === !0 ? (0, $fVLUl.h)("div", {
                        ref: i,
                        class: B.value,
                        style: b.value,
                        tabindex: -1,
                        ...x.value
                    }, $848b1ce88e755b32$var$J(t.default)) : null)
            ]);
        }
        return $;
    }
});
var $848b1ce88e755b32$var$tv = 150, $848b1ce88e755b32$export$8bd189b8cd6124c2 = $848b1ce88e755b32$var$R({
    name: "QDrawer",
    inheritAttrs: !1,
    props: {
        ...$848b1ce88e755b32$var$Ao,
        ...$848b1ce88e755b32$var$he,
        side: {
            type: String,
            default: "left",
            validator: (e)=>[
                    "left",
                    "right"
                ].includes(e)
        },
        width: {
            type: Number,
            default: 300
        },
        mini: Boolean,
        miniToOverlay: Boolean,
        miniWidth: {
            type: Number,
            default: 57
        },
        noMiniAnimation: Boolean,
        breakpoint: {
            type: Number,
            default: 1023
        },
        showIfAbove: Boolean,
        behavior: {
            type: String,
            validator: (e)=>[
                    "default",
                    "desktop",
                    "mobile"
                ].includes(e),
            default: "default"
        },
        bordered: Boolean,
        elevated: Boolean,
        overlay: Boolean,
        persistent: Boolean,
        noSwipeOpen: Boolean,
        noSwipeClose: Boolean,
        noSwipeBackdrop: Boolean
    },
    emits: [
        ...$848b1ce88e755b32$var$$o,
        "onLayout",
        "miniState"
    ],
    setup (e, { slots: t, emit: o, attrs: r }) {
        let n = (0, $fVLUl.getCurrentInstance)(), { proxy: { $q: i } } = n, a = $848b1ce88e755b32$var$pe(e, i), { preventBodyScroll: l } = $848b1ce88e755b32$var$xu(), { registerTimeout: s, removeTimeout: c } = $848b1ce88e755b32$export$d8e6abf214c9ec0f(), u = (0, $fVLUl.inject)($848b1ce88e755b32$var$co, $848b1ce88e755b32$var$Ye);
        if (u === $848b1ce88e755b32$var$Ye) return console.error("QDrawer needs to be child of QLayout"), $848b1ce88e755b32$var$Ye;
        let v, f = null, d, m = (0, $eayOh.ref)(e.behavior === "mobile" || e.behavior !== "desktop" && u.totalWidth.value <= e.breakpoint), y = (0, $eayOh.computed)(()=>e.mini === !0 && m.value !== !0), p = (0, $eayOh.computed)(()=>y.value === !0 ? e.miniWidth : e.width), C = (0, $eayOh.ref)(e.showIfAbove === !0 && m.value === !1 ? !0 : e.modelValue === !0), b = (0, $eayOh.computed)(()=>e.persistent !== !0 && (m.value === !0 || ie.value === !0));
        function h(Y, me) {
            if ($(), Y !== !1 && u.animate(), ae(0), m.value === !0) {
                let Pe = u.instances[Q.value];
                Pe !== void 0 && Pe.belowBreakpoint === !0 && Pe.hide(!1), ce(1), u.isContainer.value !== !0 && l(!0);
            } else ce(0), Y !== !1 && be(!1);
            s(()=>{
                Y !== !1 && be(!0), me !== !0 && o("show", Y);
            }, $848b1ce88e755b32$var$tv);
        }
        function g(Y, me) {
            L(), Y !== !1 && u.animate(), ce(0), ae(B.value * p.value), Fe(), me !== !0 ? s(()=>{
                o("hide", Y);
            }, $848b1ce88e755b32$var$tv) : c();
        }
        let { show: S, hide: P } = $848b1ce88e755b32$var$Eo({
            showing: C,
            hideOnRouteChange: b,
            handleShow: h,
            handleHide: g
        }), { addToHistory: $, removeFromHistory: L } = $848b1ce88e755b32$var$yu(C, P, b), E = {
            belowBreakpoint: m,
            hide: P
        }, A = (0, $eayOh.computed)(()=>e.side === "right"), B = (0, $eayOh.computed)(()=>(i.lang.rtl === !0 ? -1 : 1) * (A.value === !0 ? 1 : -1)), q = (0, $eayOh.ref)(0), x = (0, $eayOh.ref)(!1), k = (0, $eayOh.ref)(!1), j = (0, $eayOh.ref)(p.value * B.value), Q = (0, $eayOh.computed)(()=>A.value === !0 ? "left" : "right"), w = (0, $eayOh.computed)(()=>C.value === !0 && m.value === !1 && e.overlay === !1 ? e.miniToOverlay === !0 ? e.miniWidth : p.value : 0), H = (0, $eayOh.computed)(()=>e.overlay === !0 || e.miniToOverlay === !0 || u.view.value.indexOf(A.value ? "R" : "L") !== -1 || i.platform.is.ios === !0 && u.isContainer.value === !0), W = (0, $eayOh.computed)(()=>e.overlay === !1 && C.value === !0 && m.value === !1), ie = (0, $eayOh.computed)(()=>e.overlay === !0 && C.value === !0 && m.value === !1), V = (0, $eayOh.computed)(()=>"fullscreen q-drawer__backdrop" + (C.value === !1 && x.value === !1 ? " hidden" : "")), _ = (0, $eayOh.computed)(()=>({
                backgroundColor: `rgba(0,0,0,${q.value * .4})`
            })), N = (0, $eayOh.computed)(()=>A.value === !0 ? u.rows.value.top[2] === "r" : u.rows.value.top[0] === "l"), I = (0, $eayOh.computed)(()=>A.value === !0 ? u.rows.value.bottom[2] === "r" : u.rows.value.bottom[0] === "l"), oe = (0, $eayOh.computed)(()=>{
            let Y = {};
            return u.header.space === !0 && N.value === !1 && (H.value === !0 ? Y.top = `${u.header.offset}px` : u.header.space === !0 && (Y.top = `${u.header.size}px`)), u.footer.space === !0 && I.value === !1 && (H.value === !0 ? Y.bottom = `${u.footer.offset}px` : u.footer.space === !0 && (Y.bottom = `${u.footer.size}px`)), Y;
        }), T = (0, $eayOh.computed)(()=>{
            let Y = {
                width: `${p.value}px`,
                transform: `translateX(${j.value}px)`
            };
            return m.value === !0 ? Y : Object.assign(Y, oe.value);
        }), D = (0, $eayOh.computed)(()=>"q-drawer__content fit " + (u.isContainer.value !== !0 ? "scroll" : "overflow-auto")), te = (0, $eayOh.computed)(()=>`q-drawer q-drawer--${e.side}` + (k.value === !0 ? " q-drawer--mini-animate" : "") + (e.bordered === !0 ? " q-drawer--bordered" : "") + (a.value === !0 ? " q-drawer--dark q-dark" : "") + (x.value === !0 ? " no-transition" : C.value === !0 ? "" : " q-layout--prevent-focus") + (m.value === !0 ? " fixed q-drawer--on-top q-drawer--mobile q-drawer--top-padding" : ` q-drawer--${y.value === !0 ? "mini" : "standard"}` + (H.value === !0 || W.value !== !0 ? " fixed" : "") + (e.overlay === !0 || e.miniToOverlay === !0 ? " q-drawer--on-top" : "") + (N.value === !0 ? " q-drawer--top-padding" : ""))), z = (0, $eayOh.computed)(()=>{
            let Y = i.lang.rtl === !0 ? e.side : Q.value;
            return [
                [
                    $848b1ce88e755b32$export$718797250d1e376,
                    le,
                    void 0,
                    {
                        [Y]: !0,
                        mouse: !0
                    }
                ]
            ];
        }), ue = (0, $eayOh.computed)(()=>{
            let Y = i.lang.rtl === !0 ? Q.value : e.side;
            return [
                [
                    $848b1ce88e755b32$export$718797250d1e376,
                    Re,
                    void 0,
                    {
                        [Y]: !0,
                        mouse: !0
                    }
                ]
            ];
        }), _e = (0, $eayOh.computed)(()=>{
            let Y = i.lang.rtl === !0 ? Q.value : e.side;
            return [
                [
                    $848b1ce88e755b32$export$718797250d1e376,
                    Re,
                    void 0,
                    {
                        [Y]: !0,
                        mouse: !0,
                        mouseAllDir: !0
                    }
                ]
            ];
        });
        function U() {
            ne(m, e.behavior === "mobile" || e.behavior !== "desktop" && u.totalWidth.value <= e.breakpoint);
        }
        (0, $eayOh.watch)(m, (Y)=>{
            Y === !0 ? (v = C.value, C.value === !0 && P(!1)) : e.overlay === !1 && e.behavior !== "mobile" && v !== !1 && (C.value === !0 ? (ae(0), ce(0), Fe()) : S(!1));
        }), (0, $eayOh.watch)(()=>e.side, (Y, me)=>{
            u.instances[me] === E && (u.instances[me] = void 0, u[me].space = !1, u[me].offset = 0), u.instances[Y] = E, u[Y].size = p.value, u[Y].space = W.value, u[Y].offset = w.value;
        }), (0, $eayOh.watch)(u.totalWidth, ()=>{
            (u.isContainer.value === !0 || document.qScrollPrevented !== !0) && U();
        }), (0, $eayOh.watch)(()=>e.behavior + e.breakpoint, U), (0, $eayOh.watch)(u.isContainer, (Y)=>{
            C.value === !0 && l(Y !== !0), Y === !0 && U();
        }), (0, $eayOh.watch)(u.scrollbarWidth, ()=>{
            ae(C.value === !0 ? 0 : void 0);
        }), (0, $eayOh.watch)(w, (Y)=>{
            De("offset", Y);
        }), (0, $eayOh.watch)(W, (Y)=>{
            o("onLayout", Y), De("space", Y);
        }), (0, $eayOh.watch)(A, ()=>{
            ae();
        }), (0, $eayOh.watch)(p, (Y)=>{
            ae(), se(e.miniToOverlay, Y);
        }), (0, $eayOh.watch)(()=>e.miniToOverlay, (Y)=>{
            se(Y, p.value);
        }), (0, $eayOh.watch)(()=>i.lang.rtl, ()=>{
            ae();
        }), (0, $eayOh.watch)(()=>e.mini, ()=>{
            e.noMiniAnimation || e.modelValue === !0 && (Me(), u.animate());
        }), (0, $eayOh.watch)(y, (Y)=>{
            o("miniState", Y);
        });
        function ae(Y) {
            Y === void 0 ? (0, $fVLUl.nextTick)(()=>{
                Y = C.value === !0 ? 0 : p.value, ae(B.value * Y);
            }) : (u.isContainer.value === !0 && A.value === !0 && (m.value === !0 || Math.abs(Y) === p.value) && (Y += B.value * u.scrollbarWidth.value), j.value = Y);
        }
        function ce(Y) {
            q.value = Y;
        }
        function be(Y) {
            let me = Y === !0 ? "remove" : u.isContainer.value !== !0 ? "add" : "";
            me !== "" && document.body.classList[me]("q-body--drawer-toggle");
        }
        function Me() {
            f !== null && clearTimeout(f), n.proxy && n.proxy.$el && n.proxy.$el.classList.add("q-drawer--mini-animate"), k.value = !0, f = setTimeout(()=>{
                f = null, k.value = !1, n && n.proxy && n.proxy.$el && n.proxy.$el.classList.remove("q-drawer--mini-animate");
            }, 150);
        }
        function le(Y) {
            if (C.value !== !1) return;
            let me = p.value, Pe = $848b1ce88e755b32$var$Ze(Y.distance.x, 0, me);
            if (Y.isFinal === !0) {
                Pe >= Math.min(75, me) === !0 ? S() : (u.animate(), ce(0), ae(B.value * me)), x.value = !1;
                return;
            }
            ae((i.lang.rtl === !0 ? A.value !== !0 : A.value) ? Math.max(me - Pe, 0) : Math.min(0, Pe - me)), ce($848b1ce88e755b32$var$Ze(Pe / me, 0, 1)), Y.isFirst === !0 && (x.value = !0);
        }
        function Re(Y) {
            if (C.value !== !0) return;
            let me = p.value, Pe = Y.direction === e.side, Ee = (i.lang.rtl === !0 ? Pe !== !0 : Pe) ? $848b1ce88e755b32$var$Ze(Y.distance.x, 0, me) : 0;
            if (Y.isFinal === !0) {
                Math.abs(Ee) < Math.min(75, me) === !0 ? (u.animate(), ce(1), ae(0)) : P(), x.value = !1;
                return;
            }
            ae(B.value * Ee), ce($848b1ce88e755b32$var$Ze(1 - Ee / me, 0, 1)), Y.isFirst === !0 && (x.value = !0);
        }
        function Fe() {
            l(!1), be(!0);
        }
        function De(Y, me) {
            u.update(e.side, Y, me);
        }
        function ne(Y, me) {
            Y.value !== me && (Y.value = me);
        }
        function se(Y, me) {
            De("size", Y === !0 ? e.miniWidth : me);
        }
        return u.instances[e.side] = E, se(e.miniToOverlay, p.value), De("space", W.value), De("offset", w.value), e.showIfAbove === !0 && e.modelValue !== !0 && C.value === !0 && e["onUpdate:modelValue"] !== void 0 && o("update:modelValue", !0), (0, $fVLUl.onMounted)(()=>{
            o("onLayout", W.value), o("miniState", y.value), v = e.showIfAbove === !0;
            let Y = ()=>{
                (C.value === !0 ? h : g)(!1, !0);
            };
            if (u.totalWidth.value !== 0) {
                (0, $fVLUl.nextTick)(Y);
                return;
            }
            d = (0, $eayOh.watch)(u.totalWidth, ()=>{
                d(), d = void 0, C.value === !1 && e.showIfAbove === !0 && m.value === !1 ? S(!1) : Y();
            });
        }), (0, $fVLUl.onBeforeUnmount)(()=>{
            d !== void 0 && d(), f !== null && (clearTimeout(f), f = null), C.value === !0 && Fe(), u.instances[e.side] === E && (u.instances[e.side] = void 0, De("size", 0), De("offset", 0), De("space", !1));
        }), ()=>{
            let Y = [];
            m.value === !0 && (e.noSwipeOpen === !1 && Y.push((0, $fVLUl.withDirectives)((0, $fVLUl.h)("div", {
                key: "open",
                class: `q-drawer__opener fixed-${e.side}`,
                "aria-hidden": "true"
            }), z.value)), Y.push($848b1ce88e755b32$var$kt("div", {
                ref: "backdrop",
                class: V.value,
                style: _.value,
                "aria-hidden": "true",
                onClick: P
            }, void 0, "backdrop", e.noSwipeBackdrop !== !0 && C.value === !0, ()=>_e.value)));
            let me = y.value === !0 && t.mini !== void 0, Pe = [
                (0, $fVLUl.h)("div", {
                    ...r,
                    key: "" + me,
                    class: [
                        D.value,
                        r.class
                    ]
                }, me === !0 ? t.mini() : $848b1ce88e755b32$var$J(t.default))
            ];
            return e.elevated === !0 && C.value === !0 && Pe.push((0, $fVLUl.h)("div", {
                class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
            })), Y.push($848b1ce88e755b32$var$kt("aside", {
                ref: "content",
                class: te.value,
                style: T.value
            }, Pe, "contentclose", e.noSwipeClose !== !0 && m.value === !0, ()=>ue.value)), (0, $fVLUl.h)("div", {
                class: "q-drawer-container"
            }, Y);
        };
    }
});
function $848b1ce88e755b32$var$nv(e, t) {
    if (t && e === t) return null;
    let o = e.nodeName.toLowerCase();
    if ([
        "div",
        "li",
        "ul",
        "ol",
        "blockquote"
    ].includes(o) === !0) return e;
    let r = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle, n = r.display;
    return n === "block" || n === "table" ? e : $848b1ce88e755b32$var$nv(e.parentNode);
}
function $848b1ce88e755b32$var$Nc(e, t, o) {
    return !e || e === document.body ? !1 : o === !0 && e === t || (t === document ? document.body : t).contains(e.parentNode);
}
function $848b1ce88e755b32$var$rv(e, t, o) {
    if (o || (o = document.createRange(), o.selectNode(e), o.setStart(e, 0)), t.count === 0) o.setEnd(e, t.count);
    else if (t.count > 0) {
        if (e.nodeType === Node.TEXT_NODE) e.textContent.length < t.count ? t.count -= e.textContent.length : (o.setEnd(e, t.count), t.count = 0);
        else for(let r = 0; t.count !== 0 && r < e.childNodes.length; r++)o = $848b1ce88e755b32$var$rv(e.childNodes[r], t, o);
    }
    return o;
}
var $848b1ce88e755b32$var$Nx = /^https?:\/\//, $848b1ce88e755b32$var$el = class {
    constructor(t, o){
        this.el = t, this.eVm = o, this._range = null;
    }
    get selection() {
        if (this.el) {
            let t = document.getSelection();
            if ($848b1ce88e755b32$var$Nc(t.anchorNode, this.el, !0) && $848b1ce88e755b32$var$Nc(t.focusNode, this.el, !0)) return t;
        }
        return null;
    }
    get hasSelection() {
        return this.selection !== null ? this.selection.toString().length !== 0 : !1;
    }
    get range() {
        let t = this.selection;
        return t !== null && t.rangeCount ? t.getRangeAt(0) : this._range;
    }
    get parent() {
        let t = this.range;
        if (t !== null) {
            let o = t.startContainer;
            return o.nodeType === document.ELEMENT_NODE ? o : o.parentNode;
        }
        return null;
    }
    get blockParent() {
        let t = this.parent;
        return t !== null ? $848b1ce88e755b32$var$nv(t, this.el) : null;
    }
    save(t = this.range) {
        t !== null && (this._range = t);
    }
    restore(t = this._range) {
        let o = document.createRange(), r = document.getSelection();
        t !== null ? (o.setStart(t.startContainer, t.startOffset), o.setEnd(t.endContainer, t.endOffset), r.removeAllRanges(), r.addRange(o)) : (r.selectAllChildren(this.el), r.collapseToEnd());
    }
    savePosition() {
        let t = -1, o, r = document.getSelection(), n = this.el.parentNode;
        if (r.focusNode && $848b1ce88e755b32$var$Nc(r.focusNode, n)) for(o = r.focusNode, t = r.focusOffset; o && o !== n;)o !== this.el && o.previousSibling ? (o = o.previousSibling, t += o.textContent.length) : o = o.parentNode;
        this.savedPos = t;
    }
    restorePosition(t = 0) {
        if (this.savedPos > 0 && this.savedPos < t) {
            let o = window.getSelection(), r = $848b1ce88e755b32$var$rv(this.el, {
                count: this.savedPos
            });
            r && (r.collapse(!1), o.removeAllRanges(), o.addRange(r));
        }
    }
    hasParent(t, o) {
        let r = o ? this.parent : this.blockParent;
        return r !== null ? r.nodeName.toLowerCase() === t.toLowerCase() : !1;
    }
    hasParents(t, o, r = this.parent) {
        return r === null ? !1 : t.includes(r.nodeName.toLowerCase()) === !0 ? !0 : o === !0 ? this.hasParents(t, o, r.parentNode) : !1;
    }
    is(t, o) {
        if (this.selection === null) return !1;
        switch(t){
            case "formatBlock":
                return o === "DIV" && this.parent === this.el || this.hasParent(o, o === "PRE");
            case "link":
                return this.hasParent("A", !0);
            case "fontSize":
                return document.queryCommandValue(t) === o;
            case "fontName":
                let r = document.queryCommandValue(t);
                return r === `"${o}"` || r === o;
            case "fullscreen":
                return this.eVm.inFullscreen.value;
            case "viewsource":
                return this.eVm.isViewingSource.value;
            case void 0:
                return !1;
            default:
                let n = document.queryCommandState(t);
                return o !== void 0 ? n === o : n;
        }
    }
    getParentAttribute(t) {
        return this.parent !== null ? this.parent.getAttribute(t) : null;
    }
    can(t) {
        if (t === "outdent") return this.hasParents([
            "blockquote",
            "li"
        ], !0);
        if (t === "indent") return this.hasParents([
            "li"
        ], !0);
        if (t === "link") return this.selection !== null || this.is("link");
    }
    apply(t, o, r = $848b1ce88e755b32$export$8793edee2d425525) {
        if (t === "formatBlock") [
            "BLOCKQUOTE",
            "H1",
            "H2",
            "H3",
            "H4",
            "H5",
            "H6"
        ].includes(o) && this.is(t, o) && (t = "outdent", o = null), o === "PRE" && this.is(t, "PRE") && (o = "P");
        else if (t === "print") {
            r();
            let n = window.open();
            n.document.write(`
        <!doctype html>
        <html>
          <head>
            <title>Print - ${document.title}</title>
          </head>
          <body>
            <div>${this.el.innerHTML}</div>
          </body>
        </html>
      `), n.print(), n.close();
            return;
        } else if (t === "link") {
            let n = this.getParentAttribute("href");
            if (n === null) {
                let i = this.selectWord(this.selection), a = i ? i.toString() : "";
                if (!a.length && (!this.range || !this.range.cloneContents().querySelector("img"))) return;
                this.eVm.editLinkUrl.value = $848b1ce88e755b32$var$Nx.test(a) ? a : "https://", document.execCommand("createLink", !1, this.eVm.editLinkUrl.value), this.save(i.getRangeAt(0));
            } else this.eVm.editLinkUrl.value = n, this.range.selectNodeContents(this.parent), this.save();
            return;
        } else if (t === "fullscreen") {
            this.eVm.toggleFullscreen(), r();
            return;
        } else if (t === "viewsource") {
            this.eVm.isViewingSource.value = this.eVm.isViewingSource.value === !1, this.eVm.setContent(this.eVm.props.modelValue), r();
            return;
        }
        document.execCommand(t, !1, o), r();
    }
    selectWord(t) {
        if (t === null || t.isCollapsed !== !0 || t.modify === void 0) return t;
        let o = document.createRange();
        o.setStart(t.anchorNode, t.anchorOffset), o.setEnd(t.focusNode, t.focusOffset);
        let r = o.collapsed ? [
            "backward",
            "forward"
        ] : [
            "forward",
            "backward"
        ];
        o.detach();
        let n = t.focusNode, i = t.focusOffset;
        return t.collapse(t.anchorNode, t.anchorOffset), t.modify("move", r[0], "character"), t.modify("move", r[1], "word"), t.extend(n, i), t.modify("extend", r[1], "character"), t.modify("extend", r[0], "word"), t;
    }
};
var $848b1ce88e755b32$export$b4dba0bbe7f6a787 = $848b1ce88e755b32$var$R({
    name: "QTooltip",
    inheritAttrs: !1,
    props: {
        ...$848b1ce88e755b32$var$hi,
        ...$848b1ce88e755b32$var$Ao,
        ...$848b1ce88e755b32$var$ln,
        maxHeight: {
            type: String,
            default: null
        },
        maxWidth: {
            type: String,
            default: null
        },
        transitionShow: {
            default: "jump-down"
        },
        transitionHide: {
            default: "jump-up"
        },
        anchor: {
            type: String,
            default: "bottom middle",
            validator: $848b1ce88e755b32$var$Ti
        },
        self: {
            type: String,
            default: "top middle",
            validator: $848b1ce88e755b32$var$Ti
        },
        offset: {
            type: Array,
            default: ()=>[
                    14,
                    14
                ],
            validator: $848b1ce88e755b32$var$Ql
        },
        scrollTarget: {
            default: void 0
        },
        delay: {
            type: Number,
            default: 0
        },
        hideDelay: {
            type: Number,
            default: 0
        },
        persistent: Boolean
    },
    emits: [
        ...$848b1ce88e755b32$var$$o
    ],
    setup (e, { slots: t, emit: o, attrs: r }) {
        let n, i, a = (0, $fVLUl.getCurrentInstance)(), { proxy: { $q: l } } = a, s = (0, $eayOh.ref)(null), c = (0, $eayOh.ref)(!1), u = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$Mi(e.anchor, l.lang.rtl)), v = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$Mi(e.self, l.lang.rtl)), f = (0, $eayOh.computed)(()=>e.persistent !== !0), { registerTick: d, removeTick: m } = $848b1ce88e755b32$export$98bfbd4c9d834fed(), { registerTimeout: y } = $848b1ce88e755b32$export$d8e6abf214c9ec0f(), { transitionProps: p, transitionStyle: C } = $848b1ce88e755b32$var$Jn(e), { localScrollTarget: b, changeScrollEvent: h, unconfigureScrollTarget: g } = $848b1ce88e755b32$var$Vl(e, ie), { anchorEl: S, canShow: P, anchorEvents: $ } = $848b1ce88e755b32$var$pi({
            showing: c,
            configureAnchorEl: W
        }), { show: L, hide: E } = $848b1ce88e755b32$var$Eo({
            showing: c,
            canShow: P,
            handleShow: x,
            handleHide: k,
            hideOnRouteChange: f,
            processOnMount: !0
        });
        Object.assign($, {
            delayShow: w,
            delayHide: H
        });
        let { showPortal: A, hidePortal: B, renderPortal: q } = $848b1ce88e755b32$var$Si(a, s, _, "tooltip");
        if (l.platform.is.mobile === !0) {
            let N = {
                anchorEl: S,
                innerRef: s,
                onClickOutside (oe) {
                    return E(oe), oe.target.classList.contains("q-dialog__backdrop") && $848b1ce88e755b32$var$Se(oe), !0;
                }
            }, I = (0, $eayOh.computed)(()=>e.modelValue === null && e.persistent !== !0 && c.value === !0);
            (0, $eayOh.watch)(I, (oe)=>{
                (oe === !0 ? $848b1ce88e755b32$var$Nl : $848b1ce88e755b32$var$qi)(N);
            }), (0, $fVLUl.onBeforeUnmount)(()=>{
                $848b1ce88e755b32$var$qi(N);
            });
        }
        function x(N) {
            A(), d(()=>{
                i = new MutationObserver(()=>Q()), i.observe(s.value, {
                    attributes: !1,
                    childList: !0,
                    characterData: !0,
                    subtree: !0
                }), Q(), ie();
            }), n === void 0 && (n = (0, $eayOh.watch)(()=>l.screen.width + "|" + l.screen.height + "|" + e.self + "|" + e.anchor + "|" + l.lang.rtl, Q)), y(()=>{
                A(!0), o("show", N);
            }, e.transitionDuration);
        }
        function k(N) {
            m(), B(), j(), y(()=>{
                B(!0), o("hide", N);
            }, e.transitionDuration);
        }
        function j() {
            i !== void 0 && (i.disconnect(), i = void 0), n !== void 0 && (n(), n = void 0), g(), $848b1ce88e755b32$var$Ct($, "tooltipTemp");
        }
        function Q() {
            $848b1ce88e755b32$var$Fa({
                targetEl: s.value,
                offset: e.offset,
                anchorEl: S.value,
                anchorOrigin: u.value,
                selfOrigin: v.value,
                maxHeight: e.maxHeight,
                maxWidth: e.maxWidth
            });
        }
        function w(N) {
            if (l.platform.is.mobile === !0) {
                $848b1ce88e755b32$var$Ut(), document.body.classList.add("non-selectable");
                let I = S.value, oe = [
                    "touchmove",
                    "touchcancel",
                    "touchend",
                    "click"
                ].map((T)=>[
                        I,
                        T,
                        "delayHide",
                        "passiveCapture"
                    ]);
                $848b1ce88e755b32$var$lt($, "tooltipTemp", oe);
            }
            y(()=>{
                L(N);
            }, e.delay);
        }
        function H(N) {
            l.platform.is.mobile === !0 && ($848b1ce88e755b32$var$Ct($, "tooltipTemp"), $848b1ce88e755b32$var$Ut(), setTimeout(()=>{
                document.body.classList.remove("non-selectable");
            }, 10)), y(()=>{
                E(N);
            }, e.hideDelay);
        }
        function W() {
            if (e.noParentEvent === !0 || S.value === null) return;
            let N = l.platform.is.mobile === !0 ? [
                [
                    S.value,
                    "touchstart",
                    "delayShow",
                    "passive"
                ]
            ] : [
                [
                    S.value,
                    "mouseenter",
                    "delayShow",
                    "passive"
                ],
                [
                    S.value,
                    "mouseleave",
                    "delayHide",
                    "passive"
                ]
            ];
            $848b1ce88e755b32$var$lt($, "anchor", N);
        }
        function ie() {
            if (S.value !== null || e.scrollTarget !== void 0) {
                b.value = $848b1ce88e755b32$var$At(S.value, e.scrollTarget);
                let N = e.noParentEvent === !0 ? Q : E;
                h(b.value, N);
            }
        }
        function V() {
            return c.value === !0 ? (0, $fVLUl.h)("div", {
                ...r,
                ref: s,
                class: [
                    "q-tooltip q-tooltip--style q-position-engine no-pointer-events",
                    r.class
                ],
                style: [
                    r.style,
                    C.value
                ],
                role: "tooltip"
            }, $848b1ce88e755b32$var$J(t.default)) : null;
        }
        function _() {
            return (0, $fVLUl.h)((0, $24349.Transition), p.value, V);
        }
        return (0, $fVLUl.onBeforeUnmount)(j), Object.assign(a.proxy, {
            updatePosition: Q
        }), q;
    }
});
var $848b1ce88e755b32$export$adf75769807ad87e = $848b1ce88e755b32$var$R({
    name: "QItem",
    props: {
        ...$848b1ce88e755b32$var$he,
        ...$848b1ce88e755b32$var$zo,
        tag: {
            type: String,
            default: "div"
        },
        active: {
            type: Boolean,
            default: null
        },
        clickable: Boolean,
        dense: Boolean,
        insetLevel: Number,
        tabindex: [
            String,
            Number
        ],
        focused: Boolean,
        manualFocus: Boolean
    },
    emits: [
        "click",
        "keyup"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: { $q: r } } = (0, $fVLUl.getCurrentInstance)(), n = $848b1ce88e755b32$var$pe(e, r), { hasLink: i, linkAttrs: a, linkClass: l, linkTag: s, navigateOnClick: c } = $848b1ce88e755b32$var$Yn(), u = (0, $eayOh.ref)(null), v = (0, $eayOh.ref)(null), f = (0, $eayOh.computed)(()=>e.clickable === !0 || i.value === !0 || e.tag === "label"), d = (0, $eayOh.computed)(()=>e.disable !== !0 && f.value === !0), m = (0, $eayOh.computed)(()=>"q-item q-item-type row no-wrap" + (e.dense === !0 ? " q-item--dense" : "") + (n.value === !0 ? " q-item--dark" : "") + (i.value === !0 && e.active === null ? l.value : e.active === !0 ? ` q-item--active${e.activeClass !== void 0 ? ` ${e.activeClass}` : ""}` : "") + (e.disable === !0 ? " disabled" : "") + (d.value === !0 ? " q-item--clickable q-link cursor-pointer " + (e.manualFocus === !0 ? "q-manual-focusable" : "q-focusable q-hoverable") + (e.focused === !0 ? " q-manual-focusable--focused" : "") : "")), y = (0, $eayOh.computed)(()=>e.insetLevel === void 0 ? null : {
                ["padding" + (r.lang.rtl === !0 ? "Right" : "Left")]: 16 + e.insetLevel * 56 + "px"
            });
        function p(h) {
            d.value === !0 && (v.value !== null && (h.qKeyEvent !== !0 && document.activeElement === u.value ? v.value.focus() : document.activeElement === v.value && u.value.focus()), c(h));
        }
        function C(h) {
            if (d.value === !0 && $848b1ce88e755b32$var$wt(h, [
                13,
                32
            ]) === !0) {
                $848b1ce88e755b32$var$Se(h), h.qKeyEvent = !0;
                let g = new MouseEvent("click", h);
                g.qKeyEvent = !0, u.value.dispatchEvent(g);
            }
            o("keyup", h);
        }
        function b() {
            let h = $848b1ce88e755b32$var$tn(t.default, []);
            return d.value === !0 && h.unshift((0, $fVLUl.h)("div", {
                class: "q-focus-helper",
                tabindex: -1,
                ref: v
            })), h;
        }
        return ()=>{
            let h = {
                ref: u,
                class: m.value,
                style: y.value,
                role: "listitem",
                onClick: p,
                onKeyup: C
            };
            return d.value === !0 ? (h.tabindex = e.tabindex || "0", Object.assign(h, a.value)) : f.value === !0 && (h["aria-disabled"] = "true"), (0, $fVLUl.h)(s.value, h, b());
        };
    }
});
var $848b1ce88e755b32$export$9579d29612d4e773 = $848b1ce88e755b32$var$R({
    name: "QItemSection",
    props: {
        avatar: Boolean,
        thumbnail: Boolean,
        side: Boolean,
        top: Boolean,
        noWrap: Boolean
    },
    setup (e, { slots: t }) {
        let o = (0, $eayOh.computed)(()=>`q-item__section column q-item__section--${e.avatar === !0 || e.side === !0 || e.thumbnail === !0 ? "side" : "main"}` + (e.top === !0 ? " q-item__section--top justify-start" : " justify-center") + (e.avatar === !0 ? " q-item__section--avatar" : "") + (e.thumbnail === !0 ? " q-item__section--thumbnail" : "") + (e.noWrap === !0 ? " q-item__section--nowrap" : ""));
        return ()=>(0, $fVLUl.h)("div", {
                class: o.value
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
function $848b1ce88e755b32$var$dv(e, t, o) {
    t.handler ? t.handler(e, o, o.caret) : o.runCmd(t.cmd, t.param);
}
function $848b1ce88e755b32$var$Qc(e) {
    return (0, $fVLUl.h)("div", {
        class: "q-editor__toolbar-group"
    }, e);
}
function $848b1ce88e755b32$var$fv(e, t, o, r = !1) {
    let n = r || (t.type === "toggle" ? t.toggled ? t.toggled(e) : t.cmd && e.caret.is(t.cmd, t.param) : !1), i = [];
    if (t.tip && e.$q.platform.is.desktop) {
        let a = t.key ? (0, $fVLUl.h)("div", [
            (0, $fVLUl.h)("small", `(CTRL + ${String.fromCharCode(t.key)})`)
        ]) : null;
        i.push((0, $fVLUl.h)($848b1ce88e755b32$export$b4dba0bbe7f6a787, {
            delay: 1e3
        }, ()=>[
                (0, $fVLUl.h)("div", {
                    innerHTML: t.tip
                }),
                a
            ]));
    }
    return (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
        ...e.buttonProps.value,
        icon: t.icon !== null ? t.icon : void 0,
        color: n ? t.toggleColor || e.props.toolbarToggleColor : t.color || e.props.toolbarColor,
        textColor: n && !e.props.toolbarPush ? null : t.textColor || e.props.toolbarTextColor,
        label: t.label,
        disable: t.disable ? typeof t.disable == "function" ? t.disable(e) : !0 : !1,
        size: "sm",
        onClick (a) {
            o && o(), $848b1ce88e755b32$var$dv(a, t, e);
        }
    }, ()=>i);
}
function $848b1ce88e755b32$var$Yx(e, t) {
    let o = t.list === "only-icons", r = t.label, n = t.icon !== null ? t.icon : void 0, i, a;
    function l() {
        c.component.proxy.hide();
    }
    if (o) a = t.options.map((u)=>{
        let v = u.type === void 0 ? e.caret.is(u.cmd, u.param) : !1;
        return v && (r = u.tip, n = u.icon !== null ? u.icon : void 0), $848b1ce88e755b32$var$fv(e, u, l, v);
    }), i = e.toolbarBackgroundClass.value, a = [
        $848b1ce88e755b32$var$Qc(a)
    ];
    else {
        let u = e.props.toolbarToggleColor !== void 0 ? `text-${e.props.toolbarToggleColor}` : null, v = e.props.toolbarTextColor !== void 0 ? `text-${e.props.toolbarTextColor}` : null, f = t.list === "no-icons";
        a = t.options.map((d)=>{
            let m = d.disable ? d.disable(e) : !1, y = d.type === void 0 ? e.caret.is(d.cmd, d.param) : !1;
            y && (r = d.tip, n = d.icon !== null ? d.icon : void 0);
            let p = d.htmlTip;
            return (0, $fVLUl.h)($848b1ce88e755b32$export$adf75769807ad87e, {
                active: y,
                activeClass: u,
                clickable: !0,
                disable: m,
                dense: !0,
                onClick (C) {
                    l(), e.contentRef.value !== null && e.contentRef.value.focus(), e.caret.restore(), $848b1ce88e755b32$var$dv(C, d, e);
                }
            }, ()=>[
                    f === !0 ? null : (0, $fVLUl.h)($848b1ce88e755b32$export$9579d29612d4e773, {
                        class: y ? u : v,
                        side: !0
                    }, ()=>(0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                            name: d.icon !== null ? d.icon : void 0
                        })),
                    (0, $fVLUl.h)($848b1ce88e755b32$export$9579d29612d4e773, p ? ()=>(0, $fVLUl.h)("div", {
                            class: "text-no-wrap",
                            innerHTML: d.htmlTip
                        }) : d.tip ? ()=>(0, $fVLUl.h)("div", {
                            class: "text-no-wrap"
                        }, d.tip) : void 0)
                ]);
        }), i = [
            e.toolbarBackgroundClass.value,
            v
        ];
    }
    let s = t.highlight && r !== t.label, c = (0, $fVLUl.h)($848b1ce88e755b32$export$ed13f95342ac4309, {
        ...e.buttonProps.value,
        noCaps: !0,
        noWrap: !0,
        color: s ? e.props.toolbarToggleColor : e.props.toolbarColor,
        textColor: s && !e.props.toolbarPush ? null : e.props.toolbarTextColor,
        label: t.fixedLabel ? t.label : r,
        icon: t.fixedIcon ? t.icon !== null ? t.icon : void 0 : n,
        contentClass: i,
        onShow: (u)=>e.emit("dropdownShow", u),
        onHide: (u)=>e.emit("dropdownHide", u),
        onBeforeShow: (u)=>e.emit("dropdownBeforeShow", u),
        onBeforeHide: (u)=>e.emit("dropdownBeforeHide", u)
    }, ()=>a);
    return c;
}
function $848b1ce88e755b32$var$mv(e) {
    if (e.caret) return e.buttons.value.filter((t)=>!e.isViewingSource.value || t.find((o)=>o.cmd === "viewsource")).map((t)=>$848b1ce88e755b32$var$Qc(t.map((o)=>e.isViewingSource.value && o.cmd !== "viewsource" ? !1 : o.type === "slot" ? $848b1ce88e755b32$var$J(e.slots[o.slot]) : o.type === "dropdown" ? $848b1ce88e755b32$var$Yx(e, o) : $848b1ce88e755b32$var$fv(e, o))));
}
function $848b1ce88e755b32$var$vv(e, t, o, r = {}) {
    let n = Object.keys(r);
    if (n.length === 0) return {};
    let i = {
        default_font: {
            cmd: "fontName",
            param: e,
            icon: o,
            tip: t
        }
    };
    return n.forEach((a)=>{
        let l = r[a];
        i[a] = {
            cmd: "fontName",
            param: l,
            icon: o,
            tip: l,
            htmlTip: `<font face="${l}">${l}</font>`
        };
    }), i;
}
function $848b1ce88e755b32$var$gv(e) {
    if (e.caret) {
        let t = e.props.toolbarColor || e.props.toolbarTextColor, o = e.editLinkUrl.value, r = ()=>{
            e.caret.restore(), o !== e.editLinkUrl.value && document.execCommand("createLink", !1, o === "" ? " " : o), e.editLinkUrl.value = null;
        };
        return [
            (0, $fVLUl.h)("div", {
                class: `q-mx-xs text-${t}`
            }, `${e.$q.lang.editor.url}: `),
            (0, $fVLUl.h)("input", {
                key: "qedt_btm_input",
                class: "col q-editor__link-input",
                value: o,
                onInput: (n)=>{
                    $848b1ce88e755b32$var$tt(n), o = n.target.value;
                },
                onKeydown: (n)=>{
                    if ($848b1ce88e755b32$var$xo(n) !== !0) switch(n.keyCode){
                        case 13:
                            return $848b1ce88e755b32$var$ut(n), r();
                        case 27:
                            $848b1ce88e755b32$var$ut(n), e.caret.restore(), (!e.editLinkUrl.value || e.editLinkUrl.value === "https://") && document.execCommand("unlink"), e.editLinkUrl.value = null;
                            break;
                    }
                }
            }),
            $848b1ce88e755b32$var$Qc([
                (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                    key: "qedt_btm_rem",
                    tabindex: -1,
                    ...e.buttonProps.value,
                    label: e.$q.lang.label.remove,
                    noCaps: !0,
                    onClick: ()=>{
                        e.caret.restore(), document.execCommand("unlink"), e.editLinkUrl.value = null;
                    }
                }),
                (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                    key: "qedt_btm_upd",
                    ...e.buttonProps.value,
                    label: e.$q.lang.label.update,
                    noCaps: !0,
                    onClick: r
                })
            ])
        ];
    }
}
var $848b1ce88e755b32$var$pv = /^on[A-Z]/;
function $848b1ce88e755b32$export$6d16226782fe5bdf() {
    let { attrs: e, vnode: t } = (0, $fVLUl.getCurrentInstance)(), o = {
        listeners: (0, $eayOh.ref)({}),
        attributes: (0, $eayOh.ref)({})
    };
    function r() {
        let n = {}, i = {};
        for(let a in e)a !== "class" && a !== "style" && $848b1ce88e755b32$var$pv.test(a) === !1 && (n[a] = e[a]);
        for(let a in t.props)$848b1ce88e755b32$var$pv.test(a) === !0 && (i[a] = t.props[a]);
        o.attributes.value = n, o.listeners.value = i;
    }
    return (0, $fVLUl.onBeforeUpdate)(r), r(), o;
}
var $848b1ce88e755b32$var$Zx = Object.prototype.toString, $848b1ce88e755b32$var$jc = Object.prototype.hasOwnProperty, $848b1ce88e755b32$var$Jx = new Set([
    "Boolean",
    "Number",
    "String",
    "Function",
    "Array",
    "Date",
    "RegExp"
].map((e)=>"[object " + e + "]"));
function $848b1ce88e755b32$var$bv(e) {
    if (e !== Object(e) || $848b1ce88e755b32$var$Jx.has($848b1ce88e755b32$var$Zx.call(e)) === !0 || e.constructor && $848b1ce88e755b32$var$jc.call(e, "constructor") === !1 && $848b1ce88e755b32$var$jc.call(e.constructor.prototype, "isPrototypeOf") === !1) return !1;
    let t;
    for(t in e);
    return t === void 0 || $848b1ce88e755b32$var$jc.call(e, t);
}
function $848b1ce88e755b32$export$8b58be045bf06082() {
    let e, t, o, r, n, i, a = arguments[0] || {}, l = 1, s = !1, c = arguments.length;
    for(typeof a == "boolean" && (s = a, a = arguments[1] || {}, l = 2), Object(a) !== a && typeof a != "function" && (a = {}), c === l && (a = this, l--); l < c; l++)if ((e = arguments[l]) !== null) for(t in e)o = a[t], r = e[t], a !== r && (s === !0 && r && ((n = Array.isArray(r)) || $848b1ce88e755b32$var$bv(r) === !0) ? (n === !0 ? i = Array.isArray(o) === !0 ? o : [] : i = $848b1ce88e755b32$var$bv(o) === !0 ? o : {}, a[t] = $848b1ce88e755b32$export$8b58be045bf06082(s, i, r)) : r !== void 0 && (a[t] = r));
    return a;
}
var $848b1ce88e755b32$export$2107e7367505ec8a = $848b1ce88e755b32$var$R({
    name: "QEditor",
    props: {
        ...$848b1ce88e755b32$var$he,
        ...$848b1ce88e755b32$var$zi,
        modelValue: {
            type: String,
            required: !0
        },
        readonly: Boolean,
        disable: Boolean,
        minHeight: {
            type: String,
            default: "10rem"
        },
        maxHeight: String,
        height: String,
        definitions: Object,
        fonts: Object,
        placeholder: String,
        toolbar: {
            type: Array,
            validator: (e)=>e.length === 0 || e.every((t)=>t.length),
            default () {
                return [
                    [
                        "left",
                        "center",
                        "right",
                        "justify"
                    ],
                    [
                        "bold",
                        "italic",
                        "underline",
                        "strike"
                    ],
                    [
                        "undo",
                        "redo"
                    ]
                ];
            }
        },
        toolbarColor: String,
        toolbarBg: String,
        toolbarTextColor: String,
        toolbarToggleColor: {
            type: String,
            default: "primary"
        },
        toolbarOutline: Boolean,
        toolbarPush: Boolean,
        toolbarRounded: Boolean,
        paragraphTag: {
            type: String,
            validator: (e)=>[
                    "div",
                    "p"
                ].includes(e),
            default: "div"
        },
        contentStyle: Object,
        contentClass: [
            Object,
            Array,
            String
        ],
        square: Boolean,
        flat: Boolean,
        dense: Boolean
    },
    emits: [
        ...$848b1ce88e755b32$var$Oi,
        "update:modelValue",
        "keydown",
        "click",
        "mouseup",
        "keyup",
        "touchend",
        "focus",
        "blur",
        "dropdownShow",
        "dropdownHide",
        "dropdownBeforeShow",
        "dropdownBeforeHide",
        "linkShow",
        "linkHide"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: r } = (0, $fVLUl.getCurrentInstance)(), { $q: n } = r, i = $848b1ce88e755b32$var$pe(e, n), { inFullscreen: a, toggleFullscreen: l } = $848b1ce88e755b32$var$Ii(), s = $848b1ce88e755b32$export$6d16226782fe5bdf(), c = (0, $eayOh.ref)(null), u = (0, $eayOh.ref)(null), v = (0, $eayOh.ref)(null), f = (0, $eayOh.ref)(!1), d = (0, $eayOh.computed)(()=>!e.readonly && !e.disable), m, y, p = e.modelValue;
        document.execCommand("defaultParagraphSeparator", !1, e.paragraphTag), m = window.getComputedStyle(document.body).fontFamily;
        let C = (0, $eayOh.computed)(()=>e.toolbarBg ? ` bg-${e.toolbarBg}` : ""), b = (0, $eayOh.computed)(()=>({
                type: "a",
                flat: e.toolbarOutline !== !0 && e.toolbarPush !== !0,
                noWrap: !0,
                outline: e.toolbarOutline,
                push: e.toolbarPush,
                rounded: e.toolbarRounded,
                dense: !0,
                color: e.toolbarColor,
                disable: !d.value,
                size: "sm"
            })), h = (0, $eayOh.computed)(()=>{
            let T = n.lang.editor, D = n.iconSet.editor;
            return {
                bold: {
                    cmd: "bold",
                    icon: D.bold,
                    tip: T.bold,
                    key: 66
                },
                italic: {
                    cmd: "italic",
                    icon: D.italic,
                    tip: T.italic,
                    key: 73
                },
                strike: {
                    cmd: "strikeThrough",
                    icon: D.strikethrough,
                    tip: T.strikethrough,
                    key: 83
                },
                underline: {
                    cmd: "underline",
                    icon: D.underline,
                    tip: T.underline,
                    key: 85
                },
                unordered: {
                    cmd: "insertUnorderedList",
                    icon: D.unorderedList,
                    tip: T.unorderedList
                },
                ordered: {
                    cmd: "insertOrderedList",
                    icon: D.orderedList,
                    tip: T.orderedList
                },
                subscript: {
                    cmd: "subscript",
                    icon: D.subscript,
                    tip: T.subscript,
                    htmlTip: "x<subscript>2</subscript>"
                },
                superscript: {
                    cmd: "superscript",
                    icon: D.superscript,
                    tip: T.superscript,
                    htmlTip: "x<superscript>2</superscript>"
                },
                link: {
                    cmd: "link",
                    disable: (te)=>te.caret && !te.caret.can("link"),
                    icon: D.hyperlink,
                    tip: T.hyperlink,
                    key: 76
                },
                fullscreen: {
                    cmd: "fullscreen",
                    icon: D.toggleFullscreen,
                    tip: T.toggleFullscreen,
                    key: 70
                },
                viewsource: {
                    cmd: "viewsource",
                    icon: D.viewSource,
                    tip: T.viewSource
                },
                quote: {
                    cmd: "formatBlock",
                    param: "BLOCKQUOTE",
                    icon: D.quote,
                    tip: T.quote,
                    key: 81
                },
                left: {
                    cmd: "justifyLeft",
                    icon: D.left,
                    tip: T.left
                },
                center: {
                    cmd: "justifyCenter",
                    icon: D.center,
                    tip: T.center
                },
                right: {
                    cmd: "justifyRight",
                    icon: D.right,
                    tip: T.right
                },
                justify: {
                    cmd: "justifyFull",
                    icon: D.justify,
                    tip: T.justify
                },
                print: {
                    type: "no-state",
                    cmd: "print",
                    icon: D.print,
                    tip: T.print,
                    key: 80
                },
                outdent: {
                    type: "no-state",
                    disable: (te)=>te.caret && !te.caret.can("outdent"),
                    cmd: "outdent",
                    icon: D.outdent,
                    tip: T.outdent
                },
                indent: {
                    type: "no-state",
                    disable: (te)=>te.caret && !te.caret.can("indent"),
                    cmd: "indent",
                    icon: D.indent,
                    tip: T.indent
                },
                removeFormat: {
                    type: "no-state",
                    cmd: "removeFormat",
                    icon: D.removeFormat,
                    tip: T.removeFormat
                },
                hr: {
                    type: "no-state",
                    cmd: "insertHorizontalRule",
                    icon: D.hr,
                    tip: T.hr
                },
                undo: {
                    type: "no-state",
                    cmd: "undo",
                    icon: D.undo,
                    tip: T.undo,
                    key: 90
                },
                redo: {
                    type: "no-state",
                    cmd: "redo",
                    icon: D.redo,
                    tip: T.redo,
                    key: 89
                },
                h1: {
                    cmd: "formatBlock",
                    param: "H1",
                    icon: D.heading1 || D.heading,
                    tip: T.heading1,
                    htmlTip: `<h1 class="q-ma-none">${T.heading1}</h1>`
                },
                h2: {
                    cmd: "formatBlock",
                    param: "H2",
                    icon: D.heading2 || D.heading,
                    tip: T.heading2,
                    htmlTip: `<h2 class="q-ma-none">${T.heading2}</h2>`
                },
                h3: {
                    cmd: "formatBlock",
                    param: "H3",
                    icon: D.heading3 || D.heading,
                    tip: T.heading3,
                    htmlTip: `<h3 class="q-ma-none">${T.heading3}</h3>`
                },
                h4: {
                    cmd: "formatBlock",
                    param: "H4",
                    icon: D.heading4 || D.heading,
                    tip: T.heading4,
                    htmlTip: `<h4 class="q-ma-none">${T.heading4}</h4>`
                },
                h5: {
                    cmd: "formatBlock",
                    param: "H5",
                    icon: D.heading5 || D.heading,
                    tip: T.heading5,
                    htmlTip: `<h5 class="q-ma-none">${T.heading5}</h5>`
                },
                h6: {
                    cmd: "formatBlock",
                    param: "H6",
                    icon: D.heading6 || D.heading,
                    tip: T.heading6,
                    htmlTip: `<h6 class="q-ma-none">${T.heading6}</h6>`
                },
                p: {
                    cmd: "formatBlock",
                    param: e.paragraphTag,
                    icon: D.heading,
                    tip: T.paragraph
                },
                code: {
                    cmd: "formatBlock",
                    param: "PRE",
                    icon: D.code,
                    htmlTip: `<code>${T.code}</code>`
                },
                "size-1": {
                    cmd: "fontSize",
                    param: "1",
                    icon: D.size1 || D.size,
                    tip: T.size1,
                    htmlTip: `<font size="1">${T.size1}</font>`
                },
                "size-2": {
                    cmd: "fontSize",
                    param: "2",
                    icon: D.size2 || D.size,
                    tip: T.size2,
                    htmlTip: `<font size="2">${T.size2}</font>`
                },
                "size-3": {
                    cmd: "fontSize",
                    param: "3",
                    icon: D.size3 || D.size,
                    tip: T.size3,
                    htmlTip: `<font size="3">${T.size3}</font>`
                },
                "size-4": {
                    cmd: "fontSize",
                    param: "4",
                    icon: D.size4 || D.size,
                    tip: T.size4,
                    htmlTip: `<font size="4">${T.size4}</font>`
                },
                "size-5": {
                    cmd: "fontSize",
                    param: "5",
                    icon: D.size5 || D.size,
                    tip: T.size5,
                    htmlTip: `<font size="5">${T.size5}</font>`
                },
                "size-6": {
                    cmd: "fontSize",
                    param: "6",
                    icon: D.size6 || D.size,
                    tip: T.size6,
                    htmlTip: `<font size="6">${T.size6}</font>`
                },
                "size-7": {
                    cmd: "fontSize",
                    param: "7",
                    icon: D.size7 || D.size,
                    tip: T.size7,
                    htmlTip: `<font size="7">${T.size7}</font>`
                }
            };
        }), g = (0, $eayOh.computed)(()=>{
            let T = e.definitions || {}, D = e.definitions || e.fonts ? $848b1ce88e755b32$export$8b58be045bf06082(!0, {}, h.value, T, $848b1ce88e755b32$var$vv(m, n.lang.editor.defaultFont, n.iconSet.editor.font, e.fonts)) : h.value;
            return e.toolbar.map((te)=>te.map((z)=>{
                    if (z.options) return {
                        type: "dropdown",
                        icon: z.icon,
                        label: z.label,
                        size: "sm",
                        dense: !0,
                        fixedLabel: z.fixedLabel,
                        fixedIcon: z.fixedIcon,
                        highlight: z.highlight,
                        list: z.list,
                        options: z.options.map((_e)=>D[_e])
                    };
                    let ue = D[z];
                    return ue ? ue.type === "no-state" || T[z] && (ue.cmd === void 0 || h.value[ue.cmd] && h.value[ue.cmd].type === "no-state") ? ue : Object.assign({
                        type: "toggle"
                    }, ue) : {
                        type: "slot",
                        slot: z
                    };
                }));
        }), S = {
            $q: n,
            props: e,
            slots: t,
            emit: o,
            inFullscreen: a,
            toggleFullscreen: l,
            runCmd: _,
            isViewingSource: f,
            editLinkUrl: v,
            toolbarBackgroundClass: C,
            buttonProps: b,
            contentRef: u,
            buttons: g,
            setContent: V
        };
        (0, $eayOh.watch)(()=>e.modelValue, (T)=>{
            p !== T && (p = T, V(T, !0));
        }), (0, $eayOh.watch)(v, (T)=>{
            o(`link${T ? "Show" : "Hide"}`);
        });
        let P = (0, $eayOh.computed)(()=>e.toolbar && e.toolbar.length !== 0), $ = (0, $eayOh.computed)(()=>{
            let T = {}, D = (te)=>{
                te.key && (T[te.key] = {
                    cmd: te.cmd,
                    param: te.param
                });
            };
            return g.value.forEach((te)=>{
                te.forEach((z)=>{
                    z.options ? z.options.forEach(D) : D(z);
                });
            }), T;
        }), L = (0, $eayOh.computed)(()=>a.value ? e.contentStyle : [
                {
                    minHeight: e.minHeight,
                    height: e.height,
                    maxHeight: e.maxHeight
                },
                e.contentStyle
            ]), E = (0, $eayOh.computed)(()=>`q-editor q-editor--${f.value === !0 ? "source" : "default"}` + (e.disable === !0 ? " disabled" : "") + (a.value === !0 ? " fullscreen column" : "") + (e.square === !0 ? " q-editor--square no-border-radius" : "") + (e.flat === !0 ? " q-editor--flat" : "") + (e.dense === !0 ? " q-editor--dense" : "") + (i.value === !0 ? " q-editor--dark q-dark" : "")), A = (0, $eayOh.computed)(()=>[
                e.contentClass,
                "q-editor__content",
                {
                    col: a.value,
                    "overflow-auto": a.value || e.maxHeight
                }
            ]), B = (0, $eayOh.computed)(()=>e.disable === !0 ? {
                "aria-disabled": "true"
            } : {});
        function q() {
            if (u.value !== null) {
                let T = `inner${f.value === !0 ? "Text" : "HTML"}`, D = u.value[T];
                D !== e.modelValue && (p = D, o("update:modelValue", D));
            }
        }
        function x(T) {
            if (o("keydown", T), T.ctrlKey !== !0 || $848b1ce88e755b32$var$xo(T) === !0) {
                N();
                return;
            }
            let D = T.keyCode, te = $.value[D];
            if (te !== void 0) {
                let { cmd: z, param: ue } = te;
                $848b1ce88e755b32$var$Se(T), _(z, ue, !1);
            }
        }
        function k(T) {
            N(), o("click", T);
        }
        function j(T) {
            if (u.value !== null) {
                let { scrollTop: D, scrollHeight: te } = u.value;
                y = te - D;
            }
            S.caret.save(), o("blur", T);
        }
        function Q(T) {
            (0, $fVLUl.nextTick)(()=>{
                u.value !== null && y !== void 0 && (u.value.scrollTop = u.value.scrollHeight - y);
            }), o("focus", T);
        }
        function w(T) {
            let D = c.value;
            if (D !== null && D.contains(T.target) === !0 && (T.relatedTarget === null || D.contains(T.relatedTarget) !== !0)) {
                let te = `inner${f.value === !0 ? "Text" : "HTML"}`;
                S.caret.restorePosition(u.value[te].length), N();
            }
        }
        function H(T) {
            let D = c.value;
            D !== null && D.contains(T.target) === !0 && (T.relatedTarget === null || D.contains(T.relatedTarget) !== !0) && (S.caret.savePosition(), N());
        }
        function W() {
            y = void 0;
        }
        function ie(T) {
            S.caret.save();
        }
        function V(T, D) {
            if (u.value !== null) {
                D === !0 && S.caret.savePosition();
                let te = `inner${f.value === !0 ? "Text" : "HTML"}`;
                u.value[te] = T, D === !0 && (S.caret.restorePosition(u.value[te].length), N());
            }
        }
        function _(T, D, te = !0) {
            I(), S.caret.restore(), S.caret.apply(T, D, ()=>{
                I(), S.caret.save(), te && N();
            });
        }
        function N() {
            setTimeout(()=>{
                v.value = null, r.$forceUpdate();
            }, 1);
        }
        function I() {
            $848b1ce88e755b32$var$Bo(()=>{
                u.value !== null && u.value.focus({
                    preventScroll: !0
                });
            });
        }
        function oe() {
            return u.value;
        }
        return (0, $fVLUl.onMounted)(()=>{
            S.caret = r.caret = new $848b1ce88e755b32$var$el(u.value, S), V(e.modelValue), N(), document.addEventListener("selectionchange", ie);
        }), (0, $fVLUl.onBeforeUnmount)(()=>{
            document.removeEventListener("selectionchange", ie);
        }), Object.assign(r, {
            runCmd: _,
            refreshToolbar: N,
            focus: I,
            getContentEl: oe
        }), ()=>{
            let T;
            if (P.value) {
                let D = [
                    (0, $fVLUl.h)("div", {
                        key: "qedt_top",
                        class: "q-editor__toolbar row no-wrap scroll-x" + C.value
                    }, $848b1ce88e755b32$var$mv(S))
                ];
                v.value !== null && D.push((0, $fVLUl.h)("div", {
                    key: "qedt_btm",
                    class: "q-editor__toolbar row no-wrap items-center scroll-x" + C.value
                }, $848b1ce88e755b32$var$gv(S))), T = (0, $fVLUl.h)("div", {
                    key: "toolbar_ctainer",
                    class: "q-editor__toolbars-container"
                }, D);
            }
            return (0, $fVLUl.h)("div", {
                ref: c,
                class: E.value,
                style: {
                    height: a.value === !0 ? "100%" : null
                },
                ...B.value,
                onFocusin: w,
                onFocusout: H
            }, [
                T,
                (0, $fVLUl.h)("div", {
                    ref: u,
                    style: L.value,
                    class: A.value,
                    contenteditable: d.value,
                    placeholder: e.placeholder,
                    ...s.listeners.value,
                    onInput: q,
                    onKeydown: x,
                    onClick: k,
                    onBlur: j,
                    onFocus: Q,
                    onMousedown: W,
                    onTouchstartPassive: W
                })
            ]);
        };
    }
});
var $848b1ce88e755b32$export$17cb5eb1f3204256 = $848b1ce88e755b32$var$R({
    name: "QItemLabel",
    props: {
        overline: Boolean,
        caption: Boolean,
        header: Boolean,
        lines: [
            Number,
            String
        ]
    },
    setup (e, { slots: t }) {
        let o = (0, $eayOh.computed)(()=>parseInt(e.lines, 10)), r = (0, $eayOh.computed)(()=>"q-item__label" + (e.overline === !0 ? " q-item__label--overline text-overline" : "") + (e.caption === !0 ? " q-item__label--caption text-caption" : "") + (e.header === !0 ? " q-item__label--header" : "") + (o.value === 1 ? " ellipsis" : "")), n = (0, $eayOh.computed)(()=>e.lines !== void 0 && o.value > 1 ? {
                overflow: "hidden",
                display: "-webkit-box",
                "-webkit-box-orient": "vertical",
                "-webkit-line-clamp": o.value
            } : null);
        return ()=>(0, $fVLUl.h)("div", {
                style: n.value,
                class: r.value
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$export$1712cdc175d4649d = $848b1ce88e755b32$var$R({
    name: "QSlideTransition",
    props: {
        appear: Boolean,
        duration: {
            type: Number,
            default: 300
        }
    },
    emits: [
        "show",
        "hide"
    ],
    setup (e, { slots: t, emit: o }) {
        let r = !1, n, i, a = null, l = null, s, c;
        function u() {
            n && n(), n = null, r = !1, a !== null && (clearTimeout(a), a = null), l !== null && (clearTimeout(l), l = null), i !== void 0 && i.removeEventListener("transitionend", s), s = null;
        }
        function v(y, p, C) {
            p !== void 0 && (y.style.height = `${p}px`), y.style.transition = `height ${e.duration}ms cubic-bezier(.25, .8, .50, 1)`, r = !0, n = C;
        }
        function f(y, p) {
            y.style.overflowY = null, y.style.height = null, y.style.transition = null, u(), p !== c && o(p);
        }
        function d(y, p) {
            let C = 0;
            i = y, r === !0 ? (u(), C = y.offsetHeight === y.scrollHeight ? 0 : void 0) : (c = "hide", y.style.overflowY = "hidden"), v(y, C, p), a = setTimeout(()=>{
                a = null, y.style.height = `${y.scrollHeight}px`, s = (b)=>{
                    l = null, (Object(b) !== b || b.target === y) && f(y, "show");
                }, y.addEventListener("transitionend", s), l = setTimeout(s, e.duration * 1.1);
            }, 100);
        }
        function m(y, p) {
            let C;
            i = y, r === !0 ? u() : (c = "show", y.style.overflowY = "hidden", C = y.scrollHeight), v(y, C, p), a = setTimeout(()=>{
                a = null, y.style.height = 0, s = (b)=>{
                    l = null, (Object(b) !== b || b.target === y) && f(y, "hide");
                }, y.addEventListener("transitionend", s), l = setTimeout(s, e.duration * 1.1);
            }, 100);
        }
        return (0, $fVLUl.onBeforeUnmount)(()=>{
            r === !0 && u();
        }), ()=>(0, $fVLUl.h)((0, $24349.Transition), {
                css: !1,
                appear: e.appear,
                onEnter: d,
                onLeave: m
            }, t.default);
    }
});
var $848b1ce88e755b32$var$c_ = {
    true: "inset",
    item: "item-inset",
    "item-thumbnail": "item-thumbnail-inset"
}, $848b1ce88e755b32$var$Kc = {
    xs: 2,
    sm: 4,
    md: 8,
    lg: 16,
    xl: 24
}, $848b1ce88e755b32$export$a3fe6e564278fbe9 = $848b1ce88e755b32$var$R({
    name: "QSeparator",
    props: {
        ...$848b1ce88e755b32$var$he,
        spaced: [
            Boolean,
            String
        ],
        inset: [
            Boolean,
            String
        ],
        vertical: Boolean,
        color: String,
        size: String
    },
    setup (e) {
        let t = (0, $fVLUl.getCurrentInstance)(), o = $848b1ce88e755b32$var$pe(e, t.proxy.$q), r = (0, $eayOh.computed)(()=>e.vertical === !0 ? "vertical" : "horizontal"), n = (0, $eayOh.computed)(()=>` q-separator--${r.value}`), i = (0, $eayOh.computed)(()=>e.inset !== !1 ? `${n.value}-${$848b1ce88e755b32$var$c_[e.inset]}` : ""), a = (0, $eayOh.computed)(()=>`q-separator${n.value}${i.value}` + (e.color !== void 0 ? ` bg-${e.color}` : "") + (o.value === !0 ? " q-separator--dark" : "")), l = (0, $eayOh.computed)(()=>{
            let s = {};
            if (e.size !== void 0 && (s[e.vertical === !0 ? "width" : "height"] = e.size), e.spaced !== !1) {
                let c = e.spaced === !0 ? `${$848b1ce88e755b32$var$Kc.md}px` : e.spaced in $848b1ce88e755b32$var$Kc ? `${$848b1ce88e755b32$var$Kc[e.spaced]}px` : e.spaced, u = e.vertical === !0 ? [
                    "Left",
                    "Right"
                ] : [
                    "Top",
                    "Bottom"
                ];
                s[`margin${u[0]}`] = s[`margin${u[1]}`] = c;
            }
            return s;
        });
        return ()=>(0, $fVLUl.h)("hr", {
                class: a.value,
                style: l.value,
                "aria-orientation": r.value
            });
    }
});
var $848b1ce88e755b32$var$Nr = (0, $eayOh.shallowReactive)({}), $848b1ce88e755b32$var$h_ = Object.keys($848b1ce88e755b32$var$zo), $848b1ce88e755b32$export$eb8cb4fb55e6cd84 = $848b1ce88e755b32$var$R({
    name: "QExpansionItem",
    props: {
        ...$848b1ce88e755b32$var$zo,
        ...$848b1ce88e755b32$var$Ao,
        ...$848b1ce88e755b32$var$he,
        icon: String,
        label: String,
        labelLines: [
            Number,
            String
        ],
        caption: String,
        captionLines: [
            Number,
            String
        ],
        dense: Boolean,
        toggleAriaLabel: String,
        expandIcon: String,
        expandedIcon: String,
        expandIconClass: [
            Array,
            String,
            Object
        ],
        duration: Number,
        headerInsetLevel: Number,
        contentInsetLevel: Number,
        expandSeparator: Boolean,
        defaultOpened: Boolean,
        hideExpandIcon: Boolean,
        expandIconToggle: Boolean,
        switchToggleSide: Boolean,
        denseToggle: Boolean,
        group: String,
        popup: Boolean,
        headerStyle: [
            Array,
            String,
            Object
        ],
        headerClass: [
            Array,
            String,
            Object
        ]
    },
    emits: [
        ...$848b1ce88e755b32$var$$o,
        "click",
        "afterShow",
        "afterHide"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: { $q: r } } = (0, $fVLUl.getCurrentInstance)(), n = $848b1ce88e755b32$var$pe(e, r), i = (0, $eayOh.ref)(e.modelValue !== null ? e.modelValue : e.defaultOpened), a = (0, $eayOh.ref)(null), l = $848b1ce88e755b32$export$f680877a34711e37(), { show: s, hide: c, toggle: u } = $848b1ce88e755b32$var$Eo({
            showing: i
        }), v, f, d = (0, $eayOh.computed)(()=>`q-expansion-item q-item-type q-expansion-item--${i.value === !0 ? "expanded" : "collapsed"} q-expansion-item--${e.popup === !0 ? "popup" : "standard"}`), m = (0, $eayOh.computed)(()=>e.contentInsetLevel === void 0 ? null : {
                ["padding" + (r.lang.rtl === !0 ? "Right" : "Left")]: e.contentInsetLevel * 56 + "px"
            }), y = (0, $eayOh.computed)(()=>e.disable !== !0 && (e.href !== void 0 || e.to !== void 0 && e.to !== null && e.to !== "")), p = (0, $eayOh.computed)(()=>{
            let w = {};
            return $848b1ce88e755b32$var$h_.forEach((H)=>{
                w[H] = e[H];
            }), w;
        }), C = (0, $eayOh.computed)(()=>y.value === !0 || e.expandIconToggle !== !0), b = (0, $eayOh.computed)(()=>e.expandedIcon !== void 0 && i.value === !0 ? e.expandedIcon : e.expandIcon || r.iconSet.expansionItem[e.denseToggle === !0 ? "denseIcon" : "icon"]), h = (0, $eayOh.computed)(()=>e.disable !== !0 && (y.value === !0 || e.expandIconToggle === !0)), g = (0, $eayOh.computed)(()=>({
                expanded: i.value === !0,
                detailsId: l.value,
                toggle: u,
                show: s,
                hide: c
            })), S = (0, $eayOh.computed)(()=>{
            let w = e.toggleAriaLabel !== void 0 ? e.toggleAriaLabel : r.lang.label[i.value === !0 ? "collapse" : "expand"](e.label);
            return {
                role: "button",
                "aria-expanded": i.value === !0 ? "true" : "false",
                "aria-controls": l.value,
                "aria-label": w
            };
        });
        (0, $eayOh.watch)(()=>e.group, (w)=>{
            f !== void 0 && f(), w !== void 0 && B();
        });
        function P(w) {
            y.value !== !0 && u(w), o("click", w);
        }
        function $(w) {
            w.keyCode === 13 && L(w, !0);
        }
        function L(w, H) {
            H !== !0 && a.value !== null && a.value.focus(), u(w), $848b1ce88e755b32$var$Se(w);
        }
        function E() {
            o("afterShow");
        }
        function A() {
            o("afterHide");
        }
        function B() {
            v === void 0 && (v = $848b1ce88e755b32$export$e2a22331486dcca0()), i.value === !0 && ($848b1ce88e755b32$var$Nr[e.group] = v);
            let w = (0, $eayOh.watch)(i, (W)=>{
                W === !0 ? $848b1ce88e755b32$var$Nr[e.group] = v : $848b1ce88e755b32$var$Nr[e.group] === v && delete $848b1ce88e755b32$var$Nr[e.group];
            }), H = (0, $eayOh.watch)(()=>$848b1ce88e755b32$var$Nr[e.group], (W, ie)=>{
                ie === v && W !== void 0 && W !== v && c();
            });
            f = ()=>{
                w(), H(), $848b1ce88e755b32$var$Nr[e.group] === v && delete $848b1ce88e755b32$var$Nr[e.group], f = void 0;
            };
        }
        function q() {
            let w = {
                class: [
                    `q-focusable relative-position cursor-pointer${e.denseToggle === !0 && e.switchToggleSide === !0 ? " items-end" : ""}`,
                    e.expandIconClass
                ],
                side: e.switchToggleSide !== !0,
                avatar: e.switchToggleSide
            }, H = [
                (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                    class: "q-expansion-item__toggle-icon" + (e.expandedIcon === void 0 && i.value === !0 ? " q-expansion-item__toggle-icon--rotated" : ""),
                    name: b.value
                })
            ];
            return h.value === !0 && (Object.assign(w, {
                tabindex: 0,
                ...S.value,
                onClick: L,
                onKeyup: $
            }), H.unshift((0, $fVLUl.h)("div", {
                ref: a,
                class: "q-expansion-item__toggle-focus q-icon q-focus-helper q-focus-helper--rounded",
                tabindex: -1
            }))), (0, $fVLUl.h)($848b1ce88e755b32$export$9579d29612d4e773, w, ()=>H);
        }
        function x() {
            let w;
            return t.header !== void 0 ? w = [].concat(t.header(g.value)) : (w = [
                (0, $fVLUl.h)($848b1ce88e755b32$export$9579d29612d4e773, ()=>[
                        (0, $fVLUl.h)($848b1ce88e755b32$export$17cb5eb1f3204256, {
                            lines: e.labelLines
                        }, ()=>e.label || ""),
                        e.caption ? (0, $fVLUl.h)($848b1ce88e755b32$export$17cb5eb1f3204256, {
                            lines: e.captionLines,
                            caption: !0
                        }, ()=>e.caption) : null
                    ])
            ], e.icon && w[e.switchToggleSide === !0 ? "push" : "unshift"]((0, $fVLUl.h)($848b1ce88e755b32$export$9579d29612d4e773, {
                side: e.switchToggleSide === !0,
                avatar: e.switchToggleSide !== !0
            }, ()=>(0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                    name: e.icon
                })))), e.disable !== !0 && e.hideExpandIcon !== !0 && w[e.switchToggleSide === !0 ? "unshift" : "push"](q()), w;
        }
        function k() {
            let w = {
                ref: "item",
                style: e.headerStyle,
                class: e.headerClass,
                dark: n.value,
                disable: e.disable,
                dense: e.dense,
                insetLevel: e.headerInsetLevel
            };
            return C.value === !0 && (w.clickable = !0, w.onClick = P, Object.assign(w, y.value === !0 ? p.value : S.value)), (0, $fVLUl.h)($848b1ce88e755b32$export$adf75769807ad87e, w, x);
        }
        function j() {
            return (0, $fVLUl.withDirectives)((0, $fVLUl.h)("div", {
                key: "e-content",
                class: "q-expansion-item__content relative-position",
                style: m.value,
                id: l.value
            }, $848b1ce88e755b32$var$J(t.default)), [
                [
                    (0, $24349.vShow),
                    i.value
                ]
            ]);
        }
        function Q() {
            let w = [
                k(),
                (0, $fVLUl.h)($848b1ce88e755b32$export$1712cdc175d4649d, {
                    duration: e.duration,
                    onShow: E,
                    onHide: A
                }, j)
            ];
            return e.expandSeparator === !0 && w.push((0, $fVLUl.h)($848b1ce88e755b32$export$a3fe6e564278fbe9, {
                class: "q-expansion-item__border q-expansion-item__border--top absolute-top",
                dark: n.value
            }), (0, $fVLUl.h)($848b1ce88e755b32$export$a3fe6e564278fbe9, {
                class: "q-expansion-item__border q-expansion-item__border--bottom absolute-bottom",
                dark: n.value
            })), w;
        }
        return e.group !== void 0 && B(), (0, $fVLUl.onBeforeUnmount)(()=>{
            f !== void 0 && f();
        }), ()=>(0, $fVLUl.h)("div", {
                class: d.value
            }, [
                (0, $fVLUl.h)("div", {
                    class: "q-expansion-item__container relative-position"
                }, Q())
            ]);
    }
});
var $848b1ce88e755b32$var$p_ = [
    "top",
    "right",
    "bottom",
    "left"
], $848b1ce88e755b32$var$Mu = {
    type: {
        type: String,
        default: "a"
    },
    outline: Boolean,
    push: Boolean,
    flat: Boolean,
    unelevated: Boolean,
    color: String,
    textColor: String,
    glossy: Boolean,
    square: Boolean,
    padding: String,
    label: {
        type: [
            String,
            Number
        ],
        default: ""
    },
    labelPosition: {
        type: String,
        default: "right",
        validator: (e)=>$848b1ce88e755b32$var$p_.includes(e)
    },
    externalLabel: Boolean,
    hideLabel: {
        type: Boolean
    },
    labelClass: [
        Array,
        String,
        Object
    ],
    labelStyle: [
        Array,
        String,
        Object
    ],
    disable: Boolean,
    tabindex: [
        Number,
        String
    ]
};
function $848b1ce88e755b32$var$Ru(e, t) {
    return {
        formClass: (0, $eayOh.computed)(()=>`q-fab--form-${e.square === !0 ? "square" : "rounded"}`),
        stacked: (0, $eayOh.computed)(()=>e.externalLabel === !1 && [
                "top",
                "bottom"
            ].includes(e.labelPosition)),
        labelProps: (0, $eayOh.computed)(()=>{
            if (e.externalLabel === !0) {
                let o = e.hideLabel === null ? t.value === !1 : e.hideLabel;
                return {
                    action: "push",
                    data: {
                        class: [
                            e.labelClass,
                            `q-fab__label q-tooltip--style q-fab__label--external q-fab__label--external-${e.labelPosition}` + (o === !0 ? " q-fab__label--external-hidden" : "")
                        ],
                        style: e.labelStyle
                    }
                };
            }
            return {
                action: [
                    "left",
                    "top"
                ].includes(e.labelPosition) ? "unshift" : "push",
                data: {
                    class: [
                        e.labelClass,
                        `q-fab__label q-fab__label--internal q-fab__label--internal-${e.labelPosition}` + (e.hideLabel === !0 ? " q-fab__label--internal-hidden" : "")
                    ],
                    style: e.labelStyle
                }
            };
        })
    };
}
var $848b1ce88e755b32$var$S_ = [
    "up",
    "right",
    "down",
    "left"
], $848b1ce88e755b32$var$x_ = [
    "left",
    "center",
    "right"
], $848b1ce88e755b32$export$feca39a40ec06c6e = $848b1ce88e755b32$var$R({
    name: "QFab",
    props: {
        ...$848b1ce88e755b32$var$Mu,
        ...$848b1ce88e755b32$var$Ao,
        icon: String,
        activeIcon: String,
        hideIcon: Boolean,
        hideLabel: {
            default: null
        },
        direction: {
            type: String,
            default: "right",
            validator: (e)=>$848b1ce88e755b32$var$S_.includes(e)
        },
        persistent: Boolean,
        verticalActionsAlign: {
            type: String,
            default: "center",
            validator: (e)=>$848b1ce88e755b32$var$x_.includes(e)
        }
    },
    emits: $848b1ce88e755b32$var$$o,
    setup (e, { slots: t }) {
        let o = (0, $eayOh.ref)(null), r = (0, $eayOh.ref)(e.modelValue === !0), n = $848b1ce88e755b32$export$f680877a34711e37(), { proxy: { $q: i } } = (0, $fVLUl.getCurrentInstance)(), { formClass: a, labelProps: l } = $848b1ce88e755b32$var$Ru(e, r), s = (0, $eayOh.computed)(()=>e.persistent !== !0), { hide: c, toggle: u } = $848b1ce88e755b32$var$Eo({
            showing: r,
            hideOnRouteChange: s
        }), v = (0, $eayOh.computed)(()=>({
                opened: r.value
            })), f = (0, $eayOh.computed)(()=>`q-fab z-fab row inline justify-center q-fab--align-${e.verticalActionsAlign} ${a.value}` + (r.value === !0 ? " q-fab--opened" : " q-fab--closed")), d = (0, $eayOh.computed)(()=>`q-fab__actions flex no-wrap inline q-fab__actions--${e.direction} q-fab__actions--${r.value === !0 ? "opened" : "closed"}`), m = (0, $eayOh.computed)(()=>{
            let b = {
                id: n.value,
                role: "menu"
            };
            return r.value !== !0 && (b["aria-hidden"] = "true"), b;
        }), y = (0, $eayOh.computed)(()=>`q-fab__icon-holder  q-fab__icon-holder--${r.value === !0 ? "opened" : "closed"}`);
        function p(b, h) {
            let g = t[b], S = `q-fab__${b} absolute-full`;
            return g === void 0 ? (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                class: S,
                name: e[h] || i.iconSet.fab[h]
            }) : (0, $fVLUl.h)("div", {
                class: S
            }, g(v.value));
        }
        function C() {
            let b = [];
            return e.hideIcon !== !0 && b.push((0, $fVLUl.h)("div", {
                class: y.value
            }, [
                p("icon", "icon"),
                p("active-icon", "activeIcon")
            ])), (e.label !== "" || t.label !== void 0) && b[l.value.action]((0, $fVLUl.h)("div", l.value.data, t.label !== void 0 ? t.label(v.value) : [
                e.label
            ])), $848b1ce88e755b32$var$Ke(t.tooltip, b);
        }
        return (0, $fVLUl.provide)($848b1ce88e755b32$var$ql, {
            showing: r,
            onChildClick (b) {
                c(b), o.value !== null && o.value.$el.focus();
            }
        }), ()=>(0, $fVLUl.h)("div", {
                class: f.value
            }, [
                (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                    ref: o,
                    class: a.value,
                    ...e,
                    noWrap: !0,
                    stack: e.stacked,
                    align: void 0,
                    icon: void 0,
                    label: void 0,
                    noCaps: !0,
                    fab: !0,
                    "aria-expanded": r.value === !0 ? "true" : "false",
                    "aria-haspopup": "true",
                    "aria-controls": n.value,
                    onClick: u
                }, C),
                (0, $fVLUl.h)("div", {
                    class: d.value,
                    ...m.value
                }, $848b1ce88e755b32$var$J(t.default))
            ]);
    }
});
var $848b1ce88e755b32$var$qv = {
    start: "self-end",
    center: "self-center",
    end: "self-start"
}, $848b1ce88e755b32$var$w_ = Object.keys($848b1ce88e755b32$var$qv), $848b1ce88e755b32$export$a1eb3675933e8b79 = $848b1ce88e755b32$var$R({
    name: "QFabAction",
    props: {
        ...$848b1ce88e755b32$var$Mu,
        icon: {
            type: String,
            default: ""
        },
        anchor: {
            type: String,
            validator: (e)=>$848b1ce88e755b32$var$w_.includes(e)
        },
        to: [
            String,
            Object
        ],
        replace: Boolean
    },
    emits: [
        "click"
    ],
    setup (e, { slots: t, emit: o }) {
        let r = (0, $fVLUl.inject)($848b1ce88e755b32$var$ql, ()=>({
                showing: {
                    value: !0
                },
                onChildClick: $848b1ce88e755b32$export$8793edee2d425525
            })), { formClass: n, labelProps: i } = $848b1ce88e755b32$var$Ru(e, r.showing), a = (0, $eayOh.computed)(()=>{
            let v = $848b1ce88e755b32$var$qv[e.anchor];
            return n.value + (v !== void 0 ? ` ${v}` : "");
        }), l = (0, $eayOh.computed)(()=>e.disable === !0 || r.showing.value !== !0);
        function s(v) {
            r.onChildClick(v), o("click", v);
        }
        function c() {
            let v = [];
            return t.icon !== void 0 ? v.push(t.icon()) : e.icon !== "" && v.push((0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                name: e.icon
            })), (e.label !== "" || t.label !== void 0) && v[i.value.action]((0, $fVLUl.h)("div", i.value.data, t.label !== void 0 ? t.label() : [
                e.label
            ])), $848b1ce88e755b32$var$Ke(t.default, v);
        }
        let u = (0, $fVLUl.getCurrentInstance)();
        return Object.assign(u.proxy, {
            click: s
        }), ()=>(0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                class: a.value,
                ...e,
                noWrap: !0,
                stack: e.stacked,
                icon: void 0,
                label: void 0,
                noCaps: !0,
                fabMini: !0,
                disable: l.value,
                onClick: s
            }, c);
    }
});
function $848b1ce88e755b32$export$78d4b0ea29932732({ validate: e, resetValidation: t, requiresQForm: o }) {
    let r = (0, $fVLUl.inject)($848b1ce88e755b32$var$Rn, !1);
    if (r !== !1) {
        let { props: n, proxy: i } = (0, $fVLUl.getCurrentInstance)();
        Object.assign(i, {
            validate: e,
            resetValidation: t
        }), (0, $eayOh.watch)(()=>n.disable, (a)=>{
            a === !0 ? (typeof t == "function" && t(), r.unbindComponent(i)) : r.bindComponent(i);
        }), (0, $fVLUl.onMounted)(()=>{
            n.disable !== !0 && r.bindComponent(i);
        }), (0, $fVLUl.onBeforeUnmount)(()=>{
            n.disable !== !0 && r.unbindComponent(i);
        });
    } else o === !0 && console.error("Parent QForm not found on useFormChild()!");
}
var $848b1ce88e755b32$var$$_ = [
    !0,
    !1,
    "ondemand"
], $848b1ce88e755b32$var$Mv = {
    modelValue: {},
    error: {
        type: Boolean,
        default: null
    },
    errorMessage: String,
    noErrorIcon: Boolean,
    rules: Array,
    reactiveRules: Boolean,
    lazyRules: {
        type: [
            Boolean,
            String
        ],
        default: !1,
        validator: (e)=>$848b1ce88e755b32$var$$_.includes(e)
    }
};
function $848b1ce88e755b32$var$Rv(e, t) {
    let { props: o, proxy: r } = (0, $fVLUl.getCurrentInstance)(), n = (0, $eayOh.ref)(!1), i = (0, $eayOh.ref)(null), a = (0, $eayOh.ref)(!1);
    $848b1ce88e755b32$export$78d4b0ea29932732({
        validate: y,
        resetValidation: m
    });
    let l = 0, s, c = (0, $eayOh.computed)(()=>o.rules !== void 0 && o.rules !== null && o.rules.length !== 0), u = (0, $eayOh.computed)(()=>o.disable !== !0 && c.value === !0 && t.value === !1), v = (0, $eayOh.computed)(()=>o.error === !0 || n.value === !0), f = (0, $eayOh.computed)(()=>typeof o.errorMessage == "string" && o.errorMessage.length !== 0 ? o.errorMessage : i.value);
    (0, $eayOh.watch)(()=>o.modelValue, ()=>{
        a.value = !0, u.value === !0 && o.lazyRules === !1 && p();
    });
    function d() {
        o.lazyRules !== "ondemand" && u.value === !0 && a.value === !0 && p();
    }
    (0, $eayOh.watch)(()=>o.reactiveRules, (C)=>{
        C === !0 ? s === void 0 && (s = (0, $eayOh.watch)(()=>o.rules, d, {
            immediate: !0,
            deep: !0
        })) : s !== void 0 && (s(), s = void 0);
    }, {
        immediate: !0
    }), (0, $eayOh.watch)(()=>o.lazyRules, d), (0, $eayOh.watch)(e, (C)=>{
        C === !0 ? a.value = !0 : u.value === !0 && o.lazyRules !== "ondemand" && p();
    });
    function m() {
        l++, t.value = !1, a.value = !1, n.value = !1, i.value = null, p.cancel();
    }
    function y(C = o.modelValue) {
        if (o.disable === !0 || c.value === !1) return !0;
        let b = ++l, h = t.value !== !0 ? ()=>{
            a.value = !0;
        } : ()=>{}, g = (P, $)=>{
            P === !0 && h(), n.value = P, i.value = $ || null, t.value = !1;
        }, S = [];
        for(let P = 0; P < o.rules.length; P++){
            let $ = o.rules[P], L;
            if (typeof $ == "function" ? L = $(C, $848b1ce88e755b32$var$Dr) : typeof $ == "string" && $848b1ce88e755b32$var$Dr[$] !== void 0 && (L = $848b1ce88e755b32$var$Dr[$](C)), L === !1 || typeof L == "string") return g(!0, L), !1;
            L !== !0 && L !== void 0 && S.push(L);
        }
        return S.length === 0 ? (g(!1), !0) : (t.value = !0, Promise.all(S).then((P)=>{
            if (P === void 0 || Array.isArray(P) === !1 || P.length === 0) return b === l && g(!1), !0;
            let $ = P.find((L)=>L === !1 || typeof L == "string");
            return b === l && g($ !== void 0, $), $ === void 0;
        }, (P)=>(b === l && (console.error(P), g(!0)), !1)));
    }
    let p = $848b1ce88e755b32$export$61fc7d43ac8f84b0(y, 0);
    return (0, $fVLUl.onBeforeUnmount)(()=>{
        s !== void 0 && s(), p.cancel();
    }), Object.assign(r, {
        resetValidation: m,
        validate: y
    }), $848b1ce88e755b32$var$it(r, "hasError", ()=>v.value), {
        isDirtyModel: a,
        hasRules: c,
        hasError: v,
        errorMessage: f,
        validate: y,
        resetValidation: m
    };
}
function $848b1ce88e755b32$var$pn(e) {
    return e != null && ("" + e).length !== 0;
}
var $848b1ce88e755b32$var$zn = {
    ...$848b1ce88e755b32$var$he,
    ...$848b1ce88e755b32$var$Mv,
    label: String,
    stackLabel: Boolean,
    hint: String,
    hideHint: Boolean,
    prefix: String,
    suffix: String,
    labelColor: String,
    color: String,
    bgColor: String,
    filled: Boolean,
    outlined: Boolean,
    borderless: Boolean,
    standout: [
        Boolean,
        String
    ],
    square: Boolean,
    loading: Boolean,
    labelSlot: Boolean,
    bottomSlots: Boolean,
    hideBottomSpace: Boolean,
    rounded: Boolean,
    dense: Boolean,
    itemAligned: Boolean,
    counter: Boolean,
    clearable: Boolean,
    clearIcon: String,
    disable: Boolean,
    readonly: Boolean,
    autofocus: Boolean,
    for: String,
    maxlength: [
        Number,
        String
    ]
}, $848b1ce88e755b32$var$cr = [
    "update:modelValue",
    "clear",
    "focus",
    "blur",
    "popupShow",
    "popupHide"
];
function $848b1ce88e755b32$var$dr({ requiredForAttr: e = !0, tagProp: t } = {}) {
    let { props: o, proxy: r } = (0, $fVLUl.getCurrentInstance)(), n = $848b1ce88e755b32$var$pe(o, r.$q), i = $848b1ce88e755b32$export$f680877a34711e37({
        required: e,
        getValue: ()=>o.for
    });
    return {
        requiredForAttr: e,
        tag: t === !0 ? (0, $eayOh.computed)(()=>o.tag) : {
            value: "label"
        },
        isDark: n,
        editable: (0, $eayOh.computed)(()=>o.disable !== !0 && o.readonly !== !0),
        innerLoading: (0, $eayOh.ref)(!1),
        focused: (0, $eayOh.ref)(!1),
        hasPopupOpen: !1,
        splitAttrs: $848b1ce88e755b32$export$6d16226782fe5bdf(),
        targetUid: i,
        rootRef: (0, $eayOh.ref)(null),
        targetRef: (0, $eayOh.ref)(null),
        controlRef: (0, $eayOh.ref)(null)
    };
}
function $848b1ce88e755b32$var$fr(e) {
    let { props: t, emit: o, slots: r, attrs: n, proxy: i } = (0, $fVLUl.getCurrentInstance)(), { $q: a } = i, l = null;
    e.hasValue === void 0 && (e.hasValue = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$pn(t.modelValue))), e.emitValue === void 0 && (e.emitValue = (w)=>{
        o("update:modelValue", w);
    }), e.controlEvents === void 0 && (e.controlEvents = {
        onFocusin: E,
        onFocusout: A
    }), Object.assign(e, {
        clearValue: B,
        onControlFocusin: E,
        onControlFocusout: A,
        focus: $
    }), e.computedCounter === void 0 && (e.computedCounter = (0, $eayOh.computed)(()=>{
        if (t.counter !== !1) {
            let w = typeof t.modelValue == "string" || typeof t.modelValue == "number" ? ("" + t.modelValue).length : Array.isArray(t.modelValue) === !0 ? t.modelValue.length : 0, H = t.maxlength !== void 0 ? t.maxlength : t.maxValues;
            return w + (H !== void 0 ? " / " + H : "");
        }
    }));
    let { isDirtyModel: s, hasRules: c, hasError: u, errorMessage: v, resetValidation: f } = $848b1ce88e755b32$var$Rv(e.focused, e.innerLoading), d = e.floatingLabel !== void 0 ? (0, $eayOh.computed)(()=>t.stackLabel === !0 || e.focused.value === !0 || e.floatingLabel.value === !0) : (0, $eayOh.computed)(()=>t.stackLabel === !0 || e.focused.value === !0 || e.hasValue.value === !0), m = (0, $eayOh.computed)(()=>t.bottomSlots === !0 || t.hint !== void 0 || c.value === !0 || t.counter === !0 || t.error !== null), y = (0, $eayOh.computed)(()=>t.filled === !0 ? "filled" : t.outlined === !0 ? "outlined" : t.borderless === !0 ? "borderless" : t.standout ? "standout" : "standard"), p = (0, $eayOh.computed)(()=>`q-field row no-wrap items-start q-field--${y.value}` + (e.fieldClass !== void 0 ? ` ${e.fieldClass.value}` : "") + (t.rounded === !0 ? " q-field--rounded" : "") + (t.square === !0 ? " q-field--square" : "") + (d.value === !0 ? " q-field--float" : "") + (b.value === !0 ? " q-field--labeled" : "") + (t.dense === !0 ? " q-field--dense" : "") + (t.itemAligned === !0 ? " q-field--item-aligned q-item-type" : "") + (e.isDark.value === !0 ? " q-field--dark" : "") + (e.getControl === void 0 ? " q-field--auto-height" : "") + (e.focused.value === !0 ? " q-field--focused" : "") + (u.value === !0 ? " q-field--error" : "") + (u.value === !0 || e.focused.value === !0 ? " q-field--highlighted" : "") + (t.hideBottomSpace !== !0 && m.value === !0 ? " q-field--with-bottom" : "") + (t.disable === !0 ? " q-field--disabled" : t.readonly === !0 ? " q-field--readonly" : "")), C = (0, $eayOh.computed)(()=>"q-field__control relative-position row no-wrap" + (t.bgColor !== void 0 ? ` bg-${t.bgColor}` : "") + (u.value === !0 ? " text-negative" : typeof t.standout == "string" && t.standout.length !== 0 && e.focused.value === !0 ? ` ${t.standout}` : t.color !== void 0 ? ` text-${t.color}` : "")), b = (0, $eayOh.computed)(()=>t.labelSlot === !0 || t.label !== void 0), h = (0, $eayOh.computed)(()=>"q-field__label no-pointer-events absolute ellipsis" + (t.labelColor !== void 0 && u.value !== !0 ? ` text-${t.labelColor}` : "")), g = (0, $eayOh.computed)(()=>({
            id: e.targetUid.value,
            editable: e.editable.value,
            focused: e.focused.value,
            floatingLabel: d.value,
            modelValue: t.modelValue,
            emitValue: e.emitValue
        })), S = (0, $eayOh.computed)(()=>{
        let w = {};
        return e.targetUid.value && (w.for = e.targetUid.value), t.disable === !0 && (w["aria-disabled"] = "true"), w;
    });
    function P() {
        let w = document.activeElement, H = e.targetRef !== void 0 && e.targetRef.value;
        H && (w === null || w.id !== e.targetUid.value) && (H.hasAttribute("tabindex") === !0 || (H = H.querySelector("[tabindex]")), H && H !== w && H.focus({
            preventScroll: !0
        }));
    }
    function $() {
        $848b1ce88e755b32$var$Bo(P);
    }
    function L() {
        $848b1ce88e755b32$var$If(P);
        let w = document.activeElement;
        w !== null && e.rootRef.value.contains(w) && w.blur();
    }
    function E(w) {
        l !== null && (clearTimeout(l), l = null), e.editable.value === !0 && e.focused.value === !1 && (e.focused.value = !0, o("focus", w));
    }
    function A(w, H) {
        l !== null && clearTimeout(l), l = setTimeout(()=>{
            l = null, !(document.hasFocus() === !0 && (e.hasPopupOpen === !0 || e.controlRef === void 0 || e.controlRef.value === null || e.controlRef.value.contains(document.activeElement) !== !1)) && (e.focused.value === !0 && (e.focused.value = !1, o("blur", w)), H !== void 0 && H());
        });
    }
    function B(w) {
        $848b1ce88e755b32$var$Se(w), a.platform.is.mobile !== !0 ? (e.targetRef !== void 0 && e.targetRef.value || e.rootRef.value).focus() : e.rootRef.value.contains(document.activeElement) === !0 && document.activeElement.blur(), t.type === "file" && (e.inputRef.value.value = null), o("update:modelValue", null), o("clear", t.modelValue), (0, $fVLUl.nextTick)(()=>{
            let H = s.value;
            f(), s.value = H;
        });
    }
    function q() {
        let w = [];
        return r.prepend !== void 0 && w.push((0, $fVLUl.h)("div", {
            class: "q-field__prepend q-field__marginal row no-wrap items-center",
            key: "prepend",
            onClick: $848b1ce88e755b32$var$ut
        }, r.prepend())), w.push((0, $fVLUl.h)("div", {
            class: "q-field__control-container col relative-position row no-wrap q-anchor--skip"
        }, x())), u.value === !0 && t.noErrorIcon === !1 && w.push(j("error", [
            (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                name: a.iconSet.field.error,
                color: "negative"
            })
        ])), t.loading === !0 || e.innerLoading.value === !0 ? w.push(j("inner-loading-append", r.loading !== void 0 ? r.loading() : [
            (0, $fVLUl.h)($848b1ce88e755b32$export$7418ab329b11fed0, {
                color: t.color
            })
        ])) : t.clearable === !0 && e.hasValue.value === !0 && e.editable.value === !0 && w.push(j("inner-clearable-append", [
            (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                class: "q-field__focusable-action",
                tag: "button",
                name: t.clearIcon || a.iconSet.field.clear,
                tabindex: 0,
                type: "button",
                "aria-hidden": null,
                role: null,
                onClick: B
            })
        ])), r.append !== void 0 && w.push((0, $fVLUl.h)("div", {
            class: "q-field__append q-field__marginal row no-wrap items-center",
            key: "append",
            onClick: $848b1ce88e755b32$var$ut
        }, r.append())), e.getInnerAppend !== void 0 && w.push(j("inner-append", e.getInnerAppend())), e.getControlChild !== void 0 && w.push(e.getControlChild()), w;
    }
    function x() {
        let w = [];
        return t.prefix !== void 0 && t.prefix !== null && w.push((0, $fVLUl.h)("div", {
            class: "q-field__prefix no-pointer-events row items-center"
        }, t.prefix)), e.getShadowControl !== void 0 && e.hasShadow.value === !0 && w.push(e.getShadowControl()), e.getControl !== void 0 ? w.push(e.getControl()) : r.rawControl !== void 0 ? w.push(r.rawControl()) : r.control !== void 0 && w.push((0, $fVLUl.h)("div", {
            ref: e.targetRef,
            class: "q-field__native row",
            tabindex: -1,
            ...e.splitAttrs.attributes.value,
            "data-autofocus": t.autofocus === !0 || void 0
        }, r.control(g.value))), b.value === !0 && w.push((0, $fVLUl.h)("div", {
            class: h.value
        }, $848b1ce88e755b32$var$J(r.label, t.label))), t.suffix !== void 0 && t.suffix !== null && w.push((0, $fVLUl.h)("div", {
            class: "q-field__suffix no-pointer-events row items-center"
        }, t.suffix)), w.concat($848b1ce88e755b32$var$J(r.default));
    }
    function k() {
        let w, H;
        u.value === !0 ? v.value !== null ? (w = [
            (0, $fVLUl.h)("div", {
                role: "alert"
            }, v.value)
        ], H = `q--slot-error-${v.value}`) : (w = $848b1ce88e755b32$var$J(r.error), H = "q--slot-error") : (t.hideHint !== !0 || e.focused.value === !0) && (t.hint !== void 0 ? (w = [
            (0, $fVLUl.h)("div", t.hint)
        ], H = `q--slot-hint-${t.hint}`) : (w = $848b1ce88e755b32$var$J(r.hint), H = "q--slot-hint"));
        let W = t.counter === !0 || r.counter !== void 0;
        if (t.hideBottomSpace === !0 && W === !1 && w === void 0) return;
        let ie = (0, $fVLUl.h)("div", {
            key: H,
            class: "q-field__messages col"
        }, w);
        return (0, $fVLUl.h)("div", {
            class: "q-field__bottom row items-start q-field__bottom--" + (t.hideBottomSpace !== !0 ? "animated" : "stale"),
            onClick: $848b1ce88e755b32$var$ut
        }, [
            t.hideBottomSpace === !0 ? ie : (0, $fVLUl.h)((0, $24349.Transition), {
                name: "q-transition--field-message"
            }, ()=>ie),
            W === !0 ? (0, $fVLUl.h)("div", {
                class: "q-field__counter"
            }, r.counter !== void 0 ? r.counter() : e.computedCounter.value) : null
        ]);
    }
    function j(w, H) {
        return H === null ? null : (0, $fVLUl.h)("div", {
            key: w,
            class: "q-field__append q-field__marginal row no-wrap items-center q-anchor--skip"
        }, H);
    }
    let Q = !1;
    return (0, $fVLUl.onDeactivated)(()=>{
        Q = !0;
    }), (0, $fVLUl.onActivated)(()=>{
        Q === !0 && t.autofocus === !0 && i.focus();
    }), t.autofocus === !0 && (0, $fVLUl.onMounted)(()=>{
        i.focus();
    }), (0, $fVLUl.onBeforeUnmount)(()=>{
        l !== null && clearTimeout(l);
    }), Object.assign(i, {
        focus: $,
        blur: L
    }), function() {
        let H = e.getControl === void 0 && r.control === void 0 ? {
            ...e.splitAttrs.attributes.value,
            "data-autofocus": t.autofocus === !0 || void 0,
            ...S.value
        } : S.value;
        return (0, $fVLUl.h)(e.tag.value, {
            ref: e.rootRef,
            class: [
                p.value,
                n.class
            ],
            style: n.style,
            ...H
        }, [
            r.before !== void 0 ? (0, $fVLUl.h)("div", {
                class: "q-field__before q-field__marginal row no-wrap items-center",
                onClick: $848b1ce88e755b32$var$ut
            }, r.before()) : null,
            (0, $fVLUl.h)("div", {
                class: "q-field__inner relative-position col self-stretch"
            }, [
                (0, $fVLUl.h)("div", {
                    ref: e.controlRef,
                    class: C.value,
                    tabindex: -1,
                    ...e.controlEvents
                }, q()),
                m.value === !0 ? k() : null
            ]),
            r.after !== void 0 ? (0, $fVLUl.h)("div", {
                class: "q-field__after q-field__marginal row no-wrap items-center",
                onClick: $848b1ce88e755b32$var$ut
            }, r.after()) : null
        ]);
    };
}
var $848b1ce88e755b32$export$9e1d68206b908513 = $848b1ce88e755b32$var$R({
    name: "QField",
    inheritAttrs: !1,
    props: {
        ...$848b1ce88e755b32$var$zn,
        tag: {
            type: String,
            default: "label"
        }
    },
    emits: $848b1ce88e755b32$var$cr,
    setup () {
        return $848b1ce88e755b32$var$fr($848b1ce88e755b32$var$dr({
            requiredForAttr: !1,
            tagProp: !0
        }));
    }
});
function $848b1ce88e755b32$var$na(e, t, o, r) {
    let n = [];
    return e.forEach((i)=>{
        r(i) === !0 ? n.push(i) : t.push({
            failedPropValidation: o,
            file: i
        });
    }), n;
}
function $848b1ce88e755b32$var$$u(e) {
    e && e.dataTransfer && (e.dataTransfer.dropEffect = "copy"), $848b1ce88e755b32$var$Se(e);
}
var $848b1ce88e755b32$var$Eu = {
    multiple: Boolean,
    accept: String,
    capture: String,
    maxFileSize: [
        Number,
        String
    ],
    maxTotalSize: [
        Number,
        String
    ],
    maxFiles: [
        Number,
        String
    ],
    filter: Function
}, $848b1ce88e755b32$var$Bu = [
    "rejected"
];
function $848b1ce88e755b32$var$Lu({ editable: e, dnd: t, getFileInput: o, addFilesToQueue: r }) {
    let { props: n, emit: i, proxy: a } = (0, $fVLUl.getCurrentInstance)(), l = (0, $eayOh.ref)(null), s = (0, $eayOh.computed)(()=>n.accept !== void 0 ? n.accept.split(",").map((b)=>(b = b.trim(), b === "*" ? "*/" : (b.endsWith("/*") && (b = b.slice(0, b.length - 1)), b.toUpperCase()))) : null), c = (0, $eayOh.computed)(()=>parseInt(n.maxFiles, 10)), u = (0, $eayOh.computed)(()=>parseInt(n.maxTotalSize, 10));
    function v(b) {
        if (e.value) {
            if (b !== Object(b) && (b = {
                target: null
            }), b.target !== null && b.target.matches('input[type="file"]') === !0) b.clientX === 0 && b.clientY === 0 && $848b1ce88e755b32$var$tt(b);
            else {
                let h = o();
                h && h !== b.target && h.click(b);
            }
        }
    }
    function f(b) {
        e.value && b && r(null, b);
    }
    function d(b, h, g, S) {
        let P = Array.from(h || b.target.files), $ = [], L = ()=>{
            $.length !== 0 && i("rejected", $);
        };
        if (n.accept !== void 0 && s.value.indexOf("*/") === -1 && (P = $848b1ce88e755b32$var$na(P, $, "accept", (E)=>s.value.some((A)=>E.type.toUpperCase().startsWith(A) || E.name.toUpperCase().endsWith(A))), P.length === 0)) return L();
        if (n.maxFileSize !== void 0) {
            let E = parseInt(n.maxFileSize, 10);
            if (P = $848b1ce88e755b32$var$na(P, $, "max-file-size", (A)=>A.size <= E), P.length === 0) return L();
        }
        if (n.multiple !== !0 && P.length !== 0 && (P = [
            P[0]
        ]), P.forEach((E)=>{
            E.__key = E.webkitRelativePath + E.lastModified + E.name + E.size;
        }), S === !0) {
            let E = g.map((A)=>A.__key);
            P = $848b1ce88e755b32$var$na(P, $, "duplicate", (A)=>E.includes(A.__key) === !1);
        }
        if (P.length === 0) return L();
        if (n.maxTotalSize !== void 0) {
            let E = S === !0 ? g.reduce((A, B)=>A + B.size, 0) : 0;
            if (P = $848b1ce88e755b32$var$na(P, $, "max-total-size", (A)=>(E += A.size, E <= u.value)), P.length === 0) return L();
        }
        if (typeof n.filter == "function") {
            let E = n.filter(P);
            P = $848b1ce88e755b32$var$na(P, $, "filter", (A)=>E.includes(A));
        }
        if (n.maxFiles !== void 0) {
            let E = S === !0 ? g.length : 0;
            if (P = $848b1ce88e755b32$var$na(P, $, "max-files", ()=>(E++, E <= c.value)), P.length === 0) return L();
        }
        if (L(), P.length !== 0) return P;
    }
    function m(b) {
        $848b1ce88e755b32$var$$u(b), t.value !== !0 && (t.value = !0);
    }
    function y(b) {
        $848b1ce88e755b32$var$Se(b), (b.relatedTarget !== null || $848b1ce88e755b32$var$Ce.is.safari !== !0 ? b.relatedTarget !== l.value : document.elementsFromPoint(b.clientX, b.clientY).includes(l.value) === !1) === !0 && (t.value = !1);
    }
    function p(b) {
        $848b1ce88e755b32$var$$u(b);
        let h = b.dataTransfer.files;
        h.length !== 0 && r(null, h), t.value = !1;
    }
    function C(b) {
        if (t.value === !0) return (0, $fVLUl.h)("div", {
            ref: l,
            class: `q-${b}__dnd absolute-full`,
            onDragenter: $848b1ce88e755b32$var$$u,
            onDragover: $848b1ce88e755b32$var$$u,
            onDragleave: y,
            onDrop: p
        });
    }
    return Object.assign(a, {
        pickFiles: v,
        addFiles: f
    }), {
        pickFiles: v,
        addFiles: f,
        onDragover: m,
        onDragleave: y,
        processFiles: d,
        getDndNode: C,
        maxFilesNumber: c,
        maxTotalSizeNumber: u
    };
}
function $848b1ce88e755b32$var$Fu(e, t) {
    function o() {
        let r = e.modelValue;
        try {
            let n = "DataTransfer" in window ? new DataTransfer : "ClipboardEvent" in window ? new ClipboardEvent("").clipboardData : void 0;
            return Object(r) === r && ("length" in r ? Array.from(r) : [
                r
            ]).forEach((i)=>{
                n.items.add(i);
            }), {
                files: n.files
            };
        } catch  {
            return {
                files: void 0
            };
        }
    }
    return t === !0 ? (0, $eayOh.computed)(()=>{
        if (e.type === "file") return o();
    }) : (0, $eayOh.computed)(o);
}
var $848b1ce88e755b32$export$f9762928c84dca74 = $848b1ce88e755b32$var$R({
    name: "QFile",
    inheritAttrs: !1,
    props: {
        ...$848b1ce88e755b32$var$zn,
        ...$848b1ce88e755b32$var$_t,
        ...$848b1ce88e755b32$var$Eu,
        modelValue: [
            File,
            FileList,
            Array
        ],
        append: Boolean,
        useChips: Boolean,
        displayValue: [
            String,
            Number
        ],
        tabindex: {
            type: [
                String,
                Number
            ],
            default: 0
        },
        counterLabel: Function,
        inputClass: [
            Array,
            String,
            Object
        ],
        inputStyle: [
            Array,
            String,
            Object
        ]
    },
    emits: [
        ...$848b1ce88e755b32$var$cr,
        ...$848b1ce88e755b32$var$Bu
    ],
    setup (e, { slots: t, emit: o, attrs: r }) {
        let { proxy: n } = (0, $fVLUl.getCurrentInstance)(), i = $848b1ce88e755b32$var$dr(), a = (0, $eayOh.ref)(null), l = (0, $eayOh.ref)(!1), s = $848b1ce88e755b32$var$Ai(e), { pickFiles: c, onDragover: u, onDragleave: v, processFiles: f, getDndNode: d } = $848b1ce88e755b32$var$Lu({
            editable: i.editable,
            dnd: l,
            getFileInput: q,
            addFilesToQueue: x
        }), m = $848b1ce88e755b32$var$Fu(e), y = (0, $eayOh.computed)(()=>Object(e.modelValue) === e.modelValue ? "length" in e.modelValue ? Array.from(e.modelValue) : [
                e.modelValue
            ] : []), p = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$pn(y.value)), C = (0, $eayOh.computed)(()=>y.value.map((w)=>w.name).join(", ")), b = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$ri(y.value.reduce((w, H)=>w + H.size, 0))), h = (0, $eayOh.computed)(()=>({
                totalSize: b.value,
                filesNumber: y.value.length,
                maxFiles: e.maxFiles
            })), g = (0, $eayOh.computed)(()=>({
                tabindex: -1,
                type: "file",
                title: "",
                accept: e.accept,
                capture: e.capture,
                name: s.value,
                ...r,
                id: i.targetUid.value,
                disabled: i.editable.value !== !0
            })), S = (0, $eayOh.computed)(()=>"q-file q-field--auto-height" + (l.value === !0 ? " q-file--dnd" : "")), P = (0, $eayOh.computed)(()=>e.multiple === !0 && e.append === !0);
        function $(w) {
            let H = y.value.slice();
            H.splice(w, 1), E(H);
        }
        function L(w) {
            let H = y.value.indexOf(w);
            H !== -1 && $(H);
        }
        function E(w) {
            o("update:modelValue", e.multiple === !0 ? w : w[0]);
        }
        function A(w) {
            w.keyCode === 13 && $848b1ce88e755b32$var$ut(w);
        }
        function B(w) {
            (w.keyCode === 13 || w.keyCode === 32) && c(w);
        }
        function q() {
            return a.value;
        }
        function x(w, H) {
            let W = f(w, H, y.value, P.value), ie = q();
            ie != null && (ie.value = ""), W !== void 0 && ((e.multiple === !0 ? e.modelValue && W.every((V)=>y.value.includes(V)) : e.modelValue === W[0]) || E(P.value === !0 ? y.value.concat(W) : W));
        }
        function k() {
            return [
                (0, $fVLUl.h)("input", {
                    class: [
                        e.inputClass,
                        "q-file__filler"
                    ],
                    style: e.inputStyle
                })
            ];
        }
        function j() {
            if (t.file !== void 0) return y.value.length === 0 ? k() : y.value.map((H, W)=>t.file({
                    index: W,
                    file: H,
                    ref: this
                }));
            if (t.selected !== void 0) return y.value.length === 0 ? k() : t.selected({
                files: y.value,
                ref: this
            });
            if (e.useChips === !0) return y.value.length === 0 ? k() : y.value.map((H, W)=>(0, $fVLUl.h)($848b1ce88e755b32$export$fe8abce8a0a972d6, {
                    key: "file-" + W,
                    removable: i.editable.value,
                    dense: !0,
                    textColor: e.color,
                    tabindex: e.tabindex,
                    onRemove: ()=>{
                        $(W);
                    }
                }, ()=>(0, $fVLUl.h)("span", {
                        class: "ellipsis",
                        textContent: H.name
                    })));
            let w = e.displayValue !== void 0 ? e.displayValue : C.value;
            return w.length !== 0 ? [
                (0, $fVLUl.h)("div", {
                    class: e.inputClass,
                    style: e.inputStyle,
                    textContent: w
                })
            ] : k();
        }
        function Q() {
            let w = {
                ref: a,
                ...g.value,
                ...m.value,
                class: "q-field__input fit absolute-full cursor-pointer",
                onChange: x
            };
            return e.multiple === !0 && (w.multiple = !0), (0, $fVLUl.h)("input", w);
        }
        return Object.assign(i, {
            fieldClass: S,
            emitValue: E,
            hasValue: p,
            inputRef: a,
            innerValue: y,
            floatingLabel: (0, $eayOh.computed)(()=>p.value === !0 || $848b1ce88e755b32$var$pn(e.displayValue)),
            computedCounter: (0, $eayOh.computed)(()=>{
                if (e.counterLabel !== void 0) return e.counterLabel(h.value);
                let w = e.maxFiles;
                return `${y.value.length}${w !== void 0 ? " / " + w : ""} (${b.value})`;
            }),
            getControlChild: ()=>d("file"),
            getControl: ()=>{
                let w = {
                    ref: i.targetRef,
                    class: "q-field__native row items-center cursor-pointer",
                    tabindex: e.tabindex
                };
                return i.editable.value === !0 && Object.assign(w, {
                    onDragover: u,
                    onDragleave: v,
                    onKeydown: A,
                    onKeyup: B
                }), (0, $fVLUl.h)("div", w, [
                    Q()
                ].concat(j()));
            }
        }), Object.assign(n, {
            removeAtIndex: $,
            removeFile: L,
            getNativeElement: ()=>a.value
        }), $848b1ce88e755b32$var$it(n, "nativeEl", ()=>a.value), $848b1ce88e755b32$var$fr(i);
    }
});
var $848b1ce88e755b32$export$bf2298245c72b04b = $848b1ce88e755b32$var$R({
    name: "QFooter",
    props: {
        modelValue: {
            type: Boolean,
            default: !0
        },
        reveal: Boolean,
        bordered: Boolean,
        elevated: Boolean,
        heightHint: {
            type: [
                String,
                Number
            ],
            default: 50
        }
    },
    emits: [
        "reveal",
        "focusin"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: { $q: r } } = (0, $fVLUl.getCurrentInstance)(), n = (0, $fVLUl.inject)($848b1ce88e755b32$var$co, $848b1ce88e755b32$var$Ye);
        if (n === $848b1ce88e755b32$var$Ye) return console.error("QFooter needs to be child of QLayout"), $848b1ce88e755b32$var$Ye;
        let i = (0, $eayOh.ref)(parseInt(e.heightHint, 10)), a = (0, $eayOh.ref)(!0), l = (0, $eayOh.ref)($848b1ce88e755b32$var$bt.value === !0 || n.isContainer.value === !0 ? 0 : window.innerHeight), s = (0, $eayOh.computed)(()=>e.reveal === !0 || n.view.value.indexOf("F") !== -1 || r.platform.is.ios && n.isContainer.value === !0), c = (0, $eayOh.computed)(()=>n.isContainer.value === !0 ? n.containerHeight.value : l.value), u = (0, $eayOh.computed)(()=>{
            if (e.modelValue !== !0) return 0;
            if (s.value === !0) return a.value === !0 ? i.value : 0;
            let S = n.scroll.value.position + c.value + i.value - n.height.value;
            return S > 0 ? S : 0;
        }), v = (0, $eayOh.computed)(()=>e.modelValue !== !0 || s.value === !0 && a.value !== !0), f = (0, $eayOh.computed)(()=>e.modelValue === !0 && v.value === !0 && e.reveal === !0), d = (0, $eayOh.computed)(()=>"q-footer q-layout__section--marginal " + (s.value === !0 ? "fixed" : "absolute") + "-bottom" + (e.bordered === !0 ? " q-footer--bordered" : "") + (v.value === !0 ? " q-footer--hidden" : "") + (e.modelValue !== !0 ? " q-layout--prevent-focus" + (s.value !== !0 ? " hidden" : "") : "")), m = (0, $eayOh.computed)(()=>{
            let S = n.rows.value.bottom, P = {};
            return S[0] === "l" && n.left.space === !0 && (P[r.lang.rtl === !0 ? "right" : "left"] = `${n.left.size}px`), S[2] === "r" && n.right.space === !0 && (P[r.lang.rtl === !0 ? "left" : "right"] = `${n.right.size}px`), P;
        });
        function y(S, P) {
            n.update("footer", S, P);
        }
        function p(S, P) {
            S.value !== P && (S.value = P);
        }
        function C({ height: S }) {
            p(i, S), y("size", S);
        }
        function b() {
            if (e.reveal !== !0) return;
            let { direction: S, position: P, inflectionPoint: $ } = n.scroll.value;
            p(a, S === "up" || P - $ < 100 || n.height.value - c.value - P - i.value < 300);
        }
        function h(S) {
            f.value === !0 && p(a, !0), o("focusin", S);
        }
        (0, $eayOh.watch)(()=>e.modelValue, (S)=>{
            y("space", S), p(a, !0), n.animate();
        }), (0, $eayOh.watch)(u, (S)=>{
            y("offset", S);
        }), (0, $eayOh.watch)(()=>e.reveal, (S)=>{
            S === !1 && p(a, e.modelValue);
        }), (0, $eayOh.watch)(a, (S)=>{
            n.animate(), o("reveal", S);
        }), (0, $eayOh.watch)([
            i,
            n.scroll,
            n.height
        ], b), (0, $eayOh.watch)(()=>r.screen.height, (S)=>{
            n.isContainer.value !== !0 && p(l, S);
        });
        let g = {};
        return n.instances.footer = g, e.modelValue === !0 && y("size", i.value), y("space", e.modelValue), y("offset", u.value), (0, $fVLUl.onBeforeUnmount)(()=>{
            n.instances.footer === g && (n.instances.footer = void 0, y("size", 0), y("offset", 0), y("space", !1));
        }), ()=>{
            let S = $848b1ce88e755b32$var$Ke(t.default, [
                (0, $fVLUl.h)($848b1ce88e755b32$export$614f53fe102a3da7, {
                    debounce: 0,
                    onResize: C
                })
            ]);
            return e.elevated === !0 && S.push((0, $fVLUl.h)("div", {
                class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
            })), (0, $fVLUl.h)("footer", {
                class: d.value,
                style: m.value,
                onFocusin: h
            }, S);
        };
    }
});
var $848b1ce88e755b32$export$1f74a2a6ec5f7e27 = $848b1ce88e755b32$var$R({
    name: "QForm",
    props: {
        autofocus: Boolean,
        noErrorFocus: Boolean,
        noResetFocus: Boolean,
        greedy: Boolean,
        onSubmit: Function
    },
    emits: [
        "reset",
        "validationSuccess",
        "validationError"
    ],
    setup (e, { slots: t, emit: o }) {
        let r = (0, $fVLUl.getCurrentInstance)(), n = (0, $eayOh.ref)(null), i = 0, a = [];
        function l(d) {
            let m = typeof d == "boolean" ? d : e.noErrorFocus !== !0, y = ++i, p = (h, g)=>{
                o("validation" + (h === !0 ? "Success" : "Error"), g);
            }, C = (h)=>{
                let g = h.validate();
                return typeof g.then == "function" ? g.then((S)=>({
                        valid: S,
                        comp: h
                    }), (S)=>({
                        valid: !1,
                        comp: h,
                        err: S
                    })) : Promise.resolve({
                    valid: g,
                    comp: h
                });
            };
            return (e.greedy === !0 ? Promise.all(a.map(C)).then((h)=>h.filter((g)=>g.valid !== !0)) : a.reduce((h, g)=>h.then(()=>C(g).then((S)=>{
                        if (S.valid === !1) return Promise.reject(S);
                    })), Promise.resolve()).catch((h)=>[
                    h
                ])).then((h)=>{
                if (h === void 0 || h.length === 0) return y === i && p(!0), !0;
                if (y === i) {
                    let { comp: g, err: S } = h[0];
                    if (S !== void 0 && console.error(S), p(!1, g), m === !0) {
                        let P = h.find(({ comp: $ })=>typeof $.focus == "function" && $848b1ce88e755b32$var$Jt($.$) === !1);
                        P !== void 0 && P.comp.focus();
                    }
                }
                return !1;
            });
        }
        function s() {
            i++, a.forEach((d)=>{
                typeof d.resetValidation == "function" && d.resetValidation();
            });
        }
        function c(d) {
            d !== void 0 && $848b1ce88e755b32$var$Se(d);
            let m = i + 1;
            l().then((y)=>{
                m === i && y === !0 && (e.onSubmit !== void 0 ? o("submit", d) : d !== void 0 && d.target !== void 0 && typeof d.target.submit == "function" && d.target.submit());
            });
        }
        function u(d) {
            d !== void 0 && $848b1ce88e755b32$var$Se(d), o("reset"), (0, $fVLUl.nextTick)(()=>{
                s(), e.autofocus === !0 && e.noResetFocus !== !0 && v();
            });
        }
        function v() {
            $848b1ce88e755b32$var$Bo(()=>{
                if (n.value === null) return;
                let d = n.value.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || n.value.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || n.value.querySelector("[autofocus], [data-autofocus]") || Array.prototype.find.call(n.value.querySelectorAll("[tabindex]"), (m)=>m.tabIndex !== -1);
                d?.focus({
                    preventScroll: !0
                });
            });
        }
        (0, $fVLUl.provide)($848b1ce88e755b32$var$Rn, {
            bindComponent (d) {
                a.push(d);
            },
            unbindComponent (d) {
                let m = a.indexOf(d);
                m !== -1 && a.splice(m, 1);
            }
        });
        let f = !1;
        return (0, $fVLUl.onDeactivated)(()=>{
            f = !0;
        }), (0, $fVLUl.onActivated)(()=>{
            f === !0 && e.autofocus === !0 && v();
        }), (0, $fVLUl.onMounted)(()=>{
            e.autofocus === !0 && v();
        }), Object.assign(r.proxy, {
            validate: l,
            resetValidation: s,
            submit: c,
            reset: u,
            focus: v,
            getValidationComponents: ()=>a
        }), ()=>(0, $fVLUl.h)("form", {
                class: "q-form",
                ref: n,
                onSubmit: c,
                onReset: u
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$export$4c671bf544af0ee8 = {
    inject: {
        [$848b1ce88e755b32$var$Rn]: {
            default: $848b1ce88e755b32$export$8793edee2d425525
        }
    },
    watch: {
        disable (e) {
            let t = this.$.provides[$848b1ce88e755b32$var$Rn];
            t !== void 0 && (e === !0 ? (this.resetValidation(), t.unbindComponent(this)) : t.bindComponent(this));
        }
    },
    methods: {
        validate () {},
        resetValidation () {}
    },
    mounted () {
        let e = this.$.provides[$848b1ce88e755b32$var$Rn];
        e !== void 0 && this.disable !== !0 && e.bindComponent(this);
    },
    beforeUnmount () {
        let e = this.$.provides[$848b1ce88e755b32$var$Rn];
        e !== void 0 && this.disable !== !0 && e.unbindComponent(this);
    }
};
var $848b1ce88e755b32$export$2dcc2a0b89cfff9b = $848b1ce88e755b32$var$R({
    name: "QHeader",
    props: {
        modelValue: {
            type: Boolean,
            default: !0
        },
        reveal: Boolean,
        revealOffset: {
            type: Number,
            default: 250
        },
        bordered: Boolean,
        elevated: Boolean,
        heightHint: {
            type: [
                String,
                Number
            ],
            default: 50
        }
    },
    emits: [
        "reveal",
        "focusin"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: { $q: r } } = (0, $fVLUl.getCurrentInstance)(), n = (0, $fVLUl.inject)($848b1ce88e755b32$var$co, $848b1ce88e755b32$var$Ye);
        if (n === $848b1ce88e755b32$var$Ye) return console.error("QHeader needs to be child of QLayout"), $848b1ce88e755b32$var$Ye;
        let i = (0, $eayOh.ref)(parseInt(e.heightHint, 10)), a = (0, $eayOh.ref)(!0), l = (0, $eayOh.computed)(()=>e.reveal === !0 || n.view.value.indexOf("H") !== -1 || r.platform.is.ios && n.isContainer.value === !0), s = (0, $eayOh.computed)(()=>{
            if (e.modelValue !== !0) return 0;
            if (l.value === !0) return a.value === !0 ? i.value : 0;
            let b = i.value - n.scroll.value.position;
            return b > 0 ? b : 0;
        }), c = (0, $eayOh.computed)(()=>e.modelValue !== !0 || l.value === !0 && a.value !== !0), u = (0, $eayOh.computed)(()=>e.modelValue === !0 && c.value === !0 && e.reveal === !0), v = (0, $eayOh.computed)(()=>"q-header q-layout__section--marginal " + (l.value === !0 ? "fixed" : "absolute") + "-top" + (e.bordered === !0 ? " q-header--bordered" : "") + (c.value === !0 ? " q-header--hidden" : "") + (e.modelValue !== !0 ? " q-layout--prevent-focus" : "")), f = (0, $eayOh.computed)(()=>{
            let b = n.rows.value.top, h = {};
            return b[0] === "l" && n.left.space === !0 && (h[r.lang.rtl === !0 ? "right" : "left"] = `${n.left.size}px`), b[2] === "r" && n.right.space === !0 && (h[r.lang.rtl === !0 ? "left" : "right"] = `${n.right.size}px`), h;
        });
        function d(b, h) {
            n.update("header", b, h);
        }
        function m(b, h) {
            b.value !== h && (b.value = h);
        }
        function y({ height: b }) {
            m(i, b), d("size", b);
        }
        function p(b) {
            u.value === !0 && m(a, !0), o("focusin", b);
        }
        (0, $eayOh.watch)(()=>e.modelValue, (b)=>{
            d("space", b), m(a, !0), n.animate();
        }), (0, $eayOh.watch)(s, (b)=>{
            d("offset", b);
        }), (0, $eayOh.watch)(()=>e.reveal, (b)=>{
            b === !1 && m(a, e.modelValue);
        }), (0, $eayOh.watch)(a, (b)=>{
            n.animate(), o("reveal", b);
        }), (0, $eayOh.watch)(n.scroll, (b)=>{
            e.reveal === !0 && m(a, b.direction === "up" || b.position <= e.revealOffset || b.position - b.inflectionPoint < 100);
        });
        let C = {};
        return n.instances.header = C, e.modelValue === !0 && d("size", i.value), d("space", e.modelValue), d("offset", s.value), (0, $fVLUl.onBeforeUnmount)(()=>{
            n.instances.header === C && (n.instances.header = void 0, d("size", 0), d("offset", 0), d("space", !1));
        }), ()=>{
            let b = $848b1ce88e755b32$var$tn(t.default, []);
            return e.elevated === !0 && b.push((0, $fVLUl.h)("div", {
                class: "q-layout__shadow absolute-full overflow-hidden no-pointer-events"
            })), b.push((0, $fVLUl.h)($848b1ce88e755b32$export$614f53fe102a3da7, {
                debounce: 0,
                onResize: y
            })), (0, $fVLUl.h)("header", {
                class: v.value,
                style: f.value,
                onFocusin: p
            }, b);
        };
    }
});
var $848b1ce88e755b32$var$la = {
    ratio: [
        String,
        Number
    ]
};
function $848b1ce88e755b32$var$ua(e, t) {
    return (0, $eayOh.computed)(()=>{
        let o = Number(e.ratio || (t !== void 0 ? t.value : void 0));
        return isNaN(o) !== !0 && o > 0 ? {
            paddingBottom: `${100 / o}%`
        } : null;
    });
}
var $848b1ce88e755b32$var$u1 = 1.7778, $848b1ce88e755b32$export$b76c0105a5546ea6 = $848b1ce88e755b32$var$R({
    name: "QImg",
    props: {
        ...$848b1ce88e755b32$var$la,
        src: String,
        srcset: String,
        sizes: String,
        alt: String,
        crossorigin: String,
        decoding: String,
        referrerpolicy: String,
        draggable: Boolean,
        loading: {
            type: String,
            default: "lazy"
        },
        loadingShowDelay: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        fetchpriority: {
            type: String,
            default: "auto"
        },
        width: String,
        height: String,
        initialRatio: {
            type: [
                Number,
                String
            ],
            default: $848b1ce88e755b32$var$u1
        },
        placeholderSrc: String,
        errorSrc: String,
        fit: {
            type: String,
            default: "cover"
        },
        position: {
            type: String,
            default: "50% 50%"
        },
        imgClass: String,
        imgStyle: Object,
        noSpinner: Boolean,
        noNativeMenu: Boolean,
        noTransition: Boolean,
        spinnerColor: String,
        spinnerSize: String
    },
    emits: [
        "load",
        "error"
    ],
    setup (e, { slots: t, emit: o }) {
        let r = (0, $eayOh.ref)(e.initialRatio), n = $848b1ce88e755b32$var$ua(e, r), i = (0, $fVLUl.getCurrentInstance)(), { registerTimeout: a, removeTimeout: l } = $848b1ce88e755b32$export$d8e6abf214c9ec0f(), { registerTimeout: s, removeTimeout: c } = $848b1ce88e755b32$export$d8e6abf214c9ec0f(), u = (0, $eayOh.computed)(()=>e.placeholderSrc !== void 0 ? {
                src: e.placeholderSrc
            } : null), v = (0, $eayOh.computed)(()=>e.errorSrc !== void 0 ? {
                src: e.errorSrc,
                __qerror: !0
            } : null), f = [
            (0, $eayOh.ref)(null),
            (0, $eayOh.ref)(u.value)
        ], d = (0, $eayOh.ref)(0), m = (0, $eayOh.ref)(!1), y = (0, $eayOh.ref)(!1), p = (0, $eayOh.computed)(()=>`q-img q-img--${e.noNativeMenu === !0 ? "no-" : ""}menu`), C = (0, $eayOh.computed)(()=>({
                width: e.width,
                height: e.height
            })), b = (0, $eayOh.computed)(()=>`q-img__image ${e.imgClass !== void 0 ? e.imgClass + " " : ""}q-img__image--with${e.noTransition === !0 ? "out" : ""}-transition q-img__image--`), h = (0, $eayOh.computed)(()=>({
                ...e.imgStyle,
                objectFit: e.fit,
                objectPosition: e.position
            }));
        function g() {
            if (c(), e.loadingShowDelay === 0) {
                m.value = !0;
                return;
            }
            s(()=>{
                m.value = !0;
            }, e.loadingShowDelay);
        }
        function S() {
            c(), m.value = !1;
        }
        function P({ target: q }) {
            $848b1ce88e755b32$var$Jt(i) === !1 && (l(), r.value = q.naturalHeight === 0 ? .5 : q.naturalWidth / q.naturalHeight, $(q, 1));
        }
        function $(q, x) {
            x === 1e3 || $848b1ce88e755b32$var$Jt(i) === !0 || (q.complete === !0 ? L(q) : a(()=>{
                $(q, x + 1);
            }, 50));
        }
        function L(q) {
            $848b1ce88e755b32$var$Jt(i) !== !0 && (d.value = d.value ^ 1, f[d.value].value = null, S(), q.getAttribute("__qerror") !== "true" && (y.value = !1), o("load", q.currentSrc || q.src));
        }
        function E(q) {
            l(), S(), y.value = !0, f[d.value].value = v.value, f[d.value ^ 1].value = u.value, o("error", q);
        }
        function A(q) {
            let x = f[q].value, k = {
                key: "img_" + q,
                class: b.value,
                style: h.value,
                alt: e.alt,
                crossorigin: e.crossorigin,
                decoding: e.decoding,
                referrerpolicy: e.referrerpolicy,
                height: e.height,
                width: e.width,
                loading: e.loading,
                fetchpriority: e.fetchpriority,
                "aria-hidden": "true",
                draggable: e.draggable,
                ...x
            };
            return d.value === q ? Object.assign(k, {
                class: k.class + "current",
                onLoad: P,
                onError: E
            }) : k.class += "loaded", (0, $fVLUl.h)("div", {
                class: "q-img__container absolute-full",
                key: "img" + q
            }, (0, $fVLUl.h)("img", k));
        }
        function B() {
            return m.value === !1 ? (0, $fVLUl.h)("div", {
                key: "content",
                class: "q-img__content absolute-full q-anchor--skip"
            }, $848b1ce88e755b32$var$J(t[y.value === !0 ? "error" : "default"])) : (0, $fVLUl.h)("div", {
                key: "loading",
                class: "q-img__loading absolute-full flex flex-center"
            }, t.loading !== void 0 ? t.loading() : e.noSpinner === !0 ? void 0 : [
                (0, $fVLUl.h)($848b1ce88e755b32$export$7418ab329b11fed0, {
                    color: e.spinnerColor,
                    size: e.spinnerSize
                })
            ]);
        }
        {
            let q = function() {
                (0, $eayOh.watch)(()=>e.src || e.srcset || e.sizes ? {
                        src: e.src,
                        srcset: e.srcset,
                        sizes: e.sizes
                    } : null, (x)=>{
                    l(), y.value = !1, x === null ? (S(), f[d.value ^ 1].value = u.value) : g(), f[d.value].value = x;
                }, {
                    immediate: !0
                });
            };
            $848b1ce88e755b32$var$bt.value === !0 ? (0, $fVLUl.onMounted)(q) : q();
        }
        return ()=>{
            let q = [];
            return n.value !== null && q.push((0, $fVLUl.h)("div", {
                key: "filler",
                style: n.value
            })), f[0].value !== null && q.push(A(0)), f[1].value !== null && q.push(A(1)), q.push((0, $fVLUl.h)((0, $24349.Transition), {
                name: "q-transition--fade"
            }, B)), (0, $fVLUl.h)("div", {
                key: "main",
                class: p.value,
                style: C.value,
                role: "img",
                "aria-label": e.alt
            }, q);
        };
    }
});
var { passive: $848b1ce88e755b32$var$Ur } = $848b1ce88e755b32$var$Xe, $848b1ce88e755b32$export$cc6e9b131bede082 = $848b1ce88e755b32$var$R({
    name: "QInfiniteScroll",
    props: {
        offset: {
            type: Number,
            default: 500
        },
        debounce: {
            type: [
                String,
                Number
            ],
            default: 100
        },
        scrollTarget: {
            default: void 0
        },
        initialIndex: Number,
        disable: Boolean,
        reverse: Boolean
    },
    emits: [
        "load"
    ],
    setup (e, { slots: t, emit: o }) {
        let r = (0, $eayOh.ref)(!1), n = (0, $eayOh.ref)(!0), i = (0, $eayOh.ref)(null), a = (0, $eayOh.ref)(null), l = e.initialIndex || 0, s, c, u = (0, $eayOh.computed)(()=>"q-infinite-scroll__loading" + (r.value === !0 ? "" : " invisible"));
        function v() {
            if (e.disable === !0 || r.value === !0 || n.value === !1) return;
            let $ = $848b1ce88e755b32$var$xi(s), L = $848b1ce88e755b32$var$fo(s), E = $848b1ce88e755b32$var$nn(s);
            e.reverse === !1 ? Math.round(L + E + e.offset) >= Math.round($) && f() : Math.round(L) <= e.offset && f();
        }
        function f() {
            if (e.disable === !0 || r.value === !0 || n.value === !1) return;
            l++, r.value = !0;
            let $ = $848b1ce88e755b32$var$xi(s);
            o("load", l, (L)=>{
                n.value === !0 && (r.value = !1, (0, $fVLUl.nextTick)(()=>{
                    if (e.reverse === !0) {
                        let E = $848b1ce88e755b32$var$xi(s), A = $848b1ce88e755b32$var$fo(s), B = E - $;
                        $848b1ce88e755b32$var$un(s, A + B);
                    }
                    L === !0 ? y() : i.value && i.value.closest("body") && c();
                }));
            });
        }
        function d() {
            l = 0;
        }
        function m() {
            n.value === !1 && (n.value = !0, s.addEventListener("scroll", c, $848b1ce88e755b32$var$Ur)), v();
        }
        function y() {
            n.value === !0 && (n.value = !1, r.value = !1, s.removeEventListener("scroll", c, $848b1ce88e755b32$var$Ur), c !== void 0 && c.cancel !== void 0 && c.cancel());
        }
        function p() {
            if (s && n.value === !0 && s.removeEventListener("scroll", c, $848b1ce88e755b32$var$Ur), s = $848b1ce88e755b32$var$At(i.value, e.scrollTarget), n.value === !0) {
                if (s.addEventListener("scroll", c, $848b1ce88e755b32$var$Ur), e.reverse === !0) {
                    let $ = $848b1ce88e755b32$var$xi(s), L = $848b1ce88e755b32$var$nn(s);
                    $848b1ce88e755b32$var$un(s, $ - L);
                }
                v();
            }
        }
        function C($) {
            l = $;
        }
        function b($) {
            $ = parseInt($, 10);
            let L = c;
            c = $ <= 0 ? v : $848b1ce88e755b32$export$61fc7d43ac8f84b0(v, isNaN($) === !0 ? 100 : $), s && n.value === !0 && (L !== void 0 && s.removeEventListener("scroll", L, $848b1ce88e755b32$var$Ur), s.addEventListener("scroll", c, $848b1ce88e755b32$var$Ur));
        }
        function h($) {
            if (g.value === !0) {
                if (a.value === null) {
                    $ !== !0 && (0, $fVLUl.nextTick)(()=>{
                        h(!0);
                    });
                    return;
                }
                let L = `${r.value === !0 ? "un" : ""}pauseAnimations`;
                Array.from(a.value.getElementsByTagName("svg")).forEach((E)=>{
                    E[L]();
                });
            }
        }
        let g = (0, $eayOh.computed)(()=>e.disable !== !0 && n.value === !0);
        (0, $eayOh.watch)([
            r,
            g
        ], ()=>{
            h();
        }), (0, $eayOh.watch)(()=>e.disable, ($)=>{
            $ === !0 ? y() : m();
        }), (0, $eayOh.watch)(()=>e.reverse, ()=>{
            r.value === !1 && n.value === !0 && v();
        }), (0, $eayOh.watch)(()=>e.scrollTarget, p), (0, $eayOh.watch)(()=>e.debounce, b);
        let S = !1;
        (0, $fVLUl.onActivated)(()=>{
            S !== !1 && s && $848b1ce88e755b32$var$un(s, S);
        }), (0, $fVLUl.onDeactivated)(()=>{
            S = s ? $848b1ce88e755b32$var$fo(s) : !1;
        }), (0, $fVLUl.onBeforeUnmount)(()=>{
            n.value === !0 && s.removeEventListener("scroll", c, $848b1ce88e755b32$var$Ur);
        }), (0, $fVLUl.onMounted)(()=>{
            b(e.debounce), p(), r.value === !1 && h();
        });
        let P = (0, $fVLUl.getCurrentInstance)();
        return Object.assign(P.proxy, {
            poll: ()=>{
                c !== void 0 && c();
            },
            trigger: f,
            stop: y,
            reset: d,
            resume: m,
            setIndex: C,
            updateScrollTarget: p
        }), ()=>{
            let $ = $848b1ce88e755b32$var$tn(t.default, []);
            return g.value === !0 && $[e.reverse === !1 ? "push" : "unshift"]((0, $fVLUl.h)("div", {
                ref: a,
                class: u.value
            }, $848b1ce88e755b32$var$J(t.loading))), (0, $fVLUl.h)("div", {
                class: "q-infinite-scroll",
                ref: i
            }, $);
        };
    }
});
var $848b1ce88e755b32$export$d3667a9435d68192 = $848b1ce88e755b32$var$R({
    name: "QInnerLoading",
    props: {
        ...$848b1ce88e755b32$var$he,
        ...$848b1ce88e755b32$var$ln,
        showing: Boolean,
        color: String,
        size: {
            type: [
                String,
                Number
            ],
            default: 42
        },
        label: String,
        labelClass: String,
        labelStyle: [
            String,
            Array,
            Object
        ]
    },
    setup (e, { slots: t }) {
        let o = (0, $fVLUl.getCurrentInstance)(), r = $848b1ce88e755b32$var$pe(e, o.proxy.$q), { transitionProps: n, transitionStyle: i } = $848b1ce88e755b32$var$Jn(e), a = (0, $eayOh.computed)(()=>"q-inner-loading q--avoid-card-border absolute-full column flex-center" + (r.value === !0 ? " q-inner-loading--dark" : "")), l = (0, $eayOh.computed)(()=>"q-inner-loading__label" + (e.labelClass !== void 0 ? ` ${e.labelClass}` : ""));
        function s() {
            let u = [
                (0, $fVLUl.h)($848b1ce88e755b32$export$7418ab329b11fed0, {
                    size: e.size,
                    color: e.color
                })
            ];
            return e.label !== void 0 && u.push((0, $fVLUl.h)("div", {
                class: l.value,
                style: e.labelStyle
            }, [
                e.label
            ])), u;
        }
        function c() {
            return e.showing === !0 ? (0, $fVLUl.h)("div", {
                class: a.value,
                style: i.value
            }, t.default !== void 0 ? t.default() : s()) : null;
        }
        return ()=>(0, $fVLUl.h)((0, $24349.Transition), n.value, c);
    }
});
var $848b1ce88e755b32$var$Kv = {
    date: "####/##/##",
    datetime: "####/##/## ##:##",
    time: "##:##",
    fulltime: "##:##:##",
    phone: "(###) ### - ####",
    card: "#### #### #### ####"
}, $848b1ce88e755b32$var$Ou = {
    "#": {
        pattern: "[\\d]",
        negate: "[^\\d]"
    },
    S: {
        pattern: "[a-zA-Z]",
        negate: "[^a-zA-Z]"
    },
    N: {
        pattern: "[0-9a-zA-Z]",
        negate: "[^0-9a-zA-Z]"
    },
    A: {
        pattern: "[a-zA-Z]",
        negate: "[^a-zA-Z]",
        transform: (e)=>e.toLocaleUpperCase()
    },
    a: {
        pattern: "[a-zA-Z]",
        negate: "[^a-zA-Z]",
        transform: (e)=>e.toLocaleLowerCase()
    },
    X: {
        pattern: "[0-9a-zA-Z]",
        negate: "[^0-9a-zA-Z]",
        transform: (e)=>e.toLocaleUpperCase()
    },
    x: {
        pattern: "[0-9a-zA-Z]",
        negate: "[^0-9a-zA-Z]",
        transform: (e)=>e.toLocaleLowerCase()
    }
}, $848b1ce88e755b32$var$Yv = Object.keys($848b1ce88e755b32$var$Ou);
$848b1ce88e755b32$var$Yv.forEach((e)=>{
    $848b1ce88e755b32$var$Ou[e].regex = new RegExp($848b1ce88e755b32$var$Ou[e].pattern);
});
var $848b1ce88e755b32$var$p1 = new RegExp("\\\\([^.*+?^${}()|([\\]])|([.*+?^${}()|[\\]])|([" + $848b1ce88e755b32$var$Yv.join("") + "])|(.)", "g"), $848b1ce88e755b32$var$Wv = /[.*+?^${}()|[\]\\]/g, $848b1ce88e755b32$var$Bt = "\x01", $848b1ce88e755b32$var$Xv = {
    mask: String,
    reverseFillMask: Boolean,
    fillMask: [
        Boolean,
        String
    ],
    unmaskedValue: Boolean
};
function $848b1ce88e755b32$var$Gv(e, t, o, r) {
    let n, i, a, l, s, c, u = (0, $eayOh.ref)(null), v = (0, $eayOh.ref)(d());
    function f() {
        return e.autogrow === !0 || [
            "textarea",
            "text",
            "search",
            "url",
            "tel",
            "password"
        ].includes(e.type);
    }
    (0, $eayOh.watch)(()=>e.type + e.autogrow, y), (0, $eayOh.watch)(()=>e.mask, (E)=>{
        if (E !== void 0) p(v.value, !0);
        else {
            let A = $(v.value);
            y(), e.modelValue !== A && t("update:modelValue", A);
        }
    }), (0, $eayOh.watch)(()=>e.fillMask + e.reverseFillMask, ()=>{
        u.value === !0 && p(v.value, !0);
    }), (0, $eayOh.watch)(()=>e.unmaskedValue, ()=>{
        u.value === !0 && p(v.value);
    });
    function d() {
        if (y(), u.value === !0) {
            let E = S($(e.modelValue));
            return e.fillMask !== !1 ? L(E) : E;
        }
        return e.modelValue;
    }
    function m(E) {
        if (E < n.length) return n.slice(-E);
        let A = "", B = n, q = B.indexOf($848b1ce88e755b32$var$Bt);
        if (q !== -1) {
            for(let x = E - B.length; x > 0; x--)A += $848b1ce88e755b32$var$Bt;
            B = B.slice(0, q) + A + B.slice(q);
        }
        return B;
    }
    function y() {
        if (u.value = e.mask !== void 0 && e.mask.length !== 0 && f(), u.value === !1) {
            l = void 0, n = "", i = "";
            return;
        }
        let E = $848b1ce88e755b32$var$Kv[e.mask] === void 0 ? e.mask : $848b1ce88e755b32$var$Kv[e.mask], A = typeof e.fillMask == "string" && e.fillMask.length !== 0 ? e.fillMask.slice(0, 1) : "_", B = A.replace($848b1ce88e755b32$var$Wv, "\\$&"), q = [], x = [], k = [], j = e.reverseFillMask === !0, Q = "", w = "";
        E.replace($848b1ce88e755b32$var$p1, (V, _, N, I, oe)=>{
            if (I !== void 0) {
                let T = $848b1ce88e755b32$var$Ou[I];
                k.push(T), w = T.negate, j === !0 && (x.push("(?:" + w + "+)?(" + T.pattern + "+)?(?:" + w + "+)?(" + T.pattern + "+)?"), j = !1), x.push("(?:" + w + "+)?(" + T.pattern + ")?");
            } else if (N !== void 0) Q = "\\" + (N === "\\" ? "" : N), k.push(N), q.push("([^" + Q + "]+)?" + Q + "?");
            else {
                let T = _ !== void 0 ? _ : oe;
                Q = T === "\\" ? "\\\\\\\\" : T.replace($848b1ce88e755b32$var$Wv, "\\\\$&"), k.push(T), q.push("([^" + Q + "]+)?" + Q + "?");
            }
        });
        let H = new RegExp("^" + q.join("") + "(" + (Q === "" ? "." : "[^" + Q + "]") + "+)?" + (Q === "" ? "" : "[" + Q + "]*") + "$"), W = x.length - 1, ie = x.map((V, _)=>_ === 0 && e.reverseFillMask === !0 ? new RegExp("^" + B + "*" + V) : _ === W ? new RegExp("^" + V + "(" + (w === "" ? "." : w) + "+)?" + (e.reverseFillMask === !0 ? "$" : B + "*")) : new RegExp("^" + V));
        a = k, l = (V)=>{
            let _ = H.exec(e.reverseFillMask === !0 ? V : V.slice(0, k.length + 1));
            _ !== null && (V = _.slice(1).join(""));
            let N = [], I = ie.length;
            for(let oe = 0, T = V; oe < I; oe++){
                let D = ie[oe].exec(T);
                if (D === null) break;
                T = T.slice(D.shift().length), N.push(...D);
            }
            return N.length !== 0 ? N.join("") : V;
        }, n = k.map((V)=>typeof V == "string" ? V : $848b1ce88e755b32$var$Bt).join(""), i = n.split($848b1ce88e755b32$var$Bt).join(A);
    }
    function p(E, A, B) {
        let q = r.value, x = q.selectionEnd, k = q.value.length - x, j = $(E);
        A === !0 && y();
        let Q = S(j), w = e.fillMask !== !1 ? L(Q) : Q, H = v.value !== w;
        q.value !== w && (q.value = w), H === !0 && (v.value = w), document.activeElement === q && (0, $fVLUl.nextTick)(()=>{
            if (w === i) {
                let ie = e.reverseFillMask === !0 ? i.length : 0;
                q.setSelectionRange(ie, ie, "forward");
                return;
            }
            if (B === "insertFromPaste" && e.reverseFillMask !== !0) {
                let ie = q.selectionEnd, V = x - 1;
                for(let _ = s; _ <= V && _ < ie; _++)n[_] !== $848b1ce88e755b32$var$Bt && V++;
                b.right(q, V);
                return;
            }
            if ([
                "deleteContentBackward",
                "deleteContentForward"
            ].indexOf(B) !== -1) {
                let ie = e.reverseFillMask === !0 ? x === 0 ? w.length > Q.length ? 1 : 0 : Math.max(0, w.length - (w === i ? 0 : Math.min(Q.length, k) + 1)) + 1 : x;
                q.setSelectionRange(ie, ie, "forward");
                return;
            }
            if (e.reverseFillMask === !0) {
                if (H === !0) {
                    let ie = Math.max(0, w.length - (w === i ? 0 : Math.min(Q.length, k + 1)));
                    ie === 1 && x === 1 ? q.setSelectionRange(ie, ie, "forward") : b.rightReverse(q, ie);
                } else {
                    let ie = w.length - k;
                    q.setSelectionRange(ie, ie, "backward");
                }
            } else if (H === !0) {
                let ie = Math.max(0, n.indexOf($848b1ce88e755b32$var$Bt), Math.min(Q.length, x) - 1);
                b.right(q, ie);
            } else {
                let ie = x - 1;
                b.right(q, ie);
            }
        });
        let W = e.unmaskedValue === !0 ? $(w) : w;
        String(e.modelValue) !== W && (e.modelValue !== null || W !== "") && o(W, !0);
    }
    function C(E, A, B) {
        let q = S($(E.value));
        A = Math.max(0, n.indexOf($848b1ce88e755b32$var$Bt), Math.min(q.length, A)), s = A, E.setSelectionRange(A, B, "forward");
    }
    let b = {
        left (E, A) {
            let B = n.slice(A - 1).indexOf($848b1ce88e755b32$var$Bt) === -1, q = Math.max(0, A - 1);
            for(; q >= 0; q--)if (n[q] === $848b1ce88e755b32$var$Bt) {
                A = q, B === !0 && A++;
                break;
            }
            if (q < 0 && n[A] !== void 0 && n[A] !== $848b1ce88e755b32$var$Bt) return b.right(E, 0);
            A >= 0 && E.setSelectionRange(A, A, "backward");
        },
        right (E, A) {
            let B = E.value.length, q = Math.min(B, A + 1);
            for(; q <= B; q++)if (n[q] === $848b1ce88e755b32$var$Bt) {
                A = q;
                break;
            } else n[q - 1] === $848b1ce88e755b32$var$Bt && (A = q);
            if (q > B && n[A - 1] !== void 0 && n[A - 1] !== $848b1ce88e755b32$var$Bt) return b.left(E, B);
            E.setSelectionRange(A, A, "forward");
        },
        leftReverse (E, A) {
            let B = m(E.value.length), q = Math.max(0, A - 1);
            for(; q >= 0; q--)if (B[q - 1] === $848b1ce88e755b32$var$Bt) {
                A = q;
                break;
            } else if (B[q] === $848b1ce88e755b32$var$Bt && (A = q, q === 0)) break;
            if (q < 0 && B[A] !== void 0 && B[A] !== $848b1ce88e755b32$var$Bt) return b.rightReverse(E, 0);
            A >= 0 && E.setSelectionRange(A, A, "backward");
        },
        rightReverse (E, A) {
            let B = E.value.length, q = m(B), x = q.slice(0, A + 1).indexOf($848b1ce88e755b32$var$Bt) === -1, k = Math.min(B, A + 1);
            for(; k <= B; k++)if (q[k - 1] === $848b1ce88e755b32$var$Bt) {
                A = k, A > 0 && x === !0 && A--;
                break;
            }
            if (k > B && q[A - 1] !== void 0 && q[A - 1] !== $848b1ce88e755b32$var$Bt) return b.leftReverse(E, B);
            E.setSelectionRange(A, A, "forward");
        }
    };
    function h(E) {
        t("click", E), c = void 0;
    }
    function g(E) {
        if (t("keydown", E), $848b1ce88e755b32$var$xo(E) === !0 || E.altKey === !0) return;
        let A = r.value, B = A.selectionStart, q = A.selectionEnd;
        if (E.shiftKey || (c = void 0), E.keyCode === 37 || E.keyCode === 39) {
            E.shiftKey && c === void 0 && (c = A.selectionDirection === "forward" ? B : q);
            let x = b[(E.keyCode === 39 ? "right" : "left") + (e.reverseFillMask === !0 ? "Reverse" : "")];
            if (E.preventDefault(), x(A, c === B ? q : B), E.shiftKey) {
                let k = A.selectionStart;
                A.setSelectionRange(Math.min(c, k), Math.max(c, k), "forward");
            }
        } else E.keyCode === 8 && e.reverseFillMask !== !0 && B === q ? (b.left(A, B), A.setSelectionRange(A.selectionStart, q, "backward")) : E.keyCode === 46 && e.reverseFillMask === !0 && B === q && (b.rightReverse(A, q), A.setSelectionRange(B, A.selectionEnd, "forward"));
    }
    function S(E) {
        if (E == null || E === "") return "";
        if (e.reverseFillMask === !0) return P(E);
        let A = a, B = 0, q = "";
        for(let x = 0; x < A.length; x++){
            let k = E[B], j = A[x];
            if (typeof j == "string") q += j, k === j && B++;
            else if (k !== void 0 && j.regex.test(k)) q += j.transform !== void 0 ? j.transform(k) : k, B++;
            else return q;
        }
        return q;
    }
    function P(E) {
        let A = a, B = n.indexOf($848b1ce88e755b32$var$Bt), q = E.length - 1, x = "";
        for(let k = A.length - 1; k >= 0 && q !== -1; k--){
            let j = A[k], Q = E[q];
            if (typeof j == "string") x = j + x, Q === j && q--;
            else if (Q !== void 0 && j.regex.test(Q)) do x = (j.transform !== void 0 ? j.transform(Q) : Q) + x, q--, Q = E[q];
            while (B === k && Q !== void 0 && j.regex.test(Q));
            else return x;
        }
        return x;
    }
    function $(E) {
        return typeof E != "string" || l === void 0 ? typeof E == "number" ? l("" + E) : E : l(E);
    }
    function L(E) {
        return i.length - E.length <= 0 ? E : e.reverseFillMask === !0 && E.length !== 0 ? i.slice(0, -E.length) + E : E + i.slice(E.length);
    }
    return {
        innerValue: v,
        hasMask: u,
        moveCursorForPaste: C,
        updateMaskValue: p,
        onMaskedKeydown: g,
        onMaskedClick: h
    };
}
var $848b1ce88e755b32$var$b1 = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/, $848b1ce88e755b32$var$y1 = /[\u4e00-\u9fff\u3400-\u4dbf\u{20000}-\u{2a6df}\u{2a700}-\u{2b73f}\u{2b740}-\u{2b81f}\u{2b820}-\u{2ceaf}\uf900-\ufaff\u3300-\u33ff\ufe30-\ufe4f\uf900-\ufaff\u{2f800}-\u{2fa1f}]/u, $848b1ce88e755b32$var$S1 = /[\u3131-\u314e\u314f-\u3163\uac00-\ud7a3]/, $848b1ce88e755b32$var$x1 = /[a-z0-9_ -]$/i;
function $848b1ce88e755b32$var$Iu(e) {
    return function(o) {
        if (o.type === "compositionend" || o.type === "change") {
            if (o.target.qComposing !== !0) return;
            o.target.qComposing = !1, e(o);
        } else o.type === "compositionupdate" && o.target.qComposing !== !0 && typeof o.data == "string" && ($848b1ce88e755b32$var$Ce.is.firefox === !0 ? $848b1ce88e755b32$var$x1.test(o.data) === !1 : $848b1ce88e755b32$var$b1.test(o.data) === !0 || $848b1ce88e755b32$var$y1.test(o.data) === !0 || $848b1ce88e755b32$var$S1.test(o.data) === !0) === !0 && (o.target.qComposing = !0);
    };
}
var $848b1ce88e755b32$export$b1c6a0c22e16b328 = $848b1ce88e755b32$var$R({
    name: "QInput",
    inheritAttrs: !1,
    props: {
        ...$848b1ce88e755b32$var$zn,
        ...$848b1ce88e755b32$var$Xv,
        ...$848b1ce88e755b32$var$_t,
        modelValue: {
            required: !1
        },
        shadowText: String,
        type: {
            type: String,
            default: "text"
        },
        debounce: [
            String,
            Number
        ],
        autogrow: Boolean,
        inputClass: [
            Array,
            String,
            Object
        ],
        inputStyle: [
            Array,
            String,
            Object
        ]
    },
    emits: [
        ...$848b1ce88e755b32$var$cr,
        "paste",
        "change",
        "keydown",
        "click",
        "animationend"
    ],
    setup (e, { emit: t, attrs: o }) {
        let { proxy: r } = (0, $fVLUl.getCurrentInstance)(), { $q: n } = r, i = {}, a = NaN, l, s, c = null, u, v = (0, $eayOh.ref)(null), f = $848b1ce88e755b32$var$Ai(e), { innerValue: d, hasMask: m, moveCursorForPaste: y, updateMaskValue: p, onMaskedKeydown: C, onMaskedClick: b } = $848b1ce88e755b32$var$Gv(e, t, Q, v), h = $848b1ce88e755b32$var$Fu(e, !0), g = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$pn(d.value)), S = $848b1ce88e755b32$var$Iu(k), P = $848b1ce88e755b32$var$dr(), $ = (0, $eayOh.computed)(()=>e.type === "textarea" || e.autogrow === !0), L = (0, $eayOh.computed)(()=>$.value === !0 || [
                "text",
                "search",
                "url",
                "tel",
                "password"
            ].includes(e.type)), E = (0, $eayOh.computed)(()=>{
            let _ = {
                ...P.splitAttrs.listeners.value,
                onInput: k,
                onPaste: x,
                onChange: H,
                onBlur: W,
                onFocus: $848b1ce88e755b32$var$tt
            };
            return _.onCompositionstart = _.onCompositionupdate = _.onCompositionend = S, m.value === !0 && (_.onKeydown = C, _.onClick = b), e.autogrow === !0 && (_.onAnimationend = j), _;
        }), A = (0, $eayOh.computed)(()=>{
            let _ = {
                tabindex: 0,
                "data-autofocus": e.autofocus === !0 || void 0,
                rows: e.type === "textarea" ? 6 : void 0,
                "aria-label": e.label,
                name: f.value,
                ...P.splitAttrs.attributes.value,
                id: P.targetUid.value,
                maxlength: e.maxlength,
                disabled: e.disable === !0,
                readonly: e.readonly === !0
            };
            return $.value === !1 && (_.type = e.type), e.autogrow === !0 && (_.rows = 1), _;
        });
        (0, $eayOh.watch)(()=>e.type, ()=>{
            v.value && (v.value.value = e.modelValue);
        }), (0, $eayOh.watch)(()=>e.modelValue, (_)=>{
            if (m.value === !0) {
                if (s === !0 && (s = !1, String(_) === a)) return;
                p(_);
            } else d.value !== _ && (d.value = _, e.type === "number" && i.hasOwnProperty("value") === !0 && (l === !0 ? l = !1 : delete i.value));
            e.autogrow === !0 && (0, $fVLUl.nextTick)(w);
        }), (0, $eayOh.watch)(()=>e.autogrow, (_)=>{
            _ === !0 ? (0, $fVLUl.nextTick)(w) : v.value !== null && o.rows > 0 && (v.value.style.height = "auto");
        }), (0, $eayOh.watch)(()=>e.dense, ()=>{
            e.autogrow === !0 && (0, $fVLUl.nextTick)(w);
        });
        function B() {
            $848b1ce88e755b32$var$Bo(()=>{
                let _ = document.activeElement;
                v.value !== null && v.value !== _ && (_ === null || _.id !== P.targetUid.value) && v.value.focus({
                    preventScroll: !0
                });
            });
        }
        function q() {
            v.value !== null && v.value.select();
        }
        function x(_) {
            if (m.value === !0 && e.reverseFillMask !== !0) {
                let N = _.target;
                y(N, N.selectionStart, N.selectionEnd);
            }
            t("paste", _);
        }
        function k(_) {
            if (!_ || !_.target) return;
            if (e.type === "file") {
                t("update:modelValue", _.target.files);
                return;
            }
            let N = _.target.value;
            if (_.target.qComposing === !0) {
                i.value = N;
                return;
            }
            if (m.value === !0) p(N, !1, _.inputType);
            else if (Q(N), L.value === !0 && _.target === document.activeElement) {
                let { selectionStart: I, selectionEnd: oe } = _.target;
                I !== void 0 && oe !== void 0 && (0, $fVLUl.nextTick)(()=>{
                    _.target === document.activeElement && N.indexOf(_.target.value) === 0 && _.target.setSelectionRange(I, oe);
                });
            }
            e.autogrow === !0 && w();
        }
        function j(_) {
            t("animationend", _), w();
        }
        function Q(_, N) {
            u = ()=>{
                c = null, e.type !== "number" && i.hasOwnProperty("value") === !0 && delete i.value, e.modelValue !== _ && a !== _ && (a = _, N === !0 && (s = !0), t("update:modelValue", _), (0, $fVLUl.nextTick)(()=>{
                    a === _ && (a = NaN);
                })), u = void 0;
            }, e.type === "number" && (l = !0, i.value = _), e.debounce !== void 0 ? (c !== null && clearTimeout(c), i.value = _, c = setTimeout(u, e.debounce)) : u();
        }
        function w() {
            requestAnimationFrame(()=>{
                let _ = v.value;
                if (_ !== null) {
                    let N = _.parentNode.style, { scrollTop: I } = _, { overflowY: oe, maxHeight: T } = n.platform.is.firefox === !0 ? {} : window.getComputedStyle(_), D = oe !== void 0 && oe !== "scroll";
                    D === !0 && (_.style.overflowY = "hidden"), N.marginBottom = _.scrollHeight - 1 + "px", _.style.height = "1px", _.style.height = _.scrollHeight + "px", D === !0 && (_.style.overflowY = parseInt(T, 10) < _.scrollHeight ? "auto" : "hidden"), N.marginBottom = "", _.scrollTop = I;
                }
            });
        }
        function H(_) {
            S(_), c !== null && (clearTimeout(c), c = null), u !== void 0 && u(), t("change", _.target.value);
        }
        function W(_) {
            _ !== void 0 && $848b1ce88e755b32$var$tt(_), c !== null && (clearTimeout(c), c = null), u !== void 0 && u(), l = !1, s = !1, delete i.value, e.type !== "file" && setTimeout(()=>{
                v.value !== null && (v.value.value = d.value !== void 0 ? d.value : "");
            });
        }
        function ie() {
            return i.hasOwnProperty("value") === !0 ? i.value : d.value !== void 0 ? d.value : "";
        }
        (0, $fVLUl.onBeforeUnmount)(()=>{
            W();
        }), (0, $fVLUl.onMounted)(()=>{
            e.autogrow === !0 && w();
        }), Object.assign(P, {
            innerValue: d,
            fieldClass: (0, $eayOh.computed)(()=>`q-${$.value === !0 ? "textarea" : "input"}` + (e.autogrow === !0 ? " q-textarea--autogrow" : "")),
            hasShadow: (0, $eayOh.computed)(()=>e.type !== "file" && typeof e.shadowText == "string" && e.shadowText.length !== 0),
            inputRef: v,
            emitValue: Q,
            hasValue: g,
            floatingLabel: (0, $eayOh.computed)(()=>g.value === !0 && (e.type !== "number" || isNaN(d.value) === !1) || $848b1ce88e755b32$var$pn(e.displayValue)),
            getControl: ()=>(0, $fVLUl.h)($.value === !0 ? "textarea" : "input", {
                    ref: v,
                    class: [
                        "q-field__native q-placeholder",
                        e.inputClass
                    ],
                    style: e.inputStyle,
                    ...A.value,
                    ...E.value,
                    ...e.type !== "file" ? {
                        value: ie()
                    } : h.value
                }),
            getShadowControl: ()=>(0, $fVLUl.h)("div", {
                    class: "q-field__native q-field__shadow absolute-bottom no-pointer-events" + ($.value === !0 ? "" : " text-no-wrap")
                }, [
                    (0, $fVLUl.h)("span", {
                        class: "invisible"
                    }, ie()),
                    (0, $fVLUl.h)("span", e.shadowText)
                ])
        });
        let V = $848b1ce88e755b32$var$fr(P);
        return Object.assign(r, {
            focus: B,
            select: q,
            getNativeElement: ()=>v.value
        }), $848b1ce88e755b32$var$it(r, "nativeEl", ()=>v.value), V;
    }
});
var $848b1ce88e755b32$var$Zv = {
    threshold: 0,
    root: null,
    rootMargin: "0px"
};
function $848b1ce88e755b32$var$Jv(e, t, o) {
    let r, n, i;
    typeof o == "function" ? (r = o, n = $848b1ce88e755b32$var$Zv, i = t.cfg === void 0) : (r = o.handler, n = Object.assign({}, $848b1ce88e755b32$var$Zv, o.cfg), i = t.cfg === void 0 || $848b1ce88e755b32$var$Zt(t.cfg, n) === !1), t.handler !== r && (t.handler = r), i === !0 && (t.cfg = n, t.observer !== void 0 && t.observer.unobserve(e), t.observer = new IntersectionObserver(([a])=>{
        if (typeof t.handler == "function") {
            if (a.rootBounds === null && document.body.contains(e) === !0) {
                t.observer.unobserve(e), t.observer.observe(e);
                return;
            }
            (t.handler(a, t.observer) === !1 || t.once === !0 && a.isIntersecting === !0) && $848b1ce88e755b32$var$eg(e);
        }
    }, n), t.observer.observe(e));
}
function $848b1ce88e755b32$var$eg(e) {
    let t = e.__qvisible;
    t !== void 0 && (t.observer !== void 0 && t.observer.unobserve(e), delete e.__qvisible);
}
var $848b1ce88e755b32$export$869c896bf338bf5a = $848b1ce88e755b32$var$Mt({
    name: "intersection",
    mounted (e, { modifiers: t, value: o }) {
        let r = {
            once: t.once === !0
        };
        $848b1ce88e755b32$var$Jv(e, r, o), e.__qvisible = r;
    },
    updated (e, t) {
        let o = e.__qvisible;
        o !== void 0 && $848b1ce88e755b32$var$Jv(e, o, t.value);
    },
    beforeUnmount: $848b1ce88e755b32$var$eg
});
var $848b1ce88e755b32$export$bfb6b34b3c68a45a = $848b1ce88e755b32$var$R({
    name: "QIntersection",
    props: {
        tag: {
            type: String,
            default: "div"
        },
        once: Boolean,
        transition: String,
        transitionDuration: {
            type: [
                String,
                Number
            ],
            default: 300
        },
        ssrPrerender: Boolean,
        margin: String,
        threshold: [
            Number,
            Array
        ],
        root: {
            default: null
        },
        disable: Boolean,
        onVisibility: Function
    },
    setup (e, { slots: t, emit: o }) {
        let r = (0, $eayOh.ref)($848b1ce88e755b32$var$bt.value === !0 ? e.ssrPrerender : !1), n = (0, $eayOh.computed)(()=>e.root !== void 0 || e.margin !== void 0 || e.threshold !== void 0 ? {
                handler: s,
                cfg: {
                    root: e.root,
                    rootMargin: e.margin,
                    threshold: e.threshold
                }
            } : s), i = (0, $eayOh.computed)(()=>e.disable !== !0 && ($848b1ce88e755b32$var$bt.value !== !0 || e.once !== !0 || e.ssrPrerender !== !0)), a = (0, $eayOh.computed)(()=>[
                [
                    $848b1ce88e755b32$export$869c896bf338bf5a,
                    n.value,
                    void 0,
                    {
                        once: e.once
                    }
                ]
            ]), l = (0, $eayOh.computed)(()=>`--q-transition-duration: ${e.transitionDuration}ms`);
        function s(u) {
            r.value !== u.isIntersecting && (r.value = u.isIntersecting, e.onVisibility !== void 0 && o("visibility", r.value));
        }
        function c() {
            if (r.value === !0) return [
                (0, $fVLUl.h)("div", {
                    key: "content",
                    style: l.value
                }, $848b1ce88e755b32$var$J(t.default))
            ];
            if (t.hidden !== void 0) return [
                (0, $fVLUl.h)("div", {
                    key: "hidden",
                    style: l.value
                }, t.hidden())
            ];
        }
        return ()=>{
            let u = e.transition ? [
                (0, $fVLUl.h)((0, $24349.Transition), {
                    name: "q-transition--" + e.transition
                }, c)
            ] : c();
            return $848b1ce88e755b32$var$kt(e.tag, {
                class: "q-intersection"
            }, u, "main", i.value, ()=>a.value);
        };
    }
});
var $848b1ce88e755b32$export$546da2cac02ecac2 = $848b1ce88e755b32$var$R({
    name: "QList",
    props: {
        ...$848b1ce88e755b32$var$he,
        bordered: Boolean,
        dense: Boolean,
        separator: Boolean,
        padding: Boolean,
        tag: {
            type: String,
            default: "div"
        }
    },
    setup (e, { slots: t }) {
        let o = (0, $fVLUl.getCurrentInstance)(), r = $848b1ce88e755b32$var$pe(e, o.proxy.$q), n = (0, $eayOh.computed)(()=>"q-list" + (e.bordered === !0 ? " q-list--bordered" : "") + (e.dense === !0 ? " q-list--dense" : "") + (e.separator === !0 ? " q-list--separator" : "") + (r.value === !0 ? " q-list--dark" : "") + (e.padding === !0 ? " q-list--padding" : ""));
        return ()=>(0, $fVLUl.h)(e.tag, {
                class: n.value
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$var$ng = [
    34,
    37,
    40,
    33,
    39,
    38
], $848b1ce88e755b32$var$B1 = Object.keys($848b1ce88e755b32$var$Oa), $848b1ce88e755b32$export$6c883daf6170407d = $848b1ce88e755b32$var$R({
    name: "QKnob",
    props: {
        ...$848b1ce88e755b32$var$_t,
        ...$848b1ce88e755b32$var$Oa,
        modelValue: {
            type: Number,
            required: !0
        },
        innerMin: Number,
        innerMax: Number,
        step: {
            type: Number,
            default: 1,
            validator: (e)=>e >= 0
        },
        tabindex: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        disable: Boolean,
        readonly: Boolean
    },
    emits: [
        "update:modelValue",
        "change",
        "dragValue"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: r } = (0, $fVLUl.getCurrentInstance)(), { $q: n } = r, i = (0, $eayOh.ref)(e.modelValue), a = (0, $eayOh.ref)(!1), l = (0, $eayOh.computed)(()=>isNaN(e.innerMin) === !0 || e.innerMin < e.min ? e.min : e.innerMin), s = (0, $eayOh.computed)(()=>isNaN(e.innerMax) === !0 || e.innerMax > e.max ? e.max : e.innerMax), c;
        function u() {
            i.value = e.modelValue === null ? l.value : $848b1ce88e755b32$var$Ze(e.modelValue, l.value, s.value), B(!0);
        }
        (0, $eayOh.watch)(()=>`${e.modelValue}|${l.value}|${s.value}`, u), u();
        let v = (0, $eayOh.computed)(()=>e.disable === !1 && e.readonly === !1), f = (0, $eayOh.computed)(()=>"q-knob non-selectable" + (v.value === !0 ? " q-knob--editable" : e.disable === !0 ? " disabled" : "")), d = (0, $eayOh.computed)(()=>(String(e.step).trim().split(".")[1] || "").length), m = (0, $eayOh.computed)(()=>e.step === 0 ? 1 : e.step), y = (0, $eayOh.computed)(()=>e.instantFeedback === !0 || a.value === !0), p = n.platform.is.mobile === !0 ? (0, $eayOh.computed)(()=>v.value === !0 ? {
                onClick: $
            } : {}) : (0, $eayOh.computed)(()=>v.value === !0 ? {
                onMousedown: P,
                onClick: $,
                onKeydown: L,
                onKeyup: A
            } : {}), C = (0, $eayOh.computed)(()=>v.value === !0 ? {
                tabindex: e.tabindex
            } : {
                [`aria-${e.disable === !0 ? "disabled" : "readonly"}`]: "true"
            }), b = (0, $eayOh.computed)(()=>{
            let k = {};
            return $848b1ce88e755b32$var$B1.forEach((j)=>{
                k[j] = e[j];
            }), k;
        });
        function h(k) {
            k.isFinal ? (E(k.evt, !0), a.value = !1) : (k.isFirst && (S(), a.value = !0), E(k.evt));
        }
        let g = (0, $eayOh.computed)(()=>[
                [
                    $848b1ce88e755b32$export$718797250d1e376,
                    h,
                    void 0,
                    {
                        prevent: !0,
                        stop: !0,
                        mouse: !0
                    }
                ]
            ]);
        function S() {
            let { top: k, left: j, width: Q, height: w } = r.$el.getBoundingClientRect();
            c = {
                top: k + w / 2,
                left: j + Q / 2
            };
        }
        function P(k) {
            S(), E(k);
        }
        function $(k) {
            S(), E(k, !0);
        }
        function L(k) {
            if (!$848b1ce88e755b32$var$ng.includes(k.keyCode)) return;
            $848b1ce88e755b32$var$Se(k);
            let j = ([
                34,
                33
            ].includes(k.keyCode) ? 10 : 1) * m.value, Q = [
                34,
                37,
                40
            ].includes(k.keyCode) ? -j : j;
            i.value = $848b1ce88e755b32$var$Ze(parseFloat((i.value + Q).toFixed(d.value)), l.value, s.value), B();
        }
        function E(k, j) {
            let Q = $848b1ce88e755b32$var$yt(k), w = Math.abs(Q.top - c.top), H = Math.sqrt(w ** 2 + Math.abs(Q.left - c.left) ** 2), W = Math.asin(w / H) * (180 / Math.PI);
            Q.top < c.top ? W = c.left < Q.left ? 90 - W : 270 + W : W = c.left < Q.left ? W + 90 : 270 - W, n.lang.rtl === !0 ? W = $848b1ce88e755b32$var$qr(-W - e.angle, 0, 360) : e.angle && (W = $848b1ce88e755b32$var$qr(W - e.angle, 0, 360)), e.reverse === !0 && (W = 360 - W);
            let ie = e.min + W / 360 * (e.max - e.min);
            if (m.value !== 0) {
                let V = ie % m.value;
                ie = ie - V + (Math.abs(V) >= m.value / 2 ? (V < 0 ? -1 : 1) * m.value : 0), ie = parseFloat(ie.toFixed(d.value));
            }
            ie = $848b1ce88e755b32$var$Ze(ie, l.value, s.value), o("dragValue", ie), i.value !== ie && (i.value = ie), B(j);
        }
        function A(k) {
            $848b1ce88e755b32$var$ng.includes(k.keyCode) && B(!0);
        }
        function B(k) {
            e.modelValue !== i.value && o("update:modelValue", i.value), k === !0 && o("change", i.value);
        }
        let q = $848b1ce88e755b32$var$cn(e);
        function x() {
            return (0, $fVLUl.h)("input", q.value);
        }
        return ()=>{
            let k = {
                class: f.value,
                role: "slider",
                "aria-valuemin": l.value,
                "aria-valuemax": s.value,
                "aria-valuenow": e.modelValue,
                ...C.value,
                ...b.value,
                value: i.value,
                instantFeedback: y.value,
                ...p.value
            }, j = {
                default: t.default
            };
            return v.value === !0 && e.name !== void 0 && (j.internal = x), $848b1ce88e755b32$var$kt($848b1ce88e755b32$export$3bbfcedf93eff7f7, k, j, "knob", v.value, ()=>g.value);
        };
    }
});
var { passive: $848b1ce88e755b32$var$ag } = $848b1ce88e755b32$var$Xe, $848b1ce88e755b32$var$V1 = [
    "both",
    "horizontal",
    "vertical"
], $848b1ce88e755b32$export$d6d34850bd31dad = $848b1ce88e755b32$var$R({
    name: "QScrollObserver",
    props: {
        axis: {
            type: String,
            validator: (e)=>$848b1ce88e755b32$var$V1.includes(e),
            default: "vertical"
        },
        debounce: [
            String,
            Number
        ],
        scrollTarget: {
            default: void 0
        }
    },
    emits: [
        "scroll"
    ],
    setup (e, { emit: t }) {
        let o = {
            position: {
                top: 0,
                left: 0
            },
            direction: "down",
            directionChanged: !1,
            delta: {
                top: 0,
                left: 0
            },
            inflectionPoint: {
                top: 0,
                left: 0
            }
        }, r = null, n, i;
        (0, $eayOh.watch)(()=>e.scrollTarget, ()=>{
            s(), l();
        });
        function a() {
            r !== null && r();
            let v = Math.max(0, $848b1ce88e755b32$var$fo(n)), f = $848b1ce88e755b32$var$er(n), d = {
                top: v - o.position.top,
                left: f - o.position.left
            };
            if (e.axis === "vertical" && d.top === 0 || e.axis === "horizontal" && d.left === 0) return;
            let m = Math.abs(d.top) >= Math.abs(d.left) ? d.top < 0 ? "up" : "down" : d.left < 0 ? "left" : "right";
            o.position = {
                top: v,
                left: f
            }, o.directionChanged = o.direction !== m, o.delta = d, o.directionChanged === !0 && (o.direction = m, o.inflectionPoint = o.position), t("scroll", {
                ...o
            });
        }
        function l() {
            n = $848b1ce88e755b32$var$At(i, e.scrollTarget), n.addEventListener("scroll", c, $848b1ce88e755b32$var$ag), c(!0);
        }
        function s() {
            n !== void 0 && (n.removeEventListener("scroll", c, $848b1ce88e755b32$var$ag), n = void 0);
        }
        function c(v) {
            if (v === !0 || e.debounce === 0 || e.debounce === "0") a();
            else if (r === null) {
                let [f, d] = e.debounce ? [
                    setTimeout(a, e.debounce),
                    clearTimeout
                ] : [
                    requestAnimationFrame(a),
                    cancelAnimationFrame
                ];
                r = ()=>{
                    d(f), r = null;
                };
            }
        }
        let { proxy: u } = (0, $fVLUl.getCurrentInstance)();
        return (0, $eayOh.watch)(()=>u.$q.lang.rtl, a), (0, $fVLUl.onMounted)(()=>{
            i = u.$el.parentNode, l();
        }), (0, $fVLUl.onBeforeUnmount)(()=>{
            r !== null && r(), s();
        }), Object.assign(u, {
            trigger: c,
            getPosition: ()=>o
        }), $848b1ce88e755b32$export$8793edee2d425525;
    }
});
var $848b1ce88e755b32$export$c40af6af424a1775 = $848b1ce88e755b32$var$R({
    name: "QLayout",
    props: {
        container: Boolean,
        view: {
            type: String,
            default: "hhh lpr fff",
            validator: (e)=>/^(h|l)h(h|r) lpr (f|l)f(f|r)$/.test(e.toLowerCase())
        },
        onScroll: Function,
        onScrollHeight: Function,
        onResize: Function
    },
    setup (e, { slots: t, emit: o }) {
        let { proxy: { $q: r } } = (0, $fVLUl.getCurrentInstance)(), n = (0, $eayOh.ref)(null), i = (0, $eayOh.ref)(r.screen.height), a = (0, $eayOh.ref)(e.container === !0 ? 0 : r.screen.width), l = (0, $eayOh.ref)({
            position: 0,
            direction: "down",
            inflectionPoint: 0
        }), s = (0, $eayOh.ref)(0), c = (0, $eayOh.ref)($848b1ce88e755b32$var$bt.value === !0 ? 0 : $848b1ce88e755b32$var$Pr()), u = (0, $eayOh.computed)(()=>"q-layout q-layout--" + (e.container === !0 ? "containerized" : "standard")), v = (0, $eayOh.computed)(()=>e.container === !1 ? {
                minHeight: r.screen.height + "px"
            } : null), f = (0, $eayOh.computed)(()=>c.value !== 0 ? {
                [r.lang.rtl === !0 ? "left" : "right"]: `${c.value}px`
            } : null), d = (0, $eayOh.computed)(()=>c.value !== 0 ? {
                [r.lang.rtl === !0 ? "right" : "left"]: 0,
                [r.lang.rtl === !0 ? "left" : "right"]: `-${c.value}px`,
                width: `calc(100% + ${c.value}px)`
            } : null);
        function m(g) {
            if (e.container === !0 || document.qScrollPrevented !== !0) {
                let S = {
                    position: g.position.top,
                    direction: g.direction,
                    directionChanged: g.directionChanged,
                    inflectionPoint: g.inflectionPoint.top,
                    delta: g.delta.top
                };
                l.value = S, e.onScroll !== void 0 && o("scroll", S);
            }
        }
        function y(g) {
            let { height: S, width: P } = g, $ = !1;
            i.value !== S && ($ = !0, i.value = S, e.onScrollHeight !== void 0 && o("scrollHeight", S), C()), a.value !== P && ($ = !0, a.value = P), $ === !0 && e.onResize !== void 0 && o("resize", g);
        }
        function p({ height: g }) {
            s.value !== g && (s.value = g, C());
        }
        function C() {
            if (e.container === !0) {
                let g = i.value > s.value ? $848b1ce88e755b32$var$Pr() : 0;
                c.value !== g && (c.value = g);
            }
        }
        let b = null, h = {
            instances: {},
            view: (0, $eayOh.computed)(()=>e.view),
            isContainer: (0, $eayOh.computed)(()=>e.container),
            rootRef: n,
            height: i,
            containerHeight: s,
            scrollbarWidth: c,
            totalWidth: (0, $eayOh.computed)(()=>a.value + c.value),
            rows: (0, $eayOh.computed)(()=>{
                let g = e.view.toLowerCase().split(" ");
                return {
                    top: g[0].split(""),
                    middle: g[1].split(""),
                    bottom: g[2].split("")
                };
            }),
            header: (0, $eayOh.reactive)({
                size: 0,
                offset: 0,
                space: !1
            }),
            right: (0, $eayOh.reactive)({
                size: 300,
                offset: 0,
                space: !1
            }),
            footer: (0, $eayOh.reactive)({
                size: 0,
                offset: 0,
                space: !1
            }),
            left: (0, $eayOh.reactive)({
                size: 300,
                offset: 0,
                space: !1
            }),
            scroll: l,
            animate () {
                b !== null ? clearTimeout(b) : document.body.classList.add("q-body--layout-animate"), b = setTimeout(()=>{
                    b = null, document.body.classList.remove("q-body--layout-animate");
                }, 155);
            },
            update (g, S, P) {
                h[g][S] = P;
            }
        };
        if ((0, $fVLUl.provide)($848b1ce88e755b32$var$co, h), $848b1ce88e755b32$var$Pr() > 0) {
            let P = function() {
                g = null, S.classList.remove("hide-scrollbar");
            }, $ = function() {
                if (g === null) {
                    if (S.scrollHeight > r.screen.height) return;
                    S.classList.add("hide-scrollbar");
                } else clearTimeout(g);
                g = setTimeout(P, 300);
            }, L = function(E) {
                g !== null && E === "remove" && (clearTimeout(g), P()), window[`${E}EventListener`]("resize", $);
            }, g = null, S = document.body;
            (0, $eayOh.watch)(()=>e.container !== !0 ? "add" : "remove", L), e.container !== !0 && L("add"), (0, $fVLUl.onUnmounted)(()=>{
                L("remove");
            });
        }
        return ()=>{
            let g = $848b1ce88e755b32$var$Ke(t.default, [
                (0, $fVLUl.h)($848b1ce88e755b32$export$d6d34850bd31dad, {
                    onScroll: m
                }),
                (0, $fVLUl.h)($848b1ce88e755b32$export$614f53fe102a3da7, {
                    onResize: y
                })
            ]), S = (0, $fVLUl.h)("div", {
                class: u.value,
                style: v.value,
                ref: e.container === !0 ? void 0 : n,
                tabindex: -1
            }, g);
            return e.container === !0 ? (0, $fVLUl.h)("div", {
                class: "q-layout-container overflow-hidden",
                ref: n
            }, [
                (0, $fVLUl.h)($848b1ce88e755b32$export$614f53fe102a3da7, {
                    onResize: p
                }),
                (0, $fVLUl.h)("div", {
                    class: "absolute-full",
                    style: f.value
                }, [
                    (0, $fVLUl.h)("div", {
                        class: "scroll",
                        style: d.value
                    }, [
                        S
                    ])
                ])
            ]) : S;
        };
    }
});
var $848b1ce88e755b32$var$j1 = [
    "horizontal",
    "vertical",
    "cell",
    "none"
], $848b1ce88e755b32$export$96e16f0b01ad0bca = $848b1ce88e755b32$var$R({
    name: "QMarkupTable",
    props: {
        ...$848b1ce88e755b32$var$he,
        dense: Boolean,
        flat: Boolean,
        bordered: Boolean,
        square: Boolean,
        wrapCells: Boolean,
        separator: {
            type: String,
            default: "horizontal",
            validator: (e)=>$848b1ce88e755b32$var$j1.includes(e)
        }
    },
    setup (e, { slots: t }) {
        let o = (0, $fVLUl.getCurrentInstance)(), r = $848b1ce88e755b32$var$pe(e, o.proxy.$q), n = (0, $eayOh.computed)(()=>`q-markup-table q-table__container q-table__card q-table--${e.separator}-separator` + (r.value === !0 ? " q-table--dark q-table__card--dark q-dark" : "") + (e.dense === !0 ? " q-table--dense" : "") + (e.flat === !0 ? " q-table--flat" : "") + (e.bordered === !0 ? " q-table--bordered" : "") + (e.square === !0 ? " q-table--square" : "") + (e.wrapCells === !1 ? " q-table--no-wrap" : ""));
        return ()=>(0, $fVLUl.h)("div", {
                class: n.value
            }, [
                (0, $fVLUl.h)("table", {
                    class: "q-table"
                }, $848b1ce88e755b32$var$J(t.default))
            ]);
    }
});
var $848b1ce88e755b32$export$20500169d4287824 = $848b1ce88e755b32$var$R({
    name: "QNoSsr",
    props: {
        tag: {
            type: String,
            default: "div"
        },
        placeholder: String
    },
    setup (e, { slots: t }) {
        let { isHydrated: o } = $848b1ce88e755b32$export$5b8689c380bcb3d5();
        return ()=>{
            if (o.value === !0) {
                let i = $848b1ce88e755b32$var$J(t.default);
                return i === void 0 ? i : i.length > 1 ? (0, $fVLUl.h)(e.tag, {}, i) : i[0];
            }
            let r = {
                class: "q-no-ssr-placeholder"
            }, n = $848b1ce88e755b32$var$J(t.placeholder);
            if (n !== void 0) return n.length > 1 ? (0, $fVLUl.h)(e.tag, r, n) : n[0];
            if (e.placeholder !== void 0) return (0, $fVLUl.h)(e.tag, r, e.placeholder);
        };
    }
});
var $848b1ce88e755b32$var$W1 = (0, $fVLUl.h)("svg", {
    key: "svg",
    class: "q-radio__bg absolute non-selectable",
    viewBox: "0 0 24 24"
}, [
    (0, $fVLUl.h)("path", {
        d: "M12,22a10,10 0 0 1 -10,-10a10,10 0 0 1 10,-10a10,10 0 0 1 10,10a10,10 0 0 1 -10,10m0,-22a12,12 0 0 0 -12,12a12,12 0 0 0 12,12a12,12 0 0 0 12,-12a12,12 0 0 0 -12,-12"
    }),
    (0, $fVLUl.h)("path", {
        class: "q-radio__check",
        d: "M12,6a6,6 0 0 0 -6,6a6,6 0 0 0 6,6a6,6 0 0 0 6,-6a6,6 0 0 0 -6,-6"
    })
]), $848b1ce88e755b32$export$339924d2c57b87f = $848b1ce88e755b32$var$R({
    name: "QRadio",
    props: {
        ...$848b1ce88e755b32$var$he,
        ...$848b1ce88e755b32$var$Ot,
        ...$848b1ce88e755b32$var$_t,
        modelValue: {
            required: !0
        },
        val: {
            required: !0
        },
        label: String,
        leftLabel: Boolean,
        checkedIcon: String,
        uncheckedIcon: String,
        color: String,
        keepColor: Boolean,
        dense: Boolean,
        disable: Boolean,
        tabindex: [
            String,
            Number
        ]
    },
    emits: [
        "update:modelValue"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: r } = (0, $fVLUl.getCurrentInstance)(), n = $848b1ce88e755b32$var$pe(e, r.$q), i = $848b1ce88e755b32$var$It(e, $848b1ce88e755b32$var$Gl), a = (0, $eayOh.ref)(null), { refocusTargetEl: l, refocusTarget: s } = $848b1ce88e755b32$var$Xl(e, a), c = (0, $eayOh.computed)(()=>(0, $eayOh.toRaw)(e.modelValue) === (0, $eayOh.toRaw)(e.val)), u = (0, $eayOh.computed)(()=>"q-radio cursor-pointer no-outline row inline no-wrap items-center" + (e.disable === !0 ? " disabled" : "") + (n.value === !0 ? " q-radio--dark" : "") + (e.dense === !0 ? " q-radio--dense" : "") + (e.leftLabel === !0 ? " reverse" : "")), v = (0, $eayOh.computed)(()=>{
            let h = e.color !== void 0 && (e.keepColor === !0 || c.value === !0) ? ` text-${e.color}` : "";
            return `q-radio__inner relative-position q-radio__inner--${c.value === !0 ? "truthy" : "falsy"}${h}`;
        }), f = (0, $eayOh.computed)(()=>(c.value === !0 ? e.checkedIcon : e.uncheckedIcon) || null), d = (0, $eayOh.computed)(()=>e.disable === !0 ? -1 : e.tabindex || 0), m = (0, $eayOh.computed)(()=>{
            let h = {
                type: "radio"
            };
            return e.name !== void 0 && Object.assign(h, {
                ".checked": c.value === !0,
                "^checked": c.value === !0 ? "checked" : void 0,
                name: e.name,
                value: e.val
            }), h;
        }), y = $848b1ce88e755b32$var$eo(m);
        function p(h) {
            h !== void 0 && ($848b1ce88e755b32$var$Se(h), s(h)), e.disable !== !0 && c.value !== !0 && o("update:modelValue", e.val, h);
        }
        function C(h) {
            (h.keyCode === 13 || h.keyCode === 32) && $848b1ce88e755b32$var$Se(h);
        }
        function b(h) {
            (h.keyCode === 13 || h.keyCode === 32) && p(h);
        }
        return Object.assign(r, {
            set: p
        }), ()=>{
            let h = f.value !== null ? [
                (0, $fVLUl.h)("div", {
                    key: "icon",
                    class: "q-radio__icon-container absolute-full flex flex-center no-wrap"
                }, [
                    (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                        class: "q-radio__icon",
                        name: f.value
                    })
                ])
            ] : [
                $848b1ce88e755b32$var$W1
            ];
            e.disable !== !0 && y(h, "unshift", " q-radio__native q-ma-none q-pa-none");
            let g = [
                (0, $fVLUl.h)("div", {
                    class: v.value,
                    style: i.value,
                    "aria-hidden": "true"
                }, h)
            ];
            l.value !== null && g.push(l.value);
            let S = e.label !== void 0 ? $848b1ce88e755b32$var$Ke(t.default, [
                e.label
            ]) : $848b1ce88e755b32$var$J(t.default);
            return S !== void 0 && g.push((0, $fVLUl.h)("div", {
                class: "q-radio__label q-anchor--skip"
            }, S)), (0, $fVLUl.h)("div", {
                ref: a,
                class: u.value,
                tabindex: d.value,
                role: "radio",
                "aria-label": e.label,
                "aria-checked": c.value === !0 ? "true" : "false",
                "aria-disabled": e.disable === !0 ? "true" : void 0,
                onClick: p,
                onKeydown: C,
                onKeyup: b
            }, g);
        };
    }
});
var $848b1ce88e755b32$export$16e415cb3321864c = $848b1ce88e755b32$var$R({
    name: "QToggle",
    props: {
        ...$848b1ce88e755b32$var$Zl,
        icon: String,
        iconColor: String
    },
    emits: $848b1ce88e755b32$var$Jl,
    setup (e) {
        function t(o, r) {
            let n = (0, $eayOh.computed)(()=>(o.value === !0 ? e.checkedIcon : r.value === !0 ? e.indeterminateIcon : e.uncheckedIcon) || e.icon), i = (0, $eayOh.computed)(()=>o.value === !0 ? e.iconColor : null);
            return ()=>[
                    (0, $fVLUl.h)("div", {
                        class: "q-toggle__track"
                    }),
                    (0, $fVLUl.h)("div", {
                        class: "q-toggle__thumb absolute flex flex-center no-wrap"
                    }, n.value !== void 0 ? [
                        (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                            name: n.value,
                            color: i.value
                        })
                    ] : void 0)
                ];
        }
        return $848b1ce88e755b32$var$eu("toggle", t);
    }
});
var $848b1ce88e755b32$var$fg = {
    radio: $848b1ce88e755b32$export$339924d2c57b87f,
    checkbox: $848b1ce88e755b32$export$a3430661ad019cfb,
    toggle: $848b1ce88e755b32$export$16e415cb3321864c
}, $848b1ce88e755b32$var$X1 = Object.keys($848b1ce88e755b32$var$fg), $848b1ce88e755b32$export$3ceb287b9597da0e = $848b1ce88e755b32$var$R({
    name: "QOptionGroup",
    props: {
        ...$848b1ce88e755b32$var$he,
        modelValue: {
            required: !0
        },
        options: {
            type: Array,
            validator: (e)=>e.every((t)=>"value" in t && "label" in t)
        },
        name: String,
        type: {
            default: "radio",
            validator: (e)=>$848b1ce88e755b32$var$X1.includes(e)
        },
        color: String,
        keepColor: Boolean,
        dense: Boolean,
        size: String,
        leftLabel: Boolean,
        inline: Boolean,
        disable: Boolean
    },
    emits: [
        "update:modelValue"
    ],
    setup (e, { emit: t, slots: o }) {
        let { proxy: { $q: r } } = (0, $fVLUl.getCurrentInstance)(), n = Array.isArray(e.modelValue);
        e.type === "radio" ? n === !0 && console.error("q-option-group: model should not be array") : n === !1 && console.error("q-option-group: model should be array in your case");
        let i = $848b1ce88e755b32$var$pe(e, r), a = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$fg[e.type]), l = (0, $eayOh.computed)(()=>"q-option-group q-gutter-x-sm" + (e.inline === !0 ? " q-option-group--inline" : "")), s = (0, $eayOh.computed)(()=>{
            let u = {
                role: "group"
            };
            return e.type === "radio" && (u.role = "radiogroup", e.disable === !0 && (u["aria-disabled"] = "true")), u;
        });
        function c(u) {
            t("update:modelValue", u);
        }
        return ()=>(0, $fVLUl.h)("div", {
                class: l.value,
                ...s.value
            }, e.options.map((u, v)=>{
                let f = o["label-" + v] !== void 0 ? ()=>o["label-" + v](u) : o.label !== void 0 ? ()=>o.label(u) : void 0;
                return (0, $fVLUl.h)("div", [
                    (0, $fVLUl.h)(a.value, {
                        modelValue: e.modelValue,
                        val: u.value,
                        name: u.name === void 0 ? e.name : u.name,
                        disable: e.disable || u.disable,
                        label: f === void 0 ? u.label : null,
                        leftLabel: u.leftLabel === void 0 ? e.leftLabel : u.leftLabel,
                        color: u.color === void 0 ? e.color : u.color,
                        checkedIcon: u.checkedIcon,
                        uncheckedIcon: u.uncheckedIcon,
                        dark: u.dark || i.value,
                        size: u.size === void 0 ? e.size : u.size,
                        dense: e.dense,
                        keepColor: u.keepColor === void 0 ? e.keepColor : u.keepColor,
                        "onUpdate:modelValue": c
                    }, f)
                ]);
            }));
    }
});
var $848b1ce88e755b32$export$2739fb63d58d99fc = $848b1ce88e755b32$var$R({
    name: "QPage",
    props: {
        padding: Boolean,
        styleFn: Function
    },
    setup (e, { slots: t }) {
        let { proxy: { $q: o } } = (0, $fVLUl.getCurrentInstance)(), r = (0, $fVLUl.inject)($848b1ce88e755b32$var$co, $848b1ce88e755b32$var$Ye);
        if (r === $848b1ce88e755b32$var$Ye) return console.error("QPage needs to be a deep child of QLayout"), $848b1ce88e755b32$var$Ye;
        if ((0, $fVLUl.inject)($848b1ce88e755b32$var$kl, $848b1ce88e755b32$var$Ye) === $848b1ce88e755b32$var$Ye) return console.error("QPage needs to be child of QPageContainer"), $848b1ce88e755b32$var$Ye;
        let i = (0, $eayOh.computed)(()=>{
            let l = (r.header.space === !0 ? r.header.size : 0) + (r.footer.space === !0 ? r.footer.size : 0);
            if (typeof e.styleFn == "function") {
                let s = r.isContainer.value === !0 ? r.containerHeight.value : o.screen.height;
                return e.styleFn(l, s);
            }
            return {
                minHeight: r.isContainer.value === !0 ? r.containerHeight.value - l + "px" : o.screen.height === 0 ? l !== 0 ? `calc(100vh - ${l}px)` : "100vh" : o.screen.height - l + "px"
            };
        }), a = (0, $eayOh.computed)(()=>`q-page${e.padding === !0 ? " q-layout-padding" : ""}`);
        return ()=>(0, $fVLUl.h)("main", {
                class: a.value,
                style: i.value
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$export$c532236a32af6b2e = $848b1ce88e755b32$var$R({
    name: "QPageContainer",
    setup (e, { slots: t }) {
        let { proxy: { $q: o } } = (0, $fVLUl.getCurrentInstance)(), r = (0, $fVLUl.inject)($848b1ce88e755b32$var$co, $848b1ce88e755b32$var$Ye);
        if (r === $848b1ce88e755b32$var$Ye) return console.error("QPageContainer needs to be child of QLayout"), $848b1ce88e755b32$var$Ye;
        (0, $fVLUl.provide)($848b1ce88e755b32$var$kl, !0);
        let n = (0, $eayOh.computed)(()=>{
            let i = {};
            return r.header.space === !0 && (i.paddingTop = `${r.header.size}px`), r.right.space === !0 && (i[`padding${o.lang.rtl === !0 ? "Left" : "Right"}`] = `${r.right.size}px`), r.footer.space === !0 && (i.paddingBottom = `${r.footer.size}px`), r.left.space === !0 && (i[`padding${o.lang.rtl === !0 ? "Right" : "Left"}`] = `${r.left.size}px`), i;
        });
        return ()=>(0, $fVLUl.h)("div", {
                class: "q-page-container",
                style: n.value
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$var$Zu = {
    position: {
        type: String,
        default: "bottom-right",
        validator: (e)=>[
                "top-right",
                "top-left",
                "bottom-right",
                "bottom-left",
                "top",
                "right",
                "bottom",
                "left"
            ].includes(e)
    },
    offset: {
        type: Array,
        validator: (e)=>e.length === 2
    },
    expand: Boolean
};
function $848b1ce88e755b32$var$Ju() {
    let { props: e, proxy: { $q: t } } = (0, $fVLUl.getCurrentInstance)(), o = (0, $fVLUl.inject)($848b1ce88e755b32$var$co, $848b1ce88e755b32$var$Ye);
    if (o === $848b1ce88e755b32$var$Ye) return console.error("QPageSticky needs to be child of QLayout"), $848b1ce88e755b32$var$Ye;
    let r = (0, $eayOh.computed)(()=>{
        let v = e.position;
        return {
            top: v.indexOf("top") !== -1,
            right: v.indexOf("right") !== -1,
            bottom: v.indexOf("bottom") !== -1,
            left: v.indexOf("left") !== -1,
            vertical: v === "top" || v === "bottom",
            horizontal: v === "left" || v === "right"
        };
    }), n = (0, $eayOh.computed)(()=>o.header.offset), i = (0, $eayOh.computed)(()=>o.right.offset), a = (0, $eayOh.computed)(()=>o.footer.offset), l = (0, $eayOh.computed)(()=>o.left.offset), s = (0, $eayOh.computed)(()=>{
        let v = 0, f = 0, d = r.value, m = t.lang.rtl === !0 ? -1 : 1;
        d.top === !0 && n.value !== 0 ? f = `${n.value}px` : d.bottom === !0 && a.value !== 0 && (f = `${-a.value}px`), d.left === !0 && l.value !== 0 ? v = `${m * l.value}px` : d.right === !0 && i.value !== 0 && (v = `${-m * i.value}px`);
        let y = {
            transform: `translate(${v}, ${f})`
        };
        return e.offset && (y.margin = `${e.offset[1]}px ${e.offset[0]}px`), d.vertical === !0 ? (l.value !== 0 && (y[t.lang.rtl === !0 ? "right" : "left"] = `${l.value}px`), i.value !== 0 && (y[t.lang.rtl === !0 ? "left" : "right"] = `${i.value}px`)) : d.horizontal === !0 && (n.value !== 0 && (y.top = `${n.value}px`), a.value !== 0 && (y.bottom = `${a.value}px`)), y;
    }), c = (0, $eayOh.computed)(()=>`q-page-sticky row flex-center fixed-${e.position} q-page-sticky--${e.expand === !0 ? "expand" : "shrink"}`);
    function u(v) {
        let f = $848b1ce88e755b32$var$J(v.default);
        return (0, $fVLUl.h)("div", {
            class: c.value,
            style: s.value
        }, e.expand === !0 ? f : [
            (0, $fVLUl.h)("div", f)
        ]);
    }
    return {
        $layout: o,
        getStickyContent: u
    };
}
var $848b1ce88e755b32$export$757ee84fd3b4950f = $848b1ce88e755b32$var$R({
    name: "QPageScroller",
    props: {
        ...$848b1ce88e755b32$var$Zu,
        scrollOffset: {
            type: Number,
            default: 1e3
        },
        reverse: Boolean,
        duration: {
            type: Number,
            default: 300
        },
        offset: {
            default: ()=>[
                    18,
                    18
                ]
        }
    },
    emits: [
        "click"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: { $q: r } } = (0, $fVLUl.getCurrentInstance)(), { $layout: n, getStickyContent: i } = $848b1ce88e755b32$var$Ju(), a = (0, $eayOh.ref)(null), l, s = (0, $eayOh.computed)(()=>n.height.value - (n.isContainer.value === !0 ? n.containerHeight.value : r.screen.height));
        function c() {
            return e.reverse === !0 ? s.value - n.scroll.value.position > e.scrollOffset : n.scroll.value.position > e.scrollOffset;
        }
        let u = (0, $eayOh.ref)(c());
        function v() {
            let p = c();
            u.value !== p && (u.value = p);
        }
        function f() {
            e.reverse === !0 ? l === void 0 && (l = (0, $eayOh.watch)(s, v)) : d();
        }
        (0, $eayOh.watch)(n.scroll, v), (0, $eayOh.watch)(()=>e.reverse, f);
        function d() {
            l !== void 0 && (l(), l = void 0);
        }
        function m(p) {
            let C = $848b1ce88e755b32$var$At(n.isContainer.value === !0 ? a.value : n.rootRef.value);
            $848b1ce88e755b32$var$un(C, e.reverse === !0 ? n.height.value : 0, e.duration), o("click", p);
        }
        function y() {
            return u.value === !0 ? (0, $fVLUl.h)("div", {
                ref: a,
                class: "q-page-scroller",
                onClick: m
            }, i(t)) : null;
        }
        return f(), (0, $fVLUl.onBeforeUnmount)(d), ()=>(0, $fVLUl.h)((0, $24349.Transition), {
                name: "q-transition--fade"
            }, y);
    }
});
var $848b1ce88e755b32$export$fb6e3b1b2833174c = $848b1ce88e755b32$var$R({
    name: "QPageSticky",
    props: $848b1ce88e755b32$var$Zu,
    setup (e, { slots: t }) {
        let { getStickyContent: o } = $848b1ce88e755b32$var$Ju();
        return ()=>o(t);
    }
});
function $848b1ce88e755b32$var$es(e, t) {
    return [
        !0,
        !1
    ].includes(e) ? e : t;
}
var $848b1ce88e755b32$export$e0e0e4dfbf7cf819 = $848b1ce88e755b32$var$R({
    name: "QPagination",
    props: {
        ...$848b1ce88e755b32$var$he,
        modelValue: {
            type: Number,
            required: !0
        },
        min: {
            type: [
                Number,
                String
            ],
            default: 1
        },
        max: {
            type: [
                Number,
                String
            ],
            required: !0
        },
        maxPages: {
            type: [
                Number,
                String
            ],
            default: 0,
            validator: (e)=>(typeof e == "string" ? parseInt(e, 10) : e) >= 0
        },
        inputStyle: [
            Array,
            String,
            Object
        ],
        inputClass: [
            Array,
            String,
            Object
        ],
        size: String,
        disable: Boolean,
        input: Boolean,
        iconPrev: String,
        iconNext: String,
        iconFirst: String,
        iconLast: String,
        toFn: Function,
        boundaryLinks: {
            type: Boolean,
            default: null
        },
        boundaryNumbers: {
            type: Boolean,
            default: null
        },
        directionLinks: {
            type: Boolean,
            default: null
        },
        ellipses: {
            type: Boolean,
            default: null
        },
        ripple: {
            type: [
                Boolean,
                Object
            ],
            default: null
        },
        round: Boolean,
        rounded: Boolean,
        flat: Boolean,
        outline: Boolean,
        unelevated: Boolean,
        push: Boolean,
        glossy: Boolean,
        color: {
            type: String,
            default: "primary"
        },
        textColor: String,
        activeDesign: {
            type: String,
            default: "",
            values: (e)=>e === "" || $848b1ce88e755b32$var$ac.includes(e)
        },
        activeColor: String,
        activeTextColor: String,
        gutter: String,
        padding: {
            type: String,
            default: "3px 2px"
        }
    },
    emits: [
        "update:modelValue"
    ],
    setup (e, { emit: t }) {
        let { proxy: o } = (0, $fVLUl.getCurrentInstance)(), { $q: r } = o, n = $848b1ce88e755b32$var$pe(e, r), i = (0, $eayOh.computed)(()=>parseInt(e.min, 10)), a = (0, $eayOh.computed)(()=>parseInt(e.max, 10)), l = (0, $eayOh.computed)(()=>parseInt(e.maxPages, 10)), s = (0, $eayOh.computed)(()=>m.value + " / " + a.value), c = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$es(e.boundaryLinks, e.input)), u = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$es(e.boundaryNumbers, !e.input)), v = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$es(e.directionLinks, e.input)), f = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$es(e.ellipses, !e.input)), d = (0, $eayOh.ref)(null), m = (0, $eayOh.computed)({
            get: ()=>e.modelValue,
            set: (x)=>{
                if (x = parseInt(x, 10), e.disable || isNaN(x)) return;
                let k = $848b1ce88e755b32$var$Ze(x, i.value, a.value);
                e.modelValue !== k && t("update:modelValue", k);
            }
        });
        (0, $eayOh.watch)(()=>`${i.value}|${a.value}`, ()=>{
            m.value = e.modelValue;
        });
        let y = (0, $eayOh.computed)(()=>"q-pagination row no-wrap items-center" + (e.disable === !0 ? " disabled" : "")), p = (0, $eayOh.computed)(()=>e.gutter in $848b1ce88e755b32$var$Aa ? `${$848b1ce88e755b32$var$Aa[e.gutter]}px` : e.gutter || null), C = (0, $eayOh.computed)(()=>p.value !== null ? `--q-pagination-gutter-parent:-${p.value};--q-pagination-gutter-child:${p.value}` : null), b = (0, $eayOh.computed)(()=>{
            let x = [
                e.iconFirst || r.iconSet.pagination.first,
                e.iconPrev || r.iconSet.pagination.prev,
                e.iconNext || r.iconSet.pagination.next,
                e.iconLast || r.iconSet.pagination.last
            ];
            return r.lang.rtl === !0 ? x.reverse() : x;
        }), h = (0, $eayOh.computed)(()=>({
                "aria-disabled": e.disable === !0 ? "true" : "false",
                role: "navigation"
            })), g = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$Fl(e, "flat")), S = (0, $eayOh.computed)(()=>({
                [g.value]: !0,
                round: e.round,
                rounded: e.rounded,
                padding: e.padding,
                color: e.color,
                textColor: e.textColor,
                size: e.size,
                ripple: e.ripple !== null ? e.ripple : !0
            })), P = (0, $eayOh.computed)(()=>{
            let x = {
                [g.value]: !1
            };
            return e.activeDesign !== "" && (x[e.activeDesign] = !0), x;
        }), $ = (0, $eayOh.computed)(()=>({
                ...P.value,
                color: e.activeColor || e.color,
                textColor: e.activeTextColor || e.textColor
            })), L = (0, $eayOh.computed)(()=>{
            let x = Math.max(l.value, 1 + (f.value ? 2 : 0) + (u.value ? 2 : 0)), k = {
                pgFrom: i.value,
                pgTo: a.value,
                ellipsesStart: !1,
                ellipsesEnd: !1,
                boundaryStart: !1,
                boundaryEnd: !1,
                marginalStyle: {
                    minWidth: `${Math.max(2, String(a.value).length)}em`
                }
            };
            return l.value && x < a.value - i.value + 1 && (x = 1 + Math.floor(x / 2) * 2, k.pgFrom = Math.max(i.value, Math.min(a.value - x + 1, e.modelValue - Math.floor(x / 2))), k.pgTo = Math.min(a.value, k.pgFrom + x - 1), u.value && (k.boundaryStart = !0, k.pgFrom++), f.value && k.pgFrom > i.value + (u.value ? 1 : 0) && (k.ellipsesStart = !0, k.pgFrom++), u.value && (k.boundaryEnd = !0, k.pgTo--), f.value && k.pgTo < a.value - (u.value ? 1 : 0) && (k.ellipsesEnd = !0, k.pgTo--)), k;
        });
        function E(x) {
            m.value = x;
        }
        function A(x) {
            m.value = m.value + x;
        }
        let B = (0, $eayOh.computed)(()=>{
            function x() {
                m.value = d.value, d.value = null;
            }
            return {
                "onUpdate:modelValue": (k)=>{
                    d.value = k;
                },
                onKeyup: (k)=>{
                    $848b1ce88e755b32$var$wt(k, 13) === !0 && x();
                },
                onBlur: x
            };
        });
        function q(x, k, j) {
            let Q = {
                "aria-label": k,
                "aria-current": "false",
                ...S.value,
                ...x
            };
            return j === !0 && Object.assign(Q, {
                "aria-current": "true",
                ...$.value
            }), k !== void 0 && (e.toFn !== void 0 ? Q.to = e.toFn(k) : Q.onClick = ()=>{
                E(k);
            }), (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, Q);
        }
        return Object.assign(o, {
            set: E,
            setByOffset: A
        }), ()=>{
            let x = [], k = [], j;
            if (c.value === !0 && (x.push(q({
                key: "bls",
                disable: e.disable || e.modelValue <= i.value,
                icon: b.value[0]
            }, i.value)), k.unshift(q({
                key: "ble",
                disable: e.disable || e.modelValue >= a.value,
                icon: b.value[3]
            }, a.value))), v.value === !0 && (x.push(q({
                key: "bdp",
                disable: e.disable || e.modelValue <= i.value,
                icon: b.value[1]
            }, e.modelValue - 1)), k.unshift(q({
                key: "bdn",
                disable: e.disable || e.modelValue >= a.value,
                icon: b.value[2]
            }, e.modelValue + 1))), e.input !== !0) {
                j = [];
                let { pgFrom: Q, pgTo: w, marginalStyle: H } = L.value;
                if (L.value.boundaryStart === !0) {
                    let W = i.value === e.modelValue;
                    x.push(q({
                        key: "bns",
                        style: H,
                        disable: e.disable,
                        label: i.value
                    }, i.value, W));
                }
                if (L.value.boundaryEnd === !0) {
                    let W = a.value === e.modelValue;
                    k.unshift(q({
                        key: "bne",
                        style: H,
                        disable: e.disable,
                        label: a.value
                    }, a.value, W));
                }
                L.value.ellipsesStart === !0 && x.push(q({
                    key: "bes",
                    style: H,
                    disable: e.disable,
                    label: "\u2026",
                    ripple: !1
                }, Q - 1)), L.value.ellipsesEnd === !0 && k.unshift(q({
                    key: "bee",
                    style: H,
                    disable: e.disable,
                    label: "\u2026",
                    ripple: !1
                }, w + 1));
                for(let W = Q; W <= w; W++)j.push(q({
                    key: `bpg${W}`,
                    style: H,
                    disable: e.disable,
                    label: W
                }, W, W === e.modelValue));
            }
            return (0, $fVLUl.h)("div", {
                class: y.value,
                ...h.value
            }, [
                (0, $fVLUl.h)("div", {
                    class: "q-pagination__content row no-wrap items-center",
                    style: C.value
                }, [
                    ...x,
                    e.input === !0 ? (0, $fVLUl.h)($848b1ce88e755b32$export$b1c6a0c22e16b328, {
                        class: "inline",
                        style: {
                            width: `${s.value.length / 1.5}em`
                        },
                        type: "number",
                        dense: !0,
                        value: d.value,
                        disable: e.disable,
                        dark: n.value,
                        borderless: !0,
                        inputClass: e.inputClass,
                        inputStyle: e.inputStyle,
                        placeholder: s.value,
                        min: i.value,
                        max: a.value,
                        ...B.value
                    }) : (0, $fVLUl.h)("div", {
                        class: "q-pagination__middle row justify-center"
                    }, j),
                    ...k
                ])
            ]);
        };
    }
});
function $848b1ce88e755b32$export$f07ce136d7462df5(e) {
    let t = !1, o, r;
    function n() {
        r = arguments, t !== !0 && (t = !0, o = window.requestAnimationFrame(()=>{
            e.apply(this, r), r = void 0, t = !1;
        }));
    }
    return n.cancel = ()=>{
        window.cancelAnimationFrame(o), t = !1;
    }, n;
}
var { passive: $848b1ce88e755b32$var$ns } = $848b1ce88e755b32$var$Xe, $848b1ce88e755b32$export$7edd9a653cb140a3 = $848b1ce88e755b32$var$R({
    name: "QParallax",
    props: {
        src: String,
        height: {
            type: Number,
            default: 500
        },
        speed: {
            type: Number,
            default: 1,
            validator: (e)=>e >= 0 && e <= 1
        },
        scrollTarget: {
            default: void 0
        },
        onScroll: Function
    },
    setup (e, { slots: t, emit: o }) {
        let r = (0, $eayOh.ref)(0), n = (0, $eayOh.ref)(null), i = (0, $eayOh.ref)(null), a = (0, $eayOh.ref)(null), l, s, c, u, v, f;
        (0, $eayOh.watch)(()=>e.height, ()=>{
            l === !0 && m();
        }), (0, $eayOh.watch)(()=>e.scrollTarget, ()=>{
            l === !0 && (b(), C());
        });
        let d = (h)=>{
            r.value = h, e.onScroll !== void 0 && o("scroll", h);
        };
        function m() {
            let h, g, S;
            f === window ? (h = 0, S = g = window.innerHeight) : (h = $848b1ce88e755b32$var$Tr(f).top, g = $848b1ce88e755b32$var$nn(f), S = h + g);
            let P = $848b1ce88e755b32$var$Tr(n.value).top, $ = P + e.height;
            if (v !== void 0 || $ > h && P < S) {
                let L = (S - P) / (e.height + g);
                y((c - e.height) * L * e.speed), d(L);
            }
        }
        let y = (h)=>{
            s.style.transform = `translate3d(-50%,${Math.round(h)}px,0)`;
        };
        function p() {
            c = s.naturalHeight || s.videoHeight || $848b1ce88e755b32$var$nn(s), l === !0 && m();
        }
        function C() {
            l = !0, f = $848b1ce88e755b32$var$At(n.value, e.scrollTarget), f.addEventListener("scroll", m, $848b1ce88e755b32$var$ns), window.addEventListener("resize", u, $848b1ce88e755b32$var$ns), m();
        }
        function b() {
            l === !0 && (l = !1, f.removeEventListener("scroll", m, $848b1ce88e755b32$var$ns), window.removeEventListener("resize", u, $848b1ce88e755b32$var$ns), f = void 0, y.cancel(), d.cancel(), u.cancel());
        }
        return (0, $fVLUl.onMounted)(()=>{
            y = $848b1ce88e755b32$export$f07ce136d7462df5(y), d = $848b1ce88e755b32$export$f07ce136d7462df5(d), u = $848b1ce88e755b32$export$f07ce136d7462df5(p), s = t.media !== void 0 ? i.value.children[0] : a.value, s.onload = s.onloadstart = s.loadedmetadata = p, p(), s.style.display = "initial", window.IntersectionObserver !== void 0 ? (v = new IntersectionObserver((h)=>{
                (h[0].isIntersecting === !0 ? C : b)();
            }), v.observe(n.value)) : C();
        }), (0, $fVLUl.onBeforeUnmount)(()=>{
            b(), v !== void 0 && v.disconnect(), s.onload = s.onloadstart = s.loadedmetadata = null;
        }), ()=>(0, $fVLUl.h)("div", {
                ref: n,
                class: "q-parallax",
                style: {
                    height: `${e.height}px`
                }
            }, [
                (0, $fVLUl.h)("div", {
                    ref: i,
                    class: "q-parallax__media absolute-full"
                }, t.media !== void 0 ? t.media() : [
                    (0, $fVLUl.h)("img", {
                        ref: a,
                        src: e.src
                    })
                ]),
                (0, $fVLUl.h)("div", {
                    class: "q-parallax__content absolute-full column flex-center"
                }, t.content !== void 0 ? t.content({
                    percentScrolled: r.value
                }) : $848b1ce88e755b32$var$J(t.default))
            ]);
    }
});
function $848b1ce88e755b32$export$9cd59f9826255e47(e, t = new WeakMap) {
    if (Object(e) !== e) return e;
    if (t.has(e)) return t.get(e);
    let o = e instanceof Date ? new Date(e) : e instanceof RegExp ? new RegExp(e.source, e.flags) : e instanceof Set ? new Set : e instanceof Map ? new Map : typeof e.constructor != "function" ? Object.create(null) : e.prototype !== void 0 && typeof e.prototype.constructor == "function" ? e : new e.constructor;
    if (typeof e.constructor == "function" && typeof e.valueOf == "function") {
        let r = e.valueOf();
        if (Object(r) !== r) {
            let n = new e.constructor(r);
            return t.set(e, n), n;
        }
    }
    return t.set(e, o), e instanceof Set ? e.forEach((r)=>{
        o.add($848b1ce88e755b32$export$9cd59f9826255e47(r, t));
    }) : e instanceof Map && e.forEach((r, n)=>{
        o.set(n, $848b1ce88e755b32$export$9cd59f9826255e47(r, t));
    }), Object.assign(o, ...Object.keys(e).map((r)=>({
            [r]: $848b1ce88e755b32$export$9cd59f9826255e47(e[r], t)
        })));
}
var $848b1ce88e755b32$export$7a21aee2db893a36 = $848b1ce88e755b32$var$R({
    name: "QPopupEdit",
    props: {
        modelValue: {
            required: !0
        },
        title: String,
        buttons: Boolean,
        labelSet: String,
        labelCancel: String,
        color: {
            type: String,
            default: "primary"
        },
        validate: {
            type: Function,
            default: ()=>!0
        },
        autoSave: Boolean,
        cover: {
            type: Boolean,
            default: !0
        },
        disable: Boolean
    },
    emits: [
        "update:modelValue",
        "save",
        "cancel",
        "beforeShow",
        "show",
        "beforeHide",
        "hide"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: r } = (0, $fVLUl.getCurrentInstance)(), { $q: n } = r, i = (0, $eayOh.ref)(null), a = (0, $eayOh.ref)(""), l = (0, $eayOh.ref)(""), s = !1, c = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$it({
                initialValue: a.value,
                validate: e.validate,
                set: u,
                cancel: v,
                updatePosition: f
            }, "value", ()=>l.value, (g)=>{
                l.value = g;
            }));
        function u() {
            e.validate(l.value) !== !1 && (d() === !0 && (o("save", l.value, a.value), o("update:modelValue", l.value)), m());
        }
        function v() {
            d() === !0 && o("cancel", l.value, a.value), m();
        }
        function f() {
            (0, $fVLUl.nextTick)(()=>{
                i.value.updatePosition();
            });
        }
        function d() {
            return $848b1ce88e755b32$var$Zt(l.value, a.value) === !1;
        }
        function m() {
            s = !0, i.value.hide();
        }
        function y() {
            s = !1, a.value = $848b1ce88e755b32$export$9cd59f9826255e47(e.modelValue), l.value = $848b1ce88e755b32$export$9cd59f9826255e47(e.modelValue), o("beforeShow");
        }
        function p() {
            o("show");
        }
        function C() {
            s === !1 && d() === !0 && (e.autoSave === !0 && e.validate(l.value) === !0 ? (o("save", l.value, a.value), o("update:modelValue", l.value)) : o("cancel", l.value, a.value)), o("beforeHide");
        }
        function b() {
            o("hide");
        }
        function h() {
            let g = t.default !== void 0 ? [].concat(t.default(c.value)) : [];
            return e.title && g.unshift((0, $fVLUl.h)("div", {
                class: "q-dialog__title q-mt-sm q-mb-sm"
            }, e.title)), e.buttons === !0 && g.push((0, $fVLUl.h)("div", {
                class: "q-popup-edit__buttons row justify-center no-wrap"
            }, [
                (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                    flat: !0,
                    color: e.color,
                    label: e.labelCancel || n.lang.label.cancel,
                    onClick: v
                }),
                (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                    flat: !0,
                    color: e.color,
                    label: e.labelSet || n.lang.label.set,
                    onClick: u
                })
            ])), g;
        }
        return Object.assign(r, {
            set: u,
            cancel: v,
            show (g) {
                i.value !== null && i.value.show(g);
            },
            hide (g) {
                i.value !== null && i.value.hide(g);
            },
            updatePosition: f
        }), ()=>{
            if (e.disable !== !0) return (0, $fVLUl.h)($848b1ce88e755b32$export$73537802004a2118, {
                ref: i,
                class: "q-popup-edit",
                cover: e.cover,
                onBeforeShow: y,
                onShow: p,
                onBeforeHide: C,
                onHide: b,
                onEscapeKey: v
            }, h);
        };
    }
});
var $848b1ce88e755b32$export$8d66f956927c5a7b = $848b1ce88e755b32$var$R({
    name: "QPopupProxy",
    props: {
        ...$848b1ce88e755b32$var$hi,
        breakpoint: {
            type: [
                String,
                Number
            ],
            default: 450
        }
    },
    emits: [
        "show",
        "hide"
    ],
    setup (e, { slots: t, emit: o, attrs: r }) {
        let { proxy: n } = (0, $fVLUl.getCurrentInstance)(), { $q: i } = n, a = (0, $eayOh.ref)(!1), l = (0, $eayOh.ref)(null), s = (0, $eayOh.computed)(()=>parseInt(e.breakpoint, 10)), { canShow: c } = $848b1ce88e755b32$var$pi({
            showing: a
        });
        function u() {
            return i.screen.width < s.value || i.screen.height < s.value ? "dialog" : "menu";
        }
        let v = (0, $eayOh.ref)(u()), f = (0, $eayOh.computed)(()=>v.value === "menu" ? {
                maxHeight: "99vh"
            } : {});
        (0, $eayOh.watch)(()=>u(), (y)=>{
            a.value !== !0 && (v.value = y);
        });
        function d(y) {
            a.value = !0, o("show", y);
        }
        function m(y) {
            a.value = !1, v.value = u(), o("hide", y);
        }
        return Object.assign(n, {
            show (y) {
                c(y) === !0 && l.value.show(y);
            },
            hide (y) {
                l.value.hide(y);
            },
            toggle (y) {
                l.value.toggle(y);
            }
        }), $848b1ce88e755b32$var$it(n, "currentComponent", ()=>({
                type: v.value,
                ref: l.value
            })), ()=>{
            let y = {
                ref: l,
                ...f.value,
                ...r,
                onShow: d,
                onHide: m
            }, p;
            return v.value === "dialog" ? p = $848b1ce88e755b32$export$e6ccdac5fb3e2417 : (p = $848b1ce88e755b32$export$73537802004a2118, Object.assign(y, {
                target: e.target,
                contextMenu: e.contextMenu,
                noParentEvent: !0,
                separateClosePopup: !0
            })), (0, $fVLUl.h)(p, y, t.default);
        };
    }
});
var $848b1ce88e755b32$var$_C = {
    xs: 2,
    sm: 4,
    md: 6,
    lg: 10,
    xl: 14
};
function $848b1ce88e755b32$var$Mg(e, t, o) {
    return {
        transform: t === !0 ? `translateX(${o.lang.rtl === !0 ? "-" : ""}100%) scale3d(${-e},1,1)` : `scale3d(${e},1,1)`
    };
}
var $848b1ce88e755b32$export$2d10adb726183d68 = $848b1ce88e755b32$var$R({
    name: "QLinearProgress",
    props: {
        ...$848b1ce88e755b32$var$he,
        ...$848b1ce88e755b32$var$Ot,
        value: {
            type: Number,
            default: 0
        },
        buffer: Number,
        color: String,
        trackColor: String,
        reverse: Boolean,
        stripe: Boolean,
        indeterminate: Boolean,
        query: Boolean,
        rounded: Boolean,
        animationSpeed: {
            type: [
                String,
                Number
            ],
            default: 2100
        },
        instantFeedback: Boolean
    },
    setup (e, { slots: t }) {
        let { proxy: o } = (0, $fVLUl.getCurrentInstance)(), r = $848b1ce88e755b32$var$pe(e, o.$q), n = $848b1ce88e755b32$var$It(e, $848b1ce88e755b32$var$_C), i = (0, $eayOh.computed)(()=>e.indeterminate === !0 || e.query === !0), a = (0, $eayOh.computed)(()=>e.reverse !== e.query), l = (0, $eayOh.computed)(()=>({
                ...n.value !== null ? n.value : {},
                "--q-linear-progress-speed": `${e.animationSpeed}ms`
            })), s = (0, $eayOh.computed)(()=>"q-linear-progress" + (e.color !== void 0 ? ` text-${e.color}` : "") + (e.reverse === !0 || e.query === !0 ? " q-linear-progress--reverse" : "") + (e.rounded === !0 ? " rounded-borders" : "")), c = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$Mg(e.buffer !== void 0 ? e.buffer : 1, a.value, o.$q)), u = (0, $eayOh.computed)(()=>`with${e.instantFeedback === !0 ? "out" : ""}-transition`), v = (0, $eayOh.computed)(()=>`q-linear-progress__track absolute-full q-linear-progress__track--${u.value} q-linear-progress__track--${r.value === !0 ? "dark" : "light"}` + (e.trackColor !== void 0 ? ` bg-${e.trackColor}` : "")), f = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$Mg(i.value === !0 ? 1 : e.value, a.value, o.$q)), d = (0, $eayOh.computed)(()=>`q-linear-progress__model absolute-full q-linear-progress__model--${u.value} q-linear-progress__model--${i.value === !0 ? "in" : ""}determinate`), m = (0, $eayOh.computed)(()=>({
                width: `${e.value * 100}%`
            })), y = (0, $eayOh.computed)(()=>`q-linear-progress__stripe absolute-${e.reverse === !0 ? "right" : "left"} q-linear-progress__stripe--${u.value}`);
        return ()=>{
            let p = [
                (0, $fVLUl.h)("div", {
                    class: v.value,
                    style: c.value
                }),
                (0, $fVLUl.h)("div", {
                    class: d.value,
                    style: f.value
                })
            ];
            return e.stripe === !0 && i.value === !1 && p.push((0, $fVLUl.h)("div", {
                class: y.value,
                style: m.value
            })), (0, $fVLUl.h)("div", {
                class: s.value,
                style: l.value,
                role: "progressbar",
                "aria-valuemin": 0,
                "aria-valuemax": 1,
                "aria-valuenow": e.indeterminate === !0 ? void 0 : e.value
            }, $848b1ce88e755b32$var$Ke(t.default, p));
        };
    }
});
var $848b1ce88e755b32$var$ha = 40, $848b1ce88e755b32$var$dd = 20, $848b1ce88e755b32$export$38ad2c7cb47d3fec = $848b1ce88e755b32$var$R({
    name: "QPullToRefresh",
    props: {
        color: String,
        bgColor: String,
        icon: String,
        noMouse: Boolean,
        disable: Boolean,
        scrollTarget: {
            default: void 0
        }
    },
    emits: [
        "refresh"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: r } = (0, $fVLUl.getCurrentInstance)(), { $q: n } = r, i = (0, $eayOh.ref)("pull"), a = (0, $eayOh.ref)(0), l = (0, $eayOh.ref)(!1), s = (0, $eayOh.ref)(-$848b1ce88e755b32$var$ha), c = (0, $eayOh.ref)(!1), u = (0, $eayOh.ref)({}), v = (0, $eayOh.computed)(()=>({
                opacity: a.value,
                transform: `translateY(${s.value}px) rotate(${a.value * 360}deg)`
            })), f = (0, $eayOh.computed)(()=>"q-pull-to-refresh__puller row flex-center" + (c.value === !0 ? " q-pull-to-refresh__puller--animating" : "") + (e.bgColor !== void 0 ? ` bg-${e.bgColor}` : ""));
        function d(P) {
            if (P.isFinal === !0) {
                l.value === !0 && (l.value = !1, i.value === "pulled" ? (i.value = "refreshing", g({
                    pos: $848b1ce88e755b32$var$dd
                }), p()) : i.value === "pull" && g({
                    pos: -$848b1ce88e755b32$var$ha,
                    ratio: 0
                }));
                return;
            }
            if (c.value === !0 || i.value === "refreshing") return !1;
            if (P.isFirst === !0) {
                if ($848b1ce88e755b32$var$fo(b) !== 0 || P.direction !== "down") return l.value === !0 && (l.value = !1, i.value = "pull", g({
                    pos: -$848b1ce88e755b32$var$ha,
                    ratio: 0
                })), !1;
                l.value = !0;
                let { top: E, left: A } = C.getBoundingClientRect();
                u.value = {
                    top: E + "px",
                    left: A + "px",
                    width: window.getComputedStyle(C).getPropertyValue("width")
                };
            }
            $848b1ce88e755b32$var$ut(P.evt);
            let $ = Math.min(140, Math.max(0, P.distance.y));
            s.value = $ - $848b1ce88e755b32$var$ha, a.value = $848b1ce88e755b32$var$Ze($ / ($848b1ce88e755b32$var$dd + $848b1ce88e755b32$var$ha), 0, 1);
            let L = s.value > $848b1ce88e755b32$var$dd ? "pulled" : "pull";
            i.value !== L && (i.value = L);
        }
        let m = (0, $eayOh.computed)(()=>{
            let P = {
                down: !0
            };
            return e.noMouse !== !0 && (P.mouse = !0), [
                [
                    $848b1ce88e755b32$export$718797250d1e376,
                    d,
                    void 0,
                    P
                ]
            ];
        }), y = (0, $eayOh.computed)(()=>`q-pull-to-refresh__content${l.value === !0 ? " no-pointer-events" : ""}`);
        function p() {
            o("refresh", ()=>{
                g({
                    pos: -$848b1ce88e755b32$var$ha,
                    ratio: 0
                }, ()=>{
                    i.value = "pull";
                });
            });
        }
        let C, b, h = null;
        function g({ pos: P, ratio: $ }, L) {
            c.value = !0, s.value = P, $ !== void 0 && (a.value = $), h !== null && clearTimeout(h), h = setTimeout(()=>{
                h = null, c.value = !1, L && L();
            }, 300);
        }
        function S() {
            b = $848b1ce88e755b32$var$At(C, e.scrollTarget);
        }
        return (0, $eayOh.watch)(()=>e.scrollTarget, S), (0, $fVLUl.onMounted)(()=>{
            C = r.$el, S();
        }), (0, $fVLUl.onBeforeUnmount)(()=>{
            h !== null && clearTimeout(h);
        }), Object.assign(r, {
            trigger: p,
            updateScrollTarget: S
        }), ()=>{
            let P = [
                (0, $fVLUl.h)("div", {
                    class: y.value
                }, $848b1ce88e755b32$var$J(t.default)),
                (0, $fVLUl.h)("div", {
                    class: "q-pull-to-refresh__puller-container fixed row flex-center no-pointer-events z-top",
                    style: u.value
                }, [
                    (0, $fVLUl.h)("div", {
                        class: f.value,
                        style: v.value
                    }, [
                        i.value !== "refreshing" ? (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                            name: e.icon || n.iconSet.pullToRefresh.icon,
                            color: e.color,
                            size: "32px"
                        }) : (0, $fVLUl.h)($848b1ce88e755b32$export$7418ab329b11fed0, {
                            size: "24px",
                            color: e.color
                        })
                    ])
                ])
            ];
            return $848b1ce88e755b32$var$kt("div", {
                class: "q-pull-to-refresh"
            }, P, "main", e.disable === !1, ()=>m.value);
        };
    }
});
var $848b1ce88e755b32$var$br = {
    MIN: 0,
    RANGE: 1,
    MAX: 2
}, $848b1ce88e755b32$export$396f1d127e5ea44f = $848b1ce88e755b32$var$R({
    name: "QRange",
    props: {
        ...$848b1ce88e755b32$var$ou,
        modelValue: {
            type: Object,
            default: ()=>({
                    min: null,
                    max: null
                }),
            validator: (e)=>"min" in e && "max" in e
        },
        dragRange: Boolean,
        dragOnlyRange: Boolean,
        leftLabelColor: String,
        leftLabelTextColor: String,
        rightLabelColor: String,
        rightLabelTextColor: String,
        leftLabelValue: [
            String,
            Number
        ],
        rightLabelValue: [
            String,
            Number
        ],
        leftThumbColor: String,
        rightThumbColor: String
    },
    emits: $848b1ce88e755b32$var$nu,
    setup (e, { emit: t }) {
        let { proxy: { $q: o } } = (0, $fVLUl.getCurrentInstance)(), { state: r, methods: n } = $848b1ce88e755b32$var$ru({
            updateValue: L,
            updatePosition: A,
            getDragging: E,
            formAttrs: (0, $eayOh.computed)(()=>({
                    type: "hidden",
                    name: e.name,
                    value: `${e.modelValue.min}|${e.modelValue.max}`
                }))
        }), i = (0, $eayOh.ref)(null), a = (0, $eayOh.ref)(0), l = (0, $eayOh.ref)(0), s = (0, $eayOh.ref)({
            min: 0,
            max: 0
        });
        function c() {
            s.value.min = e.modelValue.min === null ? r.innerMin.value : $848b1ce88e755b32$var$Ze(e.modelValue.min, r.innerMin.value, r.innerMax.value), s.value.max = e.modelValue.max === null ? r.innerMax.value : $848b1ce88e755b32$var$Ze(e.modelValue.max, r.innerMin.value, r.innerMax.value);
        }
        (0, $eayOh.watch)(()=>`${e.modelValue.min}|${e.modelValue.max}|${r.innerMin.value}|${r.innerMax.value}`, c), c();
        let u = (0, $eayOh.computed)(()=>n.convertModelToRatio(s.value.min)), v = (0, $eayOh.computed)(()=>n.convertModelToRatio(s.value.max)), f = (0, $eayOh.computed)(()=>r.active.value === !0 ? a.value : u.value), d = (0, $eayOh.computed)(()=>r.active.value === !0 ? l.value : v.value), m = (0, $eayOh.computed)(()=>{
            let q = {
                [r.positionProp.value]: `${100 * f.value}%`,
                [r.sizeProp.value]: `${100 * (d.value - f.value)}%`
            };
            return e.selectionImg !== void 0 && (q.backgroundImage = `url(${e.selectionImg}) !important`), q;
        }), y = (0, $eayOh.computed)(()=>{
            if (r.editable.value !== !0) return {};
            if (o.platform.is.mobile === !0) return {
                onClick: n.onMobileClick
            };
            let q = {
                onMousedown: n.onActivate
            };
            return (e.dragRange === !0 || e.dragOnlyRange === !0) && Object.assign(q, {
                onFocus: ()=>{
                    r.focus.value = "both";
                },
                onBlur: n.onBlur,
                onKeydown: B,
                onKeyup: n.onKeyup
            }), q;
        });
        function p(q) {
            return o.platform.is.mobile !== !0 && r.editable.value === !0 && e.dragOnlyRange !== !0 ? {
                onFocus: ()=>{
                    r.focus.value = q;
                },
                onBlur: n.onBlur,
                onKeydown: B,
                onKeyup: n.onKeyup
            } : {};
        }
        let C = (0, $eayOh.computed)(()=>e.dragOnlyRange !== !0 ? r.tabindex.value : null), b = (0, $eayOh.computed)(()=>o.platform.is.mobile !== !0 && (e.dragRange || e.dragOnlyRange === !0) ? r.tabindex.value : null), h = (0, $eayOh.ref)(null), g = (0, $eayOh.computed)(()=>p("min")), S = n.getThumbRenderFn({
            focusValue: "min",
            getNodeData: ()=>({
                    ref: h,
                    key: "tmin",
                    ...g.value,
                    tabindex: C.value
                }),
            ratio: f,
            label: (0, $eayOh.computed)(()=>e.leftLabelValue !== void 0 ? e.leftLabelValue : s.value.min),
            thumbColor: (0, $eayOh.computed)(()=>e.leftThumbColor || e.thumbColor || e.color),
            labelColor: (0, $eayOh.computed)(()=>e.leftLabelColor || e.labelColor),
            labelTextColor: (0, $eayOh.computed)(()=>e.leftLabelTextColor || e.labelTextColor)
        }), P = (0, $eayOh.computed)(()=>p("max")), $ = n.getThumbRenderFn({
            focusValue: "max",
            getNodeData: ()=>({
                    ...P.value,
                    key: "tmax",
                    tabindex: C.value
                }),
            ratio: d,
            label: (0, $eayOh.computed)(()=>e.rightLabelValue !== void 0 ? e.rightLabelValue : s.value.max),
            thumbColor: (0, $eayOh.computed)(()=>e.rightThumbColor || e.thumbColor || e.color),
            labelColor: (0, $eayOh.computed)(()=>e.rightLabelColor || e.labelColor),
            labelTextColor: (0, $eayOh.computed)(()=>e.rightLabelTextColor || e.labelTextColor)
        });
        function L(q) {
            (s.value.min !== e.modelValue.min || s.value.max !== e.modelValue.max) && t("update:modelValue", {
                ...s.value
            }), q === !0 && t("change", {
                ...s.value
            });
        }
        function E(q) {
            let { left: x, top: k, width: j, height: Q } = i.value.getBoundingClientRect(), w = e.dragOnlyRange === !0 ? 0 : e.vertical === !0 ? h.value.offsetHeight / (2 * Q) : h.value.offsetWidth / (2 * j), H = {
                left: x,
                top: k,
                width: j,
                height: Q,
                valueMin: s.value.min,
                valueMax: s.value.max,
                ratioMin: u.value,
                ratioMax: v.value
            }, W = n.getDraggingRatio(q, H);
            return e.dragOnlyRange !== !0 && W < H.ratioMin + w ? H.type = $848b1ce88e755b32$var$br.MIN : e.dragOnlyRange === !0 || W < H.ratioMax - w ? e.dragRange === !0 || e.dragOnlyRange === !0 ? (H.type = $848b1ce88e755b32$var$br.RANGE, Object.assign(H, {
                offsetRatio: W,
                offsetModel: n.convertRatioToModel(W),
                rangeValue: H.valueMax - H.valueMin,
                rangeRatio: H.ratioMax - H.ratioMin
            })) : H.type = H.ratioMax - W < W - H.ratioMin ? $848b1ce88e755b32$var$br.MAX : $848b1ce88e755b32$var$br.MIN : H.type = $848b1ce88e755b32$var$br.MAX, H;
        }
        function A(q, x = r.dragging.value) {
            let k, j = n.getDraggingRatio(q, x), Q = n.convertRatioToModel(j);
            switch(x.type){
                case $848b1ce88e755b32$var$br.MIN:
                    j <= x.ratioMax ? (k = {
                        minR: j,
                        maxR: x.ratioMax,
                        min: Q,
                        max: x.valueMax
                    }, r.focus.value = "min") : (k = {
                        minR: x.ratioMax,
                        maxR: j,
                        min: x.valueMax,
                        max: Q
                    }, r.focus.value = "max");
                    break;
                case $848b1ce88e755b32$var$br.MAX:
                    j >= x.ratioMin ? (k = {
                        minR: x.ratioMin,
                        maxR: j,
                        min: x.valueMin,
                        max: Q
                    }, r.focus.value = "max") : (k = {
                        minR: j,
                        maxR: x.ratioMin,
                        min: Q,
                        max: x.valueMin
                    }, r.focus.value = "min");
                    break;
                case $848b1ce88e755b32$var$br.RANGE:
                    let w = j - x.offsetRatio, H = $848b1ce88e755b32$var$Ze(x.ratioMin + w, r.innerMinRatio.value, r.innerMaxRatio.value - x.rangeRatio), W = Q - x.offsetModel, ie = $848b1ce88e755b32$var$Ze(x.valueMin + W, r.innerMin.value, r.innerMax.value - x.rangeValue);
                    k = {
                        minR: H,
                        maxR: H + x.rangeRatio,
                        min: r.roundValueFn.value(ie),
                        max: r.roundValueFn.value(ie + x.rangeValue)
                    }, r.focus.value = "both";
                    break;
            }
            s.value = s.value.min === null || s.value.max === null ? {
                min: k.min || e.min,
                max: k.max || e.max
            } : {
                min: k.min,
                max: k.max
            }, e.snap !== !0 || e.step === 0 ? (a.value = k.minR, l.value = k.maxR) : (a.value = n.convertModelToRatio(s.value.min), l.value = n.convertModelToRatio(s.value.max));
        }
        function B(q) {
            if (!$848b1ce88e755b32$var$Ia.includes(q.keyCode)) return;
            $848b1ce88e755b32$var$Se(q);
            let x = ([
                34,
                33
            ].includes(q.keyCode) ? 10 : 1) * r.keyStep.value, k = ([
                34,
                37,
                40
            ].includes(q.keyCode) ? -1 : 1) * (r.isReversed.value === !0 ? -1 : 1) * (e.vertical === !0 ? -1 : 1) * x;
            if (r.focus.value === "both") {
                let j = s.value.max - s.value.min, Q = $848b1ce88e755b32$var$Ze(r.roundValueFn.value(s.value.min + k), r.innerMin.value, r.innerMax.value - j);
                s.value = {
                    min: Q,
                    max: r.roundValueFn.value(Q + j)
                };
            } else {
                if (r.focus.value === !1) return;
                {
                    let j = r.focus.value;
                    s.value = {
                        ...s.value,
                        [j]: $848b1ce88e755b32$var$Ze(r.roundValueFn.value(s.value[j] + k), j === "min" ? r.innerMin.value : s.value.min, j === "max" ? r.innerMax.value : s.value.max)
                    };
                }
            }
            L();
        }
        return ()=>{
            let q = n.getContent(m, b, y, (x)=>{
                x.push(S(), $());
            });
            return (0, $fVLUl.h)("div", {
                ref: i,
                class: "q-range " + r.classes.value + (e.modelValue.min === null || e.modelValue.max === null ? " q-slider--no-value" : ""),
                ...r.attributes.value,
                "aria-valuenow": e.modelValue.min + "|" + e.modelValue.max
            }, q);
        };
    }
});
var $848b1ce88e755b32$export$97d378c58b81b163 = $848b1ce88e755b32$var$R({
    name: "QRating",
    props: {
        ...$848b1ce88e755b32$var$Ot,
        ...$848b1ce88e755b32$var$_t,
        modelValue: {
            type: Number,
            required: !0
        },
        max: {
            type: [
                String,
                Number
            ],
            default: 5
        },
        icon: [
            String,
            Array
        ],
        iconHalf: [
            String,
            Array
        ],
        iconSelected: [
            String,
            Array
        ],
        iconAriaLabel: [
            String,
            Array
        ],
        color: [
            String,
            Array
        ],
        colorHalf: [
            String,
            Array
        ],
        colorSelected: [
            String,
            Array
        ],
        noReset: Boolean,
        noDimming: Boolean,
        readonly: Boolean,
        disable: Boolean
    },
    emits: [
        "update:modelValue"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: { $q: r } } = (0, $fVLUl.getCurrentInstance)(), n = $848b1ce88e755b32$var$It(e), i = $848b1ce88e755b32$var$cn(e), a = $848b1ce88e755b32$var$eo(i), l = (0, $eayOh.ref)(0), s = {}, c = (0, $eayOh.computed)(()=>e.readonly !== !0 && e.disable !== !0), u = (0, $eayOh.computed)(()=>`q-rating row inline items-center q-rating--${c.value === !0 ? "" : "non-"}editable` + (e.noDimming === !0 ? " q-rating--no-dimming" : "") + (e.disable === !0 ? " disabled" : "") + (e.color !== void 0 && Array.isArray(e.color) === !1 ? ` text-${e.color}` : "")), v = (0, $eayOh.computed)(()=>{
            let h = Array.isArray(e.icon) === !0 ? e.icon.length : 0, g = Array.isArray(e.iconSelected) === !0 ? e.iconSelected.length : 0, S = Array.isArray(e.iconHalf) === !0 ? e.iconHalf.length : 0, P = Array.isArray(e.color) === !0 ? e.color.length : 0, $ = Array.isArray(e.colorSelected) === !0 ? e.colorSelected.length : 0, L = Array.isArray(e.colorHalf) === !0 ? e.colorHalf.length : 0;
            return {
                iconLen: h,
                icon: h > 0 ? e.icon[h - 1] : e.icon,
                selIconLen: g,
                selIcon: g > 0 ? e.iconSelected[g - 1] : e.iconSelected,
                halfIconLen: S,
                halfIcon: S > 0 ? e.iconHalf[g - 1] : e.iconHalf,
                colorLen: P,
                color: P > 0 ? e.color[P - 1] : e.color,
                selColorLen: $,
                selColor: $ > 0 ? e.colorSelected[$ - 1] : e.colorSelected,
                halfColorLen: L,
                halfColor: L > 0 ? e.colorHalf[L - 1] : e.colorHalf
            };
        }), f = (0, $eayOh.computed)(()=>{
            if (typeof e.iconAriaLabel == "string") {
                let h = e.iconAriaLabel.length !== 0 ? `${e.iconAriaLabel} ` : "";
                return (g)=>`${h}${g}`;
            }
            if (Array.isArray(e.iconAriaLabel) === !0) {
                let h = e.iconAriaLabel.length;
                if (h > 0) return (g)=>e.iconAriaLabel[Math.min(g, h) - 1];
            }
            return (h, g)=>`${g} ${h}`;
        }), d = (0, $eayOh.computed)(()=>{
            let h = [], g = v.value, S = Math.ceil(e.modelValue), P = c.value === !0 ? 0 : null, $ = e.iconHalf === void 0 || S === e.modelValue ? -1 : S;
            for(let L = 1; L <= e.max; L++){
                let E = l.value === 0 && e.modelValue >= L || l.value > 0 && l.value >= L, A = $ === L && l.value < L, B = l.value > 0 && (A === !0 ? S : e.modelValue) >= L && l.value < L, q = A === !0 ? L <= g.halfColorLen ? e.colorHalf[L - 1] : g.halfColor : g.selColor !== void 0 && E === !0 ? L <= g.selColorLen ? e.colorSelected[L - 1] : g.selColor : L <= g.colorLen ? e.color[L - 1] : g.color, x = (A === !0 ? L <= g.halfIconLen ? e.iconHalf[L - 1] : g.halfIcon : g.selIcon !== void 0 && (E === !0 || B === !0) ? L <= g.selIconLen ? e.iconSelected[L - 1] : g.selIcon : L <= g.iconLen ? e.icon[L - 1] : g.icon) || r.iconSet.rating.icon;
                h.push({
                    name: (A === !0 ? L <= g.halfIconLen ? e.iconHalf[L - 1] : g.halfIcon : g.selIcon !== void 0 && (E === !0 || B === !0) ? L <= g.selIconLen ? e.iconSelected[L - 1] : g.selIcon : L <= g.iconLen ? e.icon[L - 1] : g.icon) || r.iconSet.rating.icon,
                    attrs: {
                        tabindex: P,
                        role: "radio",
                        "aria-checked": e.modelValue === L ? "true" : "false",
                        "aria-label": f.value(L, x)
                    },
                    iconClass: "q-rating__icon" + (E === !0 || A === !0 ? " q-rating__icon--active" : "") + (B === !0 ? " q-rating__icon--exselected" : "") + (l.value === L ? " q-rating__icon--hovered" : "") + (q !== void 0 ? ` text-${q}` : "")
                });
            }
            return h;
        }), m = (0, $eayOh.computed)(()=>{
            let h = {
                role: "radiogroup"
            };
            return e.disable === !0 && (h["aria-disabled"] = "true"), e.readonly === !0 && (h["aria-readonly"] = "true"), h;
        });
        function y(h) {
            if (c.value === !0) {
                let g = $848b1ce88e755b32$var$Ze(parseInt(h, 10), 1, parseInt(e.max, 10)), S = e.noReset !== !0 && e.modelValue === g ? 0 : g;
                S !== e.modelValue && o("update:modelValue", S), l.value = 0;
            }
        }
        function p(h) {
            c.value === !0 && (l.value = h);
        }
        function C(h, g) {
            switch(h.keyCode){
                case 13:
                case 32:
                    return y(g), $848b1ce88e755b32$var$Se(h);
                case 37:
                case 40:
                    return s[`rt${g - 1}`] && s[`rt${g - 1}`].focus(), $848b1ce88e755b32$var$Se(h);
                case 39:
                case 38:
                    return s[`rt${g + 1}`] && s[`rt${g + 1}`].focus(), $848b1ce88e755b32$var$Se(h);
            }
        }
        function b() {
            l.value = 0;
        }
        return (0, $fVLUl.onBeforeUpdate)(()=>{
            s = {};
        }), ()=>{
            let h = [];
            return d.value.forEach(({ iconClass: g, name: S, attrs: P }, $)=>{
                let L = $ + 1;
                h.push((0, $fVLUl.h)("div", {
                    key: L,
                    ref: (E)=>{
                        s[`rt${L}`] = E;
                    },
                    class: "q-rating__icon-container flex flex-center",
                    ...P,
                    onClick () {
                        y(L);
                    },
                    onMouseover () {
                        p(L);
                    },
                    onMouseout: b,
                    onFocus () {
                        p(L);
                    },
                    onBlur: b,
                    onKeyup (E) {
                        C(E, L);
                    }
                }, $848b1ce88e755b32$var$Ke(t[`tip-${L}`], [
                    (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                        class: g,
                        name: S
                    })
                ])));
            }), e.name !== void 0 && e.disable !== !0 && a(h, "push"), (0, $fVLUl.h)("div", {
                class: u.value,
                style: n.value,
                ...m.value
            }, h);
        };
    }
});
var $848b1ce88e755b32$export$9f7ab13694915fcc = $848b1ce88e755b32$var$R({
    name: "QResponsive",
    props: $848b1ce88e755b32$var$la,
    setup (e, { slots: t }) {
        let o = $848b1ce88e755b32$var$ua(e);
        return ()=>(0, $fVLUl.h)("div", {
                class: "q-responsive"
            }, [
                (0, $fVLUl.h)("div", {
                    class: "q-responsive__filler overflow-hidden"
                }, [
                    (0, $fVLUl.h)("div", {
                        style: o.value
                    })
                ]),
                (0, $fVLUl.h)("div", {
                    class: "q-responsive__content absolute-full fit"
                }, $848b1ce88e755b32$var$J(t.default))
            ]);
    }
});
var $848b1ce88e755b32$var$Bg = [
    "vertical",
    "horizontal"
], $848b1ce88e755b32$var$md = {
    vertical: {
        offset: "offsetY",
        scroll: "scrollTop",
        dir: "down",
        dist: "y"
    },
    horizontal: {
        offset: "offsetX",
        scroll: "scrollLeft",
        dir: "right",
        dist: "x"
    }
}, $848b1ce88e755b32$var$Lg = {
    prevent: !0,
    mouse: !0,
    mouseAllDir: !0
}, $848b1ce88e755b32$var$Fg = (e)=>e >= 250 ? 50 : Math.ceil(e / 5), $848b1ce88e755b32$export$6c88fb8d3b5e5b80 = $848b1ce88e755b32$var$R({
    name: "QScrollArea",
    props: {
        ...$848b1ce88e755b32$var$he,
        thumbStyle: Object,
        verticalThumbStyle: Object,
        horizontalThumbStyle: Object,
        barStyle: [
            Array,
            String,
            Object
        ],
        verticalBarStyle: [
            Array,
            String,
            Object
        ],
        horizontalBarStyle: [
            Array,
            String,
            Object
        ],
        contentStyle: [
            Array,
            String,
            Object
        ],
        contentActiveStyle: [
            Array,
            String,
            Object
        ],
        delay: {
            type: [
                String,
                Number
            ],
            default: 1e3
        },
        visible: {
            type: Boolean,
            default: null
        },
        tabindex: [
            String,
            Number
        ],
        onScroll: Function
    },
    setup (e, { slots: t, emit: o }) {
        let r = (0, $eayOh.ref)(!1), n = (0, $eayOh.ref)(!1), i = (0, $eayOh.ref)(!1), a = {
            vertical: (0, $eayOh.ref)(0),
            horizontal: (0, $eayOh.ref)(0)
        }, l = {
            vertical: {
                ref: (0, $eayOh.ref)(null),
                position: (0, $eayOh.ref)(0),
                size: (0, $eayOh.ref)(0)
            },
            horizontal: {
                ref: (0, $eayOh.ref)(null),
                position: (0, $eayOh.ref)(0),
                size: (0, $eayOh.ref)(0)
            }
        }, { proxy: s } = (0, $fVLUl.getCurrentInstance)(), c = $848b1ce88e755b32$var$pe(e, s.$q), u = null, v, f = (0, $eayOh.ref)(null), d = (0, $eayOh.computed)(()=>"q-scrollarea" + (c.value === !0 ? " q-scrollarea--dark" : ""));
        l.vertical.percentage = (0, $eayOh.computed)(()=>{
            let w = l.vertical.size.value - a.vertical.value;
            if (w <= 0) return 0;
            let H = $848b1ce88e755b32$var$Ze(l.vertical.position.value / w, 0, 1);
            return Math.round(H * 1e4) / 1e4;
        }), l.vertical.thumbHidden = (0, $eayOh.computed)(()=>(e.visible === null ? i.value : e.visible) !== !0 && r.value === !1 && n.value === !1 || l.vertical.size.value <= a.vertical.value + 1), l.vertical.thumbStart = (0, $eayOh.computed)(()=>l.vertical.percentage.value * (a.vertical.value - l.vertical.thumbSize.value)), l.vertical.thumbSize = (0, $eayOh.computed)(()=>Math.round($848b1ce88e755b32$var$Ze(a.vertical.value * a.vertical.value / l.vertical.size.value, $848b1ce88e755b32$var$Fg(a.vertical.value), a.vertical.value))), l.vertical.style = (0, $eayOh.computed)(()=>({
                ...e.thumbStyle,
                ...e.verticalThumbStyle,
                top: `${l.vertical.thumbStart.value}px`,
                height: `${l.vertical.thumbSize.value}px`
            })), l.vertical.thumbClass = (0, $eayOh.computed)(()=>"q-scrollarea__thumb q-scrollarea__thumb--v absolute-right" + (l.vertical.thumbHidden.value === !0 ? " q-scrollarea__thumb--invisible" : "")), l.vertical.barClass = (0, $eayOh.computed)(()=>"q-scrollarea__bar q-scrollarea__bar--v absolute-right" + (l.vertical.thumbHidden.value === !0 ? " q-scrollarea__bar--invisible" : "")), l.horizontal.percentage = (0, $eayOh.computed)(()=>{
            let w = l.horizontal.size.value - a.horizontal.value;
            if (w <= 0) return 0;
            let H = $848b1ce88e755b32$var$Ze(Math.abs(l.horizontal.position.value) / w, 0, 1);
            return Math.round(H * 1e4) / 1e4;
        }), l.horizontal.thumbHidden = (0, $eayOh.computed)(()=>(e.visible === null ? i.value : e.visible) !== !0 && r.value === !1 && n.value === !1 || l.horizontal.size.value <= a.horizontal.value + 1), l.horizontal.thumbStart = (0, $eayOh.computed)(()=>l.horizontal.percentage.value * (a.horizontal.value - l.horizontal.thumbSize.value)), l.horizontal.thumbSize = (0, $eayOh.computed)(()=>Math.round($848b1ce88e755b32$var$Ze(a.horizontal.value * a.horizontal.value / l.horizontal.size.value, $848b1ce88e755b32$var$Fg(a.horizontal.value), a.horizontal.value))), l.horizontal.style = (0, $eayOh.computed)(()=>({
                ...e.thumbStyle,
                ...e.horizontalThumbStyle,
                [s.$q.lang.rtl === !0 ? "right" : "left"]: `${l.horizontal.thumbStart.value}px`,
                width: `${l.horizontal.thumbSize.value}px`
            })), l.horizontal.thumbClass = (0, $eayOh.computed)(()=>"q-scrollarea__thumb q-scrollarea__thumb--h absolute-bottom" + (l.horizontal.thumbHidden.value === !0 ? " q-scrollarea__thumb--invisible" : "")), l.horizontal.barClass = (0, $eayOh.computed)(()=>"q-scrollarea__bar q-scrollarea__bar--h absolute-bottom" + (l.horizontal.thumbHidden.value === !0 ? " q-scrollarea__bar--invisible" : ""));
        let m = (0, $eayOh.computed)(()=>l.vertical.thumbHidden.value === !0 && l.horizontal.thumbHidden.value === !0 ? e.contentStyle : e.contentActiveStyle), y = [
            [
                $848b1ce88e755b32$export$718797250d1e376,
                (w)=>{
                    $(w, "vertical");
                },
                void 0,
                {
                    vertical: !0,
                    ...$848b1ce88e755b32$var$Lg
                }
            ]
        ], p = [
            [
                $848b1ce88e755b32$export$718797250d1e376,
                (w)=>{
                    $(w, "horizontal");
                },
                void 0,
                {
                    horizontal: !0,
                    ...$848b1ce88e755b32$var$Lg
                }
            ]
        ];
        function C() {
            let w = {};
            return $848b1ce88e755b32$var$Bg.forEach((H)=>{
                let W = l[H];
                w[H + "Position"] = W.position.value, w[H + "Percentage"] = W.percentage.value, w[H + "Size"] = W.size.value, w[H + "ContainerSize"] = a[H].value;
            }), w;
        }
        let b = $848b1ce88e755b32$export$61fc7d43ac8f84b0(()=>{
            let w = C();
            w.ref = s, o("scroll", w);
        }, 0);
        function h(w, H, W) {
            if ($848b1ce88e755b32$var$Bg.includes(w) === !1) {
                console.error("[QScrollArea]: wrong first param of setScrollPosition (vertical/horizontal)");
                return;
            }
            (w === "vertical" ? $848b1ce88e755b32$var$un : $848b1ce88e755b32$var$La)(f.value, H, W);
        }
        function g({ height: w, width: H }) {
            let W = !1;
            a.vertical.value !== w && (a.vertical.value = w, W = !0), a.horizontal.value !== H && (a.horizontal.value = H, W = !0), W === !0 && B();
        }
        function S({ position: w }) {
            let H = !1;
            l.vertical.position.value !== w.top && (l.vertical.position.value = w.top, H = !0), l.horizontal.position.value !== w.left && (l.horizontal.position.value = w.left, H = !0), H === !0 && B();
        }
        function P({ height: w, width: H }) {
            l.horizontal.size.value !== H && (l.horizontal.size.value = H, B()), l.vertical.size.value !== w && (l.vertical.size.value = w, B());
        }
        function $(w, H) {
            let W = l[H];
            if (w.isFirst === !0) {
                if (W.thumbHidden.value === !0) return;
                v = W.position.value, n.value = !0;
            } else if (n.value !== !0) return;
            w.isFinal === !0 && (n.value = !1);
            let ie = $848b1ce88e755b32$var$md[H], V = a[H].value, _ = (W.size.value - V) / (V - W.thumbSize.value), N = w.distance[ie.dist], I = v + (w.direction === ie.dir ? 1 : -1) * N * _;
            q(I, H);
        }
        function L(w, H) {
            let W = l[H];
            if (W.thumbHidden.value !== !0) {
                let ie = w[$848b1ce88e755b32$var$md[H].offset];
                if (ie < W.thumbStart.value || ie > W.thumbStart.value + W.thumbSize.value) {
                    let V = ie - W.thumbSize.value / 2;
                    q(V / a[H].value * W.size.value, H);
                }
                W.ref.value !== null && W.ref.value.dispatchEvent(new MouseEvent(w.type, w));
            }
        }
        function E(w) {
            L(w, "vertical");
        }
        function A(w) {
            L(w, "horizontal");
        }
        function B() {
            r.value = !0, u !== null && clearTimeout(u), u = setTimeout(()=>{
                u = null, r.value = !1;
            }, e.delay), e.onScroll !== void 0 && b();
        }
        function q(w, H) {
            f.value[$848b1ce88e755b32$var$md[H].scroll] = w;
        }
        let x = null;
        function k() {
            x !== null && clearTimeout(x), x = setTimeout(()=>{
                x = null, i.value = !0;
            }, s.$q.platform.is.ios ? 50 : 0);
        }
        function j() {
            x !== null && (clearTimeout(x), x = null), i.value = !1;
        }
        let Q = null;
        return (0, $eayOh.watch)(()=>s.$q.lang.rtl, (w)=>{
            f.value !== null && $848b1ce88e755b32$var$La(f.value, Math.abs(l.horizontal.position.value) * (w === !0 ? -1 : 1));
        }), (0, $fVLUl.onDeactivated)(()=>{
            Q = {
                top: l.vertical.position.value,
                left: l.horizontal.position.value
            };
        }), (0, $fVLUl.onActivated)(()=>{
            if (Q === null) return;
            let w = f.value;
            w !== null && ($848b1ce88e755b32$var$La(w, Q.left), $848b1ce88e755b32$var$un(w, Q.top));
        }), (0, $fVLUl.onBeforeUnmount)(b.cancel), Object.assign(s, {
            getScrollTarget: ()=>f.value,
            getScroll: C,
            getScrollPosition: ()=>({
                    top: l.vertical.position.value,
                    left: l.horizontal.position.value
                }),
            getScrollPercentage: ()=>({
                    top: l.vertical.percentage.value,
                    left: l.horizontal.percentage.value
                }),
            setScrollPosition: h,
            setScrollPercentage (w, H, W) {
                h(w, H * (l[w].size.value - a[w].value) * (w === "horizontal" && s.$q.lang.rtl === !0 ? -1 : 1), W);
            }
        }), ()=>(0, $fVLUl.h)("div", {
                class: d.value,
                onMouseenter: k,
                onMouseleave: j
            }, [
                (0, $fVLUl.h)("div", {
                    ref: f,
                    class: "q-scrollarea__container scroll relative-position fit hide-scrollbar",
                    tabindex: e.tabindex !== void 0 ? e.tabindex : void 0
                }, [
                    (0, $fVLUl.h)("div", {
                        class: "q-scrollarea__content absolute",
                        style: m.value
                    }, $848b1ce88e755b32$var$Ke(t.default, [
                        (0, $fVLUl.h)($848b1ce88e755b32$export$614f53fe102a3da7, {
                            debounce: 0,
                            onResize: P
                        })
                    ])),
                    (0, $fVLUl.h)($848b1ce88e755b32$export$d6d34850bd31dad, {
                        axis: "both",
                        onScroll: S
                    })
                ]),
                (0, $fVLUl.h)($848b1ce88e755b32$export$614f53fe102a3da7, {
                    debounce: 0,
                    onResize: g
                }),
                (0, $fVLUl.h)("div", {
                    class: l.vertical.barClass.value,
                    style: [
                        e.barStyle,
                        e.verticalBarStyle
                    ],
                    "aria-hidden": "true",
                    onMousedown: E
                }),
                (0, $fVLUl.h)("div", {
                    class: l.horizontal.barClass.value,
                    style: [
                        e.barStyle,
                        e.horizontalBarStyle
                    ],
                    "aria-hidden": "true",
                    onMousedown: A
                }),
                (0, $fVLUl.withDirectives)((0, $fVLUl.h)("div", {
                    ref: l.vertical.ref,
                    class: l.vertical.thumbClass.value,
                    style: l.vertical.style.value,
                    "aria-hidden": "true"
                }), y),
                (0, $fVLUl.withDirectives)((0, $fVLUl.h)("div", {
                    ref: l.horizontal.ref,
                    class: l.horizontal.thumbClass.value,
                    style: l.horizontal.style.value,
                    "aria-hidden": "true"
                }), p)
            ]);
    }
});
var $848b1ce88e755b32$var$Ko = 1e3, $848b1ce88e755b32$var$QC = [
    "start",
    "center",
    "end",
    "start-force",
    "center-force",
    "end-force"
], $848b1ce88e755b32$var$Og = Array.prototype.filter, $848b1ce88e755b32$var$jC = window.getComputedStyle(document.body).overflowAnchor === void 0 ? $848b1ce88e755b32$export$8793edee2d425525 : function(e, t) {
    e !== null && (e._qOverflowAnimationFrame !== void 0 && cancelAnimationFrame(e._qOverflowAnimationFrame), e._qOverflowAnimationFrame = requestAnimationFrame(()=>{
        if (e === null) return;
        e._qOverflowAnimationFrame = void 0;
        let o = e.children || [];
        $848b1ce88e755b32$var$Og.call(o, (n)=>n.dataset && n.dataset.qVsAnchor !== void 0).forEach((n)=>{
            delete n.dataset.qVsAnchor;
        });
        let r = o[t];
        r && r.dataset && (r.dataset.qVsAnchor = "");
    }));
};
function $848b1ce88e755b32$var$ba(e, t) {
    return e + t;
}
function $848b1ce88e755b32$var$vd(e, t, o, r, n, i, a, l) {
    let s = e === window ? document.scrollingElement || document.documentElement : e, c = n === !0 ? "offsetWidth" : "offsetHeight", u = {
        scrollStart: 0,
        scrollViewSize: -a - l,
        scrollMaxSize: 0,
        offsetStart: -a,
        offsetEnd: -l
    };
    if (n === !0 ? (e === window ? (u.scrollStart = window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, u.scrollViewSize += document.documentElement.clientWidth) : (u.scrollStart = s.scrollLeft, u.scrollViewSize += s.clientWidth), u.scrollMaxSize = s.scrollWidth, i === !0 && (u.scrollStart = ($848b1ce88e755b32$var$Fr === !0 ? u.scrollMaxSize - u.scrollViewSize : 0) - u.scrollStart)) : (e === window ? (u.scrollStart = window.pageYOffset || window.scrollY || document.body.scrollTop || 0, u.scrollViewSize += document.documentElement.clientHeight) : (u.scrollStart = s.scrollTop, u.scrollViewSize += s.clientHeight), u.scrollMaxSize = s.scrollHeight), o !== null) for(let v = o.previousElementSibling; v !== null; v = v.previousElementSibling)v.classList.contains("q-virtual-scroll--skip") === !1 && (u.offsetStart += v[c]);
    if (r !== null) for(let v = r.nextElementSibling; v !== null; v = v.nextElementSibling)v.classList.contains("q-virtual-scroll--skip") === !1 && (u.offsetEnd += v[c]);
    if (t !== e) {
        let v = s.getBoundingClientRect(), f = t.getBoundingClientRect();
        n === !0 ? (u.offsetStart += f.left - v.left, u.offsetEnd -= f.width) : (u.offsetStart += f.top - v.top, u.offsetEnd -= f.height), e !== window && (u.offsetStart += u.scrollStart), u.offsetEnd += u.scrollMaxSize - u.offsetStart;
    }
    return u;
}
function $848b1ce88e755b32$var$zg(e, t, o, r) {
    t === "end" && (t = (e === window ? document.body : e)[o === !0 ? "scrollWidth" : "scrollHeight"]), e === window ? o === !0 ? (r === !0 && (t = ($848b1ce88e755b32$var$Fr === !0 ? document.body.scrollWidth - document.documentElement.clientWidth : 0) - t), window.scrollTo(t, window.pageYOffset || window.scrollY || document.body.scrollTop || 0)) : window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, t) : o === !0 ? (r === !0 && (t = ($848b1ce88e755b32$var$Fr === !0 ? e.scrollWidth - e.offsetWidth : 0) - t), e.scrollLeft = t) : e.scrollTop = t;
}
function $848b1ce88e755b32$var$vl(e, t, o, r) {
    if (o >= r) return 0;
    let n = t.length, i = Math.floor(o / $848b1ce88e755b32$var$Ko), a = Math.floor((r - 1) / $848b1ce88e755b32$var$Ko) + 1, l = e.slice(i, a).reduce($848b1ce88e755b32$var$ba, 0);
    return o % $848b1ce88e755b32$var$Ko !== 0 && (l -= t.slice(i * $848b1ce88e755b32$var$Ko, o).reduce($848b1ce88e755b32$var$ba, 0)), r % $848b1ce88e755b32$var$Ko !== 0 && r !== n && (l -= t.slice(r, a * $848b1ce88e755b32$var$Ko).reduce($848b1ce88e755b32$var$ba, 0)), l;
}
var $848b1ce88e755b32$var$Ig = {
    virtualScrollSliceSize: {
        type: [
            Number,
            String
        ],
        default: null
    },
    virtualScrollSliceRatioBefore: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    virtualScrollSliceRatioAfter: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    virtualScrollItemSize: {
        type: [
            Number,
            String
        ],
        default: 24
    },
    virtualScrollStickySizeStart: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    virtualScrollStickySizeEnd: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    tableColspan: [
        Number,
        String
    ]
}, $848b1ce88e755b32$var$gd = Object.keys($848b1ce88e755b32$var$Ig), $848b1ce88e755b32$var$ss = {
    virtualScrollHorizontal: Boolean,
    onVirtualScroll: Function,
    ...$848b1ce88e755b32$var$Ig
};
function $848b1ce88e755b32$var$cs({ virtualScrollLength: e, getVirtualScrollTarget: t, getVirtualScrollEl: o, virtualScrollItemSizeComputed: r }) {
    let n = (0, $fVLUl.getCurrentInstance)(), { props: i, emit: a, proxy: l } = n, { $q: s } = l, c, u, v, f = [], d, m = (0, $eayOh.ref)(0), y = (0, $eayOh.ref)(0), p = (0, $eayOh.ref)({}), C = (0, $eayOh.ref)(null), b = (0, $eayOh.ref)(null), h = (0, $eayOh.ref)(null), g = (0, $eayOh.ref)({
        from: 0,
        to: 0
    }), S = (0, $eayOh.computed)(()=>i.tableColspan !== void 0 ? i.tableColspan : 100);
    r === void 0 && (r = (0, $eayOh.computed)(()=>i.virtualScrollItemSize));
    let P = (0, $eayOh.computed)(()=>r.value + ";" + i.virtualScrollHorizontal), $ = (0, $eayOh.computed)(()=>P.value + ";" + i.virtualScrollSliceRatioBefore + ";" + i.virtualScrollSliceRatioAfter);
    (0, $eayOh.watch)($, ()=>{
        Q();
    }), (0, $eayOh.watch)(P, L);
    function L() {
        j(u, !0);
    }
    function E(V) {
        j(V === void 0 ? u : V);
    }
    function A(V, _) {
        let N = t();
        if (N == null || N.nodeType === 8) return;
        let I = $848b1ce88e755b32$var$vd(N, o(), C.value, b.value, i.virtualScrollHorizontal, s.lang.rtl, i.virtualScrollStickySizeStart, i.virtualScrollStickySizeEnd);
        v !== I.scrollViewSize && Q(I.scrollViewSize), q(N, I, Math.min(e.value - 1, Math.max(0, parseInt(V, 10) || 0)), 0, $848b1ce88e755b32$var$QC.indexOf(_) !== -1 ? _ : u !== -1 && V > u ? "end" : "start");
    }
    function B() {
        let V = t();
        if (V == null || V.nodeType === 8) return;
        let _ = $848b1ce88e755b32$var$vd(V, o(), C.value, b.value, i.virtualScrollHorizontal, s.lang.rtl, i.virtualScrollStickySizeStart, i.virtualScrollStickySizeEnd), N = e.value - 1, I = _.scrollMaxSize - _.offsetStart - _.offsetEnd - y.value;
        if (c === _.scrollStart) return;
        if (_.scrollMaxSize <= 0) {
            q(V, _, 0, 0);
            return;
        }
        v !== _.scrollViewSize && Q(_.scrollViewSize), x(g.value.from);
        let oe = Math.floor(_.scrollMaxSize - Math.max(_.scrollViewSize, _.offsetEnd) - Math.min(d[N], _.scrollViewSize / 2));
        if (oe > 0 && Math.ceil(_.scrollStart) >= oe) {
            q(V, _, N, _.scrollMaxSize - _.offsetEnd - f.reduce($848b1ce88e755b32$var$ba, 0));
            return;
        }
        let T = 0, D = _.scrollStart - _.offsetStart, te = D;
        if (D <= I && D + _.scrollViewSize >= m.value) D -= m.value, T = g.value.from, te = D;
        else for(let z = 0; D >= f[z] && T < N; z++)D -= f[z], T += $848b1ce88e755b32$var$Ko;
        for(; D > 0 && T < N;)D -= d[T], D > -_.scrollViewSize ? (T++, te = D) : te = d[T] + D;
        q(V, _, T, te);
    }
    function q(V, _, N, I, oe) {
        let T = typeof oe == "string" && oe.indexOf("-force") !== -1, D = T === !0 ? oe.replace("-force", "") : oe, te = D !== void 0 ? D : "start", z = Math.max(0, N - p.value[te]), ue = z + p.value.total;
        ue > e.value && (ue = e.value, z = Math.max(0, ue - p.value.total)), c = _.scrollStart;
        let _e = z !== g.value.from || ue !== g.value.to;
        if (_e === !1 && D === void 0) {
            H(N);
            return;
        }
        let { activeElement: U } = document, ae = h.value;
        _e === !0 && ae !== null && ae !== U && ae.contains(U) === !0 && (ae.addEventListener("focusout", k), setTimeout(()=>{
            ae !== null && ae.removeEventListener("focusout", k);
        })), $848b1ce88e755b32$var$jC(ae, N - z);
        let ce = D !== void 0 ? d.slice(z, N).reduce($848b1ce88e755b32$var$ba, 0) : 0;
        if (_e === !0) {
            let be = ue >= g.value.from && z <= g.value.to ? g.value.to : ue;
            g.value = {
                from: z,
                to: be
            }, m.value = $848b1ce88e755b32$var$vl(f, d, 0, z), y.value = $848b1ce88e755b32$var$vl(f, d, ue, e.value), requestAnimationFrame(()=>{
                g.value.to !== ue && c === _.scrollStart && (g.value = {
                    from: g.value.from,
                    to: ue
                }, y.value = $848b1ce88e755b32$var$vl(f, d, ue, e.value));
            });
        }
        requestAnimationFrame(()=>{
            if (c !== _.scrollStart) return;
            _e === !0 && x(z);
            let be = d.slice(z, N).reduce($848b1ce88e755b32$var$ba, 0), Me = be + _.offsetStart + m.value, le = Me + d[N], Re = Me + I;
            if (D !== void 0) {
                let Fe = be - ce, De = _.scrollStart + Fe;
                Re = T !== !0 && De < Me && le < De + _.scrollViewSize ? De : D === "end" ? le - _.scrollViewSize : Me - (D === "start" ? 0 : Math.round((_.scrollViewSize - d[N]) / 2));
            }
            c = Re, $848b1ce88e755b32$var$zg(V, Re, i.virtualScrollHorizontal, s.lang.rtl), H(N);
        });
    }
    function x(V) {
        let _ = h.value;
        if (_) {
            let N = $848b1ce88e755b32$var$Og.call(_.children, (z)=>z.classList && z.classList.contains("q-virtual-scroll--skip") === !1), I = N.length, oe = i.virtualScrollHorizontal === !0 ? (z)=>z.getBoundingClientRect().width : (z)=>z.offsetHeight, T = V, D, te;
            for(let z = 0; z < I;){
                for(D = oe(N[z]), z++; z < I && N[z].classList.contains("q-virtual-scroll--with-prev") === !0;)D += oe(N[z]), z++;
                te = D - d[T], te !== 0 && (d[T] += te, f[Math.floor(T / $848b1ce88e755b32$var$Ko)] += te), T++;
            }
        }
    }
    function k() {
        h.value !== null && h.value !== void 0 && h.value.focus();
    }
    function j(V, _) {
        let N = 1 * r.value;
        (_ === !0 || Array.isArray(d) === !1) && (d = []);
        let I = d.length;
        d.length = e.value;
        for(let T = e.value - 1; T >= I; T--)d[T] = N;
        let oe = Math.floor((e.value - 1) / $848b1ce88e755b32$var$Ko);
        f = [];
        for(let T = 0; T <= oe; T++){
            let D = 0, te = Math.min((T + 1) * $848b1ce88e755b32$var$Ko, e.value);
            for(let z = T * $848b1ce88e755b32$var$Ko; z < te; z++)D += d[z];
            f.push(D);
        }
        u = -1, c = void 0, m.value = $848b1ce88e755b32$var$vl(f, d, 0, g.value.from), y.value = $848b1ce88e755b32$var$vl(f, d, g.value.to, e.value), V >= 0 ? (x(g.value.from), (0, $fVLUl.nextTick)(()=>{
            A(V);
        })) : W();
    }
    function Q(V) {
        if (V === void 0 && typeof window < "u") {
            let D = t();
            D != null && D.nodeType !== 8 && (V = $848b1ce88e755b32$var$vd(D, o(), C.value, b.value, i.virtualScrollHorizontal, s.lang.rtl, i.virtualScrollStickySizeStart, i.virtualScrollStickySizeEnd).scrollViewSize);
        }
        v = V;
        let _ = parseFloat(i.virtualScrollSliceRatioBefore) || 0, N = parseFloat(i.virtualScrollSliceRatioAfter) || 0, I = 1 + _ + N, oe = V === void 0 || V <= 0 ? 1 : Math.ceil(V / r.value), T = Math.max(1, oe, Math.ceil((i.virtualScrollSliceSize > 0 ? i.virtualScrollSliceSize : 10) / I));
        p.value = {
            total: Math.ceil(T * I),
            start: Math.ceil(T * _),
            center: Math.ceil(T * (.5 + _)),
            end: Math.ceil(T * (1 + _)),
            view: oe
        };
    }
    function w(V, _) {
        let N = i.virtualScrollHorizontal === !0 ? "width" : "height", I = {
            ["--q-virtual-scroll-item-" + N]: r.value + "px"
        };
        return [
            V === "tbody" ? (0, $fVLUl.h)(V, {
                class: "q-virtual-scroll__padding",
                key: "before",
                ref: C
            }, [
                (0, $fVLUl.h)("tr", [
                    (0, $fVLUl.h)("td", {
                        style: {
                            [N]: `${m.value}px`,
                            ...I
                        },
                        colspan: S.value
                    })
                ])
            ]) : (0, $fVLUl.h)(V, {
                class: "q-virtual-scroll__padding",
                key: "before",
                ref: C,
                style: {
                    [N]: `${m.value}px`,
                    ...I
                }
            }),
            (0, $fVLUl.h)(V, {
                class: "q-virtual-scroll__content",
                key: "content",
                ref: h,
                tabindex: -1
            }, _.flat()),
            V === "tbody" ? (0, $fVLUl.h)(V, {
                class: "q-virtual-scroll__padding",
                key: "after",
                ref: b
            }, [
                (0, $fVLUl.h)("tr", [
                    (0, $fVLUl.h)("td", {
                        style: {
                            [N]: `${y.value}px`,
                            ...I
                        },
                        colspan: S.value
                    })
                ])
            ]) : (0, $fVLUl.h)(V, {
                class: "q-virtual-scroll__padding",
                key: "after",
                ref: b,
                style: {
                    [N]: `${y.value}px`,
                    ...I
                }
            })
        ];
    }
    function H(V) {
        u !== V && (i.onVirtualScroll !== void 0 && a("virtualScroll", {
            index: V,
            from: g.value.from,
            to: g.value.to - 1,
            direction: V < u ? "decrease" : "increase",
            ref: l
        }), u = V);
    }
    Q();
    let W = $848b1ce88e755b32$export$61fc7d43ac8f84b0(B, s.platform.is.ios === !0 ? 120 : 35);
    (0, $fVLUl.onBeforeMount)(()=>{
        Q();
    });
    let ie = !1;
    return (0, $fVLUl.onDeactivated)(()=>{
        ie = !0;
    }), (0, $fVLUl.onActivated)(()=>{
        if (ie !== !0) return;
        let V = t();
        c !== void 0 && V !== void 0 && V !== null && V.nodeType !== 8 ? $848b1ce88e755b32$var$zg(V, c, i.virtualScrollHorizontal, s.lang.rtl) : A(u);
    }), (0, $fVLUl.onBeforeUnmount)(()=>{
        W.cancel();
    }), Object.assign(l, {
        scrollTo: A,
        reset: L,
        refresh: E
    }), {
        virtualScrollSliceRange: g,
        virtualScrollSliceSizeComputed: p,
        setVirtualScrollSize: Q,
        onVirtualScrollEvt: W,
        localResetVirtualScroll: j,
        padVirtualScroll: w,
        scrollTo: A,
        reset: L,
        refresh: E
    };
}
var $848b1ce88e755b32$var$Hg = (e)=>[
        "add",
        "add-unique",
        "toggle"
    ].includes(e), $848b1ce88e755b32$var$XC = ".*+?^${}()|[]\\", $848b1ce88e755b32$var$GC = Object.keys($848b1ce88e755b32$var$zn), $848b1ce88e755b32$export$c6f171932ae1be1a = $848b1ce88e755b32$var$R({
    name: "QSelect",
    inheritAttrs: !1,
    props: {
        ...$848b1ce88e755b32$var$ss,
        ...$848b1ce88e755b32$var$_t,
        ...$848b1ce88e755b32$var$zn,
        modelValue: {
            required: !0
        },
        multiple: Boolean,
        displayValue: [
            String,
            Number
        ],
        displayValueHtml: Boolean,
        dropdownIcon: String,
        options: {
            type: Array,
            default: ()=>[]
        },
        optionValue: [
            Function,
            String
        ],
        optionLabel: [
            Function,
            String
        ],
        optionDisable: [
            Function,
            String
        ],
        hideSelected: Boolean,
        hideDropdownIcon: Boolean,
        fillInput: Boolean,
        maxValues: [
            Number,
            String
        ],
        optionsDense: Boolean,
        optionsDark: {
            type: Boolean,
            default: null
        },
        optionsSelectedClass: String,
        optionsHtml: Boolean,
        optionsCover: Boolean,
        menuShrink: Boolean,
        menuAnchor: String,
        menuSelf: String,
        menuOffset: Array,
        popupContentClass: String,
        popupContentStyle: [
            String,
            Array,
            Object
        ],
        popupNoRouteDismiss: Boolean,
        useInput: Boolean,
        useChips: Boolean,
        newValueMode: {
            type: String,
            validator: $848b1ce88e755b32$var$Hg
        },
        mapOptions: Boolean,
        emitValue: Boolean,
        inputDebounce: {
            type: [
                Number,
                String
            ],
            default: 500
        },
        inputClass: [
            Array,
            String,
            Object
        ],
        inputStyle: [
            Array,
            String,
            Object
        ],
        tabindex: {
            type: [
                String,
                Number
            ],
            default: 0
        },
        autocomplete: String,
        transitionShow: String,
        transitionHide: String,
        transitionDuration: [
            String,
            Number
        ],
        behavior: {
            type: String,
            validator: (e)=>[
                    "default",
                    "menu",
                    "dialog"
                ].includes(e),
            default: "default"
        },
        virtualScrollItemSize: {
            type: [
                Number,
                String
            ],
            default: void 0
        },
        onNewValue: Function,
        onFilter: Function
    },
    emits: [
        ...$848b1ce88e755b32$var$cr,
        "add",
        "remove",
        "inputValue",
        "keyup",
        "keypress",
        "keydown",
        "filterAbort"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: r } = (0, $fVLUl.getCurrentInstance)(), { $q: n } = r, i = (0, $eayOh.ref)(!1), a = (0, $eayOh.ref)(!1), l = (0, $eayOh.ref)(-1), s = (0, $eayOh.ref)(""), c = (0, $eayOh.ref)(!1), u = (0, $eayOh.ref)(!1), v = null, f = null, d, m, y, p = null, C, b, h, g, S = (0, $eayOh.ref)(null), P = (0, $eayOh.ref)(null), $ = (0, $eayOh.ref)(null), L = (0, $eayOh.ref)(null), E = (0, $eayOh.ref)(null), A = $848b1ce88e755b32$var$Ai(e), B = $848b1ce88e755b32$var$Iu(ve), q = (0, $eayOh.computed)(()=>Array.isArray(e.options) ? e.options.length : 0), x = (0, $eayOh.computed)(()=>e.virtualScrollItemSize === void 0 ? e.optionsDense === !0 ? 24 : 48 : e.virtualScrollItemSize), { virtualScrollSliceRange: k, virtualScrollSliceSizeComputed: j, localResetVirtualScroll: Q, padVirtualScroll: w, onVirtualScrollEvt: H, scrollTo: W, setVirtualScrollSize: ie } = $848b1ce88e755b32$var$cs({
            virtualScrollLength: q,
            getVirtualScrollTarget: qo,
            getVirtualScrollEl: ro,
            virtualScrollItemSizeComputed: x
        }), V = $848b1ce88e755b32$var$dr(), _ = (0, $eayOh.computed)(()=>{
            let F = e.mapOptions === !0 && e.multiple !== !0, xe = e.modelValue !== void 0 && (e.modelValue !== null || F === !0) ? e.multiple === !0 && Array.isArray(e.modelValue) ? e.modelValue : [
                e.modelValue
            ] : [];
            if (e.mapOptions === !0 && Array.isArray(e.options) === !0) {
                let ge = e.mapOptions === !0 && d !== void 0 ? d : [], Ue = xe.map((vt)=>K(vt, ge));
                return e.modelValue === null && F === !0 ? Ue.filter((vt)=>vt !== null) : Ue;
            }
            return xe;
        }), N = (0, $eayOh.computed)(()=>{
            let F = {};
            return $848b1ce88e755b32$var$GC.forEach((xe)=>{
                let ge = e[xe];
                ge !== void 0 && (F[xe] = ge);
            }), F;
        }), I = (0, $eayOh.computed)(()=>e.optionsDark === null ? V.isDark.value : e.optionsDark), oe = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$pn(_.value)), T = (0, $eayOh.computed)(()=>{
            let F = "q-field__input q-placeholder col";
            return e.hideSelected === !0 || _.value.length === 0 ? [
                F,
                e.inputClass
            ] : (F += " q-field__input--padding", e.inputClass === void 0 ? F : [
                F,
                e.inputClass
            ]);
        }), D = (0, $eayOh.computed)(()=>(e.virtualScrollHorizontal === !0 ? "q-virtual-scroll--horizontal" : "") + (e.popupContentClass ? " " + e.popupContentClass : "")), te = (0, $eayOh.computed)(()=>q.value === 0), z = (0, $eayOh.computed)(()=>_.value.map((F)=>se.value(F)).join(", ")), ue = (0, $eayOh.computed)(()=>e.displayValue !== void 0 ? e.displayValue : z.value), _e = (0, $eayOh.computed)(()=>e.optionsHtml === !0 ? ()=>!0 : (F)=>F != null && F.html === !0), U = (0, $eayOh.computed)(()=>e.displayValueHtml === !0 || e.displayValue === void 0 && (e.optionsHtml === !0 || _.value.some(_e.value))), ae = (0, $eayOh.computed)(()=>V.focused.value === !0 ? e.tabindex : -1), ce = (0, $eayOh.computed)(()=>{
            let F = {
                tabindex: e.tabindex,
                role: "combobox",
                "aria-label": e.label,
                "aria-readonly": e.readonly === !0 ? "true" : "false",
                "aria-autocomplete": e.useInput === !0 ? "list" : "none",
                "aria-expanded": i.value === !0 ? "true" : "false",
                "aria-controls": `${V.targetUid.value}_lb`
            };
            return l.value >= 0 && (F["aria-activedescendant"] = `${V.targetUid.value}_${l.value}`), F;
        }), be = (0, $eayOh.computed)(()=>({
                id: `${V.targetUid.value}_lb`,
                role: "listbox",
                "aria-multiselectable": e.multiple === !0 ? "true" : "false"
            })), Me = (0, $eayOh.computed)(()=>_.value.map((F, xe)=>({
                    index: xe,
                    opt: F,
                    html: _e.value(F),
                    selected: !0,
                    removeAtIndex: nt,
                    toggleOption: dt,
                    tabindex: ae.value
                }))), le = (0, $eayOh.computed)(()=>{
            if (q.value === 0) return [];
            let { from: F, to: xe } = k.value;
            return e.options.slice(F, xe).map((ge, Ue)=>{
                let vt = Y.value(ge) === !0, ft = ke(ge) === !0, jt = F + Ue, Pt = {
                    clickable: !0,
                    active: ft,
                    activeClass: De.value,
                    manualFocus: !0,
                    focused: !1,
                    disable: vt,
                    tabindex: -1,
                    dense: e.optionsDense,
                    dark: I.value,
                    role: "option",
                    "aria-selected": ft === !0 ? "true" : "false",
                    id: `${V.targetUid.value}_${jt}`,
                    onClick: ()=>{
                        dt(ge);
                    }
                };
                return vt !== !0 && (l.value === jt && (Pt.focused = !0), n.platform.is.desktop === !0 && (Pt.onMousemove = ()=>{
                    i.value === !0 && G(jt);
                })), {
                    index: jt,
                    opt: ge,
                    html: _e.value(ge),
                    label: se.value(ge),
                    selected: Pt.active,
                    focused: Pt.focused,
                    toggleOption: dt,
                    setOptionIndex: G,
                    itemProps: Pt
                };
            });
        }), Re = (0, $eayOh.computed)(()=>e.dropdownIcon !== void 0 ? e.dropdownIcon : n.iconSet.arrow.dropdown), Fe = (0, $eayOh.computed)(()=>e.optionsCover === !1 && e.outlined !== !0 && e.standout !== !0 && e.borderless !== !0 && e.rounded !== !0), De = (0, $eayOh.computed)(()=>e.optionsSelectedClass !== void 0 ? e.optionsSelectedClass : e.color !== void 0 ? `text-${e.color}` : ""), ne = (0, $eayOh.computed)(()=>ee(e.optionValue, "value")), se = (0, $eayOh.computed)(()=>ee(e.optionLabel, "label")), Y = (0, $eayOh.computed)(()=>ee(e.optionDisable, "disable")), me = (0, $eayOh.computed)(()=>_.value.map((F)=>ne.value(F))), Pe = (0, $eayOh.computed)(()=>{
            let F = {
                onInput: ve,
                onChange: B,
                onKeydown: ht,
                onKeyup: Ge,
                onKeypress: mt,
                onFocus: ze,
                onClick (xe) {
                    m === !0 && $848b1ce88e755b32$var$tt(xe);
                }
            };
            return F.onCompositionstart = F.onCompositionupdate = F.onCompositionend = B, F;
        });
        (0, $eayOh.watch)(_, (F)=>{
            d = F, e.useInput === !0 && e.fillInput === !0 && e.multiple !== !0 && V.innerLoading.value !== !0 && (a.value !== !0 && i.value !== !0 || oe.value !== !0) && (y !== !0 && oi(), (a.value === !0 || i.value === !0) && Ne(""));
        }, {
            immediate: !0
        }), (0, $eayOh.watch)(()=>e.fillInput, oi), (0, $eayOh.watch)(i, Hs), (0, $eayOh.watch)(q, h0);
        function Ee(F) {
            return e.emitValue === !0 ? ne.value(F) : F;
        }
        function Ae(F) {
            if (F !== -1 && F < _.value.length) {
                if (e.multiple === !0) {
                    let xe = e.modelValue.slice();
                    o("remove", {
                        index: F,
                        value: xe.splice(F, 1)[0]
                    }), o("update:modelValue", xe);
                } else o("update:modelValue", null);
            }
        }
        function nt(F) {
            Ae(F), V.focus();
        }
        function ct(F, xe) {
            let ge = Ee(F);
            if (e.multiple !== !0) {
                e.fillInput === !0 && Be(se.value(F), !0, !0), o("update:modelValue", ge);
                return;
            }
            if (_.value.length === 0) {
                o("add", {
                    index: 0,
                    value: ge
                }), o("update:modelValue", e.multiple === !0 ? [
                    ge
                ] : ge);
                return;
            }
            if (xe === !0 && ke(F) === !0 || e.maxValues !== void 0 && e.modelValue.length >= e.maxValues) return;
            let Ue = e.modelValue.slice();
            o("add", {
                index: Ue.length,
                value: ge
            }), Ue.push(ge), o("update:modelValue", Ue);
        }
        function dt(F, xe) {
            if (V.editable.value !== !0 || F === void 0 || Y.value(F) === !0) return;
            let ge = ne.value(F);
            if (e.multiple !== !0) {
                xe !== !0 && (Be(e.fillInput === !0 ? se.value(F) : "", !0, !0), wr()), P.value !== null && P.value.focus(), (_.value.length === 0 || $848b1ce88e755b32$var$Zt(ne.value(_.value[0]), ge) !== !0) && o("update:modelValue", e.emitValue === !0 ? ge : F);
                return;
            }
            if ((m !== !0 || c.value === !0) && V.focus(), ze(), _.value.length === 0) {
                let ft = e.emitValue === !0 ? ge : F;
                o("add", {
                    index: 0,
                    value: ft
                }), o("update:modelValue", e.multiple === !0 ? [
                    ft
                ] : ft);
                return;
            }
            let Ue = e.modelValue.slice(), vt = me.value.findIndex((ft)=>$848b1ce88e755b32$var$Zt(ft, ge));
            if (vt !== -1) o("remove", {
                index: vt,
                value: Ue.splice(vt, 1)[0]
            });
            else {
                if (e.maxValues !== void 0 && Ue.length >= e.maxValues) return;
                let ft = e.emitValue === !0 ? ge : F;
                o("add", {
                    index: Ue.length,
                    value: ft
                }), Ue.push(ft);
            }
            o("update:modelValue", Ue);
        }
        function G(F) {
            if (n.platform.is.desktop !== !0) return;
            let xe = F !== -1 && F < q.value ? F : -1;
            l.value !== xe && (l.value = xe);
        }
        function re(F = 1, xe) {
            if (i.value === !0) {
                let ge = l.value;
                do ge = $848b1ce88e755b32$var$qr(ge + F, -1, q.value - 1);
                while (ge !== -1 && ge !== l.value && Y.value(e.options[ge]) === !0);
                l.value !== ge && (G(ge), W(ge), xe !== !0 && e.useInput === !0 && e.fillInput === !0 && qe(ge >= 0 ? se.value(e.options[ge]) : C, !0));
            }
        }
        function K(F, xe) {
            let ge = (Ue)=>$848b1ce88e755b32$var$Zt(ne.value(Ue), F);
            return e.options.find(ge) || xe.find(ge) || F;
        }
        function ee(F, xe) {
            let ge = F !== void 0 ? F : xe;
            return typeof ge == "function" ? ge : (Ue)=>Ue !== null && typeof Ue == "object" && ge in Ue ? Ue[ge] : Ue;
        }
        function ke(F) {
            let xe = ne.value(F);
            return me.value.find((ge)=>$848b1ce88e755b32$var$Zt(ge, xe)) !== void 0;
        }
        function ze(F) {
            e.useInput === !0 && P.value !== null && (F === void 0 || P.value === F.target && F.target.value === z.value) && P.value.select();
        }
        function ye(F) {
            $848b1ce88e755b32$var$wt(F, 27) === !0 && i.value === !0 && ($848b1ce88e755b32$var$tt(F), wr(), oi()), o("keyup", F);
        }
        function Ge(F) {
            let { value: xe } = F.target;
            if (F.keyCode !== void 0) {
                ye(F);
                return;
            }
            if (F.target.value = "", v !== null && (clearTimeout(v), v = null), f !== null && (clearTimeout(f), f = null), oi(), typeof xe == "string" && xe.length !== 0) {
                let ge = xe.toLocaleLowerCase(), Ue = (ft)=>{
                    let jt = e.options.find((Pt)=>ft.value(Pt).toLocaleLowerCase() === ge);
                    return jt === void 0 ? !1 : (_.value.indexOf(jt) === -1 ? dt(jt) : wr(), !0);
                }, vt = (ft)=>{
                    Ue(ne) !== !0 && (Ue(se) === !0 || ft === !0 || Ne(xe, !0, ()=>vt(!0)));
                };
                vt();
            } else V.clearValue(F);
        }
        function mt(F) {
            o("keypress", F);
        }
        function ht(F) {
            if (o("keydown", F), $848b1ce88e755b32$var$xo(F) === !0) return;
            let xe = s.value.length !== 0 && (e.newValueMode !== void 0 || e.onNewValue !== void 0), ge = F.shiftKey !== !0 && e.multiple !== !0 && (l.value !== -1 || xe === !0);
            if (F.keyCode === 27) {
                $848b1ce88e755b32$var$ut(F);
                return;
            }
            if (F.keyCode === 9 && ge === !1) {
                rt();
                return;
            }
            if (F.target === void 0 || F.target.id !== V.targetUid.value || V.editable.value !== !0) return;
            if (F.keyCode === 40 && V.innerLoading.value !== !0 && i.value === !1) {
                $848b1ce88e755b32$var$Se(F), To();
                return;
            }
            if (F.keyCode === 8 && (e.useChips === !0 || e.clearable === !0) && e.hideSelected !== !0 && s.value.length === 0) {
                e.multiple === !0 && Array.isArray(e.modelValue) === !0 ? Ae(e.modelValue.length - 1) : e.multiple !== !0 && e.modelValue !== null && o("update:modelValue", null);
                return;
            }
            (F.keyCode === 35 || F.keyCode === 36) && (typeof s.value != "string" || s.value.length === 0) && ($848b1ce88e755b32$var$Se(F), l.value = -1, re(F.keyCode === 36 ? 1 : -1, e.multiple)), (F.keyCode === 33 || F.keyCode === 34) && j.value !== void 0 && ($848b1ce88e755b32$var$Se(F), l.value = Math.max(-1, Math.min(q.value, l.value + (F.keyCode === 33 ? -1 : 1) * j.value.view)), re(F.keyCode === 33 ? 1 : -1, e.multiple)), (F.keyCode === 38 || F.keyCode === 40) && ($848b1ce88e755b32$var$Se(F), re(F.keyCode === 38 ? -1 : 1, e.multiple));
            let Ue = q.value;
            if ((h === void 0 || g < Date.now()) && (h = ""), Ue > 0 && e.useInput !== !0 && F.key !== void 0 && F.key.length === 1 && F.altKey === !1 && F.ctrlKey === !1 && F.metaKey === !1 && (F.keyCode !== 32 || h.length !== 0)) {
                i.value !== !0 && To(F);
                let vt = F.key.toLocaleLowerCase(), ft = h.length === 1 && h[0] === vt;
                g = Date.now() + 1500, ft === !1 && ($848b1ce88e755b32$var$Se(F), h += vt);
                let jt = new RegExp("^" + h.split("").map((Ns)=>$848b1ce88e755b32$var$XC.indexOf(Ns) !== -1 ? "\\" + Ns : Ns).join(".*"), "i"), Pt = l.value;
                if (ft === !0 || Pt < 0 || jt.test(se.value(e.options[Pt])) !== !0) do Pt = $848b1ce88e755b32$var$qr(Pt + 1, -1, Ue - 1);
                while (Pt !== l.value && (Y.value(e.options[Pt]) === !0 || jt.test(se.value(e.options[Pt])) !== !0));
                l.value !== Pt && (0, $fVLUl.nextTick)(()=>{
                    G(Pt), W(Pt), Pt >= 0 && e.useInput === !0 && e.fillInput === !0 && qe(se.value(e.options[Pt]), !0);
                });
                return;
            }
            if (!(F.keyCode !== 13 && (F.keyCode !== 32 || e.useInput === !0 || h !== "") && (F.keyCode !== 9 || ge === !1))) {
                if (F.keyCode !== 9 && $848b1ce88e755b32$var$Se(F), l.value !== -1 && l.value < Ue) {
                    dt(e.options[l.value]);
                    return;
                }
                if (xe === !0) {
                    let vt = (ft, jt)=>{
                        if (jt) {
                            if ($848b1ce88e755b32$var$Hg(jt) !== !0) return;
                        } else jt = e.newValueMode;
                        if (Be("", e.multiple !== !0, !0), ft == null) return;
                        (jt === "toggle" ? dt : ct)(ft, jt === "add-unique"), e.multiple !== !0 && (P.value !== null && P.value.focus(), wr());
                    };
                    if (e.onNewValue !== void 0 ? o("newValue", s.value, vt) : vt(s.value), e.multiple !== !0) return;
                }
                i.value === !0 ? rt() : V.innerLoading.value !== !0 && To();
            }
        }
        function ro() {
            return m === !0 ? E.value : $.value !== null && $.value.contentEl !== null ? $.value.contentEl : void 0;
        }
        function qo() {
            return ro();
        }
        function kn() {
            return e.hideSelected === !0 ? [] : t["selected-item"] !== void 0 ? Me.value.map((F)=>t["selected-item"](F)).slice() : t.selected !== void 0 ? [].concat(t.selected()) : e.useChips === !0 ? Me.value.map((F, xe)=>(0, $fVLUl.h)($848b1ce88e755b32$export$fe8abce8a0a972d6, {
                    key: "option-" + xe,
                    removable: V.editable.value === !0 && Y.value(F.opt) !== !0,
                    dense: !0,
                    textColor: e.color,
                    tabindex: ae.value,
                    onRemove () {
                        F.removeAtIndex(xe);
                    }
                }, ()=>(0, $fVLUl.h)("span", {
                        class: "ellipsis",
                        [F.html === !0 ? "innerHTML" : "textContent"]: se.value(F.opt)
                    }))) : [
                (0, $fVLUl.h)("span", {
                    [U.value === !0 ? "innerHTML" : "textContent"]: ue.value
                })
            ];
        }
        function en() {
            if (te.value === !0) return t["no-option"] !== void 0 ? t["no-option"]({
                inputValue: s.value
            }) : void 0;
            let F = t.option !== void 0 ? t.option : (ge)=>(0, $fVLUl.h)($848b1ce88e755b32$export$adf75769807ad87e, {
                    key: ge.index,
                    ...ge.itemProps
                }, ()=>(0, $fVLUl.h)($848b1ce88e755b32$export$9579d29612d4e773, ()=>(0, $fVLUl.h)($848b1ce88e755b32$export$17cb5eb1f3204256, ()=>(0, $fVLUl.h)("span", {
                                [ge.html === !0 ? "innerHTML" : "textContent"]: ge.label
                            })))), xe = w("div", le.value.map(F));
            return t["before-options"] !== void 0 && (xe = t["before-options"]().concat(xe)), $848b1ce88e755b32$var$Ke(t["after-options"], xe);
        }
        function Z(F, xe) {
            let ge = xe === !0 ? {
                ...ce.value,
                ...V.splitAttrs.attributes.value
            } : void 0, Ue = {
                ref: xe === !0 ? P : void 0,
                key: "i_t",
                class: T.value,
                style: e.inputStyle,
                value: s.value !== void 0 ? s.value : "",
                type: "search",
                ...ge,
                id: xe === !0 ? V.targetUid.value : void 0,
                maxlength: e.maxlength,
                autocomplete: e.autocomplete,
                "data-autofocus": F === !0 || e.autofocus === !0 || void 0,
                disabled: e.disable === !0,
                readonly: e.readonly === !0,
                ...Pe.value
            };
            return F !== !0 && m === !0 && (Array.isArray(Ue.class) === !0 ? Ue.class = [
                ...Ue.class,
                "no-pointer-events"
            ] : Ue.class += " no-pointer-events"), (0, $fVLUl.h)("input", Ue);
        }
        function ve(F) {
            v !== null && (clearTimeout(v), v = null), f !== null && (clearTimeout(f), f = null), !(F && F.target && F.target.qComposing === !0) && (qe(F.target.value || ""), y = !0, C = s.value, V.focused.value !== !0 && (m !== !0 || c.value === !0) && V.focus(), e.onFilter !== void 0 && (v = setTimeout(()=>{
                v = null, Ne(s.value);
            }, e.inputDebounce)));
        }
        function qe(F, xe) {
            s.value !== F && (s.value = F, xe === !0 || e.inputDebounce === 0 || e.inputDebounce === "0" ? o("inputValue", F) : f = setTimeout(()=>{
                f = null, o("inputValue", F);
            }, e.inputDebounce));
        }
        function Be(F, xe, ge) {
            y = ge !== !0, e.useInput === !0 && (qe(F, !0), (xe === !0 || ge !== !0) && (C = F), xe !== !0 && Ne(F));
        }
        function Ne(F, xe, ge) {
            if (e.onFilter === void 0 || xe !== !0 && V.focused.value !== !0) return;
            V.innerLoading.value === !0 ? o("filterAbort") : (V.innerLoading.value = !0, u.value = !0), F !== "" && e.multiple !== !0 && _.value.length !== 0 && y !== !0 && F === se.value(_.value[0]) && (F = "");
            let Ue = setTimeout(()=>{
                i.value === !0 && (i.value = !1);
            }, 10);
            p !== null && clearTimeout(p), p = Ue, o("filter", F, (vt, ft)=>{
                (xe === !0 || V.focused.value === !0) && p === Ue && (clearTimeout(p), typeof vt == "function" && vt(), u.value = !1, (0, $fVLUl.nextTick)(()=>{
                    V.innerLoading.value = !1, V.editable.value === !0 && (xe === !0 ? i.value === !0 && wr() : i.value === !0 ? Hs(!0) : i.value = !0), typeof ft == "function" && (0, $fVLUl.nextTick)(()=>{
                        ft(r);
                    }), typeof ge == "function" && (0, $fVLUl.nextTick)(()=>{
                        ge(r);
                    });
                }));
            }, ()=>{
                V.focused.value === !0 && p === Ue && (clearTimeout(p), V.innerLoading.value = !1, u.value = !1), i.value === !0 && (i.value = !1);
            });
        }
        function pt() {
            return (0, $fVLUl.h)($848b1ce88e755b32$export$73537802004a2118, {
                ref: $,
                class: D.value,
                style: e.popupContentStyle,
                modelValue: i.value,
                fit: e.menuShrink !== !0,
                cover: e.optionsCover === !0 && te.value !== !0 && e.useInput !== !0,
                anchor: e.menuAnchor,
                self: e.menuSelf,
                offset: e.menuOffset,
                dark: I.value,
                noParentEvent: !0,
                noRefocus: !0,
                noFocus: !0,
                noRouteDismiss: e.popupNoRouteDismiss,
                square: Fe.value,
                transitionShow: e.transitionShow,
                transitionHide: e.transitionHide,
                transitionDuration: e.transitionDuration,
                separateClosePopup: !0,
                ...be.value,
                onScrollPassive: H,
                onBeforeShow: Bd,
                onBeforeHide: M,
                onShow: O
            }, en);
        }
        function M(F) {
            Ld(F), rt();
        }
        function O() {
            ie();
        }
        function X(F) {
            $848b1ce88e755b32$var$tt(F), P.value !== null && P.value.focus(), c.value = !0, window.scrollTo(window.pageXOffset || window.scrollX || document.body.scrollLeft || 0, 0);
        }
        function de(F) {
            $848b1ce88e755b32$var$tt(F), (0, $fVLUl.nextTick)(()=>{
                c.value = !1;
            });
        }
        function fe() {
            let F = [
                (0, $fVLUl.h)($848b1ce88e755b32$export$9e1d68206b908513, {
                    class: `col-auto ${V.fieldClass.value}`,
                    ...N.value,
                    for: V.targetUid.value,
                    dark: I.value,
                    square: !0,
                    loading: u.value,
                    itemAligned: !1,
                    filled: !0,
                    stackLabel: s.value.length !== 0,
                    ...V.splitAttrs.listeners.value,
                    onFocus: X,
                    onBlur: de
                }, {
                    ...t,
                    rawControl: ()=>V.getControl(!0),
                    before: void 0,
                    after: void 0
                })
            ];
            return i.value === !0 && F.push((0, $fVLUl.h)("div", {
                ref: E,
                class: D.value + " scroll",
                style: e.popupContentStyle,
                ...be.value,
                onClick: $848b1ce88e755b32$var$ut,
                onScrollPassive: H
            }, en())), (0, $fVLUl.h)($848b1ce88e755b32$export$e6ccdac5fb3e2417, {
                ref: L,
                modelValue: a.value,
                position: e.useInput === !0 ? "top" : void 0,
                transitionShow: b,
                transitionHide: e.transitionHide,
                transitionDuration: e.transitionDuration,
                noRouteDismiss: e.popupNoRouteDismiss,
                onBeforeShow: Bd,
                onBeforeHide: et,
                onHide: Te,
                onShow: We
            }, ()=>(0, $fVLUl.h)("div", {
                    class: "q-select__dialog" + (I.value === !0 ? " q-select__dialog--dark q-dark" : "") + (c.value === !0 ? " q-select__dialog--focused" : "")
                }, F));
        }
        function et(F) {
            Ld(F), L.value !== null && L.value.__updateRefocusTarget(V.rootRef.value.querySelector(".q-field__native > [tabindex]:last-child")), V.focused.value = !1;
        }
        function Te(F) {
            wr(), V.focused.value === !1 && o("blur", F), oi();
        }
        function We() {
            let F = document.activeElement;
            (F === null || F.id !== V.targetUid.value) && P.value !== null && P.value !== F && P.value.focus(), ie();
        }
        function rt() {
            a.value !== !0 && (l.value = -1, i.value === !0 && (i.value = !1), V.focused.value === !1 && (p !== null && (clearTimeout(p), p = null), V.innerLoading.value === !0 && (o("filterAbort"), V.innerLoading.value = !1, u.value = !1)));
        }
        function To(F) {
            V.editable.value === !0 && (m === !0 ? (V.onControlFocusin(F), a.value = !0, (0, $fVLUl.nextTick)(()=>{
                V.focus();
            })) : V.focus(), e.onFilter !== void 0 ? Ne(s.value) : (te.value !== !0 || t["no-option"] !== void 0) && (i.value = !0));
        }
        function wr() {
            a.value = !1, rt();
        }
        function oi() {
            e.useInput === !0 && Be(e.multiple !== !0 && e.fillInput === !0 && _.value.length !== 0 && se.value(_.value[0]) || "", !0, !0);
        }
        function Hs(F) {
            let xe = -1;
            if (F === !0) {
                if (_.value.length !== 0) {
                    let ge = ne.value(_.value[0]);
                    xe = e.options.findIndex((Ue)=>$848b1ce88e755b32$var$Zt(ne.value(Ue), ge));
                }
                Q(xe);
            }
            G(xe);
        }
        function h0(F, xe) {
            i.value === !0 && V.innerLoading.value === !1 && (Q(-1, !0), (0, $fVLUl.nextTick)(()=>{
                i.value === !0 && V.innerLoading.value === !1 && (F > xe ? Q() : Hs(!0));
            }));
        }
        function Ed() {
            a.value === !1 && $.value !== null && $.value.updatePosition();
        }
        function Bd(F) {
            F !== void 0 && $848b1ce88e755b32$var$tt(F), o("popupShow", F), V.hasPopupOpen = !0, V.onControlFocusin(F);
        }
        function Ld(F) {
            F !== void 0 && $848b1ce88e755b32$var$tt(F), o("popupHide", F), V.hasPopupOpen = !1, V.onControlFocusout(F);
        }
        function Fd() {
            m = n.platform.is.mobile !== !0 && e.behavior !== "dialog" ? !1 : e.behavior !== "menu" && (e.useInput === !0 ? t["no-option"] !== void 0 || e.onFilter !== void 0 || te.value === !1 : !0), b = n.platform.is.ios === !0 && m === !0 && e.useInput === !0 ? "fade" : e.transitionShow;
        }
        return (0, $fVLUl.onBeforeUpdate)(Fd), (0, $fVLUl.onUpdated)(Ed), Fd(), (0, $fVLUl.onBeforeUnmount)(()=>{
            v !== null && clearTimeout(v), f !== null && clearTimeout(f);
        }), Object.assign(r, {
            showPopup: To,
            hidePopup: wr,
            removeAtIndex: Ae,
            add: ct,
            toggleOption: dt,
            getOptionIndex: ()=>l.value,
            setOptionIndex: G,
            moveOptionSelection: re,
            filter: Ne,
            updateMenuPosition: Ed,
            updateInputValue: Be,
            isOptionSelected: ke,
            getEmittingOptionValue: Ee,
            isOptionDisabled: (...F)=>Y.value.apply(null, F) === !0,
            getOptionValue: (...F)=>ne.value.apply(null, F),
            getOptionLabel: (...F)=>se.value.apply(null, F)
        }), Object.assign(V, {
            innerValue: _,
            fieldClass: (0, $eayOh.computed)(()=>`q-select q-field--auto-height q-select--with${e.useInput !== !0 ? "out" : ""}-input q-select--with${e.useChips !== !0 ? "out" : ""}-chips q-select--${e.multiple === !0 ? "multiple" : "single"}`),
            inputRef: S,
            targetRef: P,
            hasValue: oe,
            showPopup: To,
            floatingLabel: (0, $eayOh.computed)(()=>e.hideSelected !== !0 && oe.value === !0 || typeof s.value == "number" || s.value.length !== 0 || $848b1ce88e755b32$var$pn(e.displayValue)),
            getControlChild: ()=>{
                if (V.editable.value !== !1 && (a.value === !0 || te.value !== !0 || t["no-option"] !== void 0)) return m === !0 ? fe() : pt();
                V.hasPopupOpen === !0 && (V.hasPopupOpen = !1);
            },
            controlEvents: {
                onFocusin (F) {
                    V.onControlFocusin(F);
                },
                onFocusout (F) {
                    V.onControlFocusout(F, ()=>{
                        oi(), rt();
                    });
                },
                onClick (F) {
                    if ($848b1ce88e755b32$var$ut(F), m !== !0 && i.value === !0) {
                        rt(), P.value !== null && P.value.focus();
                        return;
                    }
                    To(F);
                }
            },
            getControl: (F)=>{
                let xe = kn(), ge = F === !0 || a.value !== !0 || m !== !0;
                if (e.useInput === !0) xe.push(Z(F, ge));
                else if (V.editable.value === !0) {
                    let vt = ge === !0 ? ce.value : void 0;
                    xe.push((0, $fVLUl.h)("input", {
                        ref: ge === !0 ? P : void 0,
                        key: "d_t",
                        class: "q-select__focus-target",
                        id: ge === !0 ? V.targetUid.value : void 0,
                        value: ue.value,
                        readonly: !0,
                        "data-autofocus": F === !0 || e.autofocus === !0 || void 0,
                        ...vt,
                        onKeydown: ht,
                        onKeyup: ye,
                        onKeypress: mt
                    })), ge === !0 && typeof e.autocomplete == "string" && e.autocomplete.length !== 0 && xe.push((0, $fVLUl.h)("input", {
                        class: "q-select__autocomplete-input",
                        autocomplete: e.autocomplete,
                        tabindex: -1,
                        onKeyup: Ge
                    }));
                }
                if (A.value !== void 0 && e.disable !== !0 && me.value.length !== 0) {
                    let vt = me.value.map((ft)=>(0, $fVLUl.h)("option", {
                            value: ft,
                            selected: !0
                        }));
                    xe.push((0, $fVLUl.h)("select", {
                        class: "hidden",
                        name: A.value,
                        multiple: e.multiple
                    }, vt));
                }
                let Ue = e.useInput === !0 || ge !== !0 ? void 0 : V.splitAttrs.attributes.value;
                return (0, $fVLUl.h)("div", {
                    class: "q-field__native row items-center",
                    ...Ue,
                    ...V.splitAttrs.listeners.value
                }, xe);
            },
            getInnerAppend: ()=>e.loading !== !0 && u.value !== !0 && e.hideDropdownIcon !== !0 ? [
                    (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                        class: "q-select__dropdown-icon" + (i.value === !0 ? " rotate-180" : ""),
                        name: Re.value
                    })
                ] : null
        }), $848b1ce88e755b32$var$fr(V);
    }
});
var $848b1ce88e755b32$var$ew = [
    "text",
    "rect",
    "circle",
    "QBtn",
    "QBadge",
    "QChip",
    "QToolbar",
    "QCheckbox",
    "QRadio",
    "QToggle",
    "QSlider",
    "QRange",
    "QInput",
    "QAvatar"
], $848b1ce88e755b32$var$tw = [
    "wave",
    "pulse",
    "pulse-x",
    "pulse-y",
    "fade",
    "blink",
    "none"
], $848b1ce88e755b32$export$c03597c5c32a1b2c = $848b1ce88e755b32$var$R({
    name: "QSkeleton",
    props: {
        ...$848b1ce88e755b32$var$he,
        tag: {
            type: String,
            default: "div"
        },
        type: {
            type: String,
            validator: (e)=>$848b1ce88e755b32$var$ew.includes(e),
            default: "rect"
        },
        animation: {
            type: String,
            validator: (e)=>$848b1ce88e755b32$var$tw.includes(e),
            default: "wave"
        },
        animationSpeed: {
            type: [
                String,
                Number
            ],
            default: 1500
        },
        square: Boolean,
        bordered: Boolean,
        size: String,
        width: String,
        height: String
    },
    setup (e, { slots: t }) {
        let o = (0, $fVLUl.getCurrentInstance)(), r = $848b1ce88e755b32$var$pe(e, o.proxy.$q), n = (0, $eayOh.computed)(()=>{
            let a = e.size !== void 0 ? [
                e.size,
                e.size
            ] : [
                e.width,
                e.height
            ];
            return {
                "--q-skeleton-speed": `${e.animationSpeed}ms`,
                width: a[0],
                height: a[1]
            };
        }), i = (0, $eayOh.computed)(()=>`q-skeleton q-skeleton--${r.value === !0 ? "dark" : "light"} q-skeleton--type-${e.type}` + (e.animation !== "none" ? ` q-skeleton--anim q-skeleton--anim-${e.animation}` : "") + (e.square === !0 ? " q-skeleton--square" : "") + (e.bordered === !0 ? " q-skeleton--bordered" : ""));
        return ()=>(0, $fVLUl.h)(e.tag, {
                class: i.value,
                style: n.value
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$var$Ug = [
    [
        "left",
        "center",
        "start",
        "width"
    ],
    [
        "right",
        "center",
        "end",
        "width"
    ],
    [
        "top",
        "start",
        "center",
        "height"
    ],
    [
        "bottom",
        "end",
        "center",
        "height"
    ]
], $848b1ce88e755b32$export$4b0d074f5c781fdc = $848b1ce88e755b32$var$R({
    name: "QSlideItem",
    props: {
        ...$848b1ce88e755b32$var$he,
        leftColor: String,
        rightColor: String,
        topColor: String,
        bottomColor: String,
        onSlide: Function
    },
    emits: [
        "action",
        "top",
        "right",
        "bottom",
        "left"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: r } = (0, $fVLUl.getCurrentInstance)(), { $q: n } = r, i = $848b1ce88e755b32$var$pe(e, n), { getCache: a } = $848b1ce88e755b32$export$1c2929d84167dd53(), l = (0, $eayOh.ref)(null), s = null, c = {}, u = {}, v = {}, f = (0, $eayOh.computed)(()=>n.lang.rtl === !0 ? {
                left: "right",
                right: "left"
            } : {
                left: "left",
                right: "right"
            }), d = (0, $eayOh.computed)(()=>"q-slide-item q-item-type overflow-hidden" + (i.value === !0 ? " q-slide-item--dark q-dark" : ""));
        function m() {
            l.value.style.transform = "translate(0,0)";
        }
        function y(C, b, h) {
            e.onSlide !== void 0 && o("slide", {
                side: C,
                ratio: b,
                isReset: h
            });
        }
        function p(C) {
            let b = l.value;
            if (C.isFirst) c = {
                dir: null,
                size: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                },
                scale: 0
            }, b.classList.add("no-transition"), $848b1ce88e755b32$var$Ug.forEach((P)=>{
                if (t[P[0]] !== void 0) {
                    let $ = v[P[0]];
                    $.style.transform = "scale(1)", c.size[P[0]] = $.getBoundingClientRect()[P[3]];
                }
            }), c.axis = C.direction === "up" || C.direction === "down" ? "Y" : "X";
            else if (C.isFinal) {
                b.classList.remove("no-transition"), c.scale === 1 ? (b.style.transform = `translate${c.axis}(${c.dir * 100}%)`, s !== null && clearTimeout(s), s = setTimeout(()=>{
                    s = null, o(c.showing, {
                        reset: m
                    }), o("action", {
                        side: c.showing,
                        reset: m
                    });
                }, 230)) : (b.style.transform = "translate(0,0)", y(c.showing, 0, !0));
                return;
            } else C.direction = c.axis === "X" ? C.offset.x < 0 ? "left" : "right" : C.offset.y < 0 ? "up" : "down";
            if (t.left === void 0 && C.direction === f.value.right || t.right === void 0 && C.direction === f.value.left || t.top === void 0 && C.direction === "down" || t.bottom === void 0 && C.direction === "up") {
                b.style.transform = "translate(0,0)";
                return;
            }
            let h, g, S;
            c.axis === "X" ? (g = C.direction === "left" ? -1 : 1, h = g === 1 ? f.value.left : f.value.right, S = C.distance.x) : (g = C.direction === "up" ? -2 : 2, h = g === 2 ? "top" : "bottom", S = C.distance.y), !(c.dir !== null && Math.abs(g) !== Math.abs(c.dir)) && (c.dir !== g && ([
                "left",
                "right",
                "top",
                "bottom"
            ].forEach((P)=>{
                u[P] && (u[P].style.visibility = h === P ? "visible" : "hidden");
            }), c.showing = h, c.dir = g), c.scale = Math.max(0, Math.min(1, (S - 40) / c.size[h])), b.style.transform = `translate${c.axis}(${S * g / Math.abs(g)}px)`, v[h].style.transform = `scale(${c.scale})`, y(h, c.scale, !1));
        }
        return (0, $fVLUl.onBeforeUpdate)(()=>{
            u = {}, v = {};
        }), (0, $fVLUl.onBeforeUnmount)(()=>{
            s !== null && clearTimeout(s);
        }), Object.assign(r, {
            reset: m
        }), ()=>{
            let C = [], b = {
                left: t[f.value.right] !== void 0,
                right: t[f.value.left] !== void 0,
                up: t.bottom !== void 0,
                down: t.top !== void 0
            }, h = Object.keys(b).filter((S)=>b[S] === !0);
            $848b1ce88e755b32$var$Ug.forEach((S)=>{
                let P = S[0];
                t[P] !== void 0 && C.push((0, $fVLUl.h)("div", {
                    key: P,
                    ref: ($)=>{
                        u[P] = $;
                    },
                    class: `q-slide-item__${P} absolute-full row no-wrap items-${S[1]} justify-${S[2]}` + (e[P + "Color"] !== void 0 ? ` bg-${e[P + "Color"]}` : "")
                }, [
                    (0, $fVLUl.h)("div", {
                        ref: ($)=>{
                            v[P] = $;
                        }
                    }, t[P]())
                ]));
            });
            let g = (0, $fVLUl.h)("div", {
                key: `${h.length === 0 ? "only-" : ""} content`,
                ref: l,
                class: "q-slide-item__content"
            }, $848b1ce88e755b32$var$J(t.default));
            return h.length === 0 ? C.push(g) : C.push((0, $fVLUl.withDirectives)(g, a("dir#" + h.join(""), ()=>{
                let S = {
                    prevent: !0,
                    stop: !0,
                    mouse: !0
                };
                return h.forEach((P)=>{
                    S[P] = !0;
                }), [
                    [
                        $848b1ce88e755b32$export$718797250d1e376,
                        p,
                        void 0,
                        S
                    ]
                ];
            }))), (0, $fVLUl.h)("div", {
                class: d.value
            }, C);
        };
    }
});
var $848b1ce88e755b32$var$uw = (0, $fVLUl.h)("div", {
    class: "q-space"
}), $848b1ce88e755b32$export$e2e812bf9ee33e1a = $848b1ce88e755b32$var$R({
    name: "QSpace",
    setup () {
        return ()=>$848b1ce88e755b32$var$uw;
    }
});
var $848b1ce88e755b32$var$sw = [
    (0, $fVLUl.h)("g", {
        transform: "matrix(1 0 0 -1 0 80)"
    }, [
        (0, $fVLUl.h)("rect", {
            width: "10",
            height: "20",
            rx: "3"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "height",
                begin: "0s",
                dur: "4.3s",
                values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("rect", {
            x: "15",
            width: "10",
            height: "80",
            rx: "3"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "height",
                begin: "0s",
                dur: "2s",
                values: "80;55;33;5;75;23;73;33;12;14;60;80",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("rect", {
            x: "30",
            width: "10",
            height: "50",
            rx: "3"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "height",
                begin: "0s",
                dur: "1.4s",
                values: "50;34;78;23;56;23;34;76;80;54;21;50",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("rect", {
            x: "45",
            width: "10",
            height: "30",
            rx: "3"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "height",
                begin: "0s",
                dur: "2s",
                values: "30;45;13;80;56;72;45;76;34;23;67;30",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ])
    ])
], $848b1ce88e755b32$export$65a05f088d8e2ad5 = $848b1ce88e755b32$var$R({
    name: "QSpinnerAudio",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                fill: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 55 80",
                xmlns: "http://www.w3.org/2000/svg"
            }, $848b1ce88e755b32$var$sw);
    }
});
var $848b1ce88e755b32$var$cw = [
    (0, $fVLUl.h)("g", {
        transform: "translate(1 1)",
        "stroke-width": "2",
        fill: "none",
        "fill-rule": "evenodd"
    }, [
        (0, $fVLUl.h)("circle", {
            cx: "5",
            cy: "50",
            r: "5"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "cy",
                begin: "0s",
                dur: "2.2s",
                values: "50;5;50;50",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $fVLUl.h)("animate", {
                attributeName: "cx",
                begin: "0s",
                dur: "2.2s",
                values: "5;27;49;5",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("circle", {
            cx: "27",
            cy: "5",
            r: "5"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "cy",
                begin: "0s",
                dur: "2.2s",
                from: "5",
                to: "5",
                values: "5;50;50;5",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $fVLUl.h)("animate", {
                attributeName: "cx",
                begin: "0s",
                dur: "2.2s",
                from: "27",
                to: "27",
                values: "27;49;5;27",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("circle", {
            cx: "49",
            cy: "50",
            r: "5"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "cy",
                begin: "0s",
                dur: "2.2s",
                values: "50;50;5;50",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $fVLUl.h)("animate", {
                attributeName: "cx",
                from: "49",
                to: "49",
                begin: "0s",
                dur: "2.2s",
                values: "49;5;27;49",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ])
    ])
], $848b1ce88e755b32$export$bccad2bfd65ba3b3 = $848b1ce88e755b32$var$R({
    name: "QSpinnerBall",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                stroke: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 57 57",
                xmlns: "http://www.w3.org/2000/svg"
            }, $848b1ce88e755b32$var$cw);
    }
});
var $848b1ce88e755b32$var$dw = [
    (0, $fVLUl.h)("rect", {
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "height",
            begin: "0.5s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $fVLUl.h)("animate", {
            attributeName: "y",
            begin: "0.5s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("rect", {
        x: "30",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "height",
            begin: "0.25s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $fVLUl.h)("animate", {
            attributeName: "y",
            begin: "0.25s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("rect", {
        x: "60",
        width: "15",
        height: "140",
        rx: "6"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "height",
            begin: "0s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $fVLUl.h)("animate", {
            attributeName: "y",
            begin: "0s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("rect", {
        x: "90",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "height",
            begin: "0.25s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $fVLUl.h)("animate", {
            attributeName: "y",
            begin: "0.25s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("rect", {
        x: "120",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "height",
            begin: "0.5s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $fVLUl.h)("animate", {
            attributeName: "y",
            begin: "0.5s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ])
], $848b1ce88e755b32$export$4a50726b08ffdead = $848b1ce88e755b32$var$R({
    name: "QSpinnerBars",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                fill: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 135 140",
                xmlns: "http://www.w3.org/2000/svg"
            }, $848b1ce88e755b32$var$dw);
    }
});
var $848b1ce88e755b32$var$fw = [
    (0, $fVLUl.h)("rect", {
        x: "25",
        y: "25",
        width: "50",
        height: "50",
        fill: "none",
        "stroke-width": "4",
        stroke: "currentColor"
    }, [
        (0, $fVLUl.h)("animateTransform", {
            id: "spinnerBox",
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "180 50 50",
            dur: "0.5s",
            begin: "rectBox.end"
        })
    ]),
    (0, $fVLUl.h)("rect", {
        x: "27",
        y: "27",
        width: "46",
        height: "50",
        fill: "currentColor"
    }, [
        (0, $fVLUl.h)("animate", {
            id: "rectBox",
            attributeName: "height",
            begin: "0s;spinnerBox.end",
            dur: "1.3s",
            from: "50",
            to: "0",
            fill: "freeze"
        })
    ])
], $848b1ce88e755b32$export$dca5c45bff96781d = $848b1ce88e755b32$var$R({
    name: "QSpinnerBox",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, $848b1ce88e755b32$var$fw);
    }
});
var $848b1ce88e755b32$var$mw = [
    (0, $fVLUl.h)("circle", {
        cx: "50",
        cy: "50",
        r: "48",
        fill: "none",
        "stroke-width": "4",
        "stroke-miterlimit": "10",
        stroke: "currentColor"
    }),
    (0, $fVLUl.h)("line", {
        "stroke-linecap": "round",
        "stroke-width": "4",
        "stroke-miterlimit": "10",
        stroke: "currentColor",
        x1: "50",
        y1: "50",
        x2: "85",
        y2: "50.5"
    }, [
        (0, $fVLUl.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "2s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("line", {
        "stroke-linecap": "round",
        "stroke-width": "4",
        "stroke-miterlimit": "10",
        stroke: "currentColor",
        x1: "50",
        y1: "50",
        x2: "49.5",
        y2: "74"
    }, [
        (0, $fVLUl.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "15s",
            repeatCount: "indefinite"
        })
    ])
], $848b1ce88e755b32$export$ecf55558d357e9b2 = $848b1ce88e755b32$var$R({
    name: "QSpinnerClock",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, $848b1ce88e755b32$var$mw);
    }
});
var $848b1ce88e755b32$var$vw = [
    (0, $fVLUl.h)("rect", {
        x: "0",
        y: "0",
        width: "100",
        height: "100",
        fill: "none"
    }),
    (0, $fVLUl.h)("path", {
        d: "M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z",
        fill: "currentColor"
    }),
    (0, $fVLUl.h)("circle", {
        cx: "30",
        cy: "47",
        r: "5",
        fill: "#fff"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "opacity",
            from: "0",
            to: "1",
            values: "0;1;1",
            keyTimes: "0;0.2;1",
            dur: "1s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("circle", {
        cx: "50",
        cy: "47",
        r: "5",
        fill: "#fff"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "opacity",
            from: "0",
            to: "1",
            values: "0;0;1;1",
            keyTimes: "0;0.2;0.4;1",
            dur: "1s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("circle", {
        cx: "70",
        cy: "47",
        r: "5",
        fill: "#fff"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "opacity",
            from: "0",
            to: "1",
            values: "0;0;1;1",
            keyTimes: "0;0.4;0.6;1",
            dur: "1s",
            repeatCount: "indefinite"
        })
    ])
], $848b1ce88e755b32$export$6e35813dfe5ed5df = $848b1ce88e755b32$var$R({
    name: "QSpinnerComment",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid"
            }, $848b1ce88e755b32$var$vw);
    }
});
var $848b1ce88e755b32$var$gw = [
    (0, $fVLUl.h)("rect", {
        x: "0",
        y: "0",
        width: "100",
        height: "100",
        fill: "none"
    }),
    (0, $fVLUl.h)("g", {
        transform: "translate(25 25)"
    }, [
        (0, $fVLUl.h)("rect", {
            x: "-20",
            y: "-20",
            width: "40",
            height: "40",
            fill: "currentColor",
            opacity: "0.9"
        }, [
            (0, $fVLUl.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "1.5",
                to: "1",
                repeatCount: "indefinite",
                begin: "0s",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.2 0.8 0.2 0.8",
                keyTimes: "0;1"
            })
        ])
    ]),
    (0, $fVLUl.h)("g", {
        transform: "translate(75 25)"
    }, [
        (0, $fVLUl.h)("rect", {
            x: "-20",
            y: "-20",
            width: "40",
            height: "40",
            fill: "currentColor",
            opacity: "0.8"
        }, [
            (0, $fVLUl.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "1.5",
                to: "1",
                repeatCount: "indefinite",
                begin: "0.1s",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.2 0.8 0.2 0.8",
                keyTimes: "0;1"
            })
        ])
    ]),
    (0, $fVLUl.h)("g", {
        transform: "translate(25 75)"
    }, [
        (0, $fVLUl.h)("rect", {
            x: "-20",
            y: "-20",
            width: "40",
            height: "40",
            fill: "currentColor",
            opacity: "0.7"
        }, [
            (0, $fVLUl.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "1.5",
                to: "1",
                repeatCount: "indefinite",
                begin: "0.3s",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.2 0.8 0.2 0.8",
                keyTimes: "0;1"
            })
        ])
    ]),
    (0, $fVLUl.h)("g", {
        transform: "translate(75 75)"
    }, [
        (0, $fVLUl.h)("rect", {
            x: "-20",
            y: "-20",
            width: "40",
            height: "40",
            fill: "currentColor",
            opacity: "0.6"
        }, [
            (0, $fVLUl.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "1.5",
                to: "1",
                repeatCount: "indefinite",
                begin: "0.2s",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.2 0.8 0.2 0.8",
                keyTimes: "0;1"
            })
        ])
    ])
], $848b1ce88e755b32$export$6a272c7550b80d16 = $848b1ce88e755b32$var$R({
    name: "QSpinnerCube",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid"
            }, $848b1ce88e755b32$var$gw);
    }
});
var $848b1ce88e755b32$var$hw = [
    (0, $fVLUl.h)("circle", {
        cx: "15",
        cy: "15",
        r: "15"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "r",
            from: "15",
            to: "15",
            begin: "0s",
            dur: "0.8s",
            values: "15;9;15",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $fVLUl.h)("animate", {
            attributeName: "fill-opacity",
            from: "1",
            to: "1",
            begin: "0s",
            dur: "0.8s",
            values: "1;.5;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("circle", {
        cx: "60",
        cy: "15",
        r: "9",
        "fill-opacity": ".3"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "r",
            from: "9",
            to: "9",
            begin: "0s",
            dur: "0.8s",
            values: "9;15;9",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $fVLUl.h)("animate", {
            attributeName: "fill-opacity",
            from: ".5",
            to: ".5",
            begin: "0s",
            dur: "0.8s",
            values: ".5;1;.5",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("circle", {
        cx: "105",
        cy: "15",
        r: "15"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "r",
            from: "15",
            to: "15",
            begin: "0s",
            dur: "0.8s",
            values: "15;9;15",
            calcMode: "linear",
            repeatCount: "indefinite"
        }),
        (0, $fVLUl.h)("animate", {
            attributeName: "fill-opacity",
            from: "1",
            to: "1",
            begin: "0s",
            dur: "0.8s",
            values: "1;.5;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ])
], $848b1ce88e755b32$export$d62eca58f8bab60f = $848b1ce88e755b32$var$R({
    name: "QSpinnerDots",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                fill: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 120 30",
                xmlns: "http://www.w3.org/2000/svg"
            }, $848b1ce88e755b32$var$hw);
    }
});
var $848b1ce88e755b32$var$pw = [
    (0, $fVLUl.h)("g", {
        transform: "translate(20 50)"
    }, [
        (0, $fVLUl.h)("rect", {
            x: "-10",
            y: "-30",
            width: "20",
            height: "60",
            fill: "currentColor",
            opacity: "0.6"
        }, [
            (0, $fVLUl.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "2",
                to: "1",
                begin: "0s",
                repeatCount: "indefinite",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.1 0.9 0.4 1",
                keyTimes: "0;1",
                values: "2;1"
            })
        ])
    ]),
    (0, $fVLUl.h)("g", {
        transform: "translate(50 50)"
    }, [
        (0, $fVLUl.h)("rect", {
            x: "-10",
            y: "-30",
            width: "20",
            height: "60",
            fill: "currentColor",
            opacity: "0.8"
        }, [
            (0, $fVLUl.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "2",
                to: "1",
                begin: "0.1s",
                repeatCount: "indefinite",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.1 0.9 0.4 1",
                keyTimes: "0;1",
                values: "2;1"
            })
        ])
    ]),
    (0, $fVLUl.h)("g", {
        transform: "translate(80 50)"
    }, [
        (0, $fVLUl.h)("rect", {
            x: "-10",
            y: "-30",
            width: "20",
            height: "60",
            fill: "currentColor",
            opacity: "0.9"
        }, [
            (0, $fVLUl.h)("animateTransform", {
                attributeName: "transform",
                type: "scale",
                from: "2",
                to: "1",
                begin: "0.2s",
                repeatCount: "indefinite",
                dur: "1s",
                calcMode: "spline",
                keySplines: "0.1 0.9 0.4 1",
                keyTimes: "0;1",
                values: "2;1"
            })
        ])
    ])
], $848b1ce88e755b32$export$bf634d821185ef2f = $848b1ce88e755b32$var$R({
    name: "QSpinnerFacebook",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                xmlns: "http://www.w3.org/2000/svg",
                preserveAspectRatio: "xMidYMid"
            }, $848b1ce88e755b32$var$pw);
    }
});
var $848b1ce88e755b32$var$bw = [
    (0, $fVLUl.h)("g", {
        transform: "translate(-20,-20)"
    }, [
        (0, $fVLUl.h)("path", {
            d: "M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z",
            fill: "currentColor"
        }, [
            (0, $fVLUl.h)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                from: "90 50 50",
                to: "0 50 50",
                dur: "1s",
                repeatCount: "indefinite"
            })
        ])
    ]),
    (0, $fVLUl.h)("g", {
        transform: "translate(20,20) rotate(15 50 50)"
    }, [
        (0, $fVLUl.h)("path", {
            d: "M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z",
            fill: "currentColor"
        }, [
            (0, $fVLUl.h)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                from: "0 50 50",
                to: "90 50 50",
                dur: "1s",
                repeatCount: "indefinite"
            })
        ])
    ])
], $848b1ce88e755b32$export$d13dda2748f0ba28 = $848b1ce88e755b32$var$R({
    name: "QSpinnerGears",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, $848b1ce88e755b32$var$bw);
    }
});
var $848b1ce88e755b32$var$yw = [
    (0, $fVLUl.h)("circle", {
        cx: "12.5",
        cy: "12.5",
        r: "12.5"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "fill-opacity",
            begin: "0s",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("circle", {
        cx: "12.5",
        cy: "52.5",
        r: "12.5",
        "fill-opacity": ".5"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "fill-opacity",
            begin: "100ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("circle", {
        cx: "52.5",
        cy: "12.5",
        r: "12.5"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "fill-opacity",
            begin: "300ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("circle", {
        cx: "52.5",
        cy: "52.5",
        r: "12.5"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "fill-opacity",
            begin: "600ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("circle", {
        cx: "92.5",
        cy: "12.5",
        r: "12.5"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "fill-opacity",
            begin: "800ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("circle", {
        cx: "92.5",
        cy: "52.5",
        r: "12.5"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "fill-opacity",
            begin: "400ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("circle", {
        cx: "12.5",
        cy: "92.5",
        r: "12.5"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "fill-opacity",
            begin: "700ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("circle", {
        cx: "52.5",
        cy: "92.5",
        r: "12.5"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "fill-opacity",
            begin: "500ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("circle", {
        cx: "92.5",
        cy: "92.5",
        r: "12.5"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "fill-opacity",
            begin: "200ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ])
], $848b1ce88e755b32$export$ba3edcdf00657f3b = $848b1ce88e755b32$var$R({
    name: "QSpinnerGrid",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                fill: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 105 105",
                xmlns: "http://www.w3.org/2000/svg"
            }, $848b1ce88e755b32$var$yw);
    }
});
var $848b1ce88e755b32$var$Sw = [
    (0, $fVLUl.h)("path", {
        d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.716-6.002 11.47-7.65 17.304-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
        "fill-opacity": ".5"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "fill-opacity",
            begin: "0s",
            dur: "1.4s",
            values: "0.5;1;0.5",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("path", {
        d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.593-2.32 17.308 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
        "fill-opacity": ".5"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "fill-opacity",
            begin: "0.7s",
            dur: "1.4s",
            values: "0.5;1;0.5",
            calcMode: "linear",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("path", {
        d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
    })
], $848b1ce88e755b32$export$cb77d8a2fc9a1a83 = $848b1ce88e755b32$var$R({
    name: "QSpinnerHearts",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                fill: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 140 64",
                xmlns: "http://www.w3.org/2000/svg"
            }, $848b1ce88e755b32$var$Sw);
    }
});
var $848b1ce88e755b32$var$xw = [
    (0, $fVLUl.h)("g", [
        (0, $fVLUl.h)("path", {
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "5",
            "stroke-miterlimit": "10",
            d: "M58.4,51.7c-0.9-0.9-1.4-2-1.4-2.3s0.5-0.4,1.4-1.4 C70.8,43.8,79.8,30.5,80,15.5H70H30H20c0.2,15,9.2,28.1,21.6,32.3c0.9,0.9,1.4,1.2,1.4,1.5s-0.5,1.6-1.4,2.5 C29.2,56.1,20.2,69.5,20,85.5h10h40h10C79.8,69.5,70.8,55.9,58.4,51.7z"
        }),
        (0, $fVLUl.h)("clipPath", {
            id: "uil-hourglass-clip1"
        }, [
            (0, $fVLUl.h)("rect", {
                x: "15",
                y: "20",
                width: "70",
                height: "25"
            }, [
                (0, $fVLUl.h)("animate", {
                    attributeName: "height",
                    from: "25",
                    to: "0",
                    dur: "1s",
                    repeatCount: "indefinite",
                    values: "25;0;0",
                    keyTimes: "0;0.5;1"
                }),
                (0, $fVLUl.h)("animate", {
                    attributeName: "y",
                    from: "20",
                    to: "45",
                    dur: "1s",
                    repeatCount: "indefinite",
                    values: "20;45;45",
                    keyTimes: "0;0.5;1"
                })
            ])
        ]),
        (0, $fVLUl.h)("clipPath", {
            id: "uil-hourglass-clip2"
        }, [
            (0, $fVLUl.h)("rect", {
                x: "15",
                y: "55",
                width: "70",
                height: "25"
            }, [
                (0, $fVLUl.h)("animate", {
                    attributeName: "height",
                    from: "0",
                    to: "25",
                    dur: "1s",
                    repeatCount: "indefinite",
                    values: "0;25;25",
                    keyTimes: "0;0.5;1"
                }),
                (0, $fVLUl.h)("animate", {
                    attributeName: "y",
                    from: "80",
                    to: "55",
                    dur: "1s",
                    repeatCount: "indefinite",
                    values: "80;55;55",
                    keyTimes: "0;0.5;1"
                })
            ])
        ]),
        (0, $fVLUl.h)("path", {
            d: "M29,23c3.1,11.4,11.3,19.5,21,19.5S67.9,34.4,71,23H29z",
            "clip-path": "url(#uil-hourglass-clip1)",
            fill: "currentColor"
        }),
        (0, $fVLUl.h)("path", {
            d: "M71.6,78c-3-11.6-11.5-20-21.5-20s-18.5,8.4-21.5,20H71.6z",
            "clip-path": "url(#uil-hourglass-clip2)",
            fill: "currentColor"
        }),
        (0, $fVLUl.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "180 50 50",
            repeatCount: "indefinite",
            dur: "1s",
            values: "0 50 50;0 50 50;180 50 50",
            keyTimes: "0;0.7;1"
        })
    ])
], $848b1ce88e755b32$export$44b7dee4e71f51cd = $848b1ce88e755b32$var$R({
    name: "QSpinnerHourglass",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, $848b1ce88e755b32$var$xw);
    }
});
var $848b1ce88e755b32$var$_w = [
    (0, $fVLUl.h)("path", {
        d: "M24.3,30C11.4,30,5,43.3,5,50s6.4,20,19.3,20c19.3,0,32.1-40,51.4-40C88.6,30,95,43.3,95,50s-6.4,20-19.3,20C56.4,70,43.6,30,24.3,30z",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "8",
        "stroke-dasharray": "10.691205342610678 10.691205342610678",
        "stroke-dashoffset": "0"
    }, [
        (0, $fVLUl.h)("animate", {
            attributeName: "stroke-dashoffset",
            from: "0",
            to: "21.382410685221355",
            begin: "0",
            dur: "2s",
            repeatCount: "indefinite",
            fill: "freeze"
        })
    ])
], $848b1ce88e755b32$export$b71cd080434d9a8a = $848b1ce88e755b32$var$R({
    name: "QSpinnerInfinity",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid"
            }, $848b1ce88e755b32$var$_w);
    }
});
var $848b1ce88e755b32$var$Cw = [
    (0, $fVLUl.h)("g", {
        "stroke-width": "4",
        "stroke-linecap": "round"
    }, [
        (0, $fVLUl.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(180)"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: "1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(210)"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: "0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(240)"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".1;0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(270)"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".15;.1;0;1;.85;.7;.65;.55;.45;.35;.25;.15",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(300)"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".25;.15;.1;0;1;.85;.7;.65;.55;.45;.35;.25",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(330)"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".35;.25;.15;.1;0;1;.85;.7;.65;.55;.45;.35",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(0)"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".45;.35;.25;.15;.1;0;1;.85;.7;.65;.55;.45",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(30)"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".55;.45;.35;.25;.15;.1;0;1;.85;.7;.65;.55",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(60)"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".65;.55;.45;.35;.25;.15;.1;0;1;.85;.7;.65",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(90)"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".7;.65;.55;.45;.35;.25;.15;.1;0;1;.85;.7",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(120)"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: ".85;.7;.65;.55;.45;.35;.25;.15;.1;0;1;.85",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("line", {
            y1: "17",
            y2: "29",
            transform: "translate(32,32) rotate(150)"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-opacity",
                dur: "750ms",
                values: "1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1",
                repeatCount: "indefinite"
            })
        ])
    ])
], $848b1ce88e755b32$export$77e9349f3d025ec0 = $848b1ce88e755b32$var$R({
    name: "QSpinnerIos",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                stroke: "currentColor",
                fill: "currentColor",
                viewBox: "0 0 64 64"
            }, $848b1ce88e755b32$var$Cw);
    }
});
var $848b1ce88e755b32$var$ww = [
    (0, $fVLUl.h)("circle", {
        cx: "50",
        cy: "50",
        r: "44",
        fill: "none",
        "stroke-width": "4",
        "stroke-opacity": ".5",
        stroke: "currentColor"
    }),
    (0, $fVLUl.h)("circle", {
        cx: "8",
        cy: "54",
        r: "6",
        fill: "currentColor",
        "stroke-width": "3",
        stroke: "currentColor"
    }, [
        (0, $fVLUl.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 48",
            to: "360 50 52",
            dur: "2s",
            repeatCount: "indefinite"
        })
    ])
], $848b1ce88e755b32$export$a97e088b3d2632d = $848b1ce88e755b32$var$R({
    name: "QSpinnerOrbit",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, $848b1ce88e755b32$var$ww);
    }
});
var $848b1ce88e755b32$var$kw = [
    (0, $fVLUl.h)("g", {
        transform: "translate(1 1)",
        "stroke-width": "2",
        fill: "none",
        "fill-rule": "evenodd"
    }, [
        (0, $fVLUl.h)("circle", {
            "stroke-opacity": ".5",
            cx: "18",
            cy: "18",
            r: "18"
        }),
        (0, $fVLUl.h)("path", {
            d: "M36 18c0-9.94-8.06-18-18-18"
        }, [
            (0, $fVLUl.h)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                from: "0 18 18",
                to: "360 18 18",
                dur: "1s",
                repeatCount: "indefinite"
            })
        ])
    ])
], $848b1ce88e755b32$export$36a3d935578134a2 = $848b1ce88e755b32$var$R({
    name: "QSpinnerOval",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                stroke: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 38 38",
                xmlns: "http://www.w3.org/2000/svg"
            }, $848b1ce88e755b32$var$kw);
    }
});
var $848b1ce88e755b32$var$qw = [
    (0, $fVLUl.h)("path", {
        d: "M0 50A50 50 0 0 1 50 0L50 50L0 50",
        fill: "currentColor",
        opacity: "0.5"
    }, [
        (0, $fVLUl.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "0.8s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("path", {
        d: "M50 0A50 50 0 0 1 100 50L50 50L50 0",
        fill: "currentColor",
        opacity: "0.5"
    }, [
        (0, $fVLUl.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "1.6s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("path", {
        d: "M100 50A50 50 0 0 1 50 100L50 50L100 50",
        fill: "currentColor",
        opacity: "0.5"
    }, [
        (0, $fVLUl.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "2.4s",
            repeatCount: "indefinite"
        })
    ]),
    (0, $fVLUl.h)("path", {
        d: "M50 100A50 50 0 0 1 0 50L50 50L50 100",
        fill: "currentColor",
        opacity: "0.5"
    }, [
        (0, $fVLUl.h)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            dur: "3.2s",
            repeatCount: "indefinite"
        })
    ])
], $848b1ce88e755b32$export$e6f3833977eceb50 = $848b1ce88e755b32$var$R({
    name: "QSpinnerPie",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, $848b1ce88e755b32$var$qw);
    }
});
var $848b1ce88e755b32$var$Tw = [
    (0, $fVLUl.h)("g", {
        fill: "none",
        "fill-rule": "evenodd",
        "stroke-width": "2"
    }, [
        (0, $fVLUl.h)("circle", {
            cx: "22",
            cy: "22",
            r: "1"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "r",
                begin: "0s",
                dur: "1.8s",
                values: "1; 20",
                calcMode: "spline",
                keyTimes: "0; 1",
                keySplines: "0.165, 0.84, 0.44, 1",
                repeatCount: "indefinite"
            }),
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-opacity",
                begin: "0s",
                dur: "1.8s",
                values: "1; 0",
                calcMode: "spline",
                keyTimes: "0; 1",
                keySplines: "0.3, 0.61, 0.355, 1",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("circle", {
            cx: "22",
            cy: "22",
            r: "1"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "r",
                begin: "-0.9s",
                dur: "1.8s",
                values: "1; 20",
                calcMode: "spline",
                keyTimes: "0; 1",
                keySplines: "0.165, 0.84, 0.44, 1",
                repeatCount: "indefinite"
            }),
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-opacity",
                begin: "-0.9s",
                dur: "1.8s",
                values: "1; 0",
                calcMode: "spline",
                keyTimes: "0; 1",
                keySplines: "0.3, 0.61, 0.355, 1",
                repeatCount: "indefinite"
            })
        ])
    ])
], $848b1ce88e755b32$export$56d4f370365c4ec9 = $848b1ce88e755b32$var$R({
    name: "QSpinnerPuff",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                stroke: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 44 44",
                xmlns: "http://www.w3.org/2000/svg"
            }, $848b1ce88e755b32$var$Tw);
    }
});
var $848b1ce88e755b32$var$Mw = [
    (0, $fVLUl.h)("g", {
        transform: "scale(0.55)"
    }, [
        (0, $fVLUl.h)("circle", {
            cx: "30",
            cy: "150",
            r: "30",
            fill: "currentColor"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "opacity",
                from: "0",
                to: "1",
                dur: "1s",
                begin: "0",
                repeatCount: "indefinite",
                keyTimes: "0;0.5;1",
                values: "0;1;1"
            })
        ]),
        (0, $fVLUl.h)("path", {
            d: "M90,150h30c0-49.7-40.3-90-90-90v30C63.1,90,90,116.9,90,150z",
            fill: "currentColor"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "opacity",
                from: "0",
                to: "1",
                dur: "1s",
                begin: "0.1",
                repeatCount: "indefinite",
                keyTimes: "0;0.5;1",
                values: "0;1;1"
            })
        ]),
        (0, $fVLUl.h)("path", {
            d: "M150,150h30C180,67.2,112.8,0,30,0v30C96.3,30,150,83.7,150,150z",
            fill: "currentColor"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "opacity",
                from: "0",
                to: "1",
                dur: "1s",
                begin: "0.2",
                repeatCount: "indefinite",
                keyTimes: "0;0.5;1",
                values: "0;1;1"
            })
        ])
    ])
], $848b1ce88e755b32$export$7734a351fc7fed9d = $848b1ce88e755b32$var$R({
    name: "QSpinnerRadio",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 100 100",
                preserveAspectRatio: "xMidYMid",
                xmlns: "http://www.w3.org/2000/svg"
            }, $848b1ce88e755b32$var$Mw);
    }
});
var $848b1ce88e755b32$var$Rw = [
    (0, $fVLUl.h)("g", {
        fill: "none",
        "fill-rule": "evenodd",
        transform: "translate(1 1)",
        "stroke-width": "2"
    }, [
        (0, $fVLUl.h)("circle", {
            cx: "22",
            cy: "22",
            r: "6"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "r",
                begin: "1.5s",
                dur: "3s",
                values: "6;22",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-opacity",
                begin: "1.5s",
                dur: "3s",
                values: "1;0",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-width",
                begin: "1.5s",
                dur: "3s",
                values: "2;0",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("circle", {
            cx: "22",
            cy: "22",
            r: "6"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "r",
                begin: "3s",
                dur: "3s",
                values: "6;22",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-opacity",
                begin: "3s",
                dur: "3s",
                values: "1;0",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $fVLUl.h)("animate", {
                attributeName: "stroke-width",
                begin: "3s",
                dur: "3s",
                values: "2;0",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("circle", {
            cx: "22",
            cy: "22",
            r: "8"
        }, [
            (0, $fVLUl.h)("animate", {
                attributeName: "r",
                begin: "0s",
                dur: "1.5s",
                values: "6;1;2;3;4;5;6",
                calcMode: "linear",
                repeatCount: "indefinite"
            })
        ])
    ])
], $848b1ce88e755b32$export$6d6e0a9951cccd21 = $848b1ce88e755b32$var$R({
    name: "QSpinnerRings",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                stroke: "currentColor",
                width: t.value,
                height: t.value,
                viewBox: "0 0 45 45",
                xmlns: "http://www.w3.org/2000/svg"
            }, $848b1ce88e755b32$var$Rw);
    }
});
var $848b1ce88e755b32$var$Pw = [
    (0, $fVLUl.h)("defs", [
        (0, $fVLUl.h)("linearGradient", {
            x1: "8.042%",
            y1: "0%",
            x2: "65.682%",
            y2: "23.865%",
            id: "a"
        }, [
            (0, $fVLUl.h)("stop", {
                "stop-color": "currentColor",
                "stop-opacity": "0",
                offset: "0%"
            }),
            (0, $fVLUl.h)("stop", {
                "stop-color": "currentColor",
                "stop-opacity": ".631",
                offset: "63.146%"
            }),
            (0, $fVLUl.h)("stop", {
                "stop-color": "currentColor",
                offset: "100%"
            })
        ])
    ]),
    (0, $fVLUl.h)("g", {
        transform: "translate(1 1)",
        fill: "none",
        "fill-rule": "evenodd"
    }, [
        (0, $fVLUl.h)("path", {
            d: "M36 18c0-9.94-8.06-18-18-18",
            stroke: "url(#a)",
            "stroke-width": "2"
        }, [
            (0, $fVLUl.h)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                from: "0 18 18",
                to: "360 18 18",
                dur: "0.9s",
                repeatCount: "indefinite"
            })
        ]),
        (0, $fVLUl.h)("circle", {
            fill: "currentColor",
            cx: "36",
            cy: "18",
            r: "1"
        }, [
            (0, $fVLUl.h)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                from: "0 18 18",
                to: "360 18 18",
                dur: "0.9s",
                repeatCount: "indefinite"
            })
        ])
    ])
], $848b1ce88e755b32$export$87ed3277eacd506 = $848b1ce88e755b32$var$R({
    name: "QSpinnerTail",
    props: $848b1ce88e755b32$var$Oe,
    setup (e) {
        let { cSize: t, classes: o } = $848b1ce88e755b32$var$Ve(e);
        return ()=>(0, $fVLUl.h)("svg", {
                class: o.value,
                width: t.value,
                height: t.value,
                viewBox: "0 0 38 38",
                xmlns: "http://www.w3.org/2000/svg"
            }, $848b1ce88e755b32$var$Pw);
    }
});
var $848b1ce88e755b32$export$e24eb95a687f22c5 = $848b1ce88e755b32$var$R({
    name: "QSplitter",
    props: {
        ...$848b1ce88e755b32$var$he,
        modelValue: {
            type: Number,
            required: !0
        },
        reverse: Boolean,
        unit: {
            type: String,
            default: "%",
            validator: (e)=>[
                    "%",
                    "px"
                ].includes(e)
        },
        limits: {
            type: Array,
            validator: (e)=>e.length !== 2 || typeof e[0] != "number" || typeof e[1] != "number" ? !1 : e[0] >= 0 && e[0] <= e[1]
        },
        emitImmediately: Boolean,
        horizontal: Boolean,
        disable: Boolean,
        beforeClass: [
            Array,
            String,
            Object
        ],
        afterClass: [
            Array,
            String,
            Object
        ],
        separatorClass: [
            Array,
            String,
            Object
        ],
        separatorStyle: [
            Array,
            String,
            Object
        ]
    },
    emits: [
        "update:modelValue"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: { $q: r } } = (0, $fVLUl.getCurrentInstance)(), n = $848b1ce88e755b32$var$pe(e, r), i = (0, $eayOh.ref)(null), a = {
            before: (0, $eayOh.ref)(null),
            after: (0, $eayOh.ref)(null)
        }, l = (0, $eayOh.computed)(()=>`q-splitter no-wrap ${e.horizontal === !0 ? "q-splitter--horizontal column" : "q-splitter--vertical row"} q-splitter--${e.disable === !0 ? "disabled" : "workable"}` + (n.value === !0 ? " q-splitter--dark" : "")), s = (0, $eayOh.computed)(()=>e.horizontal === !0 ? "height" : "width"), c = (0, $eayOh.computed)(()=>e.reverse !== !0 ? "before" : "after"), u = (0, $eayOh.computed)(()=>e.limits !== void 0 ? e.limits : e.unit === "%" ? [
                10,
                90
            ] : [
                50,
                1 / 0
            ]);
        function v(S) {
            return (e.unit === "%" ? S : Math.round(S)) + e.unit;
        }
        let f = (0, $eayOh.computed)(()=>({
                [c.value]: {
                    [s.value]: v(e.modelValue)
                }
            })), d, m, y, p, C;
        function b(S) {
            if (S.isFirst === !0) {
                let $ = i.value.getBoundingClientRect()[s.value];
                d = e.horizontal === !0 ? "up" : "left", m = e.unit === "%" ? 100 : $, y = Math.min(m, u.value[1], Math.max(u.value[0], e.modelValue)), p = (e.reverse !== !0 ? 1 : -1) * (e.horizontal === !0 ? 1 : r.lang.rtl === !0 ? -1 : 1) * (e.unit === "%" ? $ === 0 ? 0 : 100 / $ : 1), i.value.classList.add("q-splitter--active");
                return;
            }
            if (S.isFinal === !0) {
                C !== e.modelValue && o("update:modelValue", C), i.value.classList.remove("q-splitter--active");
                return;
            }
            let P = y + p * (S.direction === d ? -1 : 1) * S.distance[e.horizontal === !0 ? "y" : "x"];
            C = Math.min(m, u.value[1], Math.max(u.value[0], P)), a[c.value].value.style[s.value] = v(C), e.emitImmediately === !0 && e.modelValue !== C && o("update:modelValue", C);
        }
        let h = (0, $eayOh.computed)(()=>[
                [
                    $848b1ce88e755b32$export$718797250d1e376,
                    b,
                    void 0,
                    {
                        [e.horizontal === !0 ? "vertical" : "horizontal"]: !0,
                        prevent: !0,
                        stop: !0,
                        mouse: !0,
                        mouseAllDir: !0
                    }
                ]
            ]);
        function g(S, P) {
            S < P[0] ? o("update:modelValue", P[0]) : S > P[1] && o("update:modelValue", P[1]);
        }
        return (0, $eayOh.watch)(()=>e.modelValue, (S)=>{
            g(S, u.value);
        }), (0, $eayOh.watch)(()=>e.limits, ()=>{
            (0, $fVLUl.nextTick)(()=>{
                g(e.modelValue, u.value);
            });
        }), ()=>{
            let S = [
                (0, $fVLUl.h)("div", {
                    ref: a.before,
                    class: [
                        "q-splitter__panel q-splitter__before" + (e.reverse === !0 ? " col" : ""),
                        e.beforeClass
                    ],
                    style: f.value.before
                }, $848b1ce88e755b32$var$J(t.before)),
                (0, $fVLUl.h)("div", {
                    class: [
                        "q-splitter__separator",
                        e.separatorClass
                    ],
                    style: e.separatorStyle,
                    "aria-disabled": e.disable === !0 ? "true" : void 0
                }, [
                    $848b1ce88e755b32$var$kt("div", {
                        class: "q-splitter__separator-area absolute-full"
                    }, $848b1ce88e755b32$var$J(t.separator), "sep", e.disable !== !0, ()=>h.value)
                ]),
                (0, $fVLUl.h)("div", {
                    ref: a.after,
                    class: [
                        "q-splitter__panel q-splitter__after" + (e.reverse === !0 ? "" : " col"),
                        e.afterClass
                    ],
                    style: f.value.after
                }, $848b1ce88e755b32$var$J(t.after))
            ];
            return (0, $fVLUl.h)("div", {
                class: l.value,
                ref: i
            }, $848b1ce88e755b32$var$Ke(t.default, S));
        };
    }
});
var $848b1ce88e755b32$var$hs = $848b1ce88e755b32$var$R({
    name: "StepHeader",
    props: {
        stepper: {},
        step: {},
        goToPanel: Function
    },
    setup (e, { attrs: t }) {
        let { proxy: { $q: o } } = (0, $fVLUl.getCurrentInstance)(), r = (0, $eayOh.ref)(null), n = (0, $eayOh.computed)(()=>e.stepper.modelValue === e.step.name), i = (0, $eayOh.computed)(()=>{
            let p = e.step.disable;
            return p === !0 || p === "";
        }), a = (0, $eayOh.computed)(()=>{
            let p = e.step.error;
            return p === !0 || p === "";
        }), l = (0, $eayOh.computed)(()=>{
            let p = e.step.done;
            return i.value === !1 && (p === !0 || p === "");
        }), s = (0, $eayOh.computed)(()=>{
            let p = e.step.headerNav, C = p === !0 || p === "" || p === void 0;
            return i.value === !1 && e.stepper.headerNav && C;
        }), c = (0, $eayOh.computed)(()=>e.step.prefix && (n.value === !1 || e.stepper.activeIcon === "none") && (a.value === !1 || e.stepper.errorIcon === "none") && (l.value === !1 || e.stepper.doneIcon === "none")), u = (0, $eayOh.computed)(()=>{
            let p = e.step.icon || e.stepper.inactiveIcon;
            if (n.value === !0) {
                let C = e.step.activeIcon || e.stepper.activeIcon;
                return C === "none" ? p : C || o.iconSet.stepper.active;
            }
            if (a.value === !0) {
                let C = e.step.errorIcon || e.stepper.errorIcon;
                return C === "none" ? p : C || o.iconSet.stepper.error;
            }
            if (i.value === !1 && l.value === !0) {
                let C = e.step.doneIcon || e.stepper.doneIcon;
                return C === "none" ? p : C || o.iconSet.stepper.done;
            }
            return p;
        }), v = (0, $eayOh.computed)(()=>{
            let p = a.value === !0 ? e.step.errorColor || e.stepper.errorColor : void 0;
            if (n.value === !0) {
                let C = e.step.activeColor || e.stepper.activeColor || e.step.color;
                return C !== void 0 ? C : p;
            }
            return p !== void 0 ? p : i.value === !1 && l.value === !0 ? e.step.doneColor || e.stepper.doneColor || e.step.color || e.stepper.inactiveColor : e.step.color || e.stepper.inactiveColor;
        }), f = (0, $eayOh.computed)(()=>"q-stepper__tab col-grow flex items-center no-wrap relative-position" + (v.value !== void 0 ? ` text-${v.value}` : "") + (a.value === !0 ? " q-stepper__tab--error q-stepper__tab--error-with-" + (c.value === !0 ? "prefix" : "icon") : "") + (n.value === !0 ? " q-stepper__tab--active" : "") + (l.value === !0 ? " q-stepper__tab--done" : "") + (s.value === !0 ? " q-stepper__tab--navigation q-focusable q-hoverable" : "") + (i.value === !0 ? " q-stepper__tab--disabled" : "")), d = (0, $eayOh.computed)(()=>e.stepper.headerNav !== !0 ? !1 : s.value);
        function m() {
            r.value !== null && r.value.focus(), n.value === !1 && e.goToPanel(e.step.name);
        }
        function y(p) {
            p.keyCode === 13 && n.value === !1 && e.goToPanel(e.step.name);
        }
        return ()=>{
            let p = {
                class: f.value
            };
            s.value === !0 && (p.onClick = m, p.onKeyup = y, Object.assign(p, i.value === !0 ? {
                tabindex: -1,
                "aria-disabled": "true"
            } : {
                tabindex: t.tabindex || 0
            }));
            let C = [
                (0, $fVLUl.h)("div", {
                    class: "q-focus-helper",
                    tabindex: -1,
                    ref: r
                }),
                (0, $fVLUl.h)("div", {
                    class: "q-stepper__dot row flex-center q-stepper__line relative-position"
                }, [
                    (0, $fVLUl.h)("span", {
                        class: "row flex-center"
                    }, [
                        c.value === !0 ? e.step.prefix : (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                            name: u.value
                        })
                    ])
                ])
            ];
            if (e.step.title !== void 0 && e.step.title !== null) {
                let b = [
                    (0, $fVLUl.h)("div", {
                        class: "q-stepper__title"
                    }, e.step.title)
                ];
                e.step.caption !== void 0 && e.step.caption !== null && b.push((0, $fVLUl.h)("div", {
                    class: "q-stepper__caption"
                }, e.step.caption)), C.push((0, $fVLUl.h)("div", {
                    class: "q-stepper__label q-stepper__line relative-position"
                }, b));
            }
            return (0, $fVLUl.withDirectives)((0, $fVLUl.h)("div", p, C), [
                [
                    $848b1ce88e755b32$export$9e9146f7e027fdaa,
                    d.value
                ]
            ]);
        };
    }
});
function $848b1ce88e755b32$var$Sh(e) {
    return (0, $fVLUl.h)("div", {
        class: "q-stepper__step-content"
    }, [
        (0, $fVLUl.h)("div", {
            class: "q-stepper__step-inner"
        }, $848b1ce88e755b32$var$J(e.default))
    ]);
}
var $848b1ce88e755b32$var$yh = {
    setup (e, { slots: t }) {
        return ()=>$848b1ce88e755b32$var$Sh(t);
    }
}, $848b1ce88e755b32$export$973d42224d50092f = $848b1ce88e755b32$var$R({
    name: "QStep",
    props: {
        ...$848b1ce88e755b32$var$Li,
        icon: String,
        color: String,
        title: {
            type: String,
            required: !0
        },
        caption: String,
        prefix: [
            String,
            Number
        ],
        doneIcon: String,
        doneColor: String,
        activeIcon: String,
        activeColor: String,
        errorIcon: String,
        errorColor: String,
        headerNav: {
            type: Boolean,
            default: !0
        },
        done: Boolean,
        error: Boolean,
        onScroll: [
            Function,
            Array
        ]
    },
    setup (e, { slots: t, emit: o }) {
        let { proxy: { $q: r } } = (0, $fVLUl.getCurrentInstance)(), n = (0, $fVLUl.inject)($848b1ce88e755b32$var$wl, $848b1ce88e755b32$var$Ye);
        if (n === $848b1ce88e755b32$var$Ye) return console.error("QStep needs to be a child of QStepper"), $848b1ce88e755b32$var$Ye;
        let { getCache: i } = $848b1ce88e755b32$export$1c2929d84167dd53(), a = (0, $eayOh.ref)(null), l = (0, $eayOh.computed)(()=>n.value.modelValue === e.name), s = (0, $eayOh.computed)(()=>r.platform.is.ios !== !0 && r.platform.is.chrome === !0 || l.value !== !0 || n.value.vertical !== !0 ? {} : {
                onScroll (v) {
                    let { target: f } = v;
                    f.scrollTop > 0 && (f.scrollTop = 0), e.onScroll !== void 0 && o("scroll", v);
                }
            }), c = (0, $eayOh.computed)(()=>typeof e.name == "string" || typeof e.name == "number" ? e.name : String(e.name));
        function u() {
            let v = n.value.vertical;
            return v === !0 && n.value.keepAlive === !0 ? (0, $fVLUl.h)((0, $fVLUl.KeepAlive), n.value.keepAliveProps.value, l.value === !0 ? [
                (0, $fVLUl.h)(n.value.needsUniqueKeepAliveWrapper.value === !0 ? i(c.value, ()=>({
                        ...$848b1ce88e755b32$var$yh,
                        name: c.value
                    })) : $848b1ce88e755b32$var$yh, {
                    key: c.value
                }, t.default)
            ] : void 0) : v !== !0 || l.value === !0 ? $848b1ce88e755b32$var$Sh(t) : void 0;
        }
        return ()=>(0, $fVLUl.h)("div", {
                ref: a,
                class: "q-stepper__step",
                role: "tabpanel",
                ...s.value
            }, n.value.vertical === !0 ? [
                (0, $fVLUl.h)($848b1ce88e755b32$var$hs, {
                    stepper: n.value,
                    step: e,
                    goToPanel: n.value.goToPanel
                }),
                n.value.animated === !0 ? (0, $fVLUl.h)($848b1ce88e755b32$export$1712cdc175d4649d, u) : u()
            ] : [
                u()
            ]);
    }
});
var $848b1ce88e755b32$var$Hw = /(-\w)/g;
function $848b1ce88e755b32$var$Nw(e) {
    let t = {};
    for(let o in e){
        let r = o.replace($848b1ce88e755b32$var$Hw, (n)=>n[1].toUpperCase());
        t[r] = e[o];
    }
    return t;
}
var $848b1ce88e755b32$export$9b249c4f2312b48e = $848b1ce88e755b32$var$R({
    name: "QStepper",
    props: {
        ...$848b1ce88e755b32$var$he,
        ...$848b1ce88e755b32$var$Fi,
        flat: Boolean,
        bordered: Boolean,
        alternativeLabels: Boolean,
        headerNav: Boolean,
        contracted: Boolean,
        headerClass: String,
        inactiveColor: String,
        inactiveIcon: String,
        doneIcon: String,
        doneColor: String,
        activeIcon: String,
        activeColor: String,
        errorIcon: String,
        errorColor: String
    },
    emits: $848b1ce88e755b32$var$Di,
    setup (e, { slots: t }) {
        let o = (0, $fVLUl.getCurrentInstance)(), r = $848b1ce88e755b32$var$pe(e, o.proxy.$q), { updatePanelsList: n, isValidPanelName: i, updatePanelIndex: a, getPanelContent: l, getPanels: s, panelDirectives: c, goToPanel: u, keepAliveProps: v, needsUniqueKeepAliveWrapper: f } = $848b1ce88e755b32$var$Vi();
        (0, $fVLUl.provide)($848b1ce88e755b32$var$wl, (0, $eayOh.computed)(()=>({
                goToPanel: u,
                keepAliveProps: v,
                needsUniqueKeepAliveWrapper: f,
                ...e
            })));
        let d = (0, $eayOh.computed)(()=>`q-stepper q-stepper--${e.vertical === !0 ? "vertical" : "horizontal"}` + (e.flat === !0 ? " q-stepper--flat" : "") + (e.bordered === !0 ? " q-stepper--bordered" : "") + (r.value === !0 ? " q-stepper--dark q-dark" : "")), m = (0, $eayOh.computed)(()=>`q-stepper__header row items-stretch justify-between q-stepper__header--${e.alternativeLabels === !0 ? "alternative" : "standard"}-labels` + (e.flat === !1 || e.bordered === !0 ? " q-stepper__header--border" : "") + (e.contracted === !0 ? " q-stepper__header--contracted" : "") + (e.headerClass !== void 0 ? ` ${e.headerClass}` : ""));
        function y() {
            let p = $848b1ce88e755b32$var$J(t.message, []);
            if (e.vertical === !0) {
                i(e.modelValue) && a();
                let C = (0, $fVLUl.h)("div", {
                    class: "q-stepper__content"
                }, $848b1ce88e755b32$var$J(t.default));
                return p === void 0 ? [
                    C
                ] : p.concat(C);
            }
            return [
                (0, $fVLUl.h)("div", {
                    class: m.value
                }, s().map((C)=>{
                    let b = $848b1ce88e755b32$var$Nw(C.props);
                    return (0, $fVLUl.h)($848b1ce88e755b32$var$hs, {
                        key: b.name,
                        stepper: e,
                        step: b,
                        goToPanel: u
                    });
                })),
                p,
                $848b1ce88e755b32$var$kt("div", {
                    class: "q-stepper__content q-panel-parent"
                }, l(), "cont", e.swipeable, ()=>c.value)
            ];
        }
        return ()=>(n(t), (0, $fVLUl.h)("div", {
                class: d.value
            }, $848b1ce88e755b32$var$Ke(t.navigation, y())));
    }
});
var $848b1ce88e755b32$export$ccae125a3a1bd01f = $848b1ce88e755b32$var$R({
    name: "QStepperNavigation",
    setup (e, { slots: t }) {
        return ()=>(0, $fVLUl.h)("div", {
                class: "q-stepper__nav"
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$export$f3b568562ea6363f = $848b1ce88e755b32$var$R({
    name: "QTh",
    props: {
        props: Object,
        autoWidth: Boolean
    },
    emits: [
        "click"
    ],
    setup (e, { slots: t, emit: o }) {
        let r = (0, $fVLUl.getCurrentInstance)(), { proxy: { $q: n } } = r, i = (a)=>{
            o("click", a);
        };
        return ()=>{
            if (e.props === void 0) return (0, $fVLUl.h)("th", {
                class: e.autoWidth === !0 ? "q-table--col-auto-width" : "",
                onClick: i
            }, $848b1ce88e755b32$var$J(t.default));
            let a, l, s = r.vnode.key;
            if (s) {
                if (a = e.props.colsMap[s], a === void 0) return;
            } else a = e.props.col;
            if (a.sortable === !0) {
                let u = a.align === "right" ? "unshift" : "push";
                l = $848b1ce88e755b32$var$tn(t.default, []), l[u]((0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                    class: a.__iconClass,
                    name: n.iconSet.table.arrowUp
                }));
            } else l = $848b1ce88e755b32$var$J(t.default);
            let c = {
                class: a.__thClass + (e.autoWidth === !0 ? " q-table--col-auto-width" : ""),
                style: a.headerStyle,
                onClick: (u)=>{
                    a.sortable === !0 && e.props.sort(a), i(u);
                }
            };
            return (0, $fVLUl.h)("th", c, l);
        };
    }
});
function $848b1ce88e755b32$var$ys(e, t) {
    return (0, $fVLUl.h)("div", e, [
        (0, $fVLUl.h)("table", {
            class: "q-table"
        }, t)
    ]);
}
var $848b1ce88e755b32$var$Jw = {
    list: $848b1ce88e755b32$export$546da2cac02ecac2,
    table: $848b1ce88e755b32$export$96e16f0b01ad0bca
}, $848b1ce88e755b32$var$ek = [
    "list",
    "table",
    "__qtable"
], $848b1ce88e755b32$export$e23e912583dc74c1 = $848b1ce88e755b32$var$R({
    name: "QVirtualScroll",
    props: {
        ...$848b1ce88e755b32$var$ss,
        type: {
            type: String,
            default: "list",
            validator: (e)=>$848b1ce88e755b32$var$ek.includes(e)
        },
        items: {
            type: Array,
            default: ()=>[]
        },
        itemsFn: Function,
        itemsSize: Number,
        scrollTarget: {
            default: void 0
        }
    },
    setup (e, { slots: t, attrs: o }) {
        let r, n = (0, $eayOh.ref)(null), i = (0, $eayOh.computed)(()=>e.itemsSize >= 0 && e.itemsFn !== void 0 ? parseInt(e.itemsSize, 10) : Array.isArray(e.items) ? e.items.length : 0), { virtualScrollSliceRange: a, localResetVirtualScroll: l, padVirtualScroll: s, onVirtualScrollEvt: c } = $848b1ce88e755b32$var$cs({
            virtualScrollLength: i,
            getVirtualScrollTarget: m,
            getVirtualScrollEl: d
        }), u = (0, $eayOh.computed)(()=>{
            if (i.value === 0) return [];
            let b = (h, g)=>({
                    index: a.value.from + g,
                    item: h
                });
            return e.itemsFn === void 0 ? e.items.slice(a.value.from, a.value.to).map(b) : e.itemsFn(a.value.from, a.value.to - a.value.from).map(b);
        }), v = (0, $eayOh.computed)(()=>"q-virtual-scroll q-virtual-scroll" + (e.virtualScrollHorizontal === !0 ? "--horizontal" : "--vertical") + (e.scrollTarget !== void 0 ? "" : " scroll")), f = (0, $eayOh.computed)(()=>e.scrollTarget !== void 0 ? {} : {
                tabindex: 0
            });
        (0, $eayOh.watch)(i, ()=>{
            l();
        }), (0, $eayOh.watch)(()=>e.scrollTarget, ()=>{
            p(), y();
        });
        function d() {
            return n.value.$el || n.value;
        }
        function m() {
            return r;
        }
        function y() {
            r = $848b1ce88e755b32$var$At(d(), e.scrollTarget), r.addEventListener("scroll", c, $848b1ce88e755b32$var$Xe.passive);
        }
        function p() {
            r !== void 0 && (r.removeEventListener("scroll", c, $848b1ce88e755b32$var$Xe.passive), r = void 0);
        }
        function C() {
            let b = s(e.type === "list" ? "div" : "tbody", u.value.map(t.default));
            return t.before !== void 0 && (b = t.before().concat(b)), $848b1ce88e755b32$var$Ke(t.after, b);
        }
        return (0, $fVLUl.onBeforeMount)(()=>{
            l();
        }), (0, $fVLUl.onMounted)(()=>{
            y();
        }), (0, $fVLUl.onActivated)(()=>{
            y();
        }), (0, $fVLUl.onDeactivated)(()=>{
            p();
        }), (0, $fVLUl.onBeforeUnmount)(()=>{
            p();
        }), ()=>{
            if (t.default === void 0) {
                console.error("QVirtualScroll: default scoped slot is required for rendering");
                return;
            }
            return e.type === "__qtable" ? $848b1ce88e755b32$var$ys({
                ref: n,
                class: "q-table__middle " + v.value
            }, C()) : (0, $fVLUl.h)($848b1ce88e755b32$var$Jw[e.type], {
                ...o,
                ref: n,
                class: [
                    o.class,
                    v.value
                ],
                ...f.value
            }, C);
        };
    }
});
function $848b1ce88e755b32$var$qh(e, t) {
    return new Date(e) - new Date(t);
}
var $848b1ce88e755b32$var$Mh = {
    sortMethod: Function,
    binaryStateSort: Boolean,
    columnSortOrder: {
        type: String,
        validator: (e)=>e === "ad" || e === "da",
        default: "ad"
    }
};
function $848b1ce88e755b32$var$Rh(e, t, o, r) {
    let n = (0, $eayOh.computed)(()=>{
        let { sortBy: l } = t.value;
        return l && o.value.find((s)=>s.name === l) || null;
    }), i = (0, $eayOh.computed)(()=>e.sortMethod !== void 0 ? e.sortMethod : (l, s, c)=>{
            let u = o.value.find((d)=>d.name === s);
            if (u === void 0 || u.field === void 0) return l;
            let v = c === !0 ? -1 : 1, f = typeof u.field == "function" ? (d)=>u.field(d) : (d)=>d[u.field];
            return l.sort((d, m)=>{
                let y = f(d), p = f(m);
                return u.rawSort !== void 0 ? u.rawSort(y, p, d, m) * v : y == null ? -1 * v : p == null ? 1 * v : u.sort !== void 0 ? u.sort(y, p, d, m) * v : $848b1ce88e755b32$var$Mo(y) === !0 && $848b1ce88e755b32$var$Mo(p) === !0 ? (y - p) * v : $848b1ce88e755b32$var$Pn(y) === !0 && $848b1ce88e755b32$var$Pn(p) === !0 ? $848b1ce88e755b32$var$qh(y, p) * v : typeof y == "boolean" && typeof p == "boolean" ? (y - p) * v : ([y, p] = [
                    y,
                    p
                ].map((C)=>(C + "").toLocaleString().toLowerCase()), y < p ? -1 * v : y === p ? 0 : v);
            });
        });
    function a(l) {
        let s = e.columnSortOrder;
        if ($848b1ce88e755b32$var$at(l) === !0) l.sortOrder && (s = l.sortOrder), l = l.name;
        else {
            let v = o.value.find((f)=>f.name === l);
            v !== void 0 && v.sortOrder && (s = v.sortOrder);
        }
        let { sortBy: c, descending: u } = t.value;
        c !== l ? (c = l, u = s === "da") : e.binaryStateSort === !0 ? u = !u : u === !0 ? s === "ad" ? c = null : u = !1 : s === "ad" ? u = !0 : c = null, r({
            sortBy: c,
            descending: u,
            page: 1
        });
    }
    return {
        columnToSort: n,
        computedSortMethod: i,
        sort: a
    };
}
var $848b1ce88e755b32$var$Ph = {
    filter: [
        String,
        Object
    ],
    filterMethod: Function
};
function $848b1ce88e755b32$var$Ah(e, t) {
    let o = (0, $eayOh.computed)(()=>e.filterMethod !== void 0 ? e.filterMethod : (r, n, i, a)=>{
            let l = n ? n.toLowerCase() : "";
            return r.filter((s)=>i.some((c)=>{
                    let u = a(c, s) + "";
                    return (u === "undefined" || u === "null" ? "" : u.toLowerCase()).indexOf(l) !== -1;
                }));
        });
    return (0, $eayOh.watch)(()=>e.filter, ()=>{
        (0, $fVLUl.nextTick)(()=>{
            t({
                page: 1
            }, !0);
        });
    }, {
        deep: !0
    }), {
        computedFilterMethod: o
    };
}
function $848b1ce88e755b32$var$lk(e, t) {
    for(let o in t)if (t[o] !== e[o]) return !1;
    return !0;
}
function $848b1ce88e755b32$var$$h(e) {
    return e.page < 1 && (e.page = 1), e.rowsPerPage !== void 0 && e.rowsPerPage < 1 && (e.rowsPerPage = 0), e;
}
var $848b1ce88e755b32$var$Eh = {
    pagination: Object,
    rowsPerPageOptions: {
        type: Array,
        default: ()=>[
                5,
                7,
                10,
                15,
                20,
                25,
                50,
                0
            ]
    },
    "onUpdate:pagination": [
        Function,
        Array
    ]
};
function $848b1ce88e755b32$var$Bh(e, t) {
    let { props: o, emit: r } = e, n = (0, $eayOh.ref)(Object.assign({
        sortBy: null,
        descending: !1,
        page: 1,
        rowsPerPage: o.rowsPerPageOptions.length !== 0 ? o.rowsPerPageOptions[0] : 5
    }, o.pagination)), i = (0, $eayOh.computed)(()=>{
        let u = o["onUpdate:pagination"] !== void 0 ? {
            ...n.value,
            ...o.pagination
        } : n.value;
        return $848b1ce88e755b32$var$$h(u);
    }), a = (0, $eayOh.computed)(()=>i.value.rowsNumber !== void 0);
    function l(u) {
        s({
            pagination: u,
            filter: o.filter
        });
    }
    function s(u = {}) {
        (0, $fVLUl.nextTick)(()=>{
            r("request", {
                pagination: u.pagination || i.value,
                filter: u.filter || o.filter,
                getCellValue: t
            });
        });
    }
    function c(u, v) {
        let f = $848b1ce88e755b32$var$$h({
            ...i.value,
            ...u
        });
        if ($848b1ce88e755b32$var$lk(i.value, f) === !0) {
            a.value === !0 && v === !0 && l(f);
            return;
        }
        if (a.value === !0) {
            l(f);
            return;
        }
        o.pagination !== void 0 && o["onUpdate:pagination"] !== void 0 ? r("update:pagination", f) : n.value = f;
    }
    return {
        innerPagination: n,
        computedPagination: i,
        isServerSide: a,
        requestServerInteraction: s,
        setPagination: c
    };
}
function $848b1ce88e755b32$var$Lh(e, t, o, r, n, i) {
    let { props: a, emit: l, proxy: { $q: s } } = e, c = (0, $eayOh.computed)(()=>r.value === !0 ? o.value.rowsNumber || 0 : i.value), u = (0, $eayOh.computed)(()=>{
        let { page: g, rowsPerPage: S } = o.value;
        return (g - 1) * S;
    }), v = (0, $eayOh.computed)(()=>{
        let { page: g, rowsPerPage: S } = o.value;
        return g * S;
    }), f = (0, $eayOh.computed)(()=>o.value.page === 1), d = (0, $eayOh.computed)(()=>o.value.rowsPerPage === 0 ? 1 : Math.max(1, Math.ceil(c.value / o.value.rowsPerPage))), m = (0, $eayOh.computed)(()=>v.value === 0 ? !0 : o.value.page >= d.value), y = (0, $eayOh.computed)(()=>(a.rowsPerPageOptions.includes(t.value.rowsPerPage) ? a.rowsPerPageOptions : [
            t.value.rowsPerPage
        ].concat(a.rowsPerPageOptions)).map((S)=>({
                label: S === 0 ? s.lang.table.allRows : "" + S,
                value: S
            })));
    (0, $eayOh.watch)(d, (g, S)=>{
        if (g === S) return;
        let P = o.value.page;
        g && !P ? n({
            page: 1
        }) : g < P && n({
            page: g
        });
    });
    function p() {
        n({
            page: 1
        });
    }
    function C() {
        let { page: g } = o.value;
        g > 1 && n({
            page: g - 1
        });
    }
    function b() {
        let { page: g, rowsPerPage: S } = o.value;
        v.value > 0 && g * S < c.value && n({
            page: g + 1
        });
    }
    function h() {
        n({
            page: d.value
        });
    }
    return a["onUpdate:pagination"] !== void 0 && l("update:pagination", {
        ...o.value
    }), {
        firstRowIndex: u,
        lastRowIndex: v,
        isFirstPage: f,
        isLastPage: m,
        pagesNumber: d,
        computedRowsPerPageOptions: y,
        computedRowsNumber: c,
        firstPage: p,
        prevPage: C,
        nextPage: b,
        lastPage: h
    };
}
var $848b1ce88e755b32$var$Fh = {
    selection: {
        type: String,
        default: "none",
        validator: (e)=>[
                "single",
                "multiple",
                "none"
            ].includes(e)
    },
    selected: {
        type: Array,
        default: ()=>[]
    }
}, $848b1ce88e755b32$var$Dh = [
    "update:selected",
    "selection"
];
function $848b1ce88e755b32$var$Vh(e, t, o, r) {
    let n = (0, $eayOh.computed)(()=>{
        let m = {};
        return e.selected.map(r.value).forEach((y)=>{
            m[y] = !0;
        }), m;
    }), i = (0, $eayOh.computed)(()=>e.selection !== "none"), a = (0, $eayOh.computed)(()=>e.selection === "single"), l = (0, $eayOh.computed)(()=>e.selection === "multiple"), s = (0, $eayOh.computed)(()=>o.value.length !== 0 && o.value.every((m)=>n.value[r.value(m)] === !0)), c = (0, $eayOh.computed)(()=>s.value !== !0 && o.value.some((m)=>n.value[r.value(m)] === !0)), u = (0, $eayOh.computed)(()=>e.selected.length);
    function v(m) {
        return n.value[m] === !0;
    }
    function f() {
        t("update:selected", []);
    }
    function d(m, y, p, C) {
        t("selection", {
            rows: y,
            added: p,
            keys: m,
            evt: C
        });
        let b = a.value === !0 ? p === !0 ? y : [] : p === !0 ? e.selected.concat(y) : e.selected.filter((h)=>m.includes(r.value(h)) === !1);
        t("update:selected", b);
    }
    return {
        hasSelectionMode: i,
        singleSelection: a,
        multipleSelection: l,
        allRowsSelected: s,
        someRowsSelected: c,
        rowsSelectedNumber: u,
        isRowSelected: v,
        clearSelection: f,
        updateSelection: d
    };
}
function $848b1ce88e755b32$var$zh(e) {
    return Array.isArray(e) ? e.slice() : [];
}
var $848b1ce88e755b32$var$Oh = {
    expanded: Array
}, $848b1ce88e755b32$var$Ih = [
    "update:expanded"
];
function $848b1ce88e755b32$var$Hh(e, t) {
    let o = (0, $eayOh.ref)($848b1ce88e755b32$var$zh(e.expanded));
    (0, $eayOh.watch)(()=>e.expanded, (a)=>{
        o.value = $848b1ce88e755b32$var$zh(a);
    });
    function r(a) {
        return o.value.includes(a);
    }
    function n(a) {
        e.expanded !== void 0 ? t("update:expanded", a) : o.value = a;
    }
    function i(a, l) {
        let s = o.value.slice(), c = s.indexOf(a);
        l === !0 ? c === -1 && (s.push(a), n(s)) : c !== -1 && (s.splice(c, 1), n(s));
    }
    return {
        isRowExpanded: r,
        setExpanded: n,
        updateExpanded: i
    };
}
var $848b1ce88e755b32$var$Nh = {
    visibleColumns: Array
};
function $848b1ce88e755b32$var$Qh(e, t, o) {
    let r = (0, $eayOh.computed)(()=>{
        if (e.columns !== void 0) return e.columns;
        let l = e.rows[0];
        return l !== void 0 ? Object.keys(l).map((s)=>({
                name: s,
                label: s.toUpperCase(),
                field: s,
                align: $848b1ce88e755b32$var$Mo(l[s]) ? "right" : "left",
                sortable: !0
            })) : [];
    }), n = (0, $eayOh.computed)(()=>{
        let { sortBy: l, descending: s } = t.value;
        return (e.visibleColumns !== void 0 ? r.value.filter((u)=>u.required === !0 || e.visibleColumns.includes(u.name) === !0) : r.value).map((u)=>{
            let v = u.align || "right", f = `text-${v}`;
            return {
                ...u,
                align: v,
                __iconClass: `q-table__sort-icon q-table__sort-icon--${v}`,
                __thClass: f + (u.headerClasses !== void 0 ? " " + u.headerClasses : "") + (u.sortable === !0 ? " sortable" : "") + (u.name === l ? ` sorted ${s === !0 ? "sort-desc" : ""}` : ""),
                __tdStyle: u.style !== void 0 ? typeof u.style != "function" ? ()=>u.style : u.style : ()=>null,
                __tdClass: u.classes !== void 0 ? typeof u.classes != "function" ? ()=>f + " " + u.classes : (d)=>f + " " + u.classes(d) : ()=>f
            };
        });
    }), i = (0, $eayOh.computed)(()=>{
        let l = {};
        return n.value.forEach((s)=>{
            l[s.name] = s;
        }), l;
    }), a = (0, $eayOh.computed)(()=>e.tableColspan !== void 0 ? e.tableColspan : n.value.length + (o.value === !0 ? 1 : 0));
    return {
        colList: r,
        computedCols: n,
        computedColsMap: i,
        computedColspan: a
    };
}
var $848b1ce88e755b32$var$Cs = "q-table__bottom row items-center", $848b1ce88e755b32$var$Uh = {};
$848b1ce88e755b32$var$gd.forEach((e)=>{
    $848b1ce88e755b32$var$Uh[e] = {};
});
var $848b1ce88e755b32$export$27fbdc739212cd86 = $848b1ce88e755b32$var$R({
    name: "QTable",
    props: {
        rows: {
            type: Array,
            required: !0
        },
        rowKey: {
            type: [
                String,
                Function
            ],
            default: "id"
        },
        columns: Array,
        loading: Boolean,
        iconFirstPage: String,
        iconPrevPage: String,
        iconNextPage: String,
        iconLastPage: String,
        title: String,
        hideHeader: Boolean,
        grid: Boolean,
        gridHeader: Boolean,
        dense: Boolean,
        flat: Boolean,
        bordered: Boolean,
        square: Boolean,
        separator: {
            type: String,
            default: "horizontal",
            validator: (e)=>[
                    "horizontal",
                    "vertical",
                    "cell",
                    "none"
                ].includes(e)
        },
        wrapCells: Boolean,
        virtualScroll: Boolean,
        virtualScrollTarget: {
            default: void 0
        },
        ...$848b1ce88e755b32$var$Uh,
        noDataLabel: String,
        noResultsLabel: String,
        loadingLabel: String,
        selectedRowsLabel: Function,
        rowsPerPageLabel: String,
        paginationLabel: Function,
        color: {
            type: String,
            default: "grey-8"
        },
        titleClass: [
            String,
            Array,
            Object
        ],
        tableStyle: [
            String,
            Array,
            Object
        ],
        tableClass: [
            String,
            Array,
            Object
        ],
        tableHeaderStyle: [
            String,
            Array,
            Object
        ],
        tableHeaderClass: [
            String,
            Array,
            Object
        ],
        cardContainerClass: [
            String,
            Array,
            Object
        ],
        cardContainerStyle: [
            String,
            Array,
            Object
        ],
        cardStyle: [
            String,
            Array,
            Object
        ],
        cardClass: [
            String,
            Array,
            Object
        ],
        hideBottom: Boolean,
        hideSelectedBanner: Boolean,
        hideNoData: Boolean,
        hidePagination: Boolean,
        onRowClick: Function,
        onRowDblclick: Function,
        onRowContextmenu: Function,
        ...$848b1ce88e755b32$var$he,
        ...$848b1ce88e755b32$var$zi,
        ...$848b1ce88e755b32$var$Nh,
        ...$848b1ce88e755b32$var$Ph,
        ...$848b1ce88e755b32$var$Eh,
        ...$848b1ce88e755b32$var$Oh,
        ...$848b1ce88e755b32$var$Fh,
        ...$848b1ce88e755b32$var$Mh
    },
    emits: [
        "request",
        "virtualScroll",
        ...$848b1ce88e755b32$var$Oi,
        ...$848b1ce88e755b32$var$Ih,
        ...$848b1ce88e755b32$var$Dh
    ],
    setup (e, { slots: t, emit: o }) {
        let r = (0, $fVLUl.getCurrentInstance)(), { proxy: { $q: n } } = r, i = $848b1ce88e755b32$var$pe(e, n), { inFullscreen: a, toggleFullscreen: l } = $848b1ce88e755b32$var$Ii(), s = (0, $eayOh.computed)(()=>typeof e.rowKey == "function" ? e.rowKey : (Z)=>Z[e.rowKey]), c = (0, $eayOh.ref)(null), u = (0, $eayOh.ref)(null), v = (0, $eayOh.computed)(()=>e.grid !== !0 && e.virtualScroll === !0), f = (0, $eayOh.computed)(()=>" q-table__card" + (i.value === !0 ? " q-table__card--dark q-dark" : "") + (e.square === !0 ? " q-table--square" : "") + (e.flat === !0 ? " q-table--flat" : "") + (e.bordered === !0 ? " q-table--bordered" : "")), d = (0, $eayOh.computed)(()=>`q-table__container q-table--${e.separator}-separator column no-wrap` + (e.grid === !0 ? " q-table--grid" : f.value) + (i.value === !0 ? " q-table--dark" : "") + (e.dense === !0 ? " q-table--dense" : "") + (e.wrapCells === !1 ? " q-table--no-wrap" : "") + (a.value === !0 ? " fullscreen scroll" : "")), m = (0, $eayOh.computed)(()=>d.value + (e.loading === !0 ? " q-table--loading" : ""));
        (0, $eayOh.watch)(()=>e.tableStyle + e.tableClass + e.tableHeaderStyle + e.tableHeaderClass + d.value, ()=>{
            v.value === !0 && u.value !== null && u.value.reset();
        });
        let { innerPagination: y, computedPagination: p, isServerSide: C, requestServerInteraction: b, setPagination: h } = $848b1ce88e755b32$var$Bh(r, G), { computedFilterMethod: g } = $848b1ce88e755b32$var$Ah(e, h), { isRowExpanded: S, setExpanded: P, updateExpanded: $ } = $848b1ce88e755b32$var$Hh(e, o), L = (0, $eayOh.computed)(()=>{
            let Z = e.rows;
            if (C.value === !0 || Z.length === 0) return Z;
            let { sortBy: ve, descending: qe } = p.value;
            return e.filter && (Z = g.value(Z, e.filter, V.value, G)), I.value !== null && (Z = oe.value(e.rows === Z ? Z.slice() : Z, ve, qe)), Z;
        }), E = (0, $eayOh.computed)(()=>L.value.length), A = (0, $eayOh.computed)(()=>{
            let Z = L.value;
            if (C.value === !0) return Z;
            let { rowsPerPage: ve } = p.value;
            return ve !== 0 && (D.value === 0 && e.rows !== Z ? Z.length > te.value && (Z = Z.slice(0, te.value)) : Z = Z.slice(D.value, te.value)), Z;
        }), { hasSelectionMode: B, singleSelection: q, multipleSelection: x, allRowsSelected: k, someRowsSelected: j, rowsSelectedNumber: Q, isRowSelected: w, clearSelection: H, updateSelection: W } = $848b1ce88e755b32$var$Vh(e, o, A, s), { colList: ie, computedCols: V, computedColsMap: _, computedColspan: N } = $848b1ce88e755b32$var$Qh(e, p, B), { columnToSort: I, computedSortMethod: oe, sort: T } = $848b1ce88e755b32$var$Rh(e, p, ie, h), { firstRowIndex: D, lastRowIndex: te, isFirstPage: z, isLastPage: ue, pagesNumber: _e, computedRowsPerPageOptions: U, computedRowsNumber: ae, firstPage: ce, prevPage: be, nextPage: Me, lastPage: le } = $848b1ce88e755b32$var$Lh(r, y, p, C, h, E), Re = (0, $eayOh.computed)(()=>A.value.length === 0), Fe = (0, $eayOh.computed)(()=>{
            let Z = {};
            return $848b1ce88e755b32$var$gd.forEach((ve)=>{
                Z[ve] = e[ve];
            }), Z.virtualScrollItemSize === void 0 && (Z.virtualScrollItemSize = e.dense === !0 ? 28 : 48), Z;
        });
        function De() {
            v.value === !0 && u.value.reset();
        }
        function ne() {
            if (e.grid === !0) return en();
            let Z = e.hideHeader !== !0 ? ke : null;
            if (v.value === !0) {
                let qe = t["top-row"], Be = t["bottom-row"], Ne = {
                    default: (pt)=>Pe(pt.item, t.body, pt.index)
                };
                if (qe !== void 0) {
                    let pt = (0, $fVLUl.h)("tbody", qe({
                        cols: V.value
                    }));
                    Ne.before = Z === null ? ()=>pt : ()=>[
                            Z()
                        ].concat(pt);
                } else Z !== null && (Ne.before = Z);
                return Be !== void 0 && (Ne.after = ()=>(0, $fVLUl.h)("tbody", Be({
                        cols: V.value
                    }))), (0, $fVLUl.h)($848b1ce88e755b32$export$e23e912583dc74c1, {
                    ref: u,
                    class: e.tableClass,
                    style: e.tableStyle,
                    ...Fe.value,
                    scrollTarget: e.virtualScrollTarget,
                    items: A.value,
                    type: "__qtable",
                    tableColspan: N.value,
                    onVirtualScroll: Y
                }, Ne);
            }
            let ve = [
                Ee()
            ];
            return Z !== null && ve.unshift(Z()), $848b1ce88e755b32$var$ys({
                class: [
                    "q-table__middle scroll",
                    e.tableClass
                ],
                style: e.tableStyle
            }, ve);
        }
        function se(Z, ve) {
            if (u.value !== null) {
                u.value.scrollTo(Z, ve);
                return;
            }
            Z = parseInt(Z, 10);
            let qe = c.value.querySelector(`tbody tr:nth-of-type(${Z + 1})`);
            if (qe !== null) {
                let Be = c.value.querySelector(".q-table__middle.scroll"), Ne = qe.offsetTop - e.virtualScrollStickySizeStart, pt = Ne < Be.scrollTop ? "decrease" : "increase";
                Be.scrollTop = Ne, o("virtualScroll", {
                    index: Z,
                    from: 0,
                    to: y.value.rowsPerPage - 1,
                    direction: pt
                });
            }
        }
        function Y(Z) {
            o("virtualScroll", Z);
        }
        function me() {
            return [
                (0, $fVLUl.h)($848b1ce88e755b32$export$2d10adb726183d68, {
                    class: "q-table__linear-progress",
                    color: e.color,
                    dark: i.value,
                    indeterminate: !0,
                    trackColor: "transparent"
                })
            ];
        }
        function Pe(Z, ve, qe) {
            let Be = s.value(Z), Ne = w(Be);
            if (ve !== void 0) return ve(Ae({
                key: Be,
                row: Z,
                pageIndex: qe,
                __trClass: Ne ? "selected" : ""
            }));
            let pt = t["body-cell"], M = V.value.map((X)=>{
                let de = t[`body-cell-${X.name}`], fe = de !== void 0 ? de : pt;
                return fe !== void 0 ? fe(nt({
                    key: Be,
                    row: Z,
                    pageIndex: qe,
                    col: X
                })) : (0, $fVLUl.h)("td", {
                    class: X.__tdClass(Z),
                    style: X.__tdStyle(Z)
                }, G(X, Z));
            });
            if (B.value === !0) {
                let X = t["body-selection"], de = X !== void 0 ? X(ct({
                    key: Be,
                    row: Z,
                    pageIndex: qe
                })) : [
                    (0, $fVLUl.h)($848b1ce88e755b32$export$a3430661ad019cfb, {
                        modelValue: Ne,
                        color: e.color,
                        dark: i.value,
                        dense: e.dense,
                        "onUpdate:modelValue": (fe, et)=>{
                            W([
                                Be
                            ], [
                                Z
                            ], fe, et);
                        }
                    })
                ];
                M.unshift((0, $fVLUl.h)("td", {
                    class: "q-table--col-auto-width"
                }, de));
            }
            let O = {
                key: Be,
                class: {
                    selected: Ne
                }
            };
            return e.onRowClick !== void 0 && (O.class["cursor-pointer"] = !0, O.onClick = (X)=>{
                o("rowClick", X, Z, qe);
            }), e.onRowDblclick !== void 0 && (O.class["cursor-pointer"] = !0, O.onDblclick = (X)=>{
                o("rowDblclick", X, Z, qe);
            }), e.onRowContextmenu !== void 0 && (O.class["cursor-pointer"] = !0, O.onContextmenu = (X)=>{
                o("rowContextmenu", X, Z, qe);
            }), (0, $fVLUl.h)("tr", O, M);
        }
        function Ee() {
            let Z = t.body, ve = t["top-row"], qe = t["bottom-row"], Be = A.value.map((Ne, pt)=>Pe(Ne, Z, pt));
            return ve !== void 0 && (Be = ve({
                cols: V.value
            }).concat(Be)), qe !== void 0 && (Be = Be.concat(qe({
                cols: V.value
            }))), (0, $fVLUl.h)("tbody", Be);
        }
        function Ae(Z) {
            return dt(Z), Z.cols = Z.cols.map((ve)=>$848b1ce88e755b32$var$it({
                    ...ve
                }, "value", ()=>G(ve, Z.row))), Z;
        }
        function nt(Z) {
            return dt(Z), $848b1ce88e755b32$var$it(Z, "value", ()=>G(Z.col, Z.row)), Z;
        }
        function ct(Z) {
            return dt(Z), Z;
        }
        function dt(Z) {
            Object.assign(Z, {
                cols: V.value,
                colsMap: _.value,
                sort: T,
                rowIndex: D.value + Z.pageIndex,
                color: e.color,
                dark: i.value,
                dense: e.dense
            }), B.value === !0 && $848b1ce88e755b32$var$it(Z, "selected", ()=>w(Z.key), (ve, qe)=>{
                W([
                    Z.key
                ], [
                    Z.row
                ], ve, qe);
            }), $848b1ce88e755b32$var$it(Z, "expand", ()=>S(Z.key), (ve)=>{
                $(Z.key, ve);
            });
        }
        function G(Z, ve) {
            let qe = typeof Z.field == "function" ? Z.field(ve) : ve[Z.field];
            return Z.format !== void 0 ? Z.format(qe, ve) : qe;
        }
        let re = (0, $eayOh.computed)(()=>({
                pagination: p.value,
                pagesNumber: _e.value,
                isFirstPage: z.value,
                isLastPage: ue.value,
                firstPage: ce,
                prevPage: be,
                nextPage: Me,
                lastPage: le,
                inFullscreen: a.value,
                toggleFullscreen: l
            }));
        function K() {
            let Z = t.top, ve = t["top-left"], qe = t["top-right"], Be = t["top-selection"], Ne = B.value === !0 && Be !== void 0 && Q.value > 0, pt = "q-table__top relative-position row items-center";
            if (Z !== void 0) return (0, $fVLUl.h)("div", {
                class: pt
            }, [
                Z(re.value)
            ]);
            let M;
            if (Ne === !0 ? M = Be(re.value).slice() : (M = [], ve !== void 0 ? M.push((0, $fVLUl.h)("div", {
                class: "q-table__control"
            }, [
                ve(re.value)
            ])) : e.title && M.push((0, $fVLUl.h)("div", {
                class: "q-table__control"
            }, [
                (0, $fVLUl.h)("div", {
                    class: [
                        "q-table__title",
                        e.titleClass
                    ]
                }, e.title)
            ]))), qe !== void 0 && (M.push((0, $fVLUl.h)("div", {
                class: "q-table__separator col"
            })), M.push((0, $fVLUl.h)("div", {
                class: "q-table__control"
            }, [
                qe(re.value)
            ]))), M.length !== 0) return (0, $fVLUl.h)("div", {
                class: pt
            }, M);
        }
        let ee = (0, $eayOh.computed)(()=>j.value === !0 ? null : k.value);
        function ke() {
            let Z = ze();
            return e.loading === !0 && t.loading === void 0 && Z.push((0, $fVLUl.h)("tr", {
                class: "q-table__progress"
            }, [
                (0, $fVLUl.h)("th", {
                    class: "relative-position",
                    colspan: N.value
                }, me())
            ])), (0, $fVLUl.h)("thead", Z);
        }
        function ze() {
            let Z = t.header, ve = t["header-cell"];
            if (Z !== void 0) return Z(ye({
                header: !0
            })).slice();
            let qe = V.value.map((Be)=>{
                let Ne = t[`header-cell-${Be.name}`], pt = Ne !== void 0 ? Ne : ve, M = ye({
                    col: Be
                });
                return pt !== void 0 ? pt(M) : (0, $fVLUl.h)($848b1ce88e755b32$export$f3b568562ea6363f, {
                    key: Be.name,
                    props: M
                }, ()=>Be.label);
            });
            if (q.value === !0 && e.grid !== !0) qe.unshift((0, $fVLUl.h)("th", {
                class: "q-table--col-auto-width"
            }, " "));
            else if (x.value === !0) {
                let Be = t["header-selection"], Ne = Be !== void 0 ? Be(ye({})) : [
                    (0, $fVLUl.h)($848b1ce88e755b32$export$a3430661ad019cfb, {
                        color: e.color,
                        modelValue: ee.value,
                        dark: i.value,
                        dense: e.dense,
                        "onUpdate:modelValue": Ge
                    })
                ];
                qe.unshift((0, $fVLUl.h)("th", {
                    class: "q-table--col-auto-width"
                }, Ne));
            }
            return [
                (0, $fVLUl.h)("tr", {
                    class: e.tableHeaderClass,
                    style: e.tableHeaderStyle
                }, qe)
            ];
        }
        function ye(Z) {
            return Object.assign(Z, {
                cols: V.value,
                sort: T,
                colsMap: _.value,
                color: e.color,
                dark: i.value,
                dense: e.dense
            }), x.value === !0 && $848b1ce88e755b32$var$it(Z, "selected", ()=>ee.value, Ge), Z;
        }
        function Ge(Z) {
            j.value === !0 && (Z = !1), W(A.value.map(s.value), A.value, Z);
        }
        let mt = (0, $eayOh.computed)(()=>{
            let Z = [
                e.iconFirstPage || n.iconSet.table.firstPage,
                e.iconPrevPage || n.iconSet.table.prevPage,
                e.iconNextPage || n.iconSet.table.nextPage,
                e.iconLastPage || n.iconSet.table.lastPage
            ];
            return n.lang.rtl === !0 ? Z.reverse() : Z;
        });
        function ht() {
            if (e.hideBottom === !0) return;
            if (Re.value === !0) {
                if (e.hideNoData === !0) return;
                let qe = e.loading === !0 ? e.loadingLabel || n.lang.table.loading : e.filter ? e.noResultsLabel || n.lang.table.noResults : e.noDataLabel || n.lang.table.noData, Be = t["no-data"], Ne = Be !== void 0 ? [
                    Be({
                        message: qe,
                        icon: n.iconSet.table.warning,
                        filter: e.filter
                    })
                ] : [
                    (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                        class: "q-table__bottom-nodata-icon",
                        name: n.iconSet.table.warning
                    }),
                    qe
                ];
                return (0, $fVLUl.h)("div", {
                    class: $848b1ce88e755b32$var$Cs + " q-table__bottom--nodata"
                }, Ne);
            }
            let Z = t.bottom;
            if (Z !== void 0) return (0, $fVLUl.h)("div", {
                class: $848b1ce88e755b32$var$Cs
            }, [
                Z(re.value)
            ]);
            let ve = e.hideSelectedBanner !== !0 && B.value === !0 && Q.value > 0 ? [
                (0, $fVLUl.h)("div", {
                    class: "q-table__control"
                }, [
                    (0, $fVLUl.h)("div", [
                        (e.selectedRowsLabel || n.lang.table.selectedRecords)(Q.value)
                    ])
                ])
            ] : [];
            if (e.hidePagination !== !0) return (0, $fVLUl.h)("div", {
                class: $848b1ce88e755b32$var$Cs + " justify-end"
            }, qo(ve));
            if (ve.length !== 0) return (0, $fVLUl.h)("div", {
                class: $848b1ce88e755b32$var$Cs
            }, ve);
        }
        function ro(Z) {
            h({
                page: 1,
                rowsPerPage: Z.value
            });
        }
        function qo(Z) {
            let ve, { rowsPerPage: qe } = p.value, Be = e.paginationLabel || n.lang.table.pagination, Ne = t.pagination, pt = e.rowsPerPageOptions.length > 1;
            if (Z.push((0, $fVLUl.h)("div", {
                class: "q-table__separator col"
            })), pt === !0 && Z.push((0, $fVLUl.h)("div", {
                class: "q-table__control"
            }, [
                (0, $fVLUl.h)("span", {
                    class: "q-table__bottom-item"
                }, [
                    e.rowsPerPageLabel || n.lang.table.recordsPerPage
                ]),
                (0, $fVLUl.h)($848b1ce88e755b32$export$c6f171932ae1be1a, {
                    class: "q-table__select inline q-table__bottom-item",
                    color: e.color,
                    modelValue: qe,
                    options: U.value,
                    displayValue: qe === 0 ? n.lang.table.allRows : qe,
                    dark: i.value,
                    borderless: !0,
                    dense: !0,
                    optionsDense: !0,
                    optionsCover: !0,
                    "onUpdate:modelValue": ro
                })
            ])), Ne !== void 0) ve = Ne(re.value);
            else if (ve = [
                (0, $fVLUl.h)("span", qe !== 0 ? {
                    class: "q-table__bottom-item"
                } : {}, [
                    qe ? Be(D.value + 1, Math.min(te.value, ae.value), ae.value) : Be(1, E.value, ae.value)
                ])
            ], qe !== 0 && _e.value > 1) {
                let M = {
                    color: e.color,
                    round: !0,
                    dense: !0,
                    flat: !0
                };
                e.dense === !0 && (M.size = "sm"), _e.value > 2 && ve.push((0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                    key: "pgFirst",
                    ...M,
                    icon: mt.value[0],
                    disable: z.value,
                    onClick: ce
                })), ve.push((0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                    key: "pgPrev",
                    ...M,
                    icon: mt.value[1],
                    disable: z.value,
                    onClick: be
                }), (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                    key: "pgNext",
                    ...M,
                    icon: mt.value[2],
                    disable: ue.value,
                    onClick: Me
                })), _e.value > 2 && ve.push((0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                    key: "pgLast",
                    ...M,
                    icon: mt.value[3],
                    disable: ue.value,
                    onClick: le
                }));
            }
            return Z.push((0, $fVLUl.h)("div", {
                class: "q-table__control"
            }, ve)), Z;
        }
        function kn() {
            let Z = e.gridHeader === !0 ? [
                (0, $fVLUl.h)("table", {
                    class: "q-table"
                }, [
                    ke((0, $fVLUl.h))
                ])
            ] : e.loading === !0 && t.loading === void 0 ? me((0, $fVLUl.h)) : void 0;
            return (0, $fVLUl.h)("div", {
                class: "q-table__middle"
            }, Z);
        }
        function en() {
            let Z = t.item !== void 0 ? t.item : (ve)=>{
                let qe = ve.cols.map((Ne)=>(0, $fVLUl.h)("div", {
                        class: "q-table__grid-item-row"
                    }, [
                        (0, $fVLUl.h)("div", {
                            class: "q-table__grid-item-title"
                        }, [
                            Ne.label
                        ]),
                        (0, $fVLUl.h)("div", {
                            class: "q-table__grid-item-value"
                        }, [
                            Ne.value
                        ])
                    ]));
                if (B.value === !0) {
                    let Ne = t["body-selection"], pt = Ne !== void 0 ? Ne(ve) : [
                        (0, $fVLUl.h)($848b1ce88e755b32$export$a3430661ad019cfb, {
                            modelValue: ve.selected,
                            color: e.color,
                            dark: i.value,
                            dense: e.dense,
                            "onUpdate:modelValue": (M, O)=>{
                                W([
                                    ve.key
                                ], [
                                    ve.row
                                ], M, O);
                            }
                        })
                    ];
                    qe.unshift((0, $fVLUl.h)("div", {
                        class: "q-table__grid-item-row"
                    }, pt), (0, $fVLUl.h)($848b1ce88e755b32$export$a3fe6e564278fbe9, {
                        dark: i.value
                    }));
                }
                let Be = {
                    class: [
                        "q-table__grid-item-card" + f.value,
                        e.cardClass
                    ],
                    style: e.cardStyle
                };
                return (e.onRowClick !== void 0 || e.onRowDblclick !== void 0) && (Be.class[0] += " cursor-pointer", e.onRowClick !== void 0 && (Be.onClick = (Ne)=>{
                    o("RowClick", Ne, ve.row, ve.pageIndex);
                }), e.onRowDblclick !== void 0 && (Be.onDblclick = (Ne)=>{
                    o("RowDblclick", Ne, ve.row, ve.pageIndex);
                })), (0, $fVLUl.h)("div", {
                    class: "q-table__grid-item col-xs-12 col-sm-6 col-md-4 col-lg-3" + (ve.selected === !0 ? " q-table__grid-item--selected" : "")
                }, [
                    (0, $fVLUl.h)("div", Be, qe)
                ]);
            };
            return (0, $fVLUl.h)("div", {
                class: [
                    "q-table__grid-content row",
                    e.cardContainerClass
                ],
                style: e.cardContainerStyle
            }, A.value.map((ve, qe)=>Z(Ae({
                    key: s.value(ve),
                    row: ve,
                    pageIndex: qe
                }))));
        }
        return Object.assign(r.proxy, {
            requestServerInteraction: b,
            setPagination: h,
            firstPage: ce,
            prevPage: be,
            nextPage: Me,
            lastPage: le,
            isRowSelected: w,
            clearSelection: H,
            isRowExpanded: S,
            setExpanded: P,
            sort: T,
            resetVirtualScroll: De,
            scrollTo: se,
            getCellValue: G
        }), $848b1ce88e755b32$var$Sl(r.proxy, {
            filteredSortedRows: ()=>L.value,
            computedRows: ()=>A.value,
            computedRowsNumber: ()=>ae.value
        }), ()=>{
            let Z = [
                K()
            ], ve = {
                ref: c,
                class: m.value
            };
            return e.grid === !0 ? Z.push(kn()) : Object.assign(ve, {
                class: [
                    ve.class,
                    e.cardClass
                ],
                style: e.cardStyle
            }), Z.push(ne(), ht()), e.loading === !0 && t.loading !== void 0 && Z.push(t.loading()), (0, $fVLUl.h)("div", ve, Z);
        };
    }
});
var $848b1ce88e755b32$export$eb796db58a736f8f = $848b1ce88e755b32$var$R({
    name: "QTr",
    props: {
        props: Object,
        noHover: Boolean
    },
    setup (e, { slots: t }) {
        let o = (0, $eayOh.computed)(()=>"q-tr" + (e.props === void 0 || e.props.header === !0 ? "" : " " + e.props.__trClass) + (e.noHover === !0 ? " q-tr--no-hover" : ""));
        return ()=>(0, $fVLUl.h)("tr", {
                class: o.value
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$export$f8a8c02d3a86d0c6 = $848b1ce88e755b32$var$R({
    name: "QTd",
    props: {
        props: Object,
        autoWidth: Boolean,
        noHover: Boolean
    },
    setup (e, { slots: t }) {
        let o = (0, $fVLUl.getCurrentInstance)(), r = (0, $eayOh.computed)(()=>"q-td" + (e.autoWidth === !0 ? " q-table--col-auto-width" : "") + (e.noHover === !0 ? " q-td--no-hover" : "") + " ");
        return ()=>{
            if (e.props === void 0) return (0, $fVLUl.h)("td", {
                class: r.value
            }, $848b1ce88e755b32$var$J(t.default));
            let n = o.vnode.key, i = (e.props.colsMap !== void 0 ? e.props.colsMap[n] : null) || e.props.col;
            if (i === void 0) return;
            let { row: a } = e.props;
            return (0, $fVLUl.h)("td", {
                class: r.value + i.__tdClass(a),
                style: i.__tdStyle(a)
            }, $848b1ce88e755b32$var$J(t.default));
        };
    }
});
var $848b1ce88e755b32$export$fc20573fc4d541d2 = $848b1ce88e755b32$var$R({
    name: "QRouteTab",
    props: {
        ...$848b1ce88e755b32$var$zo,
        ...$848b1ce88e755b32$var$lu
    },
    emits: $848b1ce88e755b32$var$au,
    setup (e, { slots: t, emit: o }) {
        let r = $848b1ce88e755b32$var$Yn({
            useDisableForRouterLinkProps: !1
        }), { renderTab: n, $tabs: i } = $848b1ce88e755b32$var$uu(e, t, o, {
            exact: (0, $eayOh.computed)(()=>e.exact),
            ...r
        });
        return (0, $eayOh.watch)(()=>`${e.name} | ${e.exact} | ${(r.resolvedLink.value || {}).href}`, ()=>{
            i.verifyRouteModel();
        }), ()=>n(r.linkTag.value, r.linkAttrs.value);
    }
});
function $848b1ce88e755b32$var$_k(e, t) {
    if (e.hour !== null) {
        if (e.minute === null) return "minute";
        if (t === !0 && e.second === null) return "second";
    }
    return "hour";
}
function $848b1ce88e755b32$var$Ck() {
    let e = new Date;
    return {
        hour: e.getHours(),
        minute: e.getMinutes(),
        second: e.getSeconds(),
        millisecond: e.getMilliseconds()
    };
}
var $848b1ce88e755b32$export$75b50612c5275613 = $848b1ce88e755b32$var$R({
    name: "QTime",
    props: {
        ...$848b1ce88e755b32$var$he,
        ...$848b1ce88e755b32$var$_t,
        ...$848b1ce88e755b32$var$vu,
        mask: {
            default: null
        },
        format24h: {
            type: Boolean,
            default: null
        },
        defaultDate: {
            type: String,
            validator: (e)=>/^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(e)
        },
        options: Function,
        hourOptions: Array,
        minuteOptions: Array,
        secondOptions: Array,
        withSeconds: Boolean,
        nowBtn: Boolean
    },
    emits: $848b1ce88e755b32$var$gu,
    setup (e, { slots: t, emit: o }) {
        let r = (0, $fVLUl.getCurrentInstance)(), { $q: n } = r.proxy, i = $848b1ce88e755b32$var$pe(e, n), { tabindex: a, headerClass: l, getLocale: s, getCurrentDate: c } = $848b1ce88e755b32$var$hu(e, n), u = $848b1ce88e755b32$var$cn(e), v = $848b1ce88e755b32$var$eo(u), f, d, m = (0, $eayOh.ref)(null), y = (0, $eayOh.computed)(()=>oe()), p = (0, $eayOh.computed)(()=>s()), C = (0, $eayOh.computed)(()=>T()), b = $848b1ce88e755b32$var$lr(e.modelValue, y.value, p.value, e.calendar, C.value), h = (0, $eayOh.ref)($848b1ce88e755b32$var$_k(b)), g = (0, $eayOh.ref)(b), S = (0, $eayOh.ref)(b.hour === null || b.hour < 12), P = (0, $eayOh.computed)(()=>`q-time q-time--${e.landscape === !0 ? "landscape" : "portrait"}` + (i.value === !0 ? " q-time--dark q-dark" : "") + (e.disable === !0 ? " disabled" : e.readonly === !0 ? " q-time--readonly" : "") + (e.bordered === !0 ? " q-time--bordered" : "") + (e.square === !0 ? " q-time--square no-border-radius" : "") + (e.flat === !0 ? " q-time--flat no-shadow" : "")), $ = (0, $eayOh.computed)(()=>{
            let G = g.value;
            return {
                hour: G.hour === null ? "--" : L.value === !0 ? $848b1ce88e755b32$var$Je(G.hour) : String(S.value === !0 ? G.hour === 0 ? 12 : G.hour : G.hour > 12 ? G.hour - 12 : G.hour),
                minute: G.minute === null ? "--" : $848b1ce88e755b32$var$Je(G.minute),
                second: G.second === null ? "--" : $848b1ce88e755b32$var$Je(G.second)
            };
        }), L = (0, $eayOh.computed)(()=>e.format24h !== null ? e.format24h : n.lang.date.format24h), E = (0, $eayOh.computed)(()=>{
            let G = h.value === "hour", re = G === !0 ? 12 : 60, K = g.value[h.value], ke = `rotate(${Math.round(K * (360 / re)) - 180}deg) translateX(-50%)`;
            return G === !0 && L.value === !0 && g.value.hour >= 12 && (ke += " scale(.7)"), {
                transform: ke
            };
        }), A = (0, $eayOh.computed)(()=>g.value.hour !== null), B = (0, $eayOh.computed)(()=>A.value === !0 && g.value.minute !== null), q = (0, $eayOh.computed)(()=>e.hourOptions !== void 0 ? (G)=>e.hourOptions.includes(G) : e.options !== void 0 ? (G)=>e.options(G, null, null) : null), x = (0, $eayOh.computed)(()=>e.minuteOptions !== void 0 ? (G)=>e.minuteOptions.includes(G) : e.options !== void 0 ? (G)=>e.options(g.value.hour, G, null) : null), k = (0, $eayOh.computed)(()=>e.secondOptions !== void 0 ? (G)=>e.secondOptions.includes(G) : e.options !== void 0 ? (G)=>e.options(g.value.hour, g.value.minute, G) : null), j = (0, $eayOh.computed)(()=>{
            if (q.value === null) return null;
            let G = _(0, 11, q.value), re = _(12, 11, q.value);
            return {
                am: G,
                pm: re,
                values: G.values.concat(re.values)
            };
        }), Q = (0, $eayOh.computed)(()=>x.value !== null ? _(0, 59, x.value) : null), w = (0, $eayOh.computed)(()=>k.value !== null ? _(0, 59, k.value) : null), H = (0, $eayOh.computed)(()=>{
            switch(h.value){
                case "hour":
                    return j.value;
                case "minute":
                    return Q.value;
                case "second":
                    return w.value;
            }
        }), W = (0, $eayOh.computed)(()=>{
            let G, re, K = 0, ee = 1, ke = H.value !== null ? H.value.values : void 0;
            h.value === "hour" ? L.value === !0 ? (G = 0, re = 23) : (G = 0, re = 11, S.value === !1 && (K = 12)) : (G = 0, re = 55, ee = 5);
            let ze = [];
            for(let ye = G, Ge = G; ye <= re; ye += ee, Ge++){
                let mt = ye + K, ht = ke !== void 0 && ke.includes(mt) === !1, ro = h.value === "hour" && ye === 0 ? L.value === !0 ? "00" : "12" : ye;
                ze.push({
                    val: mt,
                    index: Ge,
                    disable: ht,
                    label: ro
                });
            }
            return ze;
        }), ie = (0, $eayOh.computed)(()=>[
                [
                    $848b1ce88e755b32$export$718797250d1e376,
                    z,
                    void 0,
                    {
                        stop: !0,
                        prevent: !0,
                        mouse: !0
                    }
                ]
            ]);
        (0, $eayOh.watch)(()=>e.modelValue, (G)=>{
            let re = $848b1ce88e755b32$var$lr(G, y.value, p.value, e.calendar, C.value);
            (re.dateHash !== g.value.dateHash || re.timeHash !== g.value.timeHash) && (g.value = re, re.hour === null ? h.value = "hour" : S.value = re.hour < 12);
        }), (0, $eayOh.watch)([
            y,
            p
        ], ()=>{
            (0, $fVLUl.nextTick)(()=>{
                nt();
            });
        });
        function V() {
            let G = {
                ...c(),
                ...$848b1ce88e755b32$var$Ck()
            };
            nt(G), Object.assign(g.value, G), h.value = "hour";
        }
        function _(G, re, K) {
            let ee = Array.apply(null, {
                length: re + 1
            }).map((ke, ze)=>{
                let ye = ze + G;
                return {
                    index: ye,
                    val: K(ye) === !0
                };
            }).filter((ke)=>ke.val === !0).map((ke)=>ke.index);
            return {
                min: ee[0],
                max: ee[ee.length - 1],
                values: ee,
                threshold: re + 1
            };
        }
        function N(G, re, K) {
            let ee = Math.abs(G - re);
            return Math.min(ee, K - ee);
        }
        function I(G, { min: re, max: K, values: ee, threshold: ke }) {
            if (G === re) return re;
            if (G < re || G > K) return N(G, re, ke) <= N(G, K, ke) ? re : K;
            let ze = ee.findIndex((mt)=>G <= mt), ye = ee[ze - 1], Ge = ee[ze];
            return G - ye <= Ge - G ? ye : Ge;
        }
        function oe() {
            return e.calendar !== "persian" && e.mask !== null ? e.mask : `HH:mm${e.withSeconds === !0 ? ":ss" : ""}`;
        }
        function T() {
            if (typeof e.defaultDate != "string") {
                let G = c(!0);
                return G.dateHash = $848b1ce88e755b32$var$Qo(G), G;
            }
            return $848b1ce88e755b32$var$lr(e.defaultDate, "YYYY/MM/DD", void 0, e.calendar);
        }
        function D() {
            return $848b1ce88e755b32$var$Jt(r) === !0 || H.value !== null && (H.value.values.length === 0 || h.value === "hour" && L.value !== !0 && j.value[S.value === !0 ? "am" : "pm"].values.length === 0);
        }
        function te() {
            let G = m.value, { top: re, left: K, width: ee } = G.getBoundingClientRect(), ke = ee / 2;
            return {
                top: re + ke,
                left: K + ke,
                dist: ke * .7
            };
        }
        function z(G) {
            if (D() !== !0) {
                if (G.isFirst === !0) {
                    f = te(), d = _e(G.evt, f);
                    return;
                }
                d = _e(G.evt, f, d), G.isFinal === !0 && (f = !1, d = null, ue());
            }
        }
        function ue() {
            h.value === "hour" ? h.value = "minute" : e.withSeconds && h.value === "minute" && (h.value = "second");
        }
        function _e(G, re, K) {
            let ee = $848b1ce88e755b32$var$yt(G), ke = Math.abs(ee.top - re.top), ze = Math.sqrt(Math.pow(Math.abs(ee.top - re.top), 2) + Math.pow(Math.abs(ee.left - re.left), 2)), ye, Ge = Math.asin(ke / ze) * (180 / Math.PI);
            if (ee.top < re.top ? Ge = re.left < ee.left ? 90 - Ge : 270 + Ge : Ge = re.left < ee.left ? Ge + 90 : 270 - Ge, h.value === "hour") {
                if (ye = Ge / 30, j.value !== null) {
                    let mt = L.value !== !0 ? S.value === !0 : j.value.am.values.length !== 0 && j.value.pm.values.length !== 0 ? ze >= re.dist : j.value.am.values.length !== 0;
                    ye = I(ye + (mt === !0 ? 0 : 12), j.value[mt === !0 ? "am" : "pm"]);
                } else ye = Math.round(ye), L.value === !0 ? ze < re.dist ? ye < 12 && (ye += 12) : ye === 12 && (ye = 0) : S.value === !0 && ye === 12 ? ye = 0 : S.value === !1 && ye !== 12 && (ye += 12);
                L.value === !0 && (S.value = ye < 12);
            } else ye = Math.round(Ge / 6) % 60, h.value === "minute" && Q.value !== null ? ye = I(ye, Q.value) : h.value === "second" && w.value !== null && (ye = I(ye, w.value));
            return K !== ye && Y[h.value](ye), ye;
        }
        let U = {
            hour () {
                h.value = "hour";
            },
            minute () {
                h.value = "minute";
            },
            second () {
                h.value = "second";
            }
        };
        function ae(G) {
            G.keyCode === 13 && me();
        }
        function ce(G) {
            G.keyCode === 13 && Pe();
        }
        function be(G) {
            D() !== !0 && (n.platform.is.desktop !== !0 && _e(G, te()), ue());
        }
        function Me(G) {
            D() !== !0 && _e(G, te());
        }
        function le(G) {
            if (G.keyCode === 13) h.value = "hour";
            else if ([
                37,
                39
            ].includes(G.keyCode)) {
                let re = G.keyCode === 37 ? -1 : 1;
                if (j.value !== null) {
                    let K = L.value === !0 ? j.value.values : j.value[S.value === !0 ? "am" : "pm"].values;
                    if (K.length === 0) return;
                    if (g.value.hour === null) De(K[0]);
                    else {
                        let ee = (K.length + K.indexOf(g.value.hour) + re) % K.length;
                        De(K[ee]);
                    }
                } else {
                    let K = L.value === !0 ? 24 : 12, ee = L.value !== !0 && S.value === !1 ? 12 : 0, ke = g.value.hour === null ? -re : g.value.hour;
                    De(ee + (24 + ke + re) % K);
                }
            }
        }
        function Re(G) {
            if (G.keyCode === 13) h.value = "minute";
            else if ([
                37,
                39
            ].includes(G.keyCode)) {
                let re = G.keyCode === 37 ? -1 : 1;
                if (Q.value !== null) {
                    let K = Q.value.values;
                    if (K.length === 0) return;
                    if (g.value.minute === null) ne(K[0]);
                    else {
                        let ee = (K.length + K.indexOf(g.value.minute) + re) % K.length;
                        ne(K[ee]);
                    }
                } else {
                    let K = g.value.minute === null ? -re : g.value.minute;
                    ne((60 + K + re) % 60);
                }
            }
        }
        function Fe(G) {
            if (G.keyCode === 13) h.value = "second";
            else if ([
                37,
                39
            ].includes(G.keyCode)) {
                let re = G.keyCode === 37 ? -1 : 1;
                if (w.value !== null) {
                    let K = w.value.values;
                    if (K.length === 0) return;
                    if (g.value.seconds === null) se(K[0]);
                    else {
                        let ee = (K.length + K.indexOf(g.value.second) + re) % K.length;
                        se(K[ee]);
                    }
                } else {
                    let K = g.value.second === null ? -re : g.value.second;
                    se((60 + K + re) % 60);
                }
            }
        }
        function De(G) {
            g.value.hour !== G && (g.value.hour = G, Ae());
        }
        function ne(G) {
            g.value.minute !== G && (g.value.minute = G, Ae());
        }
        function se(G) {
            g.value.second !== G && (g.value.second = G, Ae());
        }
        let Y = {
            hour: De,
            minute: ne,
            second: se
        };
        function me() {
            S.value === !1 && (S.value = !0, g.value.hour !== null && (g.value.hour -= 12, Ae()));
        }
        function Pe() {
            S.value === !0 && (S.value = !1, g.value.hour !== null && (g.value.hour += 12, Ae()));
        }
        function Ee(G) {
            let re = e.modelValue;
            h.value !== G && re !== void 0 && re !== null && re !== "" && typeof re != "string" && (h.value = G);
        }
        function Ae() {
            if (q.value !== null && q.value(g.value.hour) !== !0) {
                g.value = $848b1ce88e755b32$var$lr(), Ee("hour");
                return;
            }
            if (x.value !== null && x.value(g.value.minute) !== !0) {
                g.value.minute = null, g.value.second = null, Ee("minute");
                return;
            }
            if (e.withSeconds === !0 && k.value !== null && k.value(g.value.second) !== !0) {
                g.value.second = null, Ee("second");
                return;
            }
            g.value.hour === null || g.value.minute === null || e.withSeconds === !0 && g.value.second === null || nt();
        }
        function nt(G) {
            let re = Object.assign({
                ...g.value
            }, G), K = e.calendar === "persian" ? $848b1ce88e755b32$var$Je(re.hour) + ":" + $848b1ce88e755b32$var$Je(re.minute) + (e.withSeconds === !0 ? ":" + $848b1ce88e755b32$var$Je(re.second) : "") : $848b1ce88e755b32$var$Ka(new Date(re.year, re.month === null ? null : re.month - 1, re.day, re.hour, re.minute, re.second, re.millisecond), y.value, p.value, re.year, re.timezoneOffset);
            re.changed = K !== e.modelValue, o("update:modelValue", K, re);
        }
        function ct() {
            let G = [
                (0, $fVLUl.h)("div", {
                    class: "q-time__link " + (h.value === "hour" ? "q-time__link--active" : "cursor-pointer"),
                    tabindex: a.value,
                    onClick: U.hour,
                    onKeyup: le
                }, $.value.hour),
                (0, $fVLUl.h)("div", ":"),
                (0, $fVLUl.h)("div", A.value === !0 ? {
                    class: "q-time__link " + (h.value === "minute" ? "q-time__link--active" : "cursor-pointer"),
                    tabindex: a.value,
                    onKeyup: Re,
                    onClick: U.minute
                } : {
                    class: "q-time__link"
                }, $.value.minute)
            ];
            e.withSeconds === !0 && G.push((0, $fVLUl.h)("div", ":"), (0, $fVLUl.h)("div", B.value === !0 ? {
                class: "q-time__link " + (h.value === "second" ? "q-time__link--active" : "cursor-pointer"),
                tabindex: a.value,
                onKeyup: Fe,
                onClick: U.second
            } : {
                class: "q-time__link"
            }, $.value.second));
            let re = [
                (0, $fVLUl.h)("div", {
                    class: "q-time__header-label row items-center no-wrap",
                    dir: "ltr"
                }, G)
            ];
            return L.value === !1 && re.push((0, $fVLUl.h)("div", {
                class: "q-time__header-ampm column items-between no-wrap"
            }, [
                (0, $fVLUl.h)("div", {
                    class: "q-time__link " + (S.value === !0 ? "q-time__link--active" : "cursor-pointer"),
                    tabindex: a.value,
                    onClick: me,
                    onKeyup: ae
                }, "AM"),
                (0, $fVLUl.h)("div", {
                    class: "q-time__link " + (S.value !== !0 ? "q-time__link--active" : "cursor-pointer"),
                    tabindex: a.value,
                    onClick: Pe,
                    onKeyup: ce
                }, "PM")
            ])), (0, $fVLUl.h)("div", {
                class: "q-time__header flex flex-center no-wrap " + l.value
            }, re);
        }
        function dt() {
            let G = g.value[h.value];
            return (0, $fVLUl.h)("div", {
                class: "q-time__content col relative-position"
            }, [
                (0, $fVLUl.h)((0, $24349.Transition), {
                    name: "q-transition--scale"
                }, ()=>(0, $fVLUl.h)("div", {
                        key: "clock" + h.value,
                        class: "q-time__container-parent absolute-full"
                    }, [
                        (0, $fVLUl.h)("div", {
                            ref: m,
                            class: "q-time__container-child fit overflow-hidden"
                        }, [
                            (0, $fVLUl.withDirectives)((0, $fVLUl.h)("div", {
                                class: "q-time__clock cursor-pointer non-selectable",
                                onClick: be,
                                onMousedown: Me
                            }, [
                                (0, $fVLUl.h)("div", {
                                    class: "q-time__clock-circle fit"
                                }, [
                                    (0, $fVLUl.h)("div", {
                                        class: "q-time__clock-pointer" + (g.value[h.value] === null ? " hidden" : e.color !== void 0 ? ` text-${e.color}` : ""),
                                        style: E.value
                                    }),
                                    W.value.map((re)=>(0, $fVLUl.h)("div", {
                                            class: `q-time__clock-position row flex-center q-time__clock-pos-${re.index}` + (re.val === G ? " q-time__clock-position--active " + l.value : re.disable === !0 ? " q-time__clock-position--disable" : "")
                                        }, [
                                            (0, $fVLUl.h)("span", re.label)
                                        ]))
                                ])
                            ]), ie.value)
                        ])
                    ])),
                e.nowBtn === !0 ? (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                    class: "q-time__now-button absolute",
                    icon: n.iconSet.datetime.now,
                    unelevated: !0,
                    size: "sm",
                    round: !0,
                    color: e.color,
                    textColor: e.textColor,
                    tabindex: a.value,
                    onClick: V
                }) : null
            ]);
        }
        return r.proxy.setNow = V, ()=>{
            let G = [
                dt()
            ], re = $848b1ce88e755b32$var$J(t.default);
            return re !== void 0 && G.push((0, $fVLUl.h)("div", {
                class: "q-time__actions"
            }, re)), e.name !== void 0 && e.disable !== !0 && v(G, "push"), (0, $fVLUl.h)("div", {
                class: P.value,
                tabindex: -1
            }, [
                ct(),
                (0, $fVLUl.h)("div", {
                    class: "q-time__main col overflow-auto"
                }, G)
            ]);
        };
    }
});
var $848b1ce88e755b32$export$aaf1acdf549e0e8f = $848b1ce88e755b32$var$R({
    name: "QTimeline",
    props: {
        ...$848b1ce88e755b32$var$he,
        color: {
            type: String,
            default: "primary"
        },
        side: {
            type: String,
            default: "right",
            validator: (e)=>[
                    "left",
                    "right"
                ].includes(e)
        },
        layout: {
            type: String,
            default: "dense",
            validator: (e)=>[
                    "dense",
                    "comfortable",
                    "loose"
                ].includes(e)
        }
    },
    setup (e, { slots: t }) {
        let o = (0, $fVLUl.getCurrentInstance)(), r = $848b1ce88e755b32$var$pe(e, o.proxy.$q);
        (0, $fVLUl.provide)($848b1ce88e755b32$var$Cl, e);
        let n = (0, $eayOh.computed)(()=>`q-timeline q-timeline--${e.layout} q-timeline--${e.layout}--${e.side}` + (r.value === !0 ? " q-timeline--dark" : ""));
        return ()=>(0, $fVLUl.h)("ul", {
                class: n.value
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$export$d0a3fbd020401544 = $848b1ce88e755b32$var$R({
    name: "QTimelineEntry",
    props: {
        heading: Boolean,
        tag: {
            type: String,
            default: "h3"
        },
        side: {
            type: String,
            default: "right",
            validator: (e)=>[
                    "left",
                    "right"
                ].includes(e)
        },
        icon: String,
        avatar: String,
        color: String,
        title: String,
        subtitle: String,
        body: String
    },
    setup (e, { slots: t }) {
        let o = (0, $fVLUl.inject)($848b1ce88e755b32$var$Cl, $848b1ce88e755b32$var$Ye);
        if (o === $848b1ce88e755b32$var$Ye) return console.error("QTimelineEntry needs to be child of QTimeline"), $848b1ce88e755b32$var$Ye;
        let r = (0, $eayOh.computed)(()=>`q-timeline__entry q-timeline__entry--${e.side}` + (e.icon !== void 0 || e.avatar !== void 0 ? " q-timeline__entry--icon" : "")), n = (0, $eayOh.computed)(()=>`q-timeline__dot text-${e.color || o.color}`), i = (0, $eayOh.computed)(()=>o.layout === "comfortable" && o.side === "left");
        return ()=>{
            let a = $848b1ce88e755b32$var$tn(t.default, []);
            if (e.body !== void 0 && a.unshift(e.body), e.heading === !0) {
                let c = [
                    (0, $fVLUl.h)("div"),
                    (0, $fVLUl.h)("div"),
                    (0, $fVLUl.h)(e.tag, {
                        class: "q-timeline__heading-title"
                    }, a)
                ];
                return (0, $fVLUl.h)("div", {
                    class: "q-timeline__heading"
                }, i.value === !0 ? c.reverse() : c);
            }
            let l;
            e.icon !== void 0 ? l = [
                (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                    class: "row items-center justify-center",
                    name: e.icon
                })
            ] : e.avatar !== void 0 && (l = [
                (0, $fVLUl.h)("img", {
                    class: "q-timeline__dot-img",
                    src: e.avatar
                })
            ]);
            let s = [
                (0, $fVLUl.h)("div", {
                    class: "q-timeline__subtitle"
                }, [
                    (0, $fVLUl.h)("span", {}, $848b1ce88e755b32$var$J(t.subtitle, [
                        e.subtitle
                    ]))
                ]),
                (0, $fVLUl.h)("div", {
                    class: n.value
                }, l),
                (0, $fVLUl.h)("div", {
                    class: "q-timeline__content"
                }, [
                    (0, $fVLUl.h)("h6", {
                        class: "q-timeline__title"
                    }, $848b1ce88e755b32$var$J(t.title, [
                        e.title
                    ]))
                ].concat(a))
            ];
            return (0, $fVLUl.h)("li", {
                class: r.value
            }, i.value === !0 ? s.reverse() : s);
        };
    }
});
var $848b1ce88e755b32$export$9cfe29ba9f08864a = $848b1ce88e755b32$var$R({
    name: "QToolbar",
    props: {
        inset: Boolean
    },
    setup (e, { slots: t }) {
        let o = (0, $eayOh.computed)(()=>"q-toolbar row no-wrap items-center" + (e.inset === !0 ? " q-toolbar--inset" : ""));
        return ()=>(0, $fVLUl.h)("div", {
                class: o.value,
                role: "toolbar"
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$export$dbcf6fec4996856c = $848b1ce88e755b32$var$R({
    name: "QToolbarTitle",
    props: {
        shrink: Boolean
    },
    setup (e, { slots: t }) {
        let o = (0, $eayOh.computed)(()=>"q-toolbar__title ellipsis" + (e.shrink === !0 ? " col-shrink" : ""));
        return ()=>(0, $fVLUl.h)("div", {
                class: o.value
            }, $848b1ce88e755b32$var$J(t.default));
    }
});
var $848b1ce88e755b32$var$Vk = [
    "none",
    "strict",
    "leaf",
    "leaf-filtered"
], $848b1ce88e755b32$export$6ac73dd07dbdca3b = $848b1ce88e755b32$var$R({
    name: "QTree",
    props: {
        ...$848b1ce88e755b32$var$he,
        nodes: {
            type: Array,
            required: !0
        },
        nodeKey: {
            type: String,
            required: !0
        },
        labelKey: {
            type: String,
            default: "label"
        },
        childrenKey: {
            type: String,
            default: "children"
        },
        dense: Boolean,
        color: String,
        controlColor: String,
        textColor: String,
        selectedColor: String,
        icon: String,
        tickStrategy: {
            type: String,
            default: "none",
            validator: (e)=>$848b1ce88e755b32$var$Vk.includes(e)
        },
        ticked: Array,
        expanded: Array,
        selected: {},
        noSelectionUnset: Boolean,
        defaultExpandAll: Boolean,
        accordion: Boolean,
        filter: String,
        filterMethod: Function,
        duration: Number,
        noConnectors: Boolean,
        noTransition: Boolean,
        noNodesLabel: String,
        noResultsLabel: String
    },
    emits: [
        "update:expanded",
        "update:ticked",
        "update:selected",
        "lazyLoad",
        "afterShow",
        "afterHide"
    ],
    setup (e, { slots: t, emit: o }) {
        let { proxy: r } = (0, $fVLUl.getCurrentInstance)(), { $q: n } = r, i = $848b1ce88e755b32$var$pe(e, n), a = (0, $eayOh.ref)({}), l = (0, $eayOh.ref)(e.ticked || []), s = (0, $eayOh.ref)(e.expanded || []), c = {};
        (0, $fVLUl.onBeforeUpdate)(()=>{
            c = {};
        });
        let u = (0, $eayOh.computed)(()=>`q-tree q-tree--${e.dense === !0 ? "dense" : "standard"}` + (e.noConnectors === !0 ? " q-tree--no-connectors" : "") + (i.value === !0 ? " q-tree--dark" : "") + (e.color !== void 0 ? ` text-${e.color}` : "")), v = (0, $eayOh.computed)(()=>e.selected !== void 0), f = (0, $eayOh.computed)(()=>e.icon || n.iconSet.tree.icon), d = (0, $eayOh.computed)(()=>e.controlColor || e.color), m = (0, $eayOh.computed)(()=>e.textColor !== void 0 ? ` text-${e.textColor}` : ""), y = (0, $eayOh.computed)(()=>{
            let _ = e.selectedColor || e.color;
            return _ ? ` text-${_}` : "";
        }), p = (0, $eayOh.computed)(()=>e.filterMethod !== void 0 ? e.filterMethod : (_, N)=>{
                let I = N.toLowerCase();
                return _[e.labelKey] && _[e.labelKey].toLowerCase().indexOf(I) !== -1;
            }), C = (0, $eayOh.computed)(()=>{
            let _ = {}, N = (I, oe)=>{
                let T = I.tickStrategy || (oe ? oe.tickStrategy : e.tickStrategy), D = I[e.nodeKey], te = I[e.childrenKey] && Array.isArray(I[e.childrenKey]) && I[e.childrenKey].length !== 0, z = I.disabled !== !0 && v.value === !0 && I.selectable !== !1, ue = I.disabled !== !0 && I.expandable !== !1, _e = T !== "none", U = T === "strict", ae = T === "leaf-filtered", ce = T === "leaf" || T === "leaf-filtered", be = I.disabled !== !0 && I.tickable !== !1;
                ce === !0 && be === !0 && oe && oe.tickable !== !0 && (be = !1);
                let Me = I.lazy;
                Me === !0 && a.value[D] !== void 0 && Array.isArray(I[e.childrenKey]) === !0 && (Me = a.value[D]);
                let le = {
                    key: D,
                    parent: oe,
                    isParent: te,
                    lazy: Me,
                    disabled: I.disabled,
                    link: I.disabled !== !0 && (z === !0 || ue === !0 && (te === !0 || Me === !0)),
                    children: [],
                    matchesFilter: e.filter ? p.value(I, e.filter) : !0,
                    selected: D === e.selected && z === !0,
                    selectable: z,
                    expanded: te === !0 ? s.value.includes(D) : !1,
                    expandable: ue,
                    noTick: I.noTick === !0 || U !== !0 && Me && Me !== "loaded",
                    tickable: be,
                    tickStrategy: T,
                    hasTicking: _e,
                    strictTicking: U,
                    leafFilteredTicking: ae,
                    leafTicking: ce,
                    ticked: U === !0 ? l.value.includes(D) : te === !0 ? !1 : l.value.includes(D)
                };
                if (_[D] = le, te === !0 && (le.children = I[e.childrenKey].map((Re)=>N(Re, le)), e.filter && (le.matchesFilter !== !0 ? le.matchesFilter = le.children.some((Re)=>Re.matchesFilter) : le.noTick !== !0 && le.disabled !== !0 && le.tickable === !0 && ae === !0 && le.children.every((Re)=>Re.matchesFilter !== !0 || Re.noTick === !0 || Re.tickable !== !0) === !0 && (le.tickable = !1)), le.matchesFilter === !0 && (le.noTick !== !0 && U !== !0 && le.children.every((Re)=>Re.noTick) === !0 && (le.noTick = !0), ce))) {
                    if (le.ticked = !1, le.indeterminate = le.children.some((Re)=>Re.indeterminate === !0), le.tickable = le.tickable === !0 && le.children.some((Re)=>Re.tickable), le.indeterminate !== !0) {
                        let Re = le.children.reduce((Fe, De)=>De.ticked === !0 ? Fe + 1 : Fe, 0);
                        Re === le.children.length ? le.ticked = !0 : Re > 0 && (le.indeterminate = !0);
                    }
                    le.indeterminate === !0 && (le.indeterminateNextState = le.children.every((Re)=>Re.tickable !== !0 || Re.ticked !== !0));
                }
                return le;
            };
            return e.nodes.forEach((I)=>N(I, null)), _;
        });
        (0, $eayOh.watch)(()=>e.ticked, (_)=>{
            l.value = _;
        }), (0, $eayOh.watch)(()=>e.expanded, (_)=>{
            s.value = _;
        });
        function b(_) {
            let N = [].reduce, I = (oe, T)=>{
                if (oe || !T) return oe;
                if (Array.isArray(T) === !0) return N.call(Object(T), I, oe);
                if (T[e.nodeKey] === _) return T;
                if (T[e.childrenKey]) return I(null, T[e.childrenKey]);
            };
            return I(null, e.nodes);
        }
        function h() {
            return l.value.map((_)=>b(_));
        }
        function g() {
            return s.value.map((_)=>b(_));
        }
        function S(_) {
            return _ && C.value[_] ? C.value[_].expanded : !1;
        }
        function P() {
            e.expanded !== void 0 ? o("update:expanded", []) : s.value = [];
        }
        function $() {
            let _ = [], N = (I)=>{
                I[e.childrenKey] && I[e.childrenKey].length !== 0 && I.expandable !== !1 && I.disabled !== !0 && (_.push(I[e.nodeKey]), I[e.childrenKey].forEach(N));
            };
            e.nodes.forEach(N), e.expanded !== void 0 ? o("update:expanded", _) : s.value = _;
        }
        function L(_, N, I = b(_), oe = C.value[_]) {
            if (oe.lazy && oe.lazy !== "loaded") {
                if (oe.lazy === "loading") return;
                a.value[_] = "loading", Array.isArray(I[e.childrenKey]) !== !0 && (I[e.childrenKey] = []), o("lazyLoad", {
                    node: I,
                    key: _,
                    done: (T)=>{
                        a.value[_] = "loaded", I[e.childrenKey] = Array.isArray(T) === !0 ? T : [], (0, $fVLUl.nextTick)(()=>{
                            let D = C.value[_];
                            D && D.isParent === !0 && E(_, !0);
                        });
                    },
                    fail: ()=>{
                        delete a.value[_], I[e.childrenKey].length === 0 && delete I[e.childrenKey];
                    }
                });
            } else oe.isParent === !0 && oe.expandable === !0 && E(_, N);
        }
        function E(_, N) {
            let I = s.value, oe = e.expanded !== void 0;
            if (oe === !0 && (I = I.slice()), N) {
                if (e.accordion && C.value[_]) {
                    let T = [];
                    C.value[_].parent ? C.value[_].parent.children.forEach((D)=>{
                        D.key !== _ && D.expandable === !0 && T.push(D.key);
                    }) : e.nodes.forEach((D)=>{
                        let te = D[e.nodeKey];
                        te !== _ && T.push(te);
                    }), T.length !== 0 && (I = I.filter((D)=>T.includes(D) === !1));
                }
                I = I.concat([
                    _
                ]).filter((T, D, te)=>te.indexOf(T) === D);
            } else I = I.filter((T)=>T !== _);
            oe === !0 ? o("update:expanded", I) : s.value = I;
        }
        function A(_) {
            return _ && C.value[_] ? C.value[_].ticked : !1;
        }
        function B(_, N) {
            let I = l.value, oe = e.ticked !== void 0;
            oe === !0 && (I = I.slice()), N ? I = I.concat(_).filter((T, D, te)=>te.indexOf(T) === D) : I = I.filter((T)=>_.includes(T) === !1), oe === !0 && o("update:ticked", I);
        }
        function q(_, N, I) {
            let oe = {
                tree: r,
                node: _,
                key: I,
                color: e.color,
                dark: i.value
            };
            return $848b1ce88e755b32$var$it(oe, "expanded", ()=>N.expanded, (T)=>{
                T !== N.expanded && L(I, T);
            }), $848b1ce88e755b32$var$it(oe, "ticked", ()=>N.ticked, (T)=>{
                T !== N.ticked && B([
                    I
                ], T);
            }), oe;
        }
        function x(_) {
            return (e.filter ? _.filter((N)=>C.value[N[e.nodeKey]].matchesFilter) : _).map((N)=>w(N));
        }
        function k(_) {
            if (_.icon !== void 0) return (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                class: "q-tree__icon q-mr-sm",
                name: _.icon,
                color: _.iconColor
            });
            let N = _.img || _.avatar;
            if (N) return (0, $fVLUl.h)("img", {
                class: `q-tree__${_.img ? "img" : "avatar"} q-mr-sm`,
                src: N
            });
        }
        function j() {
            o("afterShow");
        }
        function Q() {
            o("afterHide");
        }
        function w(_) {
            let N = _[e.nodeKey], I = C.value[N], oe = _.header && t[`header-${_.header}`] || t["default-header"], T = I.isParent === !0 ? x(_[e.childrenKey]) : [], D = T.length !== 0 || I.lazy && I.lazy !== "loaded", te = _.body && t[`body-${_.body}`] || t["default-body"], z = oe !== void 0 || te !== void 0 ? q(_, I, N) : null;
            return te !== void 0 && (te = (0, $fVLUl.h)("div", {
                class: "q-tree__node-body relative-position"
            }, [
                (0, $fVLUl.h)("div", {
                    class: m.value
                }, [
                    te(z)
                ])
            ])), (0, $fVLUl.h)("div", {
                key: N,
                class: `q-tree__node relative-position q-tree__node--${D === !0 ? "parent" : "child"}`
            }, [
                (0, $fVLUl.h)("div", {
                    class: "q-tree__node-header relative-position row no-wrap items-center" + (I.link === !0 ? " q-tree__node--link q-hoverable q-focusable" : "") + (I.selected === !0 ? " q-tree__node--selected" : "") + (I.disabled === !0 ? " q-tree__node--disabled" : ""),
                    tabindex: I.link === !0 ? 0 : -1,
                    ariaExpanded: T.length > 0 ? I.expanded : null,
                    role: "treeitem",
                    onClick: (ue)=>{
                        W(_, I, ue);
                    },
                    onKeypress (ue) {
                        $848b1ce88e755b32$var$xo(ue) !== !0 && (ue.keyCode === 13 ? W(_, I, ue, !0) : ue.keyCode === 32 && ie(_, I, ue, !0));
                    }
                }, [
                    (0, $fVLUl.h)("div", {
                        class: "q-focus-helper",
                        tabindex: -1,
                        ref: (ue)=>{
                            c[I.key] = ue;
                        }
                    }),
                    I.lazy === "loading" ? (0, $fVLUl.h)($848b1ce88e755b32$export$7418ab329b11fed0, {
                        class: "q-tree__spinner",
                        color: d.value
                    }) : D === !0 ? (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                        class: "q-tree__arrow" + (I.expanded === !0 ? " q-tree__arrow--rotate" : ""),
                        name: f.value,
                        onClick (ue) {
                            ie(_, I, ue);
                        }
                    }) : null,
                    I.hasTicking === !0 && I.noTick !== !0 ? (0, $fVLUl.h)($848b1ce88e755b32$export$a3430661ad019cfb, {
                        class: "q-tree__tickbox",
                        modelValue: I.indeterminate === !0 ? null : I.ticked,
                        color: d.value,
                        dark: i.value,
                        dense: !0,
                        keepColor: !0,
                        disable: I.tickable !== !0,
                        onKeydown: $848b1ce88e755b32$var$Se,
                        "onUpdate:modelValue": (ue)=>{
                            V(I, ue);
                        }
                    }) : null,
                    (0, $fVLUl.h)("div", {
                        class: "q-tree__node-header-content col row no-wrap items-center" + (I.selected === !0 ? y.value : m.value)
                    }, [
                        oe ? oe(z) : [
                            k(_),
                            (0, $fVLUl.h)("div", _[e.labelKey])
                        ]
                    ])
                ]),
                D === !0 ? e.noTransition === !0 ? I.expanded === !0 ? (0, $fVLUl.h)("div", {
                    class: "q-tree__node-collapsible" + m.value,
                    key: `${N}__q`
                }, [
                    te,
                    (0, $fVLUl.h)("div", {
                        class: "q-tree__children" + (I.disabled === !0 ? " q-tree__node--disabled" : ""),
                        role: "group"
                    }, T)
                ]) : null : (0, $fVLUl.h)($848b1ce88e755b32$export$1712cdc175d4649d, {
                    duration: e.duration,
                    onShow: j,
                    onHide: Q
                }, ()=>(0, $fVLUl.withDirectives)((0, $fVLUl.h)("div", {
                        class: "q-tree__node-collapsible" + m.value,
                        key: `${N}__q`
                    }, [
                        te,
                        (0, $fVLUl.h)("div", {
                            class: "q-tree__children" + (I.disabled === !0 ? " q-tree__node--disabled" : ""),
                            role: "group"
                        }, T)
                    ]), [
                        [
                            (0, $24349.vShow),
                            I.expanded
                        ]
                    ])) : te
            ]);
        }
        function H(_) {
            let N = c[_];
            N && N.focus();
        }
        function W(_, N, I, oe) {
            oe !== !0 && N.selectable !== !1 && H(N.key), v.value && N.selectable ? e.noSelectionUnset === !1 ? o("update:selected", N.key !== e.selected ? N.key : null) : N.key !== e.selected && o("update:selected", N.key === void 0 ? null : N.key) : ie(_, N, I, oe), typeof _.handler == "function" && _.handler(_);
        }
        function ie(_, N, I, oe) {
            I !== void 0 && $848b1ce88e755b32$var$Se(I), oe !== !0 && N.selectable !== !1 && H(N.key), L(N.key, !N.expanded, _, N);
        }
        function V(_, N) {
            if (_.indeterminate === !0 && (N = _.indeterminateNextState), _.strictTicking) B([
                _.key
            ], N);
            else if (_.leafTicking) {
                let I = [], oe = (T)=>{
                    T.isParent ? (N !== !0 && T.noTick !== !0 && T.tickable === !0 && I.push(T.key), T.leafTicking === !0 && T.children.forEach(oe)) : T.noTick !== !0 && T.tickable === !0 && (T.leafFilteredTicking !== !0 || T.matchesFilter === !0) && I.push(T.key);
                };
                oe(_), B(I, N);
            }
        }
        return e.defaultExpandAll === !0 && $(), Object.assign(r, {
            getNodeByKey: b,
            getTickedNodes: h,
            getExpandedNodes: g,
            isExpanded: S,
            collapseAll: P,
            expandAll: $,
            setExpanded: L,
            isTicked: A,
            setTicked: B
        }), ()=>{
            let _ = x(e.nodes);
            return (0, $fVLUl.h)("div", {
                class: u.value,
                role: "tree"
            }, _.length === 0 ? e.filter ? e.noResultsLabel || n.lang.tree.noResults : e.noNodesLabel || n.lang.tree.noNodes : _);
        };
    }
});
function $848b1ce88e755b32$var$ap(e) {
    return (e * 100).toFixed(2) + "%";
}
var $848b1ce88e755b32$var$lp = {
    ...$848b1ce88e755b32$var$he,
    ...$848b1ce88e755b32$var$Eu,
    label: String,
    color: String,
    textColor: String,
    square: Boolean,
    flat: Boolean,
    bordered: Boolean,
    noThumbnails: Boolean,
    autoUpload: Boolean,
    hideUploadBtn: Boolean,
    disable: Boolean,
    readonly: Boolean
}, $848b1ce88e755b32$var$Cd = [
    ...$848b1ce88e755b32$var$Bu,
    "start",
    "finish",
    "added",
    "removed"
];
function $848b1ce88e755b32$var$up(e, t) {
    let o = (0, $fVLUl.getCurrentInstance)(), { props: r, slots: n, emit: i, proxy: a } = o, { $q: l } = a, s = $848b1ce88e755b32$var$pe(r, l);
    function c(z, ue, _e) {
        if (z.__status = ue, ue === "idle") {
            z.__uploaded = 0, z.__progress = 0, z.__sizeLabel = $848b1ce88e755b32$var$ri(z.size), z.__progressLabel = "0.00%";
            return;
        }
        if (ue === "failed") {
            a.$forceUpdate();
            return;
        }
        z.__uploaded = ue === "uploaded" ? z.size : _e, z.__progress = ue === "uploaded" ? 1 : Math.min(.9999, z.__uploaded / z.size), z.__progressLabel = $848b1ce88e755b32$var$ap(z.__progress), a.$forceUpdate();
    }
    let u = (0, $eayOh.computed)(()=>r.disable !== !0 && r.readonly !== !0), v = (0, $eayOh.ref)(!1), f = (0, $eayOh.ref)(null), d = (0, $eayOh.ref)(null), m = {
        files: (0, $eayOh.ref)([]),
        queuedFiles: (0, $eayOh.ref)([]),
        uploadedFiles: (0, $eayOh.ref)([]),
        uploadedSize: (0, $eayOh.ref)(0),
        updateFileStatus: c,
        isAlive: ()=>$848b1ce88e755b32$var$Jt(o) === !1
    }, { pickFiles: y, addFiles: p, onDragover: C, onDragleave: b, processFiles: h, getDndNode: g, maxFilesNumber: S, maxTotalSizeNumber: P } = $848b1ce88e755b32$var$Lu({
        editable: u,
        dnd: v,
        getFileInput: V,
        addFilesToQueue: _
    });
    Object.assign(m, e({
        props: r,
        slots: n,
        emit: i,
        helpers: m,
        exposeApi: (z)=>{
            Object.assign(m, z);
        }
    })), m.isBusy === void 0 && (m.isBusy = (0, $eayOh.ref)(!1));
    let $ = (0, $eayOh.ref)(0), L = (0, $eayOh.computed)(()=>$.value === 0 ? 0 : m.uploadedSize.value / $.value), E = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$ap(L.value)), A = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$ri($.value)), B = (0, $eayOh.computed)(()=>u.value === !0 && m.isUploading.value !== !0 && (r.multiple === !0 || m.queuedFiles.value.length === 0) && (r.maxFiles === void 0 || m.files.value.length < S.value) && (r.maxTotalSize === void 0 || $.value < P.value)), q = (0, $eayOh.computed)(()=>u.value === !0 && m.isBusy.value !== !0 && m.isUploading.value !== !0 && m.queuedFiles.value.length !== 0);
    (0, $fVLUl.provide)($848b1ce88e755b32$var$Ml, oe);
    let x = (0, $eayOh.computed)(()=>"q-uploader column no-wrap" + (s.value === !0 ? " q-uploader--dark q-dark" : "") + (r.bordered === !0 ? " q-uploader--bordered" : "") + (r.square === !0 ? " q-uploader--square no-border-radius" : "") + (r.flat === !0 ? " q-uploader--flat no-shadow" : "") + (r.disable === !0 ? " disabled q-uploader--disable" : "") + (v.value === !0 ? " q-uploader--dnd" : "")), k = (0, $eayOh.computed)(()=>"q-uploader__header" + (r.color !== void 0 ? ` bg-${r.color}` : "") + (r.textColor !== void 0 ? ` text-${r.textColor}` : ""));
    (0, $eayOh.watch)(m.isUploading, (z, ue)=>{
        ue === !1 && z === !0 ? i("start") : ue === !0 && z === !1 && i("finish");
    });
    function j() {
        r.disable === !1 && (m.abort(), m.uploadedSize.value = 0, $.value = 0, ie(), m.files.value = [], m.queuedFiles.value = [], m.uploadedFiles.value = []);
    }
    function Q() {
        r.disable === !1 && H([
            "uploaded"
        ], ()=>{
            m.uploadedFiles.value = [];
        });
    }
    function w() {
        H([
            "idle",
            "failed"
        ], ({ size: z })=>{
            $.value -= z, m.queuedFiles.value = [];
        });
    }
    function H(z, ue) {
        if (r.disable === !0) return;
        let _e = {
            files: [],
            size: 0
        }, U = m.files.value.filter((ae)=>z.indexOf(ae.__status) === -1 ? !0 : (_e.size += ae.size, _e.files.push(ae), ae.__img !== void 0 && window.URL.revokeObjectURL(ae.__img.src), !1));
        _e.files.length !== 0 && (m.files.value = U, ue(_e), i("removed", _e.files));
    }
    function W(z) {
        r.disable || (z.__status === "uploaded" ? m.uploadedFiles.value = m.uploadedFiles.value.filter((ue)=>ue.__key !== z.__key) : z.__status === "uploading" ? z.__abort() : $.value -= z.size, m.files.value = m.files.value.filter((ue)=>ue.__key !== z.__key ? !0 : (ue.__img !== void 0 && window.URL.revokeObjectURL(ue.__img.src), !1)), m.queuedFiles.value = m.queuedFiles.value.filter((ue)=>ue.__key !== z.__key), i("removed", [
            z
        ]));
    }
    function ie() {
        m.files.value.forEach((z)=>{
            z.__img !== void 0 && window.URL.revokeObjectURL(z.__img.src);
        });
    }
    function V() {
        return d.value || f.value.getElementsByClassName("q-uploader__input")[0];
    }
    function _(z, ue) {
        let _e = h(z, ue, m.files.value, !0), U = V();
        U != null && (U.value = ""), _e !== void 0 && (_e.forEach((ae)=>{
            if (m.updateFileStatus(ae, "idle"), $.value += ae.size, r.noThumbnails !== !0 && ae.type.toUpperCase().startsWith("IMAGE")) {
                let ce = new Image;
                ce.src = window.URL.createObjectURL(ae), ae.__img = ce;
            }
        }), m.files.value = m.files.value.concat(_e), m.queuedFiles.value = m.queuedFiles.value.concat(_e), i("added", _e), r.autoUpload === !0 && m.upload());
    }
    function N() {
        q.value === !0 && m.upload();
    }
    function I(z, ue, _e) {
        if (z === !0) {
            let U = {
                type: "a",
                key: ue,
                icon: l.iconSet.uploader[ue],
                flat: !0,
                dense: !0
            }, ae;
            return ue === "add" ? (U.onClick = y, ae = oe) : U.onClick = _e, (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, U, ae);
        }
    }
    function oe() {
        return (0, $fVLUl.h)("input", {
            ref: d,
            class: "q-uploader__input overflow-hidden absolute-full",
            tabindex: -1,
            type: "file",
            title: "",
            accept: r.accept,
            multiple: r.multiple === !0 ? "multiple" : void 0,
            capture: r.capture,
            onMousedown: $848b1ce88e755b32$var$tt,
            onClick: y,
            onChange: _
        });
    }
    function T() {
        return n.header !== void 0 ? n.header(te) : [
            (0, $fVLUl.h)("div", {
                class: "q-uploader__header-content column"
            }, [
                (0, $fVLUl.h)("div", {
                    class: "flex flex-center no-wrap q-gutter-xs"
                }, [
                    I(m.queuedFiles.value.length !== 0, "removeQueue", w),
                    I(m.uploadedFiles.value.length !== 0, "removeUploaded", Q),
                    m.isUploading.value === !0 ? (0, $fVLUl.h)($848b1ce88e755b32$export$7418ab329b11fed0, {
                        class: "q-uploader__spinner"
                    }) : null,
                    (0, $fVLUl.h)("div", {
                        class: "col column justify-center"
                    }, [
                        r.label !== void 0 ? (0, $fVLUl.h)("div", {
                            class: "q-uploader__title"
                        }, [
                            r.label
                        ]) : null,
                        (0, $fVLUl.h)("div", {
                            class: "q-uploader__subtitle"
                        }, [
                            A.value + " / " + E.value
                        ])
                    ]),
                    I(B.value, "add"),
                    I(r.hideUploadBtn === !1 && q.value === !0, "upload", m.upload),
                    I(m.isUploading.value, "clear", m.abort)
                ])
            ])
        ];
    }
    function D() {
        return n.list !== void 0 ? n.list(te) : m.files.value.map((z)=>(0, $fVLUl.h)("div", {
                key: z.__key,
                class: "q-uploader__file relative-position" + (r.noThumbnails !== !0 && z.__img !== void 0 ? " q-uploader__file--img" : "") + (z.__status === "failed" ? " q-uploader__file--failed" : z.__status === "uploaded" ? " q-uploader__file--uploaded" : ""),
                style: r.noThumbnails !== !0 && z.__img !== void 0 ? {
                    backgroundImage: 'url("' + z.__img.src + '")'
                } : null
            }, [
                (0, $fVLUl.h)("div", {
                    class: "q-uploader__file-header row flex-center no-wrap"
                }, [
                    z.__status === "failed" ? (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                        class: "q-uploader__file-status",
                        name: l.iconSet.type.negative,
                        color: "negative"
                    }) : null,
                    (0, $fVLUl.h)("div", {
                        class: "q-uploader__file-header-content col"
                    }, [
                        (0, $fVLUl.h)("div", {
                            class: "q-uploader__title"
                        }, [
                            z.name
                        ]),
                        (0, $fVLUl.h)("div", {
                            class: "q-uploader__subtitle row items-center no-wrap"
                        }, [
                            z.__sizeLabel + " / " + z.__progressLabel
                        ])
                    ]),
                    z.__status === "uploading" ? (0, $fVLUl.h)($848b1ce88e755b32$export$3bbfcedf93eff7f7, {
                        value: z.__progress,
                        min: 0,
                        max: 1,
                        indeterminate: z.__progress === 0
                    }) : (0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, {
                        round: !0,
                        dense: !0,
                        flat: !0,
                        icon: l.iconSet.uploader[z.__status === "uploaded" ? "done" : "clear"],
                        onClick: ()=>{
                            W(z);
                        }
                    })
                ])
            ]));
    }
    (0, $fVLUl.onBeforeUnmount)(()=>{
        m.isUploading.value === !0 && m.abort(), m.files.value.length !== 0 && ie();
    });
    let te = {};
    for(let z in m)(0, $eayOh.isRef)(m[z]) === !0 ? $848b1ce88e755b32$var$it(te, z, ()=>m[z].value) : te[z] = m[z];
    return Object.assign(te, {
        upload: N,
        reset: j,
        removeUploadedFiles: Q,
        removeQueuedFiles: w,
        removeFile: W,
        pickFiles: y,
        addFiles: p
    }), $848b1ce88e755b32$var$Sl(te, {
        canAddFiles: ()=>B.value,
        canUpload: ()=>q.value,
        uploadSizeLabel: ()=>A.value,
        uploadProgressLabel: ()=>E.value
    }), t({
        ...m,
        upload: N,
        reset: j,
        removeUploadedFiles: Q,
        removeQueuedFiles: w,
        removeFile: W,
        pickFiles: y,
        addFiles: p,
        canAddFiles: B,
        canUpload: q,
        uploadSizeLabel: A,
        uploadProgressLabel: E
    }), ()=>{
        let z = [
            (0, $fVLUl.h)("div", {
                class: k.value
            }, T()),
            (0, $fVLUl.h)("div", {
                class: "q-uploader__list scroll"
            }, D()),
            g("uploader")
        ];
        m.isBusy.value === !0 && z.push((0, $fVLUl.h)("div", {
            class: "q-uploader__overlay absolute-full flex flex-center"
        }, [
            (0, $fVLUl.h)($848b1ce88e755b32$export$7418ab329b11fed0)
        ]));
        let ue = {
            ref: f,
            class: x.value
        };
        return B.value === !0 && Object.assign(ue, {
            onDragover: C,
            onDragleave: b
        }), (0, $fVLUl.h)("div", ue, z);
    };
}
var $848b1ce88e755b32$var$Qk = ()=>!0;
function $848b1ce88e755b32$var$ks(e) {
    let t = {};
    return e.forEach((o)=>{
        t[o] = $848b1ce88e755b32$var$Qk;
    }), t;
}
var $848b1ce88e755b32$var$jk = $848b1ce88e755b32$var$ks($848b1ce88e755b32$var$Cd), $848b1ce88e755b32$export$a45880d810098f01 = ({ name: e, props: t, emits: o, injectPlugin: r })=>$848b1ce88e755b32$var$R({
        name: e,
        props: {
            ...$848b1ce88e755b32$var$lp,
            ...t
        },
        emits: $848b1ce88e755b32$var$at(o) === !0 ? {
            ...$848b1ce88e755b32$var$jk,
            ...o
        } : [
            ...$848b1ce88e755b32$var$Cd,
            ...o
        ],
        setup (n, { expose: i }) {
            return $848b1ce88e755b32$var$up(r, i);
        }
    });
function $848b1ce88e755b32$var$jn(e) {
    return typeof e == "function" ? e : ()=>e;
}
var $848b1ce88e755b32$var$Uk = "QUploader", $848b1ce88e755b32$var$Kk = {
    url: [
        Function,
        String
    ],
    method: {
        type: [
            Function,
            String
        ],
        default: "POST"
    },
    fieldName: {
        type: [
            Function,
            String
        ],
        default: ()=>(e)=>e.name
    },
    headers: [
        Function,
        Array
    ],
    formFields: [
        Function,
        Array
    ],
    withCredentials: [
        Function,
        Boolean
    ],
    sendRaw: [
        Function,
        Boolean
    ],
    batch: [
        Function,
        Boolean
    ],
    factory: Function
}, $848b1ce88e755b32$var$Wk = [
    "factoryFailed",
    "uploaded",
    "failed",
    "uploading"
];
function $848b1ce88e755b32$var$Yk({ props: e, emit: t, helpers: o }) {
    let r = (0, $eayOh.ref)([]), n = (0, $eayOh.ref)([]), i = (0, $eayOh.ref)(0), a = (0, $eayOh.computed)(()=>({
            url: $848b1ce88e755b32$var$jn(e.url),
            method: $848b1ce88e755b32$var$jn(e.method),
            headers: $848b1ce88e755b32$var$jn(e.headers),
            formFields: $848b1ce88e755b32$var$jn(e.formFields),
            fieldName: $848b1ce88e755b32$var$jn(e.fieldName),
            withCredentials: $848b1ce88e755b32$var$jn(e.withCredentials),
            sendRaw: $848b1ce88e755b32$var$jn(e.sendRaw),
            batch: $848b1ce88e755b32$var$jn(e.batch)
        })), l = (0, $eayOh.computed)(()=>i.value > 0), s = (0, $eayOh.computed)(()=>n.value.length !== 0), c;
    function u() {
        r.value.forEach((m)=>{
            m.abort();
        }), n.value.length !== 0 && (c = !0);
    }
    function v() {
        let m = o.queuedFiles.value.slice(0);
        o.queuedFiles.value = [], a.value.batch(m) ? f(m) : m.forEach((y)=>{
            f([
                y
            ]);
        });
    }
    function f(m) {
        if (i.value++, typeof e.factory != "function") {
            d(m, {});
            return;
        }
        let y = e.factory(m);
        if (!y) t("factoryFailed", new Error("QUploader: factory() does not return properly"), m), i.value--;
        else if (typeof y.catch == "function" && typeof y.then == "function") {
            n.value.push(y);
            let p = (C)=>{
                o.isAlive() === !0 && (n.value = n.value.filter((b)=>b !== y), n.value.length === 0 && (c = !1), o.queuedFiles.value = o.queuedFiles.value.concat(m), m.forEach((b)=>{
                    o.updateFileStatus(b, "failed");
                }), t("factoryFailed", C, m), i.value--);
            };
            y.then((C)=>{
                c === !0 ? p(new Error("Aborted")) : o.isAlive() === !0 && (n.value = n.value.filter((b)=>b !== y), d(m, C));
            }).catch(p);
        } else d(m, y || {});
    }
    function d(m, y) {
        let p = new FormData, C = new XMLHttpRequest, b = (q, x)=>y[q] !== void 0 ? $848b1ce88e755b32$var$jn(y[q])(x) : a.value[q](x), h = b("url", m);
        if (!h) {
            console.error("q-uploader: invalid or no URL specified"), i.value--;
            return;
        }
        let g = b("formFields", m);
        g !== void 0 && g.forEach((q)=>{
            p.append(q.name, q.value);
        });
        let S = 0, P = 0, $ = 0, L = 0, E;
        C.upload.addEventListener("progress", (q)=>{
            if (E === !0) return;
            let x = Math.min(L, q.loaded);
            o.uploadedSize.value += x - $, $ = x;
            let k = $ - P;
            for(let j = S; k > 0 && j < m.length; j++){
                let Q = m[j];
                if (k > Q.size) k -= Q.size, S++, P += Q.size, o.updateFileStatus(Q, "uploading", Q.size);
                else {
                    o.updateFileStatus(Q, "uploading", k);
                    return;
                }
            }
        }, !1), C.onreadystatechange = ()=>{
            C.readyState < 4 || (C.status && C.status < 400 ? (o.uploadedFiles.value = o.uploadedFiles.value.concat(m), m.forEach((q)=>{
                o.updateFileStatus(q, "uploaded");
            }), t("uploaded", {
                files: m,
                xhr: C
            })) : (E = !0, o.uploadedSize.value -= $, o.queuedFiles.value = o.queuedFiles.value.concat(m), m.forEach((q)=>{
                o.updateFileStatus(q, "failed");
            }), t("failed", {
                files: m,
                xhr: C
            })), i.value--, r.value = r.value.filter((q)=>q !== C));
        }, C.open(b("method", m), h), b("withCredentials", m) === !0 && (C.withCredentials = !0);
        let A = b("headers", m);
        A !== void 0 && A.forEach((q)=>{
            C.setRequestHeader(q.name, q.value);
        });
        let B = b("sendRaw", m);
        m.forEach((q)=>{
            o.updateFileStatus(q, "uploading", 0), B !== !0 && p.append(b("fieldName", q), q, q.name), q.xhr = C, q.__abort = ()=>{
                C.abort();
            }, L += q.size;
        }), t("uploading", {
            files: m,
            xhr: C
        }), r.value.push(C), B === !0 ? C.send(new Blob(m)) : C.send(p);
    }
    return {
        isUploading: l,
        isBusy: s,
        abort: u,
        upload: v
    };
}
var $848b1ce88e755b32$var$sp = {
    name: $848b1ce88e755b32$var$Uk,
    props: $848b1ce88e755b32$var$Kk,
    emits: $848b1ce88e755b32$var$Wk,
    injectPlugin: $848b1ce88e755b32$var$Yk
};
var $848b1ce88e755b32$export$fb96d5a0acebf1f = $848b1ce88e755b32$export$a45880d810098f01($848b1ce88e755b32$var$sp);
var $848b1ce88e755b32$export$6029b08fdeeb477 = $848b1ce88e755b32$var$R({
    name: "QUploaderAddTrigger",
    setup () {
        let e = (0, $fVLUl.inject)($848b1ce88e755b32$var$Ml, $848b1ce88e755b32$var$Ye);
        return e === $848b1ce88e755b32$var$Ye && console.error("QUploaderAddTrigger needs to be child of QUploader"), e;
    }
});
var $848b1ce88e755b32$export$a88d736580abbe = $848b1ce88e755b32$var$R({
    name: "QVideo",
    props: {
        ...$848b1ce88e755b32$var$la,
        src: {
            type: String,
            required: !0
        },
        title: String,
        fetchpriority: {
            type: String,
            default: "auto"
        },
        loading: {
            type: String,
            default: "eager"
        },
        referrerpolicy: {
            type: String,
            default: "strict-origin-when-cross-origin"
        }
    },
    setup (e) {
        let t = $848b1ce88e755b32$var$ua(e), o = (0, $eayOh.computed)(()=>"q-video" + (e.ratio !== void 0 ? " q-video--responsive" : ""));
        return ()=>(0, $fVLUl.h)("div", {
                class: o.value,
                style: t.value
            }, [
                (0, $fVLUl.h)("iframe", {
                    src: e.src,
                    title: e.title,
                    fetchpriority: e.fetchpriority,
                    loading: e.loading,
                    referrerpolicy: e.referrerpolicy,
                    frameborder: "0",
                    allowfullscreen: !0
                })
            ]);
    }
});
var $848b1ce88e755b32$var$Md = {};
$848b1ce88e755b32$var$Vd($848b1ce88e755b32$var$Md, {
    ClosePopup: ()=>$848b1ce88e755b32$export$5e283f024fc297b1,
    Intersection: ()=>$848b1ce88e755b32$export$869c896bf338bf5a,
    Morph: ()=>$848b1ce88e755b32$export$24a95a7694c627b7,
    Mutation: ()=>$848b1ce88e755b32$export$17b8b19c814bcf56,
    Ripple: ()=>$848b1ce88e755b32$export$9e9146f7e027fdaa,
    Scroll: ()=>$848b1ce88e755b32$export$6ed4a4084f55ee7c,
    ScrollFire: ()=>$848b1ce88e755b32$export$b9ac1153598b004c,
    TouchHold: ()=>$848b1ce88e755b32$export$2490d726097e21c2,
    TouchPan: ()=>$848b1ce88e755b32$export$718797250d1e376,
    TouchRepeat: ()=>$848b1ce88e755b32$export$a86a7e2bfeca2b3f,
    TouchSwipe: ()=>$848b1ce88e755b32$export$945da4db66eba3a1
});
function $848b1ce88e755b32$var$vp(e) {
    if (e === !1) return 0;
    if (e === !0 || e === void 0) return 1;
    let t = parseInt(e, 10);
    return isNaN(t) ? 0 : t;
}
var $848b1ce88e755b32$export$5e283f024fc297b1 = $848b1ce88e755b32$var$Mt({
    name: "close-popup",
    beforeMount (e, { value: t }) {
        let o = {
            depth: $848b1ce88e755b32$var$vp(t),
            handler (r) {
                o.depth !== 0 && setTimeout(()=>{
                    let n = $848b1ce88e755b32$var$Nf(e);
                    n !== void 0 && $848b1ce88e755b32$var$Qf(n, r, o.depth);
                });
            },
            handlerKey (r) {
                $848b1ce88e755b32$var$wt(r, 13) === !0 && o.handler(r);
            }
        };
        e.__qclosepopup = o, e.addEventListener("click", o.handler), e.addEventListener("keyup", o.handlerKey);
    },
    updated (e, { value: t, oldValue: o }) {
        t !== o && (e.__qclosepopup.depth = $848b1ce88e755b32$var$vp(t));
    },
    beforeUnmount (e) {
        let t = e.__qclosepopup;
        e.removeEventListener("click", t.handler), e.removeEventListener("keyup", t.handlerKey), delete e.__qclosepopup;
    }
});
var $848b1ce88e755b32$var$Zk = 0, $848b1ce88e755b32$var$pl;
function $848b1ce88e755b32$var$hp(e, t) {
    $848b1ce88e755b32$var$pl === void 0 && ($848b1ce88e755b32$var$pl = document.createElement("div"), $848b1ce88e755b32$var$pl.style.cssText = "position: absolute; left: 0; top: 0", document.body.appendChild($848b1ce88e755b32$var$pl));
    let o = e.getBoundingClientRect(), r = $848b1ce88e755b32$var$pl.getBoundingClientRect(), { marginLeft: n, marginRight: i, marginTop: a, marginBottom: l } = window.getComputedStyle(e), s = parseInt(n, 10) + parseInt(i, 10), c = parseInt(a, 10) + parseInt(l, 10);
    return {
        left: o.left - r.left,
        top: o.top - r.top,
        width: o.right - o.left,
        height: o.bottom - o.top,
        widthM: o.right - o.left + (t === !0 ? 0 : s),
        heightM: o.bottom - o.top + (t === !0 ? 0 : c),
        marginH: t === !0 ? s : 0,
        marginV: t === !0 ? c : 0
    };
}
function $848b1ce88e755b32$var$qs(e) {
    return {
        width: e.scrollWidth,
        height: e.scrollHeight
    };
}
var $848b1ce88e755b32$var$pp = [
    "Top",
    "Right",
    "Bottom",
    "Left"
], $848b1ce88e755b32$var$bp = [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomRightRadius",
    "borderBottomLeftRadius"
], $848b1ce88e755b32$var$Jk = /-block|-inline|block-|inline-/, $848b1ce88e755b32$var$eq = /(-block|-inline|block-|inline-).*:/;
function $848b1ce88e755b32$var$yp(e, t) {
    let o = window.getComputedStyle(e), r = {};
    for(let n = 0; n < t.length; n++){
        let i = t[n];
        if (o[i] === "") {
            if (i === "cssText") {
                let a = o.length, l = "";
                for(let s = 0; s < a; s++)$848b1ce88e755b32$var$Jk.test(o[s]) !== !0 && (l += o[s] + ": " + o[o[s]] + "; ");
                r[i] = l;
            } else if ([
                "borderWidth",
                "borderStyle",
                "borderColor"
            ].indexOf(i) !== -1) {
                let a = i.replace("border", ""), l = "";
                for(let s = 0; s < $848b1ce88e755b32$var$pp.length; s++){
                    let c = "border" + $848b1ce88e755b32$var$pp[s] + a;
                    l += o[c] + " ";
                }
                r[i] = l;
            } else if (i === "borderRadius") {
                let a = "", l = "";
                for(let s = 0; s < $848b1ce88e755b32$var$bp.length; s++){
                    let c = o[$848b1ce88e755b32$var$bp[s]].split(" ");
                    a += c[0] + " ", l += (c[1] === void 0 ? c[0] : c[1]) + " ";
                }
                r[i] = a + "/ " + l;
            } else r[i] = o[i];
        } else i === "cssText" ? r[i] = o[i].split(";").filter((a)=>$848b1ce88e755b32$var$eq.test(a) !== !0).join(";") : r[i] = o[i];
    }
    return r;
}
var $848b1ce88e755b32$var$tq = [
    "absolute",
    "fixed",
    "relative",
    "sticky"
];
function $848b1ce88e755b32$var$Sp(e) {
    let t = e, o = 0;
    for(; t !== null && t !== document;){
        let { position: r, zIndex: n } = window.getComputedStyle(t), i = Number(n);
        i > o && (t === e || $848b1ce88e755b32$var$tq.includes(r) === !0) && (o = i), t = t.parentNode;
    }
    return o;
}
function $848b1ce88e755b32$var$oq(e) {
    return {
        from: e.from,
        to: e.to !== void 0 ? e.to : e.from
    };
}
function $848b1ce88e755b32$var$nq(e) {
    return typeof e == "number" ? e = {
        duration: e
    } : typeof e == "function" && (e = {
        onEnd: e
    }), {
        ...e,
        waitFor: e.waitFor === void 0 ? 0 : e.waitFor,
        duration: isNaN(e.duration) === !0 ? 300 : parseInt(e.duration, 10),
        easing: typeof e.easing == "string" && e.easing.length !== 0 ? e.easing : "ease-in-out",
        delay: isNaN(e.delay) === !0 ? 0 : parseInt(e.delay, 10),
        fill: typeof e.fill == "string" && e.fill.length !== 0 ? e.fill : "none",
        resize: e.resize === !0,
        useCSS: e.useCSS === !0 || e.usecss === !0,
        hideFromClone: e.hideFromClone === !0 || e.hidefromclone === !0,
        keepToClone: e.keepToClone === !0 || e.keeptoclone === !0,
        tween: e.tween === !0,
        tweenFromOpacity: isNaN(e.tweenFromOpacity) === !0 ? .6 : parseFloat(e.tweenFromOpacity),
        tweenToOpacity: isNaN(e.tweenToOpacity) === !0 ? .5 : parseFloat(e.tweenToOpacity)
    };
}
function $848b1ce88e755b32$var$xp(e) {
    let t = typeof e;
    return t === "function" ? e() : t === "string" ? document.querySelector(e) : e;
}
function $848b1ce88e755b32$var$_p(e) {
    return e && e.ownerDocument === document && e.parentNode !== null;
}
function $848b1ce88e755b32$export$2e5e8c41f5d4e7c7(e) {
    let t = ()=>!1, o = !1, r = !0, n = $848b1ce88e755b32$var$oq(e), i = $848b1ce88e755b32$var$nq(e), a = $848b1ce88e755b32$var$xp(n.from);
    if ($848b1ce88e755b32$var$_p(a) !== !0) return t;
    typeof a.qMorphCancel == "function" && a.qMorphCancel();
    let l, s, c, u, v = a.parentNode, f = a.nextElementSibling, d = $848b1ce88e755b32$var$hp(a, i.resize), { width: m, height: y } = $848b1ce88e755b32$var$qs(v), { borderWidth: p, borderStyle: C, borderColor: b, borderRadius: h, backgroundColor: g, transform: S, position: P, cssText: $ } = $848b1ce88e755b32$var$yp(a, [
        "borderWidth",
        "borderStyle",
        "borderColor",
        "borderRadius",
        "backgroundColor",
        "transform",
        "position",
        "cssText"
    ]), L = a.classList.toString(), E = a.style.cssText, A = a.cloneNode(!0), B = i.tween === !0 ? a.cloneNode(!0) : void 0;
    B !== void 0 && (B.className = B.classList.toString().split(" ").filter((x)=>/^bg-/.test(x) === !1).join(" ")), i.hideFromClone === !0 && A.classList.add("q-morph--internal"), A.setAttribute("aria-hidden", "true"), A.style.transition = "none", A.style.animation = "none", A.style.pointerEvents = "none", v.insertBefore(A, f), a.qMorphCancel = ()=>{
        o = !0, A.remove(), B !== void 0 && B.remove(), i.hideFromClone === !0 && A.classList.remove("q-morph--internal"), a.qMorphCancel = void 0;
    };
    let q = ()=>{
        let x = $848b1ce88e755b32$var$xp(n.to);
        if (o === !0 || $848b1ce88e755b32$var$_p(x) !== !0) {
            typeof a.qMorphCancel == "function" && a.qMorphCancel();
            return;
        }
        a !== x && typeof x.qMorphCancel == "function" && x.qMorphCancel(), i.keepToClone !== !0 && x.classList.add("q-morph--internal"), A.classList.add("q-morph--internal");
        let { width: k, height: j } = $848b1ce88e755b32$var$qs(v), { width: Q, height: w } = $848b1ce88e755b32$var$qs(x.parentNode);
        i.hideFromClone !== !0 && A.classList.remove("q-morph--internal"), x.qMorphCancel = ()=>{
            o = !0, A.remove(), B !== void 0 && B.remove(), i.hideFromClone === !0 && A.classList.remove("q-morph--internal"), i.keepToClone !== !0 && x.classList.remove("q-morph--internal"), a.qMorphCancel = void 0, x.qMorphCancel = void 0;
        };
        let H = ()=>{
            if (o === !0) {
                typeof x.qMorphCancel == "function" && x.qMorphCancel();
                return;
            }
            i.hideFromClone !== !0 && (A.classList.add("q-morph--internal"), A.innerHTML = "", A.style.left = 0, A.style.right = "unset", A.style.top = 0, A.style.bottom = "unset", A.style.transform = "none"), i.keepToClone !== !0 && x.classList.remove("q-morph--internal");
            let W = x.parentNode, { width: ie, height: V } = $848b1ce88e755b32$var$qs(W), _ = x.cloneNode(i.keepToClone);
            _.setAttribute("aria-hidden", "true"), i.keepToClone !== !0 && (_.style.left = 0, _.style.right = "unset", _.style.top = 0, _.style.bottom = "unset", _.style.transform = "none", _.style.pointerEvents = "none"), _.classList.add("q-morph--internal");
            let N = x === a && v === W ? A : x.nextElementSibling;
            W.insertBefore(_, N);
            let { borderWidth: I, borderStyle: oe, borderColor: T, borderRadius: D, backgroundColor: te, transform: z, position: ue, cssText: _e } = $848b1ce88e755b32$var$yp(x, [
                "borderWidth",
                "borderStyle",
                "borderColor",
                "borderRadius",
                "backgroundColor",
                "transform",
                "position",
                "cssText"
            ]), U = x.classList.toString(), ae = x.style.cssText;
            x.style.cssText = _e, x.style.transform = "none", x.style.animation = "none", x.style.transition = "none", x.className = U.split(" ").filter((ee)=>/^bg-/.test(ee) === !1).join(" ");
            let ce = $848b1ce88e755b32$var$hp(x, i.resize), be = d.left - ce.left, Me = d.top - ce.top, le = d.width / (ce.width > 0 ? ce.width : 10), Re = d.height / (ce.height > 0 ? ce.height : 100), Fe = m - k, De = y - j, ne = ie - Q, se = V - w, Y = Math.max(d.widthM, Fe), me = Math.max(d.heightM, De), Pe = Math.max(ce.widthM, ne), Ee = Math.max(ce.heightM, se), Ae = a === x && [
                "absolute",
                "fixed"
            ].includes(ue) === !1 && [
                "absolute",
                "fixed"
            ].includes(P) === !1, nt = ue === "fixed", ct = W;
            for(; nt !== !0 && ct !== document;)nt = window.getComputedStyle(ct).position === "fixed", ct = ct.parentNode;
            if (i.hideFromClone !== !0 && (A.style.display = "block", A.style.flex = "0 0 auto", A.style.opacity = 0, A.style.minWidth = "unset", A.style.maxWidth = "unset", A.style.minHeight = "unset", A.style.maxHeight = "unset", A.classList.remove("q-morph--internal")), i.keepToClone !== !0 && (_.style.display = "block", _.style.flex = "0 0 auto", _.style.opacity = 0, _.style.minWidth = "unset", _.style.maxWidth = "unset", _.style.minHeight = "unset", _.style.maxHeight = "unset"), _.classList.remove("q-morph--internal"), typeof i.classes == "string" && (x.className += " " + i.classes), typeof i.style == "string") x.style.cssText += " " + i.style;
            else if ($848b1ce88e755b32$var$at(i.style) === !0) for(let ee in i.style)x.style[ee] = i.style[ee];
            let dt = $848b1ce88e755b32$var$Sp(A), G = $848b1ce88e755b32$var$Sp(x), re = nt === !0 ? document.documentElement : {
                scrollLeft: 0,
                scrollTop: 0
            };
            x.style.position = nt === !0 ? "fixed" : "absolute", x.style.left = `${ce.left - re.scrollLeft}px`, x.style.right = "unset", x.style.top = `${ce.top - re.scrollTop}px`, x.style.margin = 0, i.resize === !0 && (x.style.minWidth = "unset", x.style.maxWidth = "unset", x.style.minHeight = "unset", x.style.maxHeight = "unset", x.style.overflow = "hidden", x.style.overflowX = "hidden", x.style.overflowY = "hidden"), document.body.appendChild(x), B !== void 0 && (B.style.cssText = $, B.style.transform = "none", B.style.animation = "none", B.style.transition = "none", B.style.position = x.style.position, B.style.left = `${d.left - re.scrollLeft}px`, B.style.right = "unset", B.style.top = `${d.top - re.scrollTop}px`, B.style.margin = 0, B.style.pointerEvents = "none", i.resize === !0 && (B.style.minWidth = "unset", B.style.maxWidth = "unset", B.style.minHeight = "unset", B.style.maxHeight = "unset", B.style.overflow = "hidden", B.style.overflowX = "hidden", B.style.overflowY = "hidden"), document.body.appendChild(B));
            let K = (ee)=>{
                a === x && r !== !0 ? (x.style.cssText = E, x.className = L) : (x.style.cssText = ae, x.className = U), _.parentNode === W && W.insertBefore(x, _), A.remove(), _.remove(), B !== void 0 && B.remove(), t = ()=>!1, a.qMorphCancel = void 0, x.qMorphCancel = void 0, typeof i.onEnd == "function" && i.onEnd(r === !0 ? "to" : "from", ee === !0);
            };
            if (i.useCSS !== !0 && typeof x.animate == "function") {
                let ee = i.resize === !0 ? {
                    transform: `translate(${be}px, ${Me}px)`,
                    width: `${Y}px`,
                    height: `${me}px`
                } : {
                    transform: `translate(${be}px, ${Me}px) scale(${le}, ${Re})`
                }, ke = i.resize === !0 ? {
                    width: `${Pe}px`,
                    height: `${Ee}px`
                } : {}, ze = i.resize === !0 ? {
                    width: `${Y}px`,
                    height: `${me}px`
                } : {}, ye = i.resize === !0 ? {
                    transform: `translate(${-1 * be}px, ${-1 * Me}px)`,
                    width: `${Pe}px`,
                    height: `${Ee}px`
                } : {
                    transform: `translate(${-1 * be}px, ${-1 * Me}px) scale(${1 / le}, ${1 / Re})`
                }, Ge = B !== void 0 ? {
                    opacity: i.tweenToOpacity
                } : {
                    backgroundColor: g
                }, mt = B !== void 0 ? {
                    opacity: 1
                } : {
                    backgroundColor: te
                };
                u = x.animate([
                    {
                        margin: 0,
                        borderWidth: p,
                        borderStyle: C,
                        borderColor: b,
                        borderRadius: h,
                        zIndex: dt,
                        transformOrigin: "0 0",
                        ...ee,
                        ...Ge
                    },
                    {
                        margin: 0,
                        borderWidth: I,
                        borderStyle: oe,
                        borderColor: T,
                        borderRadius: D,
                        zIndex: G,
                        transformOrigin: "0 0",
                        transform: z,
                        ...ke,
                        ...mt
                    }
                ], {
                    duration: i.duration,
                    easing: i.easing,
                    fill: i.fill,
                    delay: i.delay
                }), s = B === void 0 ? void 0 : B.animate([
                    {
                        opacity: i.tweenFromOpacity,
                        margin: 0,
                        borderWidth: p,
                        borderStyle: C,
                        borderColor: b,
                        borderRadius: h,
                        zIndex: dt,
                        transformOrigin: "0 0",
                        transform: S,
                        ...ze
                    },
                    {
                        opacity: 0,
                        margin: 0,
                        borderWidth: I,
                        borderStyle: oe,
                        borderColor: T,
                        borderRadius: D,
                        zIndex: G,
                        transformOrigin: "0 0",
                        ...ye
                    }
                ], {
                    duration: i.duration,
                    easing: i.easing,
                    fill: i.fill,
                    delay: i.delay
                }), l = i.hideFromClone === !0 || Ae === !0 ? void 0 : A.animate([
                    {
                        margin: `${De < 0 ? De / 2 : 0}px ${Fe < 0 ? Fe / 2 : 0}px`,
                        width: `${Y + d.marginH}px`,
                        height: `${me + d.marginV}px`
                    },
                    {
                        margin: 0,
                        width: 0,
                        height: 0
                    }
                ], {
                    duration: i.duration,
                    easing: i.easing,
                    fill: i.fill,
                    delay: i.delay
                }), c = i.keepToClone === !0 ? void 0 : _.animate([
                    Ae === !0 ? {
                        margin: `${De < 0 ? De / 2 : 0}px ${Fe < 0 ? Fe / 2 : 0}px`,
                        width: `${Y + d.marginH}px`,
                        height: `${me + d.marginV}px`
                    } : {
                        margin: 0,
                        width: 0,
                        height: 0
                    },
                    {
                        margin: `${se < 0 ? se / 2 : 0}px ${ne < 0 ? ne / 2 : 0}px`,
                        width: `${Pe + ce.marginH}px`,
                        height: `${Ee + ce.marginV}px`
                    }
                ], {
                    duration: i.duration,
                    easing: i.easing,
                    fill: i.fill,
                    delay: i.delay
                });
                let ht = (ro)=>{
                    l !== void 0 && l.cancel(), s !== void 0 && s.cancel(), c !== void 0 && c.cancel(), u.cancel(), u.removeEventListener("finish", ht), u.removeEventListener("cancel", ht), K(ro), l = void 0, s = void 0, c = void 0, u = void 0;
                };
                a.qMorphCancel = ()=>{
                    a.qMorphCancel = void 0, o = !0, ht();
                }, x.qMorphCancel = ()=>{
                    x.qMorphCancel = void 0, o = !0, ht();
                }, u.addEventListener("finish", ht), u.addEventListener("cancel", ht), t = (ro)=>o === !0 || u === void 0 ? !1 : ro === !0 ? (ht(!0), !0) : (r = r !== !0, l !== void 0 && l.reverse(), s !== void 0 && s.reverse(), c !== void 0 && c.reverse(), u.reverse(), !0);
            } else {
                let ee = `q-morph-anim-${++$848b1ce88e755b32$var$Zk}`, ke = document.createElement("style"), ze = i.resize === !0 ? `
            transform: translate(${be}px, ${Me}px);
            width: ${Y}px;
            height: ${me}px;
          ` : `transform: translate(${be}px, ${Me}px) scale(${le}, ${Re});`, ye = i.resize === !0 ? `
            width: ${Pe}px;
            height: ${Ee}px;
          ` : "", Ge = i.resize === !0 ? `
            width: ${Y}px;
            height: ${me}px;
          ` : "", mt = i.resize === !0 ? `
            transform: translate(${-1 * be}px, ${-1 * Me}px);
            width: ${Pe}px;
            height: ${Ee}px;
          ` : `transform: translate(${-1 * be}px, ${-1 * Me}px) scale(${1 / le}, ${1 / Re});`, ht = B !== void 0 ? `opacity: ${i.tweenToOpacity};` : `background-color: ${g};`, ro = B !== void 0 ? "opacity: 1;" : `background-color: ${te};`, qo = B === void 0 ? "" : `
            @keyframes ${ee}-from-tween {
              0% {
                opacity: ${i.tweenFromOpacity};
                margin: 0;
                border-width: ${p};
                border-style: ${C};
                border-color: ${b};
                border-radius: ${h};
                z-index: ${dt};
                transform-origin: 0 0;
                transform: ${S};
                ${Ge}
              }

              100% {
                opacity: 0;
                margin: 0;
                border-width: ${I};
                border-style: ${oe};
                border-color: ${T};
                border-radius: ${D};
                z-index: ${G};
                transform-origin: 0 0;
                ${mt}
              }
            }
          `, kn = i.hideFromClone === !0 || Ae === !0 ? "" : `
            @keyframes ${ee}-from {
              0% {
                margin: ${De < 0 ? De / 2 : 0}px ${Fe < 0 ? Fe / 2 : 0}px;
                width: ${Y + d.marginH}px;
                height: ${me + d.marginV}px;
              }

              100% {
                margin: 0;
                width: 0;
                height: 0;
              }
            }
          `, en = Ae === !0 ? `
            margin: ${De < 0 ? De / 2 : 0}px ${Fe < 0 ? Fe / 2 : 0}px;
            width: ${Y + d.marginH}px;
            height: ${me + d.marginV}px;
          ` : `
            margin: 0;
            width: 0;
            height: 0;
          `, Z = i.keepToClone === !0 ? "" : `
            @keyframes ${ee}-to {
              0% {
                ${en}
              }

              100% {
                margin: ${se < 0 ? se / 2 : 0}px ${ne < 0 ? ne / 2 : 0}px;
                width: ${Pe + ce.marginH}px;
                height: ${Ee + ce.marginV}px;
              }
            }
          `;
                ke.innerHTML = `
          @keyframes ${ee} {
            0% {
              margin: 0;
              border-width: ${p};
              border-style: ${C};
              border-color: ${b};
              border-radius: ${h};
              background-color: ${g};
              z-index: ${dt};
              transform-origin: 0 0;
              ${ze}
              ${ht}
            }

            100% {
              margin: 0;
              border-width: ${I};
              border-style: ${oe};
              border-color: ${T};
              border-radius: ${D};
              background-color: ${te};
              z-index: ${G};
              transform-origin: 0 0;
              transform: ${z};
              ${ye}
              ${ro}
            }
          }

          ${kn}

          ${qo}

          ${Z}
        `, document.head.appendChild(ke);
                let ve = "normal";
                A.style.animation = `${i.duration}ms ${i.easing} ${i.delay}ms ${ve} ${i.fill} ${ee}-from`, B !== void 0 && (B.style.animation = `${i.duration}ms ${i.easing} ${i.delay}ms ${ve} ${i.fill} ${ee}-from-tween`), _.style.animation = `${i.duration}ms ${i.easing} ${i.delay}ms ${ve} ${i.fill} ${ee}-to`, x.style.animation = `${i.duration}ms ${i.easing} ${i.delay}ms ${ve} ${i.fill} ${ee}`;
                let qe = (Be)=>{
                    Be === Object(Be) && Be.animationName !== ee || (x.removeEventListener("animationend", qe), x.removeEventListener("animationcancel", qe), K(), ke.remove());
                };
                a.qMorphCancel = ()=>{
                    a.qMorphCancel = void 0, o = !0, qe();
                }, x.qMorphCancel = ()=>{
                    x.qMorphCancel = void 0, o = !0, qe();
                }, x.addEventListener("animationend", qe), x.addEventListener("animationcancel", qe), t = (Be)=>o === !0 || !x || !A || !_ ? !1 : Be === !0 ? (qe(), !0) : (r = r !== !0, ve = ve === "normal" ? "reverse" : "normal", A.style.animationDirection = ve, B.style.animationDirection = ve, _.style.animationDirection = ve, x.style.animationDirection = ve, !0);
            }
        };
        i.waitFor > 0 || i.waitFor === "transitionend" || i.waitFor === Object(i.waitFor) && typeof i.waitFor.then == "function" ? (i.waitFor > 0 ? new Promise((ie)=>setTimeout(ie, i.waitFor)) : i.waitFor === "transitionend" ? new Promise((ie)=>{
            let V = ()=>{
                _ !== null && (clearTimeout(_), _ = null), x && (x.removeEventListener("transitionend", V), x.removeEventListener("transitioncancel", V)), ie();
            }, _ = setTimeout(V, 400);
            x.addEventListener("transitionend", V), x.addEventListener("transitioncancel", V);
        }) : i.waitFor).then(H).catch(()=>{
            typeof x.qMorphCancel == "function" && x.qMorphCancel();
        }) : H();
    };
    return typeof e.onToggle == "function" && e.onToggle(), requestAnimationFrame(q), (x)=>t(x);
}
var $848b1ce88e755b32$var$Ms = {}, $848b1ce88e755b32$var$rq = [
    "duration",
    "delay",
    "easing",
    "fill",
    "classes",
    "style",
    "duration",
    "resize",
    "useCSS",
    "hideFromClone",
    "keepToClone",
    "tween",
    "tweenFromOpacity",
    "tweenToOpacity",
    "waitFor",
    "onEnd"
], $848b1ce88e755b32$var$iq = [
    "resize",
    "useCSS",
    "hideFromClone",
    "keepToClone",
    "tween"
];
function $848b1ce88e755b32$var$_a(e, t) {
    e.clsAction !== t && (e.clsAction = t, e.el.classList[t]("q-morph--invisible"));
}
function $848b1ce88e755b32$var$wp(e) {
    if (e.animating === !0 || e.queue.length < 2) return;
    let [t, o] = e.queue;
    e.animating = !0, t.animating = !0, o.animating = !0, $848b1ce88e755b32$var$_a(t, "remove"), $848b1ce88e755b32$var$_a(o, "remove");
    let r = $848b1ce88e755b32$export$2e5e8c41f5d4e7c7({
        from: t.el,
        to: o.el,
        onToggle () {
            $848b1ce88e755b32$var$_a(t, "add"), $848b1ce88e755b32$var$_a(o, "remove");
        },
        ...o.opts,
        onEnd (n, i) {
            o.opts.onEnd !== void 0 && o.opts.onEnd(n, i), i !== !0 && (t.animating = !1, o.animating = !1, e.animating = !1, e.cancel = void 0, e.queue.shift(), $848b1ce88e755b32$var$wp(e));
        }
    });
    e.cancel = ()=>{
        r(!0), e.cancel = void 0;
    };
}
function $848b1ce88e755b32$var$kp(e, t) {
    let o = t.opts;
    $848b1ce88e755b32$var$iq.forEach((r)=>{
        o[r] = e[r] === !0;
    });
}
function $848b1ce88e755b32$var$aq(e, t) {
    let o = typeof e == "string" && e.length !== 0 ? e.split(":") : [];
    t.name = o[0], t.group = o[1], Object.assign(t.opts, {
        duration: isNaN(o[2]) === !0 ? 300 : parseFloat(o[2]),
        waitFor: o[3]
    });
}
function $848b1ce88e755b32$var$lq(e, t) {
    e.group !== void 0 && (t.group = e.group), e.name !== void 0 && (t.name = e.name);
    let o = t.opts;
    $848b1ce88e755b32$var$rq.forEach((r)=>{
        e[r] !== void 0 && (o[r] = e[r]);
    });
}
function $848b1ce88e755b32$var$uq(e, t) {
    if (t.name === e) {
        let o = $848b1ce88e755b32$var$Ms[t.group];
        o === void 0 ? ($848b1ce88e755b32$var$Ms[t.group] = {
            name: t.group,
            model: e,
            queue: [
                t
            ],
            animating: !1
        }, $848b1ce88e755b32$var$_a(t, "remove")) : o.model !== e && (o.model = e, o.queue.push(t), o.animating === !1 && o.queue.length === 2 && $848b1ce88e755b32$var$wp(o));
        return;
    }
    t.animating === !1 && $848b1ce88e755b32$var$_a(t, "add");
}
function $848b1ce88e755b32$var$Cp(e, t) {
    let o;
    Object(t) === t ? (o = "" + t.model, $848b1ce88e755b32$var$lq(t, e), $848b1ce88e755b32$var$kp(t, e)) : o = "" + t, o !== e.model ? (e.model = o, $848b1ce88e755b32$var$uq(o, e)) : e.animating === !1 && e.clsAction !== void 0 && e.el.classList[e.clsAction]("q-morph--invisible");
}
var $848b1ce88e755b32$export$24a95a7694c627b7 = $848b1ce88e755b32$var$Mt({
    name: "morph",
    mounted (e, t) {
        let o = {
            el: e,
            animating: !1,
            opts: {}
        };
        $848b1ce88e755b32$var$kp(t.modifiers, o), $848b1ce88e755b32$var$aq(t.arg, o), $848b1ce88e755b32$var$Cp(o, t.value), e.__qmorph = o;
    },
    updated (e, t) {
        $848b1ce88e755b32$var$Cp(e.__qmorph, t.value);
    },
    beforeUnmount (e) {
        let t = e.__qmorph, o = $848b1ce88e755b32$var$Ms[t.group];
        o !== void 0 && o.queue.indexOf(t) !== -1 && (o.queue = o.queue.filter((n)=>n !== t), o.queue.length === 0 && (o.cancel !== void 0 && o.cancel(), delete $848b1ce88e755b32$var$Ms[t.group])), t.clsAction === "add" && e.classList.remove("q-morph--invisible"), delete e.__qmorph;
    }
});
var $848b1ce88e755b32$var$sq = {
    childList: !0,
    subtree: !0,
    attributes: !0,
    characterData: !0,
    attributeOldValue: !0,
    characterDataOldValue: !0
};
function $848b1ce88e755b32$var$Tp(e, t, o) {
    t.handler = o, t.observer !== void 0 && t.observer.disconnect(), t.observer = new MutationObserver((r)=>{
        typeof t.handler == "function" && (t.handler(r) === !1 || t.once === !0) && $848b1ce88e755b32$var$Mp(e);
    }), t.observer.observe(e, t.opts);
}
function $848b1ce88e755b32$var$Mp(e) {
    let t = e.__qmutation;
    t !== void 0 && (t.observer !== void 0 && t.observer.disconnect(), delete e.__qmutation);
}
var $848b1ce88e755b32$export$17b8b19c814bcf56 = $848b1ce88e755b32$var$Mt({
    name: "mutation",
    mounted (e, { modifiers: { once: t, ...o }, value: r }) {
        let n = {
            once: t,
            opts: Object.keys(o).length === 0 ? $848b1ce88e755b32$var$sq : o
        };
        $848b1ce88e755b32$var$Tp(e, n, r), e.__qmutation = n;
    },
    updated (e, { oldValue: t, value: o }) {
        let r = e.__qmutation;
        r !== void 0 && t !== o && $848b1ce88e755b32$var$Tp(e, r, o);
    },
    beforeUnmount: $848b1ce88e755b32$var$Mp
});
var { passive: $848b1ce88e755b32$var$Rs } = $848b1ce88e755b32$var$Xe;
function $848b1ce88e755b32$var$Pp(e, { value: t, oldValue: o }) {
    if (typeof t != "function") {
        e.scrollTarget.removeEventListener("scroll", e.scroll, $848b1ce88e755b32$var$Rs);
        return;
    }
    e.handler = t, typeof o != "function" && (e.scrollTarget.addEventListener("scroll", e.scroll, $848b1ce88e755b32$var$Rs), e.scroll());
}
var $848b1ce88e755b32$export$b9ac1153598b004c = $848b1ce88e755b32$var$Mt({
    name: "scroll-fire",
    mounted (e, t) {
        let o = {
            scrollTarget: $848b1ce88e755b32$var$At(e),
            scroll: $848b1ce88e755b32$export$61fc7d43ac8f84b0(()=>{
                let r, n;
                o.scrollTarget === window ? (n = e.getBoundingClientRect().bottom, r = window.innerHeight) : (n = $848b1ce88e755b32$var$Tr(e).top + $848b1ce88e755b32$var$nn(e), r = $848b1ce88e755b32$var$Tr(o.scrollTarget).top + $848b1ce88e755b32$var$nn(o.scrollTarget)), n > 0 && n < r && (o.scrollTarget.removeEventListener("scroll", o.scroll, $848b1ce88e755b32$var$Rs), o.handler(e));
            }, 25)
        };
        $848b1ce88e755b32$var$Pp(o, t), e.__qscrollfire = o;
    },
    updated (e, t) {
        t.value !== t.oldValue && $848b1ce88e755b32$var$Pp(e.__qscrollfire, t);
    },
    beforeUnmount (e) {
        let t = e.__qscrollfire;
        t.scrollTarget.removeEventListener("scroll", t.scroll, $848b1ce88e755b32$var$Rs), t.scroll.cancel(), delete e.__qscrollfire;
    }
});
function $848b1ce88e755b32$var$$p(e, { value: t, oldValue: o }) {
    if (typeof t != "function") {
        e.scrollTarget.removeEventListener("scroll", e.scroll, $848b1ce88e755b32$var$Xe.passive);
        return;
    }
    e.handler = t, typeof o != "function" && e.scrollTarget.addEventListener("scroll", e.scroll, $848b1ce88e755b32$var$Xe.passive);
}
var $848b1ce88e755b32$export$6ed4a4084f55ee7c = $848b1ce88e755b32$var$Mt({
    name: "scroll",
    mounted (e, t) {
        let o = {
            scrollTarget: $848b1ce88e755b32$var$At(e),
            scroll () {
                o.handler($848b1ce88e755b32$var$fo(o.scrollTarget), $848b1ce88e755b32$var$er(o.scrollTarget));
            }
        };
        $848b1ce88e755b32$var$$p(o, t), e.__qscroll = o;
    },
    updated (e, t) {
        e.__qscroll !== void 0 && t.oldValue !== t.value && $848b1ce88e755b32$var$$p(e.__qscroll, t);
    },
    beforeUnmount (e) {
        let t = e.__qscroll;
        t.scrollTarget.removeEventListener("scroll", t.scroll, $848b1ce88e755b32$var$Xe.passive), delete e.__qscroll;
    }
});
var $848b1ce88e755b32$export$2490d726097e21c2 = $848b1ce88e755b32$var$Mt({
    name: "touch-hold",
    beforeMount (e, t) {
        let { modifiers: o } = t;
        if (o.mouse !== !0 && $848b1ce88e755b32$var$Ce.has.touch !== !0) return;
        let r = {
            handler: t.value,
            noop: $848b1ce88e755b32$export$8793edee2d425525,
            mouseStart (i) {
                typeof r.handler == "function" && $848b1ce88e755b32$var$Tn(i) === !0 && ($848b1ce88e755b32$var$lt(r, "temp", [
                    [
                        document,
                        "mousemove",
                        "move",
                        "passiveCapture"
                    ],
                    [
                        document,
                        "click",
                        "end",
                        "notPassiveCapture"
                    ]
                ]), r.start(i, !0));
            },
            touchStart (i) {
                if (i.target !== void 0 && typeof r.handler == "function") {
                    let a = i.target;
                    $848b1ce88e755b32$var$lt(r, "temp", [
                        [
                            a,
                            "touchmove",
                            "move",
                            "passiveCapture"
                        ],
                        [
                            a,
                            "touchcancel",
                            "end",
                            "notPassiveCapture"
                        ],
                        [
                            a,
                            "touchend",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]), r.start(i);
                }
            },
            start (i, a) {
                r.origin = $848b1ce88e755b32$var$yt(i);
                let l = Date.now();
                $848b1ce88e755b32$var$Ce.is.mobile === !0 && (document.body.classList.add("non-selectable"), $848b1ce88e755b32$var$Ut(), r.styleCleanup = (s)=>{
                    r.styleCleanup = void 0;
                    let c = ()=>{
                        document.body.classList.remove("non-selectable");
                    };
                    s === !0 ? ($848b1ce88e755b32$var$Ut(), setTimeout(c, 10)) : c();
                }), r.triggered = !1, r.sensitivity = a === !0 ? r.mouseSensitivity : r.touchSensitivity, r.timer = setTimeout(()=>{
                    r.timer = void 0, $848b1ce88e755b32$var$Ut(), r.triggered = !0, r.handler({
                        evt: i,
                        touch: a !== !0,
                        mouse: a === !0,
                        position: r.origin,
                        duration: Date.now() - l
                    });
                }, r.duration);
            },
            move (i) {
                let { top: a, left: l } = $848b1ce88e755b32$var$yt(i);
                r.timer !== void 0 && (Math.abs(l - r.origin.left) >= r.sensitivity || Math.abs(a - r.origin.top) >= r.sensitivity) && (clearTimeout(r.timer), r.timer = void 0);
            },
            end (i) {
                $848b1ce88e755b32$var$Ct(r, "temp"), r.styleCleanup !== void 0 && r.styleCleanup(r.triggered), r.triggered === !0 ? i !== void 0 && $848b1ce88e755b32$var$Se(i) : r.timer !== void 0 && (clearTimeout(r.timer), r.timer = void 0);
            }
        }, n = [
            600,
            5,
            7
        ];
        if (typeof t.arg == "string" && t.arg.length !== 0 && t.arg.split(":").forEach((i, a)=>{
            let l = parseInt(i, 10);
            l && (n[a] = l);
        }), [r.duration, r.touchSensitivity, r.mouseSensitivity] = n, e.__qtouchhold = r, o.mouse === !0) {
            let i = o.mouseCapture === !0 || o.mousecapture === !0 ? "Capture" : "";
            $848b1ce88e755b32$var$lt(r, "main", [
                [
                    e,
                    "mousedown",
                    "mouseStart",
                    `passive${i}`
                ]
            ]);
        }
        $848b1ce88e755b32$var$Ce.has.touch === !0 && $848b1ce88e755b32$var$lt(r, "main", [
            [
                e,
                "touchstart",
                "touchStart",
                `passive${o.capture === !0 ? "Capture" : ""}`
            ],
            [
                e,
                "touchend",
                "noop",
                "notPassiveCapture"
            ]
        ]);
    },
    updated (e, t) {
        let o = e.__qtouchhold;
        o !== void 0 && t.oldValue !== t.value && (typeof t.value != "function" && o.end(), o.handler = t.value);
    },
    beforeUnmount (e) {
        let t = e.__qtouchhold;
        t !== void 0 && ($848b1ce88e755b32$var$Ct(t, "main"), $848b1ce88e755b32$var$Ct(t, "temp"), t.timer !== void 0 && clearTimeout(t.timer), t.styleCleanup !== void 0 && t.styleCleanup(), delete e.__qtouchhold);
    }
});
var $848b1ce88e755b32$var$Lp = {
    esc: 27,
    tab: 9,
    enter: 13,
    space: 32,
    up: 38,
    left: 37,
    right: 39,
    down: 40,
    delete: [
        8,
        46
    ]
}, $848b1ce88e755b32$var$cq = new RegExp(`^([\\d+]+|${Object.keys($848b1ce88e755b32$var$Lp).join("|")})$`, "i");
function $848b1ce88e755b32$var$dq(e, t) {
    let { top: o, left: r } = $848b1ce88e755b32$var$yt(e);
    return Math.abs(r - t.left) >= 7 || Math.abs(o - t.top) >= 7;
}
var $848b1ce88e755b32$export$a86a7e2bfeca2b3f = $848b1ce88e755b32$var$Mt({
    name: "touch-repeat",
    beforeMount (e, { modifiers: t, value: o, arg: r }) {
        let n = Object.keys(t).reduce((s, c)=>{
            if ($848b1ce88e755b32$var$cq.test(c) === !0) {
                let u = isNaN(parseInt(c, 10)) ? $848b1ce88e755b32$var$Lp[c.toLowerCase()] : parseInt(c, 10);
                u >= 0 && s.push(u);
            }
            return s;
        }, []);
        if (t.mouse !== !0 && $848b1ce88e755b32$var$Ce.has.touch !== !0 && n.length === 0) return;
        let i = typeof r == "string" && r.length !== 0 ? r.split(":").map((s)=>parseInt(s, 10)) : [
            0,
            600,
            300
        ], a = i.length - 1, l = {
            keyboard: n,
            handler: o,
            noop: $848b1ce88e755b32$export$8793edee2d425525,
            mouseStart (s) {
                l.event === void 0 && typeof l.handler == "function" && $848b1ce88e755b32$var$Tn(s) === !0 && ($848b1ce88e755b32$var$lt(l, "temp", [
                    [
                        document,
                        "mousemove",
                        "move",
                        "passiveCapture"
                    ],
                    [
                        document,
                        "click",
                        "end",
                        "notPassiveCapture"
                    ]
                ]), l.start(s, !0));
            },
            keyboardStart (s) {
                if (typeof l.handler == "function" && $848b1ce88e755b32$var$wt(s, n) === !0) {
                    if ((i[0] === 0 || l.event !== void 0) && ($848b1ce88e755b32$var$Se(s), e.focus(), l.event !== void 0)) return;
                    $848b1ce88e755b32$var$lt(l, "temp", [
                        [
                            document,
                            "keyup",
                            "end",
                            "notPassiveCapture"
                        ],
                        [
                            document,
                            "click",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]), l.start(s, !1, !0);
                }
            },
            touchStart (s) {
                if (s.target !== void 0 && typeof l.handler == "function") {
                    let c = s.target;
                    $848b1ce88e755b32$var$lt(l, "temp", [
                        [
                            c,
                            "touchmove",
                            "move",
                            "passiveCapture"
                        ],
                        [
                            c,
                            "touchcancel",
                            "end",
                            "notPassiveCapture"
                        ],
                        [
                            c,
                            "touchend",
                            "end",
                            "notPassiveCapture"
                        ]
                    ]), l.start(s);
                }
            },
            start (s, c, u) {
                u !== !0 && (l.origin = $848b1ce88e755b32$var$yt(s));
                function v(d) {
                    l.styleCleanup = void 0, document.documentElement.style.cursor = "";
                    let m = ()=>{
                        document.body.classList.remove("non-selectable");
                    };
                    d === !0 ? ($848b1ce88e755b32$var$Ut(), setTimeout(m, 10)) : m();
                }
                $848b1ce88e755b32$var$Ce.is.mobile === !0 && (document.body.classList.add("non-selectable"), $848b1ce88e755b32$var$Ut(), l.styleCleanup = v), l.event = {
                    touch: c !== !0 && u !== !0,
                    mouse: c === !0,
                    keyboard: u === !0,
                    startTime: Date.now(),
                    repeatCount: 0
                };
                let f = ()=>{
                    if (l.timer = void 0, l.event === void 0) return;
                    l.event.repeatCount === 0 && (l.event.evt = s, u === !0 ? l.event.keyCode = s.keyCode : l.event.position = $848b1ce88e755b32$var$yt(s), $848b1ce88e755b32$var$Ce.is.mobile !== !0 && (document.documentElement.style.cursor = "pointer", document.body.classList.add("non-selectable"), $848b1ce88e755b32$var$Ut(), l.styleCleanup = v)), l.event.duration = Date.now() - l.event.startTime, l.event.repeatCount += 1, l.handler(l.event);
                    let d = a < l.event.repeatCount ? a : l.event.repeatCount;
                    l.timer = setTimeout(f, i[d]);
                };
                i[0] === 0 ? f() : l.timer = setTimeout(f, i[0]);
            },
            move (s) {
                l.event !== void 0 && l.timer !== void 0 && $848b1ce88e755b32$var$dq(s, l.origin) === !0 && (clearTimeout(l.timer), l.timer = void 0);
            },
            end (s) {
                l.event !== void 0 && (l.styleCleanup !== void 0 && l.styleCleanup(!0), s !== void 0 && l.event.repeatCount > 0 && $848b1ce88e755b32$var$Se(s), $848b1ce88e755b32$var$Ct(l, "temp"), l.timer !== void 0 && (clearTimeout(l.timer), l.timer = void 0), l.event = void 0);
            }
        };
        if (e.__qtouchrepeat = l, t.mouse === !0) {
            let s = t.mouseCapture === !0 || t.mousecapture === !0 ? "Capture" : "";
            $848b1ce88e755b32$var$lt(l, "main", [
                [
                    e,
                    "mousedown",
                    "mouseStart",
                    `passive${s}`
                ]
            ]);
        }
        if ($848b1ce88e755b32$var$Ce.has.touch === !0 && $848b1ce88e755b32$var$lt(l, "main", [
            [
                e,
                "touchstart",
                "touchStart",
                `passive${t.capture === !0 ? "Capture" : ""}`
            ],
            [
                e,
                "touchend",
                "noop",
                "passiveCapture"
            ]
        ]), n.length !== 0) {
            let s = t.keyCapture === !0 || t.keycapture === !0 ? "Capture" : "";
            $848b1ce88e755b32$var$lt(l, "main", [
                [
                    e,
                    "keydown",
                    "keyboardStart",
                    `notPassive${s}`
                ]
            ]);
        }
    },
    updated (e, { oldValue: t, value: o }) {
        let r = e.__qtouchrepeat;
        r !== void 0 && t !== o && (typeof o != "function" && r.end(), r.handler = o);
    },
    beforeUnmount (e) {
        let t = e.__qtouchrepeat;
        t !== void 0 && (t.timer !== void 0 && clearTimeout(t.timer), $848b1ce88e755b32$var$Ct(t, "main"), $848b1ce88e755b32$var$Ct(t, "temp"), t.styleCleanup !== void 0 && t.styleCleanup(), delete e.__qtouchrepeat);
    }
});
function $848b1ce88e755b32$export$57e6a6d9b8e425d7(e, t = document.body) {
    if (typeof e != "string") throw new TypeError("Expected a string as propName");
    if (!(t instanceof Element)) throw new TypeError("Expected a DOM element");
    return getComputedStyle(t).getPropertyValue(`--q-${e}`).trim() || null;
}
var $848b1ce88e755b32$var$As;
function $848b1ce88e755b32$var$fq() {
    return $848b1ce88e755b32$var$Ce.is.winphone ? "msapplication-navbutton-color" : $848b1ce88e755b32$var$Ce.is.safari ? "apple-mobile-web-app-status-bar-style" : "theme-color";
}
function $848b1ce88e755b32$var$mq(e) {
    let t = document.getElementsByTagName("META");
    for(let o in t)if (t[o].name === e) return t[o];
}
function $848b1ce88e755b32$var$vq(e) {
    $848b1ce88e755b32$var$As === void 0 && ($848b1ce88e755b32$var$As = $848b1ce88e755b32$var$fq());
    let t = $848b1ce88e755b32$var$mq($848b1ce88e755b32$var$As), o = t === void 0;
    o && (t = document.createElement("meta"), t.setAttribute("name", $848b1ce88e755b32$var$As)), t.setAttribute("content", e), o && document.head.appendChild(t);
}
var $848b1ce88e755b32$export$7e8bbd192bc25721 = {
    set: $848b1ce88e755b32$var$Ce.is.mobile === !0 && ($848b1ce88e755b32$var$Ce.is.nativeMobile === !0 || $848b1ce88e755b32$var$Ce.is.winphone === !0 || $848b1ce88e755b32$var$Ce.is.safari === !0 || $848b1ce88e755b32$var$Ce.is.webkit === !0 || $848b1ce88e755b32$var$Ce.is.vivaldi === !0) ? (e)=>{
        let t = e || $848b1ce88e755b32$export$57e6a6d9b8e425d7("primary");
        $848b1ce88e755b32$var$Ce.is.nativeMobile === !0 && window.StatusBar ? window.StatusBar.backgroundColorByHexString(t) : $848b1ce88e755b32$var$vq(t);
    } : $848b1ce88e755b32$export$8793edee2d425525,
    install ({ $q: e }) {
        e.addressbarColor = this, e.config.addressbarColor && this.set(e.config.addressbarColor);
    }
};
var $848b1ce88e755b32$var$bl = {};
function $848b1ce88e755b32$var$hq(e) {
    Object.assign($848b1ce88e755b32$var$Yt, {
        request: e,
        exit: e,
        toggle: e
    });
}
function $848b1ce88e755b32$var$Vp() {
    return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement || null;
}
function $848b1ce88e755b32$var$zp() {
    let e = $848b1ce88e755b32$var$Yt.activeEl = $848b1ce88e755b32$var$Yt.isActive === !1 ? null : $848b1ce88e755b32$var$Vp();
    $848b1ce88e755b32$var$Hf(e === null || e === document.documentElement ? document.body : e);
}
function $848b1ce88e755b32$var$pq() {
    $848b1ce88e755b32$var$Yt.isActive = $848b1ce88e755b32$var$Yt.isActive === !1, $848b1ce88e755b32$var$zp();
}
function $848b1ce88e755b32$var$Dp(e, t) {
    try {
        let o = e[t]();
        return o === void 0 ? Promise.resolve() : o;
    } catch (o) {
        return Promise.reject(o);
    }
}
var $848b1ce88e755b32$var$Yt = $848b1ce88e755b32$var$Xt({
    isActive: !1,
    activeEl: null
}, {
    isCapable: !1,
    install ({ $q: e }) {
        e.fullscreen = this;
    }
});
$848b1ce88e755b32$var$bl.request = [
    "requestFullscreen",
    "msRequestFullscreen",
    "mozRequestFullScreen",
    "webkitRequestFullscreen"
].find((e)=>document.documentElement[e] !== void 0), $848b1ce88e755b32$var$Yt.isCapable = $848b1ce88e755b32$var$bl.request !== void 0, $848b1ce88e755b32$var$Yt.isCapable === !1 ? $848b1ce88e755b32$var$hq(()=>Promise.reject("Not capable")) : (Object.assign($848b1ce88e755b32$var$Yt, {
    request (e) {
        let t = e || document.documentElement, { activeEl: o } = $848b1ce88e755b32$var$Yt;
        return t === o ? Promise.resolve() : (o !== null && t.contains(o) === !0 ? $848b1ce88e755b32$var$Yt.exit() : Promise.resolve()).finally(()=>$848b1ce88e755b32$var$Dp(t, $848b1ce88e755b32$var$bl.request));
    },
    exit () {
        return $848b1ce88e755b32$var$Yt.isActive === !0 ? $848b1ce88e755b32$var$Dp(document, $848b1ce88e755b32$var$bl.exit) : Promise.resolve();
    },
    toggle (e) {
        return $848b1ce88e755b32$var$Yt.isActive === !0 ? $848b1ce88e755b32$var$Yt.exit() : $848b1ce88e755b32$var$Yt.request(e);
    }
}), $848b1ce88e755b32$var$bl.exit = [
    "exitFullscreen",
    "msExitFullscreen",
    "mozCancelFullScreen",
    "webkitExitFullscreen"
].find((e)=>document[e]), $848b1ce88e755b32$var$Yt.isActive = !!$848b1ce88e755b32$var$Vp(), $848b1ce88e755b32$var$Yt.isActive === !0 && $848b1ce88e755b32$var$zp(), [
    "onfullscreenchange",
    "onmsfullscreenchange",
    "onwebkitfullscreenchange"
].forEach((e)=>{
    document[e] = $848b1ce88e755b32$var$pq;
}));
var $848b1ce88e755b32$export$ef7fdd8c6fbd4635 = $848b1ce88e755b32$var$Yt;
var $848b1ce88e755b32$var$Op = $848b1ce88e755b32$var$Xt({
    appVisible: !0
}, {
    install ({ $q: e }) {
        $848b1ce88e755b32$var$it(e, "appVisible", ()=>this.appVisible);
    }
});
{
    let e, t;
    if (typeof document.hidden < "u" ? (e = "hidden", t = "visibilitychange") : typeof document.msHidden < "u" ? (e = "msHidden", t = "msvisibilitychange") : typeof document.webkitHidden < "u" && (e = "webkitHidden", t = "webkitvisibilitychange"), t && typeof document[e] < "u") {
        let o = ()=>{
            $848b1ce88e755b32$var$Op.appVisible = !document[e];
        };
        document.addEventListener(t, o, !1);
    }
}var $848b1ce88e755b32$export$1aceaed33e7eed17 = $848b1ce88e755b32$var$Op;
var $848b1ce88e755b32$var$Ip = $848b1ce88e755b32$var$R({
    name: "BottomSheetComponent",
    props: {
        ...$848b1ce88e755b32$var$he,
        title: String,
        message: String,
        actions: Array,
        grid: Boolean,
        cardClass: [
            String,
            Array,
            Object
        ],
        cardStyle: [
            String,
            Array,
            Object
        ]
    },
    emits: [
        "ok",
        "hide"
    ],
    setup (e, { emit: t }) {
        let { proxy: o } = (0, $fVLUl.getCurrentInstance)(), r = $848b1ce88e755b32$var$pe(e, o.$q), n = (0, $eayOh.ref)(null);
        function i() {
            n.value.show();
        }
        function a() {
            n.value.hide();
        }
        function l(d) {
            t("ok", d), a();
        }
        function s() {
            t("hide");
        }
        function c() {
            return e.actions.map((d)=>{
                let m = d.avatar || d.img;
                return d.label === void 0 ? (0, $fVLUl.h)($848b1ce88e755b32$export$a3fe6e564278fbe9, {
                    class: "col-all",
                    dark: r.value
                }) : (0, $fVLUl.h)("div", {
                    class: [
                        "q-bottom-sheet__item q-hoverable q-focusable cursor-pointer relative-position",
                        d.class
                    ],
                    style: d.style,
                    tabindex: 0,
                    role: "listitem",
                    onClick () {
                        l(d);
                    },
                    onKeyup (y) {
                        y.keyCode === 13 && l(d);
                    }
                }, [
                    (0, $fVLUl.h)("div", {
                        class: "q-focus-helper"
                    }),
                    d.icon ? (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                        name: d.icon,
                        color: d.color
                    }) : m ? (0, $fVLUl.h)("img", {
                        class: d.avatar ? "q-bottom-sheet__avatar" : "",
                        src: m
                    }) : (0, $fVLUl.h)("div", {
                        class: "q-bottom-sheet__empty-icon"
                    }),
                    (0, $fVLUl.h)("div", d.label)
                ]);
            });
        }
        function u() {
            return e.actions.map((d)=>{
                let m = d.avatar || d.img;
                return d.label === void 0 ? (0, $fVLUl.h)($848b1ce88e755b32$export$a3fe6e564278fbe9, {
                    spaced: !0,
                    dark: r.value
                }) : (0, $fVLUl.h)($848b1ce88e755b32$export$adf75769807ad87e, {
                    class: [
                        "q-bottom-sheet__item",
                        d.classes
                    ],
                    style: d.style,
                    tabindex: 0,
                    clickable: !0,
                    dark: r.value,
                    onClick () {
                        l(d);
                    }
                }, ()=>[
                        (0, $fVLUl.h)($848b1ce88e755b32$export$9579d29612d4e773, {
                            avatar: !0
                        }, ()=>d.icon ? (0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                                name: d.icon,
                                color: d.color
                            }) : m ? (0, $fVLUl.h)("img", {
                                class: d.avatar ? "q-bottom-sheet__avatar" : "",
                                src: m
                            }) : null),
                        (0, $fVLUl.h)($848b1ce88e755b32$export$9579d29612d4e773, ()=>d.label)
                    ]);
            });
        }
        function v() {
            let d = [];
            return e.title && d.push((0, $fVLUl.h)($848b1ce88e755b32$export$653482776a1a6c98, {
                class: "q-dialog__title"
            }, ()=>e.title)), e.message && d.push((0, $fVLUl.h)($848b1ce88e755b32$export$653482776a1a6c98, {
                class: "q-dialog__message"
            }, ()=>e.message)), d.push(e.grid === !0 ? (0, $fVLUl.h)("div", {
                class: "row items-stretch justify-start",
                role: "list"
            }, c()) : (0, $fVLUl.h)("div", {
                role: "list"
            }, u())), d;
        }
        function f() {
            return [
                (0, $fVLUl.h)($848b1ce88e755b32$export$866037ffbc2a7c62, {
                    class: [
                        `q-bottom-sheet q-bottom-sheet--${e.grid === !0 ? "grid" : "list"}` + (r.value === !0 ? " q-bottom-sheet--dark q-dark" : ""),
                        e.cardClass
                    ],
                    style: e.cardStyle
                }, v)
            ];
        }
        return Object.assign(o, {
            show: i,
            hide: a
        }), ()=>(0, $fVLUl.h)($848b1ce88e755b32$export$e6ccdac5fb3e2417, {
                ref: n,
                position: "bottom",
                onHide: s
            }, f);
    }
});
function $848b1ce88e755b32$var$Hp(e, t) {
    for(let o in t)o !== "spinner" && Object(t[o]) === t[o] ? (e[o] = Object(e[o]) !== e[o] ? {} : {
        ...e[o]
    }, $848b1ce88e755b32$var$Hp(e[o], t[o])) : e[o] = t[o];
}
function $848b1ce88e755b32$var$$s(e, t, o) {
    return (r)=>{
        let n, i, a = t === !0 && r.component !== void 0;
        if (a === !0) {
            let { component: b, componentProps: h } = r;
            n = typeof b == "string" ? o.component(b) : b, i = h || {};
        } else {
            let { class: b, style: h, ...g } = r;
            n = e, i = g, b !== void 0 && (g.cardClass = b), h !== void 0 && (g.cardStyle = h);
        }
        let l, s = !1, c = (0, $eayOh.ref)(null), u = $848b1ce88e755b32$var$an(!1, "dialog"), v = (b)=>{
            if (c.value !== null && c.value[b] !== void 0) {
                c.value[b]();
                return;
            }
            let h = l.$.subTree;
            if (h && h.component) {
                if (h.component.proxy && h.component.proxy[b]) {
                    h.component.proxy[b]();
                    return;
                }
                if (h.component.subTree && h.component.subTree.component && h.component.subTree.component.proxy && h.component.subTree.component.proxy[b]) {
                    h.component.subTree.component.proxy[b]();
                    return;
                }
            }
            console.error("[Quasar] Incorrectly defined Dialog component");
        }, f = [], d = [], m = {
            onOk (b) {
                return f.push(b), m;
            },
            onCancel (b) {
                return d.push(b), m;
            },
            onDismiss (b) {
                return f.push(b), d.push(b), m;
            },
            hide () {
                return v("hide"), m;
            },
            update (b) {
                if (l !== null) {
                    if (a === !0) Object.assign(i, b);
                    else {
                        let { class: h, style: g, ...S } = b;
                        h !== void 0 && (S.cardClass = h), g !== void 0 && (S.cardStyle = g), $848b1ce88e755b32$var$Hp(i, S);
                    }
                    l.$forceUpdate();
                }
                return m;
            }
        }, y = (b)=>{
            s = !0, f.forEach((h)=>{
                h(b);
            });
        }, p = ()=>{
            C.unmount(u), $848b1ce88e755b32$var$yi(u), C = null, l = null, s !== !0 && d.forEach((b)=>{
                b();
            });
        }, C = $848b1ce88e755b32$var$Wn({
            name: "QGlobalDialog",
            setup: ()=>()=>(0, $fVLUl.h)(n, {
                        ...i,
                        ref: c,
                        onOk: y,
                        onHide: p,
                        onVnodeMounted (...b) {
                            typeof i.onVnodeMounted == "function" && i.onVnodeMounted(...b), (0, $fVLUl.nextTick)(()=>v("show"));
                        }
                    })
        }, o);
        return l = C.mount(u), m;
    };
}
var $848b1ce88e755b32$export$2058ef1a26004a97 = {
    install ({ $q: e, parentApp: t }) {
        e.bottomSheet = this.create = $848b1ce88e755b32$var$$s($848b1ce88e755b32$var$Ip, !1, t);
    }
};
function $848b1ce88e755b32$var$Np(e) {
    return encodeURIComponent(e);
}
function $848b1ce88e755b32$var$Qp(e) {
    return decodeURIComponent(e);
}
function $848b1ce88e755b32$var$qq(e) {
    return $848b1ce88e755b32$var$Np(e === Object(e) ? JSON.stringify(e) : "" + e);
}
function $848b1ce88e755b32$var$Tq(e) {
    if (e === "") return e;
    e.indexOf('"') === 0 && (e = e.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\")), e = $848b1ce88e755b32$var$Qp(e.replace(/\+/g, " "));
    try {
        let t = JSON.parse(e);
        (t === Object(t) || Array.isArray(t) === !0) && (e = t);
    } catch  {}
    return e;
}
function $848b1ce88e755b32$var$jp(e) {
    let t = new Date;
    return t.setMilliseconds(t.getMilliseconds() + e), t.toUTCString();
}
function $848b1ce88e755b32$var$Mq(e) {
    let t = 0, o = e.match(/(\d+)d/), r = e.match(/(\d+)h/), n = e.match(/(\d+)m/), i = e.match(/(\d+)s/);
    return o && (t += o[1] * 864e5), r && (t += r[1] * 36e5), n && (t += n[1] * 6e4), i && (t += i[1] * 1e3), t === 0 ? e : $848b1ce88e755b32$var$jp(t);
}
function $848b1ce88e755b32$var$Up(e, t, o = {}, r) {
    let n, i;
    o.expires !== void 0 && (Object.prototype.toString.call(o.expires) === "[object Date]" ? n = o.expires.toUTCString() : typeof o.expires == "string" ? n = $848b1ce88e755b32$var$Mq(o.expires) : (i = parseFloat(o.expires), n = isNaN(i) === !1 ? $848b1ce88e755b32$var$jp(i * 864e5) : o.expires));
    let a = `${$848b1ce88e755b32$var$Np(e)}=${$848b1ce88e755b32$var$qq(t)}`, l = [
        a,
        n !== void 0 ? "; Expires=" + n : "",
        o.path ? "; Path=" + o.path : "",
        o.domain ? "; Domain=" + o.domain : "",
        o.sameSite ? "; SameSite=" + o.sameSite : "",
        o.httpOnly ? "; HttpOnly" : "",
        o.secure ? "; Secure" : "",
        o.other ? "; " + o.other : ""
    ].join("");
    if (r) {
        r.req.qCookies ? r.req.qCookies.push(l) : r.req.qCookies = [
            l
        ], r.res.setHeader("Set-Cookie", r.req.qCookies);
        let s = r.req.headers.cookie || "";
        if (n !== void 0 && i < 0) {
            let c = $848b1ce88e755b32$var$Es(e, r);
            c !== void 0 && (s = s.replace(`${e}=${c}; `, "").replace(`; ${e}=${c}`, "").replace(`${e}=${c}`, ""));
        } else s = s ? `${a}; ${s}` : l;
        r.req.headers.cookie = s;
    } else document.cookie = l;
}
function $848b1ce88e755b32$var$Es(e, t) {
    let o = t ? t.req.headers : document, r = o.cookie ? o.cookie.split("; ") : [], n = r.length, i = e ? null : {}, a = 0, l, s, c;
    for(; a < n; a++)if (l = r[a].split("="), s = $848b1ce88e755b32$var$Qp(l.shift()), c = l.join("="), !e) i[s] = c;
    else if (e === s) {
        i = $848b1ce88e755b32$var$Tq(c);
        break;
    }
    return i;
}
function $848b1ce88e755b32$var$Rq(e, t, o) {
    $848b1ce88e755b32$var$Up(e, "", {
        expires: -1,
        ...t
    }, o);
}
function $848b1ce88e755b32$var$Pq(e, t) {
    return $848b1ce88e755b32$var$Es(e, t) !== null;
}
function $848b1ce88e755b32$var$Aq(e) {
    return {
        get: (t)=>$848b1ce88e755b32$var$Es(t, e),
        set: (t, o, r)=>$848b1ce88e755b32$var$Up(t, o, r, e),
        has: (t)=>$848b1ce88e755b32$var$Pq(t, e),
        remove: (t, o)=>$848b1ce88e755b32$var$Rq(t, o, e),
        getAll: ()=>$848b1ce88e755b32$var$Es(null, e)
    };
}
var $848b1ce88e755b32$var$Kp = {
    install ({ $q: e, ssrContext: t }) {
        e.cookies = this;
    }
};
Object.assign($848b1ce88e755b32$var$Kp, $848b1ce88e755b32$var$Aq());
var $848b1ce88e755b32$export$3a9db9793503eddb = $848b1ce88e755b32$var$Kp;
var $848b1ce88e755b32$var$Xp = $848b1ce88e755b32$var$R({
    name: "DialogPluginComponent",
    props: {
        ...$848b1ce88e755b32$var$he,
        title: String,
        message: String,
        prompt: Object,
        options: Object,
        progress: [
            Boolean,
            Object
        ],
        html: Boolean,
        ok: {
            type: [
                String,
                Object,
                Boolean
            ],
            default: !0
        },
        cancel: [
            String,
            Object,
            Boolean
        ],
        focus: {
            type: String,
            default: "ok",
            validator: (e)=>[
                    "ok",
                    "cancel",
                    "none"
                ].includes(e)
        },
        stackButtons: Boolean,
        color: String,
        cardClass: [
            String,
            Array,
            Object
        ],
        cardStyle: [
            String,
            Array,
            Object
        ]
    },
    emits: [
        "ok",
        "hide"
    ],
    setup (e, { emit: t }) {
        let { proxy: o } = (0, $fVLUl.getCurrentInstance)(), { $q: r } = o, n = $848b1ce88e755b32$var$pe(e, r), i = (0, $eayOh.ref)(null), a = (0, $eayOh.ref)(e.prompt !== void 0 ? e.prompt.model : e.options !== void 0 ? e.options.model : void 0), l = (0, $eayOh.computed)(()=>"q-dialog-plugin" + (n.value === !0 ? " q-dialog-plugin--dark q-dark" : "") + (e.progress !== !1 ? " q-dialog-plugin--progress" : "")), s = (0, $eayOh.computed)(()=>e.color || (n.value === !0 ? "amber" : "primary")), c = (0, $eayOh.computed)(()=>e.progress === !1 ? null : $848b1ce88e755b32$var$at(e.progress) === !0 ? {
                component: e.progress.spinner || $848b1ce88e755b32$export$7418ab329b11fed0,
                props: {
                    color: e.progress.color || s.value
                }
            } : {
                component: $848b1ce88e755b32$export$7418ab329b11fed0,
                props: {
                    color: s.value
                }
            }), u = (0, $eayOh.computed)(()=>e.prompt !== void 0 || e.options !== void 0), v = (0, $eayOh.computed)(()=>{
            if (u.value !== !0) return {};
            let { model: k, isValid: j, items: Q, ...w } = e.prompt !== void 0 ? e.prompt : e.options;
            return w;
        }), f = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$at(e.ok) === !0 || e.ok === !0 ? r.lang.label.ok : e.ok), d = (0, $eayOh.computed)(()=>$848b1ce88e755b32$var$at(e.cancel) === !0 || e.cancel === !0 ? r.lang.label.cancel : e.cancel), m = (0, $eayOh.computed)(()=>e.prompt !== void 0 ? e.prompt.isValid !== void 0 && e.prompt.isValid(a.value) !== !0 : e.options !== void 0 ? e.options.isValid !== void 0 && e.options.isValid(a.value) !== !0 : !1), y = (0, $eayOh.computed)(()=>({
                color: s.value,
                label: f.value,
                ripple: !1,
                disable: m.value,
                ...$848b1ce88e755b32$var$at(e.ok) === !0 ? e.ok : {
                    flat: !0
                },
                "data-autofocus": e.focus === "ok" && u.value !== !0 || void 0,
                onClick: h
            })), p = (0, $eayOh.computed)(()=>({
                color: s.value,
                label: d.value,
                ripple: !1,
                ...$848b1ce88e755b32$var$at(e.cancel) === !0 ? e.cancel : {
                    flat: !0
                },
                "data-autofocus": e.focus === "cancel" && u.value !== !0 || void 0,
                onClick: g
            }));
        (0, $eayOh.watch)(()=>e.prompt && e.prompt.model, P), (0, $eayOh.watch)(()=>e.options && e.options.model, P);
        function C() {
            i.value.show();
        }
        function b() {
            i.value.hide();
        }
        function h() {
            t("ok", (0, $eayOh.toRaw)(a.value)), b();
        }
        function g() {
            b();
        }
        function S() {
            t("hide");
        }
        function P(k) {
            a.value = k;
        }
        function $(k) {
            m.value !== !0 && e.prompt.type !== "textarea" && $848b1ce88e755b32$var$wt(k, 13) === !0 && h();
        }
        function L(k, j) {
            return e.html === !0 ? (0, $fVLUl.h)($848b1ce88e755b32$export$653482776a1a6c98, {
                class: k,
                innerHTML: j
            }) : (0, $fVLUl.h)($848b1ce88e755b32$export$653482776a1a6c98, {
                class: k
            }, ()=>j);
        }
        function E() {
            return [
                (0, $fVLUl.h)($848b1ce88e755b32$export$b1c6a0c22e16b328, {
                    color: s.value,
                    dense: !0,
                    autofocus: !0,
                    dark: n.value,
                    ...v.value,
                    modelValue: a.value,
                    "onUpdate:modelValue": P,
                    onKeyup: $
                })
            ];
        }
        function A() {
            return [
                (0, $fVLUl.h)($848b1ce88e755b32$export$3ceb287b9597da0e, {
                    color: s.value,
                    options: e.options.items,
                    dark: n.value,
                    ...v.value,
                    modelValue: a.value,
                    "onUpdate:modelValue": P
                })
            ];
        }
        function B() {
            let k = [];
            return e.cancel && k.push((0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, p.value)), e.ok && k.push((0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, y.value)), (0, $fVLUl.h)($848b1ce88e755b32$export$8c05ea70037eac6a, {
                class: e.stackButtons === !0 ? "items-end" : "",
                vertical: e.stackButtons,
                align: "right"
            }, ()=>k);
        }
        function q() {
            let k = [];
            return e.title && k.push(L("q-dialog__title", e.title)), e.progress !== !1 && k.push((0, $fVLUl.h)($848b1ce88e755b32$export$653482776a1a6c98, {
                class: "q-dialog__progress"
            }, ()=>(0, $fVLUl.h)(c.value.component, c.value.props))), e.message && k.push(L("q-dialog__message", e.message)), e.prompt !== void 0 ? k.push((0, $fVLUl.h)($848b1ce88e755b32$export$653482776a1a6c98, {
                class: "scroll q-dialog-plugin__form"
            }, E)) : e.options !== void 0 && k.push((0, $fVLUl.h)($848b1ce88e755b32$export$a3fe6e564278fbe9, {
                dark: n.value
            }), (0, $fVLUl.h)($848b1ce88e755b32$export$653482776a1a6c98, {
                class: "scroll q-dialog-plugin__form"
            }, A), (0, $fVLUl.h)($848b1ce88e755b32$export$a3fe6e564278fbe9, {
                dark: n.value
            })), (e.ok || e.cancel) && k.push(B()), k;
        }
        function x() {
            return [
                (0, $fVLUl.h)($848b1ce88e755b32$export$866037ffbc2a7c62, {
                    class: [
                        l.value,
                        e.cardClass
                    ],
                    style: e.cardStyle,
                    dark: n.value
                }, q)
            ];
        }
        return Object.assign(o, {
            show: C,
            hide: b
        }), ()=>(0, $fVLUl.h)($848b1ce88e755b32$export$e6ccdac5fb3e2417, {
                ref: i,
                onHide: S
            }, x);
    }
});
var $848b1ce88e755b32$export$3ddf2d174ce01153 = {
    install ({ $q: e, parentApp: t }) {
        e.dialog = this.create = $848b1ce88e755b32$var$$s($848b1ce88e755b32$var$Xp, !0, t);
    }
};
var $848b1ce88e755b32$var$wa, $848b1ce88e755b32$var$Rd, $848b1ce88e755b32$var$Gp = 0, $848b1ce88e755b32$var$ei = null, $848b1ce88e755b32$var$Qt = {}, $848b1ce88e755b32$var$ti = {}, $848b1ce88e755b32$var$Zp = {
    group: "__default_quasar_group__",
    delay: 0,
    message: !1,
    html: !1,
    spinnerSize: 80,
    spinnerColor: "",
    messageColor: "",
    backgroundColor: "",
    boxClass: "",
    spinner: $848b1ce88e755b32$export$7418ab329b11fed0,
    customClass: ""
}, $848b1ce88e755b32$var$Jp = {
    ...$848b1ce88e755b32$var$Zp
};
function $848b1ce88e755b32$var$Vq(e) {
    if (e && e.group !== void 0 && $848b1ce88e755b32$var$ti[e.group] !== void 0) return Object.assign($848b1ce88e755b32$var$ti[e.group], e);
    let t = $848b1ce88e755b32$var$at(e) === !0 && e.ignoreDefaults === !0 ? {
        ...$848b1ce88e755b32$var$Zp,
        ...e
    } : {
        ...$848b1ce88e755b32$var$Jp,
        ...e
    };
    return $848b1ce88e755b32$var$ti[t.group] = t, t;
}
var $848b1ce88e755b32$var$Go = $848b1ce88e755b32$var$Xt({
    isActive: !1
}, {
    show (e) {
        $848b1ce88e755b32$var$Qt = $848b1ce88e755b32$var$Vq(e);
        let { group: t } = $848b1ce88e755b32$var$Qt;
        return $848b1ce88e755b32$var$Go.isActive = !0, $848b1ce88e755b32$var$wa !== void 0 ? ($848b1ce88e755b32$var$Qt.uid = $848b1ce88e755b32$var$Gp, $848b1ce88e755b32$var$Rd.$forceUpdate()) : ($848b1ce88e755b32$var$Qt.uid = ++$848b1ce88e755b32$var$Gp, $848b1ce88e755b32$var$ei !== null && clearTimeout($848b1ce88e755b32$var$ei), $848b1ce88e755b32$var$ei = setTimeout(()=>{
            $848b1ce88e755b32$var$ei = null;
            let o = $848b1ce88e755b32$var$an("q-loading");
            $848b1ce88e755b32$var$wa = $848b1ce88e755b32$var$Wn({
                name: "QLoading",
                setup () {
                    (0, $fVLUl.onMounted)(()=>{
                        $848b1ce88e755b32$var$Za(!0);
                    });
                    function r() {
                        $848b1ce88e755b32$var$Go.isActive !== !0 && $848b1ce88e755b32$var$wa !== void 0 && ($848b1ce88e755b32$var$Za(!1), $848b1ce88e755b32$var$wa.unmount(o), $848b1ce88e755b32$var$yi(o), $848b1ce88e755b32$var$wa = void 0, $848b1ce88e755b32$var$Rd = void 0);
                    }
                    function n() {
                        if ($848b1ce88e755b32$var$Go.isActive !== !0) return null;
                        let i = [
                            (0, $fVLUl.h)($848b1ce88e755b32$var$Qt.spinner, {
                                class: "q-loading__spinner",
                                color: $848b1ce88e755b32$var$Qt.spinnerColor,
                                size: $848b1ce88e755b32$var$Qt.spinnerSize
                            })
                        ];
                        return $848b1ce88e755b32$var$Qt.message && i.push((0, $fVLUl.h)("div", {
                            class: "q-loading__message" + ($848b1ce88e755b32$var$Qt.messageColor ? ` text-${$848b1ce88e755b32$var$Qt.messageColor}` : ""),
                            [$848b1ce88e755b32$var$Qt.html === !0 ? "innerHTML" : "textContent"]: $848b1ce88e755b32$var$Qt.message
                        })), (0, $fVLUl.h)("div", {
                            class: "q-loading fullscreen flex flex-center z-max " + $848b1ce88e755b32$var$Qt.customClass.trim(),
                            key: $848b1ce88e755b32$var$Qt.uid
                        }, [
                            (0, $fVLUl.h)("div", {
                                class: "q-loading__backdrop" + ($848b1ce88e755b32$var$Qt.backgroundColor ? ` bg-${$848b1ce88e755b32$var$Qt.backgroundColor}` : "")
                            }),
                            (0, $fVLUl.h)("div", {
                                class: "q-loading__box column items-center " + $848b1ce88e755b32$var$Qt.boxClass
                            }, i)
                        ]);
                    }
                    return ()=>(0, $fVLUl.h)((0, $24349.Transition), {
                            name: "q-transition--fade",
                            appear: !0,
                            onAfterLeave: r
                        }, n);
                }
            }, $848b1ce88e755b32$var$Go.__parentApp), $848b1ce88e755b32$var$Rd = $848b1ce88e755b32$var$wa.mount(o);
        }, $848b1ce88e755b32$var$Qt.delay)), (o)=>{
            if (o === void 0 || Object(o) !== o) {
                $848b1ce88e755b32$var$Go.hide(t);
                return;
            }
            $848b1ce88e755b32$var$Go.show({
                ...o,
                group: t
            });
        };
    },
    hide (e) {
        if ($848b1ce88e755b32$var$Go.isActive === !0) {
            if (e === void 0) $848b1ce88e755b32$var$ti = {};
            else {
                if ($848b1ce88e755b32$var$ti[e] === void 0) return;
                {
                    delete $848b1ce88e755b32$var$ti[e];
                    let t = Object.keys($848b1ce88e755b32$var$ti);
                    if (t.length !== 0) {
                        let o = t[t.length - 1];
                        $848b1ce88e755b32$var$Go.show({
                            group: o
                        });
                        return;
                    }
                }
            }
            $848b1ce88e755b32$var$ei !== null && (clearTimeout($848b1ce88e755b32$var$ei), $848b1ce88e755b32$var$ei = null), $848b1ce88e755b32$var$Go.isActive = !1;
        }
    },
    setDefaults (e) {
        $848b1ce88e755b32$var$at(e) === !0 && Object.assign($848b1ce88e755b32$var$Jp, e);
    },
    install ({ $q: e, parentApp: t }) {
        e.loading = this, $848b1ce88e755b32$var$Go.__parentApp = t, e.config.loading !== void 0 && this.setDefaults(e.config.loading);
    }
}), $848b1ce88e755b32$export$669f6ea7d267feaf = $848b1ce88e755b32$var$Go;
var $848b1ce88e755b32$var$Bs = (0, $eayOh.ref)(null), $848b1ce88e755b32$var$Pd = $848b1ce88e755b32$var$Xt({
    isActive: !1
}, {
    start: $848b1ce88e755b32$export$8793edee2d425525,
    stop: $848b1ce88e755b32$export$8793edee2d425525,
    increment: $848b1ce88e755b32$export$8793edee2d425525,
    setDefaults: $848b1ce88e755b32$export$8793edee2d425525,
    install ({ $q: e, parentApp: t }) {
        if (e.loadingBar = this, this.__installed === !0) {
            e.config.loadingBar !== void 0 && this.setDefaults(e.config.loadingBar);
            return;
        }
        let o = (0, $eayOh.ref)(e.config.loadingBar !== void 0 ? {
            ...e.config.loadingBar
        } : {});
        function r() {
            $848b1ce88e755b32$var$Pd.isActive = !0;
        }
        function n() {
            $848b1ce88e755b32$var$Pd.isActive = !1;
        }
        let i = $848b1ce88e755b32$var$an("q-loading-bar");
        $848b1ce88e755b32$var$Wn({
            name: "LoadingBar",
            devtools: {
                hide: !0
            },
            setup: ()=>()=>(0, $fVLUl.h)($848b1ce88e755b32$export$b18d87171d171ca9, {
                        ...o.value,
                        onStart: r,
                        onStop: n,
                        ref: $848b1ce88e755b32$var$Bs
                    })
        }, t).mount(i), Object.assign(this, {
            start (a) {
                $848b1ce88e755b32$var$Bs.value.start(a);
            },
            stop () {
                $848b1ce88e755b32$var$Bs.value.stop();
            },
            increment () {
                $848b1ce88e755b32$var$Bs.value.increment.apply(null, arguments);
            },
            setDefaults (a) {
                $848b1ce88e755b32$var$at(a) === !0 && Object.assign(o.value, a);
            }
        });
    }
}), $848b1ce88e755b32$export$6665614bc5d690f6 = $848b1ce88e755b32$var$Pd;
var $848b1ce88e755b32$var$Ls = null, $848b1ce88e755b32$var$Ad, $848b1ce88e755b32$var$Zo = [];
function $848b1ce88e755b32$var$Hq(e) {
    e.title && (e.title = e.titleTemplate ? e.titleTemplate(e.title) : e.title, delete e.titleTemplate), [
        [
            "meta",
            "content"
        ],
        [
            "link",
            "href"
        ]
    ].forEach((t)=>{
        let o = e[t[0]], r = t[1];
        for(let n in o){
            let i = o[n];
            i.template && (Object.keys(i).length === 1 ? delete o[n] : (i[r] = i.template(i[r] || ""), delete i.template));
        }
    });
}
function $848b1ce88e755b32$var$Nq(e, t) {
    if (Object.keys(e).length !== Object.keys(t).length) return !0;
    for(let o in e)if (e[o] !== t[o]) return !0;
}
function $848b1ce88e755b32$var$t0(e) {
    return [
        "class",
        "style"
    ].includes(e) === !1;
}
function $848b1ce88e755b32$var$o0(e) {
    return [
        "lang",
        "dir"
    ].includes(e) === !1;
}
function $848b1ce88e755b32$var$Qq(e, t) {
    let o = {}, r = {};
    return e === void 0 ? {
        add: t,
        remove: r
    } : (e.title !== t.title && (o.title = t.title), [
        "meta",
        "link",
        "script",
        "htmlAttr",
        "bodyAttr"
    ].forEach((n)=>{
        let i = e[n], a = t[n];
        if (r[n] = [], i == null) {
            o[n] = a;
            return;
        }
        o[n] = {};
        for(let l in i)a.hasOwnProperty(l) === !1 && r[n].push(l);
        for(let l in a)i.hasOwnProperty(l) === !1 ? o[n][l] = a[l] : $848b1ce88e755b32$var$Nq(i[l], a[l]) === !0 && (r[n].push(l), o[n][l] = a[l]);
    }), {
        add: o,
        remove: r
    });
}
function $848b1ce88e755b32$var$jq({ add: e, remove: t }) {
    e.title && (document.title = e.title), Object.keys(t).length !== 0 && ([
        "meta",
        "link",
        "script"
    ].forEach((o)=>{
        t[o].forEach((r)=>{
            document.head.querySelector(`${o}[data-qmeta="${r}"]`).remove();
        });
    }), t.htmlAttr.filter($848b1ce88e755b32$var$o0).forEach((o)=>{
        document.documentElement.removeAttribute(o);
    }), t.bodyAttr.filter($848b1ce88e755b32$var$t0).forEach((o)=>{
        document.body.removeAttribute(o);
    })), [
        "meta",
        "link",
        "script"
    ].forEach((o)=>{
        let r = e[o];
        for(let n in r){
            let i = document.createElement(o);
            for(let a in r[n])a !== "innerHTML" && i.setAttribute(a, r[n][a]);
            i.setAttribute("data-qmeta", n), o === "script" && (i.innerHTML = r[n].innerHTML || ""), document.head.appendChild(i);
        }
    }), Object.keys(e.htmlAttr).filter($848b1ce88e755b32$var$o0).forEach((o)=>{
        document.documentElement.setAttribute(o, e.htmlAttr[o] || "");
    }), Object.keys(e.bodyAttr).filter($848b1ce88e755b32$var$t0).forEach((o)=>{
        document.body.setAttribute(o, e.bodyAttr[o] || "");
    });
}
function $848b1ce88e755b32$var$Uq() {
    $848b1ce88e755b32$var$Ls = null;
    let e = {
        title: "",
        titleTemplate: null,
        meta: {},
        link: {},
        script: {},
        htmlAttr: {},
        bodyAttr: {}
    };
    for(let t = 0; t < $848b1ce88e755b32$var$Zo.length; t++){
        let { active: o, val: r } = $848b1ce88e755b32$var$Zo[t];
        o === !0 && $848b1ce88e755b32$export$8b58be045bf06082(!0, e, r);
    }
    $848b1ce88e755b32$var$Hq(e), $848b1ce88e755b32$var$jq($848b1ce88e755b32$var$Qq($848b1ce88e755b32$var$Ad, e)), $848b1ce88e755b32$var$Ad = e;
}
function $848b1ce88e755b32$var$ko() {
    $848b1ce88e755b32$var$Ls !== null && clearTimeout($848b1ce88e755b32$var$Ls), $848b1ce88e755b32$var$Ls = setTimeout($848b1ce88e755b32$var$Uq, 50);
}
var $848b1ce88e755b32$export$b08a9033b36413fb = {
    install (e) {
        this.__installed !== !0 && $848b1ce88e755b32$var$bt.value === !0 && ($848b1ce88e755b32$var$Ad = window.__Q_META__, document.getElementById("qmeta-init").remove());
    }
};
var $848b1ce88e755b32$var$Gq = 0, $848b1ce88e755b32$var$Fs = {}, $848b1ce88e755b32$var$Ds = {}, $848b1ce88e755b32$var$Jo = {}, $848b1ce88e755b32$var$r0 = {}, $848b1ce88e755b32$var$Zq = /^\s*$/, $848b1ce88e755b32$var$i0 = [], $848b1ce88e755b32$var$Jq = [
    void 0,
    null,
    !0,
    !1,
    ""
], $848b1ce88e755b32$var$$d = [
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right",
    "top",
    "bottom",
    "left",
    "right",
    "center"
], $848b1ce88e755b32$var$eT = [
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right"
], $848b1ce88e755b32$var$ka = {
    positive: {
        icon: (e)=>e.iconSet.type.positive,
        color: "positive"
    },
    negative: {
        icon: (e)=>e.iconSet.type.negative,
        color: "negative"
    },
    warning: {
        icon: (e)=>e.iconSet.type.warning,
        color: "warning",
        textColor: "dark"
    },
    info: {
        icon: (e)=>e.iconSet.type.info,
        color: "info"
    },
    ongoing: {
        group: !1,
        timeout: 0,
        spinner: !0,
        color: "grey-8"
    }
};
function $848b1ce88e755b32$var$a0(e, t, o) {
    if (!e) return $848b1ce88e755b32$var$yl("parameter required");
    let r, n = {
        textColor: "white"
    };
    if (e.ignoreDefaults !== !0 && Object.assign(n, $848b1ce88e755b32$var$Fs), $848b1ce88e755b32$var$at(e) === !1 && (n.type && Object.assign(n, $848b1ce88e755b32$var$ka[n.type]), e = {
        message: e
    }), Object.assign(n, $848b1ce88e755b32$var$ka[e.type || n.type], e), typeof n.icon == "function" && (n.icon = n.icon(t)), n.spinner ? (n.spinner === !0 && (n.spinner = $848b1ce88e755b32$export$7418ab329b11fed0), n.spinner = (0, $eayOh.markRaw)(n.spinner)) : n.spinner = !1, n.meta = {
        hasMedia: !!(n.spinner !== !1 || n.icon || n.avatar),
        hasText: $848b1ce88e755b32$var$n0(n.message) || $848b1ce88e755b32$var$n0(n.caption)
    }, n.position) {
        if ($848b1ce88e755b32$var$$d.includes(n.position) === !1) return $848b1ce88e755b32$var$yl("wrong position", e);
    } else n.position = "bottom";
    if ($848b1ce88e755b32$var$Jq.includes(n.timeout) === !0) n.timeout = 5e3;
    else {
        let s = Number(n.timeout);
        if (isNaN(s) || s < 0) return $848b1ce88e755b32$var$yl("wrong timeout", e);
        n.timeout = Number.isFinite(s) ? s : 0;
    }
    n.timeout === 0 ? n.progress = !1 : n.progress === !0 && (n.meta.progressClass = "q-notification__progress" + (n.progressClass ? ` ${n.progressClass}` : ""), n.meta.progressStyle = {
        animationDuration: `${n.timeout + 1e3}ms`
    });
    let i = (Array.isArray(e.actions) === !0 ? e.actions : []).concat(e.ignoreDefaults !== !0 && Array.isArray($848b1ce88e755b32$var$Fs.actions) === !0 ? $848b1ce88e755b32$var$Fs.actions : []).concat($848b1ce88e755b32$var$ka[e.type] !== void 0 && Array.isArray($848b1ce88e755b32$var$ka[e.type].actions) === !0 ? $848b1ce88e755b32$var$ka[e.type].actions : []), { closeBtn: a } = n;
    if (a && i.push({
        label: typeof a == "string" ? a : t.lang.label.close
    }), n.actions = i.map(({ handler: s, noDismiss: c, ...u })=>({
            flat: !0,
            ...u,
            onClick: typeof s == "function" ? ()=>{
                s(), c !== !0 && l();
            } : ()=>{
                l();
            }
        })), n.multiLine === void 0 && (n.multiLine = n.actions.length > 1), Object.assign(n.meta, {
        class: `q-notification row items-stretch q-notification--${n.multiLine === !0 ? "multi-line" : "standard"}` + (n.color !== void 0 ? ` bg-${n.color}` : "") + (n.textColor !== void 0 ? ` text-${n.textColor}` : "") + (n.classes !== void 0 ? ` ${n.classes}` : ""),
        wrapperClass: "q-notification__wrapper col relative-position border-radius-inherit " + (n.multiLine === !0 ? "column no-wrap justify-center" : "row items-center"),
        contentClass: "q-notification__content row items-center" + (n.multiLine === !0 ? "" : " col"),
        leftClass: n.meta.hasText === !0 ? "additional" : "single",
        attrs: {
            role: "alert",
            ...n.attrs
        }
    }), n.group === !1 ? (n.group = void 0, n.meta.group = void 0) : ((n.group === void 0 || n.group === !0) && (n.group = [
        n.message,
        n.caption,
        n.multiline
    ].concat(n.actions.map((s)=>`${s.label}*${s.icon}`)).join("|")), n.meta.group = n.group + "|" + n.position), n.actions.length === 0 ? n.actions = void 0 : n.meta.actionsClass = "q-notification__actions row items-center " + (n.multiLine === !0 ? "justify-end" : "col-auto") + (n.meta.hasMedia === !0 ? " q-notification__actions--with-media" : ""), o !== void 0) {
        o.notif.meta.timer && (clearTimeout(o.notif.meta.timer), o.notif.meta.timer = void 0), n.meta.uid = o.notif.meta.uid;
        let s = $848b1ce88e755b32$var$Jo[n.position].value.indexOf(o.notif);
        $848b1ce88e755b32$var$Jo[n.position].value[s] = n;
    } else {
        let s = $848b1ce88e755b32$var$Ds[n.meta.group];
        if (s === void 0) {
            if (n.meta.uid = $848b1ce88e755b32$var$Gq++, n.meta.badge = 1, [
                "left",
                "right",
                "center"
            ].indexOf(n.position) !== -1) $848b1ce88e755b32$var$Jo[n.position].value.splice(Math.floor($848b1ce88e755b32$var$Jo[n.position].value.length / 2), 0, n);
            else {
                let c = n.position.indexOf("top") !== -1 ? "unshift" : "push";
                $848b1ce88e755b32$var$Jo[n.position].value[c](n);
            }
            n.group !== void 0 && ($848b1ce88e755b32$var$Ds[n.meta.group] = n);
        } else {
            if (s.meta.timer && (clearTimeout(s.meta.timer), s.meta.timer = void 0), n.badgePosition !== void 0) {
                if ($848b1ce88e755b32$var$eT.includes(n.badgePosition) === !1) return $848b1ce88e755b32$var$yl("wrong badgePosition", e);
            } else n.badgePosition = `top-${n.position.indexOf("left") !== -1 ? "right" : "left"}`;
            n.meta.uid = s.meta.uid, n.meta.badge = s.meta.badge + 1, n.meta.badgeClass = `q-notification__badge q-notification__badge--${n.badgePosition}` + (n.badgeColor !== void 0 ? ` bg-${n.badgeColor}` : "") + (n.badgeTextColor !== void 0 ? ` text-${n.badgeTextColor}` : "") + (n.badgeClass ? ` ${n.badgeClass}` : "");
            let c = $848b1ce88e755b32$var$Jo[n.position].value.indexOf(s);
            $848b1ce88e755b32$var$Jo[n.position].value[c] = $848b1ce88e755b32$var$Ds[n.meta.group] = n;
        }
    }
    let l = ()=>{
        $848b1ce88e755b32$var$tT(n), r = void 0;
    };
    if (n.timeout > 0 && (n.meta.timer = setTimeout(()=>{
        n.meta.timer = void 0, l();
    }, n.timeout + 1e3)), n.group !== void 0) return (s)=>{
        s !== void 0 ? $848b1ce88e755b32$var$yl("trying to update a grouped one which is forbidden", e) : l();
    };
    if (r = {
        dismiss: l,
        config: e,
        notif: n
    }, o !== void 0) {
        Object.assign(o, r);
        return;
    }
    return (s)=>{
        if (r !== void 0) {
            if (s === void 0) r.dismiss();
            else {
                let c = Object.assign({}, r.config, s, {
                    group: !1,
                    position: n.position
                });
                $848b1ce88e755b32$var$a0(c, t, r);
            }
        }
    };
}
function $848b1ce88e755b32$var$tT(e) {
    e.meta.timer && (clearTimeout(e.meta.timer), e.meta.timer = void 0);
    let t = $848b1ce88e755b32$var$Jo[e.position].value.indexOf(e);
    if (t !== -1) {
        e.group !== void 0 && delete $848b1ce88e755b32$var$Ds[e.meta.group];
        let o = $848b1ce88e755b32$var$i0["" + e.meta.uid];
        if (o) {
            let { width: r, height: n } = getComputedStyle(o);
            o.style.left = `${o.offsetLeft}px`, o.style.width = r, o.style.height = n;
        }
        $848b1ce88e755b32$var$Jo[e.position].value.splice(t, 1), typeof e.onDismiss == "function" && e.onDismiss();
    }
}
function $848b1ce88e755b32$var$n0(e) {
    return e != null && $848b1ce88e755b32$var$Zq.test(e) !== !0;
}
function $848b1ce88e755b32$var$yl(e, t) {
    return console.error(`Notify: ${e}`, t), !1;
}
function $848b1ce88e755b32$var$oT() {
    return $848b1ce88e755b32$var$R({
        name: "QNotifications",
        devtools: {
            hide: !0
        },
        setup () {
            return ()=>(0, $fVLUl.h)("div", {
                    class: "q-notifications"
                }, $848b1ce88e755b32$var$$d.map((e)=>(0, $fVLUl.h)((0, $24349.TransitionGroup), {
                        key: e,
                        class: $848b1ce88e755b32$var$r0[e],
                        tag: "div",
                        name: `q-notification--${e}`
                    }, ()=>$848b1ce88e755b32$var$Jo[e].value.map((t)=>{
                            let o = t.meta, r = [];
                            if (o.hasMedia === !0 && (t.spinner !== !1 ? r.push((0, $fVLUl.h)(t.spinner, {
                                class: "q-notification__spinner q-notification__spinner--" + o.leftClass,
                                color: t.spinnerColor,
                                size: t.spinnerSize
                            })) : t.icon ? r.push((0, $fVLUl.h)($848b1ce88e755b32$export$d56d6691b226e237, {
                                class: "q-notification__icon q-notification__icon--" + o.leftClass,
                                name: t.icon,
                                color: t.iconColor,
                                size: t.iconSize,
                                role: "img"
                            })) : t.avatar && r.push((0, $fVLUl.h)($848b1ce88e755b32$export$f3774053158ba051, {
                                class: "q-notification__avatar q-notification__avatar--" + o.leftClass
                            }, ()=>(0, $fVLUl.h)("img", {
                                    src: t.avatar,
                                    "aria-hidden": "true"
                                })))), o.hasText === !0) {
                                let i, a = {
                                    class: "q-notification__message col"
                                };
                                if (t.html === !0) a.innerHTML = t.caption ? `<div>${t.message}</div><div class="q-notification__caption">${t.caption}</div>` : t.message;
                                else {
                                    let l = [
                                        t.message
                                    ];
                                    i = t.caption ? [
                                        (0, $fVLUl.h)("div", l),
                                        (0, $fVLUl.h)("div", {
                                            class: "q-notification__caption"
                                        }, [
                                            t.caption
                                        ])
                                    ] : l;
                                }
                                r.push((0, $fVLUl.h)("div", a, i));
                            }
                            let n = [
                                (0, $fVLUl.h)("div", {
                                    class: o.contentClass
                                }, r)
                            ];
                            return t.progress === !0 && n.push((0, $fVLUl.h)("div", {
                                key: `${o.uid}|p|${o.badge}`,
                                class: o.progressClass,
                                style: o.progressStyle
                            })), t.actions !== void 0 && n.push((0, $fVLUl.h)("div", {
                                class: o.actionsClass
                            }, t.actions.map((i)=>(0, $fVLUl.h)($848b1ce88e755b32$export$72abad9388e88b7, i)))), o.badge > 1 && n.push((0, $fVLUl.h)("div", {
                                key: `${o.uid}|${o.badge}`,
                                class: t.meta.badgeClass,
                                style: t.badgeStyle
                            }, [
                                o.badge
                            ])), (0, $fVLUl.h)("div", {
                                ref: (i)=>{
                                    $848b1ce88e755b32$var$i0["" + o.uid] = i;
                                },
                                key: o.uid,
                                class: o.class,
                                ...o.attrs
                            }, [
                                (0, $fVLUl.h)("div", {
                                    class: o.wrapperClass
                                }, n)
                            ]);
                        }))));
        }
    });
}
var $848b1ce88e755b32$export$dd80a68918412a62 = {
    setDefaults (e) {
        $848b1ce88e755b32$var$at(e) === !0 && Object.assign($848b1ce88e755b32$var$Fs, e);
    },
    registerType (e, t) {
        $848b1ce88e755b32$var$at(t) === !0 && ($848b1ce88e755b32$var$ka[e] = t);
    },
    install ({ $q: e, parentApp: t }) {
        if (e.notify = this.create = (o)=>$848b1ce88e755b32$var$a0(o, e), e.notify.setDefaults = this.setDefaults, e.notify.registerType = this.registerType, e.config.notify !== void 0 && this.setDefaults(e.config.notify), this.__installed !== !0) {
            $848b1ce88e755b32$var$$d.forEach((r)=>{
                $848b1ce88e755b32$var$Jo[r] = (0, $eayOh.ref)([]);
                let n = [
                    "left",
                    "center",
                    "right"
                ].includes(r) === !0 ? "center" : r.indexOf("top") !== -1 ? "top" : "bottom", i = r.indexOf("left") !== -1 ? "start" : r.indexOf("right") !== -1 ? "end" : "center", a = [
                    "left",
                    "right"
                ].includes(r) ? `items-${r === "left" ? "start" : "end"} justify-center` : r === "center" ? "flex-center" : `items-${i}`;
                $848b1ce88e755b32$var$r0[r] = `q-notifications__list q-notifications__list--${n} fixed column no-wrap ${a}`;
            });
            let o = $848b1ce88e755b32$var$an("q-notify");
            $848b1ce88e755b32$var$Wn($848b1ce88e755b32$var$oT(), t).mount(o);
        }
    }
};
function $848b1ce88e755b32$var$rT(e) {
    return $848b1ce88e755b32$var$Pn(e) === !0 ? "__q_date|" + e.getTime() : $848b1ce88e755b32$var$Js(e) === !0 ? "__q_expr|" + e.source : typeof e == "number" ? "__q_numb|" + e : typeof e == "boolean" ? "__q_bool|" + (e ? "1" : "0") : typeof e == "string" ? "__q_strn|" + e : typeof e == "function" ? "__q_strn|" + e.toString() : e === Object(e) ? "__q_objt|" + JSON.stringify(e) : e;
}
function $848b1ce88e755b32$var$iT(e) {
    if (e.length < 9) return e;
    let o = e.substring(0, 8), r = e.substring(9);
    switch(o){
        case "__q_date":
            let n = Number(r);
            return new Date(Number.isNaN(n) === !0 ? r : n);
        case "__q_expr":
            return new RegExp(r);
        case "__q_numb":
            return Number(r);
        case "__q_bool":
            return r === "1";
        case "__q_strn":
            return "" + r;
        case "__q_objt":
            return JSON.parse(r);
        default:
            return e;
    }
}
function $848b1ce88e755b32$var$Vs() {
    let e = ()=>null;
    return {
        has: ()=>!1,
        hasItem: ()=>!1,
        getLength: ()=>0,
        getItem: e,
        getIndex: e,
        getKey: e,
        getAll: ()=>{},
        getAllKeys: ()=>[],
        set: $848b1ce88e755b32$export$8793edee2d425525,
        setItem: $848b1ce88e755b32$export$8793edee2d425525,
        remove: $848b1ce88e755b32$export$8793edee2d425525,
        removeItem: $848b1ce88e755b32$export$8793edee2d425525,
        clear: $848b1ce88e755b32$export$8793edee2d425525,
        isEmpty: ()=>!0
    };
}
function $848b1ce88e755b32$var$zs(e) {
    let t = window[e + "Storage"], o = (a)=>{
        let l = t.getItem(a);
        return l ? $848b1ce88e755b32$var$iT(l) : null;
    }, r = (a)=>t.getItem(a) !== null, n = (a, l)=>{
        t.setItem(a, $848b1ce88e755b32$var$rT(l));
    }, i = (a)=>{
        t.removeItem(a);
    };
    return {
        has: r,
        hasItem: r,
        getLength: ()=>t.length,
        getItem: o,
        getIndex: (a)=>a < t.length ? o(t.key(a)) : null,
        getKey: (a)=>a < t.length ? t.key(a) : null,
        getAll: ()=>{
            let a, l = {}, s = t.length;
            for(let c = 0; c < s; c++)a = t.key(c), l[a] = o(a);
            return l;
        },
        getAllKeys: ()=>{
            let a = [], l = t.length;
            for(let s = 0; s < l; s++)a.push(t.key(s));
            return a;
        },
        set: n,
        setItem: n,
        remove: i,
        removeItem: i,
        clear: ()=>{
            t.clear();
        },
        isEmpty: ()=>t.length === 0
    };
}
var $848b1ce88e755b32$var$l0 = $848b1ce88e755b32$var$Ce.has.webStorage === !1 ? $848b1ce88e755b32$var$Vs() : $848b1ce88e755b32$var$zs("local"), $848b1ce88e755b32$var$u0 = {
    install ({ $q: e }) {
        e.localStorage = $848b1ce88e755b32$var$l0;
    }
};
Object.assign($848b1ce88e755b32$var$u0, $848b1ce88e755b32$var$l0);
var $848b1ce88e755b32$export$19fffca37ef3e106 = $848b1ce88e755b32$var$u0;
var $848b1ce88e755b32$var$s0 = $848b1ce88e755b32$var$Ce.has.webStorage === !1 ? $848b1ce88e755b32$var$Vs() : $848b1ce88e755b32$var$zs("session"), $848b1ce88e755b32$var$c0 = {
    install ({ $q: e }) {
        e.sessionStorage = $848b1ce88e755b32$var$s0;
    }
};
Object.assign($848b1ce88e755b32$var$c0, $848b1ce88e755b32$var$s0);
var $848b1ce88e755b32$export$2c4b17e1c2e0931 = $848b1ce88e755b32$var$c0;
function $848b1ce88e755b32$export$e4253bd609c2f55d() {
    let { emit: e, proxy: t } = (0, $fVLUl.getCurrentInstance)(), o = (0, $eayOh.ref)(null);
    function r() {
        o.value.show();
    }
    function n() {
        o.value.hide();
    }
    function i(l) {
        e("ok", l), n();
    }
    function a() {
        e("hide");
    }
    return Object.assign(t, {
        show: r,
        hide: n
    }), {
        dialogRef: o,
        onDialogHide: a,
        onDialogOK: i,
        onDialogCancel: n
    };
}
var $848b1ce88e755b32$var$d0 = [
    "ok",
    "hide"
];
$848b1ce88e755b32$export$e4253bd609c2f55d.emits = $848b1ce88e755b32$var$d0;
$848b1ce88e755b32$export$e4253bd609c2f55d.emitsObject = $848b1ce88e755b32$var$ks($848b1ce88e755b32$var$d0);
function $848b1ce88e755b32$export$3fb9275d3845bd5a(e) {
    {
        let t = {
            active: !0
        };
        if (typeof e == "function") {
            let o = (0, $eayOh.computed)(e);
            t.val = o.value, (0, $eayOh.watch)(o, (r)=>{
                t.val = r, t.active === !0 && $848b1ce88e755b32$var$ko();
            });
        } else t.val = e;
        $848b1ce88e755b32$var$Zo.push(t), $848b1ce88e755b32$var$ko(), (0, $fVLUl.onActivated)(()=>{
            t.active = !0, $848b1ce88e755b32$var$ko();
        }), (0, $fVLUl.onDeactivated)(()=>{
            t.active = !1, $848b1ce88e755b32$var$ko();
        }), (0, $fVLUl.onUnmounted)(()=>{
            $848b1ce88e755b32$var$Zo.splice($848b1ce88e755b32$var$Zo.indexOf(t), 1), $848b1ce88e755b32$var$ko();
        });
    }
}
function $848b1ce88e755b32$export$b1dfd21c8751085() {
    return (0, $fVLUl.inject)($848b1ce88e755b32$var$_l);
}
function $848b1ce88e755b32$export$f4b266cd2aae9cb1() {
    let e = null, t = (0, $fVLUl.getCurrentInstance)();
    function o() {
        e !== null && (clearInterval(e), e = null);
    }
    return (0, $fVLUl.onDeactivated)(o), (0, $fVLUl.onBeforeUnmount)(o), {
        removeInterval: o,
        registerInterval (r, n) {
            o(e), $848b1ce88e755b32$var$Jt(t) === !1 && (e = setInterval(r, n));
        }
    };
}
function $848b1ce88e755b32$var$xT(e) {
    let t = document.createElement("textarea");
    t.value = e, t.contentEditable = "true", t.style.position = "fixed";
    let o = ()=>{};
    $848b1ce88e755b32$var$wi(o), document.body.appendChild(t), t.focus(), t.select();
    let r = document.execCommand("copy");
    return t.remove(), $848b1ce88e755b32$var$Er(o), r;
}
function $848b1ce88e755b32$export$2cdf1b96a9f86d16(e) {
    return navigator.clipboard !== void 0 ? navigator.clipboard.writeText(e) : new Promise((t, o)=>{
        let r = $848b1ce88e755b32$var$xT(e);
        r ? t(!0) : o(r);
    });
}
var $848b1ce88e755b32$export$f72a2bbac6b612b4 = (e)=>{
    let t = {
        activated () {
            this.__qMeta.active = !0, $848b1ce88e755b32$var$ko();
        },
        deactivated () {
            this.__qMeta.active = !1, $848b1ce88e755b32$var$ko();
        },
        unmounted () {
            $848b1ce88e755b32$var$Zo.splice($848b1ce88e755b32$var$Zo.indexOf(this.__qMeta), 1), $848b1ce88e755b32$var$ko(), this.__qMeta = void 0;
        }
    };
    return typeof e == "function" ? Object.assign(t, {
        computed: {
            __qMetaOptions () {
                return e.call(this) || {};
            }
        },
        watch: {
            __qMetaOptions (o) {
                this.__qMeta.val = o, this.__qMeta.active === !0 && $848b1ce88e755b32$var$ko();
            }
        },
        created () {
            this.__qMeta = {
                active: !0,
                val: this.__qMetaOptions
            }, $848b1ce88e755b32$var$Zo.push(this.__qMeta), $848b1ce88e755b32$var$ko();
        }
    }) : t.created = function() {
        this.__qMeta = {
            active: !0,
            val: e
        }, $848b1ce88e755b32$var$Zo.push(this.__qMeta), $848b1ce88e755b32$var$ko();
    }, t;
};
var $848b1ce88e755b32$export$5087227eb54526 = class {
    constructor(){
        this.__stack = {};
    }
    on(t, o, r) {
        return (this.__stack[t] || (this.__stack[t] = [])).push({
            fn: o,
            ctx: r
        }), this;
    }
    once(t, o, r) {
        let n = (...i)=>{
            this.off(t, n), o.apply(r, i);
        };
        return n.__callback = o, this.on(t, n, r);
    }
    emit(t) {
        let o = this.__stack[t];
        if (o !== void 0) {
            let r = [].slice.call(arguments, 1);
            o.forEach((n)=>{
                n.fn.apply(n.ctx, r);
            });
        }
        return this;
    }
    off(t, o) {
        let r = this.__stack[t];
        if (r === void 0) return this;
        if (o === void 0) return delete this.__stack[t], this;
        let n = r.filter((i)=>i.fn !== o && i.fn.__callback !== o);
        return n.length !== 0 ? this.__stack[t] = n : delete this.__stack[t], this;
    }
};
function $848b1ce88e755b32$var$m0(e) {
    setTimeout(()=>{
        window.URL.revokeObjectURL(e.href);
    }, 1e4), e.remove();
}
function $848b1ce88e755b32$export$1343164278ec5939(e, t, o = {}) {
    let { mimeType: r, byteOrderMark: n, encoding: i } = typeof o == "string" ? {
        mimeType: o
    } : o, a = i !== void 0 ? new TextEncoder(i).encode([
        t
    ]) : t, l = n !== void 0 ? [
        n,
        a
    ] : [
        a
    ], s = new Blob(l, {
        type: r || "application/octet-stream"
    }), c = document.createElement("a");
    c.href = window.URL.createObjectURL(s), c.setAttribute("download", e), typeof c.download > "u" && c.setAttribute("target", "_blank"), c.classList.add("hidden"), c.style.position = "fixed", document.body.appendChild(c);
    try {
        return c.click(), $848b1ce88e755b32$var$m0(c), !0;
    } catch (u) {
        return $848b1ce88e755b32$var$m0(c), u;
    }
}
function $848b1ce88e755b32$var$kT(e) {
    let t = Object.assign({
        noopener: !0
    }, e), o = [];
    for(let r in t){
        let n = t[r];
        n === !0 ? o.push(r) : ($848b1ce88e755b32$var$Mo(n) || typeof n == "string" && n !== "") && o.push(r + "=" + n);
    }
    return o.join(",");
}
function $848b1ce88e755b32$var$v0(e, t, o) {
    let r = window.open;
    if ($848b1ce88e755b32$export$2dffd0b5373a4389.is.cordova === !0) {
        if (cordova !== void 0 && cordova.InAppBrowser !== void 0 && cordova.InAppBrowser.open !== void 0) r = cordova.InAppBrowser.open;
        else if (navigator !== void 0 && navigator.app !== void 0) return navigator.app.loadUrl(e, {
            openExternal: !0
        });
    }
    let n = r(e, "_blank", $848b1ce88e755b32$var$kT(o));
    if (n) return $848b1ce88e755b32$export$2dffd0b5373a4389.is.desktop && n.focus(), n;
    t && t();
}
var $848b1ce88e755b32$export$eda597b8f512706d = (e, t, o)=>{
    if ($848b1ce88e755b32$export$2dffd0b5373a4389.is.ios === !0 && window.SafariViewController !== void 0) {
        window.SafariViewController.isAvailable((r)=>{
            r ? window.SafariViewController.show({
                url: e
            }, $848b1ce88e755b32$export$8793edee2d425525, t) : $848b1ce88e755b32$var$v0(e, t, o);
        });
        return;
    }
    return $848b1ce88e755b32$var$v0(e, t, o);
};
function $848b1ce88e755b32$var$TT(e) {
    let t = Array.isArray(e);
    if (t === !0) {
        let n = e.length;
        return {
            isList: t,
            totalJobs: n,
            resultAggregator: Array(n).fill(null)
        };
    }
    let o = Object.keys(e), r = {};
    return o.forEach((n)=>{
        r[n] = null;
    }), {
        isList: t,
        totalJobs: o.length,
        resultAggregator: r,
        resultKeys: o
    };
}
function $848b1ce88e755b32$export$514dd18ef8f5c321(e, { threadsNumber: t = 1, abortOnFail: o = !0 } = {}) {
    let r = -1, n = !1, { isList: i, totalJobs: a, resultAggregator: l, resultKeys: s } = $848b1ce88e755b32$var$TT(e), c = ()=>new Promise((v, f)=>{
            function d() {
                let m = ++r;
                if (n === !0 || m >= a) {
                    v();
                    return;
                }
                let y = i === !0 ? m : s[m];
                e[y](l).then((p)=>{
                    if (n === !0) {
                        v();
                        return;
                    }
                    l[y] = {
                        key: y,
                        status: "fulfilled",
                        value: p
                    }, setTimeout(d);
                }).catch((p)=>{
                    if (n === !0) {
                        v();
                        return;
                    }
                    let C = {
                        key: y,
                        status: "rejected",
                        reason: p
                    };
                    if (l[y] = C, o === !0) {
                        n = !0, f({
                            ...C,
                            resultAggregator: l
                        });
                        return;
                    }
                    setTimeout(d);
                });
            }
            d();
        }), u = Array(t).fill(c());
    return Promise.all(u).then(()=>l);
}
var $848b1ce88e755b32$export$aa2891570c510a77 = {
    version: "2.15.4",
    install (e, t, o) {
        $848b1ce88e755b32$var$rf(e, {
            components: $848b1ce88e755b32$var$Td,
            directives: $848b1ce88e755b32$var$Md,
            ...t
        }, o);
    },
    lang: $848b1ce88e755b32$export$8a4528ea5590497a,
    iconSet: $848b1ce88e755b32$export$c0faf18b76ac5204
};

});

parcelRegister("emn4R", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7450570f831b760$export$2e2bcd8739ae039);
let $a7450570f831b760$var$script;



let $a7450570f831b760$var$initialize = ()=>{
    $a7450570f831b760$var$script = (parcelRequire("bjHSV"));
    if ($a7450570f831b760$var$script.__esModule) $a7450570f831b760$var$script = $a7450570f831b760$var$script.default;
    $a7450570f831b760$var$script.render = (parcelRequire("51p1E")).render;
    (parcelRequire("4Dvl4")).default($a7450570f831b760$var$script);
    $a7450570f831b760$var$script.__scopeId = "data-v-64aeab";
    $a7450570f831b760$var$script.__file = "YMap.vue";
};
$a7450570f831b760$var$initialize();
var $a7450570f831b760$export$2e2bcd8739ae039 = $a7450570f831b760$var$script;

});
parcelRegister("bjHSV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0db1bcf7dbc34f9f$export$2e2bcd8739ae039);
parcelRequire("8BBfn");
var $fVLUl = parcelRequire("fVLUl");
var $eayOh = parcelRequire("eayOh");

var $aF2ha = parcelRequire("aF2ha");
var $0db1bcf7dbc34f9f$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $fVLUl.defineComponent)({
    __name: "YMap",
    props: {
        pointAddresses: {
            type: Array
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const self = (0, $fVLUl.getCurrentInstance)();
        const props = __props;
        const mapContainer = (0, $eayOh.ref)(null);
        let multiRoute;
        const init = ()=>{
            const myMap = new ymaps.Map(mapContainer.value, {
                center: [
                    55,
                    38.5
                ],
                zoom: 8,
                controls: []
            });
            const zoomControl = new ymaps.control.ZoomControl({
                options: {
                    size: "small",
                    float: "none",
                    position: {
                        bottom: 145,
                        right: 10
                    }
                }
            });
            myMap.controls.add(zoomControl);
            // Создаем мультимаршрут и настраиваем его внешний вид с помощью опций.
            multiRoute = new ymaps.multiRouter.MultiRoute({
                referencePoints: [],
                params: {}
            }, {});
            myMap.geoObjects.add(multiRoute);
            multiRoute.model.events.add("requestsuccess", ()=>{
                const activeRoute = multiRoute.getActiveRoute();
                const waypoints = multiRoute.getWayPoints().toArray().map((waypoint)=>waypoint.properties.get("geocoderMetaData", {})?.Address);
                console.log(waypoints);
                self.emit("waypointsChanged", waypoints);
                if (!activeRoute) {
                    self.emit("routeDistanceChanged", null);
                    return;
                }
                const length = activeRoute.properties.get("distance", null); // .value в метрах
                self.emit("routeDistanceChanged", length.value / 1000);
                const balloonContentLayout = ymaps.templateLayoutFactory.createClass("<span>\u0420\u0430\u0441\u0441\u0442\u043E\u044F\u043D\u0438\u0435: " + length.text + ".</span>");
                multiRoute.options.set("routeBalloonContentLayout", balloonContentLayout);
                activeRoute.balloon.open();
            });
            multiRoute.model.events.add("requestfail", ()=>{
                self.emit("routeDistanceChanged", null);
            });
        };
        (0, $fVLUl.onMounted)(()=>{
            ymaps.ready(init);
            let oldValue = [];
            (0, $eayOh.watch)(()=>props.pointAddresses, (newValue)=>{
                console.log("changed", newValue, oldValue);
                const filter = (arr)=>[
                        ...new Set(arr.filter((w)=>w?.length))
                    ];
                newValue = filter(newValue);
                if ((0, $aF2ha.AreArraysEqualShallow)(newValue, oldValue)) return;
                multiRoute.model.setReferencePoints(newValue);
                oldValue = newValue;
            }, {
                deep: true
            });
        });
        (0, $fVLUl.onUnmounted)(()=>{});
        const __returned__ = {
            self: self,
            props: props,
            mapContainer: mapContainer,
            get multiRoute () {
                return multiRoute;
            },
            set multiRoute (v){
                multiRoute = v;
            },
            init: init
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("aF2ha", function(module, exports) {

$parcel$export(module.exports, "AreArraysEqualShallow", () => $4f3bf98d1172fe04$export$7a826881c0bda31d);
function $4f3bf98d1172fe04$export$7a826881c0bda31d(a, b) {
    return a.length === b.length && a.every((element, index)=>element === b[index]);
}
function $4f3bf98d1172fe04$export$98ee72278636ad22(array, predicate) {
    let l = array.length;
    while(l--){
        if (predicate(array[l], l, array)) return l;
    }
    return -1;
}
function $4f3bf98d1172fe04$export$e56689678fec745e(array, predicate) {
    return array[$4f3bf98d1172fe04$export$98ee72278636ad22(array, predicate)];
}

});


parcelRegister("51p1E", function(module, exports) {

$parcel$export(module.exports, "render", () => $3a80754d129019cf$export$b3890eb0ae9dca99);
parcelRequire("8BBfn");
var $fVLUl = parcelRequire("fVLUl");
const $3a80754d129019cf$var$_hoisted_1 = {
    class: "fit"
};
const $3a80754d129019cf$var$_hoisted_2 = {
    id: "q-app",
    ref: "mapContainer",
    class: "fit"
};
function $3a80754d129019cf$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $fVLUl.openBlock)(), (0, $fVLUl.createElementBlock)("div", $3a80754d129019cf$var$_hoisted_1, [
        (0, $fVLUl.createElementVNode)("div", $3a80754d129019cf$var$_hoisted_2, null, 512)
    ]);
}

});

parcelRegister("4Dvl4", function(module, exports) {

$parcel$export(module.exports, "default", () => $36031d3145ec5eeb$export$2e2bcd8739ae039);
let $36031d3145ec5eeb$var$NOOP = ()=>{};
var $36031d3145ec5eeb$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("ki3ue", function(module, exports) {

$parcel$export(module.exports, "isAddressIn", () => $ef69176d9a6ef1cf$export$42ac43c61b2d51dc);
$parcel$export(module.exports, "isAddressOneOf", () => $ef69176d9a6ef1cf$export$242895ee1e5d57ca);
$parcel$export(module.exports, "findRoutes", () => $ef69176d9a6ef1cf$export$c97fcd9c1c17dc84);
$parcel$export(module.exports, "isRailwayOnly", () => $ef69176d9a6ef1cf$export$683737700974ace3);
$parcel$export(module.exports, "warningText", () => $ef69176d9a6ef1cf$export$d1e6de57dc4d952e);
$parcel$export(module.exports, "transportKindToNumber", () => $ef69176d9a6ef1cf$export$77df853c8d01be8c);
$parcel$export(module.exports, "calcPrice", () => $ef69176d9a6ef1cf$export$fa71f60e51bfb1b6);
$parcel$export(module.exports, "priceToString", () => $ef69176d9a6ef1cf$export$6d06b8d11ed4d846);
$parcel$export(module.exports, "getPopupText", () => $ef69176d9a6ef1cf$export$3c1bf6be870d6a6a);

var $2Iyjw = parcelRequire("2Iyjw");
let $ef69176d9a6ef1cf$var$tables;
(async ()=>{
    $ef69176d9a6ef1cf$var$tables = await fetch("tables.json").then((res)=>res.json());
})();
function $ef69176d9a6ef1cf$var$compareAddressComponent(component, place) {
    const placeLC = (Array.isArray(place) ? place[0] : place).toLowerCase();
    const compName = component.toLowerCase();
    return [
        compName,
        ...compName.split(" ")
    ].includes(placeLC);
}
function $ef69176d9a6ef1cf$export$42ac43c61b2d51dc(address, list) {
    if (!address) return false;
    return address.Components.some((component)=>list.some((place)=>$ef69176d9a6ef1cf$var$compareAddressComponent(component.name, place)));
}
function $ef69176d9a6ef1cf$export$242895ee1e5d57ca(address, list) {
    if (!address) return false;
    return list.some((place)=>(0, $2Iyjw.isAddressAllOf)(address, Array.isArray(place) ? place : [
            place
        ]));
}
function $ef69176d9a6ef1cf$export$c97fcd9c1c17dc84(waypoints, transportKindNo, deliveryType, manualTripCost) {
    let res = [];
    if (waypoints.length < 2 || transportKindNo === undefined) return res;
    if (!$ef69176d9a6ef1cf$export$242895ee1e5d57ca(waypoints[0], [
        "\u0420\u044F\u0437\u0430\u043D\u044C"
    ])) return res;
    if (waypoints.length === 2) for (const [addr, costs] of Object.entries($ef69176d9a6ef1cf$var$tables.tripCost)){
        const addrComponents = addr.split("<");
        const allMatch = (0, $2Iyjw.isAddressAllOf)(waypoints[1], addrComponents);
        if (!allMatch) continue;
        let newRoute = {
            cost: costs[transportKindNo]
        };
        if (deliveryType === "warehouse") {
            if (!$ef69176d9a6ef1cf$export$242895ee1e5d57ca(waypoints[1], $ef69176d9a6ef1cf$var$tables.warehousePlaces)) continue;
            res.push(newRoute);
            res.push({
                freeFrom: 500000,
                route: addr
            });
        } else res.push(newRoute);
        break;
    }
    if (manualTripCost) res.push({
        cost: manualTripCost
    });
    if (waypoints.length === 2 && res.length === 0) res.push({}); // первый элемент зарезервирован для доставки по указанному маршруту, даже если условия неизвестны
    if (deliveryType === "warehouse") return res;
    let hasFreeRoutes = false;
    for (const [addr2, passingTowns] of Object.entries($ef69176d9a6ef1cf$var$tables.routesToFreePassingTowns)){
        if (waypoints[2] && !(0, $2Iyjw.isAddressAllOf)(waypoints[2], [
            addr2
        ])) continue;
        for (let town of passingTowns){
            let options = {};
            if (town[town.length - 1] instanceof Object) {
                options = town[town.length - 1];
                town = town.slice(0, town.length - 1);
            }
            if (!$ef69176d9a6ef1cf$export$242895ee1e5d57ca(waypoints[1], [
                town
            ])) continue;
            if (!waypoints[2]) res[0].freeFrom = 7000000;
            const info = {
                freeFrom: options.passingFreeFrom ?? 2000000,
                route: (options.flags || "").includes("r") ? addr2 + ";" + town[0] : town[0] + ";" + addr2
            };
            const paidRoute = ($ef69176d9a6ef1cf$var$tables.paidRoutes[addr2] || [])[town[0]];
            if (paidRoute) {
                info.cost = paidRoute[transportKindNo];
                info.shoulder = transportKindNo === 0 ? paidRoute[3] : undefined;
            }
            res.push(info);
            hasFreeRoutes = true;
        }
    }
    if (hasFreeRoutes) return res;
    for (const [addr1, dests] of Object.entries($ef69176d9a6ef1cf$var$tables.paidRoutes)){
        if (waypoints[2] && !(0, $2Iyjw.isAddressAllOf)(waypoints[1], addr1.split("<"))) continue;
        for (const [addr2, costs] of Object.entries(dests)){
            if (addr2 === "//") continue;
            const isReverse = (costs[4] || "").includes("r");
            if (!(0, $2Iyjw.isAddressAllOf)(waypoints[2] || waypoints[1], addr2.split("<"))) continue;
            res.push({
                cost: costs[transportKindNo],
                shoulder: transportKindNo === 0 ? costs[3] : undefined,
                route: isReverse ? addr2 + ";" + addr1 : addr1 + ";" + addr2
            });
        }
    }
    return res;
}
function $ef69176d9a6ef1cf$export$683737700974ace3(routeDistanceKm, waypoints) {
    return routeDistanceKm >= 3000 && !$ef69176d9a6ef1cf$export$242895ee1e5d57ca(waypoints[1], $ef69176d9a6ef1cf$var$tables.railwayExceptions);
}
function $ef69176d9a6ef1cf$export$d1e6de57dc4d952e(routeDistanceKm, waypoints) {
    let res = "";
    if ($ef69176d9a6ef1cf$export$683737700974ace3(routeDistanceKm, waypoints)) res += '\u0422\u043E\u043B\u044C\u043A\u043E \u0416\u0414 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043E\u043C. \u041E\u0442\u043F\u0440\u0430\u0432\u043A\u0430 \u0430\u0432\u0442\u043E \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u043E \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044E \u0441 \u041E\u041E\u041E "\u041C\u0413\u041A "\u0421\u0432\u0435\u0442\u043E\u0432\u044B\u0435 \u0422\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0438".\n';
    res += "\u041F\u043E\u0441\u0442\u0430\u0432\u043A\u0430 \u043E\u043F\u043E\u0440 \u043D\u0435 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0441\u0431\u043E\u0440\u043D\u044B\u043C\u0438 \u0440\u0435\u0439\u0441\u0430\u043C\u0438 \u0438 \u0442\u043E\u043B\u044C\u043A\u043E \u043D\u0430 \u043F\u043B\u0430\u0442\u043D\u043E\u0439 \u043E\u0441\u043D\u043E\u0432\u0435.";
    return res;
}
function $ef69176d9a6ef1cf$export$77df853c8d01be8c(transportKind) {
    return ({
        "truck": 0,
        "fiveton": 1,
        "gazelle": 2
    })[transportKind];
}
function $ef69176d9a6ef1cf$export$fa71f60e51bfb1b6({ routeDistanceKm: routeDistanceKm, waypoints: waypoints, cargoCost: cargoCost, cargoCostAbove4M: cargoCostAbove4M, transportType: transportType, deliveryType: deliveryType, route: route }) {
    //console.log({routeDistanceKm, fromAddress, toAddress});
    const transportKindNo = $ef69176d9a6ef1cf$export$77df853c8d01be8c(transportType);
    const isRailway = $ef69176d9a6ef1cf$export$683737700974ace3(routeDistanceKm, waypoints);
    if (route.freeFrom && !isRailway) {
        if (cargoCost >= route.freeFrom) return 0;
    //return undefined;
    }
    const isWarehouse = deliveryType === "warehouse";
    if (!cargoCost && isWarehouse && transportKindNo === 0) return $ef69176d9a6ef1cf$var$tables.strings["fill_fields"];
    if (route.shoulder) return route.shoulder; // для рейсов с плечом скидок нет, никакие формулы не применяем
    if (route.cost === undefined) {
        if (route.freeFrom) return $ef69176d9a6ef1cf$var$tables.strings["for_cargo_cost"] + route.freeFrom.toLocaleString("ru") + "\u20BD";
        return undefined;
    }
    if (!isWarehouse && $ef69176d9a6ef1cf$export$42ac43c61b2d51dc(waypoints[1], $ef69176d9a6ef1cf$var$tables.fullCostDeliveryPlaces)) return route.cost;
    if (transportKindNo === 0) {
        if (isWarehouse) {
            if (routeDistanceKm === null) return null;
            if (!isRailway) {
                if (waypoints.length === 2 && $ef69176d9a6ef1cf$export$42ac43c61b2d51dc(waypoints[1], [
                    "\u041C\u043E\u0441\u043A\u0432\u0430",
                    "\u041C\u043E\u0441\u043A\u043E\u0432\u0441\u043A\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C"
                ])) return undefined;
                return Math.round(route.cost * Math.max(0, 1 - cargoCost / 7000000));
            }
            if (!$ef69176d9a6ef1cf$export$242895ee1e5d57ca(waypoints[1], $ef69176d9a6ef1cf$var$tables.noFreeDeliveryPlaces) || $ef69176d9a6ef1cf$export$242895ee1e5d57ca(waypoints[1], $ef69176d9a6ef1cf$var$tables.halfCostDeliveryPlaces)) return Math.round(route.cost * Math.max(0.5, 1 - cargoCost / 7000000));
        } else return Math.round(route.cost * Math.max(0.5, 1 - cargoCost / 8000000));
    } else if (transportKindNo === 1) return Math.round(cargoCostAbove4M ? 0.5 * route.cost : 0.7 * route.cost);
    else if (transportKindNo === 2) return Math.round(cargoCostAbove4M ? 0.5 * route.cost : route.cost);
    for (const waypoint of waypoints)if (!waypoint || !$ef69176d9a6ef1cf$export$42ac43c61b2d51dc(waypoint, [
        "\u0420\u043E\u0441\u0441\u0438\u044F"
    ])) return null;
    return undefined;
}
function $ef69176d9a6ef1cf$export$6d06b8d11ed4d846(price) {
    return typeof price === "string" ? price : price === undefined ? "\u043F\u043E \u0441\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u044E \u0441 \u0421\u0422." : price === null ? "\u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u0430" : price === 0 ? "\u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E" : isNaN(price) ? "\u043E\u0448\u0438\u0431\u043A\u0430" : "\u0441 \u0434\u043E\u043F\u043B\u0430\u0442\u043E\u0439 " + price.toLocaleString("ru") + "\u20BD";
}
function $ef69176d9a6ef1cf$export$3c1bf6be870d6a6a({ transportType: transportType, deliveryType: deliveryType, foundRoutes: foundRoutes, routeDistanceKm: routeDistanceKm, waypoints: waypoints, showInternalInfo: showInternalInfo }) {
    const isRailway = $ef69176d9a6ef1cf$export$683737700974ace3(routeDistanceKm, waypoints);
    const isWarehouse = deliveryType === "warehouse";
    const isWarehousePlace = isWarehouse && $ef69176d9a6ef1cf$export$242895ee1e5d57ca(waypoints[1], $ef69176d9a6ef1cf$var$tables.warehousePlaces);
    let res = "";
    const isFullCostDelivery = !isWarehouse && $ef69176d9a6ef1cf$export$42ac43c61b2d51dc(waypoints[1], $ef69176d9a6ef1cf$var$tables.fullCostDeliveryPlaces);
    const isNewRegionDelivery = !isWarehouse && $ef69176d9a6ef1cf$export$42ac43c61b2d51dc(waypoints[1], $ef69176d9a6ef1cf$var$tables.newRegions);
    if (isFullCostDelivery) ;
    else if (transportType !== "truck" || !isWarehouse) {
        if (!isRailway) res += $ef69176d9a6ef1cf$var$tables.strings["direct_delivery_cost"] + "\n";
    } else if (isWarehousePlace) {
        const stringifyRouteList = (l)=>l.map((r)=>r.route.replace(/;/g, "\u2014").replace(/</g, ",")).join(", ");
        const routeListStr = stringifyRouteList(foundRoutes.filter((r)=>r.route !== undefined));
        const routeListText = showInternalInfo ? " \u043D\u0430 \u0433. " + routeListStr : "";
        res += $ef69176d9a6ef1cf$var$tables.strings["free_delivery_from"] + routeListText + ".\n";
    }
    if (isRailway) {
        if (res !== "") res += "\n";
        res += $ef69176d9a6ef1cf$var$tables.strings["railway_compensation"] + "\n";
    } else if (transportType === "truck" && isWarehousePlace) {
        if (res !== "") res += "\n";
        res += $ef69176d9a6ef1cf$var$tables.strings["warehouse_compensation"] + "\n";
    }
    if (isNewRegionDelivery) {
        if (res !== "") res += "\n";
        res += $ef69176d9a6ef1cf$var$tables.strings["new_region_delivery"] + "\n";
    }
    if (isFullCostDelivery) {
        if (res !== "") res += "\n";
        res += $ef69176d9a6ef1cf$var$tables.strings["full_cost_delivery"].replace("{}", $ef69176d9a6ef1cf$var$tables.fullCostDeliveryPlaces.join(", ")) + "\n";
    } else if (transportType === "truck" && !isWarehouse) {
        if (res !== "") res += "\n";
        res += $ef69176d9a6ef1cf$var$tables.strings["direct_delivery_routes"] + "\n";
    } else if (!isRailway) {
        if (transportType === "gazelle") {
            if (res !== "") res += "\n";
            res += $ef69176d9a6ef1cf$var$tables.strings["payment_percent_gazelle"] + "\n";
        } else if (transportType === "fiveton") {
            if (res !== "") res += "\n";
            res += $ef69176d9a6ef1cf$var$tables.strings["payment_percent_fiveton"] + "\n";
        }
    }
    if (!isWarehouse && !isRailway) {
        const stringifyRouteList = (l)=>l.map((r)=>"\u0420\u044F\u0437\u0430\u043D\u044C\u2014" + r.route.replace(/;/g, "\u2014").replace(/</g, ",")).join(", ");
        const freeRoutes = foundRoutes.filter((r)=>r.freeFrom <= 2000000);
        const freeRouteListStr = stringifyRouteList(freeRoutes);
        const paidRouteListStr = stringifyRouteList(foundRoutes.filter((r)=>(r.cost || r.shoulder) && r.route));
        const paidRouteListText = showInternalInfo ? " \u043D\u0430 " + paidRouteListStr : "";
        if (freeRoutes.length) {
            const freeRoutePriceStr = freeRoutes[0].freeFrom / 1000000 + " \u043C\u043B\u043D.";
            const freeRouteListText = showInternalInfo ? " " + freeRouteListStr : "";
            res += $ef69176d9a6ef1cf$var$tables.strings["free_delivery"].replace("{}", freeRoutePriceStr).replace("{}", freeRouteListText) + "\n";
        }
        if (paidRouteListStr !== "") res += "\n" + $ef69176d9a6ef1cf$var$tables.strings["paid_delivery_compensation"].replace("{}", paidRouteListText) + "\n";
        if (!freeRoutes.length || paidRouteListStr !== "") res += "\n" + $ef69176d9a6ef1cf$var$tables.strings["planning_note"] + "\n";
    }
    if ($ef69176d9a6ef1cf$export$242895ee1e5d57ca(waypoints[1], [
        "\u041A\u0430\u043B\u0438\u043D\u0438\u043D\u0433\u0440\u0430\u0434"
    ])) {
        if (res !== "") res += "\n";
        res += $ef69176d9a6ef1cf$var$tables.strings["kaliningrad_delivery"] + "\n";
    }
    if (routeDistanceKm < 3000) res += "\n" + $ef69176d9a6ef1cf$var$tables.strings["tariffs_valid"];
    return res;
}

});
parcelRegister("2Iyjw", function(module, exports) {

$parcel$export(module.exports, "isAddressAllOf", () => $15de60adf064c0c7$export$c5ba5a75a359ce54);
function $15de60adf064c0c7$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $15de60adf064c0c7$var$matchesAddressComponent(actualComponent, requiredComponent) {
    if (requiredComponent.includes("*")) {
        const pattern = requiredComponent.split("*").map($15de60adf064c0c7$var$escapeRegExp).join(".*");
        const regex = new RegExp(`^${pattern}$`, "i");
        return regex.test(actualComponent);
    }
    return actualComponent === requiredComponent;
}
function $15de60adf064c0c7$export$c5ba5a75a359ce54(address, requiredComponents) {
    const filteredComponents = address.Components.filter((component)=>[
            "province",
            "area",
            "locality"
        ].includes(component.kind));
    const reversedComponents = filteredComponents.map((component)=>component.name).reverse();
    let searchFrom = 0;
    return requiredComponents.every((requiredComponent)=>{
        const matchIndex = reversedComponents.findIndex((actualComponent, index)=>index >= searchFrom && $15de60adf064c0c7$var$matchesAddressComponent(actualComponent, requiredComponent));
        if (matchIndex === -1) return false;
        searchFrom = matchIndex + 1;
        return true;
    });
}
// Вспомогательная функция для разбивки составных названий
function $15de60adf064c0c7$var$addPlaceWithSeparators(place, places) {
    // Разбиваем по разделителям < и ;
    const parts = place.split(/[<>;]/);
    parts.forEach((part)=>{
        const trimmed = part.trim();
        if (trimmed && trimmed !== "//") places.add(trimmed);
    });
}
function $15de60adf064c0c7$export$f465c52c0a6e95cc(tables) {
    const places = new Set();
    // tripCost - ключи это названия городов
    Object.keys(tables.tripCost).forEach((city)=>{
        const parts = city.split("<");
        places.add(parts[0]); // основное название
        if (parts[1]) places.add(parts[1].trim()); // регион для уточнения
    });
    tables.warehousePlaces.forEach((place)=>{
        $15de60adf064c0c7$var$addPlaceWithSeparators(place, places);
    });
    tables.noFreeDeliveryPlaces.forEach((place)=>{
        $15de60adf064c0c7$var$addPlaceWithSeparators(place, places);
    });
    tables.halfCostDeliveryPlaces.forEach((place)=>{
        $15de60adf064c0c7$var$addPlaceWithSeparators(place, places);
    });
    tables.fullCostDeliveryPlaces.forEach((place)=>{
        $15de60adf064c0c7$var$addPlaceWithSeparators(place, places);
    });
    tables.railwayExceptions.forEach((place)=>{
        $15de60adf064c0c7$var$addPlaceWithSeparators(place, places);
    });
    Object.keys(tables.routesToFreePassingTowns).forEach((route)=>{
        $15de60adf064c0c7$var$addPlaceWithSeparators(route, places);
        tables.routesToFreePassingTowns[route].forEach((town)=>{
            if (typeof town === "string") $15de60adf064c0c7$var$addPlaceWithSeparators(town, places);
        });
    });
    Object.keys(tables.paidRoutes).forEach((route)=>{
        $15de60adf064c0c7$var$addPlaceWithSeparators(route, places);
        Object.keys(tables.paidRoutes[route]).forEach((dest)=>{
            if (dest !== "//") $15de60adf064c0c7$var$addPlaceWithSeparators(dest, places);
        });
    });
    places.delete("//");
    places.delete("<");
    // Удаляем числовые значения и пустые строки
    for (const place of places){
        if (/^\d+$/.test(place) || place.trim() === "") places.delete(place);
        if (place.startsWith("//")) places.delete(place);
    }
    tables.newRegions.forEach((place)=>{
        $15de60adf064c0c7$var$addPlaceWithSeparators(place, places);
    });
    return places;
}

});



parcelRegister("3NNX1", function(module, exports) {

$parcel$export(module.exports, "render", () => $2c4cb1eb429dee56$export$b3890eb0ae9dca99);
parcelRequire("8BBfn");
var $fVLUl = parcelRequire("fVLUl");
var $iE8iy = parcelRequire("iE8iy");
var $24349 = parcelRequire("24349");
const $2c4cb1eb429dee56$var$_hoisted_1 = {
    id: "q-app"
};
const $2c4cb1eb429dee56$var$_hoisted_2 = {
    class: "label"
};
const $2c4cb1eb429dee56$var$_hoisted_3 = {
    class: "label"
};
const $2c4cb1eb429dee56$var$_hoisted_4 = {
    key: 0
};
const $2c4cb1eb429dee56$var$_hoisted_5 = {
    class: "label"
};
const $2c4cb1eb429dee56$var$_hoisted_6 = [
    "placeholder",
    "value"
];
const $2c4cb1eb429dee56$var$_hoisted_7 = {
    class: "label"
};
const $2c4cb1eb429dee56$var$_hoisted_8 = [
    "value"
];
const $2c4cb1eb429dee56$var$_hoisted_9 = {
    key: 0
};
const $2c4cb1eb429dee56$var$_hoisted_10 = {
    key: 1
};
const $2c4cb1eb429dee56$var$_hoisted_11 = {
    class: "label"
};
const $2c4cb1eb429dee56$var$_hoisted_12 = [
    "value"
];
const $2c4cb1eb429dee56$var$_hoisted_13 = {
    key: 2
};
const $2c4cb1eb429dee56$var$_hoisted_14 = {
    class: "label"
};
const $2c4cb1eb429dee56$var$_hoisted_15 = [
    "title"
];
const $2c4cb1eb429dee56$var$_hoisted_16 = {
    class: "result"
};
const $2c4cb1eb429dee56$var$_hoisted_17 = {
    class: "label"
};
const $2c4cb1eb429dee56$var$_hoisted_18 = {
    class: "result"
};
const $2c4cb1eb429dee56$var$_hoisted_19 = {
    class: "note"
};
function $2c4cb1eb429dee56$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_input = (0, $fVLUl.resolveComponent)("q-input");
    const _component_q_scroll_area = (0, $fVLUl.resolveComponent)("q-scroll-area");
    const _component_q_card = (0, $fVLUl.resolveComponent)("q-card");
    const _component_q_page = (0, $fVLUl.resolveComponent)("q-page");
    const _component_q_page_container = (0, $fVLUl.resolveComponent)("q-page-container");
    const _component_q_splitter = (0, $fVLUl.resolveComponent)("q-splitter");
    const _component_q_layout = (0, $fVLUl.resolveComponent)("q-layout");
    return (0, $fVLUl.openBlock)(), (0, $fVLUl.createElementBlock)("div", $2c4cb1eb429dee56$var$_hoisted_1, [
        (0, $fVLUl.createVNode)(_component_q_layout, {
            class: "fit"
        }, {
            default: (0, $fVLUl.withCtx)(()=>[
                    (0, $fVLUl.createVNode)(_component_q_splitter, {
                        modelValue: $setup.splitterModel,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$setup.splitterModel = $event),
                        class: "fit"
                    }, {
                        before: (0, $fVLUl.withCtx)(()=>[
                                (0, $fVLUl.createVNode)(_component_q_page_container, {
                                    class: "fit"
                                }, {
                                    default: (0, $fVLUl.withCtx)(()=>[
                                            (0, $fVLUl.createVNode)(_component_q_page, {
                                                class: "column fit"
                                            }, {
                                                default: (0, $fVLUl.withCtx)(()=>[
                                                        (0, $fVLUl.createVNode)(_component_q_card, {
                                                            class: "col column"
                                                        }, {
                                                            default: (0, $fVLUl.withCtx)(()=>[
                                                                    (0, $fVLUl.createVNode)(_component_q_scroll_area, {
                                                                        class: "fit",
                                                                        visible: true
                                                                    }, {
                                                                        default: (0, $fVLUl.withCtx)(()=>[
                                                                                (0, $fVLUl.createVNode)(_component_q_input, {
                                                                                    modelValue: $setup.pointAddresses[0],
                                                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.pointAddresses[0] = $event),
                                                                                    debounce: "500",
                                                                                    filled: "",
                                                                                    label: "\u041E\u0442\u043A\u0443\u0434\u0430"
                                                                                }, null, 8, [
                                                                                    "modelValue"
                                                                                ]),
                                                                                (0, $fVLUl.createVNode)(_component_q_input, {
                                                                                    modelValue: $setup.pointAddresses[1],
                                                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.pointAddresses[1] = $event),
                                                                                    debounce: "500",
                                                                                    filled: "",
                                                                                    clearable: "",
                                                                                    label: "\u041A\u0443\u0434\u0430 (1)"
                                                                                }, null, 8, [
                                                                                    "modelValue"
                                                                                ]),
                                                                                (0, $fVLUl.createVNode)(_component_q_input, {
                                                                                    modelValue: $setup.pointAddresses[2],
                                                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.pointAddresses[2] = $event),
                                                                                    debounce: "500",
                                                                                    filled: "",
                                                                                    clearable: "",
                                                                                    label: "\u041A\u0443\u0434\u0430 (2)"
                                                                                }, null, 8, [
                                                                                    "modelValue"
                                                                                ]),
                                                                                (0, $fVLUl.createElementVNode)("p", null, [
                                                                                    (0, $fVLUl.createElementVNode)("label", $2c4cb1eb429dee56$var$_hoisted_2, [
                                                                                        _cache[12] || (_cache[12] = (0, $fVLUl.createTextVNode)("\u0412\u0438\u0434 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430")),
                                                                                        _cache[13] || (_cache[13] = (0, $fVLUl.createElementVNode)("br", null, null, -1)),
                                                                                        (0, $fVLUl.withDirectives)((0, $fVLUl.createElementVNode)("select", {
                                                                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.transportType = $event)
                                                                                        }, _cache[11] || (_cache[11] = [
                                                                                            (0, $fVLUl.createElementVNode)("option", {
                                                                                                value: "truck"
                                                                                            }, "\u0424\u0443\u0440\u0430", -1),
                                                                                            (0, $fVLUl.createElementVNode)("option", {
                                                                                                value: "fiveton"
                                                                                            }, "\u041F\u044F\u0442\u0438\u0442\u043E\u043D\u043D\u0438\u043A", -1),
                                                                                            (0, $fVLUl.createElementVNode)("option", {
                                                                                                value: "gazelle"
                                                                                            }, "\u0413\u0430\u0437\u0435\u043B\u044C", -1)
                                                                                        ]), 512), [
                                                                                            [
                                                                                                (0, $24349.vModelSelect),
                                                                                                $setup.transportType
                                                                                            ]
                                                                                        ])
                                                                                    ])
                                                                                ]),
                                                                                (0, $fVLUl.createElementVNode)("p", null, [
                                                                                    (0, $fVLUl.createElementVNode)("label", $2c4cb1eb429dee56$var$_hoisted_3, [
                                                                                        _cache[15] || (_cache[15] = (0, $fVLUl.createTextVNode)("\u0421\u043F\u043E\u0441\u043E\u0431 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438")),
                                                                                        _cache[16] || (_cache[16] = (0, $fVLUl.createElementVNode)("br", null, null, -1)),
                                                                                        (0, $fVLUl.withDirectives)((0, $fVLUl.createElementVNode)("select", {
                                                                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.deliveryType = $event)
                                                                                        }, _cache[14] || (_cache[14] = [
                                                                                            (0, $fVLUl.createElementVNode)("option", {
                                                                                                value: "warehouse"
                                                                                            }, "\u0421\u043A\u043B\u0430\u0434", -1),
                                                                                            (0, $fVLUl.createElementVNode)("option", {
                                                                                                value: "object"
                                                                                            }, "\u041E\u0431\u044A\u0435\u043A\u0442", -1)
                                                                                        ]), 512), [
                                                                                            [
                                                                                                (0, $24349.vModelSelect),
                                                                                                $setup.deliveryType
                                                                                            ]
                                                                                        ])
                                                                                    ])
                                                                                ]),
                                                                                $setup.showInternalInfo ? ((0, $fVLUl.openBlock)(), (0, $fVLUl.createElementBlock)("p", $2c4cb1eb429dee56$var$_hoisted_4, [
                                                                                    (0, $fVLUl.createElementVNode)("label", $2c4cb1eb429dee56$var$_hoisted_5, [
                                                                                        _cache[17] || (_cache[17] = (0, $fVLUl.createTextVNode)("\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0440\u0435\u0439\u0441\u0430")),
                                                                                        _cache[18] || (_cache[18] = (0, $fVLUl.createElementVNode)("br", null, null, -1)),
                                                                                        (0, $fVLUl.createElementVNode)("input", {
                                                                                            type: "text",
                                                                                            step: "1000",
                                                                                            placeholder: $setup.foundRoutes[0]?.cost?.toLocaleString("ru") || "",
                                                                                            value: $setup.tripCost != 0 ? $setup.tripCost.toLocaleString("ru") : "",
                                                                                            onInput: _cache[5] || (_cache[5] = ($event)=>$setup.onTripCostInput($event))
                                                                                        }, null, 40, $2c4cb1eb429dee56$var$_hoisted_6)
                                                                                    ])
                                                                                ])) : (0, $fVLUl.createCommentVNode)("", true),
                                                                                (0, $fVLUl.createElementVNode)("p", null, [
                                                                                    (0, $fVLUl.createElementVNode)("label", $2c4cb1eb429dee56$var$_hoisted_7, [
                                                                                        _cache[19] || (_cache[19] = (0, $fVLUl.createTextVNode)("\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0433\u0440\u0443\u0437\u0430")),
                                                                                        _cache[20] || (_cache[20] = (0, $fVLUl.createElementVNode)("br", null, null, -1)),
                                                                                        $setup.transportType === "truck" ? ((0, $fVLUl.openBlock)(), (0, $fVLUl.createElementBlock)("input", {
                                                                                            key: 0,
                                                                                            type: "text",
                                                                                            step: "1000",
                                                                                            value: $setup.cargoCost.toLocaleString("ru"),
                                                                                            onInput: _cache[6] || (_cache[6] = ($event)=>$setup.onCargoCostInput($event))
                                                                                        }, null, 40, $2c4cb1eb429dee56$var$_hoisted_8)) : (0, $fVLUl.createCommentVNode)("", true)
                                                                                    ]),
                                                                                    $setup.transportType !== "truck" ? ((0, $fVLUl.openBlock)(), (0, $fVLUl.createElementBlock)("label", $2c4cb1eb429dee56$var$_hoisted_9, [
                                                                                        (0, $fVLUl.withDirectives)((0, $fVLUl.createElementVNode)("input", {
                                                                                            type: "checkbox",
                                                                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.cargoCostAbove4M = $event)
                                                                                        }, null, 512), [
                                                                                            [
                                                                                                (0, $24349.vModelCheckbox),
                                                                                                $setup.cargoCostAbove4M
                                                                                            ]
                                                                                        ]),
                                                                                        _cache[21] || (_cache[21] = (0, $fVLUl.createTextVNode)("\u043E\u0442 4 \u043C\u043B\u043D \u20BD"))
                                                                                    ])) : (0, $fVLUl.createCommentVNode)("", true)
                                                                                ]),
                                                                                (0, $fVLUl.createCommentVNode)("", true),
                                                                                $setup.routeDistanceKm !== undefined ? ((0, $fVLUl.openBlock)(), (0, $fVLUl.createElementBlock)("p", $2c4cb1eb429dee56$var$_hoisted_13, [
                                                                                    (0, $fVLUl.createElementVNode)("label", $2c4cb1eb429dee56$var$_hoisted_14, [
                                                                                        _cache[24] || (_cache[24] = (0, $fVLUl.createTextVNode)("\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430 ")),
                                                                                        (0, $fVLUl.createElementVNode)("span", {
                                                                                            style: {
                                                                                                "color": "blue"
                                                                                            },
                                                                                            tabindex: "0",
                                                                                            class: "more_info",
                                                                                            title: $setup.popupText
                                                                                        }, "(?)", 8, $2c4cb1eb429dee56$var$_hoisted_15)
                                                                                    ]),
                                                                                    _cache[26] || (_cache[26] = (0, $fVLUl.createElementVNode)("br", null, null, -1)),
                                                                                    (0, $fVLUl.createElementVNode)("span", $2c4cb1eb429dee56$var$_hoisted_16, (0, $iE8iy.toDisplayString)($setup.logic.priceToString($setup.deliveryPrices[0])), 1),
                                                                                    _cache[27] || (_cache[27] = (0, $fVLUl.createElementVNode)("br", null, null, -1)),
                                                                                    ((0, $fVLUl.openBlock)(true), (0, $fVLUl.createElementBlock)((0, $fVLUl.Fragment), null, (0, $fVLUl.renderList)($setup.foundRoutes.slice(1).map((r, i)=>({
                                                                                            ...r,
                                                                                            price: $setup.deliveryPrices[1 + i]
                                                                                        })).filter((r)=>r.freeFrom || r.shoulder).slice(0, $setup.showInternalInfo ? undefined : 1), (r)=>{
                                                                                        return (0, $fVLUl.openBlock)(), (0, $fVLUl.createElementBlock)("p", null, [
                                                                                            (0, $fVLUl.createElementVNode)("label", $2c4cb1eb429dee56$var$_hoisted_17, (0, $iE8iy.toDisplayString)($setup.showInternalInfo ? "\u0421\u0431\u043E\u0440\u043D\u044B\u043C \u0440\u0435\u0439\u0441\u043E\u043C \u0420\u044F\u0437\u0430\u043D\u044C\u2014" + r.route.replace(/;/g, "\u2014").replace(/</g, ",") : "\u0412 \u0441\u043E\u0441\u0442\u0430\u0432\u0435 \u0441\u0431\u043E\u0440\u043D\u043E\u0433\u043E \u0440\u0435\u0439\u0441\u0430"), 1),
                                                                                            _cache[25] || (_cache[25] = (0, $fVLUl.createElementVNode)("br", null, null, -1)),
                                                                                            (0, $fVLUl.createElementVNode)("span", $2c4cb1eb429dee56$var$_hoisted_18, (0, $iE8iy.toDisplayString)($setup.logic.priceToString(r.price)), 1)
                                                                                        ]);
                                                                                    }), 256))
                                                                                ])) : (0, $fVLUl.createCommentVNode)("", true),
                                                                                (0, $fVLUl.createElementVNode)("p", $2c4cb1eb429dee56$var$_hoisted_19, (0, $iE8iy.toDisplayString)($setup.logic.warningText($setup.routeDistanceKm, $setup.waypoints)), 1)
                                                                            ]),
                                                                        _: 1
                                                                    })
                                                                ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                _: 1
                                            })
                                        ]),
                                    _: 1
                                })
                            ]),
                        after: (0, $fVLUl.withCtx)(()=>[
                                (0, $fVLUl.createVNode)($setup["YMap"], {
                                    pointAddresses: $setup.pointAddresses,
                                    onWaypointsChanged: _cache[8] || (_cache[8] = ($event)=>$setup.waypoints = $event),
                                    onRouteDistanceChanged: _cache[9] || (_cache[9] = ($event)=>$setup.routeDistanceKm = $event),
                                    class: "column"
                                }, null, 8, [
                                    "pointAddresses"
                                ])
                            ]),
                        _: 1
                    }, 8, [
                        "modelValue"
                    ])
                ]),
            _: 1
        })
    ]);
}

});

parcelRegister("1rrBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $10cdb945e864b702$export$2e2bcd8739ae039);
let $10cdb945e864b702$var$NOOP = ()=>{};
var $10cdb945e864b702$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire("8BBfn");
var $24349 = parcelRequire("24349");

var $bnwzR = parcelRequire("bnwzR");
let $ae3de8900c09c2f9$var$script;




let $ae3de8900c09c2f9$var$initialize = ()=>{
    $ae3de8900c09c2f9$var$script = (parcelRequire("boZNq"));
    if ($ae3de8900c09c2f9$var$script.__esModule) $ae3de8900c09c2f9$var$script = $ae3de8900c09c2f9$var$script.default;
    $ae3de8900c09c2f9$var$script.render = (parcelRequire("3NNX1")).render;
    $ae3de8900c09c2f9$var$script.__cssModules = {};
    (parcelRequire("1rrBo")).default($ae3de8900c09c2f9$var$script);
    $ae3de8900c09c2f9$var$script.__scopeId = "data-v-3d199a";
    $ae3de8900c09c2f9$var$script.__file = "App.vue";
};
$ae3de8900c09c2f9$var$initialize();
var $ae3de8900c09c2f9$export$2e2bcd8739ae039 = $ae3de8900c09c2f9$var$script;


const $f43313d21d3fd8e2$var$app = (0, $24349.createApp)((0, $ae3de8900c09c2f9$export$2e2bcd8739ae039));
$f43313d21d3fd8e2$var$app.use((0, $bnwzR.Quasar), {
    plugins: {
        Notify: $bnwzR.Notify
    }
});
const $f43313d21d3fd8e2$var$container = document.getElementById("eContainer");
$f43313d21d3fd8e2$var$app.mount($f43313d21d3fd8e2$var$container);
function $f43313d21d3fd8e2$var$updateChartSize() {
    $f43313d21d3fd8e2$var$container.style.height = window.innerHeight + "px";
}
$f43313d21d3fd8e2$var$updateChartSize();
window.addEventListener("resize", $f43313d21d3fd8e2$var$updateChartSize);


//# sourceMappingURL=index.d33a1276.js.map
